!function webpackUniversalModuleDefinition(t, e) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = e(require("@driftt/dds"), require("react"), require("ramda"), require("@tanstack/react-query"), require("react-redux"), require("react-dom"), require("@driftt/traffic-control"));else if ("function" === typeof define && define.amd) define(["@driftt/dds", "react", "ramda", "@tanstack/react-query", "react-redux", "react-dom", "@driftt/traffic-control"], e);else {
    var r = "object" === typeof exports ? e(require("@driftt/dds"), require("react"), require("ramda"), require("@tanstack/react-query"), require("react-redux"), require("react-dom"), require("@driftt/traffic-control")) : e(t["@driftt/dds"], t.react, t.ramda, t["@tanstack/react-query"], t["react-redux"], t["react-dom"], t["@driftt/traffic-control"]);

    for (var n in r) {
      ("object" === typeof exports ? exports : t)[n] = r[n];
    }
  }
}(window, function (t, e, r, n, i, o, a) {
  return function (t) {
    var e = {};

    function __webpack_require__(r) {
      if (e[r]) return e[r].exports;
      var n = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(n.exports, n, n.exports, __webpack_require__), n.l = !0, n.exports;
    }

    return __webpack_require__.m = t, __webpack_require__.c = e, __webpack_require__.d = function (t, e, r) {
      __webpack_require__.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: r
      });
    }, __webpack_require__.r = function (t) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, __webpack_require__.t = function (t, e) {
      if (1 & e && (t = __webpack_require__(t)), 8 & e) return t;
      if (4 & e && "object" === typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if (__webpack_require__.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var n in t) {
        __webpack_require__.d(r, n, function (e) {
          return t[e];
        }.bind(null, n));
      }
      return r;
    }, __webpack_require__.n = function (t) {
      var e = t && t.__esModule ? function getDefault() {
        return t.default;
      } : function getModuleExports() {
        return t;
      };
      return __webpack_require__.d(e, "a", e), e;
    }, __webpack_require__.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, __webpack_require__.p = "/", __webpack_require__(__webpack_require__.s = 55);
  }([function (e, r) {
    e.exports = t;
  }, function (t, r) {
    t.exports = e;
  }, function (t, e, r) {
    "use strict";

    r.d(e, "a", function () {
      return _objectSpread2;
    });
    var n = r(8);

    function ownKeys(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function _objectSpread2(t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? ownKeys(Object(r), !0).forEach(function (e) {
          Object(n.a)(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
      }

      return t;
    }
  }, function (t, e, r) {
    "use strict";

    var n = r(19);

    function _slicedToArray(t, e) {
      return function _arrayWithHoles(t) {
        if (Array.isArray(t)) return t;
      }(t) || function _iterableToArrayLimit(t, e) {
        if ("undefined" !== typeof Symbol && Symbol.iterator in Object(t)) {
          var r = [],
              n = !0,
              i = !1,
              o = void 0;

          try {
            for (var a, s = t[Symbol.iterator](); !(n = (a = s.next()).done) && (r.push(a.value), !e || r.length !== e); n = !0) {
              ;
            }
          } catch (c) {
            i = !0, o = c;
          } finally {
            try {
              n || null == s.return || s.return();
            } finally {
              if (i) throw o;
            }
          }

          return r;
        }
      }(t, e) || Object(n.a)(t, e) || function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    r.d(e, "a", function () {
      return _slicedToArray;
    });
  }, function (t, e, r) {
    t.exports = r(70);
  }, function (t, e, r) {
    "use strict";

    var n = r(22);
    var i = r(19);

    function _toConsumableArray(t) {
      return function _arrayWithoutHoles(t) {
        if (Array.isArray(t)) return Object(n.a)(t);
      }(t) || function _iterableToArray(t) {
        if ("undefined" !== typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
      }(t) || Object(i.a)(t) || function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    r.d(e, "a", function () {
      return _toConsumableArray;
    });
  }, function (t, e, r) {
    "use strict";

    function _classCallCheck(t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    }

    r.d(e, "a", function () {
      return _classCallCheck;
    });
  }, function (t, e, r) {
    "use strict";

    function asyncGeneratorStep(t, e, r, n, i, o, a) {
      try {
        var s = t[o](a),
            c = s.value;
      } catch (l) {
        return void r(l);
      }

      s.done ? e(c) : Promise.resolve(c).then(n, i);
    }

    function _asyncToGenerator(t) {
      return function () {
        var e = this,
            r = arguments;
        return new Promise(function (n, i) {
          var o = t.apply(e, r);

          function _next(t) {
            asyncGeneratorStep(o, n, i, _next, _throw, "next", t);
          }

          function _throw(t) {
            asyncGeneratorStep(o, n, i, _next, _throw, "throw", t);
          }

          _next(void 0);
        });
      };
    }

    r.d(e, "a", function () {
      return _asyncToGenerator;
    });
  }, function (t, e, r) {
    "use strict";

    function _defineProperty(t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    }

    r.d(e, "a", function () {
      return _defineProperty;
    });
  }, function (t, e, r) {
    "use strict";

    function _defineProperties(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    function _createClass(t, e, r) {
      return e && _defineProperties(t.prototype, e), r && _defineProperties(t, r), t;
    }

    r.d(e, "a", function () {
      return _createClass;
    });
  }, function (t, e, r) {
    "use strict";

    r.d(e, "a", function () {
      return _inherits;
    });
    var n = r(20);

    function _inherits(t, e) {
      if ("function" !== typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && Object(n.a)(t, e);
    }
  }, function (t, e, r) {
    "use strict";

    var n = r(15),
        i = r(25);

    function _typeof(t) {
      return (_typeof = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function _typeof(t) {
        return typeof t;
      } : function _typeof(t) {
        return t && "function" === typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    var o = r(16);

    function _createSuper(t) {
      return function () {
        var e,
            r = Object(n.a)(t);

        if (Object(i.a)()) {
          var a = Object(n.a)(this).constructor;
          e = Reflect.construct(r, arguments, a);
        } else e = r.apply(this, arguments);

        return function _possibleConstructorReturn(t, e) {
          return !e || "object" !== _typeof(e) && "function" !== typeof e ? Object(o.a)(t) : e;
        }(this, e);
      };
    }

    r.d(e, "a", function () {
      return _createSuper;
    });
  }, function (t, e) {
    t.exports = r;
  }, function (t, e) {
    t.exports = n;
  }, function (t, e, r) {
    "use strict";

    function _objectWithoutProperties(t, e) {
      if (null == t) return {};

      var r,
          n,
          i = function _objectWithoutPropertiesLoose(t, e) {
        if (null == t) return {};
        var r,
            n,
            i = {},
            o = Object.keys(t);

        for (n = 0; n < o.length; n++) {
          r = o[n], e.indexOf(r) >= 0 || (i[r] = t[r]);
        }

        return i;
      }(t, e);

      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(t);

        for (n = 0; n < o.length; n++) {
          r = o[n], e.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(t, r) && (i[r] = t[r]);
        }
      }

      return i;
    }

    r.d(e, "a", function () {
      return _objectWithoutProperties;
    });
  }, function (t, e, r) {
    "use strict";

    function _getPrototypeOf(t) {
      return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    r.d(e, "a", function () {
      return _getPrototypeOf;
    });
  }, function (t, e, r) {
    "use strict";

    function _assertThisInitialized(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }

    r.d(e, "a", function () {
      return _assertThisInitialized;
    });
  }, function (t, e, r) {
    "use strict";

    var n = SyntaxError,
        i = Function,
        o = TypeError,
        a = function getEvalledConstructor(t) {
      try {
        return i('"use strict"; return (' + t + ").constructor;")();
      } catch (e) {}
    },
        s = Object.getOwnPropertyDescriptor;

    if (s) try {
      s({}, "");
    } catch (T) {
      s = null;
    }

    var c = function throwTypeError() {
      throw new o();
    },
        l = s ? function () {
      try {
        return arguments.callee, c;
      } catch (t) {
        try {
          return s(arguments, "callee").get;
        } catch (e) {
          return c;
        }
      }
    }() : c,
        u = r(58)(),
        h = r(60)(),
        d = Object.getPrototypeOf || (h ? function (t) {
      return t.__proto__;
    } : null),
        f = {},
        p = "undefined" !== typeof Uint8Array && d ? d(Uint8Array) : void 0,
        y = {
      "%AggregateError%": "undefined" === typeof AggregateError ? void 0 : AggregateError,
      "%Array%": Array,
      "%ArrayBuffer%": "undefined" === typeof ArrayBuffer ? void 0 : ArrayBuffer,
      "%ArrayIteratorPrototype%": u && d ? d([][Symbol.iterator]()) : void 0,
      "%AsyncFromSyncIteratorPrototype%": void 0,
      "%AsyncFunction%": f,
      "%AsyncGenerator%": f,
      "%AsyncGeneratorFunction%": f,
      "%AsyncIteratorPrototype%": f,
      "%Atomics%": "undefined" === typeof Atomics ? void 0 : Atomics,
      "%BigInt%": "undefined" === typeof BigInt ? void 0 : BigInt,
      "%BigInt64Array%": "undefined" === typeof BigInt64Array ? void 0 : BigInt64Array,
      "%BigUint64Array%": "undefined" === typeof BigUint64Array ? void 0 : BigUint64Array,
      "%Boolean%": Boolean,
      "%DataView%": "undefined" === typeof DataView ? void 0 : DataView,
      "%Date%": Date,
      "%decodeURI%": decodeURI,
      "%decodeURIComponent%": decodeURIComponent,
      "%encodeURI%": encodeURI,
      "%encodeURIComponent%": encodeURIComponent,
      "%Error%": Error,
      "%eval%": eval,
      "%EvalError%": EvalError,
      "%Float32Array%": "undefined" === typeof Float32Array ? void 0 : Float32Array,
      "%Float64Array%": "undefined" === typeof Float64Array ? void 0 : Float64Array,
      "%FinalizationRegistry%": "undefined" === typeof FinalizationRegistry ? void 0 : FinalizationRegistry,
      "%Function%": i,
      "%GeneratorFunction%": f,
      "%Int8Array%": "undefined" === typeof Int8Array ? void 0 : Int8Array,
      "%Int16Array%": "undefined" === typeof Int16Array ? void 0 : Int16Array,
      "%Int32Array%": "undefined" === typeof Int32Array ? void 0 : Int32Array,
      "%isFinite%": isFinite,
      "%isNaN%": isNaN,
      "%IteratorPrototype%": u && d ? d(d([][Symbol.iterator]())) : void 0,
      "%JSON%": "object" === typeof JSON ? JSON : void 0,
      "%Map%": "undefined" === typeof Map ? void 0 : Map,
      "%MapIteratorPrototype%": "undefined" !== typeof Map && u && d ? d(new Map()[Symbol.iterator]()) : void 0,
      "%Math%": Math,
      "%Number%": Number,
      "%Object%": Object,
      "%parseFloat%": parseFloat,
      "%parseInt%": parseInt,
      "%Promise%": "undefined" === typeof Promise ? void 0 : Promise,
      "%Proxy%": "undefined" === typeof Proxy ? void 0 : Proxy,
      "%RangeError%": RangeError,
      "%ReferenceError%": ReferenceError,
      "%Reflect%": "undefined" === typeof Reflect ? void 0 : Reflect,
      "%RegExp%": RegExp,
      "%Set%": "undefined" === typeof Set ? void 0 : Set,
      "%SetIteratorPrototype%": "undefined" !== typeof Set && u && d ? d(new Set()[Symbol.iterator]()) : void 0,
      "%SharedArrayBuffer%": "undefined" === typeof SharedArrayBuffer ? void 0 : SharedArrayBuffer,
      "%String%": String,
      "%StringIteratorPrototype%": u && d ? d(""[Symbol.iterator]()) : void 0,
      "%Symbol%": u ? Symbol : void 0,
      "%SyntaxError%": n,
      "%ThrowTypeError%": l,
      "%TypedArray%": p,
      "%TypeError%": o,
      "%Uint8Array%": "undefined" === typeof Uint8Array ? void 0 : Uint8Array,
      "%Uint8ClampedArray%": "undefined" === typeof Uint8ClampedArray ? void 0 : Uint8ClampedArray,
      "%Uint16Array%": "undefined" === typeof Uint16Array ? void 0 : Uint16Array,
      "%Uint32Array%": "undefined" === typeof Uint32Array ? void 0 : Uint32Array,
      "%URIError%": URIError,
      "%WeakMap%": "undefined" === typeof WeakMap ? void 0 : WeakMap,
      "%WeakRef%": "undefined" === typeof WeakRef ? void 0 : WeakRef,
      "%WeakSet%": "undefined" === typeof WeakSet ? void 0 : WeakSet
    };

    if (d) try {
      null.error;
    } catch (T) {
      var g = d(d(T));
      y["%Error.prototype%"] = g;
    }

    var m = {
      "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
      "%ArrayPrototype%": ["Array", "prototype"],
      "%ArrayProto_entries%": ["Array", "prototype", "entries"],
      "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
      "%ArrayProto_keys%": ["Array", "prototype", "keys"],
      "%ArrayProto_values%": ["Array", "prototype", "values"],
      "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
      "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
      "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
      "%BooleanPrototype%": ["Boolean", "prototype"],
      "%DataViewPrototype%": ["DataView", "prototype"],
      "%DatePrototype%": ["Date", "prototype"],
      "%ErrorPrototype%": ["Error", "prototype"],
      "%EvalErrorPrototype%": ["EvalError", "prototype"],
      "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
      "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
      "%FunctionPrototype%": ["Function", "prototype"],
      "%Generator%": ["GeneratorFunction", "prototype"],
      "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
      "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
      "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
      "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
      "%JSONParse%": ["JSON", "parse"],
      "%JSONStringify%": ["JSON", "stringify"],
      "%MapPrototype%": ["Map", "prototype"],
      "%NumberPrototype%": ["Number", "prototype"],
      "%ObjectPrototype%": ["Object", "prototype"],
      "%ObjProto_toString%": ["Object", "prototype", "toString"],
      "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
      "%PromisePrototype%": ["Promise", "prototype"],
      "%PromiseProto_then%": ["Promise", "prototype", "then"],
      "%Promise_all%": ["Promise", "all"],
      "%Promise_reject%": ["Promise", "reject"],
      "%Promise_resolve%": ["Promise", "resolve"],
      "%RangeErrorPrototype%": ["RangeError", "prototype"],
      "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
      "%RegExpPrototype%": ["RegExp", "prototype"],
      "%SetPrototype%": ["Set", "prototype"],
      "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
      "%StringPrototype%": ["String", "prototype"],
      "%SymbolPrototype%": ["Symbol", "prototype"],
      "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
      "%TypedArrayPrototype%": ["TypedArray", "prototype"],
      "%TypeErrorPrototype%": ["TypeError", "prototype"],
      "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
      "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
      "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
      "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
      "%URIErrorPrototype%": ["URIError", "prototype"],
      "%WeakMapPrototype%": ["WeakMap", "prototype"],
      "%WeakSetPrototype%": ["WeakSet", "prototype"]
    },
        v = r(31),
        b = r(62),
        x = v.call(Function.call, Array.prototype.concat),
        w = v.call(Function.apply, Array.prototype.splice),
        S = v.call(Function.call, String.prototype.replace),
        O = v.call(Function.call, String.prototype.slice),
        E = v.call(Function.call, RegExp.prototype.exec),
        k = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g,
        _ = /\\(\\)?/g,
        C = function getBaseIntrinsic(t, e) {
      var r,
          i = t;

      if (b(m, i) && (i = "%" + (r = m[i])[0] + "%"), b(y, i)) {
        var s = y[i];
        if (s === f && (s = function doEval(t) {
          var e;
          if ("%AsyncFunction%" === t) e = a("async function () {}");else if ("%GeneratorFunction%" === t) e = a("function* () {}");else if ("%AsyncGeneratorFunction%" === t) e = a("async function* () {}");else if ("%AsyncGenerator%" === t) {
            var r = doEval("%AsyncGeneratorFunction%");
            r && (e = r.prototype);
          } else if ("%AsyncIteratorPrototype%" === t) {
            var n = doEval("%AsyncGenerator%");
            n && d && (e = d(n.prototype));
          }
          return y[t] = e, e;
        }(i)), "undefined" === typeof s && !e) throw new o("intrinsic " + t + " exists, but is not available. Please file an issue!");
        return {
          alias: r,
          name: i,
          value: s
        };
      }

      throw new n("intrinsic " + t + " does not exist!");
    };

    t.exports = function GetIntrinsic(t, e) {
      if ("string" !== typeof t || 0 === t.length) throw new o("intrinsic name must be a non-empty string");
      if (arguments.length > 1 && "boolean" !== typeof e) throw new o('"allowMissing" argument must be a boolean');
      if (null === E(/^%?[^%]*%?$/, t)) throw new n("`%` may not be present anywhere but at the beginning and end of the intrinsic name");

      var r = function stringToPath(t) {
        var e = O(t, 0, 1),
            r = O(t, -1);
        if ("%" === e && "%" !== r) throw new n("invalid intrinsic syntax, expected closing `%`");
        if ("%" === r && "%" !== e) throw new n("invalid intrinsic syntax, expected opening `%`");
        var i = [];
        return S(t, k, function (t, e, r, n) {
          i[i.length] = r ? S(n, _, "$1") : e || t;
        }), i;
      }(t),
          i = r.length > 0 ? r[0] : "",
          a = C("%" + i + "%", e),
          c = a.name,
          l = a.value,
          u = !1,
          h = a.alias;

      h && (i = h[0], w(r, x([0, 1], h)));

      for (var d = 1, f = !0; d < r.length; d += 1) {
        var p = r[d],
            g = O(p, 0, 1),
            m = O(p, -1);
        if (('"' === g || "'" === g || "`" === g || '"' === m || "'" === m || "`" === m) && g !== m) throw new n("property names with quotes must have matching quotes");
        if ("constructor" !== p && f || (u = !0), b(y, c = "%" + (i += "." + p) + "%")) l = y[c];else if (null != l) {
          if (!(p in l)) {
            if (!e) throw new o("base intrinsic for " + t + " exists, but the property is not available.");
            return;
          }

          if (s && d + 1 >= r.length) {
            var v = s(l, p);
            l = (f = !!v) && "get" in v && !("originalValue" in v.get) ? v.get : l[p];
          } else f = b(l, p), l = l[p];

          f && !u && (y[c] = l);
        }
      }

      return l;
    };
  }, function (t, e, r) {
    "use strict";

    r.d(e, "a", function () {
      return _createForOfIteratorHelper;
    });
    var n = r(19);

    function _createForOfIteratorHelper(t) {
      if ("undefined" === typeof Symbol || null == t[Symbol.iterator]) {
        if (Array.isArray(t) || (t = Object(n.a)(t))) {
          var r = 0,
              i = function F() {};

          return {
            s: i,
            n: function n() {
              return r >= t.length ? {
                done: !0
              } : {
                done: !1,
                value: t[r++]
              };
            },
            e: function e(t) {
              throw t;
            },
            f: i
          };
        }

        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }

      var o,
          a,
          c = !0,
          l = !1;
      return {
        s: function s() {
          o = t[Symbol.iterator]();
        },
        n: function n() {
          var t = o.next();
          return c = t.done, t;
        },
        e: function e(t) {
          l = !0, a = t;
        },
        f: function f() {
          try {
            c || null == o.return || o.return();
          } finally {
            if (l) throw a;
          }
        }
      };
    }
  }, function (t, e, r) {
    "use strict";

    r.d(e, "a", function () {
      return _unsupportedIterableToArray;
    });
    var n = r(22);

    function _unsupportedIterableToArray(t, e) {
      if (t) {
        if ("string" === typeof t) return Object(n.a)(t, e);
        var r = Object.prototype.toString.call(t).slice(8, -1);
        return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(r) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Object(n.a)(t, e) : void 0;
      }
    }
  }, function (t, e, r) {
    "use strict";

    function _setPrototypeOf(t, e) {
      return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    r.d(e, "a", function () {
      return _setPrototypeOf;
    });
  }, function (t, e, r) {
    "use strict";

    var n = r(15);

    function get_get(t, e, r) {
      return (get_get = "undefined" !== typeof Reflect && Reflect.get ? Reflect.get : function _get(t, e, r) {
        var i = function _superPropBase(t, e) {
          for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = Object(n.a)(t));) {
            ;
          }

          return t;
        }(t, e);

        if (i) {
          var o = Object.getOwnPropertyDescriptor(i, e);
          return o.get ? o.get.call(r) : o.value;
        }
      })(t, e, r || t);
    }

    r.d(e, "a", function () {
      return get_get;
    });
  }, function (t, e, r) {
    "use strict";

    function _arrayLikeToArray(t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var r = 0, n = new Array(e); r < e; r++) {
        n[r] = t[r];
      }

      return n;
    }

    r.d(e, "a", function () {
      return _arrayLikeToArray;
    });
  }, function (t, e, n) {
    "use strict";

    (function (o) {
      n.d(e, "a", function () {
        return Vr;
      });

      var a,
          l = n(21),
          f = n(15),
          p = n(4),
          g = n.n(p),
          v = n(7),
          E = n(5),
          _ = n(18),
          C = n(16),
          A = n(10),
          P = n(11),
          j = n(30),
          N = n(9),
          F = n(8),
          U = n(14),
          W = n(6),
          G = n(2),
          V = n(3),
          $ = n(1),
          Z = n.n($),
          J = n(0),
          tt = (n(47), ["query"]),
          et = ["x"],
          rt = ["key"],
          nt = ["title", "shortTitle"],
          it = ["refetchPage"],
          ot = ["pageParam"],
          at = ["pageParam"],
          st = ["children", "css", "rootProps"],
          ct = ["children", "withDashedDividers", "type", "withMiddleTimeLabel", "isNoonLabel", "cellDate"],
          lt = Object.defineProperty,
          ut = function __publicField(t, e, r) {
        return function __defNormalProp(t, e, r) {
          e in t ? lt(t, e, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: r
          }) : t[e] = r;
        }(t, "symbol" !== typeof e ? e + "" : e, r), r;
      };

      function _isPlaceholder(t) {
        return null != t && "object" === typeof t && !0 === t["@@functional/placeholder"];
      }

      function _curry1(t) {
        return function f1(e) {
          return 0 === arguments.length || _isPlaceholder(e) ? f1 : t.apply(this, arguments);
        };
      }

      function _curry2(t) {
        return function f2(e, r) {
          switch (arguments.length) {
            case 0:
              return f2;

            case 1:
              return _isPlaceholder(e) ? f2 : _curry1(function (r) {
                return t(e, r);
              });

            default:
              return _isPlaceholder(e) && _isPlaceholder(r) ? f2 : _isPlaceholder(e) ? _curry1(function (e) {
                return t(e, r);
              }) : _isPlaceholder(r) ? _curry1(function (r) {
                return t(e, r);
              }) : t(e, r);
          }
        };
      }

      function _arity(t, e) {
        switch (t) {
          case 0:
            return function () {
              return e.apply(this, arguments);
            };

          case 1:
            return function (t) {
              return e.apply(this, arguments);
            };

          case 2:
            return function (t, r) {
              return e.apply(this, arguments);
            };

          case 3:
            return function (t, r, n) {
              return e.apply(this, arguments);
            };

          case 4:
            return function (t, r, n, i) {
              return e.apply(this, arguments);
            };

          case 5:
            return function (t, r, n, i, o) {
              return e.apply(this, arguments);
            };

          case 6:
            return function (t, r, n, i, o, a) {
              return e.apply(this, arguments);
            };

          case 7:
            return function (t, r, n, i, o, a, s) {
              return e.apply(this, arguments);
            };

          case 8:
            return function (t, r, n, i, o, a, s, c) {
              return e.apply(this, arguments);
            };

          case 9:
            return function (t, r, n, i, o, a, s, c, l) {
              return e.apply(this, arguments);
            };

          case 10:
            return function (t, r, n, i, o, a, s, c, l, u) {
              return e.apply(this, arguments);
            };

          default:
            throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
        }
      }

      function _curryN(t, e, r) {
        return function () {
          for (var n = [], i = 0, o = t, a = 0; a < e.length || i < arguments.length;) {
            var s;
            a < e.length && (!_isPlaceholder(e[a]) || i >= arguments.length) ? s = e[a] : (s = arguments[i], i += 1), n[a] = s, _isPlaceholder(s) || (o -= 1), a += 1;
          }

          return o <= 0 ? r.apply(this, n) : _arity(o, _curryN(t, n, r));
        };
      }

      var ht = _curry2(function curryN2(t, e) {
        return 1 === t ? _curry1(e) : _arity(t, _curryN(t, [], e));
      });

      function _curry3(t) {
        return function f3(e, r, n) {
          switch (arguments.length) {
            case 0:
              return f3;

            case 1:
              return _isPlaceholder(e) ? f3 : _curry2(function (r, n) {
                return t(e, r, n);
              });

            case 2:
              return _isPlaceholder(e) && _isPlaceholder(r) ? f3 : _isPlaceholder(e) ? _curry2(function (e, n) {
                return t(e, r, n);
              }) : _isPlaceholder(r) ? _curry2(function (r, n) {
                return t(e, r, n);
              }) : _curry1(function (n) {
                return t(e, r, n);
              });

            default:
              return _isPlaceholder(e) && _isPlaceholder(r) && _isPlaceholder(n) ? f3 : _isPlaceholder(e) && _isPlaceholder(r) ? _curry2(function (e, r) {
                return t(e, r, n);
              }) : _isPlaceholder(e) && _isPlaceholder(n) ? _curry2(function (e, n) {
                return t(e, r, n);
              }) : _isPlaceholder(r) && _isPlaceholder(n) ? _curry2(function (r, n) {
                return t(e, r, n);
              }) : _isPlaceholder(e) ? _curry1(function (e) {
                return t(e, r, n);
              }) : _isPlaceholder(r) ? _curry1(function (r) {
                return t(e, r, n);
              }) : _isPlaceholder(n) ? _curry1(function (n) {
                return t(e, r, n);
              }) : t(e, r, n);
          }
        };
      }

      var dt = Array.isArray || function _isArray2(t) {
        return null != t && t.length >= 0 && "[object Array]" === Object.prototype.toString.call(t);
      };

      function _dispatchable(t, e, r) {
        return function () {
          if (0 === arguments.length) return r();
          var n = Array.prototype.slice.call(arguments, 0),
              i = n.pop();

          if (!dt(i)) {
            for (var o = 0; o < t.length;) {
              if ("function" === typeof i[t[o]]) return i[t[o]].apply(i, n);
              o += 1;
            }

            if (function _isTransformer(t) {
              return null != t && "function" === typeof t["@@transducer/step"];
            }(i)) return e.apply(null, n)(i);
          }

          return r.apply(this, arguments);
        };
      }

      var ft = {
        init: function init() {
          return this.xf["@@transducer/init"]();
        },
        result: function result(t) {
          return this.xf["@@transducer/result"](t);
        }
      };

      function _map(t, e) {
        for (var r = 0, n = e.length, i = Array(n); r < n;) {
          i[r] = t(e[r]), r += 1;
        }

        return i;
      }

      function _isString(t) {
        return "[object String]" === Object.prototype.toString.call(t);
      }

      var pt = _curry1(function isArrayLike(t) {
        return !!dt(t) || !!t && "object" === typeof t && !_isString(t) && (1 === t.nodeType ? !!t.length : 0 === t.length || t.length > 0 && t.hasOwnProperty(0) && t.hasOwnProperty(t.length - 1));
      }),
          yt = function () {
        function XWrap2(t) {
          this.f = t;
        }

        return XWrap2.prototype["@@transducer/init"] = function () {
          throw new Error("init not implemented on XWrap");
        }, XWrap2.prototype["@@transducer/result"] = function (t) {
          return t;
        }, XWrap2.prototype["@@transducer/step"] = function (t, e) {
          return this.f(t, e);
        }, XWrap2;
      }();

      var gt = _curry2(function bind(t, e) {
        return _arity(t.length, function () {
          return t.apply(e, arguments);
        });
      });

      function _iterableReduce(t, e, r) {
        for (var n = r.next(); !n.done;) {
          if ((e = t["@@transducer/step"](e, n.value)) && e["@@transducer/reduced"]) {
            e = e["@@transducer/value"];
            break;
          }

          n = r.next();
        }

        return t["@@transducer/result"](e);
      }

      function _methodReduce(t, e, r, n) {
        return t["@@transducer/result"](r[n](gt(t["@@transducer/step"], t), e));
      }

      var mt = "undefined" !== typeof Symbol ? Symbol.iterator : "@@iterator";

      function _reduce(t, e, r) {
        if ("function" === typeof t && (t = function _xwrap(t) {
          return new yt(t);
        }(t)), pt(r)) return function _arrayReduce(t, e, r) {
          for (var n = 0, i = r.length; n < i;) {
            if ((e = t["@@transducer/step"](e, r[n])) && e["@@transducer/reduced"]) {
              e = e["@@transducer/value"];
              break;
            }

            n += 1;
          }

          return t["@@transducer/result"](e);
        }(t, e, r);
        if ("function" === typeof r["fantasy-land/reduce"]) return _methodReduce(t, e, r, "fantasy-land/reduce");
        if (null != r[mt]) return _iterableReduce(t, e, r[mt]());
        if ("function" === typeof r.next) return _iterableReduce(t, e, r);
        if ("function" === typeof r.reduce) return _methodReduce(t, e, r, "reduce");
        throw new TypeError("reduce: list must be array or iterable");
      }

      var vt = function () {
        function XMap2(t, e) {
          this.xf = e, this.f = t;
        }

        return XMap2.prototype["@@transducer/init"] = ft.init, XMap2.prototype["@@transducer/result"] = ft.result, XMap2.prototype["@@transducer/step"] = function (t, e) {
          return this.xf["@@transducer/step"](t, this.f(e));
        }, XMap2;
      }(),
          bt = _curry2(function _xmap2(t, e) {
        return new vt(t, e);
      });

      function _has(t, e) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }

      var xt = Object.prototype.toString,
          wt = function () {
        return "[object Arguments]" === xt.call(arguments) ? function _isArguments2(t) {
          return "[object Arguments]" === xt.call(t);
        } : function _isArguments2(t) {
          return _has("callee", t);
        };
      }(),
          St = !{
        toString: null
      }.propertyIsEnumerable("toString"),
          Ot = ["constructor", "valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"],
          Et = function () {
        return arguments.propertyIsEnumerable("length");
      }(),
          kt = function contains2(t, e) {
        for (var r = 0; r < t.length;) {
          if (t[r] === e) return !0;
          r += 1;
        }

        return !1;
      },
          _t = "function" !== typeof Object.keys || Et ? _curry1(function keys3(t) {
        if (Object(t) !== t) return [];
        var e,
            r,
            n = [],
            i = Et && wt(t);

        for (e in t) {
          !_has(e, t) || i && "length" === e || (n[n.length] = e);
        }

        if (St) for (r = Ot.length - 1; r >= 0;) {
          _has(e = Ot[r], t) && !kt(n, e) && (n[n.length] = e), r -= 1;
        }
        return n;
      }) : _curry1(function keys2(t) {
        return Object(t) !== t ? [] : Object.keys(t);
      }),
          Ct = _curry2(_dispatchable(["fantasy-land/map", "map"], bt, function map2(t, e) {
        switch (Object.prototype.toString.call(e)) {
          case "[object Function]":
            return ht(e.length, function () {
              return t.call(this, e.apply(this, arguments));
            });

          case "[object Object]":
            return _reduce(function (r, n) {
              return r[n] = t(e[n]), r;
            }, {}, _t(e));

          default:
            return _map(t, e);
        }
      })),
          Tt = Number.isInteger || function _isInteger2(t) {
        return t << 0 === t;
      },
          At = _curry2(function nth2(t, e) {
        var r = t < 0 ? e.length + t : t;
        return _isString(e) ? e.charAt(r) : e[r];
      }),
          Mt = _curry2(function paths2(t, e) {
        return t.map(function (t) {
          for (var r, n = e, i = 0; i < t.length;) {
            if (null == n) return;
            r = t[i], n = Tt(r) ? At(r, n) : n[r], i += 1;
          }

          return n;
        });
      }),
          Pt = _curry2(function path2(t, e) {
        return Mt([t], e)[0];
      }),
          jt = _curry2(function prop2(t, e) {
        return Pt([t], e);
      }),
          Rt = _curry2(function pluck2(t, e) {
        return Ct(jt(t), e);
      }),
          Dt = _curry3(_reduce),
          It = _curry1(function values2(t) {
        for (var e = _t(t), r = e.length, n = [], i = 0; i < r;) {
          n[i] = t[e[i]], i += 1;
        }

        return n;
      }),
          Lt = _curry1(function isNil2(t) {
        return null == t;
      });

      function _isFunction(t) {
        var e = Object.prototype.toString.call(t);
        return "[object Function]" === e || "[object AsyncFunction]" === e || "[object GeneratorFunction]" === e || "[object AsyncGeneratorFunction]" === e;
      }

      function _makeFlat(t) {
        return function flatt(e) {
          for (var r, n, i, o = [], a = 0, s = e.length; a < s;) {
            if (pt(e[a])) for (i = 0, n = (r = t ? flatt(e[a]) : e[a]).length; i < n;) {
              o[o.length] = r[i], i += 1;
            } else o[o.length] = e[a];
            a += 1;
          }

          return o;
        };
      }

      var Nt = _curry1(function type2(t) {
        return null === t ? "Null" : void 0 === t ? "Undefined" : Object.prototype.toString.call(t).slice(8, -1);
      });

      function _clone(t, e, r, n) {
        var i = function copy2(i) {
          for (var o = e.length, a = 0; a < o;) {
            if (t === e[a]) return r[a];
            a += 1;
          }

          for (var s in e[a + 1] = t, r[a + 1] = i, t) {
            i[s] = n ? _clone(t[s], e, r, !0) : t[s];
          }

          return i;
        };

        switch (Nt(t)) {
          case "Object":
            return i({});

          case "Array":
            return i([]);

          case "Date":
            return new Date(t.valueOf());

          case "RegExp":
            return function _cloneRegExp(t) {
              return new RegExp(t.source, (t.global ? "g" : "") + (t.ignoreCase ? "i" : "") + (t.multiline ? "m" : "") + (t.sticky ? "y" : "") + (t.unicode ? "u" : ""));
            }(t);

          default:
            return t;
        }
      }

      var Bt = _curry1(function clone2(t) {
        return null != t && "function" === typeof t.clone ? t.clone() : _clone(t, [], [], !0);
      }),
          Ft = _curry1(function not2(t) {
        return !t;
      });

      function _pipe(t, e) {
        return function () {
          return e.call(this, t.apply(this, arguments));
        };
      }

      function _checkForMethod(t, e) {
        return function () {
          var r = arguments.length;
          if (0 === r) return e();
          var n = arguments[r - 1];
          return dt(n) || "function" !== typeof n[t] ? e.apply(this, arguments) : n[t].apply(n, Array.prototype.slice.call(arguments, 0, r - 1));
        };
      }

      var Ut = _curry3(_checkForMethod("slice", function slice(t, e, r) {
        return Array.prototype.slice.call(r, t, e);
      })),
          Wt = _curry1(_checkForMethod("tail", Ut(1, 1 / 0)));

      function pipe() {
        if (0 === arguments.length) throw new Error("pipe requires at least one argument");
        return _arity(arguments[0].length, Dt(_pipe, arguments[0], Wt(arguments)));
      }

      var zt = _curry1(function reverse2(t) {
        return _isString(t) ? t.split("").reverse().join("") : Array.prototype.slice.call(t, 0).reverse();
      });

      function compose() {
        if (0 === arguments.length) throw new Error("compose requires at least one argument");
        return pipe.apply(this, zt(arguments));
      }

      function _identity(t) {
        return t;
      }

      var qt = _curry1(_identity);

      function _arrayFromIterator(t) {
        for (var e, r = []; !(e = t.next()).done;) {
          r.push(e.value);
        }

        return r;
      }

      function _includesWith(t, e, r) {
        for (var n = 0, i = r.length; n < i;) {
          if (t(e, r[n])) return !0;
          n += 1;
        }

        return !1;
      }

      var Ht = "function" === typeof Object.is ? Object.is : function _objectIs(t, e) {
        return t === e ? 0 !== t || 1 / t === 1 / e : t !== t && e !== e;
      };

      function _uniqContentEquals(t, e, r, n) {
        var i = _arrayFromIterator(t);

        function eq(t, e) {
          return _equals(t, e, r.slice(), n.slice());
        }

        return !_includesWith(function (t, e) {
          return !_includesWith(eq, e, t);
        }, _arrayFromIterator(e), i);
      }

      function _equals(t, e, r, n) {
        if (Ht(t, e)) return !0;
        var i = Nt(t);
        if (i !== Nt(e)) return !1;
        if (null == t || null == e) return !1;
        if ("function" === typeof t["fantasy-land/equals"] || "function" === typeof e["fantasy-land/equals"]) return "function" === typeof t["fantasy-land/equals"] && t["fantasy-land/equals"](e) && "function" === typeof e["fantasy-land/equals"] && e["fantasy-land/equals"](t);
        if ("function" === typeof t.equals || "function" === typeof e.equals) return "function" === typeof t.equals && t.equals(e) && "function" === typeof e.equals && e.equals(t);

        switch (i) {
          case "Arguments":
          case "Array":
          case "Object":
            if ("function" === typeof t.constructor && "Promise" === function _functionName(t) {
              var e = String(t).match(/^function (\w*)/);
              return null == e ? "" : e[1];
            }(t.constructor)) return t === e;
            break;

          case "Boolean":
          case "Number":
          case "String":
            if (typeof t !== typeof e || !Ht(t.valueOf(), e.valueOf())) return !1;
            break;

          case "Date":
            if (!Ht(t.valueOf(), e.valueOf())) return !1;
            break;

          case "Error":
            return t.name === e.name && t.message === e.message;

          case "RegExp":
            if (t.source !== e.source || t.global !== e.global || t.ignoreCase !== e.ignoreCase || t.multiline !== e.multiline || t.sticky !== e.sticky || t.unicode !== e.unicode) return !1;
        }

        for (var o = r.length - 1; o >= 0;) {
          if (r[o] === t) return n[o] === e;
          o -= 1;
        }

        switch (i) {
          case "Map":
            return t.size === e.size && _uniqContentEquals(t.entries(), e.entries(), r.concat([t]), n.concat([e]));

          case "Set":
            return t.size === e.size && _uniqContentEquals(t.values(), e.values(), r.concat([t]), n.concat([e]));

          case "Arguments":
          case "Array":
          case "Object":
          case "Boolean":
          case "Number":
          case "String":
          case "Date":
          case "Error":
          case "RegExp":
          case "Int8Array":
          case "Uint8Array":
          case "Uint8ClampedArray":
          case "Int16Array":
          case "Uint16Array":
          case "Int32Array":
          case "Uint32Array":
          case "Float32Array":
          case "Float64Array":
          case "ArrayBuffer":
            break;

          default:
            return !1;
        }

        var a = _t(t);

        if (a.length !== _t(e).length) return !1;
        var s = r.concat([t]),
            c = n.concat([e]);

        for (o = a.length - 1; o >= 0;) {
          var l = a[o];
          if (!_has(l, e) || !_equals(e[l], t[l], s, c)) return !1;
          o -= 1;
        }

        return !0;
      }

      var Gt = _curry2(function equals2(t, e) {
        return _equals(t, e, [], []);
      });

      function _includes(t, e) {
        return function _indexOf(t, e, r) {
          var n, i;
          if ("function" === typeof t.indexOf) switch (typeof e) {
            case "number":
              if (0 === e) {
                for (n = 1 / e; r < t.length;) {
                  if (0 === (i = t[r]) && 1 / i === n) return r;
                  r += 1;
                }

                return -1;
              }

              if (e !== e) {
                for (; r < t.length;) {
                  if ("number" === typeof (i = t[r]) && i !== i) return r;
                  r += 1;
                }

                return -1;
              }

              return t.indexOf(e, r);

            case "string":
            case "boolean":
            case "function":
            case "undefined":
              return t.indexOf(e, r);

            case "object":
              if (null === e) return t.indexOf(e, r);
          }

          for (; r < t.length;) {
            if (Gt(t[r], e)) return r;
            r += 1;
          }

          return -1;
        }(e, t, 0) >= 0;
      }

      function _quote(t) {
        return '"' + t.replace(/\\/g, "\\\\").replace(/[\b]/g, "\\b").replace(/\f/g, "\\f").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\t/g, "\\t").replace(/\v/g, "\\v").replace(/\0/g, "\\0").replace(/"/g, '\\"') + '"';
      }

      var Yt = function pad2(t) {
        return (t < 10 ? "0" : "") + t;
      },
          Xt = "function" === typeof Date.prototype.toISOString ? function _toISOString2(t) {
        return t.toISOString();
      } : function _toISOString3(t) {
        return t.getUTCFullYear() + "-" + Yt(t.getUTCMonth() + 1) + "-" + Yt(t.getUTCDate()) + "T" + Yt(t.getUTCHours()) + ":" + Yt(t.getUTCMinutes()) + ":" + Yt(t.getUTCSeconds()) + "." + (t.getUTCMilliseconds() / 1e3).toFixed(3).slice(2, 5) + "Z";
      };

      function _isObject(t) {
        return "[object Object]" === Object.prototype.toString.call(t);
      }

      var Vt = function () {
        function XFilter2(t, e) {
          this.xf = e, this.f = t;
        }

        return XFilter2.prototype["@@transducer/init"] = ft.init, XFilter2.prototype["@@transducer/result"] = ft.result, XFilter2.prototype["@@transducer/step"] = function (t, e) {
          return this.f(e) ? this.xf["@@transducer/step"](t, e) : t;
        }, XFilter2;
      }(),
          $t = _curry2(_dispatchable(["filter"], _curry2(function _xfilter2(t, e) {
        return new Vt(t, e);
      }), function (t, e) {
        return _isObject(e) ? _reduce(function (r, n) {
          return t(e[n]) && (r[n] = e[n]), r;
        }, {}, _t(e)) : function _filter(t, e) {
          for (var r = 0, n = e.length, i = []; r < n;) {
            t(e[r]) && (i[i.length] = e[r]), r += 1;
          }

          return i;
        }(t, e);
      })),
          Qt = _curry2(function reject2(t, e) {
        return $t(function _complement(t) {
          return function () {
            return !t.apply(this, arguments);
          };
        }(t), e);
      });

      var Kt = _curry1(function toString2(t) {
        return function _toString(t, e) {
          var r = function recur2(r) {
            var n = e.concat([t]);
            return _includes(r, n) ? "<Circular>" : _toString(r, n);
          },
              n = function mapPairs(t, e) {
            return _map(function (e) {
              return _quote(e) + ": " + r(t[e]);
            }, e.slice().sort());
          };

          switch (Object.prototype.toString.call(t)) {
            case "[object Arguments]":
              return "(function() { return arguments; }(" + _map(r, t).join(", ") + "))";

            case "[object Array]":
              return "[" + _map(r, t).concat(n(t, Qt(function (t) {
                return /^\d+$/.test(t);
              }, _t(t)))).join(", ") + "]";

            case "[object Boolean]":
              return "object" === typeof t ? "new Boolean(" + r(t.valueOf()) + ")" : t.toString();

            case "[object Date]":
              return "new Date(" + (isNaN(t.valueOf()) ? r(NaN) : _quote(Xt(t))) + ")";

            case "[object Null]":
              return "null";

            case "[object Number]":
              return "object" === typeof t ? "new Number(" + r(t.valueOf()) + ")" : 1 / t === -1 / 0 ? "-0" : t.toString(10);

            case "[object String]":
              return "object" === typeof t ? "new String(" + r(t.valueOf()) + ")" : _quote(t);

            case "[object Undefined]":
              return "undefined";

            default:
              if ("function" === typeof t.toString) {
                var i = t.toString();
                if ("[object Object]" !== i) return i;
              }

              return "{" + n(t, _t(t)).join(", ") + "}";
          }
        }(t, []);
      }),
          Zt = _curry2(function concat2(t, e) {
        if (dt(t)) {
          if (dt(e)) return t.concat(e);
          throw new TypeError(Kt(e) + " is not an array");
        }

        if (_isString(t)) {
          if (_isString(e)) return t + e;
          throw new TypeError(Kt(e) + " is not a string");
        }

        if (null != t && _isFunction(t["fantasy-land/concat"])) return t["fantasy-land/concat"](e);
        if (null != t && _isFunction(t.concat)) return t.concat(e);
        throw new TypeError(Kt(t) + ' does not have a method named "concat" or "fantasy-land/concat"');
      }),
          Jt = function () {
        function XReduceBy2(t, e, r, n) {
          this.valueFn = t, this.valueAcc = e, this.keyFn = r, this.xf = n, this.inputs = {};
        }

        return XReduceBy2.prototype["@@transducer/init"] = ft.init, XReduceBy2.prototype["@@transducer/result"] = function (t) {
          var e;

          for (e in this.inputs) {
            if (_has(e, this.inputs) && (t = this.xf["@@transducer/step"](t, this.inputs[e]))["@@transducer/reduced"]) {
              t = t["@@transducer/value"];
              break;
            }
          }

          return this.inputs = null, this.xf["@@transducer/result"](t);
        }, XReduceBy2.prototype["@@transducer/step"] = function (t, e) {
          var r = this.keyFn(e);
          return this.inputs[r] = this.inputs[r] || [r, this.valueAcc], this.inputs[r][1] = this.valueFn(this.inputs[r][1], e), t;
        }, XReduceBy2;
      }(),
          te = _curryN(4, [], _dispatchable([], _curryN(4, [], function _xreduceBy2(t, e, r, n) {
        return new Jt(t, e, r, n);
      }), function reduceBy2(t, e, r, n) {
        return _reduce(function (n, i) {
          var o = r(i);
          return n[o] = t(_has(o, n) ? n[o] : _clone(e, [], [], !1), i), n;
        }, {}, n);
      })),
          ee = _curry2(function defaultTo2(t, e) {
        return null == e || e !== e ? t : e;
      });

      function hasOrAdd(t, e, r) {
        var n,
            i = typeof t;

        switch (i) {
          case "string":
          case "number":
            return 0 === t && 1 / t === -1 / 0 ? !!r._items["-0"] || (e && (r._items["-0"] = !0), !1) : null !== r._nativeSet ? e ? (n = r._nativeSet.size, r._nativeSet.add(t), r._nativeSet.size === n) : r._nativeSet.has(t) : i in r._items ? t in r._items[i] || (e && (r._items[i][t] = !0), !1) : (e && (r._items[i] = {}, r._items[i][t] = !0), !1);

          case "boolean":
            if (i in r._items) {
              var o = t ? 1 : 0;
              return !!r._items[i][o] || (e && (r._items[i][o] = !0), !1);
            }

            return e && (r._items[i] = t ? [!1, !0] : [!0, !1]), !1;

          case "function":
            return null !== r._nativeSet ? e ? (n = r._nativeSet.size, r._nativeSet.add(t), r._nativeSet.size === n) : r._nativeSet.has(t) : i in r._items ? !!_includes(t, r._items[i]) || (e && r._items[i].push(t), !1) : (e && (r._items[i] = [t]), !1);

          case "undefined":
            return !!r._items[i] || (e && (r._items[i] = !0), !1);

          case "object":
            if (null === t) return !!r._items.null || (e && (r._items.null = !0), !1);

          default:
            return (i = Object.prototype.toString.call(t)) in r._items ? !!_includes(t, r._items[i]) || (e && r._items[i].push(t), !1) : (e && (r._items[i] = [t]), !1);
        }
      }

      var re = function () {
        function _Set2() {
          this._nativeSet = "function" === typeof Set ? new Set() : null, this._items = {};
        }

        return _Set2.prototype.add = function (t) {
          return !hasOrAdd(t, !0, this);
        }, _Set2.prototype.has = function (t) {
          return hasOrAdd(t, !1, this);
        }, _Set2;
      }(),
          ne = _curry2(function divide2(t, e) {
        return t / e;
      }),
          ie = function () {
        function XTake2(t, e) {
          this.xf = e, this.n = t, this.i = 0;
        }

        return XTake2.prototype["@@transducer/init"] = ft.init, XTake2.prototype["@@transducer/result"] = ft.result, XTake2.prototype["@@transducer/step"] = function (t, e) {
          this.i += 1;
          var r = 0 === this.n ? t : this.xf["@@transducer/step"](t, e);
          return this.n >= 0 && this.i >= this.n ? function _reduced(t) {
            return t && t["@@transducer/reduced"] ? t : {
              "@@transducer/value": t,
              "@@transducer/reduced": !0
            };
          }(r) : r;
        }, XTake2;
      }(),
          oe = _curry2(_dispatchable(["take"], _curry2(function _xtake2(t, e) {
        return new ie(t, e);
      }), function take2(t, e) {
        return Ut(0, t < 0 ? 1 / 0 : t, e);
      }));

      function dropLast$2(t, e) {
        return oe(t < e.length ? e.length - t : 0, e);
      }

      var ae = function () {
        function XDropLast2(t, e) {
          this.xf = e, this.pos = 0, this.full = !1, this.acc = new Array(t);
        }

        return XDropLast2.prototype["@@transducer/init"] = ft.init, XDropLast2.prototype["@@transducer/result"] = function (t) {
          return this.acc = null, this.xf["@@transducer/result"](t);
        }, XDropLast2.prototype["@@transducer/step"] = function (t, e) {
          return this.full && (t = this.xf["@@transducer/step"](t, this.acc[this.pos])), this.store(e), t;
        }, XDropLast2.prototype.store = function (t) {
          this.acc[this.pos] = t, this.pos += 1, this.pos === this.acc.length && (this.pos = 0, this.full = !0);
        }, XDropLast2;
      }(),
          se = _curry2(_dispatchable([], _curry2(function _xdropLast2(t, e) {
        return new ae(t, e);
      }), dropLast$2)),
          ce = _curry1(function empty2(t) {
        return null != t && "function" === typeof t["fantasy-land/empty"] ? t["fantasy-land/empty"]() : null != t && null != t.constructor && "function" === typeof t.constructor["fantasy-land/empty"] ? t.constructor["fantasy-land/empty"]() : null != t && "function" === typeof t.empty ? t.empty() : null != t && null != t.constructor && "function" === typeof t.constructor.empty ? t.constructor.empty() : dt(t) ? [] : _isString(t) ? "" : _isObject(t) ? {} : wt(t) ? function () {
          return arguments;
        }() : void 0;
      }),
          le = _curry1(_makeFlat(!0)),
          ue = _curry1(function fromPairs2(t) {
        for (var e = {}, r = 0; r < t.length;) {
          e[t[r][0]] = t[r][1], r += 1;
        }

        return e;
      }),
          he = _curry2(_checkForMethod("groupBy", te(function (t, e) {
        return null == t && (t = []), t.push(e), t;
      }, null))),
          de = _curry2(function gt2(t, e) {
        return t > e;
      }),
          fe = te(function (t, e) {
        return e;
      }, null),
          pe = _curry2(function uniqBy2(t, e) {
        for (var r, n, i = new re(), o = [], a = 0; a < e.length;) {
          r = t(n = e[a]), i.add(r) && o.push(n), a += 1;
        }

        return o;
      }),
          ye = pe(qt);

      var ge = "function" === typeof Object.assign ? Object.assign : function _objectAssign(t) {
        if (null == t) throw new TypeError("Cannot convert undefined or null to object");

        for (var e = Object(t), r = 1, n = arguments.length; r < n;) {
          var i = arguments[r];
          if (null != i) for (var o in i) {
            _has(o, i) && (e[o] = i[o]);
          }
          r += 1;
        }

        return e;
      },
          me = _curry2(function is2(t, e) {
        return null != e && e.constructor === t || e instanceof t;
      }),
          ve = _curry1(function isEmpty2(t) {
        return null != t && Gt(t, ce(t));
      }),
          be = _curry2(function mapObjIndexed2(t, e) {
        return _reduce(function (r, n) {
          return r[n] = t(e[n], n, e), r;
        }, {}, _t(e));
      }),
          xe = _curry3(function maxBy2(t, e, r) {
        return t(r) > t(e) ? r : e;
      }),
          we = _curry1(function mergeAll2(t) {
        return ge.apply(null, [{}].concat(t));
      }),
          Se = _curry3(function mergeWithKey2(t, e, r) {
        var n,
            i = {};

        for (n in e) {
          _has(n, e) && (i[n] = _has(n, r) ? t(n, e[n], r[n]) : e[n]);
        }

        for (n in r) {
          _has(n, r) && !_has(n, i) && (i[n] = r[n]);
        }

        return i;
      }),
          Oe = _curry3(function mergeDeepWithKey2(t, e, r) {
        return Se(function (e, r, n) {
          return _isObject(r) && _isObject(n) ? mergeDeepWithKey2(t, r, n) : t(e, r, n);
        }, e, r);
      }),
          Ee = _curry2(function mergeDeepLeft2(t, e) {
        return Oe(function (t, e, r) {
          return e;
        }, t, e);
      }),
          ke = _curry2(function mergeDeepRight2(t, e) {
        return Oe(function (t, e, r) {
          return r;
        }, t, e);
      }),
          _e = _curry3(function minBy2(t, e, r) {
        return t(r) < t(e) ? r : e;
      }),
          Ce = _curry2(function multiply2(t, e) {
        return t * e;
      }),
          Te = _curry3(function pathOr2(t, e, r) {
        return ee(t, Pt(e, r));
      }),
          Ae = _curry2(function pick2(t, e) {
        for (var r = {}, n = 0; n < t.length;) {
          t[n] in e && (r[t[n]] = e[t[n]]), n += 1;
        }

        return r;
      }),
          Me = _curry2(function pickBy2(t, e) {
        var r = {};

        for (var n in e) {
          t(e[n], n, e) && (r[n] = e[n]);
        }

        return r;
      }),
          Pe = _curry2(function subtract2(t, e) {
        return Number(t) - Number(e);
      }),
          je = _curry1(function toPairs2(t) {
        var e = [];

        for (var r in t) {
          _has(r, t) && (e[e.length] = [r, t[r]]);
        }

        return e;
      }),
          Re = function isNilOrEmpty(t) {
        return Lt(t) || ve(t);
      },
          De = "undefined" !== typeof globalThis ? globalThis : "undefined" !== typeof window ? window : "undefined" !== typeof o ? o : "undefined" !== typeof self ? self : {};

      function getAugmentedNamespace(t) {
        if (t.__esModule) return t;
        var e = Object.defineProperty({}, "__esModule", {
          value: !0
        });
        return Object.keys(t).forEach(function (r) {
          var n = Object.getOwnPropertyDescriptor(t, r);
          Object.defineProperty(e, r, n.get ? n : {
            enumerable: !0,
            get: function get() {
              return t[r];
            }
          });
        }), e;
      }

      var Ie = {};
      Object.defineProperty(Ie, "__esModule", {
        value: !0
      });
      var Le = Ie.faCaretDown = void 0;
      Le = Ie.faCaretDown = {
        prefix: "fas",
        iconName: "faCaretDown",
        icon: [320, 512, [], "", "M310.6 246.6l-127.1 128C176.4 380.9 168.2 384 160 384s-16.38-3.125-22.63-9.375l-127.1-128C.2244 237.5-2.516 223.7 2.438 211.8S19.07 192 32 192h255.1c12.94 0 24.62 7.781 29.58 19.75S319.8 237.5 310.6 246.6z"]
      };
      var Ne = {};
      Object.defineProperty(Ne, "__esModule", {
        value: !0
      });
      var Be = Ne.faCaretUp = void 0;
      Be = Ne.faCaretUp = {
        prefix: "fas",
        iconName: "faCaretUp",
        icon: [320, 512, [], "", "M9.39 265.4l127.1-128C143.6 131.1 151.8 128 160 128s16.38 3.125 22.63 9.375l127.1 128c9.156 9.156 11.9 22.91 6.943 34.88S300.9 320 287.1 320H32.01c-12.94 0-24.62-7.781-29.58-19.75S.2333 274.5 9.39 265.4z"]
      };

      var Fe = function (t) {
        return t.NONE = "none", t.SUCCESS = "success", t.WARNING = "warning", t.DANGER = "danger", t.PENDING = "pending", t;
      }(Fe || {}),
          Ue = Object(J.keyframes)({
        "100%": {
          transform: "translateX(100%)"
        }
      }),
          We = Object(J.styled)("div", {
        backgroundColor: "$gray3",
        width: "50%",
        height: "48px",
        borderRadius: "$1",
        position: "relative",
        overflow: "hidden",
        zIndex: 1,
        "&::after": {
          content: " ",
          display: "block",
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "100%",
          backgroundRepeat: "no-repeat",
          backgroundImage: "linear-gradient(90deg, $gray3, $gray1, $gray3)",
          transform: "translateX(-100%)",
          animation: "".concat(Ue, " 1.5s ease-in-out infinite")
        }
      }),
          ze = Object(J.styled)(J.Card, {
        gap: "$3",
        paddingTop: "20px",
        variants: {
          statusIndicator: {
            none: {
              borderTop: "4px solid $white"
            },
            success: {
              borderTop: "4px solid $green6"
            },
            warning: {
              borderTop: "4px solid $yellow5"
            },
            danger: {
              borderTop: "4px solid $red6"
            },
            pending: {
              borderTop: "4px solid $blue6"
            }
          }
        },
        defaultVariants: {
          statusIndicator: "none"
        }
      }),
          qe = Object(J.styled)(J.Card.Content, {
        display: "flex",
        flexDirection: "column",
        gap: "$3"
      }),
          He = Object(J.styled)("span", {
        textStyles: "metric",
        color: "$gray8"
      }),
          Ge = Object(J.styled)("div", {
        minHeight: "68px",
        width: "100%"
      }),
          Ye = Object(J.styled)(J.Flex, {
        '&[data-state="positive"] > span': {
          color: "$green8"
        },
        '&[data-state="negative"] > span ': {
          color: "$red8"
        },
        '&[data-state="positive"] > svg': {
          color: "$green6"
        },
        '&[data-state="negative"] > svg': {
          color: "$red6"
        }
      }),
          Xe = {
        exports: {}
      },
          Ve = {};

      Object.getOwnPropertySymbols, Object.prototype.hasOwnProperty, Object.prototype.propertyIsEnumerable;
      !function shouldUseNative() {
        try {
          if (!Object.assign) return !1;
          var t = new String("abc");
          if (t[5] = "de", "5" === Object.getOwnPropertyNames(t)[0]) return !1;

          for (var e = {}, r = 0; r < 10; r++) {
            e["_" + String.fromCharCode(r)] = r;
          }

          if ("0123456789" !== Object.getOwnPropertyNames(e).map(function (t) {
            return e[t];
          }).join("")) return !1;
          var n = {};
          return "abcdefghijklmnopqrst".split("").forEach(function (t) {
            n[t] = t;
          }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, n)).join("");
        } catch (i) {
          return !1;
        }
      }() || Object.assign;
      var $e = Z.a,
          Qe = 60103;

      if (Ve.Fragment = 60107, "function" === typeof Symbol && Symbol.for) {
        var Ke = Symbol.for;
        Qe = Ke("react.element"), Ve.Fragment = Ke("react.fragment");
      }

      var Ze = $e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
          Je = Object.prototype.hasOwnProperty,
          tr = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      };

      function q$1(t, e, r) {
        var n,
            i = {},
            o = null,
            a = null;

        for (n in void 0 !== r && (o = "" + r), void 0 !== e.key && (o = "" + e.key), void 0 !== e.ref && (a = e.ref), e) {
          Je.call(e, n) && !tr.hasOwnProperty(n) && (i[n] = e[n]);
        }

        if (t && t.defaultProps) for (n in e = t.defaultProps) {
          void 0 === i[n] && (i[n] = e[n]);
        }
        return {
          $$typeof: Qe,
          type: t,
          key: o,
          ref: a,
          props: i,
          _owner: Ze.current
        };
      }

      Ve.jsx = q$1, Ve.jsxs = q$1, Xe.exports = Ve;

      var er = Xe.exports.jsx,
          rr = Xe.exports.jsxs,
          nr = (Xe.exports.Fragment, Object(J.createComponentContext)("KPICard", {
        isLoading: !0,
        metric: null,
        previousMetric: null,
        formatMetric: function formatMetric(t) {
          return t.toString();
        },
        hasError: !1,
        hasNoData: !1
      })),
          ir = Object(V.a)(nr, 2),
          or = ir[0],
          ar = ir[1],
          sr = function MetricDelta() {
        var t = ar("KPICard"),
            e = function getDeltaAsPercentage(t, e) {
          var r = e || 0,
              n = Pe(t || 0, r),
              i = Gt(r, 0) ? 0 : Ce(ne(n, r), 100);
          return Math.round(i);
        }(t.metric, t.previousMetric),
            r = de(e, 0);

        return Gt(e, 0) ? null : rr(Ye, {
          "data-state": r ? "positive" : "negative",
          gap: "half",
          children: [er(J.Icon, {
            icon: r ? Be : Le
          }), rr(J.Text, {
            variant: "metadata",
            children: [Math.abs(e), " %"]
          })]
        });
      },
          cr = Object($.forwardRef)(function (t, e) {
        var r = t.title,
            n = t.description,
            i = t.children;
        return rr(J.Card.Header, {
          ref: e,
          children: [r && er(J.Header, {
            variant: "h3",
            children: r
          }), n && er(J.Text, {
            variant: "metadata",
            children: n
          }), i]
        });
      });

      cr.displayName = "KPICardHeader";
      var lr = Object($.forwardRef)(function (t, e) {
        var r = t.metric,
            n = t.previousMetric,
            i = t.formatMetric,
            o = t.statusIndicator,
            a = t.isLoading,
            s = t.hasNoData,
            c = t.hasError,
            l = t.children;
        return er(or, {
          metric: r,
          previousMetric: n,
          formatMetric: i,
          hasNoData: s,
          hasError: c,
          isLoading: a,
          children: er(ze, {
            ref: e,
            statusIndicator: s || c ? Fe.NONE : o,
            children: l
          })
        });
      });
      lr.displayName = "KPICard";
      Object(G.a)(Object(G.a)({}, lr), {}, {
        Header: cr,
        Content: qe,
        Metric: function KPICardMetric() {
          var t = ar("KPICard"),
              e = t.metric,
              r = t.formatMetric,
              n = t.hasNoData,
              i = t.hasError,
              o = t.isLoading,
              a = n || i,
              s = a || Re(e);
          return o ? er(Ge, {
            children: er(We, {})
          }) : rr(Ge, {
            children: [s ? er(He, {
              children: "--"
            }) : rr(J.Flex, {
              alignItems: "center",
              children: [er(J.Header, {
                variant: "metric",
                children: r(null != e ? e : 0)
              }), er(sr, {})]
            }), a ? er(J.StatusMessage, {
              variant: i ? "error" : "warning",
              children: i ? "Error occurred while trying to display this data" : "There is no data available for this metric"
            }) : null]
          });
        }
      });

      function toInteger(t) {
        if (null === t || !0 === t || !1 === t) return NaN;
        var e = Number(t);
        return isNaN(e) ? e : e < 0 ? Math.ceil(e) : Math.floor(e);
      }

      function requiredArgs(t, e) {
        if (e.length < t) throw new TypeError(t + " argument" + (t > 1 ? "s" : "") + " required, but only " + e.length + " present");
      }

      function _typeof$2(t) {
        return (_typeof$2 = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function _typeof2(t) {
          return typeof t;
        } : function _typeof2(t) {
          return t && "function" === typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        })(t);
      }

      function toDate(t) {
        requiredArgs(1, arguments);
        var e = Object.prototype.toString.call(t);
        return t instanceof Date || "object" === _typeof$2(t) && "[object Date]" === e ? new Date(t.getTime()) : "number" === typeof t || "[object Number]" === e ? new Date(t) : ("string" !== typeof t && "[object String]" !== e || "undefined" === typeof console || (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), new Date(NaN));
      }

      function addDays(t, e) {
        requiredArgs(2, arguments);
        var r = toDate(t),
            n = toInteger(e);
        return isNaN(n) ? new Date(NaN) : n ? (r.setDate(r.getDate() + n), r) : r;
      }

      function _typeof$1(t) {
        return (_typeof$1 = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function _typeof2(t) {
          return typeof t;
        } : function _typeof2(t) {
          return t && "function" === typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        })(t);
      }

      function add(t, e) {
        if (requiredArgs(2, arguments), !e || "object" !== _typeof$1(e)) return new Date(NaN);
        var r = e.years ? toInteger(e.years) : 0,
            n = e.months ? toInteger(e.months) : 0,
            i = e.weeks ? toInteger(e.weeks) : 0,
            o = e.days ? toInteger(e.days) : 0,
            a = e.hours ? toInteger(e.hours) : 0,
            s = e.minutes ? toInteger(e.minutes) : 0,
            c = e.seconds ? toInteger(e.seconds) : 0,
            l = toDate(t),
            u = n || r ? function addMonths(t, e) {
          requiredArgs(2, arguments);
          var r = toDate(t),
              n = toInteger(e);
          if (isNaN(n)) return new Date(NaN);
          if (!n) return r;
          var i = r.getDate(),
              o = new Date(r.getTime());
          return o.setMonth(r.getMonth() + n + 1, 0), i >= o.getDate() ? o : (r.setFullYear(o.getFullYear(), o.getMonth(), i), r);
        }(l, n + 12 * r) : l,
            h = o || i ? addDays(u, o + 7 * i) : u,
            d = 1e3 * (c + 60 * (s + 60 * a));
        return new Date(h.getTime() + d);
      }

      function addMilliseconds(t, e) {
        requiredArgs(2, arguments);
        var r = toDate(t).getTime(),
            n = toInteger(e);
        return new Date(r + n);
      }

      var ur = {};

      function getDefaultOptions() {
        return ur;
      }

      function getTimezoneOffsetInMilliseconds(t) {
        var e = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
        return e.setUTCFullYear(t.getFullYear()), t.getTime() - e.getTime();
      }

      function startOfDay(t) {
        requiredArgs(1, arguments);
        var e = toDate(t);
        return e.setHours(0, 0, 0, 0), e;
      }

      var hr = 864e5;
      var dr = 6e4;

      function addMinutes(t, e) {
        return requiredArgs(2, arguments), addMilliseconds(t, toInteger(e) * dr);
      }

      function compareAsc(t, e) {
        requiredArgs(2, arguments);
        var r = toDate(t),
            n = toDate(e),
            i = r.getTime() - n.getTime();
        return i < 0 ? -1 : i > 0 ? 1 : i;
      }

      var fr = 6e4,
          pr = 36e5;

      function _typeof(t) {
        return (_typeof = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function _typeof2(t) {
          return typeof t;
        } : function _typeof2(t) {
          return t && "function" === typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        })(t);
      }

      function isValid(t) {
        if (requiredArgs(1, arguments), !function isDate$1(t) {
          return requiredArgs(1, arguments), t instanceof Date || "object" === _typeof(t) && "[object Date]" === Object.prototype.toString.call(t);
        }(t) && "number" !== typeof t) return !1;
        var e = toDate(t);
        return !isNaN(Number(e));
      }

      function compareLocalAsc(t, e) {
        var r = t.getFullYear() - e.getFullYear() || t.getMonth() - e.getMonth() || t.getDate() - e.getDate() || t.getHours() - e.getHours() || t.getMinutes() - e.getMinutes() || t.getSeconds() - e.getSeconds() || t.getMilliseconds() - e.getMilliseconds();
        return r < 0 ? -1 : r > 0 ? 1 : r;
      }

      function differenceInDays(t, e) {
        requiredArgs(2, arguments);
        var r = toDate(t),
            n = toDate(e),
            i = compareLocalAsc(r, n),
            o = Math.abs(function differenceInCalendarDays(t, e) {
          requiredArgs(2, arguments);
          var r = startOfDay(t),
              n = startOfDay(e),
              i = r.getTime() - getTimezoneOffsetInMilliseconds(r),
              o = n.getTime() - getTimezoneOffsetInMilliseconds(n);
          return Math.round((i - o) / hr);
        }(r, n));
        r.setDate(r.getDate() - i * o);
        var a = i * (o - Number(compareLocalAsc(r, n) === -i));
        return 0 === a ? 0 : a;
      }

      function differenceInMilliseconds(t, e) {
        return requiredArgs(2, arguments), toDate(t).getTime() - toDate(e).getTime();
      }

      var yr = {
        ceil: Math.ceil,
        round: Math.round,
        floor: Math.floor,
        trunc: function trunc(t) {
          return t < 0 ? Math.ceil(t) : Math.floor(t);
        }
      },
          gr = "trunc";

      function getRoundingMethod(t) {
        return t ? yr[t] : yr[gr];
      }

      function differenceInMinutes(t, e, r) {
        requiredArgs(2, arguments);
        var n = differenceInMilliseconds(t, e) / fr;
        return getRoundingMethod(null === r || void 0 === r ? void 0 : r.roundingMethod)(n);
      }

      function isLastDayOfMonth(t) {
        requiredArgs(1, arguments);
        var e = toDate(t);
        return function endOfDay(t) {
          requiredArgs(1, arguments);
          var e = toDate(t);
          return e.setHours(23, 59, 59, 999), e;
        }(e).getTime() === function endOfMonth(t) {
          requiredArgs(1, arguments);
          var e = toDate(t),
              r = e.getMonth();
          return e.setFullYear(e.getFullYear(), r + 1, 0), e.setHours(23, 59, 59, 999), e;
        }(e).getTime();
      }

      function differenceInMonths(t, e) {
        requiredArgs(2, arguments);
        var r,
            n = toDate(t),
            i = toDate(e),
            o = compareAsc(n, i),
            a = Math.abs(function differenceInCalendarMonths(t, e) {
          requiredArgs(2, arguments);
          var r = toDate(t),
              n = toDate(e);
          return 12 * (r.getFullYear() - n.getFullYear()) + (r.getMonth() - n.getMonth());
        }(n, i));
        if (a < 1) r = 0;else {
          1 === n.getMonth() && n.getDate() > 27 && n.setDate(30), n.setMonth(n.getMonth() - o * a);
          var s = compareAsc(n, i) === -o;
          isLastDayOfMonth(toDate(t)) && 1 === a && 1 === compareAsc(t, i) && (s = !1), r = o * (a - Number(s));
        }
        return 0 === r ? 0 : r;
      }

      function differenceInYears(t, e) {
        requiredArgs(2, arguments);
        var r = toDate(t),
            n = toDate(e),
            i = compareAsc(r, n),
            o = Math.abs(function differenceInCalendarYears(t, e) {
          requiredArgs(2, arguments);
          var r = toDate(t),
              n = toDate(e);
          return r.getFullYear() - n.getFullYear();
        }(r, n));
        r.setFullYear(1584), n.setFullYear(1584);
        var a = compareAsc(r, n) === -i,
            s = i * (o - Number(a));
        return 0 === s ? 0 : s;
      }

      var mr = 864e5;

      function startOfUTCISOWeek(t) {
        requiredArgs(1, arguments);
        var e = toDate(t),
            r = e.getUTCDay(),
            n = (r < 1 ? 7 : 0) + r - 1;
        return e.setUTCDate(e.getUTCDate() - n), e.setUTCHours(0, 0, 0, 0), e;
      }

      function getUTCISOWeekYear(t) {
        requiredArgs(1, arguments);
        var e = toDate(t),
            r = e.getUTCFullYear(),
            n = new Date(0);
        n.setUTCFullYear(r + 1, 0, 4), n.setUTCHours(0, 0, 0, 0);
        var i = startOfUTCISOWeek(n),
            o = new Date(0);
        o.setUTCFullYear(r, 0, 4), o.setUTCHours(0, 0, 0, 0);
        var a = startOfUTCISOWeek(o);
        return e.getTime() >= i.getTime() ? r + 1 : e.getTime() >= a.getTime() ? r : r - 1;
      }

      var vr = 6048e5;

      function getUTCISOWeek(t) {
        requiredArgs(1, arguments);

        var e = toDate(t),
            r = startOfUTCISOWeek(e).getTime() - function startOfUTCISOWeekYear(t) {
          requiredArgs(1, arguments);
          var e = getUTCISOWeekYear(t),
              r = new Date(0);
          return r.setUTCFullYear(e, 0, 4), r.setUTCHours(0, 0, 0, 0), startOfUTCISOWeek(r);
        }(e).getTime();

        return Math.round(r / vr) + 1;
      }

      function startOfUTCWeek(t, e) {
        var r, n, i, o, a, s, c, l;
        requiredArgs(1, arguments);
        var u = getDefaultOptions(),
            h = toInteger(null !== (r = null !== (n = null !== (i = null !== (o = null === e || void 0 === e ? void 0 : e.weekStartsOn) && void 0 !== o ? o : null === e || void 0 === e ? void 0 : null === (a = e.locale) || void 0 === a ? void 0 : null === (s = a.options) || void 0 === s ? void 0 : s.weekStartsOn) && void 0 !== i ? i : u.weekStartsOn) && void 0 !== n ? n : null === (c = u.locale) || void 0 === c ? void 0 : null === (l = c.options) || void 0 === l ? void 0 : l.weekStartsOn) && void 0 !== r ? r : 0);
        if (!(h >= 0 && h <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
        var d = toDate(t),
            f = d.getUTCDay(),
            p = (f < h ? 7 : 0) + f - h;
        return d.setUTCDate(d.getUTCDate() - p), d.setUTCHours(0, 0, 0, 0), d;
      }

      function getUTCWeekYear(t, e) {
        var r, n, i, o, a, s, c, l;
        requiredArgs(1, arguments);
        var u = toDate(t),
            h = u.getUTCFullYear(),
            d = getDefaultOptions(),
            f = toInteger(null !== (r = null !== (n = null !== (i = null !== (o = null === e || void 0 === e ? void 0 : e.firstWeekContainsDate) && void 0 !== o ? o : null === e || void 0 === e ? void 0 : null === (a = e.locale) || void 0 === a ? void 0 : null === (s = a.options) || void 0 === s ? void 0 : s.firstWeekContainsDate) && void 0 !== i ? i : d.firstWeekContainsDate) && void 0 !== n ? n : null === (c = d.locale) || void 0 === c ? void 0 : null === (l = c.options) || void 0 === l ? void 0 : l.firstWeekContainsDate) && void 0 !== r ? r : 1);
        if (!(f >= 1 && f <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
        var p = new Date(0);
        p.setUTCFullYear(h + 1, 0, f), p.setUTCHours(0, 0, 0, 0);
        var y = startOfUTCWeek(p, e),
            g = new Date(0);
        g.setUTCFullYear(h, 0, f), g.setUTCHours(0, 0, 0, 0);
        var m = startOfUTCWeek(g, e);
        return u.getTime() >= y.getTime() ? h + 1 : u.getTime() >= m.getTime() ? h : h - 1;
      }

      var br = 6048e5;

      function getUTCWeek(t, e) {
        requiredArgs(1, arguments);

        var r = toDate(t),
            n = startOfUTCWeek(r, e).getTime() - function startOfUTCWeekYear(t, e) {
          var r, n, i, o, a, s, c, l;
          requiredArgs(1, arguments);
          var u = getDefaultOptions(),
              h = toInteger(null !== (r = null !== (n = null !== (i = null !== (o = null === e || void 0 === e ? void 0 : e.firstWeekContainsDate) && void 0 !== o ? o : null === e || void 0 === e ? void 0 : null === (a = e.locale) || void 0 === a ? void 0 : null === (s = a.options) || void 0 === s ? void 0 : s.firstWeekContainsDate) && void 0 !== i ? i : u.firstWeekContainsDate) && void 0 !== n ? n : null === (c = u.locale) || void 0 === c ? void 0 : null === (l = c.options) || void 0 === l ? void 0 : l.firstWeekContainsDate) && void 0 !== r ? r : 1),
              d = getUTCWeekYear(t, e),
              f = new Date(0);
          return f.setUTCFullYear(d, 0, h), f.setUTCHours(0, 0, 0, 0), startOfUTCWeek(f, e);
        }(r, e).getTime();

        return Math.round(n / br) + 1;
      }

      function addLeadingZeros(t, e) {
        for (var r = t < 0 ? "-" : "", n = Math.abs(t).toString(); n.length < e;) {
          n = "0" + n;
        }

        return r + n;
      }

      var xr = {
        y: function y(t, e) {
          var r = t.getUTCFullYear(),
              n = r > 0 ? r : 1 - r;
          return addLeadingZeros("yy" === e ? n % 100 : n, e.length);
        },
        M: function M(t, e) {
          var r = t.getUTCMonth();
          return "M" === e ? String(r + 1) : addLeadingZeros(r + 1, 2);
        },
        d: function d(t, e) {
          return addLeadingZeros(t.getUTCDate(), e.length);
        },
        a: function a(t, e) {
          var r = t.getUTCHours() / 12 >= 1 ? "pm" : "am";

          switch (e) {
            case "a":
            case "aa":
              return r.toUpperCase();

            case "aaa":
              return r;

            case "aaaaa":
              return r[0];

            case "aaaa":
            default:
              return "am" === r ? "a.m." : "p.m.";
          }
        },
        h: function h(t, e) {
          return addLeadingZeros(t.getUTCHours() % 12 || 12, e.length);
        },
        H: function H(t, e) {
          return addLeadingZeros(t.getUTCHours(), e.length);
        },
        m: function m(t, e) {
          return addLeadingZeros(t.getUTCMinutes(), e.length);
        },
        s: function s(t, e) {
          return addLeadingZeros(t.getUTCSeconds(), e.length);
        },
        S: function S(t, e) {
          var r = e.length,
              n = t.getUTCMilliseconds();
          return addLeadingZeros(Math.floor(n * Math.pow(10, r - 3)), e.length);
        }
      },
          wr = "midnight",
          Sr = "noon",
          Or = "morning",
          Er = "afternoon",
          kr = "evening",
          _r = "night";

      function formatTimezoneShort(t, e) {
        var r = t > 0 ? "-" : "+",
            n = Math.abs(t),
            i = Math.floor(n / 60),
            o = n % 60;
        if (0 === o) return r + String(i);
        var a = e || "";
        return r + String(i) + a + addLeadingZeros(o, 2);
      }

      function formatTimezoneWithOptionalMinutes(t, e) {
        return t % 60 === 0 ? (t > 0 ? "-" : "+") + addLeadingZeros(Math.abs(t) / 60, 2) : formatTimezone(t, e);
      }

      function formatTimezone(t, e) {
        var r = e || "",
            n = t > 0 ? "-" : "+",
            i = Math.abs(t);
        return n + addLeadingZeros(Math.floor(i / 60), 2) + r + addLeadingZeros(i % 60, 2);
      }

      var Cr = {
        G: function G(t, e, r) {
          var n = t.getUTCFullYear() > 0 ? 1 : 0;

          switch (e) {
            case "G":
            case "GG":
            case "GGG":
              return r.era(n, {
                width: "abbreviated"
              });

            case "GGGGG":
              return r.era(n, {
                width: "narrow"
              });

            case "GGGG":
            default:
              return r.era(n, {
                width: "wide"
              });
          }
        },
        y: function y2(t, e, r) {
          if ("yo" === e) {
            var n = t.getUTCFullYear(),
                i = n > 0 ? n : 1 - n;
            return r.ordinalNumber(i, {
              unit: "year"
            });
          }

          return xr.y(t, e);
        },
        Y: function Y(t, e, r, n) {
          var i = getUTCWeekYear(t, n),
              o = i > 0 ? i : 1 - i;
          return "YY" === e ? addLeadingZeros(o % 100, 2) : "Yo" === e ? r.ordinalNumber(o, {
            unit: "year"
          }) : addLeadingZeros(o, e.length);
        },
        R: function R(t, e) {
          return addLeadingZeros(getUTCISOWeekYear(t), e.length);
        },
        u: function u(t, e) {
          return addLeadingZeros(t.getUTCFullYear(), e.length);
        },
        Q: function Q(t, e, r) {
          var n = Math.ceil((t.getUTCMonth() + 1) / 3);

          switch (e) {
            case "Q":
              return String(n);

            case "QQ":
              return addLeadingZeros(n, 2);

            case "Qo":
              return r.ordinalNumber(n, {
                unit: "quarter"
              });

            case "QQQ":
              return r.quarter(n, {
                width: "abbreviated",
                context: "formatting"
              });

            case "QQQQQ":
              return r.quarter(n, {
                width: "narrow",
                context: "formatting"
              });

            case "QQQQ":
            default:
              return r.quarter(n, {
                width: "wide",
                context: "formatting"
              });
          }
        },
        q: function q(t, e, r) {
          var n = Math.ceil((t.getUTCMonth() + 1) / 3);

          switch (e) {
            case "q":
              return String(n);

            case "qq":
              return addLeadingZeros(n, 2);

            case "qo":
              return r.ordinalNumber(n, {
                unit: "quarter"
              });

            case "qqq":
              return r.quarter(n, {
                width: "abbreviated",
                context: "standalone"
              });

            case "qqqqq":
              return r.quarter(n, {
                width: "narrow",
                context: "standalone"
              });

            case "qqqq":
            default:
              return r.quarter(n, {
                width: "wide",
                context: "standalone"
              });
          }
        },
        M: function M2(t, e, r) {
          var n = t.getUTCMonth();

          switch (e) {
            case "M":
            case "MM":
              return xr.M(t, e);

            case "Mo":
              return r.ordinalNumber(n + 1, {
                unit: "month"
              });

            case "MMM":
              return r.month(n, {
                width: "abbreviated",
                context: "formatting"
              });

            case "MMMMM":
              return r.month(n, {
                width: "narrow",
                context: "formatting"
              });

            case "MMMM":
            default:
              return r.month(n, {
                width: "wide",
                context: "formatting"
              });
          }
        },
        L: function L(t, e, r) {
          var n = t.getUTCMonth();

          switch (e) {
            case "L":
              return String(n + 1);

            case "LL":
              return addLeadingZeros(n + 1, 2);

            case "Lo":
              return r.ordinalNumber(n + 1, {
                unit: "month"
              });

            case "LLL":
              return r.month(n, {
                width: "abbreviated",
                context: "standalone"
              });

            case "LLLLL":
              return r.month(n, {
                width: "narrow",
                context: "standalone"
              });

            case "LLLL":
            default:
              return r.month(n, {
                width: "wide",
                context: "standalone"
              });
          }
        },
        w: function w(t, e, r, n) {
          var i = getUTCWeek(t, n);
          return "wo" === e ? r.ordinalNumber(i, {
            unit: "week"
          }) : addLeadingZeros(i, e.length);
        },
        I: function I(t, e, r) {
          var n = getUTCISOWeek(t);
          return "Io" === e ? r.ordinalNumber(n, {
            unit: "week"
          }) : addLeadingZeros(n, e.length);
        },
        d: function d2(t, e, r) {
          return "do" === e ? r.ordinalNumber(t.getUTCDate(), {
            unit: "date"
          }) : xr.d(t, e);
        },
        D: function D(t, e, r) {
          var n = function getUTCDayOfYear(t) {
            requiredArgs(1, arguments);
            var e = toDate(t),
                r = e.getTime();
            e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
            var n = r - e.getTime();
            return Math.floor(n / mr) + 1;
          }(t);

          return "Do" === e ? r.ordinalNumber(n, {
            unit: "dayOfYear"
          }) : addLeadingZeros(n, e.length);
        },
        E: function E(t, e, r) {
          var n = t.getUTCDay();

          switch (e) {
            case "E":
            case "EE":
            case "EEE":
              return r.day(n, {
                width: "abbreviated",
                context: "formatting"
              });

            case "EEEEE":
              return r.day(n, {
                width: "narrow",
                context: "formatting"
              });

            case "EEEEEE":
              return r.day(n, {
                width: "short",
                context: "formatting"
              });

            case "EEEE":
            default:
              return r.day(n, {
                width: "wide",
                context: "formatting"
              });
          }
        },
        e: function e(t, r, n, i) {
          var o = t.getUTCDay(),
              a = (o - i.weekStartsOn + 8) % 7 || 7;

          switch (r) {
            case "e":
              return String(a);

            case "ee":
              return addLeadingZeros(a, 2);

            case "eo":
              return n.ordinalNumber(a, {
                unit: "day"
              });

            case "eee":
              return n.day(o, {
                width: "abbreviated",
                context: "formatting"
              });

            case "eeeee":
              return n.day(o, {
                width: "narrow",
                context: "formatting"
              });

            case "eeeeee":
              return n.day(o, {
                width: "short",
                context: "formatting"
              });

            case "eeee":
            default:
              return n.day(o, {
                width: "wide",
                context: "formatting"
              });
          }
        },
        c: function c(t, e, r, n) {
          var i = t.getUTCDay(),
              o = (i - n.weekStartsOn + 8) % 7 || 7;

          switch (e) {
            case "c":
              return String(o);

            case "cc":
              return addLeadingZeros(o, e.length);

            case "co":
              return r.ordinalNumber(o, {
                unit: "day"
              });

            case "ccc":
              return r.day(i, {
                width: "abbreviated",
                context: "standalone"
              });

            case "ccccc":
              return r.day(i, {
                width: "narrow",
                context: "standalone"
              });

            case "cccccc":
              return r.day(i, {
                width: "short",
                context: "standalone"
              });

            case "cccc":
            default:
              return r.day(i, {
                width: "wide",
                context: "standalone"
              });
          }
        },
        i: function i(t, e, r) {
          var n = t.getUTCDay(),
              o = 0 === n ? 7 : n;

          switch (e) {
            case "i":
              return String(o);

            case "ii":
              return addLeadingZeros(o, e.length);

            case "io":
              return r.ordinalNumber(o, {
                unit: "day"
              });

            case "iii":
              return r.day(n, {
                width: "abbreviated",
                context: "formatting"
              });

            case "iiiii":
              return r.day(n, {
                width: "narrow",
                context: "formatting"
              });

            case "iiiiii":
              return r.day(n, {
                width: "short",
                context: "formatting"
              });

            case "iiii":
            default:
              return r.day(n, {
                width: "wide",
                context: "formatting"
              });
          }
        },
        a: function a2(t, e, r) {
          var n = t.getUTCHours() / 12 >= 1 ? "pm" : "am";

          switch (e) {
            case "a":
            case "aa":
              return r.dayPeriod(n, {
                width: "abbreviated",
                context: "formatting"
              });

            case "aaa":
              return r.dayPeriod(n, {
                width: "abbreviated",
                context: "formatting"
              }).toLowerCase();

            case "aaaaa":
              return r.dayPeriod(n, {
                width: "narrow",
                context: "formatting"
              });

            case "aaaa":
            default:
              return r.dayPeriod(n, {
                width: "wide",
                context: "formatting"
              });
          }
        },
        b: function b(t, e, r) {
          var n,
              i = t.getUTCHours();

          switch (n = 12 === i ? Sr : 0 === i ? wr : i / 12 >= 1 ? "pm" : "am", e) {
            case "b":
            case "bb":
              return r.dayPeriod(n, {
                width: "abbreviated",
                context: "formatting"
              });

            case "bbb":
              return r.dayPeriod(n, {
                width: "abbreviated",
                context: "formatting"
              }).toLowerCase();

            case "bbbbb":
              return r.dayPeriod(n, {
                width: "narrow",
                context: "formatting"
              });

            case "bbbb":
            default:
              return r.dayPeriod(n, {
                width: "wide",
                context: "formatting"
              });
          }
        },
        B: function B(t, e, r) {
          var n,
              i = t.getUTCHours();

          switch (n = i >= 17 ? kr : i >= 12 ? Er : i >= 4 ? Or : _r, e) {
            case "B":
            case "BB":
            case "BBB":
              return r.dayPeriod(n, {
                width: "abbreviated",
                context: "formatting"
              });

            case "BBBBB":
              return r.dayPeriod(n, {
                width: "narrow",
                context: "formatting"
              });

            case "BBBB":
            default:
              return r.dayPeriod(n, {
                width: "wide",
                context: "formatting"
              });
          }
        },
        h: function h2(t, e, r) {
          if ("ho" === e) {
            var n = t.getUTCHours() % 12;
            return 0 === n && (n = 12), r.ordinalNumber(n, {
              unit: "hour"
            });
          }

          return xr.h(t, e);
        },
        H: function H2(t, e, r) {
          return "Ho" === e ? r.ordinalNumber(t.getUTCHours(), {
            unit: "hour"
          }) : xr.H(t, e);
        },
        K: function K(t, e, r) {
          var n = t.getUTCHours() % 12;
          return "Ko" === e ? r.ordinalNumber(n, {
            unit: "hour"
          }) : addLeadingZeros(n, e.length);
        },
        k: function k(t, e, r) {
          var n = t.getUTCHours();
          return 0 === n && (n = 24), "ko" === e ? r.ordinalNumber(n, {
            unit: "hour"
          }) : addLeadingZeros(n, e.length);
        },
        m: function m2(t, e, r) {
          return "mo" === e ? r.ordinalNumber(t.getUTCMinutes(), {
            unit: "minute"
          }) : xr.m(t, e);
        },
        s: function s2(t, e, r) {
          return "so" === e ? r.ordinalNumber(t.getUTCSeconds(), {
            unit: "second"
          }) : xr.s(t, e);
        },
        S: function S2(t, e) {
          return xr.S(t, e);
        },
        X: function X(t, e, r, n) {
          var i = (n._originalDate || t).getTimezoneOffset();
          if (0 === i) return "Z";

          switch (e) {
            case "X":
              return formatTimezoneWithOptionalMinutes(i);

            case "XXXX":
            case "XX":
              return formatTimezone(i);

            case "XXXXX":
            case "XXX":
            default:
              return formatTimezone(i, ":");
          }
        },
        x: function x(t, e, r, n) {
          var i = (n._originalDate || t).getTimezoneOffset();

          switch (e) {
            case "x":
              return formatTimezoneWithOptionalMinutes(i);

            case "xxxx":
            case "xx":
              return formatTimezone(i);

            case "xxxxx":
            case "xxx":
            default:
              return formatTimezone(i, ":");
          }
        },
        O: function O(t, e, r, n) {
          var i = (n._originalDate || t).getTimezoneOffset();

          switch (e) {
            case "O":
            case "OO":
            case "OOO":
              return "GMT" + formatTimezoneShort(i, ":");

            case "OOOO":
            default:
              return "GMT" + formatTimezone(i, ":");
          }
        },
        z: function z(t, e, r, n) {
          var i = (n._originalDate || t).getTimezoneOffset();

          switch (e) {
            case "z":
            case "zz":
            case "zzz":
              return "GMT" + formatTimezoneShort(i, ":");

            case "zzzz":
            default:
              return "GMT" + formatTimezone(i, ":");
          }
        },
        t: function t(e, r, n, i) {
          var o = i._originalDate || e;
          return addLeadingZeros(Math.floor(o.getTime() / 1e3), r.length);
        },
        T: function T(t, e, r, n) {
          return addLeadingZeros((n._originalDate || t).getTime(), e.length);
        }
      },
          Tr = function dateLongFormatter2(t, e) {
        switch (t) {
          case "P":
            return e.date({
              width: "short"
            });

          case "PP":
            return e.date({
              width: "medium"
            });

          case "PPP":
            return e.date({
              width: "long"
            });

          case "PPPP":
          default:
            return e.date({
              width: "full"
            });
        }
      },
          Ar = function timeLongFormatter2(t, e) {
        switch (t) {
          case "p":
            return e.time({
              width: "short"
            });

          case "pp":
            return e.time({
              width: "medium"
            });

          case "ppp":
            return e.time({
              width: "long"
            });

          case "pppp":
          default:
            return e.time({
              width: "full"
            });
        }
      },
          Mr = {
        p: Ar,
        P: function dateTimeLongFormatter2(t, e) {
          var r,
              n = t.match(/(P+)(p+)?/) || [],
              i = n[1],
              o = n[2];
          if (!o) return Tr(t, e);

          switch (i) {
            case "P":
              r = e.dateTime({
                width: "short"
              });
              break;

            case "PP":
              r = e.dateTime({
                width: "medium"
              });
              break;

            case "PPP":
              r = e.dateTime({
                width: "long"
              });
              break;

            case "PPPP":
            default:
              r = e.dateTime({
                width: "full"
              });
          }

          return r.replace("{{date}}", Tr(i, e)).replace("{{time}}", Ar(o, e));
        }
      },
          Pr = ["D", "DD"],
          jr = ["YY", "YYYY"];

      function throwProtectedError(t, e, r) {
        if ("YYYY" === t) throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(e, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
        if ("YY" === t) throw new RangeError("Use `yy` instead of `YY` (in `".concat(e, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
        if ("D" === t) throw new RangeError("Use `d` instead of `D` (in `".concat(e, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
        if ("DD" === t) throw new RangeError("Use `dd` instead of `DD` (in `".concat(e, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
      }

      var Rr = {
        lessThanXSeconds: {
          one: "less than a second",
          other: "less than {{count}} seconds"
        },
        xSeconds: {
          one: "1 second",
          other: "{{count}} seconds"
        },
        halfAMinute: "half a minute",
        lessThanXMinutes: {
          one: "less than a minute",
          other: "less than {{count}} minutes"
        },
        xMinutes: {
          one: "1 minute",
          other: "{{count}} minutes"
        },
        aboutXHours: {
          one: "about 1 hour",
          other: "about {{count}} hours"
        },
        xHours: {
          one: "1 hour",
          other: "{{count}} hours"
        },
        xDays: {
          one: "1 day",
          other: "{{count}} days"
        },
        aboutXWeeks: {
          one: "about 1 week",
          other: "about {{count}} weeks"
        },
        xWeeks: {
          one: "1 week",
          other: "{{count}} weeks"
        },
        aboutXMonths: {
          one: "about 1 month",
          other: "about {{count}} months"
        },
        xMonths: {
          one: "1 month",
          other: "{{count}} months"
        },
        aboutXYears: {
          one: "about 1 year",
          other: "about {{count}} years"
        },
        xYears: {
          one: "1 year",
          other: "{{count}} years"
        },
        overXYears: {
          one: "over 1 year",
          other: "over {{count}} years"
        },
        almostXYears: {
          one: "almost 1 year",
          other: "almost {{count}} years"
        }
      },
          Dr = function formatDistance2(t, e, r) {
        var n,
            i = Rr[t];
        return n = "string" === typeof i ? i : 1 === e ? i.one : i.other.replace("{{count}}", e.toString()), null !== r && void 0 !== r && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : n + " ago" : n;
      };

      function buildFormatLongFn(t) {
        return function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              r = e.width ? String(e.width) : t.defaultWidth;
          return t.formats[r] || t.formats[t.defaultWidth];
        };
      }

      var Ir = {
        date: buildFormatLongFn({
          formats: {
            full: "EEEE, MMMM do, y",
            long: "MMMM do, y",
            medium: "MMM d, y",
            short: "MM/dd/yyyy"
          },
          defaultWidth: "full"
        }),
        time: buildFormatLongFn({
          formats: {
            full: "h:mm:ss a zzzz",
            long: "h:mm:ss a z",
            medium: "h:mm:ss a",
            short: "h:mm a"
          },
          defaultWidth: "full"
        }),
        dateTime: buildFormatLongFn({
          formats: {
            full: "{{date}} 'at' {{time}}",
            long: "{{date}} 'at' {{time}}",
            medium: "{{date}}, {{time}}",
            short: "{{date}}, {{time}}"
          },
          defaultWidth: "full"
        })
      },
          Lr = {
        lastWeek: "'last' eeee 'at' p",
        yesterday: "'yesterday at' p",
        today: "'today at' p",
        tomorrow: "'tomorrow at' p",
        nextWeek: "eeee 'at' p",
        other: "P"
      };

      function buildLocalizeFn(t) {
        return function (e, r) {
          var n;

          if ("formatting" === (null !== r && void 0 !== r && r.context ? String(r.context) : "standalone") && t.formattingValues) {
            var i = t.defaultFormattingWidth || t.defaultWidth,
                o = null !== r && void 0 !== r && r.width ? String(r.width) : i;
            n = t.formattingValues[o] || t.formattingValues[i];
          } else {
            var a = t.defaultWidth,
                s = null !== r && void 0 !== r && r.width ? String(r.width) : t.defaultWidth;
            n = t.values[s] || t.values[a];
          }

          return n[t.argumentCallback ? t.argumentCallback(e) : e];
        };
      }

      function buildMatchFn(t) {
        return function (e) {
          var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = r.width,
              i = n && t.matchPatterns[n] || t.matchPatterns[t.defaultMatchWidth],
              o = e.match(i);
          if (!o) return null;
          var a,
              s = o[0],
              c = n && t.parsePatterns[n] || t.parsePatterns[t.defaultParseWidth],
              l = Array.isArray(c) ? function findIndex(t, e) {
            for (var r = 0; r < t.length; r++) {
              if (e(t[r])) return r;
            }

            return;
          }(c, function (t) {
            return t.test(s);
          }) : function findKey(t, e) {
            for (var r in t) {
              if (t.hasOwnProperty(r) && e(t[r])) return r;
            }

            return;
          }(c, function (t) {
            return t.test(s);
          });
          return a = t.valueCallback ? t.valueCallback(l) : l, {
            value: a = r.valueCallback ? r.valueCallback(a) : a,
            rest: e.slice(s.length)
          };
        };
      }

      var Nr = {
        code: "en-US",
        formatDistance: Dr,
        formatLong: Ir,
        formatRelative: function formatRelative2(t, e, r, n) {
          return Lr[t];
        },
        localize: {
          ordinalNumber: function ordinalNumber2(t, e) {
            var r = Number(t),
                n = r % 100;
            if (n > 20 || n < 10) switch (n % 10) {
              case 1:
                return r + "st";

              case 2:
                return r + "nd";

              case 3:
                return r + "rd";
            }
            return r + "th";
          },
          era: buildLocalizeFn({
            values: {
              narrow: ["B", "A"],
              abbreviated: ["BC", "AD"],
              wide: ["Before Christ", "Anno Domini"]
            },
            defaultWidth: "wide"
          }),
          quarter: buildLocalizeFn({
            values: {
              narrow: ["1", "2", "3", "4"],
              abbreviated: ["Q1", "Q2", "Q3", "Q4"],
              wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
            },
            defaultWidth: "wide",
            argumentCallback: function argumentCallback(t) {
              return t - 1;
            }
          }),
          month: buildLocalizeFn({
            values: {
              narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
              abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
              wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
            },
            defaultWidth: "wide"
          }),
          day: buildLocalizeFn({
            values: {
              narrow: ["S", "M", "T", "W", "T", "F", "S"],
              short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
              abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
              wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
            },
            defaultWidth: "wide"
          }),
          dayPeriod: buildLocalizeFn({
            values: {
              narrow: {
                am: "a",
                pm: "p",
                midnight: "mi",
                noon: "n",
                morning: "morning",
                afternoon: "afternoon",
                evening: "evening",
                night: "night"
              },
              abbreviated: {
                am: "AM",
                pm: "PM",
                midnight: "midnight",
                noon: "noon",
                morning: "morning",
                afternoon: "afternoon",
                evening: "evening",
                night: "night"
              },
              wide: {
                am: "a.m.",
                pm: "p.m.",
                midnight: "midnight",
                noon: "noon",
                morning: "morning",
                afternoon: "afternoon",
                evening: "evening",
                night: "night"
              }
            },
            defaultWidth: "wide",
            formattingValues: {
              narrow: {
                am: "a",
                pm: "p",
                midnight: "mi",
                noon: "n",
                morning: "in the morning",
                afternoon: "in the afternoon",
                evening: "in the evening",
                night: "at night"
              },
              abbreviated: {
                am: "AM",
                pm: "PM",
                midnight: "midnight",
                noon: "noon",
                morning: "in the morning",
                afternoon: "in the afternoon",
                evening: "in the evening",
                night: "at night"
              },
              wide: {
                am: "a.m.",
                pm: "p.m.",
                midnight: "midnight",
                noon: "noon",
                morning: "in the morning",
                afternoon: "in the afternoon",
                evening: "in the evening",
                night: "at night"
              }
            },
            defaultFormattingWidth: "wide"
          })
        },
        match: {
          ordinalNumber: function buildMatchPatternFn(t) {
            return function (e) {
              var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                  n = e.match(t.matchPattern);
              if (!n) return null;
              var i = n[0],
                  o = e.match(t.parsePattern);
              if (!o) return null;
              var a = t.valueCallback ? t.valueCallback(o[0]) : o[0];
              return {
                value: a = r.valueCallback ? r.valueCallback(a) : a,
                rest: e.slice(i.length)
              };
            };
          }({
            matchPattern: /^(\d+)(th|st|nd|rd)?/i,
            parsePattern: /\d+/i,
            valueCallback: function valueCallback(t) {
              return parseInt(t, 10);
            }
          }),
          era: buildMatchFn({
            matchPatterns: {
              narrow: /^(b|a)/i,
              abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
              wide: /^(before christ|before common era|anno domini|common era)/i
            },
            defaultMatchWidth: "wide",
            parsePatterns: {
              any: [/^b/i, /^(a|c)/i]
            },
            defaultParseWidth: "any"
          }),
          quarter: buildMatchFn({
            matchPatterns: {
              narrow: /^[1234]/i,
              abbreviated: /^q[1234]/i,
              wide: /^[1234](th|st|nd|rd)? quarter/i
            },
            defaultMatchWidth: "wide",
            parsePatterns: {
              any: [/1/i, /2/i, /3/i, /4/i]
            },
            defaultParseWidth: "any",
            valueCallback: function valueCallback2(t) {
              return t + 1;
            }
          }),
          month: buildMatchFn({
            matchPatterns: {
              narrow: /^[jfmasond]/i,
              abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
              wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
            },
            defaultMatchWidth: "wide",
            parsePatterns: {
              narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
              any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
            },
            defaultParseWidth: "any"
          }),
          day: buildMatchFn({
            matchPatterns: {
              narrow: /^[smtwf]/i,
              short: /^(su|mo|tu|we|th|fr|sa)/i,
              abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
              wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
            },
            defaultMatchWidth: "wide",
            parsePatterns: {
              narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
              any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
            },
            defaultParseWidth: "any"
          }),
          dayPeriod: buildMatchFn({
            matchPatterns: {
              narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
              any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
            },
            defaultMatchWidth: "any",
            parsePatterns: {
              any: {
                am: /^a/i,
                pm: /^p/i,
                midnight: /^mi/i,
                noon: /^no/i,
                morning: /morning/i,
                afternoon: /afternoon/i,
                evening: /evening/i,
                night: /night/i
              }
            },
            defaultParseWidth: "any"
          })
        },
        options: {
          weekStartsOn: 0,
          firstWeekContainsDate: 1
        }
      },
          Br = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,
          Fr = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g,
          Ur = /^'([^]*?)'?$/,
          Wr = /''/g,
          zr = /[a-zA-Z]/;

      function format(t, e, r) {
        var n, i, o, a, s, c, l, u, h, d, f, p, y, g, m, v, b, x;
        requiredArgs(2, arguments);
        var w = String(e),
            S = getDefaultOptions(),
            O = null !== (n = null !== (i = null === r || void 0 === r ? void 0 : r.locale) && void 0 !== i ? i : S.locale) && void 0 !== n ? n : Nr,
            E = toInteger(null !== (o = null !== (a = null !== (s = null !== (c = null === r || void 0 === r ? void 0 : r.firstWeekContainsDate) && void 0 !== c ? c : null === r || void 0 === r ? void 0 : null === (l = r.locale) || void 0 === l ? void 0 : null === (u = l.options) || void 0 === u ? void 0 : u.firstWeekContainsDate) && void 0 !== s ? s : S.firstWeekContainsDate) && void 0 !== a ? a : null === (h = S.locale) || void 0 === h ? void 0 : null === (d = h.options) || void 0 === d ? void 0 : d.firstWeekContainsDate) && void 0 !== o ? o : 1);
        if (!(E >= 1 && E <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
        var k = toInteger(null !== (f = null !== (p = null !== (y = null !== (g = null === r || void 0 === r ? void 0 : r.weekStartsOn) && void 0 !== g ? g : null === r || void 0 === r ? void 0 : null === (m = r.locale) || void 0 === m ? void 0 : null === (v = m.options) || void 0 === v ? void 0 : v.weekStartsOn) && void 0 !== y ? y : S.weekStartsOn) && void 0 !== p ? p : null === (b = S.locale) || void 0 === b ? void 0 : null === (x = b.options) || void 0 === x ? void 0 : x.weekStartsOn) && void 0 !== f ? f : 0);
        if (!(k >= 0 && k <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
        if (!O.localize) throw new RangeError("locale must contain localize property");
        if (!O.formatLong) throw new RangeError("locale must contain formatLong property");

        var _ = toDate(t);

        if (!isValid(_)) throw new RangeError("Invalid time value");

        var C = function subMilliseconds(t, e) {
          return requiredArgs(2, arguments), addMilliseconds(t, -toInteger(e));
        }(_, getTimezoneOffsetInMilliseconds(_)),
            T = {
          firstWeekContainsDate: E,
          weekStartsOn: k,
          locale: O,
          _originalDate: _
        };

        return w.match(Fr).map(function (t) {
          var e = t[0];
          return "p" === e || "P" === e ? (0, Mr[e])(t, O.formatLong) : t;
        }).join("").match(Br).map(function (n) {
          if ("''" === n) return "'";
          var i = n[0];
          if ("'" === i) return function cleanEscapedString(t) {
            var e = t.match(Ur);
            if (!e) return t;
            return e[1].replace(Wr, "'");
          }(n);
          var o = Cr[i];
          if (o) return null !== r && void 0 !== r && r.useAdditionalWeekYearTokens || !function isProtectedWeekYearToken(t) {
            return -1 !== jr.indexOf(t);
          }(n) || throwProtectedError(n, e, String(t)), null !== r && void 0 !== r && r.useAdditionalDayOfYearTokens || !function isProtectedDayOfYearToken(t) {
            return -1 !== Pr.indexOf(t);
          }(n) || throwProtectedError(n, e, String(t)), o(C, n, O.localize, T);
          if (i.match(zr)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + i + "`");
          return n;
        }).join("");
      }

      function intervalToDuration(t) {
        requiredArgs(1, arguments);
        var e = toDate(t.start),
            r = toDate(t.end);
        if (isNaN(e.getTime())) throw new RangeError("Start Date is invalid");
        if (isNaN(r.getTime())) throw new RangeError("End Date is invalid");
        var n = {};
        n.years = Math.abs(differenceInYears(r, e));
        var i = compareAsc(r, e),
            o = add(e, {
          years: i * n.years
        });
        n.months = Math.abs(differenceInMonths(r, o));
        var a = add(o, {
          months: i * n.months
        });
        n.days = Math.abs(differenceInDays(r, a));
        var s = add(a, {
          days: i * n.days
        });
        n.hours = Math.abs(function differenceInHours(t, e, r) {
          requiredArgs(2, arguments);
          var n = differenceInMilliseconds(t, e) / pr;
          return getRoundingMethod(null === r || void 0 === r ? void 0 : r.roundingMethod)(n);
        }(r, s));
        var c = add(s, {
          hours: i * n.hours
        });
        n.minutes = Math.abs(differenceInMinutes(r, c));
        var l = add(c, {
          minutes: i * n.minutes
        });
        return n.seconds = Math.abs(function differenceInSeconds(t, e, r) {
          requiredArgs(2, arguments);
          var n = differenceInMilliseconds(t, e) / 1e3;
          return getRoundingMethod(null === r || void 0 === r ? void 0 : r.roundingMethod)(n);
        }(r, l)), n;
      }

      function parseISO(t, e) {
        var r;
        requiredArgs(1, arguments);
        var n = toInteger(null !== (r = null === e || void 0 === e ? void 0 : e.additionalDigits) && void 0 !== r ? r : 2);
        if (2 !== n && 1 !== n && 0 !== n) throw new RangeError("additionalDigits must be 0, 1 or 2");
        if ("string" !== typeof t && "[object String]" !== Object.prototype.toString.call(t)) return new Date(NaN);

        var i,
            o = function splitDateString(t) {
          var e,
              r = {},
              n = t.split(qr.dateTimeDelimiter);
          if (n.length > 2) return r;
          /:/.test(n[0]) ? e = n[0] : (r.date = n[0], e = n[1], qr.timeZoneDelimiter.test(r.date) && (r.date = t.split(qr.timeZoneDelimiter)[0], e = t.substr(r.date.length, t.length)));

          if (e) {
            var i = qr.timezone.exec(e);
            i ? (r.time = e.replace(i[1], ""), r.timezone = i[1]) : r.time = e;
          }

          return r;
        }(t);

        if (o.date) {
          var a = function parseYear(t, e) {
            var r = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + e) + "})|(\\d{2}|[+-]\\d{" + (2 + e) + "})$)"),
                n = t.match(r);
            if (!n) return {
              year: NaN,
              restDateString: ""
            };
            var i = n[1] ? parseInt(n[1]) : null,
                o = n[2] ? parseInt(n[2]) : null;
            return {
              year: null === o ? i : 100 * o,
              restDateString: t.slice((n[1] || n[2]).length)
            };
          }(o.date, n);

          i = function parseDate(t, e) {
            if (null === e) return new Date(NaN);
            var r = t.match(Hr);
            if (!r) return new Date(NaN);
            var n = !!r[4],
                i = parseDateUnit(r[1]),
                o = parseDateUnit(r[2]) - 1,
                a = parseDateUnit(r[3]),
                s = parseDateUnit(r[4]),
                c = parseDateUnit(r[5]) - 1;
            if (n) return function validateWeekDate(t, e, r) {
              return e >= 1 && e <= 53 && r >= 0 && r <= 6;
            }(0, s, c) ? function dayOfISOWeekYear(t, e, r) {
              var n = new Date(0);
              n.setUTCFullYear(t, 0, 4);
              var i = n.getUTCDay() || 7,
                  o = 7 * (e - 1) + r + 1 - i;
              return n.setUTCDate(n.getUTCDate() + o), n;
            }(e, s, c) : new Date(NaN);
            var l = new Date(0);
            return function validateDate(t, e, r) {
              return e >= 0 && e <= 11 && r >= 1 && r <= (Xr[e] || (isLeapYearIndex(t) ? 29 : 28));
            }(e, o, a) && function validateDayOfYearDate(t, e) {
              return e >= 1 && e <= (isLeapYearIndex(t) ? 366 : 365);
            }(e, i) ? (l.setUTCFullYear(e, o, Math.max(i, a)), l) : new Date(NaN);
          }(a.restDateString, a.year);
        }

        if (!i || isNaN(i.getTime())) return new Date(NaN);
        var s,
            c = i.getTime(),
            l = 0;
        if (o.time && (l = function parseTime(t) {
          var e = t.match(Gr);
          if (!e) return NaN;
          var r = parseTimeUnit(e[1]),
              n = parseTimeUnit(e[2]),
              i = parseTimeUnit(e[3]);
          if (!function validateTime(t, e, r) {
            if (24 === t) return 0 === e && 0 === r;
            return r >= 0 && r < 60 && e >= 0 && e < 60 && t >= 0 && t < 25;
          }(r, n, i)) return NaN;
          return r * pr + n * fr + 1e3 * i;
        }(o.time), isNaN(l))) return new Date(NaN);

        if (!o.timezone) {
          var u = new Date(c + l),
              h = new Date(0);
          return h.setFullYear(u.getUTCFullYear(), u.getUTCMonth(), u.getUTCDate()), h.setHours(u.getUTCHours(), u.getUTCMinutes(), u.getUTCSeconds(), u.getUTCMilliseconds()), h;
        }

        return s = function parseTimezone(t) {
          if ("Z" === t) return 0;
          var e = t.match(Yr);
          if (!e) return 0;
          var r = "+" === e[1] ? -1 : 1,
              n = parseInt(e[2]),
              i = e[3] && parseInt(e[3]) || 0;
          if (!function validateTimezone(t, e) {
            return e >= 0 && e <= 59;
          }(0, i)) return NaN;
          return r * (n * pr + i * fr);
        }(o.timezone), isNaN(s) ? new Date(NaN) : new Date(c + l + s);
      }

      var qr = {
        dateTimeDelimiter: /[T ]/,
        timeZoneDelimiter: /[Z ]/i,
        timezone: /([Z+-].*)$/
      },
          Hr = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/,
          Gr = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/,
          Yr = /^([+-])(\d{2})(?::?(\d{2}))?$/;

      function parseDateUnit(t) {
        return t ? parseInt(t) : 1;
      }

      function parseTimeUnit(t) {
        return t && parseFloat(t.replace(",", ".")) || 0;
      }

      var Xr = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

      function isLeapYearIndex(t) {
        return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
      }

      var Vr = function TypeFormats() {
        Object(W.a)(this, TypeFormats);
      };

      Vr.SIMPLE_DATE_TIME = function (t) {
        return Qr(t, "MMMM do, h:mm a");
      }, Vr.TIME = function (t) {
        return Qr(t, "h:mm a");
      }, Vr.DATE_TIME = function (t) {
        return Qr(t, "MM/dd/yyyy h:mm:ss a");
      }, Vr.DATE = function (t) {
        return Qr(t, "MM/dd/yyyy");
      }, Vr.DATE_DASH = function (t) {
        return Qr(t, "MM-dd-yyyy");
      }, Vr.DURATION_FROM_SECONDS_TO_MIN_SEC = function (t) {
        if (!t && 0 !== t) return "";
        var e = intervalToDuration({
          start: 0,
          end: 1e3 * t
        });
        return "".concat(e.minutes, "m ").concat(e.seconds, "s");
      }, Vr.DAY_OF_WEEK = function (t) {
        return Qr(t, "EEEE");
      }, Vr.TITLE_CASE = function (t) {
        return nn(t);
      }, Vr.PLURALIZE = function (t, e, r) {
        return Kr(t, e, r);
      }, Vr.RAW_HUMANIZED = function (t) {
        return sn(t);
      }, Vr.FIXED = function (t) {
        return ln(t, 1);
      }, Vr.ROUND = function (t) {
        return ln(t);
      }, Vr.CURRENCY = function (t) {
        return "$".concat(ln(t, 1));
      }, Vr.PERCENT = function (t) {
        return "".concat(cn(Math.round(t)) || 0, "%");
      }, Vr.NUMERIC = function (t) {
        return +t;
      };

      var $r,
          Qr = function formatDate() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Date.now(),
            e = arguments.length > 1 ? arguments[1] : void 0;
        if (null === t) return "";

        try {
          return me(String, t) ? format(parseISO(t), e) : format(t, e);
        } catch (r) {
          return "";
        }
      },
          Kr = function pluralize(t, e, r) {
        return Re(t) && Re(e) ? null : (r = Re(r) ? "".concat(e, "s") : r, Gt(t, 1) ? e : r);
      },
          Zr = /\b(?:an?d?|a[st]|because|but|by|en|for|i[fn]|neither|nor|o[fnr]|only|over|per|so|some|tha[tn]|the|to|up|upon|vs?\.?|versus|via|when|with|without|yet)\b/i,
          Jr = /[^\s:\u2013\u2014-]+|./g,
          tn = /\s/,
          en = /.(?=[A-Z]|\..)/,
          rn = /[A-Za-z0-9\u00C0-\u00FF]/,
          nn = function titleCase(t) {
        var e,
            r = "";
        if (Re(t)) return "";

        for (; null !== (e = Jr.exec(t));) {
          var n = e,
              i = n[0],
              o = n.index;
          en.test(i) || Zr.test(i) && 0 !== o && o + i.length !== t.length || ":" === t.charAt(o + i.length) && !tn.test(t.charAt(o + i.length + 1)) ? r += i : r += i.replace(rn, function (t) {
            return t.toUpperCase();
          });
        }

        return r;
      },
          on = function normalizePrecision(t, e) {
        var r = e ? Math.round(Math.abs(e)) : NaN;
        return Number.isNaN(r) ? t : r;
      },
          an = function toFixed(t, e) {
        var r = e || on(0, e),
            n = Math.pow(10, r);
        return (Math.round(t * n) / n).toFixed(r);
      },
          sn = function formatNumber(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ",",
            n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : ".",
            i = on(0, e),
            o = t < 0 ? "-" : "",
            a = String(parseInt(an(Math.abs(t || 0), i), 10)),
            s = a.length > 3 ? a.length % 3 : 0;
        return o + function firstComma(t, e, r) {
          return r ? t.substr(0, r) + e : "";
        }(a, r, s) + function commas(t, e, r) {
          return t.substr(r).replace(/(\d{3})(?=\d)/g, "$1".concat(e));
        }(a, r, s) + function decimals(t, e, r) {
          return r ? e + an(Math.abs(t), r).split(".")[1] : "";
        }(t, n, i);
      },
          cn = function intComma(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
        return sn(t, e);
      },
          ln = function compactInteger(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
        e = Math.max(e, 0);
        var r = parseInt(t.toString(), 10),
            n = r < 0 ? "-" : "",
            i = Math.abs(r),
            o = String(i),
            a = o.length,
            s = [13, 10, 7, 4],
            c = ["T", "B", "M", "k"];
        if (i < 1e3) return "".concat(n).concat(o);
        if (a > s[0] + 3) return r.toExponential(e).replace("e+", "x10^");

        for (var l = 0, u = 0; u < s.length; u++) {
          var h = s[u];

          if (a >= h) {
            l = h;
            break;
          }
        }

        var d,
            f = a - l + 1,
            p = o.split(""),
            y = p.slice(0, f),
            g = p.slice(f, f + e + 1),
            m = y.join(""),
            v = g.join("");
        if (v.length < e && (v += "".concat(Array(e - v.length + 1).join("0"))), 0 === e) d = "".concat(n).concat(m).concat(c[s.indexOf(l)]);else {
          var b = Number("".concat(m, ".").concat(v)).toFixed(e);
          d = "".concat(n).concat(b).concat(c[s.indexOf(l)]);
        }
        return d;
      },
          un = (J.theme.colors.blue9.value, J.theme.colors.teal4.value, J.theme.colors.purple8.value, J.theme.colors.pink7.value, J.theme.colors.yellow5.value, J.theme.colors.orange4.value, J.theme.colors.purple6.value, J.theme.colors.blue4.value, J.theme.colors.teal8.value, J.theme.colors.yellow3.value, J.theme.colors.green2.value, {
        title: {
          text: ""
        },
        legend: {
          layout: "horizontal",
          align: "center",
          verticalAlign: "bottom",
          backgroundColor: "var(--drift-dds-colors-white)",
          floating: !1,
          x: 0,
          y: 0,
          itemDistance: 8,
          padding: 0,
          margin: 24,
          itemMarginBottom: 8,
          itemStyle: {
            fontSize: "var(--drift-dds-fontSizes-metadata)",
            fontWeight: "var(--drift-dds-fontWeights-metadata)",
            lineHeight: "var(--drift-dds-lineHeights-metadata)",
            letterSpacing: "var(--drift-dds-letterSpacings-metadata)",
            color: "var(--drift-dds-colors-gray10)"
          },
          itemHoverStyle: {
            color: "var(--drift-dds-colors-gray12)"
          },
          itemHiddenStyle: {
            color: "var(--drift-dds-colors-gray8)"
          }
        },
        chart: {
          spacingBottom: 0,
          style: {
            fontFamily: "var(--drift-dds-fonts-primary)"
          }
        },
        yAxis: {
          title: {
            text: null
          },
          labels: {
            style: {
              fontSize: "var(--drift-dds-fontSizes-body)",
              fontWeight: "var(--drift-dds-fontWeights-body)",
              lineHeight: "var(--drift-dds-lineHeights-body)",
              letterSpacing: "var(--drift-dds-letterSpacings-body)",
              color: "var(--drift-dds-colors-gray8)"
            }
          },
          minRange: 1,
          gridLineColor: "var(--drift-dds-colors-gray3)"
        },
        xAxis: {
          type: "datetime",
          dateTimeLabelFormats: {
            day: "%o/%e"
          },
          lineColor: "transparent",
          minPadding: .05,
          maxPadding: .05,
          minorTickLength: 0,
          tickLength: 0,
          offset: 12,
          labels: {
            style: {
              marginTop: 20,
              fontSize: "var(--drift-dds-fontSizes-body)",
              fontWeight: "var(--drift-dds-fontWeights-body)",
              lineHeight: "var(--drift-dds-lineHeights-body)",
              letterSpacing: "var(--drift-dds-letterSpacings-body)",
              color: "var(--drift-dds-colors-gray8)"
            }
          }
        },
        credits: {
          enabled: !1
        },
        lang: {
          noData: "There's no data for this time frame"
        },
        noData: {
          style: {
            fontSize: "var(--drift-dds-fontSizes-body)",
            fontWeight: "var(--drift-dds-fontWeights-body)",
            color: "var(--drift-dds-colors-gray10)"
          }
        },
        tooltip: {
          useHTML: !0,
          borderWidth: 0,
          backgroundColor: void 0
        }
      }),
          hn = (Object(J.styled)("div", {
        minWidth: 150,
        zIndex: "$tooltip",
        backgroundColor: "$white",
        borderRadius: "$1",
        paddingX: "$1",
        paddingY: "$half",
        boxShadow: "$inflate24"
      }), Object(J.styled)("div", {
        width: "100%",
        display: "inline-block",
        borderTopLeftRadius: "$1",
        borderTopRightRadius: "$1",
        textStyles: "metadata",
        textColor: "metadata",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }), Object(J.styled)("div", {
        width: "100%"
      }), Object(J.createComponentContext)("ChartTooltip", {})),
          dn = Object(V.a)(hn, 2),
          fn = (dn[0], dn[1], Object(J.styled)("div", {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }), Object(J.styled)("span", {
        height: "$1",
        width: "$1",
        borderRadius: "$1",
        display: "inline-block"
      }), ($r = fn || {})[$r.DAY = 864e5] = "DAY", $r[$r.WEEK = 6048e5] = "WEEK", $r[$r.MONTH = 2592e6] = "MONTH", $r[$r.YEAR = 31536e6] = "YEAR", $r),
          pn = {
        exports: {}
      };

      !function (t) {
        var e, r;
        e = "undefined" !== typeof window ? window : De, r = function r(t) {
          function K2(e, r, n, i) {
            e.hasOwnProperty(r) || (e[r] = i.apply(null, n), "function" === typeof CustomEvent && t.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", {
              detail: {
                path: r,
                module: e[r]
              }
            })));
          }

          var e = {};
          return K2(e, "Core/Globals.js", [], function () {
            var e, r;
            return (r = e || (e = {})).SVG_NS = "http://www.w3.org/2000/svg", r.product = "Highcharts", r.version = "10.3.3", r.win = "undefined" !== typeof t ? t : {}, r.doc = r.win.document, r.svg = r.doc && r.doc.createElementNS && !!r.doc.createElementNS(r.SVG_NS, "svg").createSVGRect, r.userAgent = r.win.navigator && r.win.navigator.userAgent || "", r.isChrome = -1 !== r.userAgent.indexOf("Chrome"), r.isFirefox = -1 !== r.userAgent.indexOf("Firefox"), r.isMS = /(edge|msie|trident)/i.test(r.userAgent) && !r.win.opera, r.isSafari = !r.isChrome && -1 !== r.userAgent.indexOf("Safari"), r.isTouchDevice = /(Mobile|Android|Windows Phone)/.test(r.userAgent), r.isWebKit = -1 !== r.userAgent.indexOf("AppleWebKit"), r.deg2rad = 2 * Math.PI / 360, r.hasBidiBug = r.isFirefox && 4 > parseInt(r.userAgent.split("Firefox/")[1], 10), r.hasTouch = !!r.win.TouchEvent, r.marginNames = ["plotTop", "marginRight", "marginBottom", "plotLeft"], r.noop = function () {}, r.supportsPassiveEvents = function () {
              var t = !1;

              if (!r.isMS) {
                var e = Object.defineProperty({}, "passive", {
                  get: function get() {
                    t = !0;
                  }
                });
                r.win.addEventListener && r.win.removeEventListener && (r.win.addEventListener("testPassive", r.noop, e), r.win.removeEventListener("testPassive", r.noop, e));
              }

              return t;
            }(), r.charts = [], r.dateFormats = {}, r.seriesTypes = {}, r.symbolSizes = {}, r.chartCount = 0, e;
          }), K2(e, "Core/Utilities.js", [e["Core/Globals.js"]], function (t) {
            function g3(e, r, i, o) {
              var a = r ? "Highcharts error" : "Highcharts warning";
              32 === e && (e = a + ": Deprecated member");
              var s = l2(e),
                  c = s ? a + " #" + e + ": www.highcharts.com/errors/" + e + "/" : e.toString();

              if ("undefined" !== typeof o) {
                var l = "";
                s && (c += "?"), E2(o, function (t, e) {
                  l += "\n - ".concat(e, ": ").concat(t), s && (c += encodeURI(e) + "=" + encodeURI(t));
                }), c += l;
              }

              y3(t, "displayError", {
                chart: i,
                code: e,
                message: c,
                params: o
              }, function () {
                if (r) throw Error(c);
                n.console && -1 === g3.messages.indexOf(c) && console.warn(c);
              }), g3.messages.push(c);
            }

            function F(t, e) {
              return parseInt(t, e || 10);
            }

            function C(t) {
              return "string" === typeof t;
            }

            function B2(t) {
              return "[object Array]" === (t = Object.prototype.toString.call(t)) || "[object Array Iterator]" === t;
            }

            function H3(t, e) {
              return !!t && "object" === typeof t && (!e || !B2(t));
            }

            function t3(t) {
              return H3(t) && "number" === typeof t.nodeType;
            }

            function r2(t) {
              var e = t && t.constructor;
              return !(!H3(t, !0) || t3(t) || !e || !e.name || "Object" === e.name);
            }

            function l2(t) {
              return "number" === typeof t && !isNaN(t) && 1 / 0 > t && -1 / 0 < t;
            }

            function e3(t) {
              return "undefined" !== typeof t && null !== t;
            }

            function d3(t, e, r) {
              var n,
                  i = C(e) && !e3(r),
                  o = function n3(e, r) {
                e3(e) ? t.setAttribute(r, e) : i ? (n = t.getAttribute(r)) || "class" !== r || (n = t.getAttribute(r + "Name")) : t.removeAttribute(r);
              };

              return C(e) ? o(r, e) : E2(e, o), n;
            }

            function h4(t, e) {
              var r;

              for (r in t || (t = {}), e) {
                t[r] = e[r];
              }

              return t;
            }

            function m4() {
              for (var t = arguments, e = t.length, r = 0; r < e; r++) {
                var n = t[r];
                if ("undefined" !== typeof n && null !== n) return n;
              }
            }

            function k3(e, r) {
              t.isMS && !t.svg && r && e3(r.opacity) && (r.filter = "alpha(opacity=".concat(100 * r.opacity, ")")), h4(e.style, r);
            }

            function p2(t) {
              return Math.pow(10, Math.floor(Math.log(t) / Math.LN10));
            }

            function D2(t, e) {
              return 1e14 < t ? t : parseFloat(t.toPrecision(e || 14));
            }

            function E2(t, e, r) {
              for (var n in t) {
                Object.hasOwnProperty.call(t, n) && e.call(r || t[n], t[n], n, t);
              }
            }

            function L2(e, r, n) {
              function z2(r, n) {
                var i = e.removeEventListener || t.removeEventListenerPolyfill;
                i && i.call(e, r, n, !1);
              }

              function q3(t) {
                var n;

                if (e.nodeName) {
                  if (r) {
                    var i = {};
                    i[r] = !0;
                  } else i = t;

                  E2(i, function (e, r) {
                    if (t[r]) for (n = t[r].length; n--;) {
                      z2(r, t[r][n].fn);
                    }
                  });
                }
              }

              var i = "function" === typeof e && e.prototype || e;

              if (Object.hasOwnProperty.call(i, "hcEvents")) {
                var o = i.hcEvents;
                r ? (i = o[r] || [], n ? (o[r] = i.filter(function (t) {
                  return n !== t.fn;
                }), z2(r, n)) : (q3(o), o[r] = [])) : (q3(o), delete i.hcEvents);
              }
            }

            function y3(e, n, i, o) {
              if (i = i || {}, r.createEvent && (e.dispatchEvent || e.fireEvent && e !== t)) {
                var a = r.createEvent("Events");
                a.initEvent(n, !0, !0), i = h4(a, i), e.dispatchEvent ? e.dispatchEvent(i) : e.fireEvent(n, i);
              } else if (e.hcEvents) {
                i.target || h4(i, {
                  preventDefault: function preventDefault() {
                    i.defaultPrevented = !0;
                  },
                  target: e,
                  type: n
                }), a = [];

                for (var s = e, c = !1; s.hcEvents;) {
                  Object.hasOwnProperty.call(s, "hcEvents") && s.hcEvents[n] && (a.length && (c = !0), a.unshift.apply(a, s.hcEvents[n])), s = Object.getPrototypeOf(s);
                }

                c && a.sort(function (t, e) {
                  return t.order - e.order;
                }), a.forEach(function (t) {
                  !1 === t.fn.call(e, i) && i.preventDefault();
                });
              }

              o && !i.defaultPrevented && o.call(e, i);
            }

            var e = t.charts,
                r = t.doc,
                n = t.win;
            (g3 || (g3 = {})).messages = [], Math.easeInOutSine = function (t) {
              return -.5 * (Math.cos(Math.PI * t) - 1);
            };
            var i = Array.prototype.find ? function (t, e) {
              return t.find(e);
            } : function (t, e) {
              var r,
                  n = t.length;

              for (r = 0; r < n; r++) {
                if (e(t[r], r)) return t[r];
              }
            };
            E2({
              map: "map",
              each: "forEach",
              grep: "filter",
              reduce: "reduce",
              some: "some"
            }, function (e, r) {
              t[r] = function (t) {
                var n;
                return g3(32, !1, void 0, ((n = {})["Highcharts.".concat(r)] = "use Array.".concat(e), n)), Array.prototype[e].apply(t, [].slice.call(arguments, 1));
              };
            });

            var o,
                a = function () {
              var t = Math.random().toString(36).substring(2, 9) + "-",
                  e = 0;
              return function () {
                return "highcharts-" + (o ? "" : t) + e++;
              };
            }();

            return n.jQuery && (n.jQuery.fn.highcharts = function () {
              var r = [].slice.call(arguments);
              if (this[0]) return r[0] ? (new t[C(r[0]) ? r.shift() : "Chart"](this[0], r[0], r[1]), this) : e[d3(this[0], "data-highcharts-chart")];
            }), i = {
              addEvent: function addEvent(e, r, n, i) {
                void 0 === i && (i = {});
                var o = "function" === typeof e && e.prototype || e;
                Object.hasOwnProperty.call(o, "hcEvents") || (o.hcEvents = {}), o = o.hcEvents, t.Point && e instanceof t.Point && e.series && e.series.chart && (e.series.chart.runTrackerClick = !0);
                var a = e.addEventListener || t.addEventListenerPolyfill;
                return a && a.call(e, r, n, !!t.supportsPassiveEvents && {
                  passive: void 0 === i.passive ? -1 !== r.indexOf("touch") : i.passive,
                  capture: !1
                }), o[r] || (o[r] = []), o[r].push({
                  fn: n,
                  order: "number" === typeof i.order ? i.order : 1 / 0
                }), o[r].sort(function (t, e) {
                  return t.order - e.order;
                }), function () {
                  L2(e, r, n);
                };
              },
              arrayMax: function arrayMax(t) {
                for (var e = t.length, r = t[0]; e--;) {
                  t[e] > r && (r = t[e]);
                }

                return r;
              },
              arrayMin: function arrayMin(t) {
                for (var e = t.length, r = t[0]; e--;) {
                  t[e] < r && (r = t[e]);
                }

                return r;
              },
              attr: d3,
              clamp: function clamp(t, e, r) {
                return t > e ? t < r ? t : r : e;
              },
              cleanRecursively: function x2(t, e) {
                var r = {};
                return E2(t, function (n, i) {
                  H3(t[i], !0) && !t.nodeType && e[i] ? (n = x2(t[i], e[i]), Object.keys(n).length && (r[i] = n)) : (H3(t[i]) || t[i] !== e[i] || i in t && !(i in e)) && (r[i] = t[i]);
                }), r;
              },
              clearTimeout: function (t) {
                function clearTimeout(e) {
                  return t.apply(this, arguments);
                }

                return clearTimeout.toString = function () {
                  return t.toString();
                }, clearTimeout;
              }(function (t) {
                e3(t) && clearTimeout(t);
              }),
              correctFloat: D2,
              createElement: function createElement(t, e, n, i, o) {
                return t = r.createElement(t), e && h4(t, e), o && k3(t, {
                  padding: "0",
                  border: "none",
                  margin: "0"
                }), n && k3(t, n), i && i.appendChild(t), t;
              },
              css: k3,
              defined: e3,
              destroyObjectProperties: function destroyObjectProperties(t, e) {
                E2(t, function (r, n) {
                  r && r !== e && r.destroy && r.destroy(), delete t[n];
                });
              },
              discardElement: function discardElement(t) {
                t && t.parentElement && t.parentElement.removeChild(t);
              },
              erase: function erase(t, e) {
                for (var r = t.length; r--;) {
                  if (t[r] === e) {
                    t.splice(r, 1);
                    break;
                  }
                }
              },
              error: g3,
              extend: h4,
              extendClass: function extendClass(t, e) {
                var r = function c3() {};

                return h4(r.prototype = new t(), e), r;
              },
              find: i,
              fireEvent: y3,
              getMagnitude: p2,
              getNestedProperty: function getNestedProperty(t, e) {
                for (t = t.split("."); t.length && e3(e);) {
                  var r = t.shift();
                  if ("undefined" === typeof r || "__proto__" === r) return;
                  if (!e3(e = e[r]) || "function" === typeof e || "number" === typeof e.nodeType || e === n) return;
                }

                return e;
              },
              getStyle: function I2(e, r, i) {
                var o = t.getStyle || I2;
                if ("width" === r) return r = Math.min(e.offsetWidth, e.scrollWidth), (i = e.getBoundingClientRect && e.getBoundingClientRect().width) < r && i >= r - 1 && (r = Math.floor(i)), Math.max(0, r - (o(e, "padding-left", !0) || 0) - (o(e, "padding-right", !0) || 0));
                if ("height" === r) return Math.max(0, Math.min(e.offsetHeight, e.scrollHeight) - (o(e, "padding-top", !0) || 0) - (o(e, "padding-bottom", !0) || 0));

                if (n.getComputedStyle || g3(27, !0), e = n.getComputedStyle(e, void 0)) {
                  var a = e.getPropertyValue(r);
                  m4(i, "opacity" !== r) && (a = F(a));
                }

                return a;
              },
              inArray: function inArray(t, e, r) {
                return g3(32, !1, void 0, {
                  "Highcharts.inArray": "use Array.indexOf"
                }), e.indexOf(t, r);
              },
              isArray: B2,
              isClass: r2,
              isDOMElement: t3,
              isFunction: function isFunction(t) {
                return "function" === typeof t;
              },
              isNumber: l2,
              isObject: H3,
              isString: C,
              keys: function keys(t) {
                return g3(32, !1, void 0, {
                  "Highcharts.keys": "use Object.keys"
                }), Object.keys(t);
              },
              merge: function merge() {
                var t,
                    e = arguments,
                    r = {},
                    n = function J(t, e) {
                  return "object" !== typeof t && (t = {}), E2(e, function (r, n) {
                    "__proto__" !== n && "constructor" !== n && (!H3(r, !0) || r2(r) || t3(r) ? t[n] = e[n] : t[n] = J(t[n] || {}, r));
                  }), t;
                };

                !0 === e[0] && (r = e[1], e = Array.prototype.slice.call(e, 2));
                var i = e.length;

                for (t = 0; t < i; t++) {
                  r = n(r, e[t]);
                }

                return r;
              },
              normalizeTickInterval: function normalizeTickInterval(t, e, r, n, i) {
                var o = t,
                    a = t / (r = m4(r, p2(t)));

                for (e || (e = i ? [1, 1.2, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10] : [1, 2, 2.5, 5, 10], !1 === n && (1 === r ? e = e.filter(function (t) {
                  return t % 1 === 0;
                }) : .1 >= r && (e = [1 / r]))), n = 0; n < e.length && (o = e[n], !(i && o * r >= t || !i && a <= (e[n] + (e[n + 1] || e[n])) / 2)); n++) {
                  ;
                }

                return D2(o * r, -Math.round(Math.log(.001) / Math.LN10));
              },
              objectEach: E2,
              offset: function offset(t) {
                var e = r.documentElement;
                return {
                  top: (t = t.parentElement || t.parentNode ? t.getBoundingClientRect() : {
                    top: 0,
                    left: 0,
                    width: 0,
                    height: 0
                  }).top + (n.pageYOffset || e.scrollTop) - (e.clientTop || 0),
                  left: t.left + (n.pageXOffset || e.scrollLeft) - (e.clientLeft || 0),
                  width: t.width,
                  height: t.height
                };
              },
              pad: function pad(t, e, r) {
                return Array((e || 2) + 1 - String(t).replace("-", "").length).join(r || "0") + t;
              },
              pick: m4,
              pInt: F,
              relativeLength: function relativeLength(t, e, r) {
                return /%$/.test(t) ? e * parseFloat(t) / 100 + (r || 0) : parseFloat(t);
              },
              removeEvent: L2,
              splat: function splat(t) {
                return B2(t) ? t : [t];
              },
              stableSort: function stableSort(t, e) {
                var r,
                    n,
                    i = t.length;

                for (n = 0; n < i; n++) {
                  t[n].safeI = n;
                }

                for (t.sort(function (t, n) {
                  return 0 === (r = e(t, n)) ? t.safeI - n.safeI : r;
                }), n = 0; n < i; n++) {
                  delete t[n].safeI;
                }
              },
              syncTimeout: function syncTimeout(t, e, r) {
                return 0 < e ? setTimeout(t, e, r) : (t.call(0, r), -1);
              },
              timeUnits: {
                millisecond: 1,
                second: 1e3,
                minute: 6e4,
                hour: 36e5,
                day: 864e5,
                week: 6048e5,
                month: 24192e5,
                year: 314496e5
              },
              uniqueKey: a,
              useSerialIds: function useSerialIds(t) {
                return o = m4(t, o);
              },
              wrap: function wrap(t, e, r) {
                var n = t[e];

                t[e] = function () {
                  var t = arguments,
                      e = this;
                  return r.apply(this, [function () {
                    return n.apply(e, arguments.length ? arguments : t);
                  }].concat([].slice.call(arguments)));
                };
              }
            };
          }), K2(e, "Core/Chart/ChartDefaults.js", [], function () {
            return {
              alignThresholds: !1,
              panning: {
                enabled: !1,
                type: "x"
              },
              styledMode: !1,
              borderRadius: 0,
              colorCount: 10,
              allowMutatingData: !0,
              defaultSeriesType: "line",
              ignoreHiddenSeries: !0,
              spacing: [10, 10, 15, 10],
              resetZoomButton: {
                theme: {
                  zIndex: 6
                },
                position: {
                  align: "right",
                  x: -10,
                  y: 10
                }
              },
              zoomBySingleTouch: !1,
              zooming: {
                singleTouch: !1,
                resetButton: {
                  theme: {
                    zIndex: 6
                  },
                  position: {
                    align: "right",
                    x: -10,
                    y: 10
                  }
                }
              },
              width: null,
              height: null,
              borderColor: "#335cad",
              backgroundColor: "#ffffff",
              plotBorderColor: "#cccccc"
            };
          }), K2(e, "Core/Color/Color.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function (t, e) {
            var r = e.isNumber,
                n = e.merge,
                i = e.pInt;
            return e = function () {
              function g4(e) {
                this.rgba = [NaN, NaN, NaN, NaN], this.input = e;
                var r = t.Color;
                return r && r !== g4 ? new r(e) : this instanceof g4 ? void this.init(e) : new g4(e);
              }

              return g4.parse = function (t) {
                return t ? new g4(t) : g4.None;
              }, g4.prototype.init = function (t) {
                var e;
                if ("object" === typeof t && "undefined" !== typeof t.stops) this.stops = t.stops.map(function (t) {
                  return new g4(t[1]);
                });else if ("string" === typeof t) {
                  if (this.input = t = g4.names[t.toLowerCase()] || t, "#" === t.charAt(0)) {
                    var r = t.length,
                        n = parseInt(t.substr(1), 16);
                    7 === r ? e = [(16711680 & n) >> 16, (65280 & n) >> 8, 255 & n, 1] : 4 === r && (e = [(3840 & n) >> 4 | (3840 & n) >> 8, (240 & n) >> 4 | 240 & n, (15 & n) << 4 | 15 & n, 1]);
                  }

                  if (!e) for (n = g4.parsers.length; n-- && !e;) {
                    var i = g4.parsers[n];
                    (r = i.regex.exec(t)) && (e = i.parse(r));
                  }
                }
                e && (this.rgba = e);
              }, g4.prototype.get = function (t) {
                var e = this.input,
                    i = this.rgba;

                if ("object" === typeof e && "undefined" !== typeof this.stops) {
                  var o = n(e);
                  return o.stops = [].slice.call(o.stops), this.stops.forEach(function (e, r) {
                    o.stops[r] = [o.stops[r][0], e.get(t)];
                  }), o;
                }

                return i && r(i[0]) ? "rgb" === t || !t && 1 === i[3] ? "rgb(" + i[0] + "," + i[1] + "," + i[2] + ")" : "a" === t ? "".concat(i[3]) : "rgba(" + i.join(",") + ")" : e;
              }, g4.prototype.brighten = function (t) {
                var e = this.rgba;
                if (this.stops) this.stops.forEach(function (e) {
                  e.brighten(t);
                });else if (r(t) && 0 !== t) for (var n = 0; 3 > n; n++) {
                  e[n] += i(255 * t), 0 > e[n] && (e[n] = 0), 255 < e[n] && (e[n] = 255);
                }
                return this;
              }, g4.prototype.setOpacity = function (t) {
                return this.rgba[3] = t, this;
              }, g4.prototype.tweenTo = function (t, e) {
                var n = this.rgba,
                    i = t.rgba;
                return r(n[0]) && r(i[0]) ? ((t = 1 !== i[3] || 1 !== n[3]) ? "rgba(" : "rgb(") + Math.round(i[0] + (n[0] - i[0]) * (1 - e)) + "," + Math.round(i[1] + (n[1] - i[1]) * (1 - e)) + "," + Math.round(i[2] + (n[2] - i[2]) * (1 - e)) + (t ? "," + (i[3] + (n[3] - i[3]) * (1 - e)) : "") + ")" : t.input || "none";
              }, g4.names = {
                white: "#ffffff",
                black: "#000000"
              }, g4.parsers = [{
                regex: /rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,
                parse: function parse(t) {
                  return [i(t[1]), i(t[2]), i(t[3]), parseFloat(t[4], 10)];
                }
              }, {
                regex: /rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,
                parse: function parse(t) {
                  return [i(t[1]), i(t[2]), i(t[3]), 1];
                }
              }], g4.None = new g4(""), g4;
            }();
          }), K2(e, "Core/Color/Palettes.js", [], function () {
            return {
              colors: "#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1".split(" ")
            };
          }), K2(e, "Core/Time.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function (t, e) {
            var r = t.win,
                n = e.defined,
                i = e.error,
                o = e.extend,
                a = e.isObject,
                s = e.merge,
                c = e.objectEach,
                l = e.pad,
                u = e.pick,
                h = e.splat,
                d = e.timeUnits,
                f = t.isSafari && r.Intl && r.Intl.DateTimeFormat.prototype.formatRange,
                p = t.isSafari && r.Intl && !r.Intl.DateTimeFormat.prototype.formatRange;
            return e = function () {
              function p2(t) {
                this.options = {}, this.variableTimezone = this.useUTC = !1, this.Date = r.Date, this.getTimezoneOffset = this.timezoneOffsetFunction(), this.update(t);
              }

              return p2.prototype.get = function (t, e) {
                if (this.variableTimezone || this.timezoneOffset) {
                  var r = e.getTime(),
                      n = r - this.getTimezoneOffset(e);
                  return e.setTime(n), t = e["getUTC" + t](), e.setTime(r), t;
                }

                return this.useUTC ? e["getUTC" + t]() : e["get" + t]();
              }, p2.prototype.set = function (t, e, r) {
                if (this.variableTimezone || this.timezoneOffset) {
                  if ("Milliseconds" === t || "Seconds" === t || "Minutes" === t && this.getTimezoneOffset(e) % 36e5 === 0) return e["setUTC" + t](r);
                  var n = this.getTimezoneOffset(e);
                  return n = e.getTime() - n, e.setTime(n), e["setUTC" + t](r), t = this.getTimezoneOffset(e), n = e.getTime() + t, e.setTime(n);
                }

                return this.useUTC || f && "FullYear" === t ? e["setUTC" + t](r) : e["set" + t](r);
              }, p2.prototype.update = function (t) {
                void 0 === t && (t = {});
                var e = u(t.useUTC, !0);
                this.options = t = s(!0, this.options, t), this.Date = t.Date || r.Date || Date, this.timezoneOffset = (this.useUTC = e) && t.timezoneOffset || void 0, this.getTimezoneOffset = this.timezoneOffsetFunction(), this.variableTimezone = e && !(!t.getTimezoneOffset && !t.timezone);
              }, p2.prototype.makeTime = function (t, e, r, n, i, o) {
                if (this.useUTC) {
                  var a = this.Date.UTC.apply(0, arguments),
                      s = this.getTimezoneOffset(a);
                  a += s;
                  var c = this.getTimezoneOffset(a);
                  s !== c ? a += c - s : s - 36e5 !== this.getTimezoneOffset(a - 36e5) || p || (a -= 36e5);
                } else a = new this.Date(t, e, u(r, 1), u(n, 0), u(i, 0), u(o, 0)).getTime();

                return a;
              }, p2.prototype.timezoneOffsetFunction = function () {
                var t = this,
                    e = this.options,
                    n = e.getTimezoneOffset,
                    o = e.moment || r.moment;
                if (!this.useUTC) return function (t) {
                  return 6e4 * new Date(t.toString()).getTimezoneOffset();
                };

                if (e.timezone) {
                  if (o) return function (t) {
                    return 6e4 * -o.tz(t, e.timezone).utcOffset();
                  };
                  i(25);
                }

                return this.useUTC && n ? function (t) {
                  return 6e4 * n(t.valueOf());
                } : function () {
                  return 6e4 * (t.timezoneOffset || 0);
                };
              }, p2.prototype.dateFormat = function (e, r, i) {
                if (!n(r) || isNaN(r)) return t.defaultOptions.lang && t.defaultOptions.lang.invalidDate || "";
                e = u(e, "%Y-%m-%d %H:%M:%S");
                var a = this,
                    s = new this.Date(r),
                    h = this.get("Hours", s),
                    d = this.get("Day", s),
                    f = this.get("Date", s),
                    p = this.get("Month", s),
                    y = this.get("FullYear", s),
                    g = t.defaultOptions.lang,
                    m = g && g.weekdays,
                    v = g && g.shortWeekdays;
                return s = o({
                  a: v ? v[d] : m[d].substr(0, 3),
                  A: m[d],
                  d: l(f),
                  e: l(f, 2, " "),
                  w: d,
                  b: g.shortMonths[p],
                  B: g.months[p],
                  m: l(p + 1),
                  o: p + 1,
                  y: y.toString().substr(2, 2),
                  Y: y,
                  H: l(h),
                  k: h,
                  I: l(h % 12 || 12),
                  l: h % 12 || 12,
                  M: l(this.get("Minutes", s)),
                  p: 12 > h ? "AM" : "PM",
                  P: 12 > h ? "am" : "pm",
                  S: l(s.getSeconds()),
                  L: l(Math.floor(r % 1e3), 3)
                }, t.dateFormats), c(s, function (t, n) {
                  for (; -1 !== e.indexOf("%" + n);) {
                    e = e.replace("%" + n, "function" === typeof t ? t.call(a, r) : t);
                  }
                }), i ? e.substr(0, 1).toUpperCase() + e.substr(1) : e;
              }, p2.prototype.resolveDTLFormat = function (t) {
                return a(t, !0) ? t : {
                  main: (t = h(t))[0],
                  from: t[1],
                  to: t[2]
                };
              }, p2.prototype.getTimeTicks = function (t, e, r, i) {
                var a,
                    s = this,
                    c = [],
                    l = {},
                    h = new s.Date(e),
                    f = t.unitRange,
                    p = t.count || 1;

                if (i = u(i, 1), n(e)) {
                  if (s.set("Milliseconds", h, f >= d.second ? 0 : p * Math.floor(s.get("Milliseconds", h) / p)), f >= d.second && s.set("Seconds", h, f >= d.minute ? 0 : p * Math.floor(s.get("Seconds", h) / p)), f >= d.minute && s.set("Minutes", h, f >= d.hour ? 0 : p * Math.floor(s.get("Minutes", h) / p)), f >= d.hour && s.set("Hours", h, f >= d.day ? 0 : p * Math.floor(s.get("Hours", h) / p)), f >= d.day && s.set("Date", h, f >= d.month ? 1 : Math.max(1, p * Math.floor(s.get("Date", h) / p))), f >= d.month) {
                    s.set("Month", h, f >= d.year ? 0 : p * Math.floor(s.get("Month", h) / p));
                    var y = s.get("FullYear", h);
                  }

                  f >= d.year && s.set("FullYear", h, y - y % p), f === d.week && (y = s.get("Day", h), s.set("Date", h, s.get("Date", h) - y + i + (y < i ? -7 : 0))), y = s.get("FullYear", h), i = s.get("Month", h);
                  var g = s.get("Date", h),
                      m = s.get("Hours", h);

                  for (e = h.getTime(), !s.variableTimezone && s.useUTC || !n(r) || (a = r - e > 4 * d.month || s.getTimezoneOffset(e) !== s.getTimezoneOffset(r)), e = h.getTime(), h = 1; e < r;) {
                    c.push(e), e = f === d.year ? s.makeTime(y + h * p, 0) : f === d.month ? s.makeTime(y, i + h * p) : !a || f !== d.day && f !== d.week ? a && f === d.hour && 1 < p ? s.makeTime(y, i, g, m + h * p) : e + f * p : s.makeTime(y, i, g + h * p * (f === d.day ? 1 : 7)), h++;
                  }

                  c.push(e), f <= d.hour && 1e4 > c.length && c.forEach(function (t) {
                    t % 18e5 === 0 && "000000000" === s.dateFormat("%H%M%S%L", t) && (l[t] = "day");
                  });
                }

                return c.info = o(t, {
                  higherRanks: l,
                  totalRange: f * p
                }), c;
              }, p2.prototype.getDateFormat = function (t, e, r, n) {
                var i = this.dateFormat("%m-%d %H:%M:%S.%L", e),
                    o = {
                  millisecond: 15,
                  second: 12,
                  minute: 9,
                  hour: 6,
                  day: 3
                },
                    a = "millisecond";

                for (s in d) {
                  if (t === d.week && +this.dateFormat("%w", e) === r && "00:00:00.000" === i.substr(6)) {
                    var s = "week";
                    break;
                  }

                  if (d[s] > t) {
                    s = a;
                    break;
                  }

                  if (o[s] && i.substr(o[s]) !== "01-01 00:00:00.000".substr(o[s])) break;
                  "week" !== s && (a = s);
                }

                return this.resolveDTLFormat(n[s]).main;
              }, p2;
            }();
          }), K2(e, "Core/Defaults.js", [e["Core/Chart/ChartDefaults.js"], e["Core/Color/Color.js"], e["Core/Globals.js"], e["Core/Color/Palettes.js"], e["Core/Time.js"], e["Core/Utilities.js"]], function (t, e, r, n, i, o) {
            e = e.parse;
            var a = o.merge,
                s = {
              colors: n.colors,
              symbols: ["circle", "diamond", "square", "triangle", "triangle-down"],
              lang: {
                loading: "Loading...",
                months: "January February March April May June July August September October November December".split(" "),
                shortMonths: "Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),
                weekdays: "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),
                decimalPoint: ".",
                numericSymbols: "kMGTPE".split(""),
                resetZoom: "Reset zoom",
                resetZoomTitle: "Reset zoom level 1:1",
                thousandsSep: " "
              },
              global: {},
              time: {
                Date: void 0,
                getTimezoneOffset: void 0,
                timezone: void 0,
                timezoneOffset: 0,
                useUTC: !0
              },
              chart: t,
              title: {
                text: "Chart title",
                align: "center",
                margin: 15,
                widthAdjust: -44
              },
              subtitle: {
                text: "",
                align: "center",
                widthAdjust: -44
              },
              caption: {
                margin: 15,
                text: "",
                align: "left",
                verticalAlign: "bottom"
              },
              plotOptions: {},
              labels: {
                style: {
                  position: "absolute",
                  color: "#333333"
                }
              },
              legend: {
                enabled: !0,
                align: "center",
                alignColumns: !0,
                className: "highcharts-no-tooltip",
                layout: "horizontal",
                labelFormatter: function labelFormatter() {
                  return this.name;
                },
                borderColor: "#999999",
                borderRadius: 0,
                navigation: {
                  activeColor: "#003399",
                  inactiveColor: "#cccccc"
                },
                itemStyle: {
                  color: "#333333",
                  cursor: "pointer",
                  fontSize: "12px",
                  fontWeight: "bold",
                  textOverflow: "ellipsis"
                },
                itemHoverStyle: {
                  color: "#000000"
                },
                itemHiddenStyle: {
                  color: "#cccccc"
                },
                shadow: !1,
                itemCheckboxStyle: {
                  position: "absolute",
                  width: "13px",
                  height: "13px"
                },
                squareSymbol: !0,
                symbolPadding: 5,
                verticalAlign: "bottom",
                x: 0,
                y: 0,
                title: {
                  style: {
                    fontWeight: "bold"
                  }
                }
              },
              loading: {
                labelStyle: {
                  fontWeight: "bold",
                  position: "relative",
                  top: "45%"
                },
                style: {
                  position: "absolute",
                  backgroundColor: "#ffffff",
                  opacity: .5,
                  textAlign: "center"
                }
              },
              tooltip: {
                enabled: !0,
                animation: r.svg,
                borderRadius: 3,
                dateTimeLabelFormats: {
                  millisecond: "%A, %b %e, %H:%M:%S.%L",
                  second: "%A, %b %e, %H:%M:%S",
                  minute: "%A, %b %e, %H:%M",
                  hour: "%A, %b %e, %H:%M",
                  day: "%A, %b %e, %Y",
                  week: "Week from %A, %b %e, %Y",
                  month: "%B %Y",
                  year: "%Y"
                },
                footerFormat: "",
                headerShape: "callout",
                hideDelay: 500,
                padding: 8,
                shape: "callout",
                shared: !1,
                snap: r.isTouchDevice ? 25 : 10,
                headerFormat: '<span style="font-size: 10px">{point.key}</span><br/>',
                pointFormat: "<span style=\"color:{point.color}\">\u25CF</span> {series.name}: <b>{point.y}</b><br/>",
                backgroundColor: e("#f7f7f7").setOpacity(.85).get(),
                borderWidth: 1,
                shadow: !0,
                stickOnContact: !1,
                style: {
                  color: "#333333",
                  cursor: "default",
                  fontSize: "12px",
                  whiteSpace: "nowrap"
                },
                useHTML: !1
              },
              credits: {
                enabled: !0,
                href: "https://www.highcharts.com?credits",
                position: {
                  align: "right",
                  x: -10,
                  verticalAlign: "bottom",
                  y: -5
                },
                style: {
                  cursor: "pointer",
                  color: "#999999",
                  fontSize: "9px"
                },
                text: "Highcharts.com"
              }
            };
            s.chart.styledMode = !1;
            var c = new i(a(s.global, s.time));
            return t = {
              defaultOptions: s,
              defaultTime: c,
              getOptions: function getOptions() {
                return s;
              },
              setOptions: function setOptions(t) {
                return a(!0, s, t), (t.time || t.global) && (r.time ? r.time.update(a(s.global, s.time, t.global, t.time)) : r.time = c), s;
              }
            };
          }), K2(e, "Core/Animation/Fx.js", [e["Core/Color/Color.js"], e["Core/Globals.js"], e["Core/Utilities.js"]], function (t, e, r) {
            var n = t.parse,
                i = e.win,
                o = r.isNumber,
                a = r.objectEach;
            return function () {
              function a4(t, e, r) {
                this.pos = NaN, this.options = e, this.elem = t, this.prop = r;
              }

              return a4.prototype.dSetter = function () {
                var t = this.paths,
                    e = t && t[0];
                t = t && t[1];
                var r = this.now || 0,
                    n = [];
                if (1 !== r && e && t) {
                  if (e.length === t.length && 1 > r) for (var i = 0; i < t.length; i++) {
                    for (var a = e[i], s = t[i], c = [], l = 0; l < s.length; l++) {
                      var u = a[l],
                          h = s[l];
                      o(u) && o(h) && ("A" !== s[0] || 4 !== l && 5 !== l) ? c[l] = u + r * (h - u) : c[l] = h;
                    }

                    n.push(c);
                  } else n = t;
                } else n = this.toD || [];
                this.elem.attr("d", n, void 0, !0);
              }, a4.prototype.update = function () {
                var t = this.elem,
                    e = this.prop,
                    r = this.now,
                    n = this.options.step;
                this[e + "Setter"] ? this[e + "Setter"]() : t.attr ? t.element && t.attr(e, r, null, !0) : t.style[e] = r + this.unit, n && n.call(t, r, this);
              }, a4.prototype.run = function (t, e, r) {
                var n = this,
                    o = n.options,
                    a = function m4(t) {
                  return !m4.stopped && n.step(t);
                },
                    s = i.requestAnimationFrame || function (t) {
                  setTimeout(t, 13);
                };

                t !== e || this.elem["forceAnimate:" + this.prop] ? (this.startTime = +new Date(), this.start = t, this.end = e, this.unit = r, this.now = this.start, this.pos = 0, a.elem = this.elem, a.prop = this.prop, a() && 1 === a4.timers.push(a) && s(function p2() {
                  for (var t = 0; t < a4.timers.length; t++) {
                    a4.timers[t]() || a4.timers.splice(t--, 1);
                  }

                  a4.timers.length && s(p2);
                })) : (delete o.curAnim[this.prop], o.complete && 0 === Object.keys(o.curAnim).length && o.complete.call(this.elem));
              }, a4.prototype.step = function (t) {
                var e = +new Date(),
                    r = this.options,
                    n = this.elem,
                    i = r.complete,
                    o = r.duration,
                    s = r.curAnim;
                if (n.attr && !n.element) t = !1;else if (t || e >= o + this.startTime) {
                  this.now = this.end, this.pos = 1, this.update();
                  var c = s[this.prop] = !0;
                  a(s, function (t) {
                    !0 !== t && (c = !1);
                  }), c && i && i.call(n), t = !1;
                } else this.pos = r.easing((e - this.startTime) / o), this.now = this.start + (this.end - this.start) * this.pos, this.update(), t = !0;
                return t;
              }, a4.prototype.initPath = function (t, e, r) {
                function d3(t, e) {
                  for (; t.length < u;) {
                    var r = t[0],
                        n = e[u - t.length];
                    n && "M" === r[0] && (t[0] = "C" === n[0] ? ["C", r[1], r[2], r[1], r[2], r[1], r[2]] : ["L", r[1], r[2]]), t.unshift(r), a && (r = t.pop(), t.push(t[t.length - 1], r));
                  }
                }

                function h4(t, e) {
                  for (; t.length < u;) {
                    if ("C" === (e = t[Math.floor(t.length / s) - 1].slice())[0] && (e[1] = e[5], e[2] = e[6]), a) {
                      var r = t[Math.floor(t.length / s)].slice();
                      t.splice(t.length / 2, 0, e, r);
                    } else t.push(e);
                  }
                }

                var n = t.startX,
                    i = t.endX;
                r = r.slice();
                var a = t.isArea,
                    s = a ? 2 : 1;
                if (!(e = e && e.slice())) return [r, r];

                if (n && i && i.length) {
                  for (t = 0; t < n.length; t++) {
                    if (n[t] === i[0]) {
                      var c = t;
                      break;
                    }

                    if (n[0] === i[i.length - n.length + t]) {
                      c = t;
                      var l = !0;
                      break;
                    }

                    if (n[n.length - 1] === i[i.length - n.length + t]) {
                      c = n.length - t;
                      break;
                    }
                  }

                  "undefined" === typeof c && (e = []);
                }

                if (e.length && o(c)) {
                  var u = r.length + c * s;
                  l ? (d3(e, r), h4(r, e)) : (d3(r, e), h4(e, r));
                }

                return [e, r];
              }, a4.prototype.fillSetter = function () {
                a4.prototype.strokeSetter.apply(this, arguments);
              }, a4.prototype.strokeSetter = function () {
                this.elem.attr(this.prop, n(this.start).tweenTo(n(this.end), this.pos), void 0, !0);
              }, a4.timers = [], a4;
            }();
          }), K2(e, "Core/Animation/AnimationUtilities.js", [e["Core/Animation/Fx.js"], e["Core/Utilities.js"]], function (t, e) {
            function A(t) {
              return a(t) ? s({
                duration: 500,
                defer: 0
              }, t) : {
                duration: t ? 500 : 0,
                defer: 0
              };
            }

            function F(e, r) {
              for (var n = t.timers.length; n--;) {
                t.timers[n].elem !== e || r && r !== t.timers[n].prop || (t.timers[n].stopped = !0);
              }
            }

            var r = e.defined,
                n = e.getStyle,
                i = e.isArray,
                o = e.isNumber,
                a = e.isObject,
                s = e.merge,
                c = e.objectEach,
                l = e.pick;
            return {
              animate: function animate(e, r, l) {
                var u,
                    h,
                    d,
                    f = "";

                if (!a(l)) {
                  var p = arguments;
                  l = {
                    duration: p[2],
                    easing: p[3],
                    complete: p[4]
                  };
                }

                o(l.duration) || (l.duration = 400), l.easing = "function" === typeof l.easing ? l.easing : Math[l.easing] || Math.easeInOutSine, l.curAnim = s(r), c(r, function (o, a) {
                  F(e, a), d = new t(e, l, a), h = void 0, "d" === a && i(r.d) ? (d.paths = d.initPath(e, e.pathArray, r.d), d.toD = r.d, u = 0, h = 1) : e.attr ? u = e.attr(a) : (u = parseFloat(n(e, a)) || 0, "opacity" !== a && (f = "px")), h || (h = o), "string" === typeof h && h.match("px") && (h = h.replace(/px/g, "")), d.run(u, h, f);
                });
              },
              animObject: A,
              getDeferredAnimation: function getDeferredAnimation(t, e, n) {
                var i = A(e),
                    o = 0,
                    a = 0;
                return (n ? [n] : t.series).forEach(function (t) {
                  t = A(t.options.animation), o = e && r(e.defer) ? i.defer : Math.max(o, t.duration + t.defer), a = Math.min(i.duration, t.duration);
                }), t.renderer.forExport && (o = 0), {
                  defer: Math.max(0, o - a),
                  duration: Math.min(o, a)
                };
              },
              setAnimation: function setAnimation(t, e) {
                e.renderer.globalAnimation = l(t, e.options.chart.animation, !0);
              },
              stop: F
            };
          }), K2(e, "Core/Renderer/HTML/AST.js", [e["Core/Globals.js"], e["Core/Utilities.js"]], function (t, e) {
            var r = t.SVG_NS,
                n = e.attr,
                i = e.createElement,
                o = e.css,
                a = e.error,
                s = e.isFunction,
                c = e.isString,
                l = e.objectEach,
                u = e.splat,
                h = (e = t.win.trustedTypes) && s(e.createPolicy) && e.createPolicy("highcharts", {
              createHTML: function createHTML(t) {
                return t;
              }
            }),
                d = h ? h.createHTML("") : "";

            try {
              var f = !!new DOMParser().parseFromString(d, "text/html");
            } catch (p) {
              f = !1;
            }

            return s = function () {
              function k3(t) {
                this.nodes = "string" === typeof t ? this.parseMarkup(t) : t;
              }

              return k3.filterUserAttributes = function (t) {
                return l(t, function (e, r) {
                  var n = !0;
                  -1 === k3.allowedAttributes.indexOf(r) && (n = !1), -1 !== ["background", "dynsrc", "href", "lowsrc", "src"].indexOf(r) && (n = c(e) && k3.allowedReferences.some(function (t) {
                    return 0 === e.indexOf(t);
                  })), n || (a(33, !1, void 0, {
                    "Invalid attribute in config": "".concat(r)
                  }), delete t[r]), c(e) && t[r] && (t[r] = e.replace(/</g, "&lt;"));
                }), t;
              }, k3.parseStyle = function (t) {
                return t.split(";").reduce(function (t, e) {
                  var r = (e = e.split(":").map(function (t) {
                    return t.trim();
                  })).shift();
                  return r && e.length && (t[r.replace(/-([a-z])/g, function (t) {
                    return t[1].toUpperCase();
                  })] = e.join(":")), t;
                }, {});
              }, k3.setElementHTML = function (t, e) {
                t.innerHTML = k3.emptyHTML, e && new k3(e).addToDOM(t);
              }, k3.prototype.addToDOM = function (e) {
                return function h5(e, i) {
                  var s;
                  return u(e).forEach(function (e) {
                    var c = e.tagName,
                        u = e.textContent ? t.doc.createTextNode(e.textContent) : void 0,
                        h = k3.bypassHTMLFiltering;
                    if (c) if ("#text" === c) var d = u;else if (-1 !== k3.allowedTags.indexOf(c) || h) {
                      c = t.doc.createElementNS("svg" === c ? r : i.namespaceURI || r, c);
                      var f = e.attributes || {};
                      l(e, function (t, e) {
                        "tagName" !== e && "attributes" !== e && "children" !== e && "style" !== e && "textContent" !== e && (f[e] = t);
                      }), n(c, h ? f : k3.filterUserAttributes(f)), e.style && o(c, e.style), u && c.appendChild(u), h5(e.children || [], c), d = c;
                    } else a(33, !1, void 0, {
                      "Invalid tagName in config": c
                    });
                    d && i.appendChild(d), s = d;
                  }), s;
                }(this.nodes, e);
              }, k3.prototype.parseMarkup = function (t) {
                var e = [];
                if (t = t.trim().replace(/ style=(["'])/g, " data-style=$1"), f) t = new DOMParser().parseFromString(h ? h.createHTML(t) : t, "text/html");else {
                  var r = i("div");
                  r.innerHTML = t, t = {
                    body: r
                  };
                }
                return [].forEach.call(t.body.childNodes, function (t) {
                  return function a4(t, e) {
                    var r = t.nodeName.toLowerCase(),
                        n = {
                      tagName: r
                    };

                    if ("#text" === r && (n.textContent = t.textContent || ""), r = t.attributes) {
                      var i = {};
                      [].forEach.call(r, function (t) {
                        "data-style" === t.name ? n.style = k3.parseStyle(t.value) : i[t.name] = t.value;
                      }), n.attributes = i;
                    }

                    if (t.childNodes.length) {
                      var o = [];
                      [].forEach.call(t.childNodes, function (t) {
                        a4(t, o);
                      }), o.length && (n.children = o);
                    }

                    e.push(n);
                  }(t, e);
                }), e;
              }, k3.allowedAttributes = "aria-controls aria-describedby aria-expanded aria-haspopup aria-hidden aria-label aria-labelledby aria-live aria-pressed aria-readonly aria-roledescription aria-selected class clip-path color colspan cx cy d dx dy disabled fill height href id in markerHeight markerWidth offset opacity orient padding paddingLeft paddingRight patternUnits r refX refY role scope slope src startOffset stdDeviation stroke stroke-linecap stroke-width style tableValues result rowspan summary target tabindex text-align text-anchor textAnchor textLength title type valign width x x1 x2 xlink:href y y1 y2 zIndex".split(" "), k3.allowedReferences = "https:// http:// mailto: / ../ ./ #".split(" "), k3.allowedTags = "a abbr b br button caption circle clipPath code dd defs div dl dt em feComponentTransfer feFuncA feFuncB feFuncG feFuncR feGaussianBlur feOffset feMerge feMergeNode filter h1 h2 h3 h4 h5 h6 hr i img li linearGradient marker ol p path pattern pre rect small span stop strong style sub sup svg table text textPath thead title tbody tspan td th tr u ul #text".split(" "), k3.emptyHTML = d, k3.bypassHTMLFiltering = !1, k3;
            }();
          }), K2(e, "Core/FormatUtilities.js", [e["Core/Defaults.js"], e["Core/Utilities.js"]], function (t, e) {
            function A(t, e, n, i) {
              t = +t || 0, e = +e;
              var c = r.lang,
                  l = (t.toString().split(".")[1] || "").split("e")[0].length,
                  u = t.toString().split("e"),
                  h = e;
              if (-1 === e) e = Math.min(l, 20);else if (o(e)) {
                if (e && u[1] && 0 > u[1]) {
                  var d = e + +u[1];
                  0 <= d ? (u[0] = (+u[0]).toExponential(d).split("e")[0], e = d) : (u[0] = u[0].split(".")[0] || 0, t = 20 > e ? (u[0] * Math.pow(10, u[1])).toFixed(e) : 0, u[1] = 0);
                }
              } else e = 2;
              d = (Math.abs(u[1] ? u[0] : t) + Math.pow(10, -Math.max(e, l) - 1)).toFixed(e);
              var f = 3 < (l = String(s(d))).length ? l.length % 3 : 0;
              return n = a(n, c.decimalPoint), i = a(i, c.thousandsSep), t = (0 > t ? "-" : "") + (f ? l.substr(0, f) + i : ""), t = 0 > +u[1] && !h ? "0" : t + l.substr(f).replace(/(\d{3})(?=\d)/g, "$1" + i), e && (t += n + d.slice(-e)), u[1] && 0 !== +t && (t += "e" + u[1]), t;
            }

            var r = t.defaultOptions,
                n = t.defaultTime,
                i = e.getNestedProperty,
                o = e.isNumber,
                a = e.pick,
                s = e.pInt;
            return {
              dateFormat: function dateFormat(t, e, r) {
                return n.dateFormat(t, e, r);
              },
              format: function format(t, e, o) {
                var a = "{",
                    s = !1,
                    c = /f$/,
                    l = /\.([0-9])/,
                    u = r.lang,
                    h = o && o.time || n;
                o = o && o.numberFormatter || A;

                for (var d = []; t;) {
                  var f = t.indexOf(a);
                  if (-1 === f) break;
                  var p = t.slice(0, f);

                  if (s) {
                    if (p = p.split(":"), a = i(p.shift() || "", e), p.length && "number" === typeof a) if (p = p.join(":"), c.test(p)) {
                      var y = parseInt((p.match(l) || ["", "-1"])[1], 10);
                      null !== a && (a = o(a, y, u.decimalPoint, -1 < p.indexOf(",") ? u.thousandsSep : ""));
                    } else a = h.dateFormat(p, a);
                    d.push(a);
                  } else d.push(p);

                  t = t.slice(f + 1), a = (s = !s) ? "}" : "{";
                }

                return d.push(t), d.join("");
              },
              numberFormat: A
            };
          }), K2(e, "Core/Renderer/RendererUtilities.js", [e["Core/Utilities.js"]], function (t) {
            var e,
                r = t.clamp,
                n = t.pick,
                i = t.stableSort;
            return function (t) {
              (e || (e = {})).distribute = function A(t, e, o) {
                var a,
                    s = t,
                    c = s.reducedLen || e,
                    l = function h4(t, e) {
                  return (e.rank || 0) - (t.rank || 0);
                },
                    u = function m4(t, e) {
                  return t.target - e.target;
                },
                    h = !0,
                    d = [],
                    f = 0;

                for (a = t.length; a--;) {
                  f += t[a].size;
                }

                if (f > c) {
                  for (i(t, l), f = a = 0; f <= c;) {
                    f += t[a].size, a++;
                  }

                  d = t.splice(a - 1, t.length);
                }

                for (i(t, u), t = t.map(function (t) {
                  return {
                    size: t.size,
                    targets: [t.target],
                    align: n(t.align, .5)
                  };
                }); h;) {
                  for (a = t.length; a--;) {
                    c = t[a], l = (Math.min.apply(0, c.targets) + Math.max.apply(0, c.targets)) / 2, c.pos = r(l - c.size * c.align, 0, e - c.size);
                  }

                  for (a = t.length, h = !1; a--;) {
                    0 < a && t[a - 1].pos + t[a - 1].size > t[a].pos && (t[a - 1].size += t[a].size, t[a - 1].targets = t[a - 1].targets.concat(t[a].targets), t[a - 1].align = .5, t[a - 1].pos + t[a - 1].size > e && (t[a - 1].pos = e - t[a - 1].size), t.splice(a, 1), h = !0);
                  }
                }

                return s.push.apply(s, d), a = 0, t.some(function (t) {
                  var r = 0;
                  return (t.targets || []).some(function () {
                    return s[a].pos = t.pos + r, "undefined" !== typeof o && Math.abs(s[a].pos - s[a].target) > o ? (s.slice(0, a + 1).forEach(function (t) {
                      return delete t.pos;
                    }), s.reducedLen = (s.reducedLen || e) - .1 * e, s.reducedLen > .1 * e && A(s, e, o), !0) : (r += s[a].size, a++, !1);
                  });
                }), i(s, u), s;
              };
            }(), e;
          }), K2(e, "Core/Renderer/SVG/SVGElement.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Color/Color.js"], e["Core/Globals.js"], e["Core/Utilities.js"]], function (t, e, r, n) {
            var i = t.animate,
                o = t.animObject,
                a = t.stop,
                s = r.deg2rad,
                c = r.doc,
                l = r.svg,
                u = r.SVG_NS,
                h = r.win,
                d = n.addEvent,
                f = n.attr,
                p = n.createElement,
                y = n.css,
                g = n.defined,
                m = n.erase,
                v = n.extend,
                b = n.fireEvent,
                x = n.isArray,
                w = n.isFunction,
                S = n.isString,
                O = n.merge,
                E = n.objectEach,
                k = n.pick,
                _ = n.pInt,
                C = n.syncTimeout,
                T = n.uniqueKey;
            return (t = function () {
              function a4() {
                this.element = void 0, this.onEvents = {}, this.opacity = 1, this.renderer = void 0, this.SVG_NS = u, this.symbolCustomAttribs = "x y width height r start end innerR anchorX anchorY rounded".split(" ");
              }

              return a4.prototype._defaultGetter = function (t) {
                return t = k(this[t + "Value"], this[t], this.element ? this.element.getAttribute(t) : null, 0), /^[\-0-9\.]+$/.test(t) && (t = parseFloat(t)), t;
              }, a4.prototype._defaultSetter = function (t, e, r) {
                r.setAttribute(e, t);
              }, a4.prototype.add = function (t) {
                var e = this.renderer,
                    r = this.element;
                if (t && (this.parentGroup = t), "undefined" !== typeof this.textStr && "text" === this.element.nodeName && e.buildText(this), this.added = !0, !t || t.handleZ || this.zIndex) var n = this.zIndexSetter();
                return n || (t ? t.element : e.box).appendChild(r), this.onAdd && this.onAdd(), this;
              }, a4.prototype.addClass = function (t, e) {
                var r = e ? "" : this.attr("class") || "";
                return (t = (t || "").split(/ /g).reduce(function (t, e) {
                  return -1 === r.indexOf(e) && t.push(e), t;
                }, r ? [r] : []).join(" ")) !== r && this.attr("class", t), this;
              }, a4.prototype.afterSetters = function () {
                this.doTransform && (this.updateTransform(), this.doTransform = !1);
              }, a4.prototype.align = function (t, e, r) {
                var n,
                    i,
                    o,
                    a = {},
                    s = this.renderer,
                    c = s.alignedObjects;
                t ? (this.alignOptions = t, this.alignByTranslate = e, (!r || S(r)) && (this.alignTo = n = r || "renderer", m(c, this), c.push(this), r = void 0)) : (t = this.alignOptions, e = this.alignByTranslate, n = this.alignTo), r = k(r, s[n], "scrollablePlotBox" === n ? s.plotBox : void 0, s), n = t.align;
                var l = t.verticalAlign;
                return s = (r.x || 0) + (t.x || 0), c = (r.y || 0) + (t.y || 0), "right" === n ? i = 1 : "center" === n && (i = 2), i && (s += (r.width - (t.width || 0)) / i), a[e ? "translateX" : "x"] = Math.round(s), "bottom" === l ? o = 1 : "middle" === l && (o = 2), o && (c += (r.height - (t.height || 0)) / o), a[e ? "translateY" : "y"] = Math.round(c), this[this.placed ? "animate" : "attr"](a), this.placed = !0, this.alignAttr = a, this;
              }, a4.prototype.alignSetter = function (t) {
                var e = {
                  left: "start",
                  center: "middle",
                  right: "end"
                };
                e[t] && (this.alignValue = t, this.element.setAttribute("text-anchor", e[t]));
              }, a4.prototype.animate = function (t, e, r) {
                var n = this,
                    a = o(k(e, this.renderer.globalAnimation, !0));
                return e = a.defer, k(c.hidden, c.msHidden, c.webkitHidden, !1) && (a.duration = 0), 0 !== a.duration ? (r && (a.complete = r), C(function () {
                  n.element && i(n, t, a);
                }, e)) : (this.attr(t, void 0, r || a.complete), E(t, function (t, e) {
                  a.step && a.step.call(this, t, {
                    prop: e,
                    pos: 1,
                    elem: this
                  });
                }, this)), this;
              }, a4.prototype.applyTextOutline = function (t) {
                var e = this.element;
                -1 !== t.indexOf("contrast") && (t = t.replace(/contrast/g, this.renderer.getContrast(e.style.fill)));
                var n = t.split(" ");

                if (t = n[n.length - 1], (n = n[0]) && "none" !== n && r.svg) {
                  this.fakeTS = !0, n = n.replace(/(^[\d\.]+)(.*?)$/g, function (t, e, r) {
                    return 2 * Number(e) + r;
                  }), this.removeTextOutline();
                  var i = c.createElementNS(u, "tspan");
                  f(i, {
                    class: "highcharts-text-outline",
                    fill: t,
                    stroke: t,
                    "stroke-width": n,
                    "stroke-linejoin": "round"
                  }), t = e.querySelector("textPath") || e, [].forEach.call(t.childNodes, function (t) {
                    var e = t.cloneNode(!0);
                    e.removeAttribute && ["fill", "stroke", "stroke-width", "stroke"].forEach(function (t) {
                      return e.removeAttribute(t);
                    }), i.appendChild(e);
                  });
                  var o = 0;
                  [].forEach.call(t.querySelectorAll("text tspan"), function (t) {
                    o += Number(t.getAttribute("dy"));
                  }), (n = c.createElementNS(u, "tspan")).textContent = "\u200B", f(n, {
                    x: Number(e.getAttribute("x")),
                    dy: -o
                  }), i.appendChild(n), t.insertBefore(i, t.firstChild);
                }
              }, a4.prototype.attr = function (t, e, r, n) {
                var i,
                    o,
                    s,
                    c = this.element,
                    l = this.symbolCustomAttribs,
                    u = this;

                if ("string" === typeof t && "undefined" !== typeof e) {
                  var h = t;
                  (t = {})[h] = e;
                }

                return "string" === typeof t ? u = (this[t + "Getter"] || this._defaultGetter).call(this, t, c) : (E(t, function (e, r) {
                  o = !1, n || a(this, r), this.symbolName && -1 !== l.indexOf(r) && (i || (this.symbolAttr(t), i = !0), o = !0), !this.rotation || "x" !== r && "y" !== r || (this.doTransform = !0), o || ((s = this[r + "Setter"] || this._defaultSetter).call(this, e, r, c), !this.styledMode && this.shadows && /^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(r) && this.updateShadows(r, e, s));
                }, this), this.afterSetters()), r && r.call(this), u;
              }, a4.prototype.clip = function (t) {
                return this.attr("clip-path", t ? "url(" + this.renderer.url + "#" + t.id + ")" : "none");
              }, a4.prototype.crisp = function (t, e) {
                e = e || t.strokeWidth || 0;
                var r = Math.round(e) % 2 / 2;
                return t.x = Math.floor(t.x || this.x || 0) + r, t.y = Math.floor(t.y || this.y || 0) + r, t.width = Math.floor((t.width || this.width || 0) - 2 * r), t.height = Math.floor((t.height || this.height || 0) - 2 * r), g(t.strokeWidth) && (t.strokeWidth = e), t;
              }, a4.prototype.complexColor = function (t, r, n) {
                var i,
                    o,
                    a,
                    s,
                    c,
                    l,
                    u,
                    h,
                    d,
                    f,
                    p,
                    y = this.renderer,
                    m = [];
                b(this.renderer, "complexColor", {
                  args: arguments
                }, function () {
                  if (t.radialGradient ? o = "radialGradient" : t.linearGradient && (o = "linearGradient"), o) {
                    if (a = t[o], c = y.gradients, l = t.stops, d = n.radialReference, x(a) && (t[o] = a = {
                      x1: a[0],
                      y1: a[1],
                      x2: a[2],
                      y2: a[3],
                      gradientUnits: "userSpaceOnUse"
                    }), "radialGradient" === o && d && !g(a.gradientUnits) && (s = a, a = O(a, y.getRadialAttr(d, s), {
                      gradientUnits: "userSpaceOnUse"
                    })), E(a, function (t, e) {
                      "id" !== e && m.push(e, t);
                    }), E(l, function (t) {
                      m.push(t);
                    }), m = m.join(","), c[m]) f = c[m].attr("id");else {
                      a.id = f = T();
                      var v = c[m] = y.createElement(o).attr(a).add(y.defs);
                      v.radAttr = s, v.stops = [], l.forEach(function (t) {
                        0 === t[1].indexOf("rgba") ? (i = e.parse(t[1]), u = i.get("rgb"), h = i.get("a")) : (u = t[1], h = 1), t = y.createElement("stop").attr({
                          offset: t[0],
                          "stop-color": u,
                          "stop-opacity": h
                        }).add(v), v.stops.push(t);
                      });
                    }
                    p = "url(" + y.url + "#" + f + ")", n.setAttribute(r, p), n.gradient = m, t.toString = function () {
                      return p;
                    };
                  }
                });
              }, a4.prototype.css = function (t) {
                var e = this.styles,
                    r = {},
                    n = this.element,
                    i = !e;

                if (t.color && (t.fill = t.color), e && E(t, function (t, n) {
                  e && e[n] !== t && (r[n] = t, i = !0);
                }), i) {
                  if (e && (t = v(e, r)), null === t.width || "auto" === t.width) delete this.textWidth;else if ("text" === n.nodeName.toLowerCase() && t.width) var o = this.textWidth = _(t.width);
                  this.styles = t, o && !l && this.renderer.forExport && delete t.width;
                  var a = O(t);
                  n.namespaceURI === this.SVG_NS && ["textOutline", "textOverflow", "width"].forEach(function (t) {
                    return a && delete a[t];
                  }), y(n, a), this.added && ("text" === this.element.nodeName && this.renderer.buildText(this), t.textOutline && this.applyTextOutline(t.textOutline));
                }

                return this;
              }, a4.prototype.dashstyleSetter = function (t) {
                var e = this["stroke-width"];

                if ("inherit" === e && (e = 1), t = t && t.toLowerCase()) {
                  var r = t.replace("shortdashdotdot", "3,1,1,1,1,1,").replace("shortdashdot", "3,1,1,1").replace("shortdot", "1,1,").replace("shortdash", "3,1,").replace("longdash", "8,3,").replace(/dot/g, "1,3,").replace("dash", "4,3,").replace(/,$/, "").split(",");

                  for (t = r.length; t--;) {
                    r[t] = "" + _(r[t]) * k(e, NaN);
                  }

                  t = r.join(",").replace(/NaN/g, "none"), this.element.setAttribute("stroke-dasharray", t);
                }
              }, a4.prototype.destroy = function () {
                var t = this,
                    e = t.element || {},
                    r = t.renderer,
                    n = e.ownerSVGElement,
                    i = r.isSVG && "SPAN" === e.nodeName && t.parentGroup || void 0;

                if (e.onclick = e.onmouseout = e.onmouseover = e.onmousemove = e.point = null, a(t), t.clipPath && n) {
                  var o = t.clipPath;
                  [].forEach.call(n.querySelectorAll("[clip-path],[CLIP-PATH]"), function (t) {
                    -1 < t.getAttribute("clip-path").indexOf(o.element.id) && t.removeAttribute("clip-path");
                  }), t.clipPath = o.destroy();
                }

                if (t.stops) {
                  for (n = 0; n < t.stops.length; n++) {
                    t.stops[n].destroy();
                  }

                  t.stops.length = 0, t.stops = void 0;
                }

                for (t.safeRemoveChild(e), r.styledMode || t.destroyShadows(); i && i.div && 0 === i.div.childNodes.length;) {
                  e = i.parentGroup, t.safeRemoveChild(i.div), delete i.div, i = e;
                }

                t.alignTo && m(r.alignedObjects, t), E(t, function (e, r) {
                  t[r] && t[r].parentGroup === t && t[r].destroy && t[r].destroy(), delete t[r];
                });
              }, a4.prototype.destroyShadows = function () {
                (this.shadows || []).forEach(function (t) {
                  this.safeRemoveChild(t);
                }, this), this.shadows = void 0;
              }, a4.prototype.dSetter = function (t, e, r) {
                x(t) && ("string" === typeof t[0] && (t = this.renderer.pathToSegments(t)), this.pathArray = t, t = t.reduce(function (t, e, r) {
                  return e && e.join ? (r ? t + " " : "") + e.join(" ") : (e || "").toString();
                }, "")), /(NaN| {2}|^$)/.test(t) && (t = "M 0 0"), this[e] !== t && (r.setAttribute(e, t), this[e] = t);
              }, a4.prototype.fadeOut = function (t) {
                var e = this;
                e.animate({
                  opacity: 0
                }, {
                  duration: k(t, 150),
                  complete: function complete() {
                    e.hide();
                  }
                });
              }, a4.prototype.fillSetter = function (t, e, r) {
                "string" === typeof t ? r.setAttribute(e, t) : t && this.complexColor(t, e, r);
              }, a4.prototype.getBBox = function (t, e) {
                var r = this.alignValue,
                    n = this.element,
                    i = this.renderer,
                    o = this.styles,
                    a = this.textStr,
                    c = i.cache,
                    l = i.cacheKeys,
                    u = n.namespaceURI === this.SVG_NS;
                e = k(e, this.rotation, 0);
                var h,
                    d = i.styledMode ? n && a4.prototype.getStyle.call(n, "font-size") : o && o.fontSize;

                if (g(a)) {
                  var f = a.toString();
                  -1 === f.indexOf("<") && (f = f.replace(/[0-9]/g, "0")), f += ["", e, d, this.textWidth, r, o && o.textOverflow, o && o.fontWeight].join();
                }

                if (f && !t && (h = c[f]), !h) {
                  if (u || i.forExport) {
                    try {
                      var p = this.fakeTS && function (t) {
                        var e = n.querySelector(".highcharts-text-outline");
                        e && y(e, {
                          display: t
                        });
                      };

                      w(p) && p("none"), h = n.getBBox ? v({}, n.getBBox()) : {
                        width: n.offsetWidth,
                        height: n.offsetHeight,
                        x: 0,
                        y: 0
                      }, w(p) && p("");
                    } catch (b) {}

                    (!h || 0 > h.width) && (h = {
                      x: 0,
                      y: 0,
                      width: 0,
                      height: 0
                    });
                  } else h = this.htmlGetBBox();

                  if (i.isSVG && (i = h.width, t = h.height, u && (h.height = t = {
                    "11px,17": 14,
                    "13px,20": 16
                  }["" + (d || "") + ",".concat(Math.round(t))] || t), e)) {
                    u = Number(n.getAttribute("y") || 0) - h.y, r = {
                      right: 1,
                      center: .5
                    }[r || 0] || 0, o = e * s, d = (e - 90) * s;
                    var m = i * Math.cos(o);
                    e = i * Math.sin(o), p = Math.cos(d), o = Math.sin(d), m = (p = (d = (i = h.x + r * (i - m) + u * p) + m) - t * p) - m, e = (t = (r = (u = h.y + u - r * e + u * o) + e) - t * o) - e, h.x = Math.min(i, d, p, m), h.y = Math.min(u, r, t, e), h.width = Math.max(i, d, p, m) - h.x, h.height = Math.max(u, r, t, e) - h.y;
                  }

                  if (f && ("" === a || 0 < h.height)) {
                    for (; 250 < l.length;) {
                      delete c[l.shift()];
                    }

                    c[f] || l.push(f), c[f] = h;
                  }
                }

                return h;
              }, a4.prototype.getStyle = function (t) {
                return h.getComputedStyle(this.element || this, "").getPropertyValue(t);
              }, a4.prototype.hasClass = function (t) {
                return -1 !== ("" + this.attr("class")).split(" ").indexOf(t);
              }, a4.prototype.hide = function () {
                return this.attr({
                  visibility: "hidden"
                });
              }, a4.prototype.htmlGetBBox = function () {
                return {
                  height: 0,
                  width: 0,
                  x: 0,
                  y: 0
                };
              }, a4.prototype.init = function (t, e) {
                this.element = "span" === e ? p(e) : c.createElementNS(this.SVG_NS, e), this.renderer = t, b(this, "afterInit");
              }, a4.prototype.on = function (t, e) {
                var r = this.onEvents;
                return r[t] && r[t](), r[t] = d(this.element, t, e), this;
              }, a4.prototype.opacitySetter = function (t, e, r) {
                this.opacity = t = Number(Number(t).toFixed(3)), r.setAttribute(e, t);
              }, a4.prototype.removeClass = function (t) {
                return this.attr("class", ("" + this.attr("class")).replace(S(t) ? new RegExp("(^| )".concat(t, "( |$)")) : t, " ").replace(/ +/g, " ").trim());
              }, a4.prototype.removeTextOutline = function () {
                var t = this.element.querySelector("tspan.highcharts-text-outline");
                t && this.safeRemoveChild(t);
              }, a4.prototype.safeRemoveChild = function (t) {
                var e = t.parentNode;
                e && e.removeChild(t);
              }, a4.prototype.setRadialReference = function (t) {
                var e = this.element.gradient && this.renderer.gradients[this.element.gradient];
                return this.element.radialReference = t, e && e.radAttr && e.animate(this.renderer.getRadialAttr(t, e.radAttr)), this;
              }, a4.prototype.setTextPath = function (t, e) {
                var r = this;
                e = O(!0, {
                  enabled: !0,
                  attributes: {
                    dy: -5,
                    startOffset: "50%",
                    textAnchor: "middle"
                  }
                }, e);
                var n = this.renderer.url,
                    i = this.text || this,
                    o = i.textPath,
                    a = e.attributes,
                    s = e.enabled;
                return t = t || o && o.path, o && o.undo(), t && s ? (e = d(i, "afterModifyTree", function (e) {
                  if (t && s) {
                    var o = t.attr("id");
                    o || t.attr("id", o = T());
                    var c = {
                      x: 0,
                      y: 0
                    };
                    g(a.dx) && (c.dx = a.dx, delete a.dx), g(a.dy) && (c.dy = a.dy, delete a.dy), i.attr(c), r.attr({
                      transform: ""
                    }), r.box && (r.box = r.box.destroy()), c = e.nodes.slice(0), e.nodes.length = 0, e.nodes[0] = {
                      tagName: "textPath",
                      attributes: v(a, {
                        "text-anchor": a.textAnchor,
                        href: "" + n + "#".concat(o)
                      }),
                      children: c
                    };
                  }
                }), i.textPath = {
                  path: t,
                  undo: e
                }) : (i.attr({
                  dx: 0,
                  dy: 0
                }), delete i.textPath), this.added && (i.textCache = "", this.renderer.buildText(i)), this;
              }, a4.prototype.shadow = function (t, e, r) {
                var n = [],
                    i = this.element,
                    o = this.oldShadowOptions,
                    a = this.parentGroup,
                    s = a && 90 === a.rotation;
                a = {
                  color: "#000000",
                  offsetX: s ? -1 : 1,
                  offsetY: s ? -1 : 1,
                  opacity: .15,
                  width: 3
                };
                var c,
                    l = !1;

                if (!0 === t ? c = a : "object" === typeof t && (c = v(a, t)), c && (c && o && E(c, function (t, e) {
                  t !== o[e] && (l = !0);
                }), l && this.destroyShadows(), this.oldShadowOptions = c), c) {
                  if (!this.shadows) {
                    a = c.opacity / c.width;
                    var u = s ? "translate(".concat(c.offsetY, ", ").concat(c.offsetX, ")") : "translate(".concat(c.offsetX, ", ").concat(c.offsetY, ")");

                    for (s = 1; s <= c.width; s++) {
                      var h = i.cloneNode(!1),
                          d = 2 * c.width + 1 - 2 * s;
                      f(h, {
                        stroke: t.color || "#000000",
                        "stroke-opacity": a * s,
                        "stroke-width": d,
                        transform: u,
                        fill: "none"
                      }), h.setAttribute("class", (h.getAttribute("class") || "") + " highcharts-shadow"), r && (f(h, "height", Math.max(f(h, "height") - d, 0)), h.cutHeight = d), e ? e.element.appendChild(h) : i.parentNode && i.parentNode.insertBefore(h, i), n.push(h);
                    }

                    this.shadows = n;
                  }
                } else this.destroyShadows();

                return this;
              }, a4.prototype.show = function (t) {
                return void 0 === t && (t = !0), this.attr({
                  visibility: t ? "inherit" : "visible"
                });
              }, a4.prototype["stroke-widthSetter"] = function (t, e, r) {
                this[e] = t, r.setAttribute(e, t);
              }, a4.prototype.strokeWidth = function () {
                if (!this.renderer.styledMode) return this["stroke-width"] || 0;
                var t = this.getStyle("stroke-width"),
                    e = 0;
                if (t.indexOf("px") === t.length - 2) e = _(t);else if ("" !== t) {
                  var r = c.createElementNS(u, "rect");
                  f(r, {
                    width: t,
                    "stroke-width": 0
                  }), this.element.parentNode.appendChild(r), e = r.getBBox().width, r.parentNode.removeChild(r);
                }
                return e;
              }, a4.prototype.symbolAttr = function (t) {
                var e = this;
                "x y r start end width height innerR anchorX anchorY clockwise".split(" ").forEach(function (r) {
                  e[r] = k(t[r], e[r]);
                }), e.attr({
                  d: e.renderer.symbols[e.symbolName](e.x, e.y, e.width, e.height, e)
                });
              }, a4.prototype.textSetter = function (t) {
                t !== this.textStr && (delete this.textPxLength, this.textStr = t, this.added && this.renderer.buildText(this));
              }, a4.prototype.titleSetter = function (t) {
                var e = this.element,
                    r = e.getElementsByTagName("title")[0] || c.createElementNS(this.SVG_NS, "title");
                e.insertBefore ? e.insertBefore(r, e.firstChild) : e.appendChild(r), r.textContent = String(k(t, "")).replace(/<[^>]*>/g, "").replace(/&lt;/g, "<").replace(/&gt;/g, ">");
              }, a4.prototype.toFront = function () {
                var t = this.element;
                return t.parentNode.appendChild(t), this;
              }, a4.prototype.translate = function (t, e) {
                return this.attr({
                  translateX: t,
                  translateY: e
                });
              }, a4.prototype.updateShadows = function (t, e, r) {
                var n = this.shadows;
                if (n) for (var i = n.length; i--;) {
                  r.call(n[i], "height" === t ? Math.max(e - (n[i].cutHeight || 0), 0) : "d" === t ? this.d : e, t, n[i]);
                }
              }, a4.prototype.updateTransform = function () {
                var t = this.element,
                    e = this.matrix,
                    r = this.rotation;
                r = void 0 === r ? 0 : r;
                var n = this.scaleX,
                    i = this.scaleY,
                    o = this.translateX,
                    a = this.translateY;
                o = ["translate(" + (void 0 === o ? 0 : o) + "," + (void 0 === a ? 0 : a) + ")"], g(e) && o.push("matrix(" + e.join(",") + ")"), r && o.push("rotate(" + r + " " + k(this.rotationOriginX, t.getAttribute("x"), 0) + " " + k(this.rotationOriginY, t.getAttribute("y") || 0) + ")"), (g(n) || g(i)) && o.push("scale(" + k(n, 1) + " " + k(i, 1) + ")"), o.length && !(this.text || this).textPath && t.setAttribute("transform", o.join(" "));
              }, a4.prototype.visibilitySetter = function (t, e, r) {
                "inherit" === t ? r.removeAttribute(e) : this[e] !== t && r.setAttribute(e, t), this[e] = t;
              }, a4.prototype.xGetter = function (t) {
                return "circle" === this.element.nodeName && ("x" === t ? t = "cx" : "y" === t && (t = "cy")), this._defaultGetter(t);
              }, a4.prototype.zIndexSetter = function (t, e) {
                var r = this.renderer,
                    n = this.parentGroup,
                    i = (n || r).element || r.box,
                    o = this.element;
                r = i === r.box;
                var a,
                    s = !1,
                    c = this.added;

                if (g(t) ? (o.setAttribute("data-z-index", t), t = +t, this[e] === t && (c = !1)) : g(this[e]) && o.removeAttribute("data-z-index"), this[e] = t, c) {
                  for ((t = this.zIndex) && n && (n.handleZ = !0), a = (e = i.childNodes).length - 1; 0 <= a && !s; a--) {
                    c = (n = e[a]).getAttribute("data-z-index");
                    var l = !g(c);
                    n !== o && (0 > t && l && !r && !a ? (i.insertBefore(o, e[a]), s = !0) : (_(c) <= t || l && (!g(t) || 0 <= t)) && (i.insertBefore(o, e[a + 1] || null), s = !0));
                  }

                  s || (i.insertBefore(o, e[r ? 3 : 0] || null), s = !0);
                }

                return s;
              }, a4;
            }()).prototype.strokeSetter = t.prototype.fillSetter, t.prototype.yGetter = t.prototype.xGetter, t.prototype.matrixSetter = t.prototype.rotationOriginXSetter = t.prototype.rotationOriginYSetter = t.prototype.rotationSetter = t.prototype.scaleXSetter = t.prototype.scaleYSetter = t.prototype.translateXSetter = t.prototype.translateYSetter = t.prototype.verticalAlignSetter = function (t, e) {
              this[e] = t, this.doTransform = !0;
            }, t;
          }), K2(e, "Core/Renderer/RendererRegistry.js", [e["Core/Globals.js"]], function (t) {
            var e;
            return function (e) {
              var r;
              e.rendererTypes = {}, e.getRendererType = function (t) {
                return void 0 === t && (t = r), e.rendererTypes[t] || e.rendererTypes[r];
              }, e.registerRendererType = function (n, i, o) {
                e.rendererTypes[n] = i, r && !o || (r = n, t.Renderer = i);
              };
            }(e || (e = {})), e;
          }), K2(e, "Core/Renderer/SVG/SVGLabel.js", [e["Core/Renderer/SVG/SVGElement.js"], e["Core/Utilities.js"]], function (t, e) {
            var r = this && this.__extends || function () {
              var t = function a4(e, r) {
                return (t = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, e) {
                  t.__proto__ = e;
                } || function (t, e) {
                  for (var r in e) {
                    e.hasOwnProperty(r) && (t[r] = e[r]);
                  }
                })(e, r);
              };

              return function (e, r) {
                function h4() {
                  this.constructor = e;
                }

                t(e, r), e.prototype = null === r ? Object.create(r) : (h4.prototype = r.prototype, new h4());
              };
            }(),
                n = e.defined,
                i = e.extend,
                o = e.isNumber,
                a = e.merge,
                s = e.pick,
                c = e.removeEvent;

            return function (e) {
              function e3(t, r, n, i, o, a, s, c, l, u) {
                var h,
                    d = e.call(this) || this;
                return d.paddingLeftSetter = d.paddingSetter, d.paddingRightSetter = d.paddingSetter, d.init(t, "g"), d.textStr = r, d.x = n, d.y = i, d.anchorX = a, d.anchorY = s, d.baseline = l, d.className = u, d.addClass("button" === u ? "highcharts-no-tooltip" : "highcharts-label"), u && d.addClass("highcharts-" + u), d.text = t.text(void 0, 0, 0, c).attr({
                  zIndex: 1
                }), "string" === typeof o && ((h = /^url\((.*?)\)$/.test(o)) || d.renderer.symbols[o]) && (d.symbolKey = o), d.bBox = e3.emptyBBox, d.padding = 3, d.baselineOffset = 0, d.needsBox = t.styledMode || h, d.deferredAttr = {}, d.alignFactor = 0, d;
              }

              return r(e3, e), e3.prototype.alignSetter = function (t) {
                (t = {
                  left: 0,
                  center: .5,
                  right: 1
                }[t]) !== this.alignFactor && (this.alignFactor = t, this.bBox && o(this.xSetting) && this.attr({
                  x: this.xSetting
                }));
              }, e3.prototype.anchorXSetter = function (t, e) {
                this.anchorX = t, this.boxAttr(e, Math.round(t) - this.getCrispAdjust() - this.xSetting);
              }, e3.prototype.anchorYSetter = function (t, e) {
                this.anchorY = t, this.boxAttr(e, t - this.ySetting);
              }, e3.prototype.boxAttr = function (t, e) {
                this.box ? this.box.attr(t, e) : this.deferredAttr[t] = e;
              }, e3.prototype.css = function (e) {
                if (e) {
                  var r = {};
                  e = a(e), e3.textProps.forEach(function (t) {
                    "undefined" !== typeof e[t] && (r[t] = e[t], delete e[t]);
                  }), this.text.css(r), "fontSize" in r || "fontWeight" in r ? this.updateTextPadding() : ("width" in r || "textOverflow" in r) && this.updateBoxSize();
                }

                return t.prototype.css.call(this, e);
              }, e3.prototype.destroy = function () {
                c(this.element, "mouseenter"), c(this.element, "mouseleave"), this.text && this.text.destroy(), this.box && (this.box = this.box.destroy()), t.prototype.destroy.call(this);
              }, e3.prototype.fillSetter = function (t, e) {
                t && (this.needsBox = !0), this.fill = t, this.boxAttr(e, t);
              }, e3.prototype.getBBox = function () {
                this.textStr && 0 === this.bBox.width && 0 === this.bBox.height && this.updateBoxSize();
                var t = this.padding,
                    e = s(this.paddingLeft, t);
                return {
                  width: this.width,
                  height: this.height,
                  x: this.bBox.x - e,
                  y: this.bBox.y - t
                };
              }, e3.prototype.getCrispAdjust = function () {
                return this.renderer.styledMode && this.box ? this.box.strokeWidth() % 2 / 2 : (this["stroke-width"] ? parseInt(this["stroke-width"], 10) : 0) % 2 / 2;
              }, e3.prototype.heightSetter = function (t) {
                this.heightSetting = t;
              }, e3.prototype.onAdd = function () {
                this.text.add(this), this.attr({
                  text: s(this.textStr, ""),
                  x: this.x || 0,
                  y: this.y || 0
                }), this.box && n(this.anchorX) && this.attr({
                  anchorX: this.anchorX,
                  anchorY: this.anchorY
                });
              }, e3.prototype.paddingSetter = function (t, e) {
                o(t) ? t !== this[e] && (this[e] = t, this.updateTextPadding()) : this[e] = void 0;
              }, e3.prototype.rSetter = function (t, e) {
                this.boxAttr(e, t);
              }, e3.prototype.shadow = function (t) {
                return t && !this.renderer.styledMode && (this.updateBoxSize(), this.box && this.box.shadow(t)), this;
              }, e3.prototype.strokeSetter = function (t, e) {
                this.stroke = t, this.boxAttr(e, t);
              }, e3.prototype["stroke-widthSetter"] = function (t, e) {
                t && (this.needsBox = !0), this["stroke-width"] = t, this.boxAttr(e, t);
              }, e3.prototype["text-alignSetter"] = function (t) {
                this.textAlign = t;
              }, e3.prototype.textSetter = function (t) {
                "undefined" !== typeof t && this.text.attr({
                  text: t
                }), this.updateTextPadding();
              }, e3.prototype.updateBoxSize = function () {
                var t = this.text,
                    e = t.element.style,
                    r = {},
                    a = this.padding,
                    s = this.bBox = o(this.widthSetting) && o(this.heightSetting) && !this.textAlign || !n(t.textStr) ? e3.emptyBBox : t.getBBox();
                this.width = this.getPaddedWidth(), this.height = (this.heightSetting || s.height || 0) + 2 * a, e = this.renderer.fontMetrics(e && e.fontSize, t), this.baselineOffset = a + Math.min((this.text.firstLineMetrics || e).b, s.height || 1 / 0), this.heightSetting && (this.baselineOffset += (this.heightSetting - e.h) / 2), this.needsBox && !t.textPath && (this.box || ((t = this.box = this.symbolKey ? this.renderer.symbol(this.symbolKey) : this.renderer.rect()).addClass(("button" === this.className ? "" : "highcharts-label-box") + (this.className ? " highcharts-" + this.className + "-box" : "")), t.add(this)), t = this.getCrispAdjust(), r.x = t, r.y = (this.baseline ? -this.baselineOffset : 0) + t, r.width = Math.round(this.width), r.height = Math.round(this.height), this.box.attr(i(r, this.deferredAttr)), this.deferredAttr = {});
              }, e3.prototype.updateTextPadding = function () {
                var t = this.text;

                if (!t.textPath) {
                  this.updateBoxSize();
                  var e = this.baseline ? 0 : this.baselineOffset,
                      r = s(this.paddingLeft, this.padding);
                  n(this.widthSetting) && this.bBox && ("center" === this.textAlign || "right" === this.textAlign) && (r += {
                    center: .5,
                    right: 1
                  }[this.textAlign] * (this.widthSetting - this.bBox.width)), r === t.x && e === t.y || (t.attr("x", r), t.hasBoxWidthChanged && (this.bBox = t.getBBox(!0)), "undefined" !== typeof e && t.attr("y", e)), t.x = r, t.y = e;
                }
              }, e3.prototype.widthSetter = function (t) {
                this.widthSetting = o(t) ? t : void 0;
              }, e3.prototype.getPaddedWidth = function () {
                var t = this.padding,
                    e = s(this.paddingLeft, t);
                return t = s(this.paddingRight, t), (this.widthSetting || this.bBox.width || 0) + e + t;
              }, e3.prototype.xSetter = function (t) {
                this.x = t, this.alignFactor && (t -= this.alignFactor * this.getPaddedWidth(), this["forceAnimate:x"] = !0), this.xSetting = Math.round(t), this.attr("translateX", this.xSetting);
              }, e3.prototype.ySetter = function (t) {
                this.ySetting = this.y = Math.round(t), this.attr("translateY", this.ySetting);
              }, e3.emptyBBox = {
                width: 0,
                height: 0,
                x: 0,
                y: 0
              }, e3.textProps = "color direction fontFamily fontSize fontStyle fontWeight lineHeight textAlign textDecoration textOutline textOverflow width".split(" "), e3;
            }(t);
          }), K2(e, "Core/Renderer/SVG/Symbols.js", [e["Core/Utilities.js"]], function (t) {
            function g3(t, r, i, o, a) {
              var s = [];

              if (a) {
                var c = a.start || 0,
                    l = n(a.r, i);
                i = n(a.r, o || i);
                var u = (a.end || 0) - .001;
                o = a.innerR;
                var h = n(a.open, .001 > Math.abs((a.end || 0) - c - 2 * Math.PI)),
                    d = Math.cos(c),
                    f = Math.sin(c),
                    p = Math.cos(u),
                    y = Math.sin(u);
                c = n(a.longArc, .001 > u - c - Math.PI ? 0 : 1), s.push(["M", t + l * d, r + i * f], ["A", l, i, 0, c, n(a.clockwise, 1), t + l * p, r + i * y]), e(o) && s.push(h ? ["M", t + o * p, r + o * y] : ["L", t + o * p, r + o * y], ["A", o, o, 0, c, e(a.clockwise) ? 1 - a.clockwise : 0, t + o * d, r + o * f]), h || s.push(["Z"]);
              }

              return s;
            }

            function x2(t, e, r, n, i) {
              return i && i.r ? F(t, e, r, n, i) : [["M", t, e], ["L", t + r, e], ["L", t + r, e + n], ["L", t, e + n], ["Z"]];
            }

            function F(t, e, r, n, i) {
              return [["M", t + (i = i && i.r || 0), e], ["L", t + r - i, e], ["C", t + r, e, t + r, e, t + r, e + i], ["L", t + r, e + n - i], ["C", t + r, e + n, t + r, e + n, t + r - i, e + n], ["L", t + i, e + n], ["C", t, e + n, t, e + n, t, e + n - i], ["L", t, e + i], ["C", t, e, t, e, t + i, e]];
            }

            var e = t.defined,
                r = t.isNumber,
                n = t.pick;
            return {
              arc: g3,
              callout: function callout(t, e, n, i, o) {
                var a = Math.min(o && o.r || 0, n, i),
                    s = a + 6,
                    c = o && o.anchorX;
                o = o && o.anchorY || 0;
                var l = F(t, e, n, i, {
                  r: a
                });
                return r(c) ? (t + c >= n ? o > e + s && o < e + i - s ? l.splice(3, 1, ["L", t + n, o - 6], ["L", t + n + 6, o], ["L", t + n, o + 6], ["L", t + n, e + i - a]) : l.splice(3, 1, ["L", t + n, i / 2], ["L", c, o], ["L", t + n, i / 2], ["L", t + n, e + i - a]) : 0 >= t + c ? o > e + s && o < e + i - s ? l.splice(7, 1, ["L", t, o + 6], ["L", t - 6, o], ["L", t, o - 6], ["L", t, e + a]) : l.splice(7, 1, ["L", t, i / 2], ["L", c, o], ["L", t, i / 2], ["L", t, e + a]) : o && o > i && c > t + s && c < t + n - s ? l.splice(5, 1, ["L", c + 6, e + i], ["L", c, e + i + 6], ["L", c - 6, e + i], ["L", t + a, e + i]) : o && 0 > o && c > t + s && c < t + n - s && l.splice(1, 1, ["L", c - 6, e], ["L", c, e - 6], ["L", c + 6, e], ["L", n - a, e]), l) : l;
              },
              circle: function circle(t, e, r, n) {
                return g3(t + r / 2, e + n / 2, r / 2, n / 2, {
                  start: .5 * Math.PI,
                  end: 2.5 * Math.PI,
                  open: !1
                });
              },
              diamond: function diamond(t, e, r, n) {
                return [["M", t + r / 2, e], ["L", t + r, e + n / 2], ["L", t + r / 2, e + n], ["L", t, e + n / 2], ["Z"]];
              },
              rect: x2,
              roundedRect: F,
              square: x2,
              triangle: function triangle(t, e, r, n) {
                return [["M", t + r / 2, e], ["L", t + r, e + n], ["L", t, e + n], ["Z"]];
              },
              "triangle-down": function triangleDown(t, e, r, n) {
                return [["M", t, e], ["L", t + r, e], ["L", t + r / 2, e + n], ["Z"]];
              }
            };
          }), K2(e, "Core/Renderer/SVG/TextBuilder.js", [e["Core/Renderer/HTML/AST.js"], e["Core/Globals.js"], e["Core/Utilities.js"]], function (t, e, r) {
            var n = e.doc,
                i = e.SVG_NS,
                o = e.win,
                a = r.attr,
                s = r.extend,
                c = r.fireEvent,
                l = r.isString,
                u = r.objectEach,
                h = r.pick;
            return function () {
              function h4(t) {
                var e = t.styles;
                this.renderer = t.renderer, this.svgElement = t, this.width = t.textWidth, this.textLineHeight = e && e.lineHeight, this.textOutline = e && e.textOutline, this.ellipsis = !(!e || "ellipsis" !== e.textOverflow), this.noWrap = !(!e || "nowrap" !== e.whiteSpace), this.fontSize = e && e.fontSize;
              }

              return h4.prototype.buildSVG = function () {
                var e = this.svgElement,
                    r = e.element,
                    i = e.renderer,
                    o = h(e.textStr, "").toString(),
                    a = -1 !== o.indexOf("<"),
                    s = r.childNodes;
                i = this.width && !e.added && i.box;
                var c = [o, this.ellipsis, this.noWrap, this.textLineHeight, this.textOutline, this.fontSize, this.width].join();

                if (c !== e.textCache) {
                  for (e.textCache = c, delete e.actualWidth, c = s.length; c--;) {
                    r.removeChild(s[c]);
                  }

                  a || this.ellipsis || this.width || e.textPath || -1 !== o.indexOf(" ") && (!this.noWrap || /<br.*?>/g.test(o)) ? "" !== o && (i && i.appendChild(r), o = new t(o), this.modifyTree(o.nodes), o.addToDOM(r), this.modifyDOM(), this.ellipsis && -1 !== (r.textContent || "").indexOf("\u2026") && e.attr("title", this.unescapeEntities(e.textStr || "", ["&lt;", "&gt;"])), i && i.removeChild(r)) : r.appendChild(n.createTextNode(this.unescapeEntities(o))), l(this.textOutline) && e.applyTextOutline && e.applyTextOutline(this.textOutline);
                }
              }, h4.prototype.modifyDOM = function () {
                var t,
                    e = this,
                    r = this.svgElement,
                    s = a(r.element, "x");

                for (r.firstLineMetrics = void 0; (t = r.element.firstChild) && /^[\s\u200B]*$/.test(t.textContent || " ");) {
                  r.element.removeChild(t);
                }

                [].forEach.call(r.element.querySelectorAll("tspan.highcharts-br"), function (t, n) {
                  t.nextSibling && t.previousSibling && (0 === n && 1 === t.previousSibling.nodeType && (r.firstLineMetrics = r.renderer.fontMetrics(void 0, t.previousSibling)), a(t, {
                    dy: e.getLineHeight(t.nextSibling),
                    x: s
                  }));
                });
                var c = this.width || 0;

                if (c) {
                  !function L2(t) {
                    [].slice.call(t.childNodes).forEach(function (l) {
                      l.nodeType === o.Node.TEXT_NODE ? function l3(t, o) {
                        var l = t.textContent || "",
                            u = l.replace(/([^\^])-/g, "$1- ").split(" "),
                            h = !e.noWrap && (1 < u.length || 1 < r.element.childNodes.length),
                            d = e.getLineHeight(o),
                            f = 0,
                            p = r.actualWidth;
                        if (e.ellipsis) l && e.truncate(t, l, void 0, 0, Math.max(0, c - parseInt(e.fontSize || 12, 10)), function (t, e) {
                          return t.substring(0, e) + "\u2026";
                        });else if (h) {
                          for (l = [], h = []; o.firstChild && o.firstChild !== t;) {
                            h.push(o.firstChild), o.removeChild(o.firstChild);
                          }

                          for (; u.length;) {
                            u.length && !e.noWrap && 0 < f && (l.push(t.textContent || ""), t.textContent = u.join(" ").replace(/- /g, "-")), e.truncate(t, void 0, u, 0 === f && p || 0, c, function (t, e) {
                              return u.slice(0, e).join(" ").replace(/- /g, "-");
                            }), p = r.actualWidth, f++;
                          }

                          h.forEach(function (e) {
                            o.insertBefore(e, t);
                          }), l.forEach(function (e) {
                            o.insertBefore(n.createTextNode(e), t), (e = n.createElementNS(i, "tspan")).textContent = "\u200B", a(e, {
                              dy: d,
                              x: s
                            }), o.insertBefore(e, t);
                          });
                        }
                      }(l, t) : (-1 !== l.className.baseVal.indexOf("highcharts-br") && (r.actualWidth = 0), L2(l));
                    });
                  }(r.element);
                }
              }, h4.prototype.getLineHeight = function (t) {
                var e;
                return t = t.nodeType === o.Node.TEXT_NODE ? t.parentElement : t, this.renderer.styledMode || (e = t && /(px|em)$/.test(t.style.fontSize) ? t.style.fontSize : this.fontSize || this.renderer.style.fontSize || 12), this.textLineHeight ? parseInt(this.textLineHeight.toString(), 10) : this.renderer.fontMetrics(e, t || this.svgElement.element).h;
              }, h4.prototype.modifyTree = function (t) {
                var e = this;
                t.forEach(function a4(r, n) {
                  var i = r.attributes;
                  i = void 0 === i ? {} : i;
                  var o = r.children,
                      a = r.style;
                  a = void 0 === a ? {} : a;
                  var c = r.tagName,
                      l = e.renderer.styledMode;
                  "b" === c || "strong" === c ? l ? i.class = "highcharts-strong" : a.fontWeight = "bold" : "i" !== c && "em" !== c || (l ? i.class = "highcharts-emphasized" : a.fontStyle = "italic"), a && a.color && (a.fill = a.color), "br" === c ? (i.class = "highcharts-br", r.textContent = "\u200B", (n = t[n + 1]) && n.textContent && (n.textContent = n.textContent.replace(/^ +/gm, ""))) : "a" === c && o && o.some(function (t) {
                    return "#text" === t.tagName;
                  }) && (r.children = [{
                    children: o,
                    tagName: "tspan"
                  }]), "#text" !== c && "a" !== c && (r.tagName = "tspan"), s(r, {
                    attributes: i,
                    style: a
                  }), o && o.filter(function (t) {
                    return "#text" !== t.tagName;
                  }).forEach(a4);
                }), c(this.svgElement, "afterModifyTree", {
                  nodes: t
                });
              }, h4.prototype.truncate = function (t, e, r, n, i, o) {
                var a,
                    s = this.svgElement,
                    c = s.renderer,
                    l = s.rotation,
                    u = [],
                    h = r ? 1 : 0,
                    d = (e || r || "").length,
                    f = d,
                    p = function z2(i, a) {
                  a = a || i;
                  var l = t.parentNode;
                  if (l && "undefined" === typeof u[a]) if (l.getSubStringLength) try {
                    u[a] = n + l.getSubStringLength(0, r ? a + 1 : a);
                  } catch (h) {} else c.getSpanWidth && (t.textContent = o(e || r, i), u[a] = n + c.getSpanWidth(s, t));
                  return u[a];
                };

                s.rotation = 0;
                var y = p(t.textContent.length);

                if (n + y > i) {
                  for (; h <= d;) {
                    f = Math.ceil((h + d) / 2), r && (a = o(r, f)), y = p(f, a && a.length - 1), h === d ? h = d + 1 : y > i ? d = f - 1 : h = f;
                  }

                  0 === d ? t.textContent = "" : e && d === e.length - 1 || (t.textContent = a || o(e || r, f));
                }

                r && r.splice(0, f), s.actualWidth = y, s.rotation = l;
              }, h4.prototype.unescapeEntities = function (t, e) {
                return u(this.renderer.escapes, function (r, n) {
                  e && -1 !== e.indexOf(r) || (t = t.toString().replace(new RegExp(r, "g"), n));
                }), t;
              }, h4;
            }();
          }), K2(e, "Core/Renderer/SVG/SVGRenderer.js", [e["Core/Renderer/HTML/AST.js"], e["Core/Color/Color.js"], e["Core/Globals.js"], e["Core/Renderer/RendererRegistry.js"], e["Core/Renderer/SVG/SVGElement.js"], e["Core/Renderer/SVG/SVGLabel.js"], e["Core/Renderer/SVG/Symbols.js"], e["Core/Renderer/SVG/TextBuilder.js"], e["Core/Utilities.js"]], function (t, e, r, n, i, o, a, s, c) {
            var l,
                u = r.charts,
                h = r.deg2rad,
                d = r.doc,
                f = r.isFirefox,
                p = r.isMS,
                y = r.isWebKit,
                g = r.noop,
                m = r.SVG_NS,
                b = r.symbolSizes,
                x = r.win,
                w = c.addEvent,
                S = c.attr,
                O = c.createElement,
                E = c.css,
                k = c.defined,
                _ = c.destroyObjectProperties,
                C = c.extend,
                T = c.isArray,
                A = c.isNumber,
                M = c.isObject,
                P = c.isString,
                j = c.merge,
                R = c.pick,
                D = c.pInt,
                I = c.uniqueKey;
            return r = function () {
              function v(t, e, r, n, i, o, a) {
                this.width = this.url = this.style = this.isSVG = this.imgCount = this.height = this.gradients = this.globalAnimation = this.defs = this.chartIndex = this.cacheKeys = this.cache = this.boxWrapper = this.box = this.alignedObjects = void 0, this.init(t, e, r, n, i, o, a);
              }

              return v.prototype.init = function (t, e, r, n, i, o, a) {
                var s,
                    c = this.createElement("svg").attr({
                  version: "1.1",
                  class: "highcharts-root"
                }),
                    l = c.element;
                a || c.css(this.getStyle(n)), t.appendChild(l), S(t, "dir", "ltr"), -1 === t.innerHTML.indexOf("xmlns") && S(l, "xmlns", this.SVG_NS), this.isSVG = !0, this.box = l, this.boxWrapper = c, this.alignedObjects = [], this.url = this.getReferenceURL(), this.createElement("desc").add().element.appendChild(d.createTextNode("Created with Highcharts 10.3.3")), this.defs = this.createElement("defs").add(), this.allowHTML = o, this.forExport = i, this.styledMode = a, this.gradients = {}, this.cache = {}, this.cacheKeys = [], this.imgCount = 0, this.setSize(e, r, !1), f && t.getBoundingClientRect && ((e = function c3() {
                  E(t, {
                    left: 0,
                    top: 0
                  }), s = t.getBoundingClientRect(), E(t, {
                    left: Math.ceil(s.left) - s.left + "px",
                    top: Math.ceil(s.top) - s.top + "px"
                  });
                })(), this.unSubPixelFix = w(x, "resize", e));
              }, v.prototype.definition = function (e) {
                return new t([e]).addToDOM(this.defs.element);
              }, v.prototype.getReferenceURL = function () {
                if ((f || y) && d.getElementsByTagName("base").length) {
                  if (!k(l)) {
                    var e = I();
                    e = new t([{
                      tagName: "svg",
                      attributes: {
                        width: 8,
                        height: 8
                      },
                      children: [{
                        tagName: "defs",
                        children: [{
                          tagName: "clipPath",
                          attributes: {
                            id: e
                          },
                          children: [{
                            tagName: "rect",
                            attributes: {
                              width: 4,
                              height: 4
                            }
                          }]
                        }]
                      }, {
                        tagName: "rect",
                        attributes: {
                          id: "hitme",
                          width: 8,
                          height: 8,
                          "clip-path": "url(#".concat(e, ")"),
                          fill: "rgba(0,0,0,0.001)"
                        }
                      }]
                    }]).addToDOM(d.body), E(e, {
                      position: "fixed",
                      top: 0,
                      left: 0,
                      zIndex: 9e5
                    });
                    var r = d.elementFromPoint(6, 6);
                    l = "hitme" === (r && r.id), d.body.removeChild(e);
                  }

                  if (l) return x.location.href.split("#")[0].replace(/<[^>]*>/g, "").replace(/([\('\)])/g, "\\$1").replace(/ /g, "%20");
                }

                return "";
              }, v.prototype.getStyle = function (t) {
                return this.style = C({
                  fontFamily: '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',
                  fontSize: "12px"
                }, t);
              }, v.prototype.setStyle = function (t) {
                this.boxWrapper.css(this.getStyle(t));
              }, v.prototype.isHidden = function () {
                return !this.boxWrapper.getBBox().width;
              }, v.prototype.destroy = function () {
                var t = this.defs;
                return this.box = null, this.boxWrapper = this.boxWrapper.destroy(), _(this.gradients || {}), this.gradients = null, t && (this.defs = t.destroy()), this.unSubPixelFix && this.unSubPixelFix(), this.alignedObjects = null;
              }, v.prototype.createElement = function (t) {
                var e = new this.Element();
                return e.init(this, t), e;
              }, v.prototype.getRadialAttr = function (t, e) {
                return {
                  cx: t[0] - t[2] / 2 + (e.cx || 0) * t[2],
                  cy: t[1] - t[2] / 2 + (e.cy || 0) * t[2],
                  r: (e.r || 0) * t[2]
                };
              }, v.prototype.buildText = function (t) {
                new s(t).buildSVG();
              }, v.prototype.getContrast = function (t) {
                return 1.05 / ((t = .2126 * (t = e.parse(t).rgba.map(function (t) {
                  return .03928 >= (t /= 255) ? t / 12.92 : Math.pow((t + .055) / 1.055, 2.4);
                }))[0] + .7152 * t[1] + .0722 * t[2]) + .05) > (t + .05) / .05 ? "#FFFFFF" : "#000000";
              }, v.prototype.button = function (e, r, n, i, o, a, s, c, l, u) {
                void 0 === o && (o = {});
                var h = this.label(e, r, n, l, void 0, void 0, u, void 0, "button"),
                    d = this.styledMode;
                e = o.states || {};
                var f = 0;
                delete (o = j(o)).states;
                var y = j({
                  color: "#333333",
                  cursor: "pointer",
                  fontWeight: "normal"
                }, o.style);
                delete o.style;
                var g = t.filterUserAttributes(o);

                if (h.attr(j({
                  padding: 8,
                  r: 2
                }, g)), !d) {
                  g = j({
                    fill: "#f7f7f7",
                    stroke: "#cccccc",
                    "stroke-width": 1
                  }, g);
                  var m = (a = j(g, {
                    fill: "#e6e6e6"
                  }, t.filterUserAttributes(a || e.hover || {}))).style;
                  delete a.style;
                  var v = (s = j(g, {
                    fill: "#e6ebf5",
                    style: {
                      color: "#000000",
                      fontWeight: "bold"
                    }
                  }, t.filterUserAttributes(s || e.select || {}))).style;
                  delete s.style;
                  var b = (c = j(g, {
                    style: {
                      color: "#cccccc"
                    }
                  }, t.filterUserAttributes(c || e.disabled || {}))).style;
                  delete c.style;
                }

                return w(h.element, p ? "mouseover" : "mouseenter", function () {
                  3 !== f && h.setState(1);
                }), w(h.element, p ? "mouseout" : "mouseleave", function () {
                  3 !== f && h.setState(f);
                }), h.setState = function (t) {
                  1 !== t && (h.state = f = t), h.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-" + ["normal", "hover", "pressed", "disabled"][t || 0]), d || (h.attr([g, a, s, c][t || 0]), M(t = [y, m, v, b][t || 0]) && h.css(t));
                }, d || (h.attr(g).css(C({
                  cursor: "default"
                }, y)), u && h.text.css({
                  pointerEvents: "none"
                })), h.on("touchstart", function (t) {
                  return t.stopPropagation();
                }).on("click", function (t) {
                  3 !== f && i.call(h, t);
                });
              }, v.prototype.crispLine = function (t, e, r) {
                void 0 === r && (r = "round");
                var n = t[0],
                    i = t[1];
                return k(n[1]) && n[1] === i[1] && (n[1] = i[1] = Math[r](n[1]) - e % 2 / 2), k(n[2]) && n[2] === i[2] && (n[2] = i[2] = Math[r](n[2]) + e % 2 / 2), t;
              }, v.prototype.path = function (t) {
                var e = this.styledMode ? {} : {
                  fill: "none"
                };
                return T(t) ? e.d = t : M(t) && C(e, t), this.createElement("path").attr(e);
              }, v.prototype.circle = function (t, e, r) {
                return t = M(t) ? t : "undefined" === typeof t ? {} : {
                  x: t,
                  y: e,
                  r: r
                }, (e = this.createElement("circle")).xSetter = e.ySetter = function (t, e, r) {
                  r.setAttribute("c" + e, t);
                }, e.attr(t);
              }, v.prototype.arc = function (t, e, r, n, i, o) {
                return M(t) ? (e = (n = t).y, r = n.r, t = n.x) : n = {
                  innerR: n,
                  start: i,
                  end: o
                }, (t = this.symbol("arc", t, e, r, r, n)).r = r, t;
              }, v.prototype.rect = function (t, e, r, n, i, o) {
                i = M(t) ? t.r : i;
                var a = this.createElement("rect");
                return t = M(t) ? t : "undefined" === typeof t ? {} : {
                  x: t,
                  y: e,
                  width: Math.max(r, 0),
                  height: Math.max(n, 0)
                }, this.styledMode || ("undefined" !== typeof o && (t["stroke-width"] = o, t = a.crisp(t)), t.fill = "none"), i && (t.r = i), a.rSetter = function (t, e, r) {
                  a.r = t, S(r, {
                    rx: t,
                    ry: t
                  });
                }, a.rGetter = function () {
                  return a.r || 0;
                }, a.attr(t);
              }, v.prototype.setSize = function (t, e, r) {
                this.width = t, this.height = e, this.boxWrapper.animate({
                  width: t,
                  height: e
                }, {
                  step: function step() {
                    this.attr({
                      viewBox: "0 0 " + this.attr("width") + " " + this.attr("height")
                    });
                  },
                  duration: R(r, !0) ? void 0 : 0
                }), this.alignElements();
              }, v.prototype.g = function (t) {
                var e = this.createElement("g");
                return t ? e.attr({
                  class: "highcharts-" + t
                }) : e;
              }, v.prototype.image = function (t, e, r, n, i, o) {
                var a = {
                  preserveAspectRatio: "none"
                },
                    s = function n3(t, e) {
                  t.setAttributeNS ? t.setAttributeNS("http://www.w3.org/1999/xlink", "href", e) : t.setAttribute("hc-svg-href", e);
                };

                A(e) && (a.x = e), A(r) && (a.y = r), A(n) && (a.width = n), A(i) && (a.height = i);
                var c = this.createElement("image").attr(a);
                return e = function c3(e) {
                  s(c.element, t), o.call(c, e);
                }, o ? (s(c.element, "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="), r = new x.Image(), w(r, "load", e), r.src = t, r.complete && e({})) : s(c.element, t), c;
              }, v.prototype.symbol = function (t, e, r, n, i, o) {
                var a,
                    s = this,
                    c = /^url\((.*?)\)$/,
                    l = c.test(t),
                    h = !l && (this.symbols[t] ? t : "circle"),
                    f = h && this.symbols[h];

                if (f) {
                  "number" === typeof e && (a = f.call(this.symbols, Math.round(e || 0), Math.round(r || 0), n || 0, i || 0, o));
                  var p = this.path(a);
                  s.styledMode || p.attr("fill", "none"), C(p, {
                    symbolName: h || void 0,
                    x: e,
                    y: r,
                    width: n,
                    height: i
                  }), o && C(p, o);
                } else if (l) {
                  var y = t.match(c)[1],
                      g = p = this.image(y);
                  g.imgwidth = R(b[y] && b[y].width, o && o.width), g.imgheight = R(b[y] && b[y].height, o && o.height);

                  var m = function N2(t) {
                    return t.attr({
                      width: t.width,
                      height: t.height
                    });
                  };

                  ["width", "height"].forEach(function (t) {
                    g[t + "Setter"] = function (t, e) {
                      this[e] = t, t = this.alignByTranslate;
                      var r = this.element,
                          n = this.width,
                          i = this.height,
                          a = this.imgwidth,
                          s = this.imgheight,
                          c = this["img" + e];

                      if (k(c)) {
                        var l = 1;
                        o && "within" === o.backgroundSize && n && i ? (l = Math.min(n / a, i / s), c = Math.round(c * l), S(r, {
                          width: Math.round(a * l),
                          height: Math.round(s * l)
                        })) : r && r.setAttribute(e, c), t || this.translate(((n || 0) - c * l) / 2, ((i || 0) - c * l) / 2);
                      }
                    };
                  }), k(e) && g.attr({
                    x: e,
                    y: r
                  }), g.isImg = !0, k(g.imgwidth) && k(g.imgheight) ? m(g) : (g.attr({
                    width: 0,
                    height: 0
                  }), O("img", {
                    onload: function onload() {
                      var t = u[s.chartIndex];
                      0 === this.width && (E(this, {
                        position: "absolute",
                        top: "-999em"
                      }), d.body.appendChild(this)), b[y] = {
                        width: this.width,
                        height: this.height
                      }, g.imgwidth = this.width, g.imgheight = this.height, g.element && m(g), this.parentNode && this.parentNode.removeChild(this), s.imgCount--, s.imgCount || !t || t.hasLoaded || t.onload();
                    },
                    src: y
                  }), this.imgCount++);
                }

                return p;
              }, v.prototype.clipRect = function (t, e, r, n) {
                var i = I() + "-",
                    o = this.createElement("clipPath").attr({
                  id: i
                }).add(this.defs);
                return (t = this.rect(t, e, r, n, 0).add(o)).id = i, t.clipPath = o, t.count = 0, t;
              }, v.prototype.text = function (t, e, r, n) {
                var i = {};
                return !n || !this.allowHTML && this.forExport ? (i.x = Math.round(e || 0), r && (i.y = Math.round(r)), k(t) && (i.text = t), t = this.createElement("text").attr(i), (!n || this.forExport && !this.allowHTML) && (t.xSetter = function (t, e, r) {
                  for (var n, i = r.getElementsByTagName("tspan"), o = r.getAttribute(e), a = 0; a < i.length; a++) {
                    (n = i[a]).getAttribute(e) === o && n.setAttribute(e, t);
                  }

                  r.setAttribute(e, t);
                }), t) : this.html(t, e, r);
              }, v.prototype.fontMetrics = function (t, e) {
                return t = !this.styledMode && /px/.test(t) || !x.getComputedStyle ? t || e && e.style && e.style.fontSize || this.style && this.style.fontSize : e && i.prototype.getStyle.call(e, "font-size"), {
                  h: e = 24 > (t = /px/.test(t) ? D(t) : 12) ? t + 3 : Math.round(1.2 * t),
                  b: Math.round(.8 * e),
                  f: t
                };
              }, v.prototype.rotCorr = function (t, e, r) {
                var n = t;
                return e && r && (n = Math.max(n * Math.cos(e * h), 4)), {
                  x: -t / 3 * Math.sin(e * h),
                  y: n
                };
              }, v.prototype.pathToSegments = function (t) {
                for (var e = [], r = [], n = {
                  A: 8,
                  C: 7,
                  H: 2,
                  L: 3,
                  M: 3,
                  Q: 5,
                  S: 5,
                  T: 3,
                  V: 2
                }, i = 0; i < t.length; i++) {
                  P(r[0]) && A(t[i]) && r.length === n[r[0].toUpperCase()] && t.splice(i, 0, r[0].replace("M", "L").replace("m", "l")), "string" === typeof t[i] && (r.length && e.push(r.slice(0)), r.length = 0), r.push(t[i]);
                }

                return e.push(r.slice(0)), e;
              }, v.prototype.label = function (t, e, r, n, i, a, s, c, l) {
                return new o(this, t, e, r, n, i, a, s, c, l);
              }, v.prototype.alignElements = function () {
                this.alignedObjects.forEach(function (t) {
                  return t.align();
                });
              }, v;
            }(), C(r.prototype, {
              Element: i,
              SVG_NS: m,
              escapes: {
                "&": "&amp;",
                "<": "&lt;",
                ">": "&gt;",
                "'": "&#39;",
                '"': "&quot;"
              },
              symbols: a,
              draw: g
            }), n.registerRendererType("svg", r, !0), r;
          }), K2(e, "Core/Renderer/HTML/HTMLElement.js", [e["Core/Globals.js"], e["Core/Renderer/SVG/SVGElement.js"], e["Core/Utilities.js"]], function (t, e, r) {
            var n = this && this.__extends || function () {
              var t = function d4(e, r) {
                return (t = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, e) {
                  t.__proto__ = e;
                } || function (t, e) {
                  for (var r in e) {
                    e.hasOwnProperty(r) && (t[r] = e[r]);
                  }
                })(e, r);
              };

              return function (e, r) {
                function h5() {
                  this.constructor = e;
                }

                t(e, r), e.prototype = null === r ? Object.create(r) : (h5.prototype = r.prototype, new h5());
              };
            }(),
                i = t.isFirefox,
                o = t.isMS,
                a = t.isWebKit,
                s = t.win,
                c = r.css,
                l = r.defined,
                u = r.extend,
                h = r.pick,
                d = r.pInt;

            return function (t) {
              function k3() {
                return null !== t && t.apply(this, arguments) || this;
              }

              return n(k3, t), k3.compose = function (t) {
                if (-1 === k3.composedClasses.indexOf(t)) {
                  k3.composedClasses.push(t);
                  var e = k3.prototype,
                      r = t.prototype;
                  r.getSpanCorrection = e.getSpanCorrection, r.htmlCss = e.htmlCss, r.htmlGetBBox = e.htmlGetBBox, r.htmlUpdateTransform = e.htmlUpdateTransform, r.setSpanRotation = e.setSpanRotation;
                }

                return t;
              }, k3.prototype.getSpanCorrection = function (t, e, r) {
                this.xCorr = -t * r, this.yCorr = -e;
              }, k3.prototype.htmlCss = function (t) {
                var e = "SPAN" === this.element.tagName && t && "width" in t,
                    r = h(e && t.width, void 0);

                if (e) {
                  delete t.width, this.textWidth = r;
                  var n = !0;
                }

                return t && "ellipsis" === t.textOverflow && (t.whiteSpace = "nowrap", t.overflow = "hidden"), this.styles = u(this.styles, t), c(this.element, t), n && this.htmlUpdateTransform(), this;
              }, k3.prototype.htmlGetBBox = function () {
                var t = this.element;
                return {
                  x: t.offsetLeft,
                  y: t.offsetTop,
                  width: t.offsetWidth,
                  height: t.offsetHeight
                };
              }, k3.prototype.htmlUpdateTransform = function () {
                if (this.added) {
                  var t = this.renderer,
                      e = this.element,
                      r = this.translateX || 0,
                      n = this.translateY || 0,
                      i = this.x || 0,
                      o = this.y || 0,
                      a = this.textAlign || "left",
                      s = {
                    left: 0,
                    center: .5,
                    right: 1
                  }[a],
                      u = this.styles;

                  if (u = u && u.whiteSpace, c(e, {
                    marginLeft: r,
                    marginTop: n
                  }), !t.styledMode && this.shadows && this.shadows.forEach(function (t) {
                    c(t, {
                      marginLeft: r + 1,
                      marginTop: n + 1
                    });
                  }), this.inverted && [].forEach.call(e.childNodes, function (r) {
                    t.invertChild(r, e);
                  }), "SPAN" === e.tagName) {
                    var h = this.rotation,
                        f = this.textWidth && d(this.textWidth),
                        p = [h, a, e.innerHTML, this.textWidth, this.textAlign].join(),
                        y = void 0;

                    if (y = !1, f !== this.oldTextWidth) {
                      if (this.textPxLength) var g = this.textPxLength;else c(e, {
                        width: "",
                        whiteSpace: u || "nowrap"
                      }), g = e.offsetWidth;
                      (f > this.oldTextWidth || g > f) && (/[ \-]/.test(e.textContent || e.innerText) || "ellipsis" === e.style.textOverflow) && (c(e, {
                        width: g > f || h ? f + "px" : "auto",
                        display: "block",
                        whiteSpace: u || "normal"
                      }), this.oldTextWidth = f, y = !0);
                    }

                    this.hasBoxWidthChanged = y, p !== this.cTT && (y = t.fontMetrics(e.style.fontSize, e).b, !l(h) || h === (this.oldRotation || 0) && a === this.oldAlign || this.setSpanRotation(h, s, y), this.getSpanCorrection(!l(h) && this.textPxLength || e.offsetWidth, y, s, h, a)), c(e, {
                      left: i + (this.xCorr || 0) + "px",
                      top: o + (this.yCorr || 0) + "px"
                    }), this.cTT = p, this.oldRotation = h, this.oldAlign = a;
                  }
                } else this.alignOnAdd = !0;
              }, k3.prototype.setSpanRotation = function (t, e, r) {
                var n = {},
                    l = o && !/Edge/.test(s.navigator.userAgent) ? "-ms-transform" : a ? "-webkit-transform" : i ? "MozTransform" : s.opera ? "-o-transform" : void 0;
                l && (n[l] = n.transform = "rotate(" + t + "deg)", n[l + (i ? "Origin" : "-origin")] = n.transformOrigin = 100 * e + "% " + r + "px", c(this.element, n));
              }, k3.composedClasses = [], k3;
            }(e);
          }), K2(e, "Core/Renderer/HTML/HTMLRenderer.js", [e["Core/Renderer/HTML/AST.js"], e["Core/Renderer/SVG/SVGElement.js"], e["Core/Renderer/SVG/SVGRenderer.js"], e["Core/Utilities.js"]], function (t, e, r, n) {
            var i = this && this.__extends || function () {
              var t = function a4(e, r) {
                return (t = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, e) {
                  t.__proto__ = e;
                } || function (t, e) {
                  for (var r in e) {
                    e.hasOwnProperty(r) && (t[r] = e[r]);
                  }
                })(e, r);
              };

              return function (e, r) {
                function h4() {
                  this.constructor = e;
                }

                t(e, r), e.prototype = null === r ? Object.create(r) : (h4.prototype = r.prototype, new h4());
              };
            }(),
                o = n.attr,
                a = n.createElement,
                s = n.extend,
                c = n.pick;

            return function (r) {
              function e3() {
                return null !== r && r.apply(this, arguments) || this;
              }

              return i(e3, r), e3.compose = function (t) {
                return -1 === e3.composedClasses.indexOf(t) && (e3.composedClasses.push(t), t.prototype.html = e3.prototype.html), t;
              }, e3.prototype.html = function (r, n, i) {
                var l = this.createElement("span"),
                    u = l.element,
                    h = l.renderer,
                    d = h.isSVG,
                    f = function E2(t, r) {
                  ["opacity", "visibility"].forEach(function (n) {
                    t[n + "Setter"] = function (i, o, a) {
                      var s = t.div ? t.div.style : r;
                      e.prototype[n + "Setter"].call(this, i, o, a), s && (s[o] = i);
                    };
                  }), t.addedSetters = !0;
                };

                return l.textSetter = function (e) {
                  e !== this.textStr && (delete this.bBox, delete this.oldTextWidth, t.setElementHTML(this.element, c(e, "")), this.textStr = e, l.doTransform = !0);
                }, d && f(l, l.element.style), l.xSetter = l.ySetter = l.alignSetter = l.rotationSetter = function (t, e) {
                  "align" === e ? l.alignValue = l.textAlign = t : l[e] = t, l.doTransform = !0;
                }, l.afterSetters = function () {
                  this.doTransform && (this.htmlUpdateTransform(), this.doTransform = !1);
                }, l.attr({
                  text: r,
                  x: Math.round(n),
                  y: Math.round(i)
                }).css({
                  position: "absolute"
                }), h.styledMode || l.css({
                  fontFamily: this.style.fontFamily,
                  fontSize: this.style.fontSize
                }), u.style.whiteSpace = "nowrap", l.css = l.htmlCss, d && (l.add = function (t) {
                  var e = h.box.parentNode,
                      r = [];

                  if (this.parentGroup = t) {
                    var n = t.div;

                    if (!n) {
                      for (; t;) {
                        r.push(t), t = t.parentGroup;
                      }

                      r.reverse().forEach(function (t) {
                        function d5(e, r) {
                          t[r] = e, "translateX" === r ? h.left = e + "px" : h.top = e + "px", t.doTransform = !0;
                        }

                        var i,
                            c = o(t.element, "class"),
                            u = t.styles || {},
                            h = (n = t.div = t.div || a("div", c ? {
                          className: c
                        } : void 0, {
                          position: "absolute",
                          left: (t.translateX || 0) + "px",
                          top: (t.translateY || 0) + "px",
                          display: t.display,
                          opacity: t.opacity,
                          cursor: u.cursor,
                          pointerEvents: u.pointerEvents,
                          visibility: t.visibility
                        }, n || e)).style;
                        s(t, {
                          classSetter: (i = n, function (t) {
                            this.element.setAttribute("class", t), i.className = t;
                          }),
                          on: function on() {
                            return r[0].div && l.on.apply({
                              element: r[0].div,
                              onEvents: t.onEvents
                            }, arguments), t;
                          },
                          translateXSetter: d5,
                          translateYSetter: d5
                        }), t.addedSetters || f(t);
                      });
                    }
                  } else n = e;

                  return n.appendChild(u), l.added = !0, l.alignOnAdd && l.htmlUpdateTransform(), l;
                }), l;
              }, e3.composedClasses = [], e3;
            }(r);
          }), K2(e, "Core/Axis/AxisDefaults.js", [], function () {
            var t, e;
            return (e = t || (t = {})).defaultXAxisOptions = {
              alignTicks: !0,
              allowDecimals: void 0,
              panningEnabled: !0,
              zIndex: 2,
              zoomEnabled: !0,
              dateTimeLabelFormats: {
                millisecond: {
                  main: "%H:%M:%S.%L",
                  range: !1
                },
                second: {
                  main: "%H:%M:%S",
                  range: !1
                },
                minute: {
                  main: "%H:%M",
                  range: !1
                },
                hour: {
                  main: "%H:%M",
                  range: !1
                },
                day: {
                  main: "%e. %b"
                },
                week: {
                  main: "%e. %b"
                },
                month: {
                  main: "%b '%y"
                },
                year: {
                  main: "%Y"
                }
              },
              endOnTick: !1,
              gridLineDashStyle: "Solid",
              gridZIndex: 1,
              labels: {
                autoRotation: void 0,
                autoRotationLimit: 80,
                distance: void 0,
                enabled: !0,
                indentation: 10,
                overflow: "justify",
                padding: 5,
                reserveSpace: void 0,
                rotation: void 0,
                staggerLines: 0,
                step: 0,
                useHTML: !1,
                x: 0,
                zIndex: 7,
                style: {
                  color: "#666666",
                  cursor: "default",
                  fontSize: "11px"
                }
              },
              maxPadding: .01,
              minorGridLineDashStyle: "Solid",
              minorTickLength: 2,
              minorTickPosition: "outside",
              minPadding: .01,
              offset: void 0,
              opposite: !1,
              reversed: void 0,
              reversedStacks: !1,
              showEmpty: !0,
              showFirstLabel: !0,
              showLastLabel: !0,
              startOfWeek: 1,
              startOnTick: !1,
              tickLength: 10,
              tickPixelInterval: 100,
              tickmarkPlacement: "between",
              tickPosition: "outside",
              title: {
                align: "middle",
                rotation: 0,
                useHTML: !1,
                x: 0,
                y: 0,
                style: {
                  color: "#666666"
                }
              },
              type: "linear",
              uniqueNames: !0,
              visible: !0,
              minorGridLineColor: "#f2f2f2",
              minorGridLineWidth: 1,
              minorTickColor: "#999999",
              lineColor: "#ccd6eb",
              lineWidth: 1,
              gridLineColor: "#e6e6e6",
              gridLineWidth: void 0,
              tickColor: "#ccd6eb"
            }, e.defaultYAxisOptions = {
              reversedStacks: !0,
              endOnTick: !0,
              maxPadding: .05,
              minPadding: .05,
              tickPixelInterval: 72,
              showLastLabel: !0,
              labels: {
                x: -8
              },
              startOnTick: !0,
              title: {
                rotation: 270,
                text: "Values"
              },
              stackLabels: {
                animation: {},
                allowOverlap: !1,
                enabled: !1,
                crop: !0,
                overflow: "justify",
                formatter: function formatter() {
                  return (0, this.axis.chart.numberFormatter)(this.total || 0, -1);
                },
                style: {
                  color: "#000000",
                  fontSize: "11px",
                  fontWeight: "bold",
                  textOutline: "1px contrast"
                }
              },
              gridLineWidth: 1,
              lineWidth: 0
            }, e.defaultLeftAxisOptions = {
              labels: {
                x: -15
              },
              title: {
                rotation: 270
              }
            }, e.defaultRightAxisOptions = {
              labels: {
                x: 15
              },
              title: {
                rotation: 90
              }
            }, e.defaultBottomAxisOptions = {
              labels: {
                autoRotation: [-45],
                x: 0
              },
              margin: 15,
              title: {
                rotation: 0
              }
            }, e.defaultTopAxisOptions = {
              labels: {
                autoRotation: [-45],
                x: 0
              },
              margin: 15,
              title: {
                rotation: 0
              }
            }, t;
          }), K2(e, "Core/Foundation.js", [e["Core/Utilities.js"]], function (t) {
            var e,
                r = t.addEvent,
                n = t.isFunction,
                i = t.objectEach,
                o = t.removeEvent;
            return (e || (e = {})).registerEventOptions = function (t, e) {
              t.eventOptions = t.eventOptions || {}, i(e.events, function (e, i) {
                t.eventOptions[i] !== e && (t.eventOptions[i] && (o(t, i, t.eventOptions[i]), delete t.eventOptions[i]), n(e) && (t.eventOptions[i] = e, r(t, i, e)));
              });
            }, e;
          }), K2(e, "Core/Axis/Tick.js", [e["Core/FormatUtilities.js"], e["Core/Globals.js"], e["Core/Utilities.js"]], function (t, e, r) {
            var n = e.deg2rad,
                i = r.clamp,
                o = r.correctFloat,
                a = r.defined,
                s = r.destroyObjectProperties,
                c = r.extend,
                l = r.fireEvent,
                u = r.isNumber,
                h = r.merge,
                d = r.objectEach,
                f = r.pick;
            return e = function () {
              function g4(t, e, r, n, i) {
                this.isNewLabel = this.isNew = !0, this.axis = t, this.pos = e, this.type = r || "", this.parameters = i || {}, this.tickmarkOffset = this.parameters.tickmarkOffset, this.options = this.parameters.options, l(this, "init"), r || n || this.addLabel();
              }

              return g4.prototype.addLabel = function () {
                var e = this,
                    r = e.axis,
                    n = r.options,
                    i = r.chart,
                    s = r.categories,
                    h = r.logarithmic,
                    d = r.names,
                    p = e.pos,
                    y = f(e.options && e.options.labels, n.labels),
                    g = r.tickPositions,
                    m = p === g[0],
                    v = p === g[g.length - 1],
                    b = (!y.step || 1 === y.step) && 1 === r.tickInterval;
                g = g.info;
                var x,
                    w = e.label;
                if (s = this.parameters.category || (s ? f(s[p], d[p], p) : p), h && u(s) && (s = o(h.lin2log(s))), r.dateTime) if (g) var S = i.time.resolveDTLFormat(n.dateTimeLabelFormats[!n.grid && g.higherRanks[p] || g.unitName]),
                    O = S.main;else u(s) && (O = r.dateTime.getXDateFormat(s, n.dateTimeLabelFormats || {}));
                e.isFirst = m, e.isLast = v;
                var E = {
                  axis: r,
                  chart: i,
                  dateTimeLabelFormat: O,
                  isFirst: m,
                  isLast: v,
                  pos: p,
                  tick: e,
                  tickPositionInfo: g,
                  value: s
                };
                l(this, "labelFormat", E);

                var k = function t4(e) {
                  return y.formatter ? y.formatter.call(e, e) : y.format ? (e.text = r.defaultLabelFormatter.call(e, e), t.format(y.format, e, i)) : r.defaultLabelFormatter.call(e, e);
                };

                n = k.call(E, E);

                var _ = S && S.list;

                e.shortenLabel = _ ? function () {
                  for (x = 0; x < _.length; x++) {
                    if (c(E, {
                      dateTimeLabelFormat: _[x]
                    }), w.attr({
                      text: k.call(E, E)
                    }), w.getBBox().width < r.getSlotWidth(e) - 2 * y.padding) return;
                  }

                  w.attr({
                    text: ""
                  });
                } : void 0, b && r._addedPlotLB && e.moveLabel(n, y), a(w) || e.movedLabel ? w && w.textStr !== n && !b && (!w.textWidth || y.style.width || w.styles.width || w.css({
                  width: null
                }), w.attr({
                  text: n
                }), w.textPxLength = w.getBBox().width) : (e.label = w = e.createLabel({
                  x: 0,
                  y: 0
                }, n, y), e.rotation = 0);
              }, g4.prototype.createLabel = function (t, e, r) {
                var n = this.axis,
                    i = n.chart;
                return (t = a(e) && r.enabled ? i.renderer.text(e, t.x, t.y, r.useHTML).add(n.labelGroup) : null) && (i.styledMode || t.css(h(r.style)), t.textPxLength = t.getBBox().width), t;
              }, g4.prototype.destroy = function () {
                s(this, this.axis);
              }, g4.prototype.getPosition = function (t, e, r, n) {
                var a = this.axis,
                    s = a.chart,
                    c = n && s.oldChartHeight || s.chartHeight;
                return (t = {
                  x: t ? o(a.translate(e + r, void 0, void 0, n) + a.transB) : a.left + a.offset + (a.opposite ? (n && s.oldChartWidth || s.chartWidth) - a.right - a.left : 0),
                  y: t ? c - a.bottom + a.offset - (a.opposite ? a.height : 0) : o(c - a.translate(e + r, void 0, void 0, n) - a.transB)
                }).y = i(t.y, -1e5, 1e5), l(this, "afterGetPosition", {
                  pos: t
                }), t;
              }, g4.prototype.getLabelPosition = function (t, e, r, i, o, s, c, u) {
                var h = this.axis,
                    d = h.transA,
                    f = h.isLinked && h.linkedParent ? h.linkedParent.reversed : h.reversed,
                    p = h.staggerLines,
                    y = h.tickRotCorr || {
                  x: 0,
                  y: 0
                },
                    g = i || h.reserveSpaceDefault ? 0 : -h.labelOffset * ("center" === h.labelAlign ? .5 : 1),
                    m = {};
                return r = 0 === h.side ? r.rotation ? -8 : -r.getBBox().height : 2 === h.side ? y.y + 8 : Math.cos(r.rotation * n) * (y.y - r.getBBox(!1, 0).height / 2), a(o.y) && (r = 0 === h.side && h.horiz ? o.y + r : o.y), t = t + o.x + g + y.x - (s && i ? s * d * (f ? -1 : 1) : 0), e = e + r - (s && !i ? s * d * (f ? 1 : -1) : 0), p && (i = c / (u || 1) % p, h.opposite && (i = p - i - 1), e += h.labelOffset / p * i), m.x = t, m.y = Math.round(e), l(this, "afterGetLabelPosition", {
                  pos: m,
                  tickmarkOffset: s,
                  index: c
                }), m;
              }, g4.prototype.getLabelSize = function () {
                return this.label ? this.label.getBBox()[this.axis.horiz ? "height" : "width"] : 0;
              }, g4.prototype.getMarkPath = function (t, e, r, n, i, o) {
                return o.crispLine([["M", t, e], ["L", t + (i ? 0 : -r), e + (i ? r : 0)]], n);
              }, g4.prototype.handleOverflow = function (t) {
                var e = this.axis,
                    r = e.options.labels,
                    i = t.x,
                    o = e.chart.chartWidth,
                    a = e.chart.spacing,
                    s = f(e.labelLeft, Math.min(e.pos, a[3]));
                a = f(e.labelRight, Math.max(e.isRadial ? 0 : e.pos + e.len, o - a[1]));
                var c,
                    l = this.label,
                    u = this.rotation,
                    h = {
                  left: 0,
                  center: .5,
                  right: 1
                }[e.labelAlign || l.attr("align")],
                    d = l.getBBox().width,
                    p = e.getSlotWidth(this),
                    y = {},
                    g = p,
                    m = 1;
                u || "justify" !== r.overflow ? 0 > u && i - h * d < s ? c = Math.round(i / Math.cos(u * n) - s) : 0 < u && i + h * d > a && (c = Math.round((o - i) / Math.cos(u * n))) : (o = i + (1 - h) * d, i - h * d < s ? g = t.x + g * (1 - h) - s : o > a && (g = a - t.x + g * h, m = -1), (g = Math.min(p, g)) < p && "center" === e.labelAlign && (t.x += m * (p - g - h * (p - Math.min(d, g)))), (d > g || e.autoRotation && (l.styles || {}).width) && (c = g)), c && (this.shortenLabel ? this.shortenLabel() : (y.width = Math.floor(c) + "px", (r.style || {}).textOverflow || (y.textOverflow = "ellipsis"), l.css(y)));
              }, g4.prototype.moveLabel = function (t, e) {
                var r = this,
                    n = r.label,
                    i = r.axis,
                    o = i.reversed,
                    a = !1;

                if (n && n.textStr === t ? (r.movedLabel = n, a = !0, delete r.label) : d(i.ticks, function (e) {
                  a || e.isNew || e === r || !e.label || e.label.textStr !== t || (r.movedLabel = e.label, a = !0, e.labelPos = r.movedLabel.xy, delete e.label);
                }), !a && (r.labelPos || n)) {
                  var s = r.labelPos || n.xy;
                  n = i.horiz ? o ? 0 : i.width + i.left : s.x, i = i.horiz ? s.y : o ? i.width + i.left : 0, r.movedLabel = r.createLabel({
                    x: n,
                    y: i
                  }, t, e), r.movedLabel && r.movedLabel.attr({
                    opacity: 0
                  });
                }
              }, g4.prototype.render = function (t, e, r) {
                var n = this.axis,
                    i = n.horiz,
                    o = this.pos,
                    a = f(this.tickmarkOffset, n.tickmarkOffset);
                a = (o = this.getPosition(i, o, a, e)).x;
                var s = o.y;
                n = i && a === n.pos + n.len || !i && s === n.pos ? -1 : 1, i = f(r, this.label && this.label.newOpacity, 1), r = f(r, 1), this.isActive = !0, this.renderGridLine(e, r, n), this.renderMark(o, r, n), this.renderLabel(o, e, i, t), this.isNew = !1, l(this, "afterRender");
              }, g4.prototype.renderGridLine = function (t, e, r) {
                var n = this.axis,
                    i = n.options,
                    o = {},
                    a = this.pos,
                    s = this.type,
                    c = f(this.tickmarkOffset, n.tickmarkOffset),
                    l = n.chart.renderer,
                    u = this.gridLine,
                    h = i.gridLineWidth,
                    d = i.gridLineColor,
                    p = i.gridLineDashStyle;
                "minor" === this.type && (h = i.minorGridLineWidth, d = i.minorGridLineColor, p = i.minorGridLineDashStyle), u || (n.chart.styledMode || (o.stroke = d, o["stroke-width"] = h || 0, o.dashstyle = p), s || (o.zIndex = 1), t && (e = 0), this.gridLine = u = l.path().attr(o).addClass("highcharts-" + (s ? s + "-" : "") + "grid-line").add(n.gridGroup)), u && (r = n.getPlotLinePath({
                  value: a + c,
                  lineWidth: u.strokeWidth() * r,
                  force: "pass",
                  old: t,
                  acrossPanes: !1
                })) && u[t || this.isNew ? "attr" : "animate"]({
                  d: r,
                  opacity: e
                });
              }, g4.prototype.renderMark = function (t, e, r) {
                var n = this.axis,
                    i = n.options,
                    o = n.chart.renderer,
                    a = this.type,
                    s = n.tickSize(a ? a + "Tick" : "tick"),
                    c = t.x;
                t = t.y;
                var l = f(i["minor" !== a ? "tickWidth" : "minorTickWidth"], !a && n.isXAxis ? 1 : 0);
                i = i["minor" !== a ? "tickColor" : "minorTickColor"];
                var u = this.mark,
                    h = !u;
                s && (n.opposite && (s[0] = -s[0]), u || (this.mark = u = o.path().addClass("highcharts-" + (a ? a + "-" : "") + "tick").add(n.axisGroup), n.chart.styledMode || u.attr({
                  stroke: i,
                  "stroke-width": l
                })), u[h ? "attr" : "animate"]({
                  d: this.getMarkPath(c, t, s[0], u.strokeWidth() * r, n.horiz, o),
                  opacity: e
                }));
              }, g4.prototype.renderLabel = function (t, e, r, n) {
                var i = this.axis,
                    o = i.horiz,
                    a = i.options,
                    s = this.label,
                    c = a.labels,
                    l = c.step;
                i = f(this.tickmarkOffset, i.tickmarkOffset);
                var h = t.x;
                t = t.y;
                var d = !0;
                s && u(h) && (s.xy = t = this.getLabelPosition(h, t, s, o, c, i, n, l), this.isFirst && !this.isLast && !a.showFirstLabel || this.isLast && !this.isFirst && !a.showLastLabel ? d = !1 : !o || c.step || c.rotation || e || 0 === r || this.handleOverflow(t), l && n % l && (d = !1), d && u(t.y) ? (t.opacity = r, s[this.isNewLabel ? "attr" : "animate"](t).show(!0), this.isNewLabel = !1) : (s.hide(), this.isNewLabel = !0));
              }, g4.prototype.replaceMovedLabel = function () {
                var t = this.label,
                    e = this.axis,
                    r = e.reversed;

                if (t && !this.isNew) {
                  var n = e.horiz ? r ? e.left : e.width + e.left : t.xy.x;
                  r = e.horiz ? t.xy.y : r ? e.width + e.top : e.top, t.animate({
                    x: n,
                    y: r,
                    opacity: 0
                  }, void 0, t.destroy), delete this.label;
                }

                e.isDirty = !0, this.label = this.movedLabel, delete this.movedLabel;
              }, g4;
            }();
          }), K2(e, "Core/Axis/Axis.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Axis/AxisDefaults.js"], e["Core/Color/Color.js"], e["Core/Defaults.js"], e["Core/Foundation.js"], e["Core/Globals.js"], e["Core/Axis/Tick.js"], e["Core/Utilities.js"]], function (t, e, r, n, i, o, a, s) {
            var c = t.animObject,
                l = n.defaultOptions,
                u = i.registerEventOptions,
                h = o.deg2rad,
                d = s.arrayMax,
                f = s.arrayMin,
                p = s.clamp,
                y = s.correctFloat,
                g = s.defined,
                m = s.destroyObjectProperties,
                v = s.erase,
                b = s.error,
                x = s.extend,
                w = s.fireEvent,
                S = s.isArray,
                O = s.isNumber,
                E = s.isString,
                k = s.merge,
                _ = s.normalizeTickInterval,
                C = s.objectEach,
                T = s.pick,
                A = s.relativeLength,
                M = s.removeEvent,
                P = s.splat,
                j = s.syncTimeout,
                R = function T2(t, e) {
              return _(e, void 0, void 0, T(t.options.allowDecimals, .5 > e || void 0 !== t.tickAmount), !!t.tickAmount);
            };

            return t = function () {
              function a4(t, e) {
                this.zoomEnabled = this.width = this.visible = this.userOptions = this.translationSlope = this.transB = this.transA = this.top = this.ticks = this.tickRotCorr = this.tickPositions = this.tickmarkOffset = this.tickInterval = this.tickAmount = this.side = this.series = this.right = this.positiveValuesOnly = this.pos = this.pointRangePadding = this.pointRange = this.plotLinesAndBandsGroups = this.plotLinesAndBands = this.paddedTicks = this.overlap = this.options = this.offset = this.names = this.minPixelPadding = this.minorTicks = this.minorTickInterval = this.min = this.maxLabelLength = this.max = this.len = this.left = this.labelFormatter = this.labelEdge = this.isLinked = this.height = this.hasVisibleSeries = this.hasNames = this.eventOptions = this.coll = this.closestPointRange = this.chart = this.bottom = this.alternateBands = void 0, this.init(t, e);
              }

              return a4.prototype.init = function (t, e) {
                var r = e.isX;
                this.chart = t, this.horiz = t.inverted && !this.isZAxis ? !r : r, this.isXAxis = r, this.coll = this.coll || (r ? "xAxis" : "yAxis"), w(this, "init", {
                  userOptions: e
                }), this.opposite = T(e.opposite, this.opposite), this.side = T(e.side, this.side, this.horiz ? this.opposite ? 0 : 2 : this.opposite ? 1 : 3), this.setOptions(e);
                var n = this.options,
                    i = n.labels,
                    o = n.type;
                this.userOptions = e, this.minPixelPadding = 0, this.reversed = T(n.reversed, this.reversed), this.visible = n.visible, this.zoomEnabled = n.zoomEnabled, this.hasNames = "category" === o || !0 === n.categories, this.categories = n.categories || (this.hasNames ? [] : void 0), this.names || (this.names = [], this.names.keys = {}), this.plotLinesAndBandsGroups = {}, this.positiveValuesOnly = !!this.logarithmic, this.isLinked = g(n.linkedTo), this.ticks = {}, this.labelEdge = [], this.minorTicks = {}, this.plotLinesAndBands = [], this.alternateBands = {}, this.len = 0, this.minRange = this.userMinRange = n.minRange || n.maxZoom, this.range = n.range, this.offset = n.offset || 0, this.min = this.max = null, e = T(n.crosshair, P(t.options.tooltip.crosshairs)[r ? 0 : 1]), this.crosshair = !0 === e ? {} : e, -1 === t.axes.indexOf(this) && (r ? t.axes.splice(t.xAxis.length, 0, this) : t.axes.push(this), t[this.coll].push(this)), this.series = this.series || [], t.inverted && !this.isZAxis && r && "undefined" === typeof this.reversed && (this.reversed = !0), this.labelRotation = O(i.rotation) ? i.rotation : void 0, u(this, n), w(this, "afterInit");
              }, a4.prototype.setOptions = function (t) {
                this.options = k(e.defaultXAxisOptions, "yAxis" === this.coll && e.defaultYAxisOptions, [e.defaultTopAxisOptions, e.defaultRightAxisOptions, e.defaultBottomAxisOptions, e.defaultLeftAxisOptions][this.side], k(l[this.coll], t)), w(this, "afterSetOptions", {
                  userOptions: t
                });
              }, a4.prototype.defaultLabelFormatter = function (t) {
                var e = this.axis;
                t = this.chart.numberFormatter;
                var r = O(this.value) ? this.value : NaN,
                    n = e.chart.time,
                    i = this.dateTimeLabelFormat,
                    o = l.lang,
                    a = o.numericSymbols;
                o = o.numericSymbolMagnitude || 1e3;
                var s = e.logarithmic ? Math.abs(r) : e.tickInterval,
                    c = a && a.length;
                if (e.categories) var u = "".concat(this.value);else if (i) u = n.dateFormat(i, r);else if (c && 1e3 <= s) for (; c-- && "undefined" === typeof u;) {
                  s >= (e = Math.pow(o, c + 1)) && 10 * r % e === 0 && null !== a[c] && 0 !== r && (u = t(r / e, -1) + a[c]);
                }
                return "undefined" === typeof u && (u = 1e4 <= Math.abs(r) ? t(r, -1) : t(r, -1, void 0, "")), u;
              }, a4.prototype.getSeriesExtremes = function () {
                var t,
                    e = this,
                    r = e.chart;
                w(this, "getSeriesExtremes", null, function () {
                  e.hasVisibleSeries = !1, e.dataMin = e.dataMax = e.threshold = null, e.softThreshold = !e.isXAxis, e.series.forEach(function (n) {
                    if (n.visible || !r.options.chart.ignoreHiddenSeries) {
                      var i = n.options,
                          o = i.threshold;

                      if (e.hasVisibleSeries = !0, e.positiveValuesOnly && 0 >= o && (o = null), e.isXAxis) {
                        if ((i = n.xData).length) {
                          i = e.logarithmic ? i.filter(e.validatePositiveValue) : i;
                          var a = (t = n.getXExtremes(i)).min,
                              s = t.max;
                          O(a) || a instanceof Date || (i = i.filter(O), a = (t = n.getXExtremes(i)).min, s = t.max), i.length && (e.dataMin = Math.min(T(e.dataMin, a), a), e.dataMax = Math.max(T(e.dataMax, s), s));
                        }
                      } else n = n.applyExtremes(), O(n.dataMin) && (a = n.dataMin, e.dataMin = Math.min(T(e.dataMin, a), a)), O(n.dataMax) && (s = n.dataMax, e.dataMax = Math.max(T(e.dataMax, s), s)), g(o) && (e.threshold = o), (!i.softThreshold || e.positiveValuesOnly) && (e.softThreshold = !1);
                    }
                  });
                }), w(this, "afterGetSeriesExtremes");
              }, a4.prototype.translate = function (t, e, r, n, i, o) {
                var a = this.linkedParent || this,
                    s = n && a.old ? a.old.min : a.min;
                if (!O(s)) return NaN;
                var c = a.minPixelPadding;
                i = (a.isOrdinal || a.brokenAxis && a.brokenAxis.hasBreaks || a.logarithmic && i) && a.lin2val;
                var l = 1,
                    u = 0;
                return (n = n && a.old ? a.old.transA : a.transA) || (n = a.transA), r && (l *= -1, u = a.len), a.reversed && (u -= (l *= -1) * (a.sector || a.len)), e ? (o = (t * l + u - c) / n + s, i && (o = a.lin2val(o))) : (i && (t = a.val2lin(t)), t = l * (t - s) * n, o = (a.isRadial ? t : y(t)) + u + l * c + (O(o) ? n * o : 0)), o;
              }, a4.prototype.toPixels = function (t, e) {
                return this.translate(t, !1, !this.horiz, void 0, !0) + (e ? 0 : this.pos);
              }, a4.prototype.toValue = function (t, e) {
                return this.translate(t - (e ? 0 : this.pos), !0, !this.horiz, void 0, !0);
              }, a4.prototype.getPlotLinePath = function (t) {
                function d4(t, e, r) {
                  return "pass" !== v && (t < e || t > r) && (v ? t = p(t, e, r) : o = !0), t;
                }

                var e,
                    r,
                    n,
                    i,
                    o,
                    a = this,
                    s = a.chart,
                    c = a.left,
                    l = a.top,
                    u = t.old,
                    h = t.value,
                    d = t.lineWidth,
                    f = u && s.oldChartHeight || s.chartHeight,
                    y = u && s.oldChartWidth || s.chartWidth,
                    g = a.transB,
                    m = t.translatedValue,
                    v = t.force;
                return t = {
                  value: h,
                  lineWidth: d,
                  old: u,
                  force: v,
                  acrossPanes: t.acrossPanes,
                  translatedValue: m
                }, w(this, "getPlotLinePath", t, function (t) {
                  m = T(m, a.translate(h, void 0, void 0, u)), m = p(m, -1e5, 1e5), e = n = Math.round(m + g), r = i = Math.round(f - m - g), O(m) ? a.horiz ? (r = l, i = f - a.bottom, e = n = d4(e, c, c + a.width)) : (e = c, n = y - a.right, r = i = d4(r, l, l + a.height)) : (o = !0, v = !1), t.path = o && !v ? null : s.renderer.crispLine([["M", e, r], ["L", n, i]], d || 1);
                }), t.path;
              }, a4.prototype.getLinearTickPositions = function (t, e, r) {
                var n = y(Math.floor(e / t) * t);
                r = y(Math.ceil(r / t) * t);
                var i,
                    o = [];
                if (y(n + t) === n && (i = 20), this.single) return [e];

                for (e = n; e <= r && (o.push(e), (e = y(e + t, i)) !== a);) {
                  var a = e;
                }

                return o;
              }, a4.prototype.getMinorTickInterval = function () {
                var t = this.options;
                return !0 === t.minorTicks ? T(t.minorTickInterval, "auto") : !1 === t.minorTicks ? null : t.minorTickInterval;
              }, a4.prototype.getMinorTickPositions = function () {
                var t = this.options,
                    e = this.tickPositions,
                    r = this.minorTickInterval,
                    n = this.pointRangePadding || 0,
                    i = this.min - n,
                    o = (n = this.max + n) - i,
                    a = [];

                if (o && o / r < this.len / 3) {
                  var s = this.logarithmic;
                  if (s) this.paddedTicks.forEach(function (t, e, n) {
                    e && a.push.apply(a, s.getLogTickPositions(r, n[e - 1], n[e], !0));
                  });else if (this.dateTime && "auto" === this.getMinorTickInterval()) a = a.concat(this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(r), i, n, t.startOfWeek));else for (t = i + (e[0] - i) % r; t <= n && t !== a[0]; t += r) {
                    a.push(t);
                  }
                }

                return 0 !== a.length && this.trimTicks(a), a;
              }, a4.prototype.adjustForMinRange = function () {
                var t,
                    e,
                    r,
                    n,
                    i = this.options,
                    o = this.logarithmic,
                    a = this.min,
                    s = this.max,
                    c = 0;

                if (this.isXAxis && "undefined" === typeof this.minRange && !o && (g(i.min) || g(i.max) || g(i.floor) || g(i.ceiling) ? this.minRange = null : (this.series.forEach(function (i) {
                  if (r = i.xData, n = i.xIncrement ? 1 : r.length - 1, 1 < r.length) for (t = n; 0 < t; t--) {
                    e = r[t] - r[t - 1], (!c || e < c) && (c = e);
                  }
                }), this.minRange = Math.min(5 * c, this.dataMax - this.dataMin))), s - a < this.minRange) {
                  var l = this.dataMax - this.dataMin >= this.minRange,
                      u = this.minRange,
                      h = (u - s + a) / 2;
                  h = [a - h, T(i.min, a - h)], l && (h[2] = this.logarithmic ? this.logarithmic.log2lin(this.dataMin) : this.dataMin), s = [(a = d(h)) + u, T(i.max, a + u)], l && (s[2] = o ? o.log2lin(this.dataMax) : this.dataMax), (s = f(s)) - a < u && (h[0] = s - u, h[1] = T(i.min, s - u), a = d(h));
                }

                this.min = a, this.max = s;
              }, a4.prototype.getClosest = function () {
                var t;
                return this.categories ? t = 1 : this.series.forEach(function (e) {
                  var r = e.closestPointRange,
                      n = e.visible || !e.chart.options.chart.ignoreHiddenSeries;
                  !e.noSharedTooltip && g(r) && n && (t = g(t) ? Math.min(t, r) : r);
                }), t;
              }, a4.prototype.nameToX = function (t) {
                var e = S(this.options.categories),
                    r = e ? this.categories : this.names,
                    n = t.options.x;

                if (t.series.requireSorting = !1, g(n) || (n = this.options.uniqueNames && r ? e ? r.indexOf(t.name) : T(r.keys[t.name], -1) : t.series.autoIncrement()), -1 === n) {
                  if (!e && r) var i = r.length;
                } else i = n;

                return "undefined" !== typeof i ? (this.names[i] = t.name, this.names.keys[t.name] = i) : t.x && (i = t.x), i;
              }, a4.prototype.updateNames = function () {
                var t = this,
                    e = this.names;
                0 < e.length && (Object.keys(e.keys).forEach(function (t) {
                  delete e.keys[t];
                }), e.length = 0, this.minRange = this.userMinRange, (this.series || []).forEach(function (e) {
                  e.xIncrement = null, e.points && !e.isDirtyData || (t.max = Math.max(t.max, e.xData.length - 1), e.processData(), e.generatePoints()), e.data.forEach(function (r, n) {
                    if (r && r.options && "undefined" !== typeof r.name) {
                      var i = t.nameToX(r);
                      "undefined" !== typeof i && i !== r.x && (r.x = i, e.xData[n] = i);
                    }
                  });
                }));
              }, a4.prototype.setAxisTranslation = function () {
                var t = this,
                    e = t.max - t.min,
                    r = t.linkedParent,
                    n = !!t.categories,
                    i = t.isXAxis,
                    o = t.axisPointRange || 0,
                    a = 0,
                    s = 0,
                    c = t.transA;

                if (i || n || o) {
                  var l = t.getClosest();
                  r ? (a = r.minPointOffset, s = r.pointRangePadding) : t.series.forEach(function (e) {
                    var r = n ? 1 : i ? T(e.options.pointRange, l, 0) : t.axisPointRange || 0,
                        c = e.options.pointPlacement;
                    o = Math.max(o, r), t.single && !n || (e = e.is("xrange") ? !i : i, a = Math.max(a, e && E(c) ? 0 : r / 2), s = Math.max(s, e && "on" === c ? 0 : r));
                  }), r = t.ordinal && t.ordinal.slope && l ? t.ordinal.slope / l : 1, t.minPointOffset = a *= r, t.pointRangePadding = s *= r, t.pointRange = Math.min(o, t.single && n ? 1 : e), i && (t.closestPointRange = l);
                }

                t.translationSlope = t.transA = c = t.staticScale || t.len / (e + s || 1), t.transB = t.horiz ? t.left : t.bottom, t.minPixelPadding = c * a, w(this, "afterSetAxisTranslation");
              }, a4.prototype.minFromRange = function () {
                return this.max - this.range;
              }, a4.prototype.setTickInterval = function (t) {
                var e = this.chart,
                    r = this.logarithmic,
                    n = this.options,
                    i = this.isXAxis,
                    o = this.isLinked,
                    a = n.tickPixelInterval,
                    s = this.categories,
                    c = this.softThreshold,
                    l = n.maxPadding,
                    u = n.minPadding,
                    h = O(n.tickInterval) && 0 <= n.tickInterval ? n.tickInterval : void 0,
                    d = O(this.threshold) ? this.threshold : null;
                this.dateTime || s || o || this.getTickAmount();
                var f = T(this.userMin, n.min),
                    p = T(this.userMax, n.max);

                if (o) {
                  this.linkedParent = e[this.coll][n.linkedTo];
                  var m = this.linkedParent.getExtremes();
                  this.min = T(m.min, m.dataMin), this.max = T(m.max, m.dataMax), n.type !== this.linkedParent.options.type && b(11, 1, e);
                } else {
                  if (c && g(d)) if (this.dataMin >= d) m = d, u = 0;else if (this.dataMax <= d) {
                    var v = d;
                    l = 0;
                  }
                  this.min = T(f, m, this.dataMin), this.max = T(p, v, this.dataMax);
                }

                if (r && (this.positiveValuesOnly && !t && 0 >= Math.min(this.min, T(this.dataMin, this.min)) && b(10, 1, e), this.min = y(r.log2lin(this.min), 16), this.max = y(r.log2lin(this.max), 16)), this.range && g(this.max) && (this.userMin = this.min = f = Math.max(this.dataMin, this.minFromRange()), this.userMax = p = this.max, this.range = null), w(this, "foundExtremes"), this.beforePadding && this.beforePadding(), this.adjustForMinRange(), !(s || this.axisPointRange || this.stacking && this.stacking.usePercentage || o) && g(this.min) && g(this.max) && (e = this.max - this.min) && (!g(f) && u && (this.min -= e * u), !g(p) && l && (this.max += e * l)), O(this.userMin) || (O(n.softMin) && n.softMin < this.min && (this.min = f = n.softMin), O(n.floor) && (this.min = Math.max(this.min, n.floor))), O(this.userMax) || (O(n.softMax) && n.softMax > this.max && (this.max = p = n.softMax), O(n.ceiling) && (this.max = Math.min(this.max, n.ceiling))), c && g(this.dataMin) && (d = d || 0, !g(f) && this.min < d && this.dataMin >= d ? this.min = this.options.minRange ? Math.min(d, this.max - this.minRange) : d : !g(p) && this.max > d && this.dataMax <= d && (this.max = this.options.minRange ? Math.max(d, this.min + this.minRange) : d)), O(this.min) && O(this.max) && !this.chart.polar && this.min > this.max && (g(this.options.min) ? this.max = this.min : g(this.options.max) && (this.min = this.max)), this.tickInterval = this.min === this.max || "undefined" === typeof this.min || "undefined" === typeof this.max ? 1 : o && this.linkedParent && !h && a === this.linkedParent.options.tickPixelInterval ? h = this.linkedParent.tickInterval : T(h, this.tickAmount ? (this.max - this.min) / Math.max(this.tickAmount - 1, 1) : void 0, s ? 1 : (this.max - this.min) * a / Math.max(this.len, a)), i && !t) {
                  var x = this.min !== (this.old && this.old.min) || this.max !== (this.old && this.old.max);
                  this.series.forEach(function (t) {
                    t.forceCrop = t.forceCropping && t.forceCropping(), t.processData(x);
                  }), w(this, "postProcessData", {
                    hasExtremesChanged: x
                  });
                }

                this.setAxisTranslation(), w(this, "initialAxisTranslation"), this.pointRange && !h && (this.tickInterval = Math.max(this.pointRange, this.tickInterval)), t = T(n.minTickInterval, this.dateTime && !this.series.some(function (t) {
                  return t.noSharedTooltip;
                }) ? this.closestPointRange : 0), !h && this.tickInterval < t && (this.tickInterval = t), this.dateTime || this.logarithmic || h || (this.tickInterval = R(this, this.tickInterval)), this.tickAmount || (this.tickInterval = this.unsquish()), this.setTickPositions();
              }, a4.prototype.setTickPositions = function () {
                var t,
                    e = this.options,
                    r = e.tickPositions,
                    n = e.tickPositioner,
                    i = this.getMinorTickInterval(),
                    o = this.hasVerticalPanning(),
                    a = "colorAxis" === this.coll,
                    s = (a || !o) && e.startOnTick;
                if (o = (a || !o) && e.endOnTick, a = [], this.tickmarkOffset = this.categories && "between" === e.tickmarkPlacement && 1 === this.tickInterval ? .5 : 0, this.minorTickInterval = "auto" === i && this.tickInterval ? this.tickInterval / 5 : i, this.single = this.min === this.max && g(this.min) && !this.tickAmount && (parseInt(this.min, 10) === this.min || !1 !== e.allowDecimals), r) a = r.slice();else if (O(this.min) && O(this.max)) {
                  if (this.ordinal && this.ordinal.positions || !((this.max - this.min) / this.tickInterval > Math.max(2 * this.len, 200))) {
                    if (this.dateTime) a = this.getTimeTicks(this.dateTime.normalizeTimeTickInterval(this.tickInterval, e.units), this.min, this.max, e.startOfWeek, this.ordinal && this.ordinal.positions, this.closestPointRange, !0);else if (this.logarithmic) a = this.logarithmic.getLogTickPositions(this.tickInterval, this.min, this.max);else for (i = e = this.tickInterval; i <= 2 * e && (a = this.getLinearTickPositions(this.tickInterval, this.min, this.max), this.tickAmount && a.length > this.tickAmount);) {
                      this.tickInterval = R(this, i *= 1.1);
                    }
                  } else a = [this.min, this.max], b(19, !1, this.chart);
                  a.length > this.len && (a = [a[0], a[a.length - 1]])[0] === a[1] && (a.length = 1), n && (this.tickPositions = a, (t = n.apply(this, [this.min, this.max])) && (a = t));
                }
                this.tickPositions = a, this.paddedTicks = a.slice(0), this.trimTicks(a, s, o), !this.isLinked && O(this.min) && O(this.max) && (this.single && 2 > a.length && !this.categories && !this.series.some(function (t) {
                  return t.is("heatmap") && "between" === t.options.pointPlacement;
                }) && (this.min -= .5, this.max += .5), r || t || this.adjustTickAmount()), w(this, "afterSetTickPositions");
              }, a4.prototype.trimTicks = function (t, e, r) {
                var n = t[0],
                    i = t[t.length - 1],
                    o = !this.isOrdinal && this.minPointOffset || 0;

                if (w(this, "trimTicks"), !this.isLinked) {
                  if (e && n !== -1 / 0) this.min = n;else for (; this.min - o > t[0];) {
                    t.shift();
                  }
                  if (r) this.max = i;else for (; this.max + o < t[t.length - 1];) {
                    t.pop();
                  }
                  0 === t.length && g(n) && !this.options.tickPositions && t.push((i + n) / 2);
                }
              }, a4.prototype.alignToOthers = function () {
                var t,
                    e = this,
                    r = [this],
                    n = e.options,
                    i = "yAxis" === this.coll && this.chart.options.chart.alignThresholds,
                    o = [];

                if (e.thresholdAlignment = void 0, (!1 !== this.chart.options.chart.alignTicks && n.alignTicks || i) && !1 !== n.startOnTick && !1 !== n.endOnTick && !e.logarithmic) {
                  var a = function n3(t) {
                    var e = t.options;
                    return [t.horiz ? e.left : e.top, e.width, e.height, e.pane].join();
                  },
                      s = a(this);

                  this.chart[this.coll].forEach(function (n) {
                    var i = n.series;
                    i.length && i.some(function (t) {
                      return t.visible;
                    }) && n !== e && a(n) === s && (t = !0, r.push(n));
                  });
                }

                if (t && i) {
                  r.forEach(function (t) {
                    t = t.getThresholdAlignment(e), O(t) && o.push(t);
                  });
                  var c = 1 < o.length ? o.reduce(function (t, e) {
                    return t + e;
                  }, 0) / o.length : void 0;
                  r.forEach(function (t) {
                    t.thresholdAlignment = c;
                  });
                }

                return t;
              }, a4.prototype.getThresholdAlignment = function (t) {
                if ((!O(this.dataMin) || this !== t && this.series.some(function (t) {
                  return t.isDirty || t.isDirtyData;
                })) && this.getSeriesExtremes(), O(this.threshold)) return t = p((this.threshold - (this.dataMin || 0)) / ((this.dataMax || 0) - (this.dataMin || 0)), 0, 1), this.options.reversed && (t = 1 - t), t;
              }, a4.prototype.getTickAmount = function () {
                var t = this.options,
                    e = t.tickPixelInterval,
                    r = t.tickAmount;
                !g(t.tickInterval) && !r && this.len < e && !this.isRadial && !this.logarithmic && t.startOnTick && t.endOnTick && (r = 2), !r && this.alignToOthers() && (r = Math.ceil(this.len / e) + 1), 4 > r && (this.finalTickAmt = r, r = 5), this.tickAmount = r;
              }, a4.prototype.adjustTickAmount = function () {
                var t = this,
                    e = t.finalTickAmt,
                    r = t.max,
                    n = t.min,
                    i = t.options,
                    o = t.tickPositions,
                    a = t.tickAmount,
                    s = t.thresholdAlignment,
                    c = o && o.length,
                    l = T(t.threshold, t.softThreshold ? 0 : null),
                    u = t.tickInterval;

                if (O(s)) {
                  var h = .5 > s ? Math.ceil(s * (a - 1)) : Math.floor(s * (a - 1));
                  i.reversed && (h = a - 1 - h);
                }

                if (t.hasData() && O(n) && O(r)) {
                  if (s = function u4() {
                    t.transA *= (c - 1) / (a - 1), t.min = i.startOnTick ? o[0] : Math.min(n, o[0]), t.max = i.endOnTick ? o[o.length - 1] : Math.max(r, o[o.length - 1]);
                  }, O(h) && O(t.threshold)) {
                    for (; o[h] !== l || o.length !== a || o[0] > n || o[o.length - 1] < r;) {
                      for (o.length = 0, o.push(t.threshold); o.length < a;) {
                        void 0 === o[h] || o[h] > t.threshold ? o.unshift(y(o[0] - u)) : o.push(y(o[o.length - 1] + u));
                      }

                      if (u > 8 * t.tickInterval) break;
                      u *= 2;
                    }

                    s();
                  } else if (c < a) {
                    for (; o.length < a;) {
                      o.length % 2 || n === l ? o.push(y(o[o.length - 1] + u)) : o.unshift(y(o[0] - u));
                    }

                    s();
                  }

                  if (g(e)) {
                    for (u = l = o.length; u--;) {
                      (3 === e && u % 2 === 1 || 2 >= e && 0 < u && u < l - 1) && o.splice(u, 1);
                    }

                    t.finalTickAmt = void 0;
                  }
                }
              }, a4.prototype.setScale = function () {
                var t = !1,
                    e = !1;
                this.series.forEach(function (r) {
                  t = t || r.isDirtyData || r.isDirty, e = e || r.xAxis && r.xAxis.isDirty || !1;
                }), this.setAxisSize();
                var r = this.len !== (this.old && this.old.len);
                r || t || e || this.isLinked || this.forceRedraw || this.userMin !== (this.old && this.old.userMin) || this.userMax !== (this.old && this.old.userMax) || this.alignToOthers() ? (this.stacking && (this.stacking.resetStacks(), this.stacking.buildStacks()), this.forceRedraw = !1, this.getSeriesExtremes(), this.setTickInterval(), this.isDirty || (this.isDirty = r || this.min !== (this.old && this.old.min) || this.max !== (this.old && this.old.max))) : this.stacking && this.stacking.cleanStacks(), t && this.panningState && (this.panningState.isDirty = !0), w(this, "afterSetScale");
              }, a4.prototype.setExtremes = function (t, e, r, n, i) {
                var o = this,
                    a = o.chart;
                r = T(r, !0), o.series.forEach(function (t) {
                  delete t.kdTree;
                }), i = x(i, {
                  min: t,
                  max: e
                }), w(o, "setExtremes", i, function () {
                  o.userMin = t, o.userMax = e, o.eventArgs = i, r && a.redraw(n);
                });
              }, a4.prototype.zoom = function (t, e) {
                var r = this,
                    n = this.dataMin,
                    i = this.dataMax,
                    o = this.options,
                    a = Math.min(n, T(o.min, n)),
                    s = Math.max(i, T(o.max, i));
                return w(this, "zoom", t = {
                  newMin: t,
                  newMax: e
                }, function (t) {
                  var e = t.newMin,
                      o = t.newMax;
                  e === r.min && o === r.max || (r.allowZoomOutside || (g(n) && (e < a && (e = a), e > s && (e = s)), g(i) && (o < a && (o = a), o > s && (o = s))), r.displayBtn = "undefined" !== typeof e || "undefined" !== typeof o, r.setExtremes(e, o, !1, void 0, {
                    trigger: "zoom"
                  })), t.zoomed = !0;
                }), t.zoomed;
              }, a4.prototype.setAxisSize = function () {
                var t = this.chart,
                    e = this.options,
                    r = e.offsets || [0, 0, 0, 0],
                    n = this.horiz,
                    i = this.width = Math.round(A(T(e.width, t.plotWidth - r[3] + r[1]), t.plotWidth)),
                    o = this.height = Math.round(A(T(e.height, t.plotHeight - r[0] + r[2]), t.plotHeight)),
                    a = this.top = Math.round(A(T(e.top, t.plotTop + r[0]), t.plotHeight, t.plotTop));
                e = this.left = Math.round(A(T(e.left, t.plotLeft + r[3]), t.plotWidth, t.plotLeft)), this.bottom = t.chartHeight - o - a, this.right = t.chartWidth - i - e, this.len = Math.max(n ? i : o, 0), this.pos = n ? e : a;
              }, a4.prototype.getExtremes = function () {
                var t = this.logarithmic;
                return {
                  min: t ? y(t.lin2log(this.min)) : this.min,
                  max: t ? y(t.lin2log(this.max)) : this.max,
                  dataMin: this.dataMin,
                  dataMax: this.dataMax,
                  userMin: this.userMin,
                  userMax: this.userMax
                };
              }, a4.prototype.getThreshold = function (t) {
                var e = this.logarithmic,
                    r = e ? e.lin2log(this.min) : this.min;
                return e = e ? e.lin2log(this.max) : this.max, null === t || t === -1 / 0 ? t = r : t === 1 / 0 ? t = e : r > t ? t = r : e < t && (t = e), this.translate(t, 0, 1, 0, 1);
              }, a4.prototype.autoLabelAlign = function (t) {
                var e = (T(t, 0) - 90 * this.side + 720) % 360;
                return w(this, "autoLabelAlign", t = {
                  align: "center"
                }, function (t) {
                  15 < e && 165 > e ? t.align = "right" : 195 < e && 345 > e && (t.align = "left");
                }), t.align;
              }, a4.prototype.tickSize = function (t) {
                var e = this.options,
                    r = T(e["tick" === t ? "tickWidth" : "minorTickWidth"], "tick" === t && this.isXAxis && !this.categories ? 1 : 0),
                    n = e["tick" === t ? "tickLength" : "minorTickLength"];

                if (r && n) {
                  "inside" === e[t + "Position"] && (n = -n);
                  var i = [n, r];
                }

                return w(this, "afterTickSize", t = {
                  tickSize: i
                }), t.tickSize;
              }, a4.prototype.labelMetrics = function () {
                var t = this.tickPositions && this.tickPositions[0] || 0;
                return this.chart.renderer.fontMetrics(this.options.labels.style.fontSize, this.ticks[t] && this.ticks[t].label);
              }, a4.prototype.unsquish = function () {
                var t = this.options.labels,
                    e = this.horiz,
                    r = this.tickInterval,
                    n = this.len / (((this.categories ? 1 : 0) + this.max - this.min) / r),
                    i = t.rotation,
                    o = this.labelMetrics(),
                    a = Math.max(this.max - this.min, 0),
                    s = function g4(t) {
                  var e = t / (n || 1);
                  return (e = 1 < e ? Math.ceil(e) : 1) * r > a && t !== 1 / 0 && n !== 1 / 0 && a && (e = Math.ceil(a / r)), y(e * r);
                },
                    c = r,
                    l = Number.MAX_VALUE;

                if (e) {
                  if (!t.staggerLines) if (O(i)) var u = [i];else n < t.autoRotationLimit && (u = t.autoRotation);
                  if (u) for (var d = e = void 0, f = 0, p = u; f < p.length; f++) {
                    var g = p[f];

                    if ((g === i || g && -90 <= g && 90 >= g) && (d = (e = s(Math.abs(o.h / Math.sin(h * g)))) + Math.abs(g / 360)) < l) {
                      l = d;
                      var m = g;
                      c = e;
                    }
                  }
                } else c = s(o.h);

                return this.autoRotation = u, this.labelRotation = T(m, O(i) ? i : 0), t.step ? r : c;
              }, a4.prototype.getSlotWidth = function (t) {
                var e = this.chart,
                    r = this.horiz,
                    n = this.options.labels,
                    i = Math.max(this.tickPositions.length - (this.categories ? 0 : 1), 1),
                    o = e.margin[3];
                if (t && O(t.slotWidth)) return t.slotWidth;
                if (r && 2 > n.step) return n.rotation ? 0 : (this.staggerLines || 1) * this.len / i;

                if (!r) {
                  if (void 0 !== (t = n.style.width)) return parseInt(String(t), 10);
                  if (o) return o - e.spacing[3];
                }

                return .33 * e.chartWidth;
              }, a4.prototype.renderUnsquish = function () {
                var t = this.chart,
                    e = t.renderer,
                    r = this.tickPositions,
                    n = this.ticks,
                    i = this.options.labels,
                    o = i.style,
                    a = this.horiz,
                    s = this.getSlotWidth(),
                    c = Math.max(1, Math.round(s - 2 * i.padding)),
                    l = {},
                    u = this.labelMetrics(),
                    h = o.textOverflow,
                    d = 0;
                if (E(i.rotation) || (l.rotation = i.rotation || 0), r.forEach(function (t) {
                  (t = n[t]).movedLabel && t.replaceMovedLabel(), t && t.label && t.label.textPxLength > d && (d = t.label.textPxLength);
                }), this.maxLabelLength = d, this.autoRotation) d > c && d > u.h ? l.rotation = this.labelRotation : this.labelRotation = 0;else if (s) {
                  var f = c;

                  if (!h) {
                    var p = "clip";

                    for (c = r.length; !a && c--;) {
                      var y = r[c];
                      (y = n[y].label) && (y.styles && "ellipsis" === y.styles.textOverflow ? y.css({
                        textOverflow: "clip"
                      }) : y.textPxLength > s && y.css({
                        width: s + "px"
                      }), y.getBBox().height > this.len / r.length - (u.h - u.f) && (y.specificTextOverflow = "ellipsis"));
                    }
                  }
                }
                l.rotation && (f = d > .5 * t.chartHeight ? .33 * t.chartHeight : d, h || (p = "ellipsis")), (this.labelAlign = i.align || this.autoLabelAlign(this.labelRotation)) && (l.align = this.labelAlign), r.forEach(function (t) {
                  var e = (t = n[t]) && t.label,
                      r = o.width,
                      i = {};
                  e && (e.attr(l), t.shortenLabel ? t.shortenLabel() : f && !r && "nowrap" !== o.whiteSpace && (f < e.textPxLength || "SPAN" === e.element.tagName) ? (i.width = f + "px", h || (i.textOverflow = e.specificTextOverflow || p), e.css(i)) : e.styles && e.styles.width && !i.width && !r && e.css({
                    width: null
                  }), delete e.specificTextOverflow, t.rotation = l.rotation);
                }, this), this.tickRotCorr = e.rotCorr(u.b, this.labelRotation || 0, 0 !== this.side);
              }, a4.prototype.hasData = function () {
                return this.series.some(function (t) {
                  return t.hasData();
                }) || this.options.showEmpty && g(this.min) && g(this.max);
              }, a4.prototype.addTitle = function (t) {
                var e,
                    r = this.chart.renderer,
                    n = this.horiz,
                    i = this.opposite,
                    o = this.options.title,
                    a = this.chart.styledMode;
                this.axisTitle || ((e = o.textAlign) || (e = (n ? {
                  low: "left",
                  middle: "center",
                  high: "right"
                } : {
                  low: i ? "right" : "left",
                  middle: "center",
                  high: i ? "left" : "right"
                })[o.align]), this.axisTitle = r.text(o.text || "", 0, 0, o.useHTML).attr({
                  zIndex: 7,
                  rotation: o.rotation,
                  align: e
                }).addClass("highcharts-axis-title"), a || this.axisTitle.css(k(o.style)), this.axisTitle.add(this.axisGroup), this.axisTitle.isNew = !0), a || o.style.width || this.isRadial || this.axisTitle.css({
                  width: this.len + "px"
                }), this.axisTitle[t ? "show" : "hide"](t);
              }, a4.prototype.generateTick = function (t) {
                var e = this.ticks;
                e[t] ? e[t].addLabel() : e[t] = new a(this, t);
              }, a4.prototype.getOffset = function () {
                var t = this,
                    e = this,
                    r = e.chart,
                    n = e.horiz,
                    i = e.options,
                    o = e.side,
                    a = e.ticks,
                    s = e.tickPositions,
                    c = e.coll,
                    l = e.axisParent,
                    u = r.renderer,
                    h = r.inverted && !e.isZAxis ? [1, 0, 3, 2][o] : o,
                    d = e.hasData(),
                    f = i.title,
                    p = i.labels,
                    y = r.axisOffset;
                r = r.clipOffset;
                var m,
                    v = [-1, 1, 1, -1][o],
                    b = i.className,
                    x = 0,
                    S = 0,
                    O = 0;

                if (e.showAxis = m = d || i.showEmpty, e.staggerLines = e.horiz && p.staggerLines || void 0, !e.axisGroup) {
                  var E = function I3(e, r, n) {
                    return u.g(e).attr({
                      zIndex: n
                    }).addClass("highcharts-".concat(c.toLowerCase()).concat(r, " ") + (t.isRadial ? "highcharts-radial-axis".concat(r, " ") : "") + (b || "")).add(l);
                  };

                  e.gridGroup = E("grid", "-grid", i.gridZIndex), e.axisGroup = E("axis", "", i.zIndex), e.labelGroup = E("axis-labels", "-labels", p.zIndex);
                }

                if (d || e.isLinked ? (s.forEach(function (t) {
                  e.generateTick(t);
                }), e.renderUnsquish(), e.reserveSpaceDefault = 0 === o || 2 === o || {
                  1: "left",
                  3: "right"
                }[o] === e.labelAlign, T(p.reserveSpace, "center" === e.labelAlign || null, e.reserveSpaceDefault) && s.forEach(function (t) {
                  O = Math.max(a[t].getLabelSize(), O);
                }), e.staggerLines && (O *= e.staggerLines), e.labelOffset = O * (e.opposite ? -1 : 1)) : C(a, function (t, e) {
                  t.destroy(), delete a[e];
                }), f && f.text && !1 !== f.enabled && (e.addTitle(m), m && !1 !== f.reserveSpace)) {
                  e.titleOffset = x = e.axisTitle.getBBox()[n ? "height" : "width"];
                  var k = f.offset;
                  S = g(k) ? 0 : T(f.margin, n ? 5 : 10);
                }

                e.renderLine(), e.offset = v * T(i.offset, y[o] ? y[o] + (i.margin || 0) : 0), e.tickRotCorr = e.tickRotCorr || {
                  x: 0,
                  y: 0
                }, f = 0 === o ? -e.labelMetrics().h : 2 === o ? e.tickRotCorr.y : 0, d = Math.abs(O) + S, O && (d = d - f + v * (n ? T(p.y, e.tickRotCorr.y + 8 * v) : p.x)), e.axisTitleMargin = T(k, d), e.getMaxLabelDimensions && (e.maxLabelDimensions = e.getMaxLabelDimensions(a, s)), "colorAxis" !== c && (n = this.tickSize("tick"), y[o] = Math.max(y[o], (e.axisTitleMargin || 0) + x + v * e.offset, d, s && s.length && n ? n[0] + v * e.offset : 0), i = !e.axisLine || i.offset ? 0 : 2 * Math.floor(e.axisLine.strokeWidth() / 2), r[h] = Math.max(r[h], i)), w(this, "afterGetOffset");
              }, a4.prototype.getLinePath = function (t) {
                var e = this.chart,
                    r = this.opposite,
                    n = this.offset,
                    i = this.horiz,
                    o = this.left + (r ? this.width : 0) + n;
                return n = e.chartHeight - this.bottom - (r ? this.height : 0) + n, r && (t *= -1), e.renderer.crispLine([["M", i ? this.left : o, i ? n : this.top], ["L", i ? e.chartWidth - this.right : o, i ? n : e.chartHeight - this.bottom]], t);
              }, a4.prototype.renderLine = function () {
                this.axisLine || (this.axisLine = this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup), this.chart.styledMode || this.axisLine.attr({
                  stroke: this.options.lineColor,
                  "stroke-width": this.options.lineWidth,
                  zIndex: 7
                }));
              }, a4.prototype.getTitlePosition = function () {
                var t = this.horiz,
                    e = this.left,
                    r = this.top,
                    n = this.len,
                    i = this.options.title,
                    o = t ? e : r,
                    a = this.opposite,
                    s = this.offset,
                    c = i.x,
                    l = i.y,
                    u = this.axisTitle,
                    h = this.chart.renderer.fontMetrics(i.style.fontSize, u);
                return u = u ? Math.max(u.getBBox(!1, 0).height - h.h - 1, 0) : 0, n = {
                  low: o + (t ? 0 : n),
                  middle: o + n / 2,
                  high: o + (t ? n : 0)
                }[i.align], e = (t ? r + this.height : e) + (t ? 1 : -1) * (a ? -1 : 1) * (this.axisTitleMargin || 0) + [-u, u, h.f, -u][this.side], t = {
                  x: t ? n + c : e + (a ? this.width : 0) + s + c,
                  y: t ? e + l - (a ? this.height : 0) + s : n + l
                }, w(this, "afterGetTitlePosition", {
                  titlePosition: t
                }), t;
              }, a4.prototype.renderMinorTick = function (t, e) {
                var r = this.minorTicks;
                r[t] || (r[t] = new a(this, t, "minor")), e && r[t].isNew && r[t].render(null, !0), r[t].render(null, !1, 1);
              }, a4.prototype.renderTick = function (t, e, r) {
                var n = this.ticks;
                (!this.isLinked || t >= this.min && t <= this.max || this.grid && this.grid.isColumn) && (n[t] || (n[t] = new a(this, t)), r && n[t].isNew && n[t].render(e, !0, -1), n[t].render(e));
              }, a4.prototype.render = function () {
                var t,
                    e,
                    r = this,
                    n = r.chart,
                    i = r.logarithmic,
                    s = r.options,
                    l = r.isLinked,
                    u = r.tickPositions,
                    h = r.axisTitle,
                    d = r.ticks,
                    f = r.minorTicks,
                    p = r.alternateBands,
                    y = s.stackLabels,
                    g = s.alternateGridColor,
                    m = r.tickmarkOffset,
                    v = r.axisLine,
                    b = r.showAxis,
                    x = c(n.renderer.globalAnimation);

                if (r.labelEdge.length = 0, r.overlap = !1, [d, f, p].forEach(function (t) {
                  C(t, function (t) {
                    t.isActive = !1;
                  });
                }), r.hasData() || l) {
                  var S = r.chart.hasRendered && r.old && O(r.old.min);
                  r.minorTickInterval && !r.categories && r.getMinorTickPositions().forEach(function (t) {
                    r.renderMinorTick(t, S);
                  }), u.length && (u.forEach(function (t, e) {
                    r.renderTick(t, e, S);
                  }), m && (0 === r.min || r.single) && (d[-1] || (d[-1] = new a(r, -1, null, !0)), d[-1].render(-1))), g && u.forEach(function (a, s) {
                    e = "undefined" !== typeof u[s + 1] ? u[s + 1] + m : r.max - m, s % 2 === 0 && a < r.max && e <= r.max + (n.polar ? -m : m) && (p[a] || (p[a] = new o.PlotLineOrBand(r)), t = a + m, p[a].options = {
                      from: i ? i.lin2log(t) : t,
                      to: i ? i.lin2log(e) : e,
                      color: g,
                      className: "highcharts-alternate-grid"
                    }, p[a].render(), p[a].isActive = !0);
                  }), r._addedPlotLB || (r._addedPlotLB = !0, (s.plotLines || []).concat(s.plotBands || []).forEach(function (t) {
                    r.addPlotBandOrLine(t);
                  }));
                }

                [d, f, p].forEach(function (t) {
                  var e = [],
                      r = x.duration;
                  C(t, function (t, r) {
                    t.isActive || (t.render(r, !1, 0), t.isActive = !1, e.push(r));
                  }), j(function () {
                    for (var r = e.length; r--;) {
                      t[e[r]] && !t[e[r]].isActive && (t[e[r]].destroy(), delete t[e[r]]);
                    }
                  }, t !== p && n.hasRendered && r ? r : 0);
                }), v && (v[v.isPlaced ? "animate" : "attr"]({
                  d: this.getLinePath(v.strokeWidth())
                }), v.isPlaced = !0, v[b ? "show" : "hide"](b)), h && b && (s = r.getTitlePosition(), h[h.isNew ? "attr" : "animate"](s), h.isNew = !1), y && y.enabled && r.stacking && r.stacking.renderStackTotals(), r.old = {
                  len: r.len,
                  max: r.max,
                  min: r.min,
                  transA: r.transA,
                  userMax: r.userMax,
                  userMin: r.userMin
                }, r.isDirty = !1, w(this, "afterRender");
              }, a4.prototype.redraw = function () {
                this.visible && (this.render(), this.plotLinesAndBands.forEach(function (t) {
                  t.render();
                })), this.series.forEach(function (t) {
                  t.isDirty = !0;
                });
              }, a4.prototype.getKeepProps = function () {
                return this.keepProps || a4.keepProps;
              }, a4.prototype.destroy = function (t) {
                var e = this,
                    r = e.plotLinesAndBands,
                    n = this.eventOptions;
                if (w(this, "destroy", {
                  keepEvents: t
                }), t || M(e), [e.ticks, e.minorTicks, e.alternateBands].forEach(function (t) {
                  m(t);
                }), r) for (t = r.length; t--;) {
                  r[t].destroy();
                }

                for (var i in "axisLine axisTitle axisGroup gridGroup labelGroup cross scrollbar".split(" ").forEach(function (t) {
                  e[t] && (e[t] = e[t].destroy());
                }), e.plotLinesAndBandsGroups) {
                  e.plotLinesAndBandsGroups[i] = e.plotLinesAndBandsGroups[i].destroy();
                }

                C(e, function (t, r) {
                  -1 === e.getKeepProps().indexOf(r) && delete e[r];
                }), this.eventOptions = n;
              }, a4.prototype.drawCrosshair = function (t, e) {
                var n,
                    i = this.crosshair,
                    o = T(i && i.snap, !0),
                    a = this.chart,
                    s = this.cross;

                if (w(this, "drawCrosshair", {
                  e: t,
                  point: e
                }), t || (t = this.cross && this.cross.e), i && !1 !== (g(e) || !o)) {
                  if (o ? g(e) && (n = T("colorAxis" !== this.coll ? e.crosshairPos : null, this.isXAxis ? e.plotX : this.len - e.plotY)) : n = t && (this.horiz ? t.chartX - this.pos : this.len - t.chartY + this.pos), g(n)) {
                    var c = {
                      value: e && (this.isXAxis ? e.x : T(e.stackY, e.y)),
                      translatedValue: n
                    };
                    a.polar && x(c, {
                      isCrosshair: !0,
                      chartX: t && t.chartX,
                      chartY: t && t.chartY,
                      point: e
                    }), c = this.getPlotLinePath(c) || null;
                  }

                  if (!g(c)) return void this.hideCrosshair();
                  o = this.categories && !this.isRadial, s || (this.cross = s = a.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-" + (o ? "category " : "thin ") + (i.className || "")).attr({
                    zIndex: T(i.zIndex, 2)
                  }).add(), a.styledMode || (s.attr({
                    stroke: i.color || (o ? r.parse("#ccd6eb").setOpacity(.25).get() : "#cccccc"),
                    "stroke-width": T(i.width, 1)
                  }).css({
                    "pointer-events": "none"
                  }), i.dashStyle && s.attr({
                    dashstyle: i.dashStyle
                  }))), s.show().attr({
                    d: c
                  }), o && !i.width && s.attr({
                    "stroke-width": this.transA
                  }), this.cross.e = t;
                } else this.hideCrosshair();

                w(this, "afterDrawCrosshair", {
                  e: t,
                  point: e
                });
              }, a4.prototype.hideCrosshair = function () {
                this.cross && this.cross.hide(), w(this, "afterHideCrosshair");
              }, a4.prototype.hasVerticalPanning = function () {
                var t = this.chart.options.chart.panning;
                return !!(t && t.enabled && /y/.test(t.type));
              }, a4.prototype.validatePositiveValue = function (t) {
                return O(t) && 0 < t;
              }, a4.prototype.update = function (t, e) {
                var r = this.chart;
                t = k(this.userOptions, t), this.destroy(!0), this.init(r, t), r.isDirtyBox = !0, T(e, !0) && r.redraw();
              }, a4.prototype.remove = function (t) {
                for (var e = this.chart, r = this.coll, n = this.series, i = n.length; i--;) {
                  n[i] && n[i].remove(!1);
                }

                v(e.axes, this), v(e[r], this), e[r].forEach(function (t, e) {
                  t.options.index = t.userOptions.index = e;
                }), this.destroy(), e.isDirtyBox = !0, T(t, !0) && e.redraw();
              }, a4.prototype.setTitle = function (t, e) {
                this.update({
                  title: t
                }, e);
              }, a4.prototype.setCategories = function (t, e) {
                this.update({
                  categories: t
                }, e);
              }, a4.defaultOptions = e.defaultXAxisOptions, a4.keepProps = "extKey hcEvents names series userMax userMin".split(" "), a4;
            }();
          }), K2(e, "Core/Axis/DateTimeAxis.js", [e["Core/Utilities.js"]], function (t) {
            var e,
                r = t.addEvent,
                n = t.getMagnitude,
                i = t.normalizeTickInterval,
                o = t.timeUnits;
            return function (t) {
              function t3() {
                return this.chart.time.getTimeTicks.apply(this.chart.time, arguments);
              }

              function r2(t) {
                "datetime" !== t.userOptions.type ? this.dateTime = void 0 : this.dateTime || (this.dateTime = new a(this));
              }

              var e = [];

              t.compose = function (t) {
                return -1 === e.indexOf(t) && (e.push(t), t.keepProps.push("dateTime"), t.prototype.getTimeTicks = t3, r(t, "init", r2)), t;
              };

              var a = function () {
                function d3(t) {
                  this.axis = t;
                }

                return d3.prototype.normalizeTimeTickInterval = function (t, e) {
                  var r = e || [["millisecond", [1, 2, 5, 10, 20, 25, 50, 100, 200, 500]], ["second", [1, 2, 5, 10, 15, 30]], ["minute", [1, 2, 5, 10, 15, 30]], ["hour", [1, 2, 3, 4, 6, 8, 12]], ["day", [1, 2]], ["week", [1, 2]], ["month", [1, 2, 3, 4, 6]], ["year", null]];
                  e = r[r.length - 1];
                  var a,
                      s = o[e[0]],
                      c = e[1];

                  for (a = 0; a < r.length && (e = r[a], s = o[e[0]], c = e[1], !(r[a + 1] && t <= (s * c[c.length - 1] + o[r[a + 1][0]]) / 2)); a++) {
                    ;
                  }

                  return s === o.year && t < 5 * s && (c = [1, 2, 5]), {
                    unitRange: s,
                    count: t = i(t / s, c, "year" === e[0] ? Math.max(n(t / s), 1) : 1),
                    unitName: e[0]
                  };
                }, d3.prototype.getXDateFormat = function (t, e) {
                  var r = this.axis,
                      n = r.chart.time;
                  return r.closestPointRange ? n.getDateFormat(r.closestPointRange, t, r.options.startOfWeek, e) || n.resolveDTLFormat(e.year).main : n.resolveDTLFormat(e.day).main;
                }, d3;
              }();

              t.Additions = a;
            }(e || (e = {})), e;
          }), K2(e, "Core/Axis/LogarithmicAxis.js", [e["Core/Utilities.js"]], function (t) {
            var e,
                r = t.addEvent,
                n = t.normalizeTickInterval,
                i = t.pick;
            return function (t) {
              function A(t) {
                var e = this.logarithmic;
                "logarithmic" !== t.userOptions.type ? this.logarithmic = void 0 : e || (this.logarithmic = new o(this));
              }

              function t3() {
                var t = this.logarithmic;
                t && (this.lin2val = function (e) {
                  return t.lin2log(e);
                }, this.val2lin = function (e) {
                  return t.log2lin(e);
                });
              }

              var e = [];

              t.compose = function (t) {
                return -1 === e.indexOf(t) && (e.push(t), t.keepProps.push("logarithmic"), r(t, "init", A), r(t, "afterInit", t3)), t;
              };

              var o = function () {
                function a5(t) {
                  this.axis = t;
                }

                return a5.prototype.getLogTickPositions = function (t, e, r, o) {
                  var a = this.axis,
                      s = a.len,
                      c = a.options,
                      l = [];
                  if (o || (this.minorAutoInterval = void 0), .5 <= t) t = Math.round(t), l = a.getLinearTickPositions(t, e, r);else if (.08 <= t) {
                    var u,
                        h = Math.floor(e),
                        d = c = void 0;

                    for (s = .3 < t ? [1, 2, 4] : .15 < t ? [1, 2, 4, 6, 8] : [1, 2, 3, 4, 5, 6, 7, 8, 9]; h < r + 1 && !d; h++) {
                      var f = s.length;

                      for (u = 0; u < f && !d; u++) {
                        var p = this.log2lin(this.lin2log(h) * s[u]);
                        p > e && (!o || c <= r) && "undefined" !== typeof c && l.push(c), c > r && (d = !0), c = p;
                      }
                    }
                  } else e = this.lin2log(e), r = this.lin2log(r), t = o ? a.getMinorTickInterval() : c.tickInterval, t = i("auto" === t ? null : t, this.minorAutoInterval, c.tickPixelInterval / (o ? 5 : 1) * (r - e) / ((o ? s / a.tickPositions.length : s) || 1)), t = n(t), l = a.getLinearTickPositions(t, e, r).map(this.log2lin), o || (this.minorAutoInterval = t / 5);
                  return o || (a.tickInterval = t), l;
                }, a5.prototype.lin2log = function (t) {
                  return Math.pow(10, t);
                }, a5.prototype.log2lin = function (t) {
                  return Math.log(t) / Math.LN10;
                }, a5;
              }();

              t.Additions = o;
            }(e || (e = {})), e;
          }), K2(e, "Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js", [e["Core/Utilities.js"]], function (t) {
            var e,
                r = t.erase,
                n = t.extend,
                i = t.isNumber;
            return function (t) {
              var e,
                  o = [];

              t.compose = function (t, r) {
                return e || (e = t), -1 === o.indexOf(r) && (o.push(r), n(r.prototype, a.prototype)), r;
              };

              var a = function () {
                function a5() {}

                return a5.prototype.getPlotBandPath = function (t, e, r) {
                  void 0 === r && (r = this.options);
                  var n = this.getPlotLinePath({
                    value: e,
                    force: !0,
                    acrossPanes: r.acrossPanes
                  }),
                      o = [],
                      a = this.horiz;

                  if (e = !i(this.min) || !i(this.max) || t < this.min && e < this.min || t > this.max && e > this.max, t = this.getPlotLinePath({
                    value: t,
                    force: !0,
                    acrossPanes: r.acrossPanes
                  }), r = 1, t && n) {
                    if (e) {
                      var s = t.toString() === n.toString();
                      r = 0;
                    }

                    for (e = 0; e < t.length; e += 2) {
                      var c = t[e],
                          l = t[e + 1],
                          u = n[e],
                          h = n[e + 1];
                      "M" !== c[0] && "L" !== c[0] || "M" !== l[0] && "L" !== l[0] || "M" !== u[0] && "L" !== u[0] || "M" !== h[0] && "L" !== h[0] || (a && u[1] === c[1] ? (u[1] += r, h[1] += r) : a || u[2] !== c[2] || (u[2] += r, h[2] += r), o.push(["M", c[1], c[2]], ["L", l[1], l[2]], ["L", h[1], h[2]], ["L", u[1], u[2]], ["Z"])), o.isFlat = s;
                    }
                  }

                  return o;
                }, a5.prototype.addPlotBand = function (t) {
                  return this.addPlotBandOrLine(t, "plotBands");
                }, a5.prototype.addPlotLine = function (t) {
                  return this.addPlotBandOrLine(t, "plotLines");
                }, a5.prototype.addPlotBandOrLine = function (t, r) {
                  var n = this,
                      i = this.userOptions,
                      o = new e(this, t);

                  if (this.visible && (o = o.render()), o) {
                    if (this._addedPlotLB || (this._addedPlotLB = !0, (i.plotLines || []).concat(i.plotBands || []).forEach(function (t) {
                      n.addPlotBandOrLine(t);
                    })), r) {
                      var a = i[r] || [];
                      a.push(t), i[r] = a;
                    }

                    this.plotLinesAndBands.push(o);
                  }

                  return o;
                }, a5.prototype.removePlotBandOrLine = function (t) {
                  var e = this.plotLinesAndBands,
                      n = this.options,
                      i = this.userOptions;

                  if (e) {
                    for (var o = e.length; o--;) {
                      e[o].id === t && e[o].destroy();
                    }

                    [n.plotLines || [], i.plotLines || [], n.plotBands || [], i.plotBands || []].forEach(function (e) {
                      for (o = e.length; o--;) {
                        (e[o] || {}).id === t && r(e, e[o]);
                      }
                    });
                  }
                }, a5.prototype.removePlotBand = function (t) {
                  this.removePlotBandOrLine(t);
                }, a5.prototype.removePlotLine = function (t) {
                  this.removePlotBandOrLine(t);
                }, a5;
              }();
            }(e || (e = {})), e;
          }), K2(e, "Core/Axis/PlotLineOrBand/PlotLineOrBand.js", [e["Core/Axis/PlotLineOrBand/PlotLineOrBandAxis.js"], e["Core/Utilities.js"]], function (t, e) {
            var r = e.arrayMax,
                n = e.arrayMin,
                i = e.defined,
                o = e.destroyObjectProperties,
                a = e.erase,
                s = e.fireEvent,
                c = e.merge,
                l = e.objectEach,
                u = e.pick;
            return e = function () {
              function d3(t, e) {
                this.axis = t, e && (this.options = e, this.id = e.id);
              }

              return d3.compose = function (e) {
                return t.compose(d3, e);
              }, d3.prototype.render = function () {
                s(this, "render");
                var t = this,
                    e = t.axis,
                    r = e.horiz,
                    n = e.logarithmic,
                    o = t.options,
                    a = o.color,
                    h = u(o.zIndex, 0),
                    d = o.events,
                    f = {},
                    p = e.chart.renderer,
                    y = o.label,
                    g = t.label,
                    m = o.to,
                    v = o.from,
                    b = o.value,
                    x = t.svgElem,
                    w = [],
                    S = i(v) && i(m);
                w = i(b);
                var O = !x,
                    E = {
                  class: "highcharts-plot-" + (S ? "band " : "line ") + (o.className || "")
                },
                    k = S ? "bands" : "lines";
                if (n && (v = n.log2lin(v), m = n.log2lin(m), b = n.log2lin(b)), e.chart.styledMode || (w ? (E.stroke = a || "#999999", E["stroke-width"] = u(o.width, 1), o.dashStyle && (E.dashstyle = o.dashStyle)) : S && (E.fill = a || "#e6ebf5", o.borderWidth && (E.stroke = o.borderColor, E["stroke-width"] = o.borderWidth))), f.zIndex = h, k += "-" + h, (n = e.plotLinesAndBandsGroups[k]) || (e.plotLinesAndBandsGroups[k] = n = p.g("plot-" + k).attr(f).add()), O && (t.svgElem = x = p.path().attr(E).add(n)), w) w = e.getPlotLinePath({
                  value: b,
                  lineWidth: x.strokeWidth(),
                  acrossPanes: o.acrossPanes
                });else {
                  if (!S) return;
                  w = e.getPlotBandPath(v, m, o);
                }
                return !t.eventsAdded && d && (l(d, function (e, r) {
                  x.on(r, function (e) {
                    d[r].apply(t, [e]);
                  });
                }), t.eventsAdded = !0), (O || !x.d) && w && w.length ? x.attr({
                  d: w
                }) : x && (w ? (x.show(), x.animate({
                  d: w
                })) : x.d && (x.hide(), g && (t.label = g = g.destroy()))), y && (i(y.text) || i(y.formatter)) && w && w.length && 0 < e.width && 0 < e.height && !w.isFlat ? (y = c({
                  align: r && S && "center",
                  x: r ? !S && 4 : 10,
                  verticalAlign: !r && S && "middle",
                  y: r ? S ? 16 : 10 : S ? 6 : -4,
                  rotation: r && !S && 90
                }, y), this.renderLabel(y, w, S, h)) : g && g.hide(), t;
              }, d3.prototype.renderLabel = function (t, e, i, o) {
                var a = this.axis,
                    s = a.chart.renderer,
                    l = this.label;
                l || (this.label = l = s.text(this.getLabelText(t), 0, 0, t.useHTML).attr({
                  align: t.textAlign || t.align,
                  rotation: t.rotation,
                  class: "highcharts-plot-" + (i ? "band" : "line") + "-label " + (t.className || ""),
                  zIndex: o
                }).add(), a.chart.styledMode || l.css(c({
                  textOverflow: "ellipsis"
                }, t.style))), o = e.xBounds || [e[0][1], e[1][1], i ? e[2][1] : e[0][1]], e = e.yBounds || [e[0][2], e[1][2], i ? e[2][2] : e[0][2]], i = n(o), s = n(e), l.align(t, !1, {
                  x: i,
                  y: s,
                  width: r(o) - i,
                  height: r(e) - s
                }), l.alignValue && "left" !== l.alignValue || (t = t.clip ? a.width : a.chart.chartWidth, l.css({
                  width: (90 === l.rotation ? a.height - (l.alignAttr.y - a.top) : t - (l.alignAttr.x - a.left)) + "px"
                })), l.show(!0);
              }, d3.prototype.getLabelText = function (t) {
                return i(t.formatter) ? t.formatter.call(this) : t.text;
              }, d3.prototype.destroy = function () {
                a(this.axis.plotLinesAndBands, this), delete this.axis, o(this);
              }, d3;
            }();
          }), K2(e, "Core/Tooltip.js", [e["Core/FormatUtilities.js"], e["Core/Globals.js"], e["Core/Renderer/RendererUtilities.js"], e["Core/Renderer/RendererRegistry.js"], e["Core/Utilities.js"]], function (t, e, r, n, i) {
            var o = t.format,
                a = e.doc,
                s = r.distribute,
                c = i.clamp,
                l = i.css,
                u = i.discardElement,
                h = i.extend,
                d = i.fireEvent,
                f = i.isArray,
                p = i.isNumber,
                y = i.isString,
                g = i.merge,
                m = i.pick,
                v = i.splat,
                b = i.syncTimeout;
            return t = function () {
              function a4(t, e) {
                this.allowShared = !0, this.container = void 0, this.crosshairs = [], this.distance = 0, this.isHidden = !0, this.isSticky = !1, this.now = {}, this.options = {}, this.outside = !1, this.chart = t, this.init(t, e);
              }

              return a4.prototype.applyFilter = function () {
                var t = this.chart;
                t.renderer.definition({
                  tagName: "filter",
                  attributes: {
                    id: "drop-shadow-" + t.index,
                    opacity: .5
                  },
                  children: [{
                    tagName: "feGaussianBlur",
                    attributes: {
                      in: "SourceAlpha",
                      stdDeviation: 1
                    }
                  }, {
                    tagName: "feOffset",
                    attributes: {
                      dx: 1,
                      dy: 1
                    }
                  }, {
                    tagName: "feComponentTransfer",
                    children: [{
                      tagName: "feFuncA",
                      attributes: {
                        type: "linear",
                        slope: .3
                      }
                    }]
                  }, {
                    tagName: "feMerge",
                    children: [{
                      tagName: "feMergeNode"
                    }, {
                      tagName: "feMergeNode",
                      attributes: {
                        in: "SourceGraphic"
                      }
                    }]
                  }]
                });
              }, a4.prototype.bodyFormatter = function (t) {
                return t.map(function (t) {
                  var e = t.series.tooltipOptions;
                  return (e[(t.point.formatPrefix || "point") + "Formatter"] || t.point.tooltipFormatter).call(t.point, e[(t.point.formatPrefix || "point") + "Format"] || "");
                });
              }, a4.prototype.cleanSplit = function (t) {
                this.chart.series.forEach(function (e) {
                  var r = e && e.tt;
                  r && (!r.isActive || t ? e.tt = r.destroy() : r.isActive = !1);
                });
              }, a4.prototype.defaultFormatter = function (t) {
                var e = this.points || v(this),
                    r = [t.tooltipFooterHeaderFormatter(e[0])];
                return (r = r.concat(t.bodyFormatter(e))).push(t.tooltipFooterHeaderFormatter(e[0], !0)), r;
              }, a4.prototype.destroy = function () {
                this.label && (this.label = this.label.destroy()), this.split && this.tt && (this.cleanSplit(!0), this.tt = this.tt.destroy()), this.renderer && (this.renderer = this.renderer.destroy(), u(this.container)), i.clearTimeout(this.hideTimer), i.clearTimeout(this.tooltipTimeout);
              }, a4.prototype.getAnchor = function (t, e) {
                var r = this.chart,
                    n = r.pointer,
                    i = r.inverted,
                    o = r.plotTop;
                if (r = r.plotLeft, (t = v(t))[0].series && t[0].series.yAxis && !t[0].series.yAxis.options.reversedStacks && (t = t.slice().reverse()), this.followPointer && e) "undefined" === typeof e.chartX && (e = n.normalize(e)), t = [e.chartX - r, e.chartY - o];else if (t[0].tooltipPos) t = t[0].tooltipPos;else {
                  var a = 0,
                      s = 0;
                  t.forEach(function (t) {
                    (t = t.pos(!0)) && (a += t[0], s += t[1]);
                  }), a /= t.length, s /= t.length, this.shared && 1 < t.length && e && (i ? a = e.chartX : s = e.chartY), t = [a - r, s - o];
                }
                return t.map(Math.round);
              }, a4.prototype.getClassName = function (t, e, r) {
                var n = t.series,
                    i = n.options;
                return [this.options.className, "highcharts-label", r && "highcharts-tooltip-header", e ? "highcharts-tooltip-box" : "highcharts-tooltip", !r && "highcharts-color-" + m(t.colorIndex, n.colorIndex), i && i.className].filter(y).join(" ");
              }, a4.prototype.getLabel = function () {
                var t,
                    r = this,
                    i = this.chart.styledMode,
                    o = this.options,
                    a = this.split && this.allowShared,
                    s = o.style.pointerEvents || (this.shouldStickOnContact() ? "auto" : "none"),
                    c = this.chart.renderer;

                if (r.label) {
                  var u = !r.label.hasClass("highcharts-label");
                  (a && !u || !a && u) && r.destroy();
                }

                if (!this.label) {
                  if (this.outside) {
                    u = this.chart.options.chart.style;
                    var h = n.getRendererType();
                    this.container = t = e.doc.createElement("div"), t.className = "highcharts-tooltip-container", l(t, {
                      position: "absolute",
                      top: "1px",
                      pointerEvents: s,
                      zIndex: Math.max(this.options.style.zIndex || 0, (u && u.zIndex || 0) + 3)
                    }), e.doc.body.appendChild(t), this.renderer = c = new h(t, 0, 0, u, void 0, void 0, c.styledMode);
                  }

                  if (a ? this.label = c.g("tooltip") : (this.label = c.label("", 0, 0, o.shape, void 0, void 0, o.useHTML, void 0, "tooltip").attr({
                    padding: o.padding,
                    r: o.borderRadius
                  }), i || this.label.attr({
                    fill: o.backgroundColor,
                    "stroke-width": o.borderWidth
                  }).css(o.style).css({
                    pointerEvents: s
                  }).shadow(o.shadow)), i && o.shadow && (this.applyFilter(), this.label.attr({
                    filter: "url(#drop-shadow-" + this.chart.index + ")"
                  })), r.outside && !r.split) {
                    var d = this.label,
                        f = d.xSetter,
                        p = d.ySetter;
                    d.xSetter = function (e) {
                      f.call(d, r.distance), t.style.left = e + "px";
                    }, d.ySetter = function (e) {
                      p.call(d, r.distance), t.style.top = e + "px";
                    };
                  }

                  this.label.attr({
                    zIndex: 8
                  }).add();
                }

                return this.label;
              }, a4.prototype.getPosition = function (t, e, r) {
                var n,
                    i = this.chart,
                    o = this.distance,
                    s = {},
                    c = i.inverted && r.h || 0,
                    l = this.outside,
                    u = l ? a.documentElement.clientWidth - 2 * o : i.chartWidth,
                    h = l ? Math.max(a.body.scrollHeight, a.documentElement.scrollHeight, a.body.offsetHeight, a.documentElement.offsetHeight, a.documentElement.clientHeight) : i.chartHeight,
                    d = i.pointer.getChartPosition(),
                    f = function l3(n) {
                  var a = "x" === n;
                  return [n, a ? u : h, a ? t : e].concat(l ? [a ? t * d.scaleX : e * d.scaleY, a ? d.left - o + (r.plotX + i.plotLeft) * d.scaleX : d.top - o + (r.plotY + i.plotTop) * d.scaleY, 0, a ? u : h] : [a ? t : e, a ? r.plotX + i.plotLeft : r.plotY + i.plotTop, a ? i.plotLeft : i.plotTop, a ? i.plotLeft + i.plotWidth : i.plotTop + i.plotHeight]);
                },
                    p = f("y"),
                    y = f("x");

                f = !!r.negative, !i.polar && i.hoverSeries && i.hoverSeries.yAxis && i.hoverSeries.yAxis.reversed && (f = !f);

                var g = !this.followPointer && m(r.ttBelow, !i.inverted === f),
                    v = function E3(t) {
                  var e = p;
                  p = y, y = e, n = t;
                };

                return (i.inverted || 1 < this.len) && v(), function G2() {
                  !1 !== function t4(t, e, r, n, i, a, u) {
                    var h = l ? "y" === t ? o * d.scaleY : o * d.scaleX : o,
                        f = (r - n) / 2,
                        p = n < i - o,
                        y = i + o + n < e,
                        m = i - h - r + f;
                    if (i = i + h - f, g && y) s[t] = i;else if (!g && p) s[t] = m;else if (p) s[t] = Math.min(u - n, 0 > m - c ? m : m - c);else {
                      if (!y) return !1;
                      s[t] = Math.max(a, i + c + r > e ? i : i + c);
                    }
                  }.apply(0, p) ? !1 !== function D3(t, e, r, n, i) {
                    var a;
                    return i < o || i > e - o ? a = !1 : s[t] = i < r / 2 ? 1 : i > e - n / 2 ? e - n - 2 : i - r / 2, a;
                  }.apply(0, y) || n || (v(!0), G2()) : n ? s.x = s.y = 0 : (v(!0), G2());
                }(), s;
              }, a4.prototype.hide = function (t) {
                var e = this;
                i.clearTimeout(this.hideTimer), t = m(t, this.options.hideDelay), this.isHidden || (this.hideTimer = b(function () {
                  e.getLabel().fadeOut(t ? void 0 : t), e.isHidden = !0;
                }, t));
              }, a4.prototype.init = function (t, e) {
                this.chart = t, this.options = e, this.crosshairs = [], this.now = {
                  x: 0,
                  y: 0
                }, this.isHidden = !0, this.split = e.split && !t.inverted && !t.polar, this.shared = e.shared || this.split, this.outside = m(e.outside, !(!t.scrollablePixelsX && !t.scrollablePixelsY));
              }, a4.prototype.shouldStickOnContact = function (t) {
                return !(this.followPointer || !this.options.stickOnContact || t && !this.chart.pointer.inClass(t.target, "highcharts-tooltip"));
              }, a4.prototype.move = function (t, e, r, n) {
                var o = this,
                    a = o.now,
                    s = !1 !== o.options.animation && !o.isHidden && (1 < Math.abs(t - a.x) || 1 < Math.abs(e - a.y)),
                    c = o.followPointer || 1 < o.len;
                h(a, {
                  x: s ? (2 * a.x + t) / 3 : t,
                  y: s ? (a.y + e) / 2 : e,
                  anchorX: c ? void 0 : s ? (2 * a.anchorX + r) / 3 : r,
                  anchorY: c ? void 0 : s ? (a.anchorY + n) / 2 : n
                }), o.getLabel().attr(a), o.drawTracker(), s && (i.clearTimeout(this.tooltipTimeout), this.tooltipTimeout = setTimeout(function () {
                  o && o.move(t, e, r, n);
                }, 32));
              }, a4.prototype.refresh = function (t, e) {
                var r = this.chart,
                    n = this.options,
                    o = r.pointer,
                    a = v(t),
                    s = a[0],
                    c = [],
                    l = n.formatter || this.defaultFormatter,
                    u = this.shared,
                    h = r.styledMode,
                    p = {};

                if (n.enabled && s.series) {
                  i.clearTimeout(this.hideTimer), this.allowShared = !(!f(t) && t.series && t.series.noSharedTooltip), this.followPointer = !this.split && s.series.tooltipOptions.followPointer;
                  var y = (t = this.getAnchor(t, e))[0],
                      g = t[1];
                  if (u && this.allowShared ? (o.applyInactiveState(a), a.forEach(function (t) {
                    t.setState("hover"), c.push(t.getLabelConfig());
                  }), (p = {
                    x: s.category,
                    y: s.y
                  }).points = c) : p = s.getLabelConfig(), this.len = c.length, l = l.call(p, this), u = s.series, this.distance = m(u.tooltipOptions.distance, 16), !1 === l) this.hide();else {
                    if (this.split && this.allowShared) this.renderSplit(l, a);else {
                      var b = y,
                          x = g;
                      if (e && o.isDirectTouch && (b = e.chartX - r.plotLeft, x = e.chartY - r.plotTop), !r.polar && !1 !== u.options.clip && !a.some(function (t) {
                        return o.isDirectTouch || t.series.shouldShowTooltip(b, x);
                      })) return void this.hide();
                      e = this.getLabel(), n.style.width && !h || e.css({
                        width: r.spacingBox.width + "px"
                      }), e.attr({
                        text: l && l.join ? l.join("") : l
                      }), e.addClass(this.getClassName(s), !0), h || e.attr({
                        stroke: n.borderColor || s.color || u.color || "#666666"
                      }), this.updatePosition({
                        plotX: y,
                        plotY: g,
                        negative: s.negative,
                        ttBelow: s.ttBelow,
                        h: t[2] || 0
                      });
                    }
                    this.isHidden && this.label && this.label.attr({
                      opacity: 1
                    }).show(), this.isHidden = !1;
                  }
                  d(this, "refresh");
                }
              }, a4.prototype.renderSplit = function (t, e) {
                function f2(t, e, n, i, o) {
                  return void 0 === o && (o = !0), n ? (e = T ? 0 : j, t = c(t - i / 2, k.left, k.right - i - (r.outside ? A : 0))) : (e -= M, t = c(t = o ? t - i - S : t + S, o ? t : k.left, k.right)), {
                    x: t,
                    y: e
                  };
                }

                var r = this,
                    n = r.chart,
                    i = r.chart,
                    o = i.chartWidth,
                    l = i.chartHeight,
                    u = i.plotHeight,
                    d = i.plotLeft,
                    f = i.plotTop,
                    p = i.pointer,
                    g = i.scrollablePixelsY;
                g = void 0 === g ? 0 : g;
                var v = i.scrollablePixelsX,
                    b = i.scrollingContainer,
                    x = (b = void 0 === b ? {
                  scrollLeft: 0,
                  scrollTop: 0
                } : b).scrollLeft;
                b = b.scrollTop;

                var w = i.styledMode,
                    S = r.distance,
                    O = r.options,
                    E = r.options.positioner,
                    k = r.outside && "number" !== typeof v ? a.documentElement.getBoundingClientRect() : {
                  left: x,
                  right: x + o,
                  top: b,
                  bottom: b + l
                },
                    _ = r.getLabel(),
                    C = this.renderer || n.renderer,
                    T = !(!n.xAxis[0] || !n.xAxis[0].opposite),
                    A = (n = p.getChartPosition()).left;

                n = n.top;
                var M = f + b,
                    P = 0,
                    j = u - g;
                y(t) && (t = [!1, t]), t = t.slice(0, e.length + 1).reduce(function (t, n, i) {
                  if (!1 !== n && "" !== n) {
                    var o = (i = e[i - 1] || {
                      isHeader: !0,
                      plotX: e[0].plotX,
                      plotY: u,
                      series: {}
                    }).isHeader,
                        a = o ? r : i.series;
                    n = n.toString();
                    var s = a.tt,
                        l = i.isHeader,
                        h = i.series;
                    s || (s = {
                      padding: O.padding,
                      r: O.borderRadius
                    }, w || (s.fill = O.backgroundColor, s["stroke-width"] = O.borderWidth), s = C.label("", 0, 0, O[l ? "headerShape" : "shape"], void 0, void 0, O.useHTML).addClass(r.getClassName(i, !0, l)).attr(s).add(_)), s.isActive = !0, s.attr({
                      text: n
                    }), w || s.css(O.style).shadow(O.shadow).attr({
                      stroke: O.borderColor || i.color || h.color || "#333333"
                    }), n = (l = (a = a.tt = s).getBBox()).width + a.strokeWidth(), o && (P = l.height, j += P, T && (M -= P)), h = void 0 === (h = i.plotX) ? 0 : h, s = void 0 === (s = i.plotY) ? 0 : s;
                    var p = i.series;

                    if (i.isHeader) {
                      h = d + h;
                      var y = f + u / 2;
                    } else {
                      var g = p.xAxis,
                          v = p.yAxis;
                      h = g.pos + c(h, -S, g.len + S), p.shouldShowTooltip(0, v.pos - f + s, {
                        ignoreX: !0
                      }) && (y = v.pos + s);
                    }

                    h = c(h, k.left - S, k.right + S), "number" === typeof y ? (l = l.height + 1, s = E ? E.call(r, n, l, i) : f2(h, y, o, n), t.push({
                      align: E ? 0 : void 0,
                      anchorX: h,
                      anchorY: y,
                      boxWidth: n,
                      point: i,
                      rank: m(s.rank, o ? 1 : 0),
                      size: l,
                      target: s.y,
                      tt: a,
                      x: s.x
                    })) : a.isActive = !1;
                  }

                  return t;
                }, []), !E && t.some(function (t) {
                  var e = (r.outside ? A : 0) + t.anchorX;
                  return e < k.left && e + t.boxWidth < k.right || e < A - k.left + t.boxWidth && k.right - e > e;
                }) && (t = t.map(function (t) {
                  var e = f2(t.anchorX, t.anchorY, t.point.isHeader, t.boxWidth, !1);
                  return h(t, {
                    target: e.y,
                    x: e.x
                  });
                })), r.cleanSplit(), s(t, j);
                var R = A,
                    D = A;
                t.forEach(function (t) {
                  var e = t.x,
                      n = t.boxWidth;
                  (t = t.isHeader) || (r.outside && A + e < R && (R = A + e), !t && r.outside && R + n > D && (D = A + e));
                }), t.forEach(function (t) {
                  var e = t.x,
                      n = t.anchorX,
                      i = t.pos,
                      o = t.point.isHeader;

                  if (i = {
                    visibility: "undefined" === typeof i ? "hidden" : "inherit",
                    x: e,
                    y: (i || 0) + M,
                    anchorX: n,
                    anchorY: t.anchorY
                  }, r.outside && e < n) {
                    var a = A - R;
                    0 < a && (o || (i.x = e + a, i.anchorX = n + a), o && (i.x = (D - R) / 2, i.anchorX = n + a));
                  }

                  t.tt.attr(i);
                }), t = r.container, g = r.renderer, r.outside && t && g && (i = _.getBBox(), g.setSize(i.width + i.x, i.height + i.y, !1), t.style.left = R + "px", t.style.top = n + "px");
              }, a4.prototype.drawTracker = function () {
                if (this.shouldStickOnContact()) {
                  var t = this.chart,
                      e = this.label,
                      r = this.shared ? t.hoverPoints : t.hoverPoint;

                  if (e && r) {
                    var n = {
                      x: 0,
                      y: 0,
                      width: 0,
                      height: 0
                    };
                    r = this.getAnchor(r);
                    var i = e.getBBox();
                    r[0] += t.plotLeft - e.translateX, r[1] += t.plotTop - e.translateY, n.x = Math.min(0, r[0]), n.y = Math.min(0, r[1]), n.width = 0 > r[0] ? Math.max(Math.abs(r[0]), i.width - r[0]) : Math.max(Math.abs(r[0]), i.width), n.height = 0 > r[1] ? Math.max(Math.abs(r[1]), i.height - Math.abs(r[1])) : Math.max(Math.abs(r[1]), i.height), this.tracker ? this.tracker.attr(n) : (this.tracker = e.renderer.rect(n).addClass("highcharts-tracker").add(e), t.styledMode || this.tracker.attr({
                      fill: "rgba(0,0,0,0)"
                    }));
                  }
                } else this.tracker && this.tracker.destroy();
              }, a4.prototype.styledModeFormat = function (t) {
                return t.replace('style="font-size: 10px"', 'class="highcharts-header"').replace(/style="color:{(point|series)\.color}"/g, 'class="highcharts-color-{$1.colorIndex} {series.options.className} {point.options.className}"');
              }, a4.prototype.tooltipFooterHeaderFormatter = function (t, e) {
                var r = t.series,
                    n = r.tooltipOptions,
                    i = r.xAxis,
                    a = i && i.dateTime;
                i = {
                  isFooter: e,
                  labelConfig: t
                };
                var s = n.xDateFormat,
                    c = n[e ? "footerFormat" : "headerFormat"];
                return d(this, "headerFormatter", i, function (e) {
                  a && !s && p(t.key) && (s = a.getXDateFormat(t.key, n.dateTimeLabelFormats)), a && s && (t.point && t.point.tooltipDateKeys || ["key"]).forEach(function (t) {
                    c = c.replace("{point." + t + "}", "{point." + t + ":" + s + "}");
                  }), r.chart.styledMode && (c = this.styledModeFormat(c)), e.text = o(c, {
                    point: t,
                    series: r
                  }, this.chart);
                }), i.text;
              }, a4.prototype.update = function (t) {
                this.destroy(), g(!0, this.chart.options.tooltip.userOptions, t), this.init(this.chart, g(!0, this.options, t));
              }, a4.prototype.updatePosition = function (t) {
                var e = this.chart,
                    r = this.distance,
                    n = this.options,
                    i = e.pointer,
                    o = this.getLabel(),
                    a = i.getChartPosition();
                i = a.left;
                var s = a.top,
                    c = a.scaleX;
                a = a.scaleY;
                var u = (n.positioner || this.getPosition).call(this, o.width, o.height, t),
                    h = (t.plotX || 0) + e.plotLeft;
                t = (t.plotY || 0) + e.plotTop, this.outside && (n.positioner && (u.x += i - r, u.y += s - r), r = n.borderWidth + 2 * r, this.renderer.setSize(o.width + r, o.height + r, !1), 1 === c && 1 === a || (l(this.container, {
                  transform: "scale(".concat(c, ", ").concat(a, ")")
                }), h *= c, t *= a), h += i - u.x, t += s - u.y), this.move(Math.round(u.x), Math.round(u.y || 0), h, t);
              }, a4;
            }();
          }), K2(e, "Core/Series/Point.js", [e["Core/Renderer/HTML/AST.js"], e["Core/Animation/AnimationUtilities.js"], e["Core/Defaults.js"], e["Core/FormatUtilities.js"], e["Core/Utilities.js"]], function (t, e, r, n, i) {
            var o = e.animObject,
                a = r.defaultOptions,
                s = n.format,
                c = i.addEvent,
                l = i.defined,
                u = i.erase,
                h = i.extend,
                d = i.fireEvent,
                f = i.getNestedProperty,
                p = i.isArray,
                y = i.isFunction,
                g = i.isNumber,
                m = i.isObject,
                v = i.merge,
                b = i.objectEach,
                x = i.pick,
                w = i.syncTimeout,
                S = i.removeEvent,
                O = i.uniqueKey;
            return e = function () {
              function g4() {
                this.category = void 0, this.formatPrefix = "point", this.id = void 0, this.isNull = !1, this.percentage = this.options = this.name = void 0, this.selected = !1, this.total = this.shapeArgs = this.series = void 0, this.visible = !0, this.x = void 0;
              }

              return g4.prototype.animateBeforeDestroy = function () {
                var t = this,
                    e = {
                  x: t.startXPos,
                  opacity: 0
                },
                    r = t.getGraphicalProps();
                r.singular.forEach(function (r) {
                  t[r] = t[r].animate("dataLabel" === r ? {
                    x: t[r].startXPos,
                    y: t[r].startYPos,
                    opacity: 0
                  } : e);
                }), r.plural.forEach(function (e) {
                  t[e].forEach(function (e) {
                    e.element && e.animate(h({
                      x: t.startXPos
                    }, e.startYPos ? {
                      x: e.startXPos,
                      y: e.startYPos
                    } : {}));
                  });
                });
              }, g4.prototype.applyOptions = function (t, e) {
                var r = this.series,
                    n = r.options.pointValKey || r.pointValKey;
                return t = g4.prototype.optionsToObject.call(this, t), h(this, t), this.options = this.options ? h(this.options, t) : t, t.group && delete this.group, t.dataLabels && delete this.dataLabels, n && (this.y = g4.prototype.getNestedProperty.call(this, n)), this.formatPrefix = (this.isNull = this.isValid && !this.isValid()) ? "null" : "point", this.selected && (this.state = "select"), "name" in this && "undefined" === typeof e && r.xAxis && r.xAxis.hasNames && (this.x = r.xAxis.nameToX(this)), "undefined" === typeof this.x && r ? this.x = "undefined" === typeof e ? r.autoIncrement() : e : g(t.x) && r.options.relativeXValue && (this.x = r.autoIncrement(t.x)), this;
              }, g4.prototype.destroy = function () {
                function b2() {
                  for (n in (t.graphic || t.graphics || t.dataLabel || t.dataLabels) && (S(t), t.destroyElements()), t) {
                    t[n] = null;
                  }
                }

                var t = this,
                    e = t.series,
                    r = e.chart;
                e = e.options.dataSorting;
                var n,
                    i = r.hoverPoints,
                    a = o(t.series.chart.renderer.globalAnimation);
                t.legendItem && r.legend.destroyItem(t), i && (t.setState(), u(i, t), i.length || (r.hoverPoints = null)), t === r.hoverPoint && t.onMouseOut(), e && e.enabled ? (this.animateBeforeDestroy(), w(b2, a.duration)) : b2(), r.pointCount--;
              }, g4.prototype.destroyElements = function (t) {
                var e = this;
                (t = e.getGraphicalProps(t)).singular.forEach(function (t) {
                  e[t] = e[t].destroy();
                }), t.plural.forEach(function (t) {
                  e[t].forEach(function (t) {
                    t && t.element && t.destroy();
                  }), delete e[t];
                });
              }, g4.prototype.firePointEvent = function (t, e, r) {
                var n = this,
                    i = this.series.options;
                (i.point.events[t] || n.options && n.options.events && n.options.events[t]) && n.importEvents(), "click" === t && i.allowPointSelect && (r = function a4(t) {
                  n.select && n.select(null, t.ctrlKey || t.metaKey || t.shiftKey);
                }), d(n, t, e, r);
              }, g4.prototype.getClassName = function () {
                return "highcharts-point" + (this.selected ? " highcharts-point-select" : "") + (this.negative ? " highcharts-negative" : "") + (this.isNull ? " highcharts-null-point" : "") + ("undefined" !== typeof this.colorIndex ? " highcharts-color-" + this.colorIndex : "") + (this.options.className ? " " + this.options.className : "") + (this.zone && this.zone.className ? " " + this.zone.className.replace("highcharts-negative", "") : "");
              }, g4.prototype.getGraphicalProps = function (t) {
                var e,
                    r = this,
                    n = [],
                    i = {
                  singular: [],
                  plural: []
                };

                for ((t = t || {
                  graphic: 1,
                  dataLabel: 1
                }).graphic && n.push("graphic", "shadowGroup"), t.dataLabel && n.push("dataLabel", "dataLabelPath", "dataLabelUpper", "connector"), e = n.length; e--;) {
                  var o = n[e];
                  r[o] && i.singular.push(o);
                }

                return ["graphic", "dataLabel", "connector"].forEach(function (e) {
                  var n = e + "s";
                  t[e] && r[n] && i.plural.push(n);
                }), i;
              }, g4.prototype.getLabelConfig = function () {
                return {
                  x: this.category,
                  y: this.y,
                  color: this.color,
                  colorIndex: this.colorIndex,
                  key: this.name || this.category,
                  series: this.series,
                  point: this,
                  percentage: this.percentage,
                  total: this.total || this.stackTotal
                };
              }, g4.prototype.getNestedProperty = function (t) {
                if (t) return 0 === t.indexOf("custom.") ? f(t, this.options) : this[t];
              }, g4.prototype.getZone = function () {
                var t = this.series,
                    e = t.zones;
                t = t.zoneAxis || "y";
                var r,
                    n = 0;

                for (r = e[n]; this[t] >= r.value;) {
                  r = e[++n];
                }

                return this.nonZonedColor || (this.nonZonedColor = this.color), this.color = r && r.color && !this.options.color ? r.color : this.nonZonedColor, r;
              }, g4.prototype.hasNewShapeType = function () {
                return (this.graphic && (this.graphic.symbolName || this.graphic.element.nodeName)) !== this.shapeType;
              }, g4.prototype.init = function (t, e, r) {
                return this.series = t, this.applyOptions(e, r), this.id = l(this.id) ? this.id : O(), this.resolveColor(), t.chart.pointCount++, d(this, "afterInit"), this;
              }, g4.prototype.isValid = function () {
                return null !== this.x && g(this.y);
              }, g4.prototype.optionsToObject = function (t) {
                var e = this.series,
                    r = e.options.keys,
                    n = r || e.pointArrayMap || ["y"],
                    i = n.length,
                    o = {},
                    a = 0,
                    s = 0;
                if (g(t) || null === t) o[n[0]] = t;else if (p(t)) for (!r && t.length > i && ("string" === (e = typeof t[0]) ? o.name = t[0] : "number" === e && (o.x = t[0]), a++); s < i;) {
                  r && "undefined" === typeof t[a] || (0 < n[s].indexOf(".") ? g4.prototype.setNestedProperty(o, t[a], n[s]) : o[n[s]] = t[a]), a++, s++;
                } else "object" === typeof t && (o = t, t.dataLabels && (e._hasPointLabels = !0), t.marker && (e._hasPointMarkers = !0));
                return o;
              }, g4.prototype.pos = function (t, e) {
                void 0 === e && (e = this.plotY);
                var r = this.plotX,
                    n = this.series,
                    i = n.chart,
                    o = n.xAxis;
                n = n.yAxis;
                var a = 0,
                    s = 0;
                if (g(r) && g(e)) return t && (a = o ? o.pos : i.plotLeft, s = n ? n.pos : i.plotTop), i.inverted && o && n ? [n.len - e + s, o.len - r + a] : [r + a, e + s];
              }, g4.prototype.resolveColor = function () {
                var t = this.series,
                    e = t.chart.styledMode,
                    r = t.chart.options.chart.colorCount;

                if (delete this.nonZonedColor, t.options.colorByPoint) {
                  if (!e) {
                    var n = (r = t.options.colors || t.chart.options.colors)[t.colorCounter];
                    r = r.length;
                  }

                  e = t.colorCounter, t.colorCounter++, t.colorCounter === r && (t.colorCounter = 0);
                } else e || (n = t.color), e = t.colorIndex;

                this.colorIndex = x(this.options.colorIndex, e), this.color = x(this.options.color, n);
              }, g4.prototype.setNestedProperty = function (t, e, r) {
                return r.split(".").reduce(function (t, r, n, i) {
                  return t[r] = i.length - 1 === n ? e : m(t[r], !0) ? t[r] : {}, t[r];
                }, t), t;
              }, g4.prototype.shouldDraw = function () {
                return !this.isNull;
              }, g4.prototype.tooltipFormatter = function (t) {
                var e = this.series,
                    r = e.tooltipOptions,
                    n = x(r.valueDecimals, ""),
                    i = r.valuePrefix || "",
                    o = r.valueSuffix || "";
                return e.chart.styledMode && (t = e.chart.tooltip.styledModeFormat(t)), (e.pointArrayMap || ["y"]).forEach(function (e) {
                  e = "{point." + e, (i || o) && (t = t.replace(RegExp(e + "}", "g"), i + e + "}" + o)), t = t.replace(RegExp(e + "}", "g"), e + ":,." + n + "f}");
                }), s(t, {
                  point: this,
                  series: this.series
                }, e.chart);
              }, g4.prototype.update = function (t, e, r, n) {
                function d4() {
                  o.applyOptions(t);
                  var n = s && o.hasMockGraphic;
                  n = null === o.y ? !n : n, s && n && (o.graphic = s.destroy(), delete o.hasMockGraphic), m(t, !0) && (s && s.element && t && t.marker && "undefined" !== typeof t.marker.symbol && (o.graphic = s.destroy()), t && t.dataLabels && o.dataLabel && (o.dataLabel = o.dataLabel.destroy()), o.connector && (o.connector = o.connector.destroy())), i = o.index, a.updateParallelArrays(o, i), l.data[i] = m(l.data[i], !0) || m(t, !0) ? o.options : x(t, l.data[i]), a.isDirty = a.isDirtyData = !0, !a.fixedBox && a.hasCartesianSeries && (c.isDirtyBox = !0), "point" === l.legendType && (c.isDirtyLegend = !0), e && c.redraw(r);
                }

                var i,
                    o = this,
                    a = o.series,
                    s = o.graphic,
                    c = a.chart,
                    l = a.options;
                e = x(e, !0), !1 === n ? d4() : o.firePointEvent("update", {
                  options: t
                }, d4);
              }, g4.prototype.remove = function (t, e) {
                this.series.removePoint(this.series.data.indexOf(this), t, e);
              }, g4.prototype.select = function (t, e) {
                var r = this,
                    n = r.series,
                    i = n.chart;
                this.selectedStaging = t = x(t, !r.selected), r.firePointEvent(t ? "select" : "unselect", {
                  accumulate: e
                }, function () {
                  r.selected = r.options.selected = t, n.options.data[n.data.indexOf(r)] = r.options, r.setState(t && "select"), e || i.getSelectedPoints().forEach(function (t) {
                    var e = t.series;
                    t.selected && t !== r && (t.selected = t.options.selected = !1, e.options.data[e.data.indexOf(t)] = t.options, t.setState(i.hoverPoints && e.options.inactiveOtherPoints ? "inactive" : ""), t.firePointEvent("unselect"));
                  });
                }), delete this.selectedStaging;
              }, g4.prototype.onMouseOver = function (t) {
                var e = this.series.chart,
                    r = e.pointer;
                t = t ? r.normalize(t) : r.getChartCoordinatesFromPoint(this, e.inverted), r.runPointActions(t, this);
              }, g4.prototype.onMouseOut = function () {
                var t = this.series.chart;
                this.firePointEvent("mouseOut"), this.series.options.inactiveOtherPoints || (t.hoverPoints || []).forEach(function (t) {
                  t.setState();
                }), t.hoverPoints = t.hoverPoint = null;
              }, g4.prototype.importEvents = function () {
                if (!this.hasImportedEvents) {
                  var t = this,
                      e = v(t.series.options.point, t.options).events;
                  t.events = e, b(e, function (e, r) {
                    y(e) && c(t, r, e);
                  }), this.hasImportedEvents = !0;
                }
              }, g4.prototype.setState = function (e, r) {
                var n,
                    i = this.series,
                    o = this.state,
                    s = i.options.states[e || "normal"] || {},
                    c = a.plotOptions[i.type].marker && i.options.marker,
                    l = c && !1 === c.enabled,
                    u = c && c.states && c.states[e || "normal"] || {},
                    f = !1 === u.enabled,
                    p = this.marker || {},
                    y = i.chart,
                    m = c && i.markerAttribs,
                    v = i.halo,
                    b = i.stateMarkerGraphic;

                if (!((e = e || "") === this.state && !r || this.selected && "select" !== e || !1 === s.enabled || e && (f || l && !1 === u.enabled) || e && p.states && p.states[e] && !1 === p.states[e].enabled)) {
                  if (this.state = e, m && (n = i.markerAttribs(this, e)), this.graphic && !this.hasMockGraphic) {
                    if (o && this.graphic.removeClass("highcharts-point-" + o), e && this.graphic.addClass("highcharts-point-" + e), !y.styledMode) {
                      o = i.pointAttribs(this, e);
                      var w = x(y.options.chart.animation, s.animation),
                          S = o.opacity;
                      i.options.inactiveOtherPoints && g(S) && ((this.dataLabels || []).forEach(function (t) {
                        t && !t.hasClass("highcharts-data-label-hidden") && t.animate({
                          opacity: S
                        }, w);
                      }), this.connector && this.connector.animate({
                        opacity: S
                      }, w)), this.graphic.animate(o, w);
                    }

                    n && this.graphic.animate(n, x(y.options.chart.animation, u.animation, c.animation)), b && b.hide();
                  } else e && u && (c = p.symbol || i.symbol, b && b.currentSymbol !== c && (b = b.destroy()), n && (b ? b[r ? "animate" : "attr"]({
                    x: n.x,
                    y: n.y
                  }) : c && (i.stateMarkerGraphic = b = y.renderer.symbol(c, n.x, n.y, n.width, n.height).add(i.markerGroup), b.currentSymbol = c)), !y.styledMode && b && "inactive" !== this.state && b.attr(i.pointAttribs(this, e))), b && (b[e && this.isInside ? "show" : "hide"](), b.element.point = this, b.addClass(this.getClassName(), !0));

                  s = s.halo, n = (b = this.graphic || b) && b.visibility || "inherit", s && s.size && b && "hidden" !== n && !this.isCluster ? (v || (i.halo = v = y.renderer.path().add(b.parentGroup)), v.show()[r ? "animate" : "attr"]({
                    d: this.haloPath(s.size)
                  }), v.attr({
                    class: "highcharts-halo highcharts-color-" + x(this.colorIndex, i.colorIndex) + (this.className ? " " + this.className : ""),
                    visibility: n,
                    zIndex: -1
                  }), v.point = this, y.styledMode || v.attr(h({
                    fill: this.color || i.color,
                    "fill-opacity": s.opacity
                  }, t.filterUserAttributes(s.attributes || {})))) : v && v.point && v.point.haloPath && v.animate({
                    d: v.point.haloPath(0)
                  }, null, v.hide), d(this, "afterSetState", {
                    state: e
                  });
                }
              }, g4.prototype.haloPath = function (t) {
                var e = this.pos();
                return e ? this.series.chart.renderer.symbols.circle(Math.floor(e[0]) - t, e[1] - t, 2 * t, 2 * t) : [];
              }, g4;
            }();
          }), K2(e, "Core/Pointer.js", [e["Core/Color/Color.js"], e["Core/Globals.js"], e["Core/Tooltip.js"], e["Core/Utilities.js"]], function (t, e, r, n) {
            var i = t.parse,
                o = e.charts,
                a = e.noop,
                s = n.addEvent,
                c = n.attr,
                l = n.css,
                u = n.defined,
                h = n.extend,
                d = n.find,
                f = n.fireEvent,
                p = n.isNumber,
                y = n.isObject,
                g = n.objectEach,
                m = n.offset,
                v = n.pick,
                b = n.splat;
            return t = function () {
              function a4(t, e) {
                this.lastValidTouch = {}, this.pinchDown = [], this.runChartClick = !1, this.eventsToUnbind = [], this.chart = t, this.hasDragged = !1, this.options = e, this.init(t, e);
              }

              return a4.prototype.applyInactiveState = function (t) {
                var e,
                    r = [];
                (t || []).forEach(function (t) {
                  e = t.series, r.push(e), e.linkedParent && r.push(e.linkedParent), e.linkedSeries && (r = r.concat(e.linkedSeries)), e.navigatorSeries && r.push(e.navigatorSeries);
                }), this.chart.series.forEach(function (t) {
                  -1 === r.indexOf(t) ? t.setState("inactive", !0) : t.options.inactiveOtherPoints && t.setAllPointsToState("inactive");
                });
              }, a4.prototype.destroy = function () {
                var t = this;
                this.eventsToUnbind.forEach(function (t) {
                  return t();
                }), this.eventsToUnbind = [], e.chartCount || (a4.unbindDocumentMouseUp && (a4.unbindDocumentMouseUp = a4.unbindDocumentMouseUp()), a4.unbindDocumentTouchEnd && (a4.unbindDocumentTouchEnd = a4.unbindDocumentTouchEnd())), clearInterval(t.tooltipTimeout), g(t, function (e, r) {
                  t[r] = void 0;
                });
              }, a4.prototype.getSelectionMarkerAttrs = function (t, e) {
                var r = this,
                    n = {
                  args: {
                    chartX: t,
                    chartY: e
                  },
                  attrs: {},
                  shapeType: "rect"
                };
                return f(this, "getSelectionMarkerAttrs", n, function (n) {
                  var i = r.chart,
                      o = r.mouseDownX;
                  o = void 0 === o ? 0 : o;
                  var a = r.mouseDownY;
                  a = void 0 === a ? 0 : a;
                  var s = r.zoomHor,
                      c = r.zoomVert;
                  (n = n.attrs).x = i.plotLeft, n.y = i.plotTop, n.width = s ? 1 : i.plotWidth, n.height = c ? 1 : i.plotHeight, s && (i = t - o, n.width = Math.abs(i), n.x = (0 < i ? 0 : i) + o), c && (i = e - a, n.height = Math.abs(i), n.y = (0 < i ? 0 : i) + a);
                }), n;
              }, a4.prototype.drag = function (t) {
                var e = this.chart,
                    r = e.options.chart,
                    n = e.plotLeft,
                    o = e.plotTop,
                    a = e.plotWidth,
                    s = e.plotHeight,
                    c = this.mouseDownX || 0,
                    l = this.mouseDownY || 0,
                    u = y(r.panning) ? r.panning && r.panning.enabled : r.panning,
                    h = r.panKey && t[r.panKey + "Key"],
                    d = t.chartX,
                    f = t.chartY,
                    p = this.selectionMarker;
                p && p.touch || (d < n ? d = n : d > n + a && (d = n + a), f < o ? f = o : f > o + s && (f = o + s), this.hasDragged = Math.sqrt(Math.pow(c - d, 2) + Math.pow(l - f, 2)), 10 < this.hasDragged && (n = e.isInsidePlot(c - n, l - o, {
                  visiblePlotOnly: !0
                }), d = (f = this.getSelectionMarkerAttrs(d, f)).shapeType, f = f.attrs, !e.hasCartesianSeries && !e.mapView || !this.zoomX && !this.zoomY || !n || h || p || (this.selectionMarker = p = e.renderer[d](), p.attr({
                  class: "highcharts-selection-marker",
                  zIndex: 7
                }).add(), e.styledMode || p.attr({
                  fill: r.selectionMarkerFill || i("#335cad").setOpacity(.25).get()
                })), p && p.attr(f), n && !p && u && e.pan(t, r.panning)));
              }, a4.prototype.dragStart = function (t) {
                var e = this.chart;
                e.mouseIsDown = t.type, e.cancelClick = !1, e.mouseDownX = this.mouseDownX = t.chartX, e.mouseDownY = this.mouseDownY = t.chartY;
              }, a4.prototype.getSelectionBox = function (t) {
                var e = {
                  args: {
                    marker: t
                  },
                  result: {}
                };
                return f(this, "getSelectionBox", e, function (e) {
                  e.result = {
                    x: t.attr ? +t.attr("x") : t.x,
                    y: t.attr ? +t.attr("y") : t.y,
                    width: t.attr ? t.attr("width") : t.width,
                    height: t.attr ? t.attr("height") : t.height
                  };
                }), e.result;
              }, a4.prototype.drop = function (t) {
                var e = this,
                    r = this.chart,
                    n = this.hasPinched;

                if (this.selectionMarker) {
                  var i = this.getSelectionBox(this.selectionMarker),
                      o = i.x,
                      a = i.y,
                      s = i.width,
                      c = i.height,
                      d = {
                    originalEvent: t,
                    xAxis: [],
                    yAxis: [],
                    x: o,
                    y: a,
                    width: s,
                    height: c
                  },
                      y = !!r.mapView;
                  (this.hasDragged || n) && (r.axes.forEach(function (r) {
                    if (r.zoomEnabled && u(r.min) && (n || e[{
                      xAxis: "zoomX",
                      yAxis: "zoomY"
                    }[r.coll]]) && p(o) && p(a) && p(s) && p(c)) {
                      var i = r.horiz,
                          l = "touchend" === t.type ? r.minPixelPadding : 0,
                          h = r.toValue((i ? o : a) + l);
                      i = r.toValue((i ? o + s : a + c) - l), d[r.coll].push({
                        axis: r,
                        min: Math.min(h, i),
                        max: Math.max(h, i)
                      }), y = !0;
                    }
                  }), y && f(r, "selection", d, function (t) {
                    r.zoom(h(t, n ? {
                      animation: !1
                    } : null));
                  })), p(r.index) && (this.selectionMarker = this.selectionMarker.destroy()), n && this.scaleGroups();
                }

                r && p(r.index) && (l(r.container, {
                  cursor: r._cursor
                }), r.cancelClick = 10 < this.hasDragged, r.mouseIsDown = this.hasDragged = this.hasPinched = !1, this.pinchDown = []);
              }, a4.prototype.findNearestKDPoint = function (t, e, r) {
                var n;
                return t.forEach(function (t) {
                  var i = !(t.noSharedTooltip && e) && 0 > t.options.findNearestPointBy.indexOf("y");

                  if (t = t.searchPoint(r, i), (i = y(t, !0) && t.series) && !(i = !y(n, !0))) {
                    i = n.distX - t.distX;
                    var o = n.dist - t.dist,
                        a = (t.series.group && t.series.group.zIndex) - (n.series.group && n.series.group.zIndex);
                    i = 0 < (0 !== i && e ? i : 0 !== o ? o : 0 !== a ? a : n.series.index > t.series.index ? -1 : 1);
                  }

                  i && (n = t);
                }), n;
              }, a4.prototype.getChartCoordinatesFromPoint = function (t, e) {
                var r = t.series,
                    n = r.xAxis;
                r = r.yAxis;
                var i = t.shapeArgs;

                if (n && r) {
                  var o = v(t.clientX, t.plotX),
                      a = t.plotY || 0;
                  return t.isNode && i && p(i.x) && p(i.y) && (o = i.x, a = i.y), e ? {
                    chartX: r.len + r.pos - a,
                    chartY: n.len + n.pos - o
                  } : {
                    chartX: o + n.pos,
                    chartY: a + r.pos
                  };
                }

                if (i && i.x && i.y) return {
                  chartX: i.x,
                  chartY: i.y
                };
              }, a4.prototype.getChartPosition = function () {
                if (this.chartPosition) return this.chartPosition;
                var t = this.chart.container,
                    e = m(t);
                this.chartPosition = {
                  left: e.left,
                  top: e.top,
                  scaleX: 1,
                  scaleY: 1
                };
                var r = t.offsetWidth;
                return t = t.offsetHeight, 2 < r && 2 < t && (this.chartPosition.scaleX = e.width / r, this.chartPosition.scaleY = e.height / t), this.chartPosition;
              }, a4.prototype.getCoordinates = function (t) {
                var e = {
                  xAxis: [],
                  yAxis: []
                };
                return this.chart.axes.forEach(function (r) {
                  e[r.isXAxis ? "xAxis" : "yAxis"].push({
                    axis: r,
                    value: r.toValue(t[r.horiz ? "chartX" : "chartY"])
                  });
                }), e;
              }, a4.prototype.getHoverData = function (t, e, r, n, i, o) {
                var a = [];
                n = !(!n || !t);

                var s = function n2(t) {
                  return t.visible && !(!i && t.directTouch) && v(t.options.enableMouseTracking, !0);
                },
                    c = {
                  chartX: o ? o.chartX : void 0,
                  chartY: o ? o.chartY : void 0,
                  shared: i
                };

                f(this, "beforeGetHoverData", c);
                var l = e && !e.stickyTracking ? [e] : r.filter(function (t) {
                  return t.stickyTracking && (c.filter || s)(t);
                }),
                    u = n || !o ? t : this.findNearestKDPoint(l, i, o);
                return e = u && u.series, u && (i && !e.noSharedTooltip ? (l = r.filter(function (t) {
                  return c.filter ? c.filter(t) : s(t) && !t.noSharedTooltip;
                })).forEach(function (t) {
                  var e = d(t.points, function (t) {
                    return t.x === u.x && !t.isNull;
                  });
                  y(e) && (t.boosted && t.boost && (e = t.boost.getPoint(e)), a.push(e));
                }) : a.push(u)), f(this, "afterGetHoverData", c = {
                  hoverPoint: u
                }), {
                  hoverPoint: c.hoverPoint,
                  hoverSeries: e,
                  hoverPoints: a
                };
              }, a4.prototype.getPointFromEvent = function (t) {
                t = t.target;

                for (var e; t && !e;) {
                  e = t.point, t = t.parentNode;
                }

                return e;
              }, a4.prototype.onTrackerMouseOut = function (t) {
                t = t.relatedTarget || t.toElement;
                var e = this.chart.hoverSeries;
                this.isDirectTouch = !1, !e || !t || e.stickyTracking || this.inClass(t, "highcharts-tooltip") || this.inClass(t, "highcharts-series-" + e.index) && this.inClass(t, "highcharts-tracker") || e.onMouseOut();
              }, a4.prototype.inClass = function (t, e) {
                for (var r; t;) {
                  if (r = c(t, "class")) {
                    if (-1 !== r.indexOf(e)) return !0;
                    if (-1 !== r.indexOf("highcharts-container")) return !1;
                  }

                  t = t.parentElement;
                }
              }, a4.prototype.init = function (t, e) {
                this.options = e, this.chart = t, this.runChartClick = !(!e.chart.events || !e.chart.events.click), this.pinchDown = [], this.lastValidTouch = {}, r && (t.tooltip = new r(t, e.tooltip)), this.setDOMEvents();
              }, a4.prototype.normalize = function (t, e) {
                var r = t.touches,
                    n = r ? r.length ? r.item(0) : v(r.changedTouches, t.changedTouches)[0] : t;
                return e || (e = this.getChartPosition()), r = n.pageX - e.left, n = n.pageY - e.top, r /= e.scaleX, n /= e.scaleY, h(t, {
                  chartX: Math.round(r),
                  chartY: Math.round(n)
                });
              }, a4.prototype.onContainerClick = function (t) {
                var e = this.chart,
                    r = e.hoverPoint;
                t = this.normalize(t);
                var n = e.plotLeft,
                    i = e.plotTop;
                e.cancelClick || (r && this.inClass(t.target, "highcharts-tracker") ? (f(r.series, "click", h(t, {
                  point: r
                })), e.hoverPoint && r.firePointEvent("click", t)) : (h(t, this.getCoordinates(t)), e.isInsidePlot(t.chartX - n, t.chartY - i, {
                  visiblePlotOnly: !0
                }) && f(e, "click", t)));
              }, a4.prototype.onContainerMouseDown = function (t) {
                var r = 1 === (1 & (t.buttons || t.button));
                t = this.normalize(t), e.isFirefox && 0 !== t.button && this.onContainerMouseMove(t), ("undefined" === typeof t.button || r) && (this.zoomOption(t), r && t.preventDefault && t.preventDefault(), this.dragStart(t));
              }, a4.prototype.onContainerMouseLeave = function (t) {
                var e = o[v(a4.hoverChartIndex, -1)],
                    r = this.chart.tooltip;
                t = this.normalize(t), e && (t.relatedTarget || t.toElement) && (e.pointer.reset(), e.pointer.chartPosition = void 0), r && !r.isHidden && this.reset();
              }, a4.prototype.onContainerMouseEnter = function (t) {
                delete this.chartPosition;
              }, a4.prototype.onContainerMouseMove = function (t) {
                var e = this.chart,
                    r = e.tooltip;
                t = this.normalize(t), this.setHoverChartIndex(), t.preventDefault || (t.returnValue = !1), ("mousedown" === e.mouseIsDown || this.touchSelect(t)) && this.drag(t), e.openMenu || !this.inClass(t.target, "highcharts-tracker") && !e.isInsidePlot(t.chartX - e.plotLeft, t.chartY - e.plotTop, {
                  visiblePlotOnly: !0
                }) || r && r.shouldStickOnContact(t) || (this.inClass(t.target, "highcharts-no-tooltip") ? this.reset(!1, 0) : this.runPointActions(t));
              }, a4.prototype.onDocumentTouchEnd = function (t) {
                var e = o[v(a4.hoverChartIndex, -1)];
                e && e.pointer.drop(t);
              }, a4.prototype.onContainerTouchMove = function (t) {
                this.touchSelect(t) ? this.onContainerMouseMove(t) : this.touch(t);
              }, a4.prototype.onContainerTouchStart = function (t) {
                this.touchSelect(t) ? this.onContainerMouseDown(t) : (this.zoomOption(t), this.touch(t, !0));
              }, a4.prototype.onDocumentMouseMove = function (t) {
                var e = this.chart,
                    r = e.tooltip,
                    n = this.chartPosition;
                t = this.normalize(t, n), !n || e.isInsidePlot(t.chartX - e.plotLeft, t.chartY - e.plotTop, {
                  visiblePlotOnly: !0
                }) || r && r.shouldStickOnContact(t) || this.inClass(t.target, "highcharts-tracker") || this.reset();
              }, a4.prototype.onDocumentMouseUp = function (t) {
                var e = o[v(a4.hoverChartIndex, -1)];
                e && e.pointer.drop(t);
              }, a4.prototype.pinch = function (t) {
                var e = this,
                    r = e.chart,
                    n = e.pinchDown,
                    i = t.touches || [],
                    o = i.length,
                    s = e.lastValidTouch,
                    c = e.hasZoom,
                    l = {},
                    u = 1 === o && (e.inClass(t.target, "highcharts-tracker") && r.runTrackerClick || e.runChartClick),
                    d = {},
                    p = e.chart.tooltip;
                p = 1 === o && v(p && p.options.followTouchMove, !0);
                var y = e.selectionMarker;
                1 < o ? e.initiated = !0 : p && (e.initiated = !1), c && e.initiated && !u && !1 !== t.cancelable && t.preventDefault(), [].map.call(i, function (t) {
                  return e.normalize(t);
                }), "touchstart" === t.type ? ([].forEach.call(i, function (t, e) {
                  n[e] = {
                    chartX: t.chartX,
                    chartY: t.chartY
                  };
                }), s.x = [n[0].chartX, n[1] && n[1].chartX], s.y = [n[0].chartY, n[1] && n[1].chartY], r.axes.forEach(function (t) {
                  if (t.zoomEnabled) {
                    var e = r.bounds[t.horiz ? "h" : "v"],
                        n = t.minPixelPadding,
                        i = t.toPixels(Math.min(v(t.options.min, t.dataMin), t.dataMin)),
                        o = t.toPixels(Math.max(v(t.options.max, t.dataMax), t.dataMax)),
                        a = Math.max(i, o);
                    e.min = Math.min(t.pos, Math.min(i, o) - n), e.max = Math.max(t.pos + t.len, a + n);
                  }
                }), e.res = !0) : p ? this.runPointActions(e.normalize(t)) : n.length && (f(r, "touchpan", {
                  originalEvent: t
                }, function () {
                  y || (e.selectionMarker = y = h({
                    destroy: a,
                    touch: !0
                  }, r.plotBox)), e.pinchTranslate(n, i, l, y, d, s), e.hasPinched = c, e.scaleGroups(l, d);
                }), e.res && (e.res = !1, this.reset(!1, 0)));
              }, a4.prototype.pinchTranslate = function (t, e, r, n, i, o) {
                this.zoomHor && this.pinchTranslateDirection(!0, t, e, r, n, i, o), this.zoomVert && this.pinchTranslateDirection(!1, t, e, r, n, i, o);
              }, a4.prototype.pinchTranslateDirection = function (t, e, r, n, i, o, a, s) {
                var c = this.chart,
                    l = t ? "x" : "y",
                    u = t ? "X" : "Y",
                    h = "chart" + u,
                    d = t ? "width" : "height",
                    f = c["plot" + (t ? "Left" : "Top")],
                    p = c.inverted,
                    y = c.bounds[t ? "h" : "v"],
                    g = 1 === e.length,
                    m = e[0][h],
                    v = !g && e[1][h];

                e = function d4() {
                  "number" === typeof O && 20 < Math.abs(m - v) && (w = s || Math.abs(S - O) / Math.abs(m - v)), x = (f - S) / w + m, b = c["plot" + (t ? "Width" : "Height")] / w;
                };

                var b,
                    x,
                    w = s || 1,
                    S = r[0][h],
                    O = !g && r[1][h];

                if (e(), (r = x) < y.min) {
                  r = y.min;
                  var E = !0;
                } else r + b > y.max && (r = y.max - b, E = !0);

                E ? (S -= .8 * (S - a[l][0]), "number" === typeof O && (O -= .8 * (O - a[l][1])), e()) : a[l] = [S, O], p || (o[l] = x - f, o[d] = b), o = p ? 1 / w : w, i[d] = b, i[l] = r, n[p ? t ? "scaleY" : "scaleX" : "scale" + u] = w, n["translate" + u] = o * f + (S - o * m);
              }, a4.prototype.reset = function (t, e) {
                var r = this.chart,
                    n = r.hoverSeries,
                    i = r.hoverPoint,
                    o = r.hoverPoints,
                    a = r.tooltip,
                    s = a && a.shared ? o : i;
                t && s && b(s).forEach(function (e) {
                  e.series.isCartesian && "undefined" === typeof e.plotX && (t = !1);
                }), t ? a && s && b(s).length && (a.refresh(s), a.shared && o ? o.forEach(function (t) {
                  t.setState(t.state, !0), t.series.isCartesian && (t.series.xAxis.crosshair && t.series.xAxis.drawCrosshair(null, t), t.series.yAxis.crosshair && t.series.yAxis.drawCrosshair(null, t));
                }) : i && (i.setState(i.state, !0), r.axes.forEach(function (t) {
                  t.crosshair && i.series[t.coll] === t && t.drawCrosshair(null, i);
                }))) : (i && i.onMouseOut(), o && o.forEach(function (t) {
                  t.setState();
                }), n && n.onMouseOut(), a && a.hide(e), this.unDocMouseMove && (this.unDocMouseMove = this.unDocMouseMove()), r.axes.forEach(function (t) {
                  t.hideCrosshair();
                }), this.hoverX = r.hoverPoints = r.hoverPoint = null);
              }, a4.prototype.runPointActions = function (t, e, r) {
                var n = this.chart,
                    i = n.tooltip && n.tooltip.options.enabled ? n.tooltip : void 0,
                    a = !!i && i.shared,
                    c = e || n.hoverPoint,
                    l = c && c.series || n.hoverSeries;
                e = this.getHoverData(c, l, n.series, (!t || "touchmove" !== t.type) && (!!e || l && l.directTouch && this.isDirectTouch), a, t), c = e.hoverPoint, l = e.hoverSeries;
                var u = e.hoverPoints;
                e = l && l.tooltipOptions.followPointer && !l.tooltipOptions.split;
                var h = a && l && !l.noSharedTooltip;

                if (c && (r || c !== n.hoverPoint || i && i.isHidden)) {
                  if ((n.hoverPoints || []).forEach(function (t) {
                    -1 === u.indexOf(t) && t.setState();
                  }), n.hoverSeries !== l && l.onMouseOver(), this.applyInactiveState(u), (u || []).forEach(function (t) {
                    t.setState("hover");
                  }), n.hoverPoint && n.hoverPoint.firePointEvent("mouseOut"), !c.series) return;
                  n.hoverPoints = u, n.hoverPoint = c, c.firePointEvent("mouseOver", void 0, function () {
                    i && c && i.refresh(h ? u : c, t);
                  });
                } else e && i && !i.isHidden && (r = i.getAnchor([{}], t), n.isInsidePlot(r[0], r[1], {
                  visiblePlotOnly: !0
                }) && i.updatePosition({
                  plotX: r[0],
                  plotY: r[1]
                }));

                this.unDocMouseMove || (this.unDocMouseMove = s(n.container.ownerDocument, "mousemove", function (t) {
                  var e = o[a4.hoverChartIndex];
                  e && e.pointer.onDocumentMouseMove(t);
                }), this.eventsToUnbind.push(this.unDocMouseMove)), n.axes.forEach(function (e) {
                  var r,
                      i = v((e.crosshair || {}).snap, !0);
                  i && ((r = n.hoverPoint) && r.series[e.coll] === e || (r = d(u, function (t) {
                    return t.series && t.series[e.coll] === e;
                  }))), r || !i ? e.drawCrosshair(t, r) : e.hideCrosshair();
                });
              }, a4.prototype.scaleGroups = function (t, e) {
                var r = this.chart;
                r.series.forEach(function (n) {
                  var i = t || n.getPlotBox();
                  n.group && (n.xAxis && n.xAxis.zoomEnabled || r.mapView) && (n.group.attr(i), n.markerGroup && (n.markerGroup.attr(i), n.markerGroup.clip(e ? r.clipRect : null)), n.dataLabelsGroup && n.dataLabelsGroup.attr(i));
                }), r.clipRect.attr(e || r.clipBox);
              }, a4.prototype.setDOMEvents = function () {
                var t = this,
                    r = this.chart.container,
                    n = r.ownerDocument;
                r.onmousedown = this.onContainerMouseDown.bind(this), r.onmousemove = this.onContainerMouseMove.bind(this), r.onclick = this.onContainerClick.bind(this), this.eventsToUnbind.push(s(r, "mouseenter", this.onContainerMouseEnter.bind(this))), this.eventsToUnbind.push(s(r, "mouseleave", this.onContainerMouseLeave.bind(this))), a4.unbindDocumentMouseUp || (a4.unbindDocumentMouseUp = s(n, "mouseup", this.onDocumentMouseUp.bind(this)));

                for (var i = this.chart.renderTo.parentElement; i && "BODY" !== i.tagName;) {
                  this.eventsToUnbind.push(s(i, "scroll", function () {
                    delete t.chartPosition;
                  })), i = i.parentElement;
                }

                e.hasTouch && (this.eventsToUnbind.push(s(r, "touchstart", this.onContainerTouchStart.bind(this), {
                  passive: !1
                })), this.eventsToUnbind.push(s(r, "touchmove", this.onContainerTouchMove.bind(this), {
                  passive: !1
                })), a4.unbindDocumentTouchEnd || (a4.unbindDocumentTouchEnd = s(n, "touchend", this.onDocumentTouchEnd.bind(this), {
                  passive: !1
                })));
              }, a4.prototype.setHoverChartIndex = function () {
                var t = this.chart,
                    r = e.charts[v(a4.hoverChartIndex, -1)];
                r && r !== t && r.pointer.onContainerMouseLeave({
                  relatedTarget: t.container
                }), r && r.mouseIsDown || (a4.hoverChartIndex = t.index);
              }, a4.prototype.touch = function (t, e) {
                var r = this.chart;
                if (this.setHoverChartIndex(), 1 === t.touches.length) {
                  if (t = this.normalize(t), r.isInsidePlot(t.chartX - r.plotLeft, t.chartY - r.plotTop, {
                    visiblePlotOnly: !0
                  }) && !r.openMenu) {
                    if (e && this.runPointActions(t), "touchmove" === t.type) var n = !!(e = this.pinchDown)[0] && 4 <= Math.sqrt(Math.pow(e[0].chartX - t.chartX, 2) + Math.pow(e[0].chartY - t.chartY, 2));
                    v(n, !0) && this.pinch(t);
                  } else e && this.reset();
                } else 2 === t.touches.length && this.pinch(t);
              }, a4.prototype.touchSelect = function (t) {
                return !(!this.chart.options.chart.zooming.singleTouch || !t.touches || 1 !== t.touches.length);
              }, a4.prototype.zoomOption = function (t) {
                var e = this.chart,
                    r = e.options.chart;
                e = e.inverted;
                var n = r.zooming.type || "";
                /touch/.test(t.type) && (n = v(r.zooming.pinchType, n)), this.zoomX = t = /x/.test(n), this.zoomY = r = /y/.test(n), this.zoomHor = t && !e || r && e, this.zoomVert = r && !e || t && e, this.hasZoom = t || r;
              }, a4;
            }();
          }), K2(e, "Core/MSPointer.js", [e["Core/Globals.js"], e["Core/Pointer.js"], e["Core/Utilities.js"]], function (t, e, r) {
            function A() {
              var t = [];
              return t.item = function (t) {
                return this[t];
              }, u(f, function (e) {
                t.push({
                  pageX: e.pageX,
                  pageY: e.pageY,
                  target: e.target
                });
              }), t;
            }

            function C(t, r, n, o) {
              var s = i[e.hoverChartIndex || NaN];
              "touch" !== t.pointerType && t.pointerType !== t.MSPOINTER_TYPE_TOUCH || !s || (s = s.pointer, o(t), s[r]({
                type: n,
                target: t.currentTarget,
                preventDefault: a,
                touches: A()
              }));
            }

            var n = this && this.__extends || function () {
              var t = function a4(e, r) {
                return (t = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, e) {
                  t.__proto__ = e;
                } || function (t, e) {
                  for (var r in e) {
                    e.hasOwnProperty(r) && (t[r] = e[r]);
                  }
                })(e, r);
              };

              return function (e, r) {
                function h5() {
                  this.constructor = e;
                }

                t(e, r), e.prototype = null === r ? Object.create(r) : (h5.prototype = r.prototype, new h5());
              };
            }(),
                i = t.charts,
                o = t.doc,
                a = t.noop,
                s = t.win,
                c = r.addEvent,
                l = r.css,
                u = r.objectEach,
                h = r.pick,
                d = r.removeEvent,
                f = {},
                p = !!s.PointerEvent;

            return function (e) {
              function g4() {
                return null !== e && e.apply(this, arguments) || this;
              }

              return n(g4, e), g4.isRequired = function () {
                return !(t.hasTouch || !s.PointerEvent && !s.MSPointerEvent);
              }, g4.prototype.batchMSEvents = function (t) {
                t(this.chart.container, p ? "pointerdown" : "MSPointerDown", this.onContainerPointerDown), t(this.chart.container, p ? "pointermove" : "MSPointerMove", this.onContainerPointerMove), t(o, p ? "pointerup" : "MSPointerUp", this.onDocumentPointerUp);
              }, g4.prototype.destroy = function () {
                this.batchMSEvents(d), e.prototype.destroy.call(this);
              }, g4.prototype.init = function (t, r) {
                e.prototype.init.call(this, t, r), this.hasZoom && l(t.container, {
                  "-ms-touch-action": "none",
                  "touch-action": "none"
                });
              }, g4.prototype.onContainerPointerDown = function (t) {
                C(t, "onContainerTouchStart", "touchstart", function (t) {
                  f[t.pointerId] = {
                    pageX: t.pageX,
                    pageY: t.pageY,
                    target: t.currentTarget
                  };
                });
              }, g4.prototype.onContainerPointerMove = function (t) {
                C(t, "onContainerTouchMove", "touchmove", function (t) {
                  f[t.pointerId] = {
                    pageX: t.pageX,
                    pageY: t.pageY
                  }, f[t.pointerId].target || (f[t.pointerId].target = t.currentTarget);
                });
              }, g4.prototype.onDocumentPointerUp = function (t) {
                C(t, "onDocumentTouchEnd", "touchend", function (t) {
                  delete f[t.pointerId];
                });
              }, g4.prototype.setDOMEvents = function () {
                var t = this.chart.tooltip;
                e.prototype.setDOMEvents.call(this), (this.hasZoom || h(t && t.options.followTouchMove, !0)) && this.batchMSEvents(c);
              }, g4;
            }(e);
          }), K2(e, "Core/Legend/Legend.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/FormatUtilities.js"], e["Core/Globals.js"], e["Core/Series/Point.js"], e["Core/Renderer/RendererUtilities.js"], e["Core/Utilities.js"]], function (t, e, r, n, i, o) {
            var a = t.animObject,
                s = t.setAnimation,
                c = e.format,
                l = r.marginNames,
                u = i.distribute,
                h = o.addEvent,
                d = o.createElement,
                f = o.css,
                p = o.defined,
                y = o.discardElement,
                g = o.find,
                m = o.fireEvent,
                v = o.isNumber,
                b = o.merge,
                x = o.pick,
                w = o.relativeLength,
                S = o.stableSort,
                O = o.syncTimeout;
            return t = function () {
              function a4(t, e) {
                this.allItems = [], this.contentGroup = this.box = void 0, this.display = !1, this.group = void 0, this.offsetWidth = this.maxLegendWidth = this.maxItemWidth = this.legendWidth = this.legendHeight = this.lastLineHeight = this.lastItemY = this.itemY = this.itemX = this.itemMarginTop = this.itemMarginBottom = this.itemHeight = this.initialItemY = 0, this.options = void 0, this.padding = 0, this.pages = [], this.proximate = !1, this.scrollGroup = void 0, this.widthOption = this.totalItemWidth = this.titleHeight = this.symbolWidth = this.symbolHeight = 0, this.chart = t, this.init(t, e);
              }

              return a4.prototype.init = function (t, e) {
                this.chart = t, this.setOptions(e), e.enabled && (this.render(), h(this.chart, "endResize", function () {
                  this.legend.positionCheckboxes();
                }), this.proximate ? this.unchartrender = h(this.chart, "render", function () {
                  this.legend.proximatePositions(), this.legend.positionItems();
                }) : this.unchartrender && this.unchartrender());
              }, a4.prototype.setOptions = function (t) {
                var e = x(t.padding, 8);
                this.options = t, this.chart.styledMode || (this.itemStyle = t.itemStyle, this.itemHiddenStyle = b(this.itemStyle, t.itemHiddenStyle)), this.itemMarginTop = t.itemMarginTop || 0, this.itemMarginBottom = t.itemMarginBottom || 0, this.padding = e, this.initialItemY = e - 5, this.symbolWidth = x(t.symbolWidth, 16), this.pages = [], this.proximate = "proximate" === t.layout && !this.chart.inverted, this.baseline = void 0;
              }, a4.prototype.update = function (t, e) {
                var r = this.chart;
                this.setOptions(b(!0, this.options, t)), this.destroy(), r.isDirtyLegend = r.isDirtyBox = !0, x(e, !0) && r.redraw(), m(this, "afterUpdate");
              }, a4.prototype.colorizeItem = function (t, e) {
                var r = t.legendItem || {},
                    n = r.group,
                    i = r.label,
                    o = r.line;

                if (r = r.symbol, n && n[e ? "removeClass" : "addClass"]("highcharts-legend-item-hidden"), !this.chart.styledMode) {
                  var a = this.options;
                  n = this.itemHiddenStyle.color, a = e ? a.itemStyle.color : n;
                  var s = e && t.color || n,
                      c = t.options && t.options.marker,
                      l = {
                    fill: s
                  };
                  i && i.css({
                    fill: a,
                    color: a
                  }), o && o.attr({
                    stroke: s
                  }), r && (c && r.isMarker && (l = t.pointAttribs(), e || (l.stroke = l.fill = n)), r.attr(l));
                }

                m(this, "afterColorizeItem", {
                  item: t,
                  visible: e
                });
              }, a4.prototype.positionItems = function () {
                this.allItems.forEach(this.positionItem, this), this.chart.isResizing || this.positionCheckboxes();
              }, a4.prototype.positionItem = function (t) {
                var e = this,
                    r = t.legendItem || {},
                    n = r.group,
                    i = r.x;
                i = void 0 === i ? 0 : i, r = void 0 === (r = r.y) ? 0 : r;
                var o = this.options,
                    a = o.symbolPadding,
                    s = !o.rtl;
                o = t.checkbox, n && n.element && (a = {
                  translateX: s ? i : this.legendWidth - i - 2 * a - 4,
                  translateY: r
                }, n[p(n.translateY) ? "animate" : "attr"](a, void 0, function () {
                  m(e, "afterPositionItem", {
                    item: t
                  });
                })), o && (o.x = i, o.y = r);
              }, a4.prototype.destroyItem = function (t) {
                for (var e = t.checkbox, r = t.legendItem || {}, n = 0, i = ["group", "label", "line", "symbol"]; n < i.length; n++) {
                  var o = i[n];
                  r[o] && (r[o] = r[o].destroy());
                }

                e && y(e), t.legendItem = void 0;
              }, a4.prototype.destroy = function () {
                for (var t = 0, e = this.getAllItems(); t < e.length; t++) {
                  this.destroyItem(e[t]);
                }

                for (t = 0, e = "clipRect up down pager nav box title group".split(" "); t < e.length; t++) {
                  var r = e[t];
                  this[r] && (this[r] = this[r].destroy());
                }

                this.display = null;
              }, a4.prototype.positionCheckboxes = function () {
                var t = this.group && this.group.alignAttr,
                    e = this.clipHeight || this.legendHeight,
                    r = this.titleHeight;

                if (t) {
                  var n = t.translateY;
                  this.allItems.forEach(function (i) {
                    var o = i.checkbox;

                    if (o) {
                      var a = n + r + o.y + (this.scrollOffset || 0) + 3;
                      f(o, {
                        left: t.translateX + i.checkboxOffset + o.x - 20 + "px",
                        top: a + "px",
                        display: this.proximate || a > n - 6 && a < n + e - 6 ? "" : "none"
                      });
                    }
                  }, this);
                }
              }, a4.prototype.renderTitle = function () {
                var t = this.options,
                    e = this.padding,
                    r = t.title,
                    n = 0;
                r.text && (this.title || (this.title = this.chart.renderer.label(r.text, e - 3, e - 4, void 0, void 0, void 0, t.useHTML, void 0, "legend-title").attr({
                  zIndex: 1
                }), this.chart.styledMode || this.title.css(r.style), this.title.add(this.group)), r.width || this.title.css({
                  width: this.maxLegendWidth + "px"
                }), n = (t = this.title.getBBox()).height, this.offsetWidth = t.width, this.contentGroup.attr({
                  translateY: n
                })), this.titleHeight = n;
              }, a4.prototype.setText = function (t) {
                var e = this.options;
                t.legendItem.label.attr({
                  text: e.labelFormat ? c(e.labelFormat, t, this.chart) : e.labelFormatter.call(t)
                });
              }, a4.prototype.renderItem = function (t) {
                var e = t.legendItem = t.legendItem || {},
                    r = this.chart,
                    n = r.renderer,
                    i = this.options,
                    o = this.symbolWidth,
                    a = i.symbolPadding || 0,
                    s = this.itemStyle,
                    c = this.itemHiddenStyle,
                    l = "horizontal" === i.layout ? x(i.itemDistance, 20) : 0,
                    u = !i.rtl,
                    h = !t.series,
                    d = !h && t.series.drawLegendSymbol ? t.series : t,
                    f = d.options,
                    p = this.createCheckboxForItem && f && f.showCheckbox,
                    y = i.useHTML,
                    g = t.options.className,
                    m = e.label;
                f = o + a + l + (p ? 20 : 0), m || (e.group = n.g("legend-item").addClass("highcharts-" + d.type + "-series highcharts-color-" + t.colorIndex + (g ? " " + g : "") + (h ? " highcharts-series-" + t.index : "")).attr({
                  zIndex: 1
                }).add(this.scrollGroup), e.label = m = n.text("", u ? o + a : -a, this.baseline || 0, y), r.styledMode || m.css(b(t.visible ? s : c)), m.attr({
                  align: u ? "left" : "right",
                  zIndex: 2
                }).add(e.group), this.baseline || (this.fontMetrics = n.fontMetrics(r.styledMode ? 12 : s.fontSize, m), this.baseline = this.fontMetrics.f + 3 + this.itemMarginTop, m.attr("y", this.baseline), this.symbolHeight = i.symbolHeight || this.fontMetrics.f, i.squareSymbol && (this.symbolWidth = x(i.symbolWidth, Math.max(this.symbolHeight, 16)), f = this.symbolWidth + a + l + (p ? 20 : 0), u && m.attr("x", this.symbolWidth + a))), d.drawLegendSymbol(this, t), this.setItemEvents && this.setItemEvents(t, m, y)), p && !t.checkbox && this.createCheckboxForItem && this.createCheckboxForItem(t), this.colorizeItem(t, t.visible), !r.styledMode && s.width || m.css({
                  width: (i.itemWidth || this.widthOption || r.spacingBox.width) - f + "px"
                }), this.setText(t), r = m.getBBox(), n = this.fontMetrics && this.fontMetrics.h || 0, t.itemWidth = t.checkboxOffset = i.itemWidth || e.labelWidth || r.width + f, this.maxItemWidth = Math.max(this.maxItemWidth, t.itemWidth), this.totalItemWidth += t.itemWidth, this.itemHeight = t.itemHeight = Math.round(e.labelHeight || (r.height > 1.5 * n ? r.height : n));
              }, a4.prototype.layoutItem = function (t) {
                var e = this.options,
                    r = this.padding,
                    n = "horizontal" === e.layout,
                    i = t.itemHeight,
                    o = this.itemMarginBottom,
                    a = this.itemMarginTop,
                    s = n ? x(e.itemDistance, 20) : 0,
                    c = this.maxLegendWidth;
                e = e.alignColumns && this.totalItemWidth > c ? this.maxItemWidth : t.itemWidth;
                var l = t.legendItem || {};
                n && this.itemX - r + e > c && (this.itemX = r, this.lastLineHeight && (this.itemY += a + this.lastLineHeight + o), this.lastLineHeight = 0), this.lastItemY = a + this.itemY + o, this.lastLineHeight = Math.max(i, this.lastLineHeight), l.x = this.itemX, l.y = this.itemY, n ? this.itemX += e : (this.itemY += a + i + o, this.lastLineHeight = i), this.offsetWidth = this.widthOption || Math.max((n ? this.itemX - r - (t.checkbox ? 0 : s) : e) + r, this.offsetWidth);
              }, a4.prototype.getAllItems = function () {
                var t = [];
                return this.chart.series.forEach(function (e) {
                  var r = e && e.options;
                  e && x(r.showInLegend, !p(r.linkedTo) && void 0, !0) && (t = t.concat((e.legendItem || {}).labels || ("point" === r.legendType ? e.data : e)));
                }), m(this, "afterGetAllItems", {
                  allItems: t
                }), t;
              }, a4.prototype.getAlignment = function () {
                var t = this.options;
                return this.proximate ? t.align.charAt(0) + "tv" : t.floating ? "" : t.align.charAt(0) + t.verticalAlign.charAt(0) + t.layout.charAt(0);
              }, a4.prototype.adjustMargins = function (t, e) {
                var r = this.chart,
                    n = this.options,
                    i = this.getAlignment();
                i && [/(lth|ct|rth)/, /(rtv|rm|rbv)/, /(rbh|cb|lbh)/, /(lbv|lm|ltv)/].forEach(function (o, a) {
                  o.test(i) && !p(t[a]) && (r[l[a]] = Math.max(r[l[a]], r.legend[(a + 1) % 2 ? "legendHeight" : "legendWidth"] + [1, -1, -1, 1][a] * n[a % 2 ? "x" : "y"] + x(n.margin, 12) + e[a] + (r.titleOffset[a] || 0)));
                });
              }, a4.prototype.proximatePositions = function () {
                var t = this.chart,
                    e = [],
                    r = "left" === this.options.align;
                this.allItems.forEach(function (n) {
                  var i,
                      o = r;

                  if (n.yAxis) {
                    n.xAxis.options.reversed && (o = !o), n.points && (i = g(o ? n.points : n.points.slice(0).reverse(), function (t) {
                      return v(t.plotY);
                    })), o = this.itemMarginTop + n.legendItem.label.getBBox().height + this.itemMarginBottom;
                    var a = n.yAxis.top - t.plotTop;
                    n.visible ? (i = i ? i.plotY : n.yAxis.height, i += a - .3 * o) : i = a + n.yAxis.height, e.push({
                      target: i,
                      size: o,
                      item: n
                    });
                  }
                }, this);

                for (var n, i = 0, o = u(e, t.plotHeight); i < o.length; i++) {
                  var a = o[i];
                  n = a.item.legendItem || {}, v(a.pos) && (n.y = t.plotTop - t.spacing[0] + a.pos);
                }
              }, a4.prototype.render = function () {
                var t = this.chart,
                    e = t.renderer,
                    r = this.options,
                    n = this.padding,
                    i = this.getAllItems(),
                    o = this.group,
                    a = this.box;
                this.itemX = n, this.itemY = this.initialItemY, this.lastItemY = this.offsetWidth = 0, this.widthOption = w(r.width, t.spacingBox.width - n);
                var s = t.spacingBox.width - 2 * n - r.x;
                -1 < ["rm", "lm"].indexOf(this.getAlignment().substring(0, 2)) && (s /= 2), this.maxLegendWidth = this.widthOption || s, o || (this.group = o = e.g("legend").addClass(r.className || "").attr({
                  zIndex: 7
                }).add(), this.contentGroup = e.g().attr({
                  zIndex: 1
                }).add(o), this.scrollGroup = e.g().add(this.contentGroup)), this.renderTitle(), S(i, function (t, e) {
                  return (t.options && t.options.legendIndex || 0) - (e.options && e.options.legendIndex || 0);
                }), r.reversed && i.reverse(), this.allItems = i, this.display = s = !!i.length, this.itemHeight = this.totalItemWidth = this.maxItemWidth = this.lastLineHeight = 0, i.forEach(this.renderItem, this), i.forEach(this.layoutItem, this), i = (this.widthOption || this.offsetWidth) + n;
                var c = this.lastItemY + this.lastLineHeight + this.titleHeight;
                c = this.handleOverflow(c), c += n, a || (this.box = a = e.rect().addClass("highcharts-legend-box").attr({
                  r: r.borderRadius
                }).add(o)), t.styledMode || a.attr({
                  stroke: r.borderColor,
                  "stroke-width": r.borderWidth || 0,
                  fill: r.backgroundColor || "none"
                }).shadow(r.shadow), 0 < i && 0 < c && a[a.placed ? "animate" : "attr"](a.crisp.call({}, {
                  x: 0,
                  y: 0,
                  width: i,
                  height: c
                }, a.strokeWidth())), o[s ? "show" : "hide"](), t.styledMode && "none" === o.getStyle("display") && (i = c = 0), this.legendWidth = i, this.legendHeight = c, s && this.align(), this.proximate || this.positionItems(), m(this, "afterRender");
              }, a4.prototype.align = function (t) {
                void 0 === t && (t = this.chart.spacingBox);
                var e = this.chart,
                    r = this.options,
                    n = t.y;
                /(lth|ct|rth)/.test(this.getAlignment()) && 0 < e.titleOffset[0] ? n += e.titleOffset[0] : /(lbh|cb|rbh)/.test(this.getAlignment()) && 0 < e.titleOffset[2] && (n -= e.titleOffset[2]), n !== t.y && (t = b(t, {
                  y: n
                })), e.hasRendered || (this.group.placed = !1), this.group.align(b(r, {
                  width: this.legendWidth,
                  height: this.legendHeight,
                  verticalAlign: this.proximate ? "top" : r.verticalAlign
                }), !0, t);
              }, a4.prototype.handleOverflow = function (t) {
                var e,
                    r,
                    n,
                    i = this,
                    o = this.chart,
                    a = o.renderer,
                    s = this.options,
                    c = s.y,
                    l = "top" === s.verticalAlign,
                    u = this.padding,
                    h = s.maxHeight,
                    d = s.navigation,
                    f = x(d.animation, !0),
                    p = d.arrowSize || 12,
                    y = this.pages,
                    g = this.allItems,
                    m = function w3(t) {
                  "number" === typeof t ? w.attr({
                    height: t
                  }) : w && (i.clipRect = w.destroy(), i.contentGroup.clip()), i.contentGroup.div && (i.contentGroup.div.style.clip = t ? "rect(" + u + "px,9999px," + (u + t) + "px,0)" : "auto");
                },
                    v = function G2(t) {
                  return i[t] = a.circle(0, 0, 1.3 * p).translate(p / 2, p / 2).add(b), o.styledMode || i[t].attr("fill", "rgba(0,0,0,0.0001)"), i[t];
                };

                c = o.spacingBox.height + (l ? -c : c) - u;
                var b = this.nav,
                    w = this.clipRect;
                return "horizontal" !== s.layout || "middle" === s.verticalAlign || s.floating || (c /= 2), h && (c = Math.min(c, h)), y.length = 0, t && 0 < c && t > c && !1 !== d.enabled ? (this.clipHeight = e = Math.max(c - 20 - this.titleHeight - u, 0), this.currentPage = x(this.currentPage, 1), this.fullHeight = t, g.forEach(function (t, i) {
                  t = (n = t.legendItem || {}).y || 0;
                  var o = Math.round(n.label.getBBox().height),
                      a = y.length;
                  (!a || t - y[a - 1] > e && (r || t) !== y[a - 1]) && (y.push(r || t), a++), n.pageIx = a - 1, r && ((g[i - 1].legendItem || {}).pageIx = a - 1), i === g.length - 1 && t + o - y[a - 1] > e && o <= e && (y.push(t), n.pageIx = a), t !== r && (r = t);
                }), w || (w = i.clipRect = a.clipRect(0, u, 9999, 0), i.contentGroup.clip(w)), m(e), b || (this.nav = b = a.g().attr({
                  zIndex: 1
                }).add(this.group), this.up = a.symbol("triangle", 0, 0, p, p).add(b), v("upTracker").on("click", function () {
                  i.scroll(-1, f);
                }), this.pager = a.text("", 15, 10).addClass("highcharts-legend-navigation"), !o.styledMode && d.style && this.pager.css(d.style), this.pager.add(b), this.down = a.symbol("triangle-down", 0, 0, p, p).add(b), v("downTracker").on("click", function () {
                  i.scroll(1, f);
                })), i.scroll(0), t = c) : b && (m(), this.nav = b.destroy(), this.scrollGroup.attr({
                  translateY: 1
                }), this.clipHeight = 0), t;
              }, a4.prototype.scroll = function (t, e) {
                var r = this,
                    n = this.chart,
                    i = this.pages,
                    o = i.length,
                    c = this.clipHeight,
                    l = this.options.navigation,
                    u = this.pager,
                    h = this.padding,
                    d = this.currentPage + t;
                d > o && (d = o), 0 < d && ("undefined" !== typeof e && s(e, n), this.nav.attr({
                  translateX: h,
                  translateY: c + this.padding + 7 + this.titleHeight,
                  visibility: "inherit"
                }), [this.up, this.upTracker].forEach(function (t) {
                  t.attr({
                    class: 1 === d ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active"
                  });
                }), u.attr({
                  text: d + "/" + o
                }), [this.down, this.downTracker].forEach(function (t) {
                  t.attr({
                    x: 18 + this.pager.getBBox().width,
                    class: d === o ? "highcharts-legend-nav-inactive" : "highcharts-legend-nav-active"
                  });
                }, this), n.styledMode || (this.up.attr({
                  fill: 1 === d ? l.inactiveColor : l.activeColor
                }), this.upTracker.css({
                  cursor: 1 === d ? "default" : "pointer"
                }), this.down.attr({
                  fill: d === o ? l.inactiveColor : l.activeColor
                }), this.downTracker.css({
                  cursor: d === o ? "default" : "pointer"
                })), this.scrollOffset = -i[d - 1] + this.initialItemY, this.scrollGroup.animate({
                  translateY: this.scrollOffset
                }), this.currentPage = d, this.positionCheckboxes(), t = a(x(e, n.renderer.globalAnimation, !0)), O(function () {
                  m(r, "afterScroll", {
                    currentPage: d
                  });
                }, t.duration));
              }, a4.prototype.setItemEvents = function (t, e, r) {
                var i = this,
                    o = t.legendItem || {},
                    a = i.chart.renderer.boxWrapper,
                    s = t instanceof n,
                    c = "highcharts-legend-" + (s ? "point" : "series") + "-active",
                    l = i.chart.styledMode,
                    u = function n2(e) {
                  i.allItems.forEach(function (r) {
                    t !== r && [r].concat(r.linkedSeries || []).forEach(function (t) {
                      t.setState(e, !s);
                    });
                  });
                },
                    h = 0;

                for (r = r ? [e, o.symbol] : [o.group]; h < r.length; h++) {
                  (o = r[h]) && o.on("mouseover", function () {
                    t.visible && u("inactive"), t.setState("hover"), t.visible && a.addClass(c), l || e.css(i.options.itemHoverStyle);
                  }).on("mouseout", function () {
                    i.chart.styledMode || e.css(b(t.visible ? i.itemStyle : i.itemHiddenStyle)), u(""), a.removeClass(c), t.setState();
                  }).on("click", function (e) {
                    var r = function c4() {
                      t.setVisible && t.setVisible(), u(t.visible ? "inactive" : "");
                    };

                    a.removeClass(c), e = {
                      browserEvent: e
                    }, t.firePointEvent ? t.firePointEvent("legendItemClick", e, r) : m(t, "legendItemClick", e, r);
                  });
                }
              }, a4.prototype.createCheckboxForItem = function (t) {
                t.checkbox = d("input", {
                  type: "checkbox",
                  className: "highcharts-legend-checkbox",
                  checked: t.selected,
                  defaultChecked: t.selected
                }, this.options.itemCheckboxStyle, this.chart.container), h(t.checkbox, "click", function (e) {
                  m(t.series || t, "checkboxClick", {
                    checked: e.target.checked,
                    item: t
                  }, function () {
                    t.select();
                  });
                });
              }, a4;
            }();
          }), K2(e, "Core/Series/SeriesRegistry.js", [e["Core/Globals.js"], e["Core/Defaults.js"], e["Core/Series/Point.js"], e["Core/Utilities.js"]], function (t, e, r, n) {
            var i,
                o = e.defaultOptions,
                a = n.extendClass,
                s = n.merge;
            return function (e) {
              function l2(t, n) {
                var i = o.plotOptions || {},
                    a = n.defaultOptions,
                    s = n.prototype;
                s.type = t, s.pointClass || (s.pointClass = r), a && (i[t] = a), e.seriesTypes[t] = n;
              }

              e.seriesTypes = t.seriesTypes, e.registerSeriesType = l2, e.seriesType = function (t, n, i, c, l) {
                var u = o.plotOptions || {};
                return n = n || "", u[t] = s(u[n], i), l2(t, a(e.seriesTypes[n] || function () {}, c)), e.seriesTypes[t].prototype.type = t, l && (e.seriesTypes[t].prototype.pointClass = a(r, l)), e.seriesTypes[t];
              };
            }(i || (i = {})), i;
          }), K2(e, "Core/Chart/Chart.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Axis/Axis.js"], e["Core/Defaults.js"], e["Core/FormatUtilities.js"], e["Core/Foundation.js"], e["Core/Globals.js"], e["Core/Legend/Legend.js"], e["Core/MSPointer.js"], e["Core/Pointer.js"], e["Core/Renderer/RendererRegistry.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Renderer/SVG/SVGRenderer.js"], e["Core/Time.js"], e["Core/Utilities.js"], e["Core/Renderer/HTML/AST.js"]], function (t, e, r, n, i, o, a, s, c, l, u, h, d, f, p) {
            var y = t.animate,
                g = t.animObject,
                m = t.setAnimation,
                v = r.defaultOptions,
                b = r.defaultTime,
                x = n.numberFormat,
                w = i.registerEventOptions,
                S = o.charts,
                O = o.doc,
                E = o.marginNames,
                k = o.svg,
                _ = o.win,
                C = u.seriesTypes,
                T = f.addEvent,
                A = f.attr,
                M = f.cleanRecursively,
                P = f.createElement,
                j = f.css,
                R = f.defined,
                D = f.discardElement,
                I = f.erase,
                L = f.error,
                N = f.extend,
                B = f.find,
                F = f.fireEvent,
                U = f.getStyle,
                W = f.isArray,
                z = f.isNumber,
                q = f.isObject,
                H = f.isString,
                G = f.merge,
                Y = f.objectEach,
                X = f.pick,
                V = f.pInt,
                $ = f.relativeLength,
                Q = f.removeEvent,
                K = f.splat,
                Z = f.syncTimeout,
                J = f.uniqueKey;
            return t = function () {
              function a4(t, e, r) {
                this.series = this.renderTo = this.renderer = this.pointer = this.pointCount = this.plotWidth = this.plotTop = this.plotLeft = this.plotHeight = this.plotBox = this.options = this.numberFormatter = this.margin = this.legend = this.labelCollectors = this.isResizing = this.index = this.eventOptions = this.container = this.colorCounter = this.clipBox = this.chartWidth = this.chartHeight = this.bounds = this.axisOffset = this.axes = void 0, this.sharedClips = {}, this.yAxis = this.xAxis = this.userOptions = this.titleOffset = this.time = this.symbolCounter = this.spacingBox = this.spacing = void 0, this.getArgs(t, e, r);
              }

              return a4.chart = function (t, e, r) {
                return new a4(t, e, r);
              }, a4.prototype.getArgs = function (t, e, r) {
                H(t) || t.nodeName ? (this.renderTo = t, this.init(e, r)) : this.init(t, e);
              }, a4.prototype.init = function (t, e) {
                var r = t.plotOptions || {};
                F(this, "init", {
                  args: arguments
                }, function () {
                  var n = G(v, t),
                      i = n.chart;
                  Y(n.plotOptions, function (t, e) {
                    q(t) && (t.tooltip = r[e] && G(r[e].tooltip) || void 0);
                  }), n.tooltip.userOptions = t.chart && t.chart.forExport && t.tooltip.userOptions || t.tooltip, this.userOptions = t, this.margin = [], this.spacing = [], this.bounds = {
                    h: {},
                    v: {}
                  }, this.labelCollectors = [], this.callback = e, this.isResizing = 0;
                  var a = i.zooming = i.zooming || {};
                  t.chart && !t.chart.zooming && (a.resetButton = i.resetZoomButton), a.key = X(a.key, i.zoomKey), a.pinchType = X(a.pinchType, i.pinchType), a.singleTouch = X(a.singleTouch, i.zoomBySingleTouch), a.type = X(a.type, i.zoomType), this.options = n, this.axes = [], this.series = [], this.time = t.time && Object.keys(t.time).length ? new d(t.time) : o.time, this.numberFormatter = i.numberFormatter || x, this.styledMode = i.styledMode, this.hasCartesianSeries = i.showAxes, this.index = S.length, S.push(this), o.chartCount++, w(this, i), this.xAxis = [], this.yAxis = [], this.pointCount = this.colorCounter = this.symbolCounter = 0, F(this, "afterInit"), this.firstRender();
                });
              }, a4.prototype.initSeries = function (t) {
                var e = this.options.chart;
                e = t.type || e.type || e.defaultSeriesType;
                var r = C[e];
                return r || L(17, !0, this, {
                  missingModuleFor: e
                }), "function" === typeof (e = new r()).init && e.init(this, t), e;
              }, a4.prototype.setSeriesData = function () {
                this.getSeriesOrderByLinks().forEach(function (t) {
                  t.points || t.data || !t.enabledDataSorting || t.setData(t.options.data, !1);
                });
              }, a4.prototype.getSeriesOrderByLinks = function () {
                return this.series.concat().sort(function (t, e) {
                  return t.linkedSeries.length || e.linkedSeries.length ? e.linkedSeries.length - t.linkedSeries.length : 0;
                });
              }, a4.prototype.orderSeries = function (t) {
                var e = this.series;
                t = t || 0;

                for (var r = e.length; t < r; ++t) {
                  e[t] && (e[t].index = t, e[t].name = e[t].getName());
                }
              }, a4.prototype.isInsidePlot = function (t, e, r) {
                void 0 === r && (r = {});
                var n = this.inverted,
                    i = this.plotBox,
                    o = this.plotLeft,
                    a = this.plotTop,
                    s = this.scrollablePlotBox,
                    c = 0,
                    l = 0;
                r.visiblePlotOnly && this.scrollingContainer && (c = (l = this.scrollingContainer).scrollLeft, l = l.scrollTop);
                var u = r.series;

                if (i = r.visiblePlotOnly && s || i, t = {
                  x: s = r.inverted ? e : t,
                  y: e = r.inverted ? t : e,
                  isInsidePlot: !0,
                  options: r
                }, !r.ignoreX) {
                  var h = u && (n && !this.polar ? u.yAxis : u.xAxis) || {
                    pos: o,
                    len: 1 / 0
                  };
                  (s = r.paneCoordinates ? h.pos + s : o + s) >= Math.max(c + o, h.pos) && s <= Math.min(c + o + i.width, h.pos + h.len) || (t.isInsidePlot = !1);
                }

                return !r.ignoreY && t.isInsidePlot && (n = r.axis && !r.axis.isXAxis && r.axis || u && (n ? u.xAxis : u.yAxis) || {
                  pos: a,
                  len: 1 / 0
                }, (r = r.paneCoordinates ? n.pos + e : a + e) >= Math.max(l + a, n.pos) && r <= Math.min(l + a + i.height, n.pos + n.len) || (t.isInsidePlot = !1)), F(this, "afterIsInsidePlot", t), t.isInsidePlot;
              }, a4.prototype.redraw = function (t) {
                F(this, "beforeRedraw");
                var e = this.hasCartesianSeries ? this.axes : this.colorAxis || [],
                    r = this.series,
                    n = this.pointer,
                    i = this.legend,
                    o = this.userOptions.legend,
                    a = this.renderer,
                    s = a.isHidden(),
                    c = [],
                    l = this.isDirtyBox,
                    u = this.isDirtyLegend;

                for (this.setResponsive && this.setResponsive(!1), m(!!this.hasRendered && t, this), s && this.temporaryDisplay(), this.layOutTitles(), t = r.length; t--;) {
                  var h = r[t];

                  if (h.options.stacking || h.options.centerInCategory) {
                    var d = !0;

                    if (h.isDirty) {
                      var f = !0;
                      break;
                    }
                  }
                }

                if (f) for (t = r.length; t--;) {
                  (h = r[t]).options.stacking && (h.isDirty = !0);
                }
                r.forEach(function (t) {
                  t.isDirty && ("point" === t.options.legendType ? ("function" === typeof t.updateTotals && t.updateTotals(), u = !0) : o && (o.labelFormatter || o.labelFormat) && (u = !0)), t.isDirtyData && F(t, "updatedData");
                }), u && i && i.options.enabled && (i.render(), this.isDirtyLegend = !1), d && this.getStacks(), e.forEach(function (t) {
                  t.updateNames(), t.setScale();
                }), this.getMargins(), e.forEach(function (t) {
                  t.isDirty && (l = !0);
                }), e.forEach(function (t) {
                  var e = t.min + "," + t.max;
                  t.extKey !== e && (t.extKey = e, c.push(function () {
                    F(t, "afterSetExtremes", N(t.eventArgs, t.getExtremes())), delete t.eventArgs;
                  })), (l || d) && t.redraw();
                }), l && this.drawChartBox(), F(this, "predraw"), r.forEach(function (t) {
                  (l || t.isDirty) && t.visible && t.redraw(), t.isDirtyData = !1;
                }), n && n.reset(!0), a.draw(), F(this, "redraw"), F(this, "render"), s && this.temporaryDisplay(!0), c.forEach(function (t) {
                  t.call();
                });
              }, a4.prototype.get = function (t) {
                function a5(e) {
                  return e.id === t || e.options && e.options.id === t;
                }

                for (var e = this.series, r = B(this.axes, a5) || B(this.series, a5), n = 0; !r && n < e.length; n++) {
                  r = B(e[n].points || [], a5);
                }

                return r;
              }, a4.prototype.getAxes = function () {
                var t = this,
                    r = this.options,
                    n = r.xAxis = K(r.xAxis || {});
                r = r.yAxis = K(r.yAxis || {}), F(this, "getAxes"), n.forEach(function (t, e) {
                  t.index = e, t.isX = !0;
                }), r.forEach(function (t, e) {
                  t.index = e;
                }), n.concat(r).forEach(function (r) {
                  new e(t, r);
                }), F(this, "afterGetAxes");
              }, a4.prototype.getSelectedPoints = function () {
                return this.series.reduce(function (t, e) {
                  return e.getPointsCollection().forEach(function (e) {
                    X(e.selectedStaging, e.selected) && t.push(e);
                  }), t;
                }, []);
              }, a4.prototype.getSelectedSeries = function () {
                return this.series.filter(function (t) {
                  return t.selected;
                });
              }, a4.prototype.setTitle = function (t, e, r) {
                this.applyDescription("title", t), this.applyDescription("subtitle", e), this.applyDescription("caption", void 0), this.layOutTitles(r);
              }, a4.prototype.applyDescription = function (t, e) {
                var r = this,
                    n = "title" === t ? {
                  color: "#333333",
                  fontSize: this.options.isStock ? "16px" : "18px"
                } : {
                  color: "#666666"
                };
                n = this.options[t] = G(!this.styledMode && {
                  style: n
                }, this.options[t], e);
                var i = this[t];
                i && e && (this[t] = i = i.destroy()), n && !i && ((i = this.renderer.text(n.text, 0, 0, n.useHTML).attr({
                  align: n.align,
                  class: "highcharts-" + t,
                  zIndex: n.zIndex || 4
                }).add()).update = function (e) {
                  r[{
                    title: "setTitle",
                    subtitle: "setSubtitle",
                    caption: "setCaption"
                  }[t]](e);
                }, this.styledMode || i.css(n.style), this[t] = i);
              }, a4.prototype.layOutTitles = function (t) {
                var e = [0, 0, 0],
                    r = this.renderer,
                    n = this.spacingBox;
                ["title", "subtitle", "caption"].forEach(function (t) {
                  var i,
                      o = this[t],
                      a = this.options[t],
                      s = a.verticalAlign || "top";

                  if (t = "title" === t ? "top" === s ? -3 : 0 : "top" === s ? e[0] + 2 : 0, o) {
                    this.styledMode || (i = a.style && a.style.fontSize), i = r.fontMetrics(i, o).b, o.css({
                      width: (a.width || n.width + (a.widthAdjust || 0)) + "px"
                    });
                    var c = Math.round(o.getBBox(a.useHTML).height);
                    o.align(N({
                      y: "bottom" === s ? i : t + i,
                      height: c
                    }, a), !1, "spacingBox"), a.floating || ("top" === s ? e[0] = Math.ceil(e[0] + c) : "bottom" === s && (e[2] = Math.ceil(e[2] + c)));
                  }
                }, this), e[0] && "top" === (this.options.title.verticalAlign || "top") && (e[0] += this.options.title.margin), e[2] && "bottom" === this.options.caption.verticalAlign && (e[2] += this.options.caption.margin);
                var i = !this.titleOffset || this.titleOffset.join(",") !== e.join(",");
                this.titleOffset = e, F(this, "afterLayOutTitles"), !this.isDirtyBox && i && (this.isDirtyBox = this.isDirtyLegend = i, this.hasRendered && X(t, !0) && this.isDirtyBox && this.redraw());
              }, a4.prototype.getChartSize = function () {
                var t = this.options.chart,
                    e = t.width;
                t = t.height;
                var r = this.renderTo;
                R(e) || (this.containerWidth = U(r, "width")), R(t) || (this.containerHeight = U(r, "height")), this.chartWidth = Math.max(0, e || this.containerWidth || 600), this.chartHeight = Math.max(0, $(t, this.chartWidth) || (1 < this.containerHeight ? this.containerHeight : 400));
              }, a4.prototype.temporaryDisplay = function (t) {
                var e = this.renderTo;
                if (t) for (; e && e.style;) {
                  e.hcOrigStyle && (j(e, e.hcOrigStyle), delete e.hcOrigStyle), e.hcOrigDetached && (O.body.removeChild(e), e.hcOrigDetached = !1), e = e.parentNode;
                } else for (; e && e.style && (O.body.contains(e) || e.parentNode || (e.hcOrigDetached = !0, O.body.appendChild(e)), ("none" === U(e, "display", !1) || e.hcOricDetached) && (e.hcOrigStyle = {
                  display: e.style.display,
                  height: e.style.height,
                  overflow: e.style.overflow
                }, t = {
                  display: "block",
                  overflow: "hidden"
                }, e !== this.renderTo && (t.height = 0), j(e, t), e.offsetWidth || e.style.setProperty("display", "block", "important")), (e = e.parentNode) !== O.body);) {
                  ;
                }
              }, a4.prototype.setClassName = function (t) {
                this.container.className = "highcharts-container " + (t || "");
              }, a4.prototype.getContainer = function () {
                var t,
                    e = this.options,
                    r = e.chart,
                    n = J(),
                    i = this.renderTo;
                i || (this.renderTo = i = r.renderTo), H(i) && (this.renderTo = i = O.getElementById(i)), i || L(13, !0, this);
                var o = V(A(i, "data-highcharts-chart"));
                z(o) && S[o] && S[o].hasRendered && S[o].destroy(), A(i, "data-highcharts-chart", this.index), i.innerHTML = p.emptyHTML, r.skipClone || i.offsetWidth || this.temporaryDisplay(), this.getChartSize(), o = this.chartWidth;
                var a = this.chartHeight;
                if (j(i, {
                  overflow: "hidden"
                }), this.styledMode || (t = N({
                  position: "relative",
                  overflow: "hidden",
                  width: o + "px",
                  height: a + "px",
                  textAlign: "left",
                  lineHeight: "normal",
                  zIndex: 0,
                  "-webkit-tap-highlight-color": "rgba(0,0,0,0)",
                  userSelect: "none",
                  "touch-action": "manipulation",
                  outline: "none"
                }, r.style || {})), this.container = n = P("div", {
                  id: n
                }, t, i), this._cursor = n.style.cursor, this.renderer = new (r.renderer || !k ? l.getRendererType(r.renderer) : h)(n, o, a, void 0, r.forExport, e.exporting && e.exporting.allowHTML, this.styledMode), m(void 0, this), this.setClassName(r.className), this.styledMode) for (var s in e.defs) {
                  this.renderer.definition(e.defs[s]);
                } else this.renderer.setStyle(r.style);
                this.renderer.chartIndex = this.index, F(this, "afterGetContainer");
              }, a4.prototype.getMargins = function (t) {
                var e = this.spacing,
                    r = this.margin,
                    n = this.titleOffset;
                this.resetMargins(), n[0] && !R(r[0]) && (this.plotTop = Math.max(this.plotTop, n[0] + e[0])), n[2] && !R(r[2]) && (this.marginBottom = Math.max(this.marginBottom, n[2] + e[2])), this.legend && this.legend.display && this.legend.adjustMargins(r, e), F(this, "getMargins"), t || this.getAxisMargins();
              }, a4.prototype.getAxisMargins = function () {
                var t = this,
                    e = t.axisOffset = [0, 0, 0, 0],
                    r = t.colorAxis,
                    n = t.margin,
                    i = function f3(t) {
                  t.forEach(function (t) {
                    t.visible && t.getOffset();
                  });
                };

                t.hasCartesianSeries ? i(t.axes) : r && r.length && i(r), E.forEach(function (r, i) {
                  R(n[i]) || (t[r] += e[i]);
                }), t.setChartSize();
              }, a4.prototype.reflow = function (t) {
                var e = this,
                    r = e.options.chart,
                    n = e.renderTo,
                    i = R(r.width) && R(r.height),
                    o = r.width || U(n, "width");
                r = r.height || U(n, "height"), n = t ? t.target : _, delete e.pointer.chartPosition, i || e.isPrinting || !o || !r || n !== _ && n !== O || (o === e.containerWidth && r === e.containerHeight || (f.clearTimeout(e.reflowTimeout), e.reflowTimeout = Z(function () {
                  e.container && e.setSize(void 0, void 0, !1);
                }, t ? 100 : 0)), e.containerWidth = o, e.containerHeight = r);
              }, a4.prototype.setReflow = function (t) {
                var e = this;
                !1 === t || this.unbindReflow ? !1 === t && this.unbindReflow && (this.unbindReflow = this.unbindReflow()) : (this.unbindReflow = T(_, "resize", function (t) {
                  e.options && e.reflow(t);
                }), T(this, "destroy", this.unbindReflow));
              }, a4.prototype.setSize = function (t, e, r) {
                var n = this,
                    i = n.renderer;
                n.isResizing += 1, m(r, n), r = i.globalAnimation, n.oldChartHeight = n.chartHeight, n.oldChartWidth = n.chartWidth, "undefined" !== typeof t && (n.options.chart.width = t), "undefined" !== typeof e && (n.options.chart.height = e), n.getChartSize(), n.styledMode || (r ? y : j)(n.container, {
                  width: n.chartWidth + "px",
                  height: n.chartHeight + "px"
                }, r), n.setChartSize(!0), i.setSize(n.chartWidth, n.chartHeight, r), n.axes.forEach(function (t) {
                  t.isDirty = !0, t.setScale();
                }), n.isDirtyLegend = !0, n.isDirtyBox = !0, n.layOutTitles(), n.getMargins(), n.redraw(r), n.oldChartHeight = null, F(n, "resize"), Z(function () {
                  n && F(n, "endResize", null, function () {
                    --n.isResizing;
                  });
                }, g(r).duration);
              }, a4.prototype.setChartSize = function (t) {
                var e,
                    r,
                    n,
                    i,
                    o = this.inverted,
                    a = this.renderer,
                    s = this.chartWidth,
                    c = this.chartHeight,
                    l = this.options.chart,
                    u = this.spacing,
                    h = this.clipOffset;
                this.plotLeft = e = Math.round(this.plotLeft), this.plotTop = r = Math.round(this.plotTop), this.plotWidth = n = Math.max(0, Math.round(s - e - this.marginRight)), this.plotHeight = i = Math.max(0, Math.round(c - r - this.marginBottom)), this.plotSizeX = o ? i : n, this.plotSizeY = o ? n : i, this.plotBorderWidth = l.plotBorderWidth || 0, this.spacingBox = a.spacingBox = {
                  x: u[3],
                  y: u[0],
                  width: s - u[3] - u[1],
                  height: c - u[0] - u[2]
                }, this.plotBox = a.plotBox = {
                  x: e,
                  y: r,
                  width: n,
                  height: i
                }, o = 2 * Math.floor(this.plotBorderWidth / 2), s = Math.ceil(Math.max(o, h[3]) / 2), c = Math.ceil(Math.max(o, h[0]) / 2), this.clipBox = {
                  x: s,
                  y: c,
                  width: Math.floor(this.plotSizeX - Math.max(o, h[1]) / 2 - s),
                  height: Math.max(0, Math.floor(this.plotSizeY - Math.max(o, h[2]) / 2 - c))
                }, t || (this.axes.forEach(function (t) {
                  t.setAxisSize(), t.setAxisTranslation();
                }), a.alignElements()), F(this, "afterSetChartSize", {
                  skipAxes: t
                });
              }, a4.prototype.resetMargins = function () {
                F(this, "resetMargins");
                var t = this,
                    e = t.options.chart;
                ["margin", "spacing"].forEach(function (r) {
                  var n = e[r],
                      i = q(n) ? n : [n, n, n, n];
                  ["Top", "Right", "Bottom", "Left"].forEach(function (n, o) {
                    t[r][o] = X(e[r + n], i[o]);
                  });
                }), E.forEach(function (e, r) {
                  t[e] = X(t.margin[r], t.spacing[r]);
                }), t.axisOffset = [0, 0, 0, 0], t.clipOffset = [0, 0, 0, 0];
              }, a4.prototype.drawChartBox = function () {
                var t,
                    e = this.options.chart,
                    r = this.renderer,
                    n = this.chartWidth,
                    i = this.chartHeight,
                    o = this.styledMode,
                    a = this.plotBGImage,
                    s = e.backgroundColor,
                    c = e.plotBackgroundColor,
                    l = e.plotBackgroundImage,
                    u = this.plotLeft,
                    h = this.plotTop,
                    d = this.plotWidth,
                    f = this.plotHeight,
                    p = this.plotBox,
                    y = this.clipRect,
                    g = this.clipBox,
                    m = this.chartBackground,
                    v = this.plotBackground,
                    b = this.plotBorder,
                    x = "animate";
                if (m || (this.chartBackground = m = r.rect().addClass("highcharts-background").add(), x = "attr"), o) var w = t = m.strokeWidth();else t = (w = e.borderWidth || 0) + (e.shadow ? 8 : 0), s = {
                  fill: s || "none"
                }, (w || m["stroke-width"]) && (s.stroke = e.borderColor, s["stroke-width"] = w), m.attr(s).shadow(e.shadow);
                m[x]({
                  x: t / 2,
                  y: t / 2,
                  width: n - t - w % 2,
                  height: i - t - w % 2,
                  r: e.borderRadius
                }), x = "animate", v || (x = "attr", this.plotBackground = v = r.rect().addClass("highcharts-plot-background").add()), v[x](p), o || (v.attr({
                  fill: c || "none"
                }).shadow(e.plotShadow), l && (a ? (l !== a.attr("href") && a.attr("href", l), a.animate(p)) : this.plotBGImage = r.image(l, u, h, d, f).add())), y ? y.animate({
                  width: g.width,
                  height: g.height
                }) : this.clipRect = r.clipRect(g), x = "animate", b || (x = "attr", this.plotBorder = b = r.rect().addClass("highcharts-plot-border").attr({
                  zIndex: 1
                }).add()), o || b.attr({
                  stroke: e.plotBorderColor,
                  "stroke-width": e.plotBorderWidth || 0,
                  fill: "none"
                }), b[x](b.crisp({
                  x: u,
                  y: h,
                  width: d,
                  height: f
                }, -b.strokeWidth())), this.isDirtyBox = !1, F(this, "afterDrawChartBox");
              }, a4.prototype.propFromSeries = function () {
                var t,
                    e,
                    r,
                    n = this,
                    i = n.options.chart,
                    o = n.options.series;
                ["inverted", "angular", "polar"].forEach(function (a) {
                  for (e = C[i.type || i.defaultSeriesType], r = i[a] || e && e.prototype[a], t = o && o.length; !r && t--;) {
                    (e = C[o[t].type]) && e.prototype[a] && (r = !0);
                  }

                  n[a] = r;
                });
              }, a4.prototype.linkSeries = function () {
                var t = this,
                    e = t.series;
                e.forEach(function (t) {
                  t.linkedSeries.length = 0;
                }), e.forEach(function (e) {
                  var r = e.options.linkedTo;
                  H(r) && (r = ":previous" === r ? t.series[e.index - 1] : t.get(r)) && r.linkedParent !== e && (r.linkedSeries.push(e), e.linkedParent = r, r.enabledDataSorting && e.setDataSortingOptions(), e.visible = X(e.options.visible, r.options.visible, e.visible));
                }), F(this, "afterLinkSeries");
              }, a4.prototype.renderSeries = function () {
                this.series.forEach(function (t) {
                  t.translate(), t.render();
                });
              }, a4.prototype.renderLabels = function () {
                var t = this,
                    e = t.options.labels;
                e.items && e.items.forEach(function (r) {
                  var n = N(e.style, r.style),
                      i = V(n.left) + t.plotLeft,
                      o = V(n.top) + t.plotTop + 12;
                  delete n.left, delete n.top, t.renderer.text(r.html, i, o).attr({
                    zIndex: 2
                  }).css(n).add();
                });
              }, a4.prototype.render = function () {
                var t = this.axes,
                    e = this.colorAxis,
                    r = this.renderer,
                    n = this.options,
                    i = function f3(t) {
                  t.forEach(function (t) {
                    t.visible && t.render();
                  });
                },
                    o = 0;

                this.setTitle(), this.legend = new a(this, n.legend), this.getStacks && this.getStacks(), this.getMargins(!0), this.setChartSize(), n = this.plotWidth, t.some(function (t) {
                  if (t.horiz && t.visible && t.options.labels.enabled && t.series.length) return o = 21, !0;
                });
                var s = this.plotHeight = Math.max(this.plotHeight - o, 0);
                t.forEach(function (t) {
                  t.setScale();
                }), this.getAxisMargins();
                var c = 1.1 < n / this.plotWidth,
                    l = 1.05 < s / this.plotHeight;
                (c || l) && (t.forEach(function (t) {
                  (t.horiz && c || !t.horiz && l) && t.setTickInterval(!0);
                }), this.getMargins()), this.drawChartBox(), this.hasCartesianSeries ? i(t) : e && e.length && i(e), this.seriesGroup || (this.seriesGroup = r.g("series-group").attr({
                  zIndex: 3
                }).add()), this.renderSeries(), this.renderLabels(), this.addCredits(), this.setResponsive && this.setResponsive(), this.hasRendered = !0;
              }, a4.prototype.addCredits = function (t) {
                var e = this,
                    r = G(!0, this.options.credits, t);
                r.enabled && !this.credits && (this.credits = this.renderer.text(r.text + (this.mapCredits || ""), 0, 0).addClass("highcharts-credits").on("click", function () {
                  r.href && (_.location.href = r.href);
                }).attr({
                  align: r.position.align,
                  zIndex: 8
                }), e.styledMode || this.credits.css(r.style), this.credits.add().align(r.position), this.credits.update = function (t) {
                  e.credits = e.credits.destroy(), e.addCredits(t);
                });
              }, a4.prototype.destroy = function () {
                var t,
                    e = this,
                    r = e.axes,
                    n = e.series,
                    i = e.container,
                    a = i && i.parentNode;

                for (F(e, "destroy"), e.renderer.forExport ? I(S, e) : S[e.index] = void 0, o.chartCount--, e.renderTo.removeAttribute("data-highcharts-chart"), Q(e), t = r.length; t--;) {
                  r[t] = r[t].destroy();
                }

                for (this.scroller && this.scroller.destroy && this.scroller.destroy(), t = n.length; t--;) {
                  n[t] = n[t].destroy();
                }

                "title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" ").forEach(function (t) {
                  var r = e[t];
                  r && r.destroy && (e[t] = r.destroy());
                }), i && (i.innerHTML = p.emptyHTML, Q(i), a && D(i)), Y(e, function (t, r) {
                  delete e[r];
                });
              }, a4.prototype.firstRender = function () {
                var t = this,
                    e = t.options;
                t.isReadyToRender && !t.isReadyToRender() || (t.getContainer(), t.resetMargins(), t.setChartSize(), t.propFromSeries(), t.getAxes(), (W(e.series) ? e.series : []).forEach(function (e) {
                  t.initSeries(e);
                }), t.linkSeries(), t.setSeriesData(), F(t, "beforeRender"), c && (s.isRequired() ? t.pointer = new s(t, e) : t.pointer = new c(t, e)), t.render(), t.pointer.getChartPosition(), t.renderer.imgCount || t.hasLoaded || t.onload(), t.temporaryDisplay(!0));
              }, a4.prototype.onload = function () {
                this.callbacks.concat([this.callback]).forEach(function (t) {
                  t && "undefined" !== typeof this.index && t.apply(this, [this]);
                }, this), F(this, "load"), F(this, "render"), R(this.index) && this.setReflow(this.options.chart.reflow), this.warnIfA11yModuleNotLoaded(), this.hasLoaded = !0;
              }, a4.prototype.warnIfA11yModuleNotLoaded = function () {
                var t = this.options,
                    e = this.title;
                t && !this.accessibility && (this.renderer.boxWrapper.attr({
                  role: "img",
                  "aria-label": (e && e.element.textContent || "").replace(/</g, "&lt;")
                }), t.accessibility && !1 === t.accessibility.enabled || L('Highcharts warning: Consider including the "accessibility.js" module to make your chart more usable for people with disabilities. Set the "accessibility.enabled" option to false to remove this warning. See https://www.highcharts.com/docs/accessibility/accessibility-module.', !1, this));
              }, a4.prototype.addSeries = function (t, e, r) {
                var n,
                    i = this;
                return t && (e = X(e, !0), F(i, "addSeries", {
                  options: t
                }, function () {
                  n = i.initSeries(t), i.isDirtyLegend = !0, i.linkSeries(), n.enabledDataSorting && n.setData(t.data, !1), F(i, "afterAddSeries", {
                    series: n
                  }), e && i.redraw(r);
                })), n;
              }, a4.prototype.addAxis = function (t, e, r, n) {
                return this.createAxis(e ? "xAxis" : "yAxis", {
                  axis: t,
                  redraw: r,
                  animation: n
                });
              }, a4.prototype.addColorAxis = function (t, e, r) {
                return this.createAxis("colorAxis", {
                  axis: t,
                  redraw: e,
                  animation: r
                });
              }, a4.prototype.createAxis = function (t, r) {
                return t = new e(this, G(r.axis, {
                  index: this[t].length,
                  isX: "xAxis" === t
                })), X(r.redraw, !0) && this.redraw(r.animation), t;
              }, a4.prototype.showLoading = function (t) {
                var e = this,
                    r = e.options,
                    n = r.loading,
                    i = function f3() {
                  o && j(o, {
                    left: e.plotLeft + "px",
                    top: e.plotTop + "px",
                    width: e.plotWidth + "px",
                    height: e.plotHeight + "px"
                  });
                },
                    o = e.loadingDiv,
                    a = e.loadingSpan;

                o || (e.loadingDiv = o = P("div", {
                  className: "highcharts-loading highcharts-loading-hidden"
                }, null, e.container)), a || (e.loadingSpan = a = P("span", {
                  className: "highcharts-loading-inner"
                }, null, o), T(e, "redraw", i)), o.className = "highcharts-loading", p.setElementHTML(a, X(t, r.lang.loading, "")), e.styledMode || (j(o, N(n.style, {
                  zIndex: 10
                })), j(a, n.labelStyle), e.loadingShown || (j(o, {
                  opacity: 0,
                  display: ""
                }), y(o, {
                  opacity: n.style.opacity || .5
                }, {
                  duration: n.showDuration || 0
                }))), e.loadingShown = !0, i();
              }, a4.prototype.hideLoading = function () {
                var t = this.options,
                    e = this.loadingDiv;
                e && (e.className = "highcharts-loading highcharts-loading-hidden", this.styledMode || y(e, {
                  opacity: 0
                }, {
                  duration: t.loading.hideDuration || 100,
                  complete: function complete() {
                    j(e, {
                      display: "none"
                    });
                  }
                })), this.loadingShown = !1;
              }, a4.prototype.update = function (t, e, r, n) {
                var i,
                    o,
                    a = this,
                    s = {
                  credits: "addCredits",
                  title: "setTitle",
                  subtitle: "setSubtitle",
                  caption: "setCaption"
                },
                    c = t.isResponsiveOptions,
                    l = [];
                F(a, "update", {
                  options: t
                }), c || a.setResponsive(!1, !0), t = M(t, a.options), a.userOptions = G(a.userOptions, t);
                var u = t.chart;

                if (u) {
                  if (G(!0, a.options.chart, u), "className" in u && a.setClassName(u.className), "reflow" in u && a.setReflow(u.reflow), "inverted" in u || "polar" in u || "type" in u) {
                    a.propFromSeries();
                    var h = !0;
                  }

                  "alignTicks" in u && (h = !0), "events" in u && w(this, u), Y(u, function (t, e) {
                    -1 !== a.propsRequireUpdateSeries.indexOf("chart." + e) && (i = !0), -1 !== a.propsRequireDirtyBox.indexOf(e) && (a.isDirtyBox = !0), -1 !== a.propsRequireReflow.indexOf(e) && (c ? a.isDirtyBox = !0 : o = !0);
                  }), !a.styledMode && u.style && a.renderer.setStyle(a.options.chart.style || {});
                }

                !a.styledMode && t.colors && (this.options.colors = t.colors), t.time && (this.time === b && (this.time = new d(t.time)), G(!0, a.options.time, t.time)), Y(t, function (e, r) {
                  a[r] && "function" === typeof a[r].update ? a[r].update(e, !1) : "function" === typeof a[s[r]] ? a[s[r]](e) : "colors" !== r && -1 === a.collectionsWithUpdate.indexOf(r) && G(!0, a.options[r], t[r]), "chart" !== r && -1 !== a.propsRequireUpdateSeries.indexOf(r) && (i = !0);
                }), this.collectionsWithUpdate.forEach(function (e) {
                  if (t[e]) {
                    var n = [];
                    a[e].forEach(function (t, e) {
                      t.options.isInternal || n.push(X(t.options.index, e));
                    }), K(t[e]).forEach(function (t, i) {
                      var o,
                          s = R(t.id);
                      s && (o = a.get(t.id)), !o && a[e] && (o = a[e][n ? n[i] : i]) && s && R(o.options.id) && (o = void 0), o && o.coll === e && (o.update(t, !1), r && (o.touched = !0)), !o && r && a.collectionsWithInit[e] && (a.collectionsWithInit[e][0].apply(a, [t].concat(a.collectionsWithInit[e][1] || []).concat([!1])).touched = !0);
                    }), r && a[e].forEach(function (t) {
                      t.touched || t.options.isInternal ? delete t.touched : l.push(t);
                    });
                  }
                }), l.forEach(function (t) {
                  t.chart && t.remove && t.remove(!1);
                }), h && a.axes.forEach(function (t) {
                  t.update({}, !1);
                }), i && a.getSeriesOrderByLinks().forEach(function (t) {
                  t.chart && t.update({}, !1);
                }, this), h = u && u.width, u = u && (H(u.height) ? $(u.height, h || a.chartWidth) : u.height), o || z(h) && h !== a.chartWidth || z(u) && u !== a.chartHeight ? a.setSize(h, u, n) : X(e, !0) && a.redraw(n), F(a, "afterUpdate", {
                  options: t,
                  redraw: e,
                  animation: n
                });
              }, a4.prototype.setSubtitle = function (t, e) {
                this.applyDescription("subtitle", t), this.layOutTitles(e);
              }, a4.prototype.setCaption = function (t, e) {
                this.applyDescription("caption", t), this.layOutTitles(e);
              }, a4.prototype.showResetZoom = function () {
                function b3() {
                  t.zoomOut();
                }

                var t = this,
                    e = v.lang,
                    r = t.options.chart.zooming.resetButton,
                    n = r.theme,
                    i = "chart" === r.relativeTo || "spacingBox" === r.relativeTo ? null : "scrollablePlotBox";
                F(this, "beforeShowResetZoom", null, function () {
                  t.resetZoomButton = t.renderer.button(e.resetZoom, null, null, b3, n).attr({
                    align: r.position.align,
                    title: e.resetZoomTitle
                  }).addClass("highcharts-reset-zoom").add().align(r.position, !1, i);
                }), F(this, "afterShowResetZoom");
              }, a4.prototype.zoomOut = function () {
                F(this, "selection", {
                  resetSelection: !0
                }, this.zoom);
              }, a4.prototype.zoom = function (t) {
                var e,
                    r = this,
                    n = r.pointer,
                    i = !1;
                !t || t.resetSelection ? (r.axes.forEach(function (t) {
                  e = t.zoom();
                }), n.initiated = !1) : t.xAxis.concat(t.yAxis).forEach(function (t) {
                  var o = t.axis;
                  (n[o.isXAxis ? "zoomX" : "zoomY"] && R(n.mouseDownX) && R(n.mouseDownY) && r.isInsidePlot(n.mouseDownX - r.plotLeft, n.mouseDownY - r.plotTop, {
                    axis: o
                  }) || !R(r.inverted ? n.mouseDownX : n.mouseDownY)) && (e = o.zoom(t.min, t.max), o.displayBtn && (i = !0));
                });
                var o = r.resetZoomButton;
                i && !o ? r.showResetZoom() : !i && q(o) && (r.resetZoomButton = o.destroy()), e && r.redraw(X(r.options.chart.animation, t && t.animation, 100 > r.pointCount));
              }, a4.prototype.pan = function (t, e) {
                var r = this,
                    n = r.hoverPoints;
                e = "object" === typeof e ? e : {
                  enabled: e,
                  type: "x"
                };
                var i = r.options.chart;
                i && i.panning && (i.panning = e);
                var o,
                    a = e.type;
                F(this, "pan", {
                  originalEvent: t
                }, function () {
                  n && n.forEach(function (t) {
                    t.setState();
                  });
                  var e = r.xAxis;
                  "xy" === a ? e = e.concat(r.yAxis) : "y" === a && (e = r.yAxis);
                  var i = {};
                  e.forEach(function (e) {
                    if (e.options.panningEnabled && !e.options.isInternal) {
                      var n = e.horiz,
                          s = t[n ? "chartX" : "chartY"],
                          c = r[n = n ? "mouseDownX" : "mouseDownY"],
                          l = e.minPointOffset || 0,
                          u = e.reversed && !r.inverted || !e.reversed && r.inverted ? -1 : 1,
                          h = e.getExtremes(),
                          d = e.toValue(c - s, !0) + l * u,
                          f = e.toValue(c + e.len - s, !0) - (l * u || e.isXAxis && e.pointRangePadding || 0),
                          p = f < d;
                      u = e.hasVerticalPanning(), c = p ? f : d, d = p ? d : f;
                      var y = e.panningState;
                      !u || e.isXAxis || y && !y.isDirty || e.series.forEach(function (t) {
                        var e = t.getProcessedData(!0);
                        e = t.getExtremes(e.yData, !0), y || (y = {
                          startMin: Number.MAX_VALUE,
                          startMax: -Number.MAX_VALUE
                        }), z(e.dataMin) && z(e.dataMax) && (y.startMin = Math.min(X(t.options.threshold, 1 / 0), e.dataMin, y.startMin), y.startMax = Math.max(X(t.options.threshold, -1 / 0), e.dataMax, y.startMax));
                      }), u = Math.min(X(y && y.startMin, h.dataMin), l ? h.min : e.toValue(e.toPixels(h.min) - e.minPixelPadding)), f = Math.max(X(y && y.startMax, h.dataMax), l ? h.max : e.toValue(e.toPixels(h.max) + e.minPixelPadding)), e.panningState = y, e.isOrdinal || (0 < (l = u - c) && (d += l, c = u), 0 < (l = d - f) && (d = f, c -= l), e.series.length && c !== h.min && d !== h.max && c >= u && d <= f && (e.setExtremes(c, d, !1, !1, {
                        trigger: "pan"
                      }), !r.resetZoomButton && c !== u && d !== f && a.match("y") && (r.showResetZoom(), e.displayBtn = !1), o = !0), i[n] = s);
                    }
                  }), Y(i, function (t, e) {
                    r[e] = t;
                  }), o && r.redraw(!1), j(r.container, {
                    cursor: "move"
                  });
                });
              }, a4;
            }(), N(t.prototype, {
              callbacks: [],
              collectionsWithInit: {
                xAxis: [t.prototype.addAxis, [!0]],
                yAxis: [t.prototype.addAxis, [!1]],
                series: [t.prototype.addSeries]
              },
              collectionsWithUpdate: ["xAxis", "yAxis", "series"],
              propsRequireDirtyBox: "backgroundColor borderColor borderWidth borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "),
              propsRequireReflow: "margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft".split(" "),
              propsRequireUpdateSeries: "chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions time tooltip".split(" ")
            }), t;
          }), K2(e, "Core/Legend/LegendSymbol.js", [e["Core/Utilities.js"]], function (t) {
            var e,
                r,
                n = t.extend,
                i = t.merge,
                o = t.pick;
            return (r = e || (e = {})).drawLineMarker = function (t) {
              var e = this.legendItem = this.legendItem || {},
                  r = this.options,
                  a = t.symbolWidth,
                  s = t.symbolHeight,
                  c = s / 2,
                  l = this.chart.renderer,
                  u = e.group;
              t = t.baseline - Math.round(.3 * t.fontMetrics.b);
              var h = {},
                  d = r.marker,
                  f = 0;
              this.chart.styledMode || (h = {
                "stroke-width": Math.min(r.lineWidth || 0, 24)
              }, r.dashStyle ? h.dashstyle = r.dashStyle : "square" !== r.linecap && (h["stroke-linecap"] = "round")), e.line = l.path().addClass("highcharts-graph").attr(h).add(u), h["stroke-linecap"] && (f = Math.min(e.line.strokeWidth(), a) / 2), e.line.attr({
                d: [["M", f, t], ["L", a - f, t]]
              }), d && !1 !== d.enabled && a && (r = Math.min(o(d.radius, c), c), 0 === this.symbol.indexOf("url") && (d = i(d, {
                width: s,
                height: s
              }), r = 0), e.symbol = e = l.symbol(this.symbol, a / 2 - r, t - r, 2 * r, 2 * r, n({
                context: "legend"
              }, d)).addClass("highcharts-point").add(u), e.isMarker = !0);
            }, r.drawRectangle = function (t, e) {
              e = e.legendItem || {};
              var r = t.symbolHeight,
                  n = t.options.squareSymbol;
              e.symbol = this.chart.renderer.rect(n ? (t.symbolWidth - r) / 2 : 0, t.baseline - r + 1, n ? r : t.symbolWidth, r, o(t.options.symbolRadius, r / 2)).addClass("highcharts-point").attr({
                zIndex: 3
              }).add(e.group);
            }, e;
          }), K2(e, "Core/Series/SeriesDefaults.js", [], function () {
            return {
              lineWidth: 2,
              allowPointSelect: !1,
              crisp: !0,
              showCheckbox: !1,
              animation: {
                duration: 1e3
              },
              events: {},
              marker: {
                enabledThreshold: 2,
                lineColor: "#ffffff",
                lineWidth: 0,
                radius: 4,
                states: {
                  normal: {
                    animation: !0
                  },
                  hover: {
                    animation: {
                      duration: 50
                    },
                    enabled: !0,
                    radiusPlus: 2,
                    lineWidthPlus: 1
                  },
                  select: {
                    fillColor: "#cccccc",
                    lineColor: "#000000",
                    lineWidth: 2
                  }
                }
              },
              point: {
                events: {}
              },
              dataLabels: {
                animation: {},
                align: "center",
                borderWidth: 0,
                defer: !0,
                formatter: function formatter() {
                  var t = this.series.chart.numberFormatter;
                  return "number" !== typeof this.y ? "" : t(this.y, -1);
                },
                padding: 5,
                style: {
                  fontSize: "11px",
                  fontWeight: "bold",
                  color: "contrast",
                  textOutline: "1px contrast"
                },
                verticalAlign: "bottom",
                x: 0,
                y: 0
              },
              cropThreshold: 300,
              opacity: 1,
              pointRange: 0,
              softThreshold: !0,
              states: {
                normal: {
                  animation: !0
                },
                hover: {
                  animation: {
                    duration: 50
                  },
                  lineWidthPlus: 1,
                  marker: {},
                  halo: {
                    size: 10,
                    opacity: .25
                  }
                },
                select: {
                  animation: {
                    duration: 0
                  }
                },
                inactive: {
                  animation: {
                    duration: 50
                  },
                  opacity: .2
                }
              },
              stickyTracking: !0,
              turboThreshold: 1e3,
              findNearestPointBy: "x"
            };
          }), K2(e, "Core/Series/Series.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Defaults.js"], e["Core/Foundation.js"], e["Core/Globals.js"], e["Core/Legend/LegendSymbol.js"], e["Core/Series/Point.js"], e["Core/Series/SeriesDefaults.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Renderer/SVG/SVGElement.js"], e["Core/Utilities.js"]], function (t, e, r, n, i, o, a, s, c, l) {
            var u = t.animObject,
                h = t.setAnimation,
                d = e.defaultOptions,
                f = r.registerEventOptions,
                p = n.hasTouch,
                y = n.svg,
                g = n.win,
                m = s.seriesTypes,
                v = l.arrayMax,
                b = l.arrayMin,
                x = l.clamp,
                w = l.cleanRecursively,
                S = l.correctFloat,
                O = l.defined,
                E = l.erase,
                k = l.error,
                _ = l.extend,
                C = l.find,
                T = l.fireEvent,
                A = l.getNestedProperty,
                M = l.isArray,
                P = l.isNumber,
                j = l.isString,
                R = l.merge,
                D = l.objectEach,
                I = l.pick,
                L = l.removeEvent,
                N = l.splat,
                B = l.syncTimeout;
            return t = function () {
              function a4() {
                this.zones = this.yAxis = this.xAxis = this.userOptions = this.tooltipOptions = this.processedYData = this.processedXData = this.points = this.options = this.linkedSeries = this.index = this.eventsToUnbind = this.eventOptions = this.data = this.chart = this._i = void 0;
              }

              return a4.prototype.init = function (t, e) {
                T(this, "init", {
                  options: e
                });
                var r = this,
                    n = t.series;
                this.eventsToUnbind = [], r.chart = t, r.options = r.setOptions(e), e = r.options, r.linkedSeries = [], r.bindAxes(), _(r, {
                  name: e.name,
                  state: "",
                  visible: !1 !== e.visible,
                  selected: !0 === e.selected
                }), f(this, e);
                var i,
                    o = e.events;
                (o && o.click || e.point && e.point.events && e.point.events.click || e.allowPointSelect) && (t.runTrackerClick = !0), r.getColor(), r.getSymbol(), r.parallelArrays.forEach(function (t) {
                  r[t + "Data"] || (r[t + "Data"] = []);
                }), r.isCartesian && (t.hasCartesianSeries = !0), n.length && (i = n[n.length - 1]), r._i = I(i && i._i, -1) + 1, r.opacity = r.options.opacity, t.orderSeries(this.insert(n)), e.dataSorting && e.dataSorting.enabled ? r.setDataSortingOptions() : r.points || r.data || r.setData(e.data, !1), T(this, "afterInit");
              }, a4.prototype.is = function (t) {
                return m[t] && this instanceof m[t];
              }, a4.prototype.insert = function (t) {
                var e,
                    r = this.options.index;

                if (P(r)) {
                  for (e = t.length; e--;) {
                    if (r >= I(t[e].options.index, t[e]._i)) {
                      t.splice(e + 1, 0, this);
                      break;
                    }
                  }

                  -1 === e && t.unshift(this), e += 1;
                } else t.push(this);

                return I(e, t.length - 1);
              }, a4.prototype.bindAxes = function () {
                var t,
                    e = this,
                    r = e.options,
                    n = e.chart;
                T(this, "bindAxes", null, function () {
                  (e.axisTypes || []).forEach(function (i) {
                    var o = 0;
                    n[i].forEach(function (n) {
                      t = n.options, (r[i] === o && !t.isInternal || "undefined" !== typeof r[i] && r[i] === t.id || "undefined" === typeof r[i] && 0 === t.index) && (e.insert(n.series), e[i] = n, n.isDirty = !0), t.isInternal || o++;
                    }), e[i] || e.optionalAxis === i || k(18, !0, n);
                  });
                }), T(this, "afterBindAxes");
              }, a4.prototype.updateParallelArrays = function (t, e) {
                var r = t.series,
                    n = arguments,
                    i = P(e) ? function (n) {
                  var i = "y" === n && r.toYData ? r.toYData(t) : t[n];
                  r[n + "Data"][e] = i;
                } : function (t) {
                  Array.prototype[e].apply(r[t + "Data"], Array.prototype.slice.call(n, 2));
                };
                r.parallelArrays.forEach(i);
              }, a4.prototype.hasData = function () {
                return this.visible && "undefined" !== typeof this.dataMax && "undefined" !== typeof this.dataMin || this.visible && this.yData && 0 < this.yData.length;
              }, a4.prototype.autoIncrement = function (t) {
                var e,
                    r = this.options,
                    n = r.pointIntervalUnit,
                    i = r.relativeXValue,
                    o = this.chart.time,
                    a = this.xIncrement;
                return a = I(a, r.pointStart, 0), this.pointInterval = e = I(this.pointInterval, r.pointInterval, 1), i && P(t) && (e *= t), n && (r = new o.Date(a), "day" === n ? o.set("Date", r, o.get("Date", r) + e) : "month" === n ? o.set("Month", r, o.get("Month", r) + e) : "year" === n && o.set("FullYear", r, o.get("FullYear", r) + e), e = r.getTime() - a), i && P(t) ? a + e : (this.xIncrement = a + e, a);
              }, a4.prototype.setDataSortingOptions = function () {
                var t = this.options;
                _(this, {
                  requireSorting: !1,
                  sorted: !1,
                  enabledDataSorting: !0,
                  allowDG: !1
                }), O(t.pointRange) || (t.pointRange = 1);
              }, a4.prototype.setOptions = function (t) {
                var e = this.chart,
                    r = e.options,
                    n = r.plotOptions,
                    i = e.userOptions || {};
                t = R(t), e = e.styledMode;
                var o = {
                  plotOptions: n,
                  userOptions: t
                };
                T(this, "setOptions", o);
                var a = o.plotOptions[this.type],
                    s = i.plotOptions || {};
                return this.userOptions = o.userOptions, i = R(a, n.series, i.plotOptions && i.plotOptions[this.type], t), this.tooltipOptions = R(d.tooltip, d.plotOptions.series && d.plotOptions.series.tooltip, d.plotOptions[this.type].tooltip, r.tooltip.userOptions, n.series && n.series.tooltip, n[this.type].tooltip, t.tooltip), this.stickyTracking = I(t.stickyTracking, s[this.type] && s[this.type].stickyTracking, s.series && s.series.stickyTracking, !(!this.tooltipOptions.shared || this.noSharedTooltip) || i.stickyTracking), null === a.marker && delete i.marker, this.zoneAxis = i.zoneAxis, n = this.zones = (i.zones || []).slice(), !i.negativeColor && !i.negativeFillColor || i.zones || (r = {
                  value: i[this.zoneAxis + "Threshold"] || i.threshold || 0,
                  className: "highcharts-negative"
                }, e || (r.color = i.negativeColor, r.fillColor = i.negativeFillColor), n.push(r)), n.length && O(n[n.length - 1].value) && n.push(e ? {} : {
                  color: this.color,
                  fillColor: this.fillColor
                }), T(this, "afterSetOptions", {
                  options: i
                }), i;
              }, a4.prototype.getName = function () {
                return I(this.options.name, "Series " + (this.index + 1));
              }, a4.prototype.getCyclic = function (t, e, r) {
                var n = this.chart,
                    i = this.userOptions,
                    o = t + "Index",
                    a = t + "Counter",
                    s = r ? r.length : I(n.options.chart[t + "Count"], n[t + "Count"]);

                if (!e) {
                  var c = I(i[o], i["_" + o]);
                  O(c) || (n.series.length || (n[a] = 0), i["_" + o] = c = n[a] % s, n[a] += 1), r && (e = r[c]);
                }

                "undefined" !== typeof c && (this[o] = c), this[t] = e;
              }, a4.prototype.getColor = function () {
                this.chart.styledMode ? this.getCyclic("color") : this.options.colorByPoint ? this.color = "#cccccc" : this.getCyclic("color", this.options.color || d.plotOptions[this.type].color, this.chart.options.colors);
              }, a4.prototype.getPointsCollection = function () {
                return (this.hasGroupedData ? this.points : this.data) || [];
              }, a4.prototype.getSymbol = function () {
                this.getCyclic("symbol", this.options.marker.symbol, this.chart.options.symbols);
              }, a4.prototype.findPointIndex = function (t, e) {
                var r,
                    n,
                    i = t.id,
                    a = t.x,
                    s = this.points,
                    c = this.options.dataSorting;
                if (i) (c = this.chart.get(i)) instanceof o && (r = c);else if ((this.linkedParent || this.enabledDataSorting || this.options.relativeXValue) && (r = function h5(e) {
                  return !e.touched && e.index === t.index;
                }, c && c.matchByName ? r = function h5(e) {
                  return !e.touched && e.name === t.name;
                } : this.options.relativeXValue && (r = function h5(e) {
                  return !e.touched && e.options.x === t.x;
                }), !(r = C(s, r)))) return;

                if (r) {
                  var l = r && r.index;
                  "undefined" !== typeof l && (n = !0);
                }

                return "undefined" === typeof l && P(a) && (l = this.xData.indexOf(a, e)), -1 !== l && "undefined" !== typeof l && this.cropped && (l = l >= this.cropStart ? l - this.cropStart : l), !n && P(l) && s[l] && s[l].touched && (l = void 0), l;
              }, a4.prototype.updateData = function (t, e) {
                var r,
                    n,
                    i,
                    o = this.options,
                    a = o.dataSorting,
                    s = this.points,
                    c = [],
                    l = this.requireSorting,
                    u = t.length === s.length,
                    h = !0;
                if (this.xIncrement = null, t.forEach(function (t, e) {
                  var n = O(t) && this.pointClass.prototype.optionsToObject.call({
                    series: this
                  }, t) || {},
                      h = n.x;
                  n.id || P(h) ? (-1 === (n = this.findPointIndex(n, i)) || "undefined" === typeof n ? c.push(t) : s[n] && t !== o.data[n] ? (s[n].update(t, !1, null, !1), s[n].touched = !0, l && (i = n + 1)) : s[n] && (s[n].touched = !0), (!u || e !== n || a && a.enabled || this.hasDerivedData) && (r = !0)) : c.push(t);
                }, this), r) for (t = s.length; t--;) {
                  (n = s[t]) && !n.touched && n.remove && n.remove(!1, e);
                } else !u || a && a.enabled ? h = !1 : (t.forEach(function (t, e) {
                  t !== s[e].y && s[e].update && s[e].update(t, !1, null, !1);
                }), c.length = 0);
                return s.forEach(function (t) {
                  t && (t.touched = !1);
                }), !!h && (c.forEach(function (t) {
                  this.addPoint(t, !1, null, null, !1);
                }, this), null === this.xIncrement && this.xData && this.xData.length && (this.xIncrement = v(this.xData), this.autoIncrement()), !0);
              }, a4.prototype.setData = function (t, e, r, n) {
                void 0 === e && (e = !0);
                var i = this,
                    o = i.points,
                    a = o && o.length || 0,
                    s = i.options,
                    c = i.chart,
                    l = s.dataSorting,
                    u = i.xAxis,
                    h = s.turboThreshold,
                    d = this.xData,
                    f = this.yData,
                    p = i.pointArrayMap;
                p = p && p.length;
                var y,
                    g = s.keys,
                    m = 0,
                    v = 1,
                    b = null;

                if (!c.options.chart.allowMutatingData) {
                  s.data && delete i.options.data, i.userOptions.data && delete i.userOptions.data;
                  var x = R(!0, t);
                }

                if (x = (t = x || t || []).length, l && l.enabled && (t = this.sortData(t)), c.options.chart.allowMutatingData && !1 !== n && x && a && !i.cropped && !i.hasGroupedData && i.visible && !i.boosted && (y = this.updateData(t, r)), !y) {
                  if (i.xIncrement = null, i.colorCounter = 0, this.parallelArrays.forEach(function (t) {
                    i[t + "Data"].length = 0;
                  }), h && x > h) {
                    if (b = i.getFirstValidPoint(t), P(b)) for (r = 0; r < x; r++) {
                      d[r] = this.autoIncrement(), f[r] = t[r];
                    } else if (M(b)) {
                      if (p) {
                        if (b.length === p) for (r = 0; r < x; r++) {
                          d[r] = this.autoIncrement(), f[r] = t[r];
                        } else for (r = 0; r < x; r++) {
                          n = t[r], d[r] = n[0], f[r] = n.slice(1, p + 1);
                        }
                      } else if (g && (m = 0 <= (m = g.indexOf("x")) ? m : 0, v = 0 <= (v = g.indexOf("y")) ? v : 1), 1 === b.length && (v = 0), m === v) for (r = 0; r < x; r++) {
                        d[r] = this.autoIncrement(), f[r] = t[r][v];
                      } else for (r = 0; r < x; r++) {
                        n = t[r], d[r] = n[m], f[r] = n[v];
                      }
                    } else k(12, !1, c);
                  } else for (r = 0; r < x; r++) {
                    "undefined" !== typeof t[r] && (n = {
                      series: i
                    }, i.pointClass.prototype.applyOptions.apply(n, [t[r]]), i.updateParallelArrays(n, r));
                  }

                  for (f && j(f[0]) && k(14, !0, c), i.data = [], i.options.data = i.userOptions.data = t, r = a; r--;) {
                    o[r] && o[r].destroy && o[r].destroy();
                  }

                  u && (u.minRange = u.userMinRange), i.isDirty = c.isDirtyBox = !0, i.isDirtyData = !!o, r = !1;
                }

                "point" === s.legendType && (this.processData(), this.generatePoints()), e && c.redraw(r);
              }, a4.prototype.sortData = function (t) {
                var e = this,
                    r = e.options.dataSorting.sortKey || "y",
                    n = function d4(t, e) {
                  return O(e) && t.pointClass.prototype.optionsToObject.call({
                    series: t
                  }, e) || {};
                };

                return t.forEach(function (r, i) {
                  t[i] = n(e, r), t[i].index = i;
                }, this), t.concat().sort(function (t, e) {
                  return t = A(r, t), (e = A(r, e)) < t ? -1 : e > t ? 1 : 0;
                }).forEach(function (t, e) {
                  t.x = e;
                }, this), e.linkedSeries && e.linkedSeries.forEach(function (e) {
                  var r = e.options,
                      i = r.data;
                  r.dataSorting && r.dataSorting.enabled || !i || (i.forEach(function (r, o) {
                    i[o] = n(e, r), t[o] && (i[o].x = t[o].x, i[o].index = o);
                  }), e.setData(i, !1));
                }), t;
              }, a4.prototype.getProcessedData = function (t) {
                var e = this.xAxis,
                    r = this.options,
                    n = r.cropThreshold,
                    i = t || this.getExtremesFromAll || r.getExtremesFromAll,
                    o = this.isCartesian;
                t = e && e.val2lin, r = !(!e || !e.logarithmic);
                var a = 0,
                    s = this.xData,
                    c = this.yData,
                    l = this.requireSorting,
                    u = !1,
                    h = s.length;

                if (e) {
                  var d = (u = e.getExtremes()).min,
                      f = u.max;
                  u = !(!e.categories || e.names.length);
                }

                if (o && this.sorted && !i && (!n || h > n || this.forceCrop)) if (s[h - 1] < d || s[0] > f) s = [], c = [];else if (this.yData && (s[0] < d || s[h - 1] > f)) {
                  var p = this.cropData(this.xData, this.yData, d, f);
                  s = p.xData, c = p.yData, a = p.start, p = !0;
                }

                for (n = s.length || 1; --n;) {
                  if (0 < (e = r ? t(s[n]) - t(s[n - 1]) : s[n] - s[n - 1]) && ("undefined" === typeof y || e < y)) var y = e;else 0 > e && l && !u && (k(15, !1, this.chart), l = !1);
                }

                return {
                  xData: s,
                  yData: c,
                  cropped: p,
                  cropStart: a,
                  closestPointRange: y
                };
              }, a4.prototype.processData = function (t) {
                var e = this.xAxis;
                if (this.isCartesian && !this.isDirty && !e.isDirty && !this.yAxis.isDirty && !t) return !1;
                t = this.getProcessedData(), this.cropped = t.cropped, this.cropStart = t.cropStart, this.processedXData = t.xData, this.processedYData = t.yData, this.closestPointRange = this.basePointRange = t.closestPointRange, T(this, "afterProcessData");
              }, a4.prototype.cropData = function (t, e, r, n, i) {
                var o,
                    a = t.length,
                    s = 0,
                    c = a;

                for (i = I(i, this.cropShoulder), o = 0; o < a; o++) {
                  if (t[o] >= r) {
                    s = Math.max(0, o - i);
                    break;
                  }
                }

                for (r = o; r < a; r++) {
                  if (t[r] > n) {
                    c = r + i;
                    break;
                  }
                }

                return {
                  xData: t.slice(s, c),
                  yData: e.slice(s, c),
                  start: s,
                  end: c
                };
              }, a4.prototype.generatePoints = function () {
                var t = this.options,
                    e = this.processedData || t.data,
                    r = this.processedXData,
                    n = this.processedYData,
                    i = this.pointClass,
                    o = r.length,
                    a = this.cropStart || 0,
                    s = this.hasGroupedData,
                    c = t.keys,
                    l = [];
                t = t.dataGrouping && t.dataGrouping.groupAll ? a : 0;
                var u,
                    h,
                    d = this.data;

                if (!d && !s) {
                  var f = [];
                  f.length = e.length, d = this.data = f;
                }

                for (c && s && (this.options.keys = !1), h = 0; h < o; h++) {
                  if (f = a + h, s) {
                    var p = new i().init(this, [r[h]].concat(N(n[h])));
                    p.dataGroup = this.groupMap[t + h], p.dataGroup.options && (p.options = p.dataGroup.options, _(p, p.dataGroup.options), delete p.dataLabels);
                  } else (p = d[f]) || "undefined" === typeof e[f] || (d[f] = p = new i().init(this, e[f], r[h]));

                  p && (p.index = s ? t + h : f, l[h] = p);
                }

                if (this.options.keys = c, d && (o !== (u = d.length) || s)) for (h = 0; h < u; h++) {
                  h !== a || s || (h += o), d[h] && (d[h].destroyElements(), d[h].plotX = void 0);
                }
                this.data = d, this.points = l, T(this, "afterGeneratePoints");
              }, a4.prototype.getXExtremes = function (t) {
                return {
                  min: b(t),
                  max: v(t)
                };
              }, a4.prototype.getExtremes = function (t, e) {
                var r = this.xAxis,
                    n = this.yAxis,
                    i = this.processedXData || this.xData,
                    o = [],
                    a = this.requireSorting ? this.cropShoulder : 0;
                n = !!n && n.positiveValuesOnly;
                var s,
                    c = 0,
                    l = 0,
                    u = 0,
                    h = (t = t || this.stackedYData || this.processedYData || []).length;

                if (r) {
                  var d = r.getExtremes();
                  c = d.min, l = d.max;
                }

                for (s = 0; s < h; s++) {
                  var f = i[s];
                  d = t[s];
                  var p = (P(d) || M(d)) && (d.length || 0 < d || !n);
                  if (f = e || this.getExtremesFromAll || this.options.getExtremesFromAll || this.cropped || !r || (i[s + a] || f) >= c && (i[s - a] || f) <= l, p && f) if (p = d.length) for (; p--;) {
                    P(d[p]) && (o[u++] = d[p]);
                  } else o[u++] = d;
                }

                return t = {
                  activeYData: o,
                  dataMin: b(o),
                  dataMax: v(o)
                }, T(this, "afterGetExtremes", {
                  dataExtremes: t
                }), t;
              }, a4.prototype.applyExtremes = function () {
                var t = this.getExtremes();
                return this.dataMin = t.dataMin, this.dataMax = t.dataMax, t;
              }, a4.prototype.getFirstValidPoint = function (t) {
                for (var e = t.length, r = 0, n = null; null === n && r < e;) {
                  n = t[r], r++;
                }

                return n;
              }, a4.prototype.translate = function () {
                this.processedXData || this.processData(), this.generatePoints();
                var t,
                    e,
                    r = this.options,
                    n = r.stacking,
                    i = this.xAxis,
                    o = i.categories,
                    a = this.enabledDataSorting,
                    s = this.yAxis,
                    c = this.points,
                    l = c.length,
                    u = this.pointPlacementToXValue(),
                    h = !!u,
                    d = r.threshold,
                    f = r.startFromThreshold ? d : 0,
                    p = this.zoneAxis || "y",
                    y = Number.MAX_VALUE;

                for (t = 0; t < l; t++) {
                  var g = c[t],
                      m = g.x,
                      v = void 0,
                      b = void 0,
                      w = g.y,
                      E = g.low,
                      k = n && s.stacking && s.stacking.stacks[(this.negStacks && w < (f ? 0 : d) ? "-" : "") + this.stackKey];

                  if ((s.positiveValuesOnly && !s.validatePositiveValue(w) || i.positiveValuesOnly && !i.validatePositiveValue(m)) && (g.isNull = !0), g.plotX = e = S(x(i.translate(m, 0, 0, 0, 1, u, "flags" === this.type), -1e5, 1e5)), n && this.visible && k && k[m]) {
                    var _ = this.getStackIndicator(_, m, this.index);

                    !g.isNull && _.key && (b = (v = k[m]).points[_.key]), v && M(b) && (E = b[0], w = b[1], E === f && _.key === k[m].base && (E = I(P(d) ? d : s.min)), s.positiveValuesOnly && O(E) && 0 >= E && (E = void 0), g.total = g.stackTotal = I(v.total), g.percentage = O(g.y) && v.total ? g.y / v.total * 100 : void 0, g.stackY = w, this.irregularWidths || v.setOffset(this.pointXOffset || 0, this.barW || 0, void 0, void 0, void 0, this.xAxis));
                  }

                  if (g.yBottom = O(E) ? x(s.translate(E, 0, 1, 0, 1), -1e5, 1e5) : void 0, this.dataModify && (w = this.dataModify.modifyValue(w, t)), g.plotY = void 0, P(w) && "undefined" !== typeof (v = s.translate(w, !1, !0, !1, !0)) && (g.plotY = x(v, -1e5, 1e5)), g.isInside = this.isPointInside(g), g.clientX = h ? S(i.translate(m, 0, 0, 0, 1, u)) : e, g.negative = g[p] < (r[p + "Threshold"] || d || 0), g.category = I(o && o[g.x], g.x), !g.isNull && !1 !== g.visible) {
                    "undefined" !== typeof C && (y = Math.min(y, Math.abs(e - C)));
                    var C = e;
                  }

                  g.zone = this.zones.length ? g.getZone() : void 0, !g.graphic && this.group && a && (g.isNew = !0);
                }

                this.closestPointRangePx = y, T(this, "afterTranslate");
              }, a4.prototype.getValidPoints = function (t, e, r) {
                var n = this.chart;
                return (t || this.points || []).filter(function (t) {
                  return !(e && !n.isInsidePlot(t.plotX, t.plotY, {
                    inverted: n.inverted
                  })) && !1 !== t.visible && (r || !t.isNull);
                });
              }, a4.prototype.getClipBox = function () {
                var t = this.chart,
                    e = this.xAxis,
                    r = this.yAxis,
                    n = R(t.clipBox);
                return e && e.len !== t.plotSizeX && (n.width = e.len), r && r.len !== t.plotSizeY && (n.height = r.len), n;
              }, a4.prototype.getSharedClipKey = function () {
                return this.sharedClipKey = (this.options.xAxis || 0) + "," + (this.options.yAxis || 0);
              }, a4.prototype.setClip = function () {
                var t = this.chart,
                    e = this.group,
                    r = this.markerGroup,
                    n = t.sharedClips;
                t = t.renderer;
                var i = this.getClipBox(),
                    o = this.getSharedClipKey(),
                    a = n[o];
                a ? a.animate(i) : n[o] = a = t.clipRect(i), e && e.clip(!1 === this.options.clip ? void 0 : a), r && r.clip();
              }, a4.prototype.animate = function (t) {
                var e = this.chart,
                    r = this.group,
                    n = this.markerGroup,
                    i = e.inverted,
                    o = u(this.options.animation),
                    a = [this.getSharedClipKey(), o.duration, o.easing, o.defer].join(),
                    s = e.sharedClips[a],
                    c = e.sharedClips[a + "m"];
                if (t && r) o = this.getClipBox(), s ? s.attr("height", o.height) : (o.width = 0, i && (o.x = e.plotHeight), s = e.renderer.clipRect(o), e.sharedClips[a] = s, c = e.renderer.clipRect({
                  x: -99,
                  y: -99,
                  width: i ? e.plotWidth + 199 : 99,
                  height: i ? 99 : e.plotHeight + 199
                }), e.sharedClips[a + "m"] = c), r.clip(s), n && n.clip(c);else if (s && !s.hasClass("highcharts-animating")) {
                  e = this.getClipBox();
                  var l = o.step;
                  n && n.element.childNodes.length && (o.step = function (t, e) {
                    l && l.apply(e, arguments), "width" === e.prop && c && c.element && c.attr(i ? "height" : "width", t + 99);
                  }), s.addClass("highcharts-animating").animate(e, o);
                }
              }, a4.prototype.afterAnimate = function () {
                var t = this;
                this.setClip(), D(this.chart.sharedClips, function (e, r, n) {
                  e && !t.chart.container.querySelector('[clip-path="url(#'.concat(e.id, ')"]')) && (e.destroy(), delete n[r]);
                }), this.finishedAnimating = !0, T(this, "afterAnimate");
              }, a4.prototype.drawPoints = function (t) {
                void 0 === t && (t = this.points);
                var e,
                    r,
                    n = this.chart,
                    i = n.styledMode,
                    o = this.colorAxis,
                    a = this.options.marker,
                    s = this[this.specialGroup || "markerGroup"],
                    c = this.xAxis,
                    l = I(a.enabled, !(c && !c.isRadial) || null, this.closestPointRangePx >= a.enabledThreshold * a.radius);
                if (!1 !== a.enabled || this._hasPointMarkers) for (e = 0; e < t.length; e++) {
                  var u = t[e],
                      h = (r = u.graphic) ? "animate" : "attr",
                      d = u.marker || {},
                      f = !!u.marker;

                  if ((l && "undefined" === typeof d.enabled || d.enabled) && !u.isNull && !1 !== u.visible) {
                    var p = I(d.symbol, this.symbol, "rect"),
                        y = this.markerAttribs(u, u.selected && "select");
                    this.enabledDataSorting && (u.startXPos = c.reversed ? -(y.width || 0) : c.width);
                    var g = !1 !== u.isInside;
                    !r && g && (0 < (y.width || 0) || u.hasImage) && (u.graphic = r = n.renderer.symbol(p, y.x, y.y, y.width, y.height, f ? d : a).add(s), this.enabledDataSorting && n.hasRendered && (r.attr({
                      x: u.startXPos
                    }), h = "animate")), r && "animate" === h && r[g ? "show" : "hide"](g).animate(y), r && (d = this.pointAttribs(u, i || !u.selected ? void 0 : "select"), i ? o && r.css({
                      fill: d.fill
                    }) : r[h](d)), r && r.addClass(u.getClassName(), !0);
                  } else r && (u.graphic = r.destroy());
                }
              }, a4.prototype.markerAttribs = function (t, e) {
                var r = this.options,
                    n = r.marker,
                    i = t.marker || {},
                    o = i.symbol || n.symbol,
                    a = {},
                    s = I(i.radius, n && n.radius);
                return e && (n = n.states[e], e = i.states && i.states[e], s = I(e && e.radius, n && n.radius, s && s + (n && n.radiusPlus || 0))), t.hasImage = o && 0 === o.indexOf("url"), t.hasImage && (s = 0), t = t.pos(), P(s) && t && (a.x = t[0] - s, a.y = t[1] - s, r.crisp && (a.x = Math.floor(a.x))), s && (a.width = a.height = 2 * s), a;
              }, a4.prototype.pointAttribs = function (t, e) {
                var r = this.options.marker,
                    n = t && t.options,
                    i = n && n.marker || {},
                    o = n && n.color,
                    a = t && t.color,
                    s = t && t.zone && t.zone.color,
                    c = this.color;
                return t = I(i.lineWidth, r.lineWidth), n = 1, c = o || s || a || c, o = i.fillColor || r.fillColor || c, a = i.lineColor || r.lineColor || c, e = e || "normal", r = r.states[e] || {}, e = i.states && i.states[e] || {}, t = I(e.lineWidth, r.lineWidth, t + I(e.lineWidthPlus, r.lineWidthPlus, 0)), o = e.fillColor || r.fillColor || o, {
                  stroke: a = e.lineColor || r.lineColor || a,
                  "stroke-width": t,
                  fill: o,
                  opacity: n = I(e.opacity, r.opacity, n)
                };
              }, a4.prototype.destroy = function (t) {
                var e,
                    r,
                    n,
                    i = this,
                    o = i.chart,
                    a = /AppleWebKit\/533/.test(g.navigator.userAgent),
                    s = i.data || [];

                for (T(i, "destroy", {
                  keepEventsForUpdate: t
                }), this.removeEvents(t), (i.axisTypes || []).forEach(function (t) {
                  (n = i[t]) && n.series && (E(n.series, i), n.isDirty = n.forceRedraw = !0);
                }), i.legendItem && i.chart.legend.destroyItem(i), e = s.length; e--;) {
                  (r = s[e]) && r.destroy && r.destroy();
                }

                i.clips && i.clips.forEach(function (t) {
                  return t.destroy();
                }), l.clearTimeout(i.animationTimeout), D(i, function (t, e) {
                  t instanceof c && !t.survive && t[a && "group" === e ? "hide" : "destroy"]();
                }), o.hoverSeries === i && (o.hoverSeries = void 0), E(o.series, i), o.orderSeries(), D(i, function (e, r) {
                  t && "hcEvents" === r || delete i[r];
                });
              }, a4.prototype.applyZones = function () {
                var t,
                    e,
                    r,
                    n,
                    i,
                    o,
                    a,
                    s,
                    c = this,
                    l = this.chart,
                    u = l.renderer,
                    h = this.zones,
                    d = this.clips || [],
                    f = this.graph,
                    p = this.area,
                    y = Math.max(l.plotWidth, l.plotHeight),
                    g = this[(this.zoneAxis || "y") + "Axis"],
                    m = l.inverted,
                    v = !1;

                if (h.length && (f || p) && g && "undefined" !== typeof g.min) {
                  var b = g.reversed,
                      w = g.horiz;
                  f && !this.showLine && f.hide(), p && p.hide();
                  var S = g.getExtremes();
                  h.forEach(function (h, O) {
                    t = b ? w ? l.plotWidth : 0 : w ? 0 : g.toPixels(S.min) || 0, t = x(I(e, t), 0, y), e = x(Math.round(g.toPixels(I(h.value, S.max), !0) || 0), 0, y), v && (t = e = g.toPixels(S.max)), n = Math.abs(t - e), i = Math.min(t, e), o = Math.max(t, e), g.isXAxis ? (r = {
                      x: m ? o : i,
                      y: 0,
                      width: n,
                      height: y
                    }, w || (r.x = l.plotHeight - r.x)) : (r = {
                      x: 0,
                      y: m ? o : i,
                      width: y,
                      height: n
                    }, w && (r.y = l.plotWidth - r.y)), m && u.isVML && (r = g.isXAxis ? {
                      x: 0,
                      y: b ? i : o,
                      height: r.width,
                      width: l.chartWidth
                    } : {
                      x: r.y - l.plotLeft - l.spacingBox.x,
                      y: 0,
                      width: r.height,
                      height: l.chartHeight
                    }), d[O] ? d[O].animate(r) : d[O] = u.clipRect(r), a = c["zone-area-" + O], s = c["zone-graph-" + O], f && s && s.clip(d[O]), p && a && a.clip(d[O]), v = h.value > S.max, c.resetZones && 0 === e && (e = void 0);
                  }), this.clips = d;
                } else c.visible && (f && f.show(), p && p.show());
              }, a4.prototype.plotGroup = function (t, e, r, n, i) {
                var o = this[t],
                    a = !o;
                return r = {
                  visibility: r,
                  zIndex: n || .1
                }, "undefined" === typeof this.opacity || this.chart.styledMode || "inactive" === this.state || (r.opacity = this.opacity), a && (this[t] = o = this.chart.renderer.g().add(i)), o.addClass("highcharts-" + e + " highcharts-series-" + this.index + " highcharts-" + this.type + "-series " + (O(this.colorIndex) ? "highcharts-color-" + this.colorIndex + " " : "") + (this.options.className || "") + (o.hasClass("highcharts-tracker") ? " highcharts-tracker" : ""), !0), o.attr(r)[a ? "attr" : "animate"](this.getPlotBox(e)), o;
              }, a4.prototype.getPlotBox = function (t) {
                var e = this.xAxis,
                    r = this.yAxis,
                    n = this.chart;
                return t = n.inverted && !n.polar && e && !1 !== this.invertible && "series" === t, n.inverted && (e = r, r = this.xAxis), {
                  translateX: e ? e.left : n.plotLeft,
                  translateY: r ? r.top : n.plotTop,
                  rotation: t ? 90 : 0,
                  rotationOriginX: t ? (e.len - r.len) / 2 : 0,
                  rotationOriginY: t ? (e.len + r.len) / 2 : 0,
                  scaleX: t ? -1 : 1,
                  scaleY: 1
                };
              }, a4.prototype.removeEvents = function (t) {
                t || L(this), this.eventsToUnbind.length && (this.eventsToUnbind.forEach(function (t) {
                  t();
                }), this.eventsToUnbind.length = 0);
              }, a4.prototype.render = function () {
                var t = this,
                    e = t.chart,
                    r = t.options,
                    n = u(r.animation),
                    i = t.visible ? "inherit" : "hidden",
                    o = r.zIndex,
                    a = t.hasRendered,
                    s = e.seriesGroup;
                e = !t.finishedAnimating && e.renderer.isSVG ? n.duration : 0, T(this, "render"), t.plotGroup("group", "series", i, o, s), t.markerGroup = t.plotGroup("markerGroup", "markers", i, o, s), !1 !== r.clip && t.setClip(), t.animate && e && t.animate(!0), t.drawGraph && (t.drawGraph(), t.applyZones()), t.visible && t.drawPoints(), t.drawDataLabels && t.drawDataLabels(), t.redrawPoints && t.redrawPoints(), t.drawTracker && !1 !== t.options.enableMouseTracking && t.drawTracker(), t.animate && e && t.animate(), a || (e && n.defer && (e += n.defer), t.animationTimeout = B(function () {
                  t.afterAnimate();
                }, e || 0)), t.isDirty = !1, t.hasRendered = !0, T(t, "afterRender");
              }, a4.prototype.redraw = function () {
                var t = this.isDirty || this.isDirtyData;
                this.translate(), this.render(), t && delete this.kdTree;
              }, a4.prototype.searchPoint = function (t, e) {
                var r = this.xAxis,
                    n = this.yAxis,
                    i = this.chart.inverted;
                return this.searchKDTree({
                  clientX: i ? r.len - t.chartY + r.pos : t.chartX - r.pos,
                  plotY: i ? n.len - t.chartX + n.pos : t.chartY - n.pos
                }, e, t);
              }, a4.prototype.buildKDTree = function (t) {
                this.buildingKdTree = !0;
                var e = this,
                    r = -1 < e.options.findNearestPointBy.indexOf("y") ? 2 : 1;
                delete e.kdTree, B(function () {
                  e.kdTree = function a5(t, r, n) {
                    var i = t && t.length;

                    if (i) {
                      var o = e.kdAxisArray[r % n];
                      return t.sort(function (t, e) {
                        return t[o] - e[o];
                      }), {
                        point: t[i = Math.floor(i / 2)],
                        left: a5(t.slice(0, i), r + 1, n),
                        right: a5(t.slice(i + 1), r + 1, n)
                      };
                    }
                  }(e.getValidPoints(null, !e.directTouch), r, r), e.buildingKdTree = !1;
                }, e.options.kdNow || t && "touchstart" === t.type ? 0 : 1);
              }, a4.prototype.searchKDTree = function (t, e, r) {
                var n = this,
                    i = this.kdAxisArray[0],
                    o = this.kdAxisArray[1],
                    a = e ? "distX" : "dist";
                if (e = -1 < n.options.findNearestPointBy.indexOf("y") ? 2 : 1, this.kdTree || this.buildingKdTree || this.buildKDTree(r), this.kdTree) return function d4(t, e, r, s) {
                  var c = e.point,
                      l = n.kdAxisArray[r % s],
                      u = c,
                      h = O(t[i]) && O(c[i]) ? Math.pow(t[i] - c[i], 2) : null,
                      d = O(t[o]) && O(c[o]) ? Math.pow(t[o] - c[o], 2) : null;
                  return d = (h || 0) + (d || 0), c.dist = O(d) ? Math.sqrt(d) : Number.MAX_VALUE, c.distX = O(h) ? Math.sqrt(h) : Number.MAX_VALUE, h = 0 > (l = t[l] - c[l]) ? "right" : "left", e[d = 0 > l ? "left" : "right"] && (u = (d = d4(t, e[d], r + 1, s))[a] < u[a] ? d : c), e[h] && Math.sqrt(l * l) < u[a] && (u = (t = d4(t, e[h], r + 1, s))[a] < u[a] ? t : u), u;
                }(t, this.kdTree, e, e);
              }, a4.prototype.pointPlacementToXValue = function () {
                var t = this.options,
                    e = t.pointRange,
                    r = this.xAxis;
                return "between" === (t = t.pointPlacement) && (t = r.reversed ? -.5 : .5), P(t) ? t * (e || r.pointRange) : 0;
              }, a4.prototype.isPointInside = function (t) {
                var e = this.chart,
                    r = this.xAxis,
                    n = this.yAxis;
                return "undefined" !== typeof t.plotY && "undefined" !== typeof t.plotX && 0 <= t.plotY && t.plotY <= (n ? n.len : e.plotHeight) && 0 <= t.plotX && t.plotX <= (r ? r.len : e.plotWidth);
              }, a4.prototype.drawTracker = function () {
                var t = this,
                    e = t.options,
                    r = e.trackByArea,
                    n = [].concat(r ? t.areaPath : t.graphPath),
                    i = t.chart,
                    o = i.pointer,
                    a = i.renderer,
                    s = i.options.tooltip.snap,
                    c = t.tracker,
                    l = function m5(e) {
                  i.hoverSeries !== t && t.onMouseOver();
                },
                    u = "rgba(192,192,192," + (y ? 1e-4 : .002) + ")";

                c ? c.attr({
                  d: n
                }) : t.graph && (t.tracker = a.path(n).attr({
                  visibility: t.visible ? "inherit" : "hidden",
                  zIndex: 2
                }).addClass(r ? "highcharts-tracker-area" : "highcharts-tracker-line").add(t.group), i.styledMode || t.tracker.attr({
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  stroke: u,
                  fill: r ? u : "none",
                  "stroke-width": t.graph.strokeWidth() + (r ? 0 : 2 * s)
                }), [t.tracker, t.markerGroup, t.dataLabelsGroup].forEach(function (t) {
                  t && (t.addClass("highcharts-tracker").on("mouseover", l).on("mouseout", function (t) {
                    o.onTrackerMouseOut(t);
                  }), e.cursor && !i.styledMode && t.css({
                    cursor: e.cursor
                  }), p) && t.on("touchstart", l);
                })), T(this, "afterDrawTracker");
              }, a4.prototype.addPoint = function (t, e, r, n, i) {
                var o = this.options,
                    a = this.data,
                    s = this.chart,
                    c = this.xAxis;
                c = c && c.hasNames && c.names;
                var l,
                    u = o.data,
                    h = this.xData;
                e = I(e, !0);
                var d = {
                  series: this
                };
                this.pointClass.prototype.applyOptions.apply(d, [t]);
                var f = d.x,
                    p = h.length;
                if (this.requireSorting && f < h[p - 1]) for (l = !0; p && h[p - 1] > f;) {
                  p--;
                }
                this.updateParallelArrays(d, "splice", p, 0, 0), this.updateParallelArrays(d, p), c && d.name && (c[f] = d.name), u.splice(p, 0, t), (l || this.processedData) && (this.data.splice(p, 0, null), this.processData()), "point" === o.legendType && this.generatePoints(), r && (a[0] && a[0].remove ? a[0].remove(!1) : (a.shift(), this.updateParallelArrays(d, "shift"), u.shift())), !1 !== i && T(this, "addPoint", {
                  point: d
                }), this.isDirtyData = this.isDirty = !0, e && s.redraw(n);
              }, a4.prototype.removePoint = function (t, e, r) {
                var n = this,
                    i = n.data,
                    o = i[t],
                    a = n.points,
                    s = n.chart,
                    c = function n3() {
                  a && a.length === i.length && a.splice(t, 1), i.splice(t, 1), n.options.data.splice(t, 1), n.updateParallelArrays(o || {
                    series: n
                  }, "splice", t, 1), o && o.destroy(), n.isDirty = !0, n.isDirtyData = !0, e && s.redraw();
                };

                h(r, s), e = I(e, !0), o ? o.firePointEvent("remove", null, c) : c();
              }, a4.prototype.remove = function (t, e, r, n) {
                function e4() {
                  i.destroy(n), o.isDirtyLegend = o.isDirtyBox = !0, o.linkSeries(), I(t, !0) && o.redraw(e);
                }

                var i = this,
                    o = i.chart;
                !1 !== r ? T(i, "remove", null, e4) : e4();
              }, a4.prototype.update = function (t, e) {
                t = w(t, this.userOptions), T(this, "update", {
                  options: t
                });
                var r = this,
                    n = r.chart,
                    i = r.userOptions,
                    o = r.initialType || r.type,
                    a = n.options.plotOptions,
                    s = m[o].prototype,
                    c = r.finishedAnimating && {
                  animation: !1
                },
                    l = {},
                    u = ["eventOptions", "navigatorSeries", "baseSeries"],
                    h = t.type || i.type || n.options.chart.type,
                    d = !(this.hasDerivedData || h && h !== this.type || "undefined" !== typeof t.pointStart || "undefined" !== typeof t.pointInterval || "undefined" !== typeof t.relativeXValue || t.joinBy || t.mapData || r.hasOptionChanged("dataGrouping") || r.hasOptionChanged("pointStart") || r.hasOptionChanged("pointInterval") || r.hasOptionChanged("pointIntervalUnit") || r.hasOptionChanged("keys"));

                if (h = h || o, d && (u.push("data", "isDirtyData", "points", "processedData", "processedXData", "processedYData", "xIncrement", "cropped", "_hasPointMarkers", "_hasPointLabels", "clips", "nodes", "layout", "level", "mapMap", "mapData", "minY", "maxY", "minX", "maxX"), !1 !== t.visible && u.push("area", "graph"), r.parallelArrays.forEach(function (t) {
                  u.push(t + "Data");
                }), t.data && (t.dataSorting && _(r.options.dataSorting, t.dataSorting), this.setData(t.data, !1))), t = R(i, c, {
                  index: "undefined" === typeof i.index ? r.index : i.index,
                  pointStart: I(a && a.series && a.series.pointStart, i.pointStart, r.xData[0])
                }, !d && {
                  data: r.options.data
                }, t), d && t.data && (t.data = r.options.data), (u = ["group", "markerGroup", "dataLabelsGroup", "transformGroup", "shadowGroup"].concat(u)).forEach(function (t) {
                  u[t] = r[t], delete r[t];
                }), a = !1, m[h]) {
                  if (a = h !== r.type, r.remove(!1, !1, !1, !0), a) if (Object.setPrototypeOf) Object.setPrototypeOf(r, m[h].prototype);else {
                    for (f in c = Object.hasOwnProperty.call(r, "hcEvents") && r.hcEvents, s) {
                      r[f] = void 0;
                    }

                    _(r, m[h].prototype), c ? r.hcEvents = c : delete r.hcEvents;
                  }
                } else k(17, !0, n, {
                  missingModuleFor: h
                });

                if (u.forEach(function (t) {
                  r[t] = u[t];
                }), r.init(n, t), d && this.points) {
                  if (!1 === (t = r.options).visible) l.graphic = 1, l.dataLabel = 1;else if (!r._hasPointLabels) {
                    s = t.marker;
                    var f = t.dataLabels;
                    i = i.marker || {}, !s || !1 !== s.enabled && i.symbol === s.symbol && i.height === s.height && i.width === s.width || (l.graphic = 1), f && !1 === f.enabled && (l.dataLabel = 1);
                  }

                  for (i = 0, s = this.points; i < s.length; i++) {
                    (f = s[i]) && f.series && (f.resolveColor(), Object.keys(l).length && f.destroyElements(l), !1 === t.showInLegend && f.legendItem && n.legend.destroyItem(f));
                  }
                }

                r.initialType = o, n.linkSeries(), a && r.linkedSeries.length && (r.isDirtyData = !0), T(this, "afterUpdate"), I(e, !0) && n.redraw(!!d && void 0);
              }, a4.prototype.setName = function (t) {
                this.name = this.options.name = this.userOptions.name = t, this.chart.isDirtyLegend = !0;
              }, a4.prototype.hasOptionChanged = function (t) {
                var e = this.options[t],
                    r = this.chart.options.plotOptions,
                    n = this.userOptions[t];
                return n ? e !== n : e !== I(r && r[this.type] && r[this.type][t], r && r.series && r.series[t], e);
              }, a4.prototype.onMouseOver = function () {
                var t = this.chart,
                    e = t.hoverSeries;
                t.pointer.setHoverChartIndex(), e && e !== this && e.onMouseOut(), this.options.events.mouseOver && T(this, "mouseOver"), this.setState("hover"), t.hoverSeries = this;
              }, a4.prototype.onMouseOut = function () {
                var t = this.options,
                    e = this.chart,
                    r = e.tooltip,
                    n = e.hoverPoint;
                e.hoverSeries = null, n && n.onMouseOut(), this && t.events.mouseOut && T(this, "mouseOut"), !r || this.stickyTracking || r.shared && !this.noSharedTooltip || r.hide(), e.series.forEach(function (t) {
                  t.setState("", !0);
                });
              }, a4.prototype.setState = function (t, e) {
                var r = this,
                    n = r.options,
                    i = r.graph,
                    o = n.inactiveOtherPoints,
                    a = n.states,
                    s = I(a[t || "normal"] && a[t || "normal"].animation, r.chart.options.chart.animation),
                    c = n.lineWidth,
                    l = 0,
                    u = n.opacity;

                if (t = t || "", r.state !== t && ([r.group, r.markerGroup, r.dataLabelsGroup].forEach(function (e) {
                  e && (r.state && e.removeClass("highcharts-series-" + r.state), t && e.addClass("highcharts-series-" + t));
                }), r.state = t, !r.chart.styledMode)) {
                  if (a[t] && !1 === a[t].enabled) return;
                  if (t && (c = a[t].lineWidth || c + (a[t].lineWidthPlus || 0), u = I(a[t].opacity, u)), i && !i.dashstyle && P(c)) for (n = {
                    "stroke-width": c
                  }, i.animate(n, s); r["zone-graph-" + l];) {
                    r["zone-graph-" + l].animate(n, s), l += 1;
                  }
                  o || [r.group, r.markerGroup, r.dataLabelsGroup, r.labelBySeries].forEach(function (t) {
                    t && t.animate({
                      opacity: u
                    }, s);
                  });
                }

                e && o && r.points && r.setAllPointsToState(t || void 0);
              }, a4.prototype.setAllPointsToState = function (t) {
                this.points.forEach(function (e) {
                  e.setState && e.setState(t);
                });
              }, a4.prototype.setVisible = function (t, e) {
                var r = this,
                    n = r.chart,
                    i = n.options.chart.ignoreHiddenSeries,
                    o = r.visible,
                    a = (r.visible = t = r.options.visible = r.userOptions.visible = "undefined" === typeof t ? !o : t) ? "show" : "hide";
                ["group", "dataLabelsGroup", "markerGroup", "tracker", "tt"].forEach(function (t) {
                  r[t] && r[t][a]();
                }), n.hoverSeries !== r && (n.hoverPoint && n.hoverPoint.series) !== r || r.onMouseOut(), r.legendItem && n.legend.colorizeItem(r, t), r.isDirty = !0, r.options.stacking && n.series.forEach(function (t) {
                  t.options.stacking && t.visible && (t.isDirty = !0);
                }), r.linkedSeries.forEach(function (e) {
                  e.setVisible(t, !1);
                }), i && (n.isDirtyBox = !0), T(r, a), !1 !== e && n.redraw();
              }, a4.prototype.show = function () {
                this.setVisible(!0);
              }, a4.prototype.hide = function () {
                this.setVisible(!1);
              }, a4.prototype.select = function (t) {
                this.selected = t = this.options.selected = "undefined" === typeof t ? !this.selected : t, this.checkbox && (this.checkbox.checked = t), T(this, t ? "select" : "unselect");
              }, a4.prototype.shouldShowTooltip = function (t, e, r) {
                return void 0 === r && (r = {}), r.series = this, r.visiblePlotOnly = !0, this.chart.isInsidePlot(t, e, r);
              }, a4.defaultOptions = a, a4.types = s.seriesTypes, a4.registerType = s.registerSeriesType, a4;
            }(), _(t.prototype, {
              axisTypes: ["xAxis", "yAxis"],
              coll: "series",
              colorCounter: 0,
              cropShoulder: 1,
              directTouch: !1,
              drawLegendSymbol: i.drawLineMarker,
              isCartesian: !0,
              kdAxisArray: ["clientX", "plotY"],
              parallelArrays: ["x", "y"],
              pointClass: o,
              requireSorting: !0,
              sorted: !0
            }), s.series = t, t;
          }), K2(e, "Extensions/ScrollablePlotArea.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Axis/Axis.js"], e["Core/Chart/Chart.js"], e["Core/Series/Series.js"], e["Core/Renderer/RendererRegistry.js"], e["Core/Utilities.js"]], function (t, e, r, n, i, o) {
            var a = t.stop,
                s = o.addEvent,
                c = o.createElement,
                l = o.defined,
                u = o.merge,
                h = o.pick;
            s(r, "afterSetChartSize", function (t) {
              var r = this.options.chart.scrollablePlotArea,
                  n = r && r.minWidth;

              if (r = r && r.minHeight, !this.renderer.forExport) {
                if (n) {
                  if (this.scrollablePixelsX = n = Math.max(0, n - this.chartWidth)) {
                    this.scrollablePlotBox = this.renderer.scrollablePlotBox = u(this.plotBox), this.plotBox.width = this.plotWidth += n, this.inverted ? this.clipBox.height += n : this.clipBox.width += n;
                    var i = {
                      1: {
                        name: "right",
                        value: n
                      }
                    };
                  }
                } else r && (this.scrollablePixelsY = n = Math.max(0, r - this.chartHeight), l(n) && (this.scrollablePlotBox = this.renderer.scrollablePlotBox = u(this.plotBox), this.plotBox.height = this.plotHeight += n, this.inverted ? this.clipBox.width += n : this.clipBox.height += n, i = {
                  2: {
                    name: "bottom",
                    value: n
                  }
                }));

                i && !t.skipAxes && this.axes.forEach(function (t) {
                  i[t.side] ? t.getPlotLinePath = function () {
                    var r = i[t.side].name,
                        n = this[r];
                    this[r] = n - i[t.side].value;
                    var o = e.prototype.getPlotLinePath.apply(this, arguments);
                    return this[r] = n, o;
                  } : (t.setAxisSize(), t.setAxisTranslation());
                });
              }
            }), s(r, "render", function () {
              this.scrollablePixelsX || this.scrollablePixelsY ? (this.setUpScrolling && this.setUpScrolling(), this.applyFixed()) : this.fixedDiv && this.applyFixed();
            }), r.prototype.setUpScrolling = function () {
              var t,
                  e = this,
                  r = {
                WebkitOverflowScrolling: "touch",
                overflowX: "hidden",
                overflowY: "hidden"
              };
              this.scrollablePixelsX && (r.overflowX = "auto"), this.scrollablePixelsY && (r.overflowY = "auto"), this.scrollingParent = c("div", {
                className: "highcharts-scrolling-parent"
              }, {
                position: "relative"
              }, this.renderTo), this.scrollingContainer = c("div", {
                className: "highcharts-scrolling"
              }, r, this.scrollingParent), s(this.scrollingContainer, "scroll", function () {
                e.pointer && (delete e.pointer.chartPosition, e.hoverPoint && (t = e.hoverPoint), e.pointer.runPointActions(void 0, t, !0));
              }), this.innerContainer = c("div", {
                className: "highcharts-inner-container"
              }, null, this.scrollingContainer), this.innerContainer.appendChild(this.container), this.setUpScrolling = null;
            }, r.prototype.moveFixedElements = function () {
              var t,
                  e = this.container,
                  r = this.fixedRenderer,
                  n = ".highcharts-breadcrumbs-group .highcharts-contextbutton .highcharts-credits .highcharts-legend .highcharts-legend-checkbox .highcharts-navigator-series .highcharts-navigator-xaxis .highcharts-navigator-yaxis .highcharts-navigator .highcharts-reset-zoom .highcharts-drillup-button .highcharts-scrollbar .highcharts-subtitle .highcharts-title".split(" ");
              this.scrollablePixelsX && !this.inverted ? t = ".highcharts-yaxis" : this.scrollablePixelsX && this.inverted ? t = ".highcharts-xaxis" : this.scrollablePixelsY && !this.inverted ? t = ".highcharts-xaxis" : this.scrollablePixelsY && this.inverted && (t = ".highcharts-yaxis"), t && n.push(t + ":not(.highcharts-radial-axis)", t + "-labels:not(.highcharts-radial-axis-labels)"), n.forEach(function (t) {
                [].forEach.call(e.querySelectorAll(t), function (t) {
                  (t.namespaceURI === r.SVG_NS ? r.box : r.box.parentNode).appendChild(t), t.style.pointerEvents = "auto";
                });
              });
            }, r.prototype.applyFixed = function () {
              var t = !this.fixedDiv,
                  e = this.options.chart,
                  r = e.scrollablePlotArea,
                  n = i.getRendererType();
              t ? (this.fixedDiv = c("div", {
                className: "highcharts-fixed"
              }, {
                position: "absolute",
                overflow: "hidden",
                pointerEvents: "none",
                zIndex: (e.style && e.style.zIndex || 0) + 2,
                top: 0
              }, null, !0), this.scrollingContainer && this.scrollingContainer.parentNode.insertBefore(this.fixedDiv, this.scrollingContainer), this.renderTo.style.overflow = "visible", this.fixedRenderer = e = new n(this.fixedDiv, this.chartWidth, this.chartHeight, this.options.chart.style), this.scrollableMask = e.path().attr({
                fill: this.options.chart.backgroundColor || "#fff",
                "fill-opacity": h(r.opacity, .85),
                zIndex: -1
              }).addClass("highcharts-scrollable-mask").add(), s(this, "afterShowResetZoom", this.moveFixedElements), s(this, "afterApplyDrilldown", this.moveFixedElements), s(this, "afterLayOutTitles", this.moveFixedElements)) : this.fixedRenderer.setSize(this.chartWidth, this.chartHeight), (this.scrollableDirty || t) && (this.scrollableDirty = !1, this.moveFixedElements()), e = this.chartWidth + (this.scrollablePixelsX || 0), n = this.chartHeight + (this.scrollablePixelsY || 0), a(this.container), this.container.style.width = e + "px", this.container.style.height = n + "px", this.renderer.boxWrapper.attr({
                width: e,
                height: n,
                viewBox: [0, 0, e, n].join(" ")
              }), this.chartBackground.attr({
                width: e,
                height: n
              }), this.scrollingContainer.style.height = this.chartHeight + "px", t && (r.scrollPositionX && (this.scrollingContainer.scrollLeft = this.scrollablePixelsX * r.scrollPositionX), r.scrollPositionY && (this.scrollingContainer.scrollTop = this.scrollablePixelsY * r.scrollPositionY)), n = this.axisOffset, t = this.plotTop - n[0] - 1, r = this.plotLeft - n[3] - 1, e = this.plotTop + this.plotHeight + n[2] + 1, n = this.plotLeft + this.plotWidth + n[1] + 1;
              var o = this.plotLeft + this.plotWidth - (this.scrollablePixelsX || 0),
                  l = this.plotTop + this.plotHeight - (this.scrollablePixelsY || 0);
              t = this.scrollablePixelsX ? [["M", 0, t], ["L", this.plotLeft - 1, t], ["L", this.plotLeft - 1, e], ["L", 0, e], ["Z"], ["M", o, t], ["L", this.chartWidth, t], ["L", this.chartWidth, e], ["L", o, e], ["Z"]] : this.scrollablePixelsY ? [["M", r, 0], ["L", r, this.plotTop - 1], ["L", n, this.plotTop - 1], ["L", n, 0], ["Z"], ["M", r, l], ["L", r, this.chartHeight], ["L", n, this.chartHeight], ["L", n, l], ["Z"]] : [["M", 0, 0]], "adjustHeight" !== this.redrawTrigger && this.scrollableMask.attr({
                d: t
              });
            }, s(e, "afterInit", function () {
              this.chart.scrollableDirty = !0;
            }), s(n, "show", function () {
              this.chart.scrollableDirty = !0;
            });
          }), K2(e, "Core/Axis/Stacking/StackItem.js", [e["Core/FormatUtilities.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function (t, e, r) {
            var n = t.format,
                i = e.series,
                o = r.destroyObjectProperties,
                a = r.pick,
                s = r.isNumber;
            return t = function () {
              function a4(t, e, r, n, i) {
                var o = t.chart.inverted,
                    a = t.reversed;
                this.axis = t, t = this.isNegative = !!r !== !!a, this.options = e = e || {}, this.x = n, this.cumulative = this.total = null, this.points = {}, this.hasValidPoints = !1, this.stack = i, this.rightCliff = this.leftCliff = 0, this.alignOptions = {
                  align: e.align || (o ? t ? "left" : "right" : "center"),
                  verticalAlign: e.verticalAlign || (o ? "middle" : t ? "bottom" : "top"),
                  y: e.y,
                  x: e.x
                }, this.textAlign = e.textAlign || (o ? t ? "right" : "left" : "center");
              }

              return a4.prototype.destroy = function () {
                o(this, this.axis);
              }, a4.prototype.render = function (t) {
                var e = this.axis.chart,
                    r = this.options,
                    i = r.format;
                i = i ? n(i, this, e) : r.formatter.call(this), this.label ? this.label.attr({
                  text: i,
                  visibility: "hidden"
                }) : (this.label = e.renderer.label(i, null, void 0, r.shape, void 0, void 0, r.useHTML, !1, "stack-labels"), i = {
                  r: r.borderRadius || 0,
                  text: i,
                  padding: a(r.padding, 5),
                  visibility: "hidden"
                }, e.styledMode || (i.fill = r.backgroundColor, i.stroke = r.borderColor, i["stroke-width"] = r.borderWidth, this.label.css(r.style || {})), this.label.attr(i), this.label.added || this.label.add(t)), this.label.labelrank = e.plotSizeY;
              }, a4.prototype.setOffset = function (t, e, r, n, o, c) {
                var l = this.alignOptions,
                    u = this.axis,
                    h = this.label,
                    d = this.options,
                    f = this.textAlign,
                    p = u.chart;
                t = this.getStackBox({
                  xOffset: t,
                  width: e,
                  boxBottom: r,
                  boxTop: n,
                  defaultX: o,
                  xAxis: c
                }), o = l.verticalAlign, h && t && (e = h.getBBox(), r = h.padding, n = "justify" === a(d.overflow, "justify"), l.x = d.x || 0, l.y = d.y || 0, f = (o = this.adjustStackPosition({
                  labelBox: e,
                  verticalAlign: o,
                  textAlign: f
                })).x, o = o.y, t.x -= f, t.y -= o, h.align(l, !1, t), (f = p.isInsidePlot(h.alignAttr.x + l.x + f, h.alignAttr.y + l.y + o)) || (n = !1), n && i.prototype.justifyDataLabel.call(u, h, l, h.alignAttr, e, t), h.attr({
                  x: h.alignAttr.x,
                  y: h.alignAttr.y,
                  rotation: d.rotation,
                  rotationOriginX: e.width / 2,
                  rotationOriginY: e.height / 2
                }), a(!n && d.crop, !0) && (f = s(h.x) && s(h.y) && p.isInsidePlot(h.x - r + h.width, h.y) && p.isInsidePlot(h.x + r, h.y)), h[f ? "show" : "hide"]());
              }, a4.prototype.adjustStackPosition = function (t) {
                var e = t.labelBox,
                    r = {
                  bottom: 0,
                  middle: 1,
                  top: 2,
                  right: 1,
                  center: 0,
                  left: -1
                };
                return {
                  x: e.width / 2 + e.width / 2 * r[t.textAlign],
                  y: e.height / 2 * r[t.verticalAlign]
                };
              }, a4.prototype.getStackBox = function (t) {
                var e = this.axis,
                    r = e.chart,
                    n = t.boxTop,
                    i = t.defaultX,
                    o = t.xOffset,
                    s = t.width,
                    c = t.boxBottom;
                return n = e.stacking.usePercentage ? 100 : a(n, this.total, 0), n = e.toPixels(n), t = a(i, (t.xAxis || r.xAxis[0]).toPixels(this.x)) + o, e = e.toPixels(c || 0), e = Math.abs(n - e), c = this.isNegative, r.inverted ? {
                  x: (c ? n : n - e) - r.plotLeft,
                  y: t - r.plotTop,
                  width: e,
                  height: s
                } : {
                  x: t - r.plotLeft,
                  y: (c ? n - e : n) - r.plotTop,
                  width: s,
                  height: e
                };
              }, a4;
            }();
          }), K2(e, "Core/Axis/Stacking/StackingAxis.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Axis/Axis.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Axis/Stacking/StackItem.js"], e["Core/Utilities.js"]], function (t, e, r, n, i) {
            function A() {
              var t = this,
                  e = t.inverted;
              t.yAxis.forEach(function (t) {
                t.stacking && t.stacking.stacks && t.hasVisibleSeries && (t.stacking.oldStacks = t.stacking.stacks);
              }), t.series.forEach(function (r) {
                var n = r.xAxis && r.xAxis.options || {};
                !r.options.stacking || !0 !== r.visible && !1 !== t.options.chart.ignoreHiddenSeries || (r.stackKey = [r.type, g(r.options.stack, ""), e ? n.top : n.left, e ? n.height : n.width].join());
              });
            }

            function H3() {
              var t = this.stacking;

              if (t) {
                var e = t.stacks;
                y(e, function (t, r) {
                  h(t), e[r] = null;
                }), t && t.stackTotalGroup && t.stackTotalGroup.destroy();
              }
            }

            function t3() {
              "yAxis" !== this.coll || this.stacking || (this.stacking = new m(this));
            }

            function r2(t, e, r, n) {
              return !u(t) || t.x !== e || n && t.stackKey !== n ? t = {
                x: e,
                index: 0,
                key: n,
                stackKey: n
              } : t.index++, t.key = [r, e, t.index].join(), t;
            }

            function l2() {
              var t,
                  e = this,
                  r = e.stackKey,
                  n = e.yAxis.stacking.stacks,
                  i = e.processedXData,
                  o = e[e.options.stacking + "Stacker"];
              o && [r, "-" + r].forEach(function (r) {
                for (var a, s, c = i.length; c--;) {
                  a = i[c], t = e.getStackIndicator(t, a, e.index, r), (s = (a = n[r] && n[r][a]) && a.points[t.key]) && o.call(e, s, a, c);
                }
              });
            }

            function e3(t, e, r) {
              e = e.total ? 100 / e.total : 0, t[0] = l(t[0] * e), t[1] = l(t[1] * e), this.stackedYData[r] = t[1];
            }

            function d3() {
              var t = this.yAxis.stacking;
              this.options.centerInCategory && (this.is("column") || this.is("columnrange")) && !this.options.stacking && 1 < this.chart.series.length ? s.setStackedPoints.call(this, "group") : t && y(t.stacks, function (e, r) {
                "group" === r.slice(-5) && (y(e, function (t) {
                  return t.destroy();
                }), delete t.stacks[r]);
              });
            }

            function h4(t) {
              var e = this.chart,
                  r = t || this.options.stacking;

              if (r && (!0 === this.visible || !1 === e.options.chart.ignoreHiddenSeries)) {
                var i = this.processedXData,
                    o = this.processedYData,
                    a = [],
                    s = o.length,
                    c = this.options,
                    h = c.threshold,
                    d = g(c.startFromThreshold && h, 0);
                c = c.stack;
                var p,
                    y,
                    m = "-" + (t = t ? "" + this.type + ",".concat(r) : this.stackKey),
                    v = this.negStacks,
                    b = (e = "group" === r ? e.yAxis[0] : this.yAxis).stacking.stacks,
                    x = e.stacking.oldStacks;

                for (e.stacking.stacksTouched += 1, y = 0; y < s; y++) {
                  var w = i[y],
                      S = o[y],
                      O = this.getStackIndicator(O, w, this.index),
                      E = O.key,
                      k = (p = v && S < (d ? 0 : h)) ? m : t;
                  b[k] || (b[k] = {}), b[k][w] || (x[k] && x[k][w] ? (b[k][w] = x[k][w], b[k][w].total = null) : b[k][w] = new n(e, e.options.stackLabels, !!p, w, c)), k = b[k][w], null !== S ? (k.points[E] = k.points[this.index] = [g(k.cumulative, d)], u(k.cumulative) || (k.base = E), k.touched = e.stacking.stacksTouched, 0 < O.index && !1 === this.singleStacks && (k.points[E][0] = k.points[this.index + "," + w + ",0"][0])) : k.points[E] = k.points[this.index] = null, "percent" === r ? (p = p ? t : m, v && b[p] && b[p][w] ? (p = b[p][w], k.total = p.total = Math.max(p.total, k.total) + Math.abs(S) || 0) : k.total = l(k.total + (Math.abs(S) || 0))) : "group" === r ? (f(S) && (S = S[0]), null !== S && (k.total = (k.total || 0) + 1)) : k.total = l(k.total + (S || 0)), k.cumulative = "group" === r ? (k.total || 1) - 1 : g(k.cumulative, d) + (S || 0), null !== S && (k.points[E].push(k.cumulative), a[y] = k.cumulative, k.hasValidPoints = !0);
                }

                "percent" === r && (e.stacking.usePercentage = !0), "group" !== r && (this.stackedYData = a), e.stacking.oldStacks = {};
              }
            }

            var o,
                a = t.getDeferredAnimation,
                s = r.series.prototype,
                c = i.addEvent,
                l = i.correctFloat,
                u = i.defined,
                h = i.destroyObjectProperties,
                d = i.fireEvent,
                f = i.isArray,
                p = i.isNumber,
                y = i.objectEach,
                g = i.pick,
                m = function () {
              function b3(t) {
                this.oldStacks = {}, this.stacks = {}, this.stacksTouched = 0, this.axis = t;
              }

              return b3.prototype.buildStacks = function () {
                var t,
                    e = this.axis,
                    r = e.series,
                    n = e.options.reversedStacks,
                    i = r.length;

                for (this.usePercentage = !1, t = i; t--;) {
                  var o = r[n ? t : i - t - 1];
                  o.setStackedPoints(), o.setGroupedPoints();
                }

                for (t = 0; t < i; t++) {
                  r[t].modifyStacks();
                }

                d(e, "afterBuildStacks");
              }, b3.prototype.cleanStacks = function () {
                if (this.oldStacks) var t = this.stacks = this.oldStacks;
                y(t, function (t) {
                  y(t, function (t) {
                    t.cumulative = t.total;
                  });
                });
              }, b3.prototype.resetStacks = function () {
                var t = this;
                y(this.stacks, function (e) {
                  y(e, function (r, n) {
                    p(r.touched) && r.touched < t.stacksTouched ? (r.destroy(), delete e[n]) : (r.total = null, r.cumulative = null);
                  });
                });
              }, b3.prototype.renderStackTotals = function () {
                var t = this.axis,
                    e = t.chart,
                    r = e.renderer,
                    n = this.stacks;
                t = a(e, t.options.stackLabels && t.options.stackLabels.animation || !1);
                var i = this.stackTotalGroup = this.stackTotalGroup || r.g("stack-labels").attr({
                  zIndex: 6,
                  opacity: 0
                }).add();
                i.translate(e.plotLeft, e.plotTop), y(n, function (t) {
                  y(t, function (t) {
                    t.render(i);
                  });
                }), i.animate({
                  opacity: 1
                }, t);
              }, b3;
            }();

            return function (t) {
              var e = [];

              t.compose = function (t, r, n) {
                -1 === e.indexOf(t) && (e.push(t), c(t, "init", t3), c(t, "destroy", H3)), -1 === e.indexOf(r) && (e.push(r), r.prototype.getStacks = A), -1 === e.indexOf(n) && (e.push(n), (t = n.prototype).getStackIndicator = r2, t.modifyStacks = l2, t.percentStacker = e3, t.setGroupedPoints = d3, t.setStackedPoints = h4);
              };
            }(o || (o = {})), o;
          }), K2(e, "Series/Line/LineSeries.js", [e["Core/Series/Series.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function (t, e, r) {
            var n = this && this.__extends || function () {
              var t = function a4(e, r) {
                return (t = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, e) {
                  t.__proto__ = e;
                } || function (t, e) {
                  for (var r in e) {
                    e.hasOwnProperty(r) && (t[r] = e[r]);
                  }
                })(e, r);
              };

              return function (e, r) {
                function l2() {
                  this.constructor = e;
                }

                t(e, r), e.prototype = null === r ? Object.create(r) : (l2.prototype = r.prototype, new l2());
              };
            }(),
                i = r.defined,
                o = r.merge;

            return r = function (e) {
              function t3() {
                var t = null !== e && e.apply(this, arguments) || this;
                return t.data = void 0, t.options = void 0, t.points = void 0, t;
              }

              return n(t3, e), t3.prototype.drawGraph = function () {
                var t = this,
                    e = this.options,
                    r = (this.gappedPath || this.getGraphPath).call(this),
                    n = this.chart.styledMode,
                    i = [["graph", "highcharts-graph"]];
                n || i[0].push(e.lineColor || this.color || "#cccccc", e.dashStyle), (i = t.getZonesGraphs(i)).forEach(function (i, o) {
                  var a = i[0],
                      s = t[a],
                      c = s ? "animate" : "attr";
                  s ? (s.endX = t.preventGraphAnimation ? null : r.xMap, s.animate({
                    d: r
                  })) : r.length && (t[a] = s = t.chart.renderer.path(r).addClass(i[1]).attr({
                    zIndex: 1
                  }).add(t.group)), s && !n && (a = {
                    stroke: i[2],
                    "stroke-width": e.lineWidth || 0,
                    fill: t.fillGraph && t.color || "none"
                  }, i[3] ? a.dashstyle = i[3] : "square" !== e.linecap && (a["stroke-linecap"] = a["stroke-linejoin"] = "round"), s[c](a).shadow(2 > o && e.shadow)), s && (s.startX = r.xMap, s.isArea = r.isArea);
                });
              }, t3.prototype.getGraphPath = function (t, e, r) {
                var n,
                    o = this,
                    a = o.options,
                    s = [],
                    c = [],
                    l = a.step,
                    u = (t = t || o.points).reversed;
                return u && t.reverse(), (l = {
                  right: 1,
                  center: 2
                }[l] || l && 3) && u && (l = 4 - l), (t = this.getValidPoints(t, !1, !(a.connectNulls && !e && !r))).forEach(function (u, h) {
                  var d = u.plotX,
                      f = u.plotY,
                      p = t[h - 1];
                  (u.leftCliff || p && p.rightCliff) && !r && (n = !0), u.isNull && !i(e) && 0 < h ? n = !a.connectNulls : u.isNull && !e ? n = !0 : (0 === h || n ? h = [["M", u.plotX, u.plotY]] : o.getPointSpline ? h = [o.getPointSpline(t, u, h)] : l ? (h = 1 === l ? [["L", p.plotX, f]] : 2 === l ? [["L", (p.plotX + d) / 2, p.plotY], ["L", (p.plotX + d) / 2, f]] : [["L", d, p.plotY]]).push(["L", d, f]) : h = [["L", d, f]], c.push(u.x), l && (c.push(u.x), 2 === l && c.push(u.x)), s.push.apply(s, h), n = !1);
                }), s.xMap = c, o.graphPath = s;
              }, t3.prototype.getZonesGraphs = function (t) {
                return this.zones.forEach(function (e, r) {
                  r = ["zone-graph-" + r, "highcharts-graph highcharts-zone-graph-" + r + " " + (e.className || "")], this.chart.styledMode || r.push(e.color || this.color, e.dashStyle || this.options.dashStyle), t.push(r);
                }, this), t;
              }, t3.defaultOptions = o(t.defaultOptions, {}), t3;
            }(t), e.registerSeriesType("line", r), r;
          }), K2(e, "Series/Area/AreaSeries.js", [e["Core/Color/Color.js"], e["Core/Legend/LegendSymbol.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function (t, e, r, n) {
            var i = this && this.__extends || function () {
              var t = function a4(e, r) {
                return (t = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, e) {
                  t.__proto__ = e;
                } || function (t, e) {
                  for (var r in e) {
                    e.hasOwnProperty(r) && (t[r] = e[r]);
                  }
                })(e, r);
              };

              return function (e, r) {
                function h4() {
                  this.constructor = e;
                }

                t(e, r), e.prototype = null === r ? Object.create(r) : (h4.prototype = r.prototype, new h4());
              };
            }(),
                o = t.parse,
                a = r.seriesTypes.line;

            t = n.extend;
            var s = n.merge,
                c = n.objectEach,
                l = n.pick;
            return t((n = function (t) {
              function d3() {
                var e = null !== t && t.apply(this, arguments) || this;
                return e.data = void 0, e.options = void 0, e.points = void 0, e;
              }

              return i(d3, t), d3.prototype.drawGraph = function () {
                this.areaPath = [], t.prototype.drawGraph.apply(this);
                var e = this,
                    r = this.areaPath,
                    n = this.options,
                    i = [["area", "highcharts-area", this.color, n.fillColor]];
                this.zones.forEach(function (t, r) {
                  i.push(["zone-area-" + r, "highcharts-area highcharts-zone-area-" + r + " " + t.className, t.color || e.color, t.fillColor || n.fillColor]);
                }), i.forEach(function (t) {
                  var i = t[0],
                      a = {},
                      s = e[i],
                      c = s ? "animate" : "attr";
                  s ? (s.endX = e.preventGraphAnimation ? null : r.xMap, s.animate({
                    d: r
                  })) : (a.zIndex = 0, (s = e[i] = e.chart.renderer.path(r).addClass(t[1]).add(e.group)).isArea = !0), e.chart.styledMode || (a.fill = l(t[3], o(t[2]).setOpacity(l(n.fillOpacity, .75)).get())), s[c](a), s.startX = r.xMap, s.shiftUnit = n.step ? 2 : 1;
                });
              }, d3.prototype.getGraphPath = function (t) {
                var e = a.prototype.getGraphPath,
                    r = this.options,
                    n = r.stacking,
                    i = this.yAxis,
                    o = [],
                    s = [],
                    c = this.index,
                    u = i.stacking.stacks[this.stackKey],
                    h = r.threshold,
                    d = Math.round(i.getThreshold(r.threshold));
                r = l(r.connectNulls, "percent" === n);

                var f = function f2(e, r, a) {
                  var l = t[e];
                  e = n && u[l.x].points[c];
                  var f = l[a + "Null"] || 0;

                  if (a = l[a + "Cliff"] || 0, l = !0, a || f) {
                    var p = (f ? e[0] : e[1]) + a,
                        y = e[0] + a;
                    l = !!f;
                  } else !n && t[r] && t[r].isNull && (p = y = h);

                  "undefined" !== typeof p && (s.push({
                    plotX: m,
                    plotY: null === p ? d : i.getThreshold(p),
                    isNull: l,
                    isCliff: !0
                  }), o.push({
                    plotX: m,
                    plotY: null === y ? d : i.getThreshold(y),
                    doCurve: !1
                  }));
                };

                t = t || this.points, n && (t = this.getStackPoints(t));

                for (var p = 0, y = t.length; p < y; ++p) {
                  n || (t[p].leftCliff = t[p].rightCliff = t[p].leftNull = t[p].rightNull = void 0);
                  var g = t[p].isNull,
                      m = l(t[p].rectPlotX, t[p].plotX),
                      v = n ? l(t[p].yBottom, d) : d;
                  g && !r || (r || f(p, p - 1, "left"), g && !n && r || (s.push(t[p]), o.push({
                    x: p,
                    plotX: m,
                    plotY: v
                  })), r || f(p, p + 1, "right"));
                }

                return f = e.call(this, s, !0, !0), o.reversed = !0, (v = (g = e.call(this, o, !0, !0))[0]) && "M" === v[0] && (g[0] = ["L", v[1], v[2]]), (g = f.concat(g)).length && g.push(["Z"]), e = e.call(this, s, !1, r), g.xMap = f.xMap, this.areaPath = g, e;
              }, d3.prototype.getStackPoints = function (t) {
                var e = this,
                    r = [],
                    n = [],
                    i = this.xAxis,
                    o = this.yAxis,
                    a = o.stacking.stacks[this.stackKey],
                    s = {},
                    u = o.series,
                    h = u.length,
                    d = o.options.reversedStacks ? 1 : -1,
                    f = u.indexOf(e);

                if (t = t || this.points, this.options.stacking) {
                  for (var p = 0; p < t.length; p++) {
                    t[p].leftNull = t[p].rightNull = void 0, s[t[p].x] = t[p];
                  }

                  c(a, function (t, e) {
                    null !== t.total && n.push(e);
                  }), n.sort(function (t, e) {
                    return t - e;
                  });
                  var y = u.map(function (t) {
                    return t.visible;
                  });
                  n.forEach(function (t, c) {
                    var p,
                        g,
                        m = 0;
                    if (s[t] && !s[t].isNull) r.push(s[t]), [-1, 1].forEach(function (r) {
                      var i = 1 === r ? "rightNull" : "leftNull",
                          o = a[n[c + r]],
                          l = 0;
                      if (o) for (var m = f; 0 <= m && m < h;) {
                        var v = u[m].index;
                        (p = o.points[v]) || (v === e.index ? s[t][i] = !0 : y[m] && (g = a[t].points[v]) && (l -= g[1] - g[0])), m += d;
                      }
                      s[t][1 === r ? "rightCliff" : "leftCliff"] = l;
                    });else {
                      for (var v = f; 0 <= v && v < h;) {
                        if (p = a[t].points[u[v].index]) {
                          m = p[1];
                          break;
                        }

                        v += d;
                      }

                      m = l(m, 0), m = o.translate(m, 0, 1, 0, 1), r.push({
                        isNull: !0,
                        plotX: i.translate(t, 0, 0, 0, 1),
                        x: t,
                        plotY: m,
                        yBottom: m
                      });
                    }
                  });
                }

                return r;
              }, d3.defaultOptions = s(a.defaultOptions, {
                threshold: 0
              }), d3;
            }(a)).prototype, {
              singleStacks: !1,
              drawLegendSymbol: e.drawRectangle
            }), r.registerSeriesType("area", n), n;
          }), K2(e, "Series/Spline/SplineSeries.js", [e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function (t, e) {
            var r = this && this.__extends || function () {
              var t = function a4(e, r) {
                return (t = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, e) {
                  t.__proto__ = e;
                } || function (t, e) {
                  for (var r in e) {
                    e.hasOwnProperty(r) && (t[r] = e[r]);
                  }
                })(e, r);
              };

              return function (e, r) {
                function l2() {
                  this.constructor = e;
                }

                t(e, r), e.prototype = null === r ? Object.create(r) : (l2.prototype = r.prototype, new l2());
              };
            }(),
                n = t.seriesTypes.line,
                i = e.merge,
                o = e.pick;

            return e = function (t) {
              function g4() {
                var e = null !== t && t.apply(this, arguments) || this;
                return e.data = void 0, e.options = void 0, e.points = void 0, e;
              }

              return r(g4, t), g4.prototype.getPointSpline = function (t, e, r) {
                var n = e.plotX || 0,
                    i = e.plotY || 0,
                    a = t[r - 1];

                if (r = t[r + 1], a && !a.isNull && !1 !== a.doCurve && !e.isCliff && r && !r.isNull && !1 !== r.doCurve && !e.isCliff) {
                  t = a.plotY || 0;
                  var s = r.plotX || 0;
                  r = r.plotY || 0;
                  var c = 0,
                      l = (1.5 * n + (a.plotX || 0)) / 2.5,
                      u = (1.5 * i + t) / 2.5,
                      h = (1.5 * i + r) / 2.5;
                  (s = (1.5 * n + s) / 2.5) !== l && (c = (h - u) * (s - n) / (s - l) + i - h), h += c, (u += c) > t && u > i ? h = 2 * i - (u = Math.max(t, i)) : u < t && u < i && (h = 2 * i - (u = Math.min(t, i))), h > r && h > i ? u = 2 * i - (h = Math.max(r, i)) : h < r && h < i && (u = 2 * i - (h = Math.min(r, i))), e.rightContX = s, e.rightContY = h;
                }

                return e = ["C", o(a.rightContX, a.plotX, 0), o(a.rightContY, a.plotY, 0), o(l, n, 0), o(u, i, 0), n, i], a.rightContX = a.rightContY = void 0, e;
              }, g4.defaultOptions = i(n.defaultOptions), g4;
            }(n), t.registerSeriesType("spline", e), e;
          }), K2(e, "Series/AreaSpline/AreaSplineSeries.js", [e["Series/Spline/SplineSeries.js"], e["Core/Legend/LegendSymbol.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function (t, e, r, n) {
            var i = this && this.__extends || function () {
              var t = function a4(e, r) {
                return (t = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, e) {
                  t.__proto__ = e;
                } || function (t, e) {
                  for (var r in e) {
                    e.hasOwnProperty(r) && (t[r] = e[r]);
                  }
                })(e, r);
              };

              return function (e, r) {
                function g4() {
                  this.constructor = e;
                }

                t(e, r), e.prototype = null === r ? Object.create(r) : (g4.prototype = r.prototype, new g4());
              };
            }(),
                o = r.seriesTypes,
                a = o.area;

            o = o.area.prototype;
            var s = n.extend,
                c = n.merge;
            return s((n = function (e) {
              function e3() {
                var t = null !== e && e.apply(this, arguments) || this;
                return t.data = void 0, t.points = void 0, t.options = void 0, t;
              }

              return i(e3, e), e3.defaultOptions = c(t.defaultOptions, a.defaultOptions), e3;
            }(t)).prototype, {
              getGraphPath: o.getGraphPath,
              getStackPoints: o.getStackPoints,
              drawGraph: o.drawGraph,
              drawLegendSymbol: e.drawRectangle
            }), r.registerSeriesType("areaspline", n), n;
          }), K2(e, "Series/Column/ColumnSeriesDefaults.js", [], function () {
            return {
              borderRadius: 0,
              centerInCategory: !1,
              groupPadding: .2,
              marker: null,
              pointPadding: .1,
              minPointLength: 0,
              cropThreshold: 50,
              pointRange: null,
              states: {
                hover: {
                  halo: !1,
                  brightness: .1
                },
                select: {
                  color: "#cccccc",
                  borderColor: "#000000"
                }
              },
              dataLabels: {
                align: void 0,
                verticalAlign: void 0,
                y: void 0
              },
              startFromThreshold: !0,
              stickyTracking: !1,
              tooltip: {
                distance: 6
              },
              threshold: 0,
              borderColor: "#ffffff"
            };
          }), K2(e, "Series/Column/ColumnSeries.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Color/Color.js"], e["Series/Column/ColumnSeriesDefaults.js"], e["Core/Globals.js"], e["Core/Legend/LegendSymbol.js"], e["Core/Series/Series.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function (t, e, r, n, i, o, a, s) {
            var c = this && this.__extends || function () {
              var t = function a4(e, r) {
                return (t = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, e) {
                  t.__proto__ = e;
                } || function (t, e) {
                  for (var r in e) {
                    e.hasOwnProperty(r) && (t[r] = e[r]);
                  }
                })(e, r);
              };

              return function (e, r) {
                function e4() {
                  this.constructor = e;
                }

                t(e, r), e.prototype = null === r ? Object.create(r) : (e4.prototype = r.prototype, new e4());
              };
            }(),
                l = t.animObject,
                u = e.parse,
                h = n.hasTouch;

            t = n.noop;
            var d = s.clamp,
                f = s.defined,
                p = s.extend,
                y = s.fireEvent,
                g = s.isArray,
                m = s.isNumber,
                v = s.merge,
                b = s.pick,
                x = s.objectEach;
            return s = function (t) {
              function c2() {
                var e = null !== t && t.apply(this, arguments) || this;
                return e.borderWidth = void 0, e.data = void 0, e.group = void 0, e.options = void 0, e.points = void 0, e;
              }

              return c(c2, t), c2.prototype.animate = function (t) {
                var e = this,
                    r = this.yAxis,
                    n = e.options,
                    i = this.chart.inverted,
                    o = {},
                    a = i ? "translateX" : "translateY";
                if (t) o.scaleY = .001, t = d(r.toPixels(n.threshold), r.pos, r.pos + r.len), i ? o.translateX = t - r.len : o.translateY = t, e.clipBox && e.setClip(), e.group.attr(o);else {
                  var s = Number(e.group.attr(a));
                  e.group.animate({
                    scaleY: 1
                  }, p(l(e.options.animation), {
                    step: function step(t, n) {
                      e.group && (o[a] = s + n.pos * (r.pos - s), e.group.attr(o));
                    }
                  }));
                }
              }, c2.prototype.init = function (e, r) {
                t.prototype.init.apply(this, arguments);
                var n = this;
                (e = n.chart).hasRendered && e.series.forEach(function (t) {
                  t.type === n.type && (t.isDirty = !0);
                });
              }, c2.prototype.getColumnMetrics = function () {
                var t = this,
                    e = t.options,
                    r = t.xAxis,
                    n = t.yAxis,
                    i = r.options.reversedStacks;
                i = r.reversed && !i || !r.reversed && i;
                var o,
                    a = {},
                    s = 0;
                !1 === e.grouping ? s = 1 : t.chart.series.forEach(function (e) {
                  var r = e.yAxis,
                      i = e.options;

                  if (e.type === t.type && (e.visible || !t.chart.options.chart.ignoreHiddenSeries) && n.len === r.len && n.pos === r.pos) {
                    if (i.stacking && "group" !== i.stacking) {
                      o = e.stackKey, "undefined" === typeof a[o] && (a[o] = s++);
                      var c = a[o];
                    } else !1 !== i.grouping && (c = s++);

                    e.columnIndex = c;
                  }
                });
                var c = Math.min(Math.abs(r.transA) * (r.ordinal && r.ordinal.slope || e.pointRange || r.closestPointRange || r.tickInterval || 1), r.len),
                    l = c * e.groupPadding,
                    u = (c - 2 * l) / (s || 1);
                return e = Math.min(e.maxPointWidth || r.len, b(e.pointWidth, u * (1 - 2 * e.pointPadding))), t.columnMetrics = {
                  width: e,
                  offset: (u - e) / 2 + (l + ((t.columnIndex || 0) + (i ? 1 : 0)) * u - c / 2) * (i ? -1 : 1),
                  paddedWidth: u,
                  columnCount: s
                }, t.columnMetrics;
              }, c2.prototype.crispCol = function (t, e, r, n) {
                var i = this.chart,
                    o = this.borderWidth,
                    a = -(o % 2 ? .5 : 0);
                return o = o % 2 ? .5 : 1, i.inverted && i.renderer.isVML && (o += 1), this.options.crisp && (r = Math.round(t + r) + a, r -= t = Math.round(t) + a), n = Math.round(e + n) + o, a = .5 >= Math.abs(e) && .5 < n, n -= e = Math.round(e) + o, a && n && (--e, n += 1), {
                  x: t,
                  y: e,
                  width: r,
                  height: n
                };
              }, c2.prototype.adjustForMissingColumns = function (t, e, r, n) {
                var i = this,
                    o = this.options.stacking;

                if (!r.isNull && 1 < n.columnCount) {
                  var a = this.yAxis.options.reversedStacks,
                      s = 0,
                      c = a ? 0 : -n.columnCount;
                  x(this.yAxis.stacking && this.yAxis.stacking.stacks, function (t) {
                    if ("number" === typeof r.x) {
                      var e = t[r.x.toString()];
                      e && (t = e.points[i.index], o ? (t && (s = c), e.hasValidPoints && (a ? c++ : c--)) : g(t) && (t = Object.keys(e.points).filter(function (t) {
                        return !t.match(",") && e.points[t] && 1 < e.points[t].length;
                      }).map(parseFloat).sort(function (t, e) {
                        return e - t;
                      }), s = t.indexOf(i.index), c = t.length));
                    }
                  }), t = (r.plotX || 0) + ((c - 1) * n.paddedWidth + e) / 2 - e - s * n.paddedWidth;
                }

                return t;
              }, c2.prototype.translate = function () {
                var t = this,
                    e = t.chart,
                    r = t.options,
                    n = t.dense = 2 > t.closestPointRange * t.xAxis.transA;
                n = t.borderWidth = b(r.borderWidth, n ? 0 : 1);
                var i = t.xAxis,
                    a = t.yAxis,
                    s = r.threshold,
                    c = t.translatedThreshold = a.getThreshold(s),
                    l = b(r.minPointLength, 5),
                    u = t.getColumnMetrics(),
                    h = u.width,
                    p = t.pointXOffset = u.offset,
                    y = t.dataMin,
                    g = t.dataMax,
                    v = t.barW = Math.max(h, 1 + 2 * n);
                e.inverted && (c -= .5), r.pointPadding && (v = Math.ceil(v)), o.prototype.translate.apply(t), t.points.forEach(function (n) {
                  var o = b(n.yBottom, c),
                      x = 999 + Math.abs(o),
                      w = n.plotX || 0;
                  x = d(n.plotY, -x, a.len + x);
                  var S = Math.min(x, o),
                      O = Math.max(x, o) - S,
                      E = h,
                      k = w + p,
                      _ = v;
                  l && Math.abs(O) < l && (O = l, w = !a.reversed && !n.negative || a.reversed && n.negative, m(s) && m(g) && n.y === s && g <= s && (a.min || 0) < s && (y !== g || (a.max || 0) <= s) && (w = !w), S = Math.abs(S - c) > l ? o - l : c - (w ? l : 0)), f(n.options.pointWidth) && (E = _ = Math.ceil(n.options.pointWidth), k -= Math.round((E - h) / 2)), r.centerInCategory && (k = t.adjustForMissingColumns(k, E, n, u)), n.barX = k, n.pointWidth = E, n.tooltipPos = e.inverted ? [d(a.len + a.pos - e.plotLeft - x, a.pos - e.plotLeft, a.len + a.pos - e.plotLeft), i.len + i.pos - e.plotTop - k - _ / 2, O] : [i.left - e.plotLeft + k + _ / 2, d(x + a.pos - e.plotTop, a.pos - e.plotTop, a.len + a.pos - e.plotTop), O], n.shapeType = t.pointClass.prototype.shapeType || "rect", n.shapeArgs = t.crispCol.apply(t, n.isNull ? [k, c, _, 0] : [k, S, _, O]);
                });
              }, c2.prototype.drawGraph = function () {
                this.group[this.dense ? "addClass" : "removeClass"]("highcharts-dense-data");
              }, c2.prototype.pointAttribs = function (t, e) {
                var r = this.options,
                    n = this.pointAttrToOptions || {},
                    i = n.stroke || "borderColor",
                    o = n["stroke-width"] || "borderWidth",
                    a = t && t.color || this.color,
                    s = t && t[i] || r[i] || a;
                n = t && t.options.dashStyle || r.dashStyle;
                var c = t && t[o] || r[o] || this[o] || 0,
                    l = b(t && t.opacity, r.opacity, 1);

                if (t && this.zones.length) {
                  var h = t.getZone();
                  a = t.options.color || h && (h.color || t.nonZonedColor) || this.color, h && (s = h.borderColor || s, n = h.dashStyle || n, c = h.borderWidth || c);
                }

                return e && t && (e = (t = v(r.states[e], t.options.states && t.options.states[e] || {})).brightness, a = t.color || "undefined" !== typeof e && u(a).brighten(t.brightness).get() || a, s = t[i] || s, c = t[o] || c, n = t.dashStyle || n, l = b(t.opacity, l)), i = {
                  fill: a,
                  stroke: s,
                  "stroke-width": c,
                  opacity: l
                }, n && (i.dashstyle = n), i;
              }, c2.prototype.drawPoints = function (t) {
                void 0 === t && (t = this.points);
                var e,
                    r = this,
                    n = this.chart,
                    i = r.options,
                    o = n.renderer,
                    a = i.animationLimit || 250;
                t.forEach(function (t) {
                  var s = t.graphic,
                      c = !!s,
                      l = s && n.pointCount < a ? "animate" : "attr";
                  m(t.plotY) && null !== t.y ? (e = t.shapeArgs, s && t.hasNewShapeType() && (s = s.destroy()), r.enabledDataSorting && (t.startXPos = r.xAxis.reversed ? -(e && e.width || 0) : r.xAxis.width), s || (t.graphic = s = o[t.shapeType](e).add(t.group || r.group)) && r.enabledDataSorting && n.hasRendered && n.pointCount < a && (s.attr({
                    x: t.startXPos
                  }), c = !0, l = "animate"), s && c && s[l](v(e)), i.borderRadius && s[l]({
                    r: i.borderRadius
                  }), n.styledMode || s[l](r.pointAttribs(t, t.selected && "select")).shadow(!1 !== t.allowShadow && i.shadow, null, i.stacking && !i.borderRadius), s && (s.addClass(t.getClassName(), !0), s.attr({
                    visibility: t.visible ? "inherit" : "hidden"
                  }))) : s && (t.graphic = s.destroy());
                });
              }, c2.prototype.drawTracker = function (t) {
                void 0 === t && (t = this.points);

                var e,
                    r = this,
                    n = r.chart,
                    i = n.pointer,
                    o = function f2(t) {
                  var e = i.getPointFromEvent(t);
                  "undefined" !== typeof e && (i.isDirectTouch = !0, e.onMouseOver(t));
                };

                t.forEach(function (t) {
                  e = g(t.dataLabels) ? t.dataLabels : t.dataLabel ? [t.dataLabel] : [], t.graphic && (t.graphic.element.point = t), e.forEach(function (e) {
                    e.div ? e.div.point = t : e.element.point = t;
                  });
                }), r._hasTracking || (r.trackerGroups.forEach(function (t) {
                  r[t] && (r[t].addClass("highcharts-tracker").on("mouseover", o).on("mouseout", function (t) {
                    i.onTrackerMouseOut(t);
                  }), h && r[t].on("touchstart", o), !n.styledMode && r.options.cursor && r[t].css({
                    cursor: r.options.cursor
                  }));
                }), r._hasTracking = !0), y(this, "afterDrawTracker");
              }, c2.prototype.remove = function () {
                var t = this,
                    e = t.chart;
                e.hasRendered && e.series.forEach(function (e) {
                  e.type === t.type && (e.isDirty = !0);
                }), o.prototype.remove.apply(t, arguments);
              }, c2.defaultOptions = v(o.defaultOptions, r), c2;
            }(o), p(s.prototype, {
              cropShoulder: 0,
              directTouch: !0,
              drawLegendSymbol: i.drawRectangle,
              getSymbol: t,
              negStacks: !0,
              trackerGroups: ["group", "dataLabelsGroup"]
            }), a.registerSeriesType("column", s), s;
          }), K2(e, "Core/Series/DataLabel.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/FormatUtilities.js"], e["Core/Utilities.js"]], function (t, e, r) {
            var n,
                i = t.getDeferredAnimation,
                o = e.format,
                a = r.defined,
                s = r.extend,
                c = r.fireEvent,
                l = r.isArray,
                u = r.isString,
                h = r.merge,
                d = r.objectEach,
                f = r.pick,
                p = r.splat;
            return function (t) {
              function g4(t, e, r, n, i) {
                var o = this,
                    c = this.chart,
                    l = this.isCartesian && c.inverted,
                    u = this.enabledDataSorting,
                    h = t.plotX,
                    d = t.plotY,
                    p = r.rotation,
                    y = r.align,
                    g = a(h) && a(d) && c.isInsidePlot(h, Math.round(d), {
                  inverted: l,
                  paneCoordinates: !0,
                  series: o
                });

                d = function l3(r) {
                  u && o.xAxis && !m && o.setDataLabelStartPos(t, e, i, g, r);
                };

                var m = "justify" === f(r.overflow, u ? "none" : "justify");

                if (h = this.visible && !1 !== t.visible && a(h) && (t.series.forceDL || u && !m || g || f(r.inside, !!this.options.stacking) && n && c.isInsidePlot(h, l ? n.x + 1 : n.y + n.height - 1, {
                  inverted: l,
                  paneCoordinates: !0,
                  series: o
                })), l = t.pos(), h && l) {
                  p && e.attr({
                    align: y
                  }), y = e.getBBox(!0);
                  var v = [0, 0],
                      b = c.renderer.fontMetrics(c.styledMode ? void 0 : r.style.fontSize, e).b;
                  n = s({
                    x: l[0],
                    y: Math.round(l[1]),
                    width: 0,
                    height: 0
                  }, n), s(r, {
                    width: y.width,
                    height: y.height
                  }), p ? (m = !1, v = c.renderer.rotCorr(b, p), b = {
                    x: n.x + (r.x || 0) + n.width / 2 + v.x,
                    y: n.y + (r.y || 0) + {
                      top: 0,
                      middle: .5,
                      bottom: 1
                    }[r.verticalAlign] * n.height
                  }, v = [y.x - Number(e.attr("x")), y.y - Number(e.attr("y"))], d(b), e[i ? "attr" : "animate"](b)) : (d(n), e.align(r, void 0, n), b = e.alignAttr), m && 0 <= n.height ? this.justifyDataLabel(e, r, b, y, n, i) : f(r.crop, !0) && (n = b.x, d = b.y, n += v[0], d += v[1], h = c.isInsidePlot(n, d, {
                    paneCoordinates: !0,
                    series: o
                  }) && c.isInsidePlot(n + y.width, d + y.height, {
                    paneCoordinates: !0,
                    series: o
                  })), r.shape && !p && e[i ? "attr" : "animate"]({
                    anchorX: l[0],
                    anchorY: l[1]
                  });
                }

                i && u && (e.placed = !1), h || u && !m ? e.show() : (e.hide(), e.placed = !1);
              }

              function p2(t) {
                void 0 === t && (t = this.points);
                var e = this,
                    r = e.chart,
                    n = e.options,
                    s = e.hasRendered || 0,
                    h = r.renderer,
                    y = r.options.chart,
                    g = y.backgroundColor;
                y = y.plotBackgroundColor;
                var m = h.getContrast(u(y) && y || u(g) && g || "#000000"),
                    v = n.dataLabels;

                if (g = v.animation, g = v.defer ? i(r, g, e) : {
                  defer: 0,
                  duration: 0
                }, v = y3(y3(r.options.plotOptions && r.options.plotOptions.series && r.options.plotOptions.series.dataLabels, r.options.plotOptions && r.options.plotOptions[e.type] && r.options.plotOptions[e.type].dataLabels), v), c(this, "drawDataLabels"), l(v) || v.enabled || e._hasPointLabels) {
                  var b = e.plotGroup("dataLabelsGroup", "data-labels", s ? "inherit" : "hidden", v.zIndex || 6);
                  b.attr({
                    opacity: +s
                  }), !s && (s = e.dataLabelsGroup) && (e.visible && b.show(), s[n.animation ? "animate" : "attr"]({
                    opacity: 1
                  }, g)), t.forEach(function (t) {
                    p(y3(v, t.dlOptions || t.options && t.options.dataLabels)).forEach(function (i, s) {
                      var c = i.enabled && (!t.isNull || t.dataLabelOnNull) && function k4(t, e) {
                        var r = e.filter;
                        return !r || (e = r.operator, t = t[r.property], r = r.value, ">" === e && t > r || "<" === e && t < r || ">=" === e && t >= r || "<=" === e && t <= r || "==" === e && t == r || "===" === e && t === r);
                      }(t, i),
                          l = t.connectors ? t.connectors[s] : t.connector,
                          u = t.dataLabels ? t.dataLabels[s] : t.dataLabel,
                          p = !u,
                          y = f(i.distance, t.labelDistance);

                      if (c) {
                        var g = t.getLabelConfig(),
                            v = f(i[t.formatPrefix + "Format"], i.format);
                        g = a(v) ? o(v, g, r) : (i[t.formatPrefix + "Formatter"] || i.formatter).call(g, i), v = i.style;
                        var x = i.rotation;
                        r.styledMode || (v.color = f(i.color, v.color, e.color, "#000000"), "contrast" === v.color ? (t.contrastColor = h.getContrast(t.color || e.color), v.color = !a(y) && i.inside || 0 > y || n.stacking ? t.contrastColor : m) : delete t.contrastColor, n.cursor && (v.cursor = n.cursor));
                        var w = {
                          r: i.borderRadius || 0,
                          rotation: x,
                          padding: i.padding,
                          zIndex: 1
                        };

                        if (!r.styledMode) {
                          y = i.backgroundColor;
                          var S = i.borderColor;
                          w.fill = "auto" === y ? t.color : y, w.stroke = "auto" === S ? t.color : S, w["stroke-width"] = i.borderWidth;
                        }

                        d(w, function (t, e) {
                          "undefined" === typeof t && delete w[e];
                        });
                      }

                      !u || c && a(g) && !!u.div === !!i.useHTML && (u.rotation && i.rotation || u.rotation === i.rotation) || (p = !0, t.dataLabel = u = t.dataLabel && t.dataLabel.destroy(), t.dataLabels && (1 === t.dataLabels.length ? delete t.dataLabels : delete t.dataLabels[s]), s || delete t.dataLabel, l && (t.connector = t.connector.destroy(), t.connectors && (1 === t.connectors.length ? delete t.connectors : delete t.connectors[s]))), c && a(g) ? (u ? w.text = g : (t.dataLabels = t.dataLabels || [], u = t.dataLabels[s] = x ? h.text(g, 0, 0, i.useHTML).addClass("highcharts-data-label") : h.label(g, 0, 0, i.shape, null, null, i.useHTML, null, "data-label"), s || (t.dataLabel = u), u.addClass(" highcharts-data-label-color-" + t.colorIndex + " " + (i.className || "") + (i.useHTML ? " highcharts-tracker" : ""))), u.options = i, u.attr(w), r.styledMode || u.css(v).shadow(i.shadow), (s = i[t.formatPrefix + "TextPath"] || i.textPath) && !i.useHTML && (u.setTextPath(t.getDataLabelPath && t.getDataLabelPath(u) || t.graphic, s), t.dataLabelPath && !s.enabled && (t.dataLabelPath = t.dataLabelPath.destroy())), u.added || u.add(b), e.alignDataLabel(t, u, i, null, p)) : u && u.hide();
                    });
                  });
                }

                c(this, "afterDrawDataLabels");
              }

              function x3(t, e, r, n, i, o) {
                var a = this.chart,
                    s = e.align,
                    c = e.verticalAlign,
                    l = t.box ? 0 : t.padding || 0,
                    u = e.x;
                u = void 0 === u ? 0 : u;
                var h = e.y;
                h = void 0 === h ? 0 : h;
                var d = (r.x || 0) + l;

                if (0 > d) {
                  "right" === s && 0 <= u ? (e.align = "left", e.inside = !0) : u -= d;
                  var f = !0;
                }

                return (d = (r.x || 0) + n.width - l) > a.plotWidth && ("left" === s && 0 >= u ? (e.align = "right", e.inside = !0) : u += a.plotWidth - d, f = !0), 0 > (d = r.y + l) && ("bottom" === c && 0 <= h ? (e.verticalAlign = "top", e.inside = !0) : h -= d, f = !0), (d = (r.y || 0) + n.height - l) > a.plotHeight && ("top" === c && 0 >= h ? (e.verticalAlign = "bottom", e.inside = !0) : h += a.plotHeight - d, f = !0), f && (e.x = u, e.y = h, t.placed = !o, t.align(e, void 0, i)), f;
              }

              function y3(t, e) {
                var r,
                    n = [];
                if (l(t) && !l(e)) n = t.map(function (t) {
                  return h(t, e);
                });else if (l(e) && !l(t)) n = e.map(function (e) {
                  return h(t, e);
                });else if (l(t) || l(e)) for (r = Math.max(t.length, e.length); r--;) {
                  n[r] = h(t[r], e[r]);
                } else n = h(t, e);
                return n;
              }

              function c2(t, e, r, n, i) {
                var o = this.chart,
                    a = o.inverted,
                    s = this.xAxis,
                    c = s.reversed,
                    l = a ? e.height / 2 : e.width / 2;
                t = (t = t.pointWidth) ? t / 2 : 0, e.startXPos = a ? i.x : c ? -l - t : s.width - l + t, e.startYPos = a ? c ? this.yAxis.height - l + t : -l - t : i.y, n ? "hidden" === e.visibility && (e.show(), e.attr({
                  opacity: 0
                }).animate({
                  opacity: 1
                })) : e.attr({
                  opacity: 1
                }).animate({
                  opacity: 0
                }, void 0, e.hide), o.hasRendered && (r && e.attr({
                  x: e.startXPos,
                  y: e.startYPos
                }), e.placed = !0);
              }

              var e = [];

              t.compose = function (t) {
                if (-1 === e.indexOf(t)) {
                  var r = t.prototype;
                  e.push(t), r.alignDataLabel = g4, r.drawDataLabels = p2, r.justifyDataLabel = x3, r.setDataLabelStartPos = c2;
                }
              };
            }(n || (n = {})), n;
          }), K2(e, "Series/Column/ColumnDataLabel.js", [e["Core/Series/DataLabel.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function (t, e, r) {
            var n,
                i = e.series,
                o = r.merge,
                a = r.pick;
            return function (e) {
              function r2(t, e, r, n, s) {
                var c = this.chart.inverted,
                    l = t.series,
                    u = (l.xAxis ? l.xAxis.len : this.chart.plotSizeX) || 0;
                l = (l.yAxis ? l.yAxis.len : this.chart.plotSizeY) || 0;
                var h = t.dlBox || t.shapeArgs,
                    d = a(t.below, t.plotY > a(this.translatedThreshold, l)),
                    f = a(r.inside, !!this.options.stacking);
                h && (0 > (n = o(h)).y && (n.height += n.y, n.y = 0), 0 < (h = n.y + n.height - l) && h < n.height && (n.height -= h), c && (n = {
                  x: l - n.y - n.height,
                  y: u - n.x - n.width,
                  width: n.height,
                  height: n.width
                }), f || (c ? (n.x += d ? 0 : n.width, n.width = 0) : (n.y += d ? n.height : 0, n.height = 0))), r.align = a(r.align, !c || f ? "center" : d ? "right" : "left"), r.verticalAlign = a(r.verticalAlign, c || f ? "middle" : d ? "top" : "bottom"), i.prototype.alignDataLabel.call(this, t, e, r, n, s), r.inside && t.contrastColor && e.css({
                  color: t.contrastColor
                });
              }

              var r = [];

              e.compose = function (e) {
                t.compose(i), -1 === r.indexOf(e) && (r.push(e), e.prototype.alignDataLabel = r2);
              };
            }(n || (n = {})), n;
          }), K2(e, "Series/Bar/BarSeries.js", [e["Series/Column/ColumnSeries.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function (t, e, r) {
            var n = this && this.__extends || function () {
              var t = function a4(e, r) {
                return (t = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, e) {
                  t.__proto__ = e;
                } || function (t, e) {
                  for (var r in e) {
                    e.hasOwnProperty(r) && (t[r] = e[r]);
                  }
                })(e, r);
              };

              return function (e, r) {
                function l2() {
                  this.constructor = e;
                }

                t(e, r), e.prototype = null === r ? Object.create(r) : (l2.prototype = r.prototype, new l2());
              };
            }(),
                i = r.extend,
                o = r.merge;

            return i((r = function (e) {
              function t3() {
                var t = null !== e && e.apply(this, arguments) || this;
                return t.data = void 0, t.options = void 0, t.points = void 0, t;
              }

              return n(t3, e), t3.defaultOptions = o(t.defaultOptions, {}), t3;
            }(t)).prototype, {
              inverted: !0
            }), e.registerSeriesType("bar", r), r;
          }), K2(e, "Series/Scatter/ScatterSeriesDefaults.js", [], function () {
            return {
              lineWidth: 0,
              findNearestPointBy: "xy",
              jitter: {
                x: 0,
                y: 0
              },
              marker: {
                enabled: !0
              },
              tooltip: {
                headerFormat: "<span style=\"color:{point.color}\">\u25CF</span> <span style=\"font-size: 10px\"> {series.name}</span><br/>",
                pointFormat: "x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>"
              }
            };
          }), K2(e, "Series/Scatter/ScatterSeries.js", [e["Series/Scatter/ScatterSeriesDefaults.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function (t, e, r) {
            var n = this && this.__extends || function () {
              var t = function a4(e, r) {
                return (t = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, e) {
                  t.__proto__ = e;
                } || function (t, e) {
                  for (var r in e) {
                    e.hasOwnProperty(r) && (t[r] = e[r]);
                  }
                })(e, r);
              };

              return function (e, r) {
                function g4() {
                  this.constructor = e;
                }

                t(e, r), e.prototype = null === r ? Object.create(r) : (g4.prototype = r.prototype, new g4());
              };
            }(),
                i = e.seriesTypes,
                o = i.column,
                a = i.line;

            i = r.addEvent;
            var s = r.extend,
                c = r.merge;
            return s((r = function (e) {
              function e3() {
                var t = null !== e && e.apply(this, arguments) || this;
                return t.data = void 0, t.options = void 0, t.points = void 0, t;
              }

              return n(e3, e), e3.prototype.applyJitter = function () {
                var t = this,
                    e = this.options.jitter,
                    r = this.points.length;
                e && this.points.forEach(function (n, i) {
                  ["x", "y"].forEach(function (o, a) {
                    var s = "plot" + o.toUpperCase();

                    if (e[o] && !n.isNull) {
                      var c = t[o + "Axis"],
                          l = e[o] * c.transA;

                      if (c && !c.isLog) {
                        var u = Math.max(0, n[s] - l);
                        c = Math.min(c.len, n[s] + l), a = 1e4 * Math.sin(i + a * r), n[s] = u + (c - u) * (a - Math.floor(a)), "x" === o && (n.clientX = n.plotX);
                      }
                    }
                  });
                });
              }, e3.prototype.drawGraph = function () {
                this.options.lineWidth ? e.prototype.drawGraph.call(this) : this.graph && (this.graph = this.graph.destroy());
              }, e3.defaultOptions = c(a.defaultOptions, t), e3;
            }(a)).prototype, {
              drawTracker: o.prototype.drawTracker,
              sorted: !1,
              requireSorting: !1,
              noSharedTooltip: !0,
              trackerGroups: ["group", "markerGroup", "dataLabelsGroup"],
              takeOrdinalPosition: !1
            }), i(r, "afterTranslate", function () {
              this.applyJitter();
            }), e.registerSeriesType("scatter", r), r;
          }), K2(e, "Series/CenteredUtilities.js", [e["Core/Globals.js"], e["Core/Series/Series.js"], e["Core/Utilities.js"]], function (t, e, r) {
            var n,
                i,
                o = t.deg2rad,
                a = r.fireEvent,
                s = r.isNumber,
                c = r.pick,
                l = r.relativeLength;
            return (i = n || (n = {})).getCenter = function () {
              var t = this.options,
                  r = this.chart,
                  n = 2 * (t.slicedOffset || 0),
                  i = r.plotWidth - 2 * n,
                  o = r.plotHeight - 2 * n,
                  u = t.center,
                  h = Math.min(i, o),
                  d = t.thickness,
                  f = t.size,
                  p = t.innerSize || 0;

              for ("string" === typeof f && (f = parseFloat(f)), "string" === typeof p && (p = parseFloat(p)), t = [c(u[0], "50%"), c(u[1], "50%"), c(f && 0 > f ? void 0 : t.size, "100%"), c(p && 0 > p ? void 0 : t.innerSize || 0, "0%")], !r.angular || this instanceof e || (t[3] = 0), u = 0; 4 > u; ++u) {
                f = t[u], r = 2 > u || 2 === u && /%$/.test(f), t[u] = l(f, [i, o, h, t[2]][u]) + (r ? n : 0);
              }

              return t[3] > t[2] && (t[3] = t[2]), s(d) && 2 * d < t[2] && 0 < d && (t[3] = t[2] - 2 * d), a(this, "afterGetCenter", {
                positions: t
              }), t;
            }, i.getStartAndEndRadians = function (t, e) {
              return t = s(t) ? t : 0, e = s(e) && e > t && 360 > e - t ? e : t + 360, {
                start: o * (t + -90),
                end: o * (e + -90)
              };
            }, n;
          }), K2(e, "Series/Pie/PiePoint.js", [e["Core/Animation/AnimationUtilities.js"], e["Core/Series/Point.js"], e["Core/Utilities.js"]], function (t, e, r) {
            var n = this && this.__extends || function () {
              var t = function a4(e, r) {
                return (t = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, e) {
                  t.__proto__ = e;
                } || function (t, e) {
                  for (var r in e) {
                    e.hasOwnProperty(r) && (t[r] = e[r]);
                  }
                })(e, r);
              };

              return function (e, r) {
                function g4() {
                  this.constructor = e;
                }

                t(e, r), e.prototype = null === r ? Object.create(r) : (g4.prototype = r.prototype, new g4());
              };
            }(),
                i = t.setAnimation,
                o = r.addEvent,
                a = r.defined;

            t = r.extend;
            var s = r.isNumber,
                c = r.pick,
                l = r.relativeLength;
            return t((e = function (t) {
              function d3() {
                var e = null !== t && t.apply(this, arguments) || this;
                return e.labelDistance = void 0, e.options = void 0, e.series = void 0, e;
              }

              return n(d3, t), d3.prototype.getConnectorPath = function () {
                var t = this.labelPosition,
                    e = this.series.options.dataLabels,
                    r = this.connectorShapes,
                    n = e.connectorShape;
                return r[n] && (n = r[n]), n.call(this, {
                  x: t.final.x,
                  y: t.final.y,
                  alignment: t.alignment
                }, t.connectorPosition, e);
              }, d3.prototype.getTranslate = function () {
                return this.sliced ? this.slicedTranslation : {
                  translateX: 0,
                  translateY: 0
                };
              }, d3.prototype.haloPath = function (t) {
                var e = this.shapeArgs;
                return this.sliced || !this.visible ? [] : this.series.chart.renderer.symbols.arc(e.x, e.y, e.r + t, e.r + t, {
                  innerR: e.r - 1,
                  start: e.start,
                  end: e.end
                });
              }, d3.prototype.init = function () {
                var e = this;
                t.prototype.init.apply(this, arguments), this.name = c(this.name, "Slice");

                var r = function e3(t) {
                  e.slice("select" === t.type);
                };

                return o(this, "select", r), o(this, "unselect", r), this;
              }, d3.prototype.isValid = function () {
                return s(this.y) && 0 <= this.y;
              }, d3.prototype.setVisible = function (t, e) {
                var r = this,
                    n = this.series,
                    i = n.chart,
                    o = n.options.ignoreHiddenPoint;
                e = c(e, o), t !== this.visible && (this.visible = this.options.visible = t = "undefined" === typeof t ? !this.visible : t, n.options.data[n.data.indexOf(this)] = this.options, ["graphic", "dataLabel", "connector", "shadowGroup"].forEach(function (e) {
                  r[e] && r[e][t ? "show" : "hide"](t);
                }), this.legendItem && i.legend.colorizeItem(this, t), t || "hover" !== this.state || this.setState(""), o && (n.isDirty = !0), e && i.redraw());
              }, d3.prototype.slice = function (t, e, r) {
                var n = this.series;
                i(r, n.chart), c(e, !0), this.sliced = this.options.sliced = a(t) ? t : !this.sliced, n.options.data[n.data.indexOf(this)] = this.options, this.graphic && this.graphic.animate(this.getTranslate()), this.shadowGroup && this.shadowGroup.animate(this.getTranslate());
              }, d3;
            }(e)).prototype, {
              connectorShapes: {
                fixedOffset: function fixedOffset(t, e, r) {
                  var n = e.breakAt;
                  return e = e.touchingSliceAt, [["M", t.x, t.y], r.softConnector ? ["C", t.x + ("left" === t.alignment ? -5 : 5), t.y, 2 * n.x - e.x, 2 * n.y - e.y, n.x, n.y] : ["L", n.x, n.y], ["L", e.x, e.y]];
                },
                straight: function straight(t, e) {
                  return e = e.touchingSliceAt, [["M", t.x, t.y], ["L", e.x, e.y]];
                },
                crookedLine: function crookedLine(t, e, r) {
                  e = e.touchingSliceAt;
                  var n = this.series,
                      i = n.center[0],
                      o = n.chart.plotWidth,
                      a = n.chart.plotLeft;
                  n = t.alignment;
                  var s = this.shapeArgs.r;
                  return r = l(r.crookDistance, 1), r = ["L", o = "left" === n ? i + s + (o + a - i - s) * (1 - r) : a + (i - s) * r, t.y], i = !0, ("left" === n ? o > t.x || o < e.x : o < t.x || o > e.x) && (i = !1), t = [["M", t.x, t.y]], i && t.push(r), t.push(["L", e.x, e.y]), t;
                }
              }
            }), e;
          }), K2(e, "Series/Pie/PieSeriesDefaults.js", [], function () {
            return {
              center: [null, null],
              clip: !1,
              colorByPoint: !0,
              dataLabels: {
                allowOverlap: !0,
                connectorPadding: 5,
                connectorShape: "fixedOffset",
                crookDistance: "70%",
                distance: 30,
                enabled: !0,
                formatter: function formatter() {
                  return this.point.isNull ? void 0 : this.point.name;
                },
                softConnector: !0,
                x: 0
              },
              fillColor: void 0,
              ignoreHiddenPoint: !0,
              inactiveOtherPoints: !0,
              legendType: "point",
              marker: null,
              size: null,
              showInLegend: !1,
              slicedOffset: 10,
              stickyTracking: !1,
              tooltip: {
                followPointer: !0
              },
              borderColor: "#ffffff",
              borderWidth: 1,
              lineWidth: void 0,
              states: {
                hover: {
                  brightness: .1
                }
              }
            };
          }), K2(e, "Series/Pie/PieSeries.js", [e["Series/CenteredUtilities.js"], e["Series/Column/ColumnSeries.js"], e["Core/Globals.js"], e["Core/Legend/LegendSymbol.js"], e["Series/Pie/PiePoint.js"], e["Series/Pie/PieSeriesDefaults.js"], e["Core/Series/Series.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Renderer/SVG/Symbols.js"], e["Core/Utilities.js"]], function (t, e, r, n, i, o, a, s, c, l) {
            var u = this && this.__extends || function () {
              var t = function a4(e, r) {
                return (t = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, e) {
                  t.__proto__ = e;
                } || function (t, e) {
                  for (var r in e) {
                    e.hasOwnProperty(r) && (t[r] = e[r]);
                  }
                })(e, r);
              };

              return function (e, r) {
                function c2() {
                  this.constructor = e;
                }

                t(e, r), e.prototype = null === r ? Object.create(r) : (c2.prototype = r.prototype, new c2());
              };
            }(),
                h = t.getStartAndEndRadians;

            r = r.noop;
            var d = l.clamp,
                f = l.extend,
                p = l.fireEvent,
                y = l.merge,
                g = l.pick,
                m = l.relativeLength;
            return f((l = function (t) {
              function g4() {
                var e = null !== t && t.apply(this, arguments) || this;
                return e.center = void 0, e.data = void 0, e.maxLabelDistance = void 0, e.options = void 0, e.points = void 0, e;
              }

              return u(g4, t), g4.prototype.animate = function (t) {
                var e = this,
                    r = e.points,
                    n = e.startAngleRad;
                t || r.forEach(function (t) {
                  var r = t.graphic,
                      i = t.shapeArgs;
                  r && i && (r.attr({
                    r: g(t.startR, e.center && e.center[3] / 2),
                    start: n,
                    end: n
                  }), r.animate({
                    r: i.r,
                    start: i.start,
                    end: i.end
                  }, e.options.animation));
                });
              }, g4.prototype.drawEmpty = function () {
                var t = this.startAngleRad,
                    e = this.endAngleRad,
                    r = this.options;

                if (0 === this.total && this.center) {
                  var n = this.center[0],
                      i = this.center[1];
                  this.graph || (this.graph = this.chart.renderer.arc(n, i, this.center[1] / 2, 0, t, e).addClass("highcharts-empty-series").add(this.group)), this.graph.attr({
                    d: c.arc(n, i, this.center[2] / 2, 0, {
                      start: t,
                      end: e,
                      innerR: this.center[3] / 2
                    })
                  }), this.chart.styledMode || this.graph.attr({
                    "stroke-width": r.borderWidth,
                    fill: r.fillColor || "none",
                    stroke: r.color || "#cccccc"
                  });
                } else this.graph && (this.graph = this.graph.destroy());
              }, g4.prototype.drawPoints = function () {
                var t = this.chart.renderer;
                this.points.forEach(function (e) {
                  e.graphic && e.hasNewShapeType() && (e.graphic = e.graphic.destroy()), e.graphic || (e.graphic = t[e.shapeType](e.shapeArgs).add(e.series.group), e.delayedRendering = !0);
                });
              }, g4.prototype.generatePoints = function () {
                t.prototype.generatePoints.call(this), this.updateTotals();
              }, g4.prototype.getX = function (t, e, r) {
                var n = this.center,
                    i = this.radii ? this.radii[r.index] || 0 : n[2] / 2;
                return t = Math.asin(d((t - n[1]) / (i + r.labelDistance), -1, 1)), n[0] + (e ? -1 : 1) * Math.cos(t) * (i + r.labelDistance) + (0 < r.labelDistance ? (e ? -1 : 1) * this.options.dataLabels.padding : 0);
              }, g4.prototype.hasData = function () {
                return !!this.processedXData.length;
              }, g4.prototype.redrawPoints = function () {
                var t,
                    e,
                    r,
                    n,
                    i = this,
                    o = i.chart,
                    a = o.renderer,
                    s = i.options.shadow;
                this.drawEmpty(), !s || i.shadowGroup || o.styledMode || (i.shadowGroup = a.g("shadow").attr({
                  zIndex: -1
                }).add(i.group)), i.points.forEach(function (c) {
                  var l = {};

                  if (e = c.graphic, !c.isNull && e) {
                    var u = void 0;
                    n = c.shapeArgs, t = c.getTranslate(), o.styledMode || (u = c.shadowGroup, s && !u && (u = c.shadowGroup = a.g("shadow").add(i.shadowGroup)), u && u.attr(t), r = i.pointAttribs(c, c.selected && "select")), c.delayedRendering ? (e.setRadialReference(i.center).attr(n).attr(t), o.styledMode || e.attr(r).attr({
                      "stroke-linejoin": "round"
                    }).shadow(s, u), c.delayedRendering = !1) : (e.setRadialReference(i.center), o.styledMode || y(!0, l, r), y(!0, l, n, t), e.animate(l)), e.attr({
                      visibility: c.visible ? "inherit" : "hidden"
                    }), e.addClass(c.getClassName(), !0);
                  } else e && (c.graphic = e.destroy());
                });
              }, g4.prototype.sortByAngle = function (t, e) {
                t.sort(function (t, r) {
                  return "undefined" !== typeof t.angle && (r.angle - t.angle) * e;
                });
              }, g4.prototype.translate = function (t) {
                p(this, "translate"), this.generatePoints();
                var e = this.options,
                    r = e.slicedOffset,
                    n = r + (e.borderWidth || 0),
                    i = h(e.startAngle, e.endAngle),
                    o = this.startAngleRad = i.start;
                i = (this.endAngleRad = i.end) - o;
                var a = this.points,
                    s = e.dataLabels.distance;
                e = e.ignoreHiddenPoint;
                var c,
                    l = a.length,
                    u = 0;

                for (t || (this.center = t = this.getCenter()), c = 0; c < l; c++) {
                  var d = a[c],
                      f = o + u * i;
                  !d.isValid() || e && !d.visible || (u += d.percentage / 100);
                  var y = o + u * i,
                      v = {
                    x: t[0],
                    y: t[1],
                    r: t[2] / 2,
                    innerR: t[3] / 2,
                    start: Math.round(1e3 * f) / 1e3,
                    end: Math.round(1e3 * y) / 1e3
                  };
                  d.shapeType = "arc", d.shapeArgs = v, d.labelDistance = g(d.options.dataLabels && d.options.dataLabels.distance, s), d.labelDistance = m(d.labelDistance, v.r), this.maxLabelDistance = Math.max(this.maxLabelDistance || 0, d.labelDistance), (y = (y + f) / 2) > 1.5 * Math.PI ? y -= 2 * Math.PI : y < -Math.PI / 2 && (y += 2 * Math.PI), d.slicedTranslation = {
                    translateX: Math.round(Math.cos(y) * r),
                    translateY: Math.round(Math.sin(y) * r)
                  }, v = Math.cos(y) * t[2] / 2;
                  var b = Math.sin(y) * t[2] / 2;
                  d.tooltipPos = [t[0] + .7 * v, t[1] + .7 * b], d.half = y < -Math.PI / 2 || y > Math.PI / 2 ? 1 : 0, d.angle = y, f = Math.min(n, d.labelDistance / 5), d.labelPosition = {
                    natural: {
                      x: t[0] + v + Math.cos(y) * d.labelDistance,
                      y: t[1] + b + Math.sin(y) * d.labelDistance
                    },
                    final: {},
                    alignment: 0 > d.labelDistance ? "center" : d.half ? "right" : "left",
                    connectorPosition: {
                      breakAt: {
                        x: t[0] + v + Math.cos(y) * f,
                        y: t[1] + b + Math.sin(y) * f
                      },
                      touchingSliceAt: {
                        x: t[0] + v,
                        y: t[1] + b
                      }
                    }
                  };
                }

                p(this, "afterTranslate");
              }, g4.prototype.updateTotals = function () {
                var t,
                    e = this.points,
                    r = e.length,
                    n = this.options.ignoreHiddenPoint,
                    i = 0;

                for (t = 0; t < r; t++) {
                  var o = e[t];
                  !o.isValid() || n && !o.visible || (i += o.y);
                }

                for (this.total = i, t = 0; t < r; t++) {
                  (o = e[t]).percentage = 0 < i && (o.visible || !n) ? o.y / i * 100 : 0, o.total = i;
                }
              }, g4.defaultOptions = y(a.defaultOptions, o), g4;
            }(a)).prototype, {
              axisTypes: [],
              directTouch: !0,
              drawGraph: void 0,
              drawLegendSymbol: n.drawRectangle,
              drawTracker: e.prototype.drawTracker,
              getCenter: t.getCenter,
              getSymbol: r,
              isCartesian: !1,
              noSharedTooltip: !0,
              pointAttribs: e.prototype.pointAttribs,
              pointClass: i,
              requireSorting: !1,
              searchPoint: r,
              trackerGroups: ["group", "dataLabelsGroup"]
            }), s.registerSeriesType("pie", l), l;
          }), K2(e, "Series/Pie/PieDataLabel.js", [e["Core/Series/DataLabel.js"], e["Core/Globals.js"], e["Core/Renderer/RendererUtilities.js"], e["Core/Series/SeriesRegistry.js"], e["Core/Utilities.js"]], function (t, e, r, n, i) {
            var o,
                a = e.noop,
                s = r.distribute,
                c = n.series,
                l = i.arrayMax,
                u = i.clamp,
                h = i.defined,
                d = i.merge,
                f = i.pick,
                p = i.relativeLength;
            return function (e) {
              function k4() {
                var t,
                    e,
                    r,
                    n,
                    i,
                    o,
                    a,
                    u,
                    p,
                    y,
                    g,
                    m,
                    v = this,
                    b = v.data,
                    x = v.chart,
                    w = v.options.dataLabels || {},
                    S = w.connectorPadding,
                    O = x.plotWidth,
                    E = x.plotHeight,
                    k = x.plotLeft,
                    _ = Math.round(x.chartWidth / 3),
                    C = v.center,
                    T = C[2] / 2,
                    A = C[1],
                    M = [[], []],
                    P = [0, 0, 0, 0],
                    j = v.dataLabelPositioners;

                v.visible && (w.enabled || v._hasPointLabels) && (b.forEach(function (t) {
                  t.dataLabel && t.visible && t.dataLabel.shortened && (t.dataLabel.attr({
                    width: "auto"
                  }).css({
                    width: "auto",
                    textOverflow: "clip"
                  }), t.dataLabel.shortened = !1);
                }), c.prototype.drawDataLabels.apply(v), b.forEach(function (t) {
                  t.dataLabel && (t.visible ? (M[t.half].push(t), t.dataLabel._pos = null, !h(w.style.width) && !h(t.options.dataLabels && t.options.dataLabels.style && t.options.dataLabels.style.width) && t.dataLabel.getBBox().width > _ && (t.dataLabel.css({
                    width: Math.round(.7 * _) + "px"
                  }), t.dataLabel.shortened = !0)) : (t.dataLabel = t.dataLabel.destroy(), t.dataLabels && 1 === t.dataLabels.length && delete t.dataLabels));
                }), M.forEach(function (e, r) {
                  var c,
                      l = e.length,
                      d = [];

                  if (l) {
                    if (v.sortByAngle(e, r - .5), 0 < v.maxLabelDistance) {
                      var b = Math.max(0, A - T - v.maxLabelDistance),
                          _ = Math.min(A + T + v.maxLabelDistance, x.plotHeight);

                      e.forEach(function (t) {
                        0 < t.labelDistance && t.dataLabel && (t.top = Math.max(0, A - T - t.labelDistance), t.bottom = Math.min(A + T + t.labelDistance, x.plotHeight), c = t.dataLabel.getBBox().height || 21, t.distributeBox = {
                          target: t.labelPosition.natural.y - t.top + c / 2,
                          size: c,
                          rank: t.y
                        }, d.push(t.distributeBox));
                      }), s(d, b = _ + c - b, b / 5);
                    }

                    for (g = 0; g < l; g++) {
                      if (t = e[g], o = t.labelPosition, n = t.dataLabel, y = !1 === t.visible ? "hidden" : "inherit", p = b = o.natural.y, d && h(t.distributeBox) && ("undefined" === typeof t.distributeBox.pos ? y = "hidden" : (a = t.distributeBox.size, p = j.radialDistributionY(t))), delete t.positionIndex, w.justify) u = j.justify(t, T, C);else switch (w.alignTo) {
                        case "connectors":
                          u = j.alignToConnectors(e, r, O, k);
                          break;

                        case "plotEdges":
                          u = j.alignToPlotEdges(n, r, O, k);
                          break;

                        default:
                          u = j.radialDistributionX(v, t, p, b);
                      }
                      n._attr = {
                        visibility: y,
                        align: o.alignment
                      }, m = t.options.dataLabels || {}, n._pos = {
                        x: u + f(m.x, w.x) + ({
                          left: S,
                          right: -S
                        }[o.alignment] || 0),
                        y: p + f(m.y, w.y) - 10
                      }, o.final.x = u, o.final.y = p, f(w.crop, !0) && (i = n.getBBox().width, b = null, u - i < S && 1 === r ? (b = Math.round(i - u + S), P[3] = Math.max(b, P[3])) : u + i > O - S && 0 === r && (b = Math.round(u + i - O + S), P[1] = Math.max(b, P[1])), 0 > p - a / 2 ? P[0] = Math.max(Math.round(a / 2 - p), P[0]) : p + a / 2 > E && (P[2] = Math.max(Math.round(p + a / 2 - E), P[2])), n.sideOverflow = b);
                    }
                  }
                }), 0 === l(P) || this.verifyDataLabelOverflow(P)) && (this.placeDataLabels(), this.points.forEach(function (t) {
                  var i;
                  (m = d(w, t.options.dataLabels), e = f(m.connectorWidth, 1)) && (r = t.connector, (n = t.dataLabel) && n._pos && t.visible && 0 < t.labelDistance ? (y = n._attr.visibility, (i = !r) && (t.connector = r = x.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-" + t.colorIndex + (t.className ? " " + t.className : "")).add(v.dataLabelsGroup), x.styledMode || r.attr({
                    "stroke-width": e,
                    stroke: m.connectorColor || t.color || "#666666"
                  })), r[i ? "attr" : "animate"]({
                    d: t.getConnectorPath()
                  }), r.attr("visibility", y)) : r && (t.connector = r.destroy()));
                }));
              }

              function p2() {
                this.points.forEach(function (t) {
                  var e,
                      r = t.dataLabel;
                  r && t.visible && ((e = r._pos) ? (r.sideOverflow && (r._attr.width = Math.max(r.getBBox().width - r.sideOverflow, 0), r.css({
                    width: r._attr.width + "px",
                    textOverflow: (this.options.dataLabels.style || {}).textOverflow || "ellipsis"
                  }), r.shortened = !0), r.attr(r._attr), r[r.moved ? "animate" : "attr"](e), r.moved = !0) : r && r.attr({
                    y: -9999
                  })), delete t.distributeBox;
                }, this);
              }

              function x3(t) {
                var e = this.center,
                    r = this.options,
                    n = r.center,
                    i = r.minSize || 80,
                    o = null !== r.size;

                if (!o) {
                  if (null !== n[0]) var a = Math.max(e[2] - Math.max(t[1], t[3]), i);else a = Math.max(e[2] - t[1] - t[3], i), e[0] += (t[3] - t[1]) / 2;
                  null !== n[1] ? a = u(a, i, e[2] - Math.max(t[0], t[2])) : (a = u(a, i, e[2] - t[0] - t[2]), e[1] += (t[0] - t[2]) / 2), a < e[2] ? (e[2] = a, e[3] = Math.min(r.thickness ? Math.max(0, a - 2 * r.thickness) : Math.max(0, p(r.innerSize || 0, a)), a), this.translate(e), this.drawDataLabels && this.drawDataLabels()) : o = !0;
                }

                return o;
              }

              var r = [],
                  n = {
                radialDistributionY: function radialDistributionY(t) {
                  return t.top + t.distributeBox.pos;
                },
                radialDistributionX: function radialDistributionX(t, e, r, n) {
                  return t.getX(r < e.top + 2 || r > e.bottom - 2 ? n : r, e.half, e);
                },
                justify: function justify(t, e, r) {
                  return r[0] + (t.half ? -1 : 1) * (e + t.labelDistance);
                },
                alignToPlotEdges: function alignToPlotEdges(t, e, r, n) {
                  return t = t.getBBox().width, e ? t + n : r - t - n;
                },
                alignToConnectors: function alignToConnectors(t, e, r, n) {
                  var i,
                      o = 0;
                  return t.forEach(function (t) {
                    (i = t.dataLabel.getBBox().width) > o && (o = i);
                  }), e ? o + n : r - o - n;
                }
              };

              e.compose = function (e) {
                t.compose(c), -1 === r.indexOf(e) && (r.push(e), (e = e.prototype).dataLabelPositioners = n, e.alignDataLabel = a, e.drawDataLabels = k4, e.placeDataLabels = p2, e.verifyDataLabelOverflow = x3);
              };
            }(o || (o = {})), o;
          }), K2(e, "Extensions/OverlappingDataLabels.js", [e["Core/Chart/Chart.js"], e["Core/Utilities.js"]], function (t, e) {
            function A(t, e) {
              var r = !1;

              if (t) {
                var i = t.newOpacity;
                t.oldOpacity !== i && (t.alignAttr && t.placed ? (t[i ? "removeClass" : "addClass"]("highcharts-data-label-hidden"), r = !0, t.alignAttr.opacity = i, t[t.isOld ? "animate" : "attr"](t.alignAttr, null, function () {
                  e.styledMode || t.css({
                    pointerEvents: i ? "auto" : "none"
                  });
                }), n(e, "afterHideOverlappingLabel")) : t.attr({
                  opacity: i
                })), t.isOld = !0;
              }

              return r;
            }

            var r = e.addEvent,
                n = e.fireEvent,
                i = e.isArray,
                o = e.isNumber,
                a = e.objectEach,
                s = e.pick;
            r(t, "render", function () {
              var t = this,
                  e = [];
              (this.labelCollectors || []).forEach(function (t) {
                e = e.concat(t());
              }), (this.yAxis || []).forEach(function (t) {
                t.stacking && t.options.stackLabels && !t.options.stackLabels.allowOverlap && a(t.stacking.stacks, function (t) {
                  a(t, function (t) {
                    t.label && e.push(t.label);
                  });
                });
              }), (this.series || []).forEach(function (r) {
                var n = r.options.dataLabels;
                r.visible && (!1 !== n.enabled || r._hasPointLabels) && ((n = function g4(r) {
                  return r.forEach(function (r) {
                    r.visible && (i(r.dataLabels) ? r.dataLabels : r.dataLabel ? [r.dataLabel] : []).forEach(function (n) {
                      var i = n.options;
                      n.labelrank = s(i.labelrank, r.labelrank, r.shapeArgs && r.shapeArgs.height), i.allowOverlap ? (n.oldOpacity = n.opacity, n.newOpacity = 1, A(n, t)) : e.push(n);
                    });
                  });
                })(r.nodes || []), n(r.points));
              }), this.hideOverlappingLabels(e);
            }), t.prototype.hideOverlappingLabels = function (t) {
              var e,
                  r,
                  i,
                  a = this,
                  s = t.length,
                  c = a.renderer,
                  l = !1,
                  u = function t4(t) {
                var e,
                    r,
                    n = t.box ? 0 : t.padding || 0,
                    i = e = 0;

                if (t && (!t.alignAttr || t.placed)) {
                  var a = t.alignAttr || {
                    x: t.attr("x"),
                    y: t.attr("y")
                  },
                      s = t.parentGroup;
                  t.width || (e = t.getBBox(), t.width = e.width, t.height = e.height, e = c.fontMetrics(null, t.element).h);
                  var l = t.width - 2 * n;
                  return (r = {
                    left: "0",
                    center: "0.5",
                    right: "1"
                  }[t.alignValue]) ? i = +r * l : o(t.x) && Math.round(t.x) !== t.translateX && (i = t.x - t.translateX), {
                    x: a.x + (s.translateX || 0) + n - (i || 0),
                    y: a.y + (s.translateY || 0) + n - e,
                    width: t.width - 2 * n,
                    height: t.height - 2 * n
                  };
                }
              };

              for (r = 0; r < s; r++) {
                (e = t[r]) && (e.oldOpacity = e.opacity, e.newOpacity = 1, e.absoluteBox = u(e));
              }

              for (t.sort(function (t, e) {
                return (e.labelrank || 0) - (t.labelrank || 0);
              }), r = 0; r < s; r++) {
                var h = (u = t[r]) && u.absoluteBox;

                for (e = r + 1; e < s; ++e) {
                  var d = (i = t[e]) && i.absoluteBox;
                  !h || !d || u === i || 0 === u.newOpacity || 0 === i.newOpacity || "hidden" === u.visibility || "hidden" === i.visibility || d.x >= h.x + h.width || d.x + d.width <= h.x || d.y >= h.y + h.height || d.y + d.height <= h.y || ((u.labelrank < i.labelrank ? u : i).newOpacity = 0);
                }
              }

              t.forEach(function (t) {
                A(t, a) && (l = !0);
              }), l && n(a, "afterHideAllOverlappingLabels");
            };
          }), K2(e, "Core/Responsive.js", [e["Core/Utilities.js"]], function (t) {
            var e,
                r = t.extend,
                n = t.find,
                i = t.isArray,
                o = t.isObject,
                a = t.merge,
                s = t.objectEach,
                c = t.pick,
                l = t.splat,
                u = t.uniqueKey;
            return function (t) {
              var e = [];

              t.compose = function (t) {
                return -1 === e.indexOf(t) && (e.push(t), r(t.prototype, h.prototype)), t;
              };

              var h = function () {
                function a5() {}

                return a5.prototype.currentOptions = function (t) {
                  var e = this,
                      r = {};
                  return function d4(t, r, n, a) {
                    var c;
                    s(t, function (t, s) {
                      if (!a && -1 < e.collectionsWithUpdate.indexOf(s) && r[s]) for (t = l(t), n[s] = [], c = 0; c < Math.max(t.length, r[s].length); c++) {
                        r[s][c] && (void 0 === t[c] ? n[s][c] = r[s][c] : (n[s][c] = {}, d4(t[c], r[s][c], n[s][c], a + 1)));
                      } else o(t) ? (n[s] = i(t) ? [] : {}, d4(t, r[s] || {}, n[s], a + 1)) : n[s] = "undefined" === typeof r[s] ? null : r[s];
                    });
                  }(t, this.options, r, 0), r;
                }, a5.prototype.matchResponsiveRule = function (t, e) {
                  var r = t.condition;
                  (r.callback || function () {
                    return this.chartWidth <= c(r.maxWidth, Number.MAX_VALUE) && this.chartHeight <= c(r.maxHeight, Number.MAX_VALUE) && this.chartWidth >= c(r.minWidth, 0) && this.chartHeight >= c(r.minHeight, 0);
                  }).call(this) && e.push(t._id);
                }, a5.prototype.setResponsive = function (t, e) {
                  var r = this,
                      i = this.options.responsive,
                      o = this.currentResponsive,
                      s = [];
                  !e && i && i.rules && i.rules.forEach(function (t) {
                    "undefined" === typeof t._id && (t._id = u()), r.matchResponsiveRule(t, s);
                  }, this), (e = a.apply(void 0, s.map(function (t) {
                    return n((i || {}).rules || [], function (e) {
                      return e._id === t;
                    });
                  }).map(function (t) {
                    return t && t.chartOptions;
                  }))).isResponsiveOptions = !0, (s = s.toString() || void 0) !== (o && o.ruleIds) && (o && this.update(o.undoOptions, t, !0), s ? ((o = this.currentOptions(e)).isResponsiveOptions = !0, this.currentResponsive = {
                    ruleIds: s,
                    mergedOptions: e,
                    undoOptions: o
                  }, this.update(e, t, !0)) : this.currentResponsive = void 0);
                }, a5;
              }();
            }(e || (e = {})), e;
          }), K2(e, "masters/highcharts.src.js", [e["Core/Globals.js"], e["Core/Utilities.js"], e["Core/Defaults.js"], e["Core/Animation/Fx.js"], e["Core/Animation/AnimationUtilities.js"], e["Core/Renderer/HTML/AST.js"], e["Core/FormatUtilities.js"], e["Core/Renderer/RendererUtilities.js"], e["Core/Renderer/SVG/SVGElement.js"], e["Core/Renderer/SVG/SVGRenderer.js"], e["Core/Renderer/HTML/HTMLElement.js"], e["Core/Renderer/HTML/HTMLRenderer.js"], e["Core/Axis/Axis.js"], e["Core/Axis/DateTimeAxis.js"], e["Core/Axis/LogarithmicAxis.js"], e["Core/Axis/PlotLineOrBand/PlotLineOrBand.js"], e["Core/Axis/Tick.js"], e["Core/Tooltip.js"], e["Core/Series/Point.js"], e["Core/Pointer.js"], e["Core/MSPointer.js"], e["Core/Legend/Legend.js"], e["Core/Chart/Chart.js"], e["Core/Axis/Stacking/StackingAxis.js"], e["Core/Axis/Stacking/StackItem.js"], e["Core/Series/Series.js"], e["Core/Series/SeriesRegistry.js"], e["Series/Column/ColumnSeries.js"], e["Series/Column/ColumnDataLabel.js"], e["Series/Pie/PieSeries.js"], e["Series/Pie/PieDataLabel.js"], e["Core/Series/DataLabel.js"], e["Core/Responsive.js"], e["Core/Color/Color.js"], e["Core/Time.js"]], function (t, e, r, n, i, o, a, s, c, l, u, h, d, f, p, y, g, m, v, b, x, w, S, O, E, k, _, C, T, A, M, P, j, R, D) {
            return t.animate = i.animate, t.animObject = i.animObject, t.getDeferredAnimation = i.getDeferredAnimation, t.setAnimation = i.setAnimation, t.stop = i.stop, t.timers = n.timers, t.AST = o, t.Axis = d, t.Chart = S, t.chart = S.chart, t.Fx = n, t.Legend = w, t.PlotLineOrBand = y, t.Point = v, t.Pointer = x.isRequired() ? x : b, t.Series = k, t.StackItem = E, t.SVGElement = c, t.SVGRenderer = l, t.Tick = g, t.Time = D, t.Tooltip = m, t.Color = R, t.color = R.parse, h.compose(l), u.compose(c), t.defaultOptions = r.defaultOptions, t.getOptions = r.getOptions, t.time = r.defaultTime, t.setOptions = r.setOptions, t.dateFormat = a.dateFormat, t.format = a.format, t.numberFormat = a.numberFormat, t.addEvent = e.addEvent, t.arrayMax = e.arrayMax, t.arrayMin = e.arrayMin, t.attr = e.attr, t.clearTimeout = e.clearTimeout, t.correctFloat = e.correctFloat, t.createElement = e.createElement, t.css = e.css, t.defined = e.defined, t.destroyObjectProperties = e.destroyObjectProperties, t.discardElement = e.discardElement, t.distribute = s.distribute, t.erase = e.erase, t.error = e.error, t.extend = e.extend, t.extendClass = e.extendClass, t.find = e.find, t.fireEvent = e.fireEvent, t.getMagnitude = e.getMagnitude, t.getStyle = e.getStyle, t.inArray = e.inArray, t.isArray = e.isArray, t.isClass = e.isClass, t.isDOMElement = e.isDOMElement, t.isFunction = e.isFunction, t.isNumber = e.isNumber, t.isObject = e.isObject, t.isString = e.isString, t.keys = e.keys, t.merge = e.merge, t.normalizeTickInterval = e.normalizeTickInterval, t.objectEach = e.objectEach, t.offset = e.offset, t.pad = e.pad, t.pick = e.pick, t.pInt = e.pInt, t.relativeLength = e.relativeLength, t.removeEvent = e.removeEvent, t.seriesType = _.seriesType, t.splat = e.splat, t.stableSort = e.stableSort, t.syncTimeout = e.syncTimeout, t.timeUnits = e.timeUnits, t.uniqueKey = e.uniqueKey, t.useSerialIds = e.useSerialIds, t.wrap = e.wrap, T.compose(C), P.compose(k), f.compose(d), p.compose(d), M.compose(A), y.compose(d), j.compose(S), O.compose(d, S, k), t;
          }), e["masters/highcharts.src.js"]._modules = e, e["masters/highcharts.src.js"];
        }, t.exports ? (r.default = r, t.exports = e.document ? r(e) : r) : (e.Highcharts && e.Highcharts.error(16, !0), e.Highcharts = r(e));
      }(pn);
      var yn = pn.exports,
          gn = {
        exports: {}
      };
      !function (t, e) {
        var r;
        "undefined" != typeof self && self, gn.exports = (r = Z.a, function (t) {
          function t3(r) {
            if (e[r]) return e[r].exports;
            var n = e[r] = {
              i: r,
              l: !1,
              exports: {}
            };
            return t[r].call(n.exports, n, n.exports, t3), n.l = !0, n.exports;
          }

          var e = {};
          return t3.m = t, t3.c = e, t3.d = function (t, e, r) {
            t3.o(t, e) || Object.defineProperty(t, e, {
              configurable: !1,
              enumerable: !0,
              get: r
            });
          }, t3.n = function (t) {
            var e = t && t.__esModule ? function () {
              return t.default;
            } : function () {
              return t;
            };
            return t3.d(e, "a", e), e;
          }, t3.o = function (t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
          }, t3.p = "", t3(t3.s = 0);
        }([function (t, e, r) {
          function n2() {
            return (n2 = Object.assign || function (t) {
              for (var e = 1; e < arguments.length; e++) {
                var r = arguments[e];

                for (var n in r) {
                  Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
                }
              }

              return t;
            }).apply(this, arguments);
          }

          function o(t) {
            return function a3(t) {
              if (Array.isArray(t)) return f2(t);
            }(t) || function i2(t) {
              if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
            }(t) || function u3(t, e) {
              if (t) {
                if ("string" == typeof t) return f2(t, e);
                var r = Object.prototype.toString.call(t).slice(8, -1);
                return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? f2(t, e) : void 0;
              }
            }(t) || function c2() {
              throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
          }

          function f2(t, e) {
            (null == e || e > t.length) && (e = t.length);

            for (var r = 0, n = new Array(e); r < e; r++) {
              n[r] = t[r];
            }

            return n;
          }

          function s3(t) {
            return (s3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
              return typeof t;
            } : function (t) {
              return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
          }

          Object.defineProperty(e, "__esModule", {
            value: !0
          });
          var n = r(1),
              i = r.n(n),
              a = "undefined" != typeof window ? n.useLayoutEffect : n.useEffect,
              s = Object(n.forwardRef)(function (t, e) {
            var r = Object(n.useRef)(),
                s = Object(n.useRef)();
            return a(function () {
              function t5() {
                var e = t.highcharts || "object" === ("undefined" == typeof window ? "undefined" : s3(window)) && window.Highcharts,
                    n = t.constructorType || "chart";
                e ? e[n] ? t.options ? s.current = e[n](r.current, t.options, t.callback ? t.callback : void 0) : console.warn('The "options" property was not passed.') : console.warn('The "constructorType" property is incorrect or some required module is not imported.') : console.warn('The "highcharts" property was not passed.');
              }

              if (s.current) {
                if (!1 !== t.allowChartUpdate) if (!t.immutable && s.current) {
                  var e;
                  (e = s.current).update.apply(e, [t.options].concat(o(t.updateArgs || [!0, !0])));
                } else t5();
              } else t5();
            }), a(function () {
              return function () {
                s.current && (s.current.destroy(), s.current = null);
              };
            }, []), Object(n.useImperativeHandle)(e, function () {
              return {
                get chart() {
                  return s.current;
                },

                container: r
              };
            }, []), i.a.createElement("div", n2({}, t.containerProps, {
              ref: r
            }));
          });
          e.default = Object(n.memo)(s);
        }, function (t, e) {
          t.exports = r;
        }]));
      }();
      var mn = {
        exports: {}
      };
      !function (t) {
        var e;
        e = function e(t) {
          function b2(t, e, r, n) {
            t.hasOwnProperty(e) || (t[e] = n.apply(null, r), "function" === typeof CustomEvent && window.dispatchEvent(new CustomEvent("HighchartsModuleLoaded", {
              detail: {
                path: e,
                module: t[e]
              }
            })));
          }

          b2(t = t ? t._modules : {}, "Extensions/NoDataToDisplay.js", [t["Core/Renderer/HTML/AST.js"], t["Core/Chart/Chart.js"], t["Core/Defaults.js"], t["Core/Utilities.js"]], function (t, e, r, n) {
            var i = r.getOptions;
            r = n.addEvent;
            var o = n.extend;
            n = e.prototype, i = i(), o(i.lang, {
              noData: "No data to display"
            }), i.noData = {
              attr: {
                zIndex: 1
              },
              position: {
                x: 0,
                y: 0,
                align: "center",
                verticalAlign: "middle"
              },
              style: {
                fontWeight: "bold",
                fontSize: "12px",
                color: "#666666"
              }
            }, n.showNoData = function (e) {
              var r = this.options;
              e = e || r && r.lang.noData || "", r = r && (r.noData || {}), this.renderer && (this.noDataLabel || (this.noDataLabel = this.renderer.label(e, 0, 0, void 0, void 0, void 0, r.useHTML, void 0, "no-data").add()), this.styledMode || this.noDataLabel.attr(t.filterUserAttributes(r.attr || {})).css(r.style || {}), this.noDataLabel.align(o(this.noDataLabel.getBBox(), r.position || {}), !1, "plotBox"));
            }, n.hideNoData = function () {
              this.noDataLabel && (this.noDataLabel = this.noDataLabel.destroy());
            }, n.hasData = function () {
              for (var t = this.series || [], e = t.length; e--;) {
                if (t[e].hasData() && !t[e].options.isInternal) return !0;
              }

              return this.loadingShown;
            }, r(e, "render", function () {
              this.hasData() ? this.hideNoData() : this.showNoData();
            });
          }), b2(t, "masters/modules/no-data-to-display.src.js", [], function () {});
        }, t.exports ? (e.default = e, t.exports = e) : e("undefined" !== typeof Highcharts ? Highcharts : void 0);
      }(mn);
      (0, mn.exports)(yn);

      var vn = Object(J.styled)(J.Flex, {
        backgroundColor: "$blue2",
        border: "1px solid $blue5",
        borderRadius: "$4",
        paddingX: "$1"
      }),
          bn = function FilterChip(t) {
        var e = t.filterKey,
            r = t.filterOperator,
            n = t.filterValue;
        return rr(vn, {
          gap: "half",
          children: [er(J.Text, {
            as: "span",
            children: e
          }), er(J.Text, {
            as: "span",
            children: r
          }), er(J.Text, {
            as: "span",
            variant: "bodyBold",
            children: Array.isArray(n) ? n.join(",") : n
          })]
        });
      },
          xn = function asRenderableColumnKeys() {
        return (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : []).map(function (t) {
          var e = Object.keys(t),
              r = {};
          return e.forEach(function (e) {
            var n = e.split("."),
                i = n[0],
                o = n[1];
            r[i] ? r[i][o] = t[e] : r[i] = Object(F.a)({}, o, t[e]);
          }), r;
        });
      },
          wn = "undefined" !== typeof Symbol && Symbol,
          Sn = function hasSymbols() {
        if ("function" !== typeof Symbol || "function" !== typeof Object.getOwnPropertySymbols) return !1;
        if ("symbol" === typeof Symbol.iterator) return !0;
        var t = {},
            e = Symbol("test"),
            r = Object(e);
        if ("string" === typeof e) return !1;
        if ("[object Symbol]" !== Object.prototype.toString.call(e)) return !1;
        if ("[object Symbol]" !== Object.prototype.toString.call(r)) return !1;

        for (e in t[e] = 42, t) {
          return !1;
        }

        if ("function" === typeof Object.keys && 0 !== Object.keys(t).length) return !1;
        if ("function" === typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(t).length) return !1;
        var n = Object.getOwnPropertySymbols(t);
        if (1 !== n.length || n[0] !== e) return !1;
        if (!Object.prototype.propertyIsEnumerable.call(t, e)) return !1;

        if ("function" === typeof Object.getOwnPropertyDescriptor) {
          var i = Object.getOwnPropertyDescriptor(t, e);
          if (42 !== i.value || !0 !== i.enumerable) return !1;
        }

        return !0;
      },
          On = Array.prototype.slice,
          En = Object.prototype.toString,
          kn = function bind2(t) {
        var e = this;
        if ("function" !== typeof e || "[object Function]" !== En.call(e)) throw new TypeError("Function.prototype.bind called on incompatible " + e);

        for (var r, n = On.call(arguments, 1), i = Math.max(0, e.length - n.length), o = [], a = 0; a < i; a++) {
          o.push("$" + a);
        }

        if (r = Function("binder", "return function (" + o.join(",") + "){ return binder.apply(this,arguments); }")(function binder() {
          if (this instanceof r) {
            var i = e.apply(this, n.concat(On.call(arguments)));
            return Object(i) === i ? i : this;
          }

          return e.apply(t, n.concat(On.call(arguments)));
        }), e.prototype) {
          var s = function Empty2() {};

          s.prototype = e.prototype, r.prototype = new s(), s.prototype = null;
        }

        return r;
      },
          _n = Function.prototype.bind || kn,
          Cn = _n.call(Function.call, Object.prototype.hasOwnProperty),
          Tn = SyntaxError,
          An = Function,
          Mn = TypeError,
          Pn = function getEvalledConstructor(t) {
        try {
          return An('"use strict"; return (' + t + ").constructor;")();
        } catch (e) {}
      },
          jn = Object.getOwnPropertyDescriptor;

      if (jn) try {
        jn({}, "");
      } catch (ts) {
        jn = null;
      }

      var Rn = function throwTypeError() {
        throw new Mn();
      },
          Dn = jn ? function () {
        try {
          return arguments.callee, Rn;
        } catch (t) {
          try {
            return jn(arguments, "callee").get;
          } catch (e) {
            return Rn;
          }
        }
      }() : Rn,
          In = function hasNativeSymbols() {
        return "function" === typeof wn && "function" === typeof Symbol && "symbol" === typeof wn("foo") && "symbol" === typeof Symbol("bar") && Sn();
      }(),
          Ln = Object.getPrototypeOf || function (t) {
        return t.__proto__;
      },
          Nn = {},
          Bn = "undefined" === typeof Uint8Array ? void 0 : Ln(Uint8Array),
          Fn = {
        "%AggregateError%": "undefined" === typeof AggregateError ? void 0 : AggregateError,
        "%Array%": Array,
        "%ArrayBuffer%": "undefined" === typeof ArrayBuffer ? void 0 : ArrayBuffer,
        "%ArrayIteratorPrototype%": In ? Ln([][Symbol.iterator]()) : void 0,
        "%AsyncFromSyncIteratorPrototype%": void 0,
        "%AsyncFunction%": Nn,
        "%AsyncGenerator%": Nn,
        "%AsyncGeneratorFunction%": Nn,
        "%AsyncIteratorPrototype%": Nn,
        "%Atomics%": "undefined" === typeof Atomics ? void 0 : Atomics,
        "%BigInt%": "undefined" === typeof BigInt ? void 0 : BigInt,
        "%Boolean%": Boolean,
        "%DataView%": "undefined" === typeof DataView ? void 0 : DataView,
        "%Date%": Date,
        "%decodeURI%": decodeURI,
        "%decodeURIComponent%": decodeURIComponent,
        "%encodeURI%": encodeURI,
        "%encodeURIComponent%": encodeURIComponent,
        "%Error%": Error,
        "%eval%": eval,
        "%EvalError%": EvalError,
        "%Float32Array%": "undefined" === typeof Float32Array ? void 0 : Float32Array,
        "%Float64Array%": "undefined" === typeof Float64Array ? void 0 : Float64Array,
        "%FinalizationRegistry%": "undefined" === typeof FinalizationRegistry ? void 0 : FinalizationRegistry,
        "%Function%": An,
        "%GeneratorFunction%": Nn,
        "%Int8Array%": "undefined" === typeof Int8Array ? void 0 : Int8Array,
        "%Int16Array%": "undefined" === typeof Int16Array ? void 0 : Int16Array,
        "%Int32Array%": "undefined" === typeof Int32Array ? void 0 : Int32Array,
        "%isFinite%": isFinite,
        "%isNaN%": isNaN,
        "%IteratorPrototype%": In ? Ln(Ln([][Symbol.iterator]())) : void 0,
        "%JSON%": "object" === typeof JSON ? JSON : void 0,
        "%Map%": "undefined" === typeof Map ? void 0 : Map,
        "%MapIteratorPrototype%": "undefined" !== typeof Map && In ? Ln(new Map()[Symbol.iterator]()) : void 0,
        "%Math%": Math,
        "%Number%": Number,
        "%Object%": Object,
        "%parseFloat%": parseFloat,
        "%parseInt%": parseInt,
        "%Promise%": "undefined" === typeof Promise ? void 0 : Promise,
        "%Proxy%": "undefined" === typeof Proxy ? void 0 : Proxy,
        "%RangeError%": RangeError,
        "%ReferenceError%": ReferenceError,
        "%Reflect%": "undefined" === typeof Reflect ? void 0 : Reflect,
        "%RegExp%": RegExp,
        "%Set%": "undefined" === typeof Set ? void 0 : Set,
        "%SetIteratorPrototype%": "undefined" !== typeof Set && In ? Ln(new Set()[Symbol.iterator]()) : void 0,
        "%SharedArrayBuffer%": "undefined" === typeof SharedArrayBuffer ? void 0 : SharedArrayBuffer,
        "%String%": String,
        "%StringIteratorPrototype%": In ? Ln(""[Symbol.iterator]()) : void 0,
        "%Symbol%": In ? Symbol : void 0,
        "%SyntaxError%": Tn,
        "%ThrowTypeError%": Dn,
        "%TypedArray%": Bn,
        "%TypeError%": Mn,
        "%Uint8Array%": "undefined" === typeof Uint8Array ? void 0 : Uint8Array,
        "%Uint8ClampedArray%": "undefined" === typeof Uint8ClampedArray ? void 0 : Uint8ClampedArray,
        "%Uint16Array%": "undefined" === typeof Uint16Array ? void 0 : Uint16Array,
        "%Uint32Array%": "undefined" === typeof Uint32Array ? void 0 : Uint32Array,
        "%URIError%": URIError,
        "%WeakMap%": "undefined" === typeof WeakMap ? void 0 : WeakMap,
        "%WeakRef%": "undefined" === typeof WeakRef ? void 0 : WeakRef,
        "%WeakSet%": "undefined" === typeof WeakSet ? void 0 : WeakSet
      },
          Un = {
        "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
        "%ArrayPrototype%": ["Array", "prototype"],
        "%ArrayProto_entries%": ["Array", "prototype", "entries"],
        "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
        "%ArrayProto_keys%": ["Array", "prototype", "keys"],
        "%ArrayProto_values%": ["Array", "prototype", "values"],
        "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
        "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
        "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
        "%BooleanPrototype%": ["Boolean", "prototype"],
        "%DataViewPrototype%": ["DataView", "prototype"],
        "%DatePrototype%": ["Date", "prototype"],
        "%ErrorPrototype%": ["Error", "prototype"],
        "%EvalErrorPrototype%": ["EvalError", "prototype"],
        "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
        "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
        "%FunctionPrototype%": ["Function", "prototype"],
        "%Generator%": ["GeneratorFunction", "prototype"],
        "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
        "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
        "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
        "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
        "%JSONParse%": ["JSON", "parse"],
        "%JSONStringify%": ["JSON", "stringify"],
        "%MapPrototype%": ["Map", "prototype"],
        "%NumberPrototype%": ["Number", "prototype"],
        "%ObjectPrototype%": ["Object", "prototype"],
        "%ObjProto_toString%": ["Object", "prototype", "toString"],
        "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
        "%PromisePrototype%": ["Promise", "prototype"],
        "%PromiseProto_then%": ["Promise", "prototype", "then"],
        "%Promise_all%": ["Promise", "all"],
        "%Promise_reject%": ["Promise", "reject"],
        "%Promise_resolve%": ["Promise", "resolve"],
        "%RangeErrorPrototype%": ["RangeError", "prototype"],
        "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
        "%RegExpPrototype%": ["RegExp", "prototype"],
        "%SetPrototype%": ["Set", "prototype"],
        "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
        "%StringPrototype%": ["String", "prototype"],
        "%SymbolPrototype%": ["Symbol", "prototype"],
        "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
        "%TypedArrayPrototype%": ["TypedArray", "prototype"],
        "%TypeErrorPrototype%": ["TypeError", "prototype"],
        "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
        "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
        "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
        "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
        "%URIErrorPrototype%": ["URIError", "prototype"],
        "%WeakMapPrototype%": ["WeakMap", "prototype"],
        "%WeakSetPrototype%": ["WeakSet", "prototype"]
      },
          Wn = _n,
          zn = Cn,
          qn = Wn.call(Function.call, Array.prototype.concat),
          Hn = Wn.call(Function.apply, Array.prototype.splice),
          Gn = Wn.call(Function.call, String.prototype.replace),
          Yn = Wn.call(Function.call, String.prototype.slice),
          Xn = Wn.call(Function.call, RegExp.prototype.exec),
          Vn = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g,
          $n = /\\(\\)?/g,
          Qn = function getBaseIntrinsic2(t, e) {
        var r,
            n = t;

        if (zn(Un, n) && (n = "%" + (r = Un[n])[0] + "%"), zn(Fn, n)) {
          var i = Fn[n];
          if (i === Nn && (i = function doEval2(t) {
            var e;
            if ("%AsyncFunction%" === t) e = Pn("async function () {}");else if ("%GeneratorFunction%" === t) e = Pn("function* () {}");else if ("%AsyncGeneratorFunction%" === t) e = Pn("async function* () {}");else if ("%AsyncGenerator%" === t) {
              var r = doEval2("%AsyncGeneratorFunction%");
              r && (e = r.prototype);
            } else if ("%AsyncIteratorPrototype%" === t) {
              var n = doEval2("%AsyncGenerator%");
              n && (e = Ln(n.prototype));
            }
            return Fn[t] = e, e;
          }(n)), "undefined" === typeof i && !e) throw new Mn("intrinsic " + t + " exists, but is not available. Please file an issue!");
          return {
            alias: r,
            name: n,
            value: i
          };
        }

        throw new Tn("intrinsic " + t + " does not exist!");
      },
          Kn = function GetIntrinsic(t, e) {
        if ("string" !== typeof t || 0 === t.length) throw new Mn("intrinsic name must be a non-empty string");
        if (arguments.length > 1 && "boolean" !== typeof e) throw new Mn('"allowMissing" argument must be a boolean');
        if (null === Xn(/^%?[^%]*%?$/g, t)) throw new Tn("`%` may not be present anywhere but at the beginning and end of the intrinsic name");

        var r = function stringToPath2(t) {
          var e = Yn(t, 0, 1),
              r = Yn(t, -1);
          if ("%" === e && "%" !== r) throw new Tn("invalid intrinsic syntax, expected closing `%`");
          if ("%" === r && "%" !== e) throw new Tn("invalid intrinsic syntax, expected opening `%`");
          var n = [];
          return Gn(t, Vn, function (t, e, r, i) {
            n[n.length] = r ? Gn(i, $n, "$1") : e || t;
          }), n;
        }(t),
            n = r.length > 0 ? r[0] : "",
            i = Qn("%" + n + "%", e),
            o = i.name,
            a = i.value,
            s = !1,
            c = i.alias;

        c && (n = c[0], Hn(r, qn([0, 1], c)));

        for (var l = 1, u = !0; l < r.length; l += 1) {
          var h = r[l],
              d = Yn(h, 0, 1),
              f = Yn(h, -1);
          if (('"' === d || "'" === d || "`" === d || '"' === f || "'" === f || "`" === f) && d !== f) throw new Tn("property names with quotes must have matching quotes");
          if ("constructor" !== h && u || (s = !0), zn(Fn, o = "%" + (n += "." + h) + "%")) a = Fn[o];else if (null != a) {
            if (!(h in a)) {
              if (!e) throw new Mn("base intrinsic for " + t + " exists, but the property is not available.");
              return;
            }

            if (jn && l + 1 >= r.length) {
              var p = jn(a, h);
              a = (u = !!p) && "get" in p && !("originalValue" in p.get) ? p.get : a[h];
            } else u = zn(a, h), a = a[h];

            u && !s && (Fn[o] = a);
          }
        }

        return a;
      },
          Zn = {
        exports: {}
      };

      !function (t) {
        var e = _n,
            r = Kn,
            n = r("%Function.prototype.apply%"),
            i = r("%Function.prototype.call%"),
            o = r("%Reflect.apply%", !0) || e.call(i, n),
            a = r("%Object.getOwnPropertyDescriptor%", !0),
            s = r("%Object.defineProperty%", !0),
            c = r("%Math.max%");
        if (s) try {
          s({}, "a", {
            value: 1
          });
        } catch (ts) {
          s = null;
        }

        t.exports = function callBind2(t) {
          var r = o(e, i, arguments);
          a && s && a(r, "length").configurable && s(r, "length", {
            value: 1 + c(0, t.length - (arguments.length - 1))
          });
          return r;
        };

        var l = function applyBind2() {
          return o(e, n, arguments);
        };

        s ? s(t.exports, "apply", {
          value: l
        }) : t.exports.apply = l;
      }(Zn);
      var Jn = Kn,
          ti = Zn.exports,
          ei = ti(Jn("String.prototype.indexOf")),
          ri = getAugmentedNamespace(Object.freeze(Object.defineProperty({
        __proto__: null,
        default: {}
      }, Symbol.toStringTag, {
        value: "Module"
      }))),
          ni = "function" === typeof Map && Map.prototype,
          ii = Object.getOwnPropertyDescriptor && ni ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null,
          oi = (ni && ii && "function" === typeof ii.get && ii.get, ni && Map.prototype.forEach, "function" === typeof Set && Set.prototype),
          ai = Object.getOwnPropertyDescriptor && oi ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null,
          si = (oi && ai && "function" === typeof ai.get && ai.get, oi && Set.prototype.forEach, "function" === typeof WeakMap && WeakMap.prototype && WeakMap.prototype.has, "function" === typeof WeakSet && WeakSet.prototype && WeakSet.prototype.has, "function" === typeof WeakRef && WeakRef.prototype && WeakRef.prototype.deref, Boolean.prototype.valueOf, Object.prototype.toString, Function.prototype.toString, String.prototype.match, String.prototype.slice, String.prototype.replace, String.prototype.toUpperCase, String.prototype.toLowerCase, RegExp.prototype.test, Array.prototype.concat, Array.prototype.join, Array.prototype.slice, Math.floor, "function" === typeof BigInt && BigInt.prototype.valueOf, Object.getOwnPropertySymbols, "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? Symbol.prototype.toString : null),
          ci = "function" === typeof Symbol && "object" === typeof Symbol.iterator;
      "function" === typeof Symbol && Symbol.toStringTag && (typeof Symbol.toStringTag === ci || "symbol") && Symbol.toStringTag, Object.prototype.propertyIsEnumerable, ("function" === typeof Reflect ? Reflect.getPrototypeOf : Object.getPrototypeOf) || Array.prototype;
      var li = ri,
          ui = li.custom;
      isSymbol(ui);

      function isSymbol(t) {
        if (ci) return t && "object" === typeof t && t instanceof Symbol;
        if ("symbol" === typeof t) return !0;
        if (!t || "object" !== typeof t || !si) return !1;

        try {
          return si.call(t), !0;
        } catch (ts) {}

        return !1;
      }

      Object.prototype.hasOwnProperty;

      var hi = Kn,
          di = function callBoundIntrinsic(t, e) {
        var r = Jn(t, !!e);
        return "function" === typeof r && ei(t, ".prototype.") > -1 ? ti(r) : r;
      },
          fi = (hi("%TypeError%"), hi("%WeakMap%", !0), hi("%Map%", !0), di("WeakMap.prototype.get", !0), di("WeakMap.prototype.set", !0), di("WeakMap.prototype.has", !0), di("Map.prototype.get", !0), di("Map.prototype.set", !0), di("Map.prototype.has", !0), String.prototype.replace),
          pi = /%20/g,
          yi = "RFC3986",
          gi = {
        default: yi,
        formatters: {
          RFC1738: function RFC1738(t) {
            return fi.call(t, pi, "+");
          },
          RFC3986: function RFC3986(t) {
            return String(t);
          }
        },
        RFC1738: "RFC1738",
        RFC3986: yi
      },
          mi = gi,
          vi = Object.prototype.hasOwnProperty,
          bi = Array.isArray,
          xi = function () {
        for (var t = [], e = 0; e < 256; ++e) {
          t.push("%" + ((e < 16 ? "0" : "") + e.toString(16)).toUpperCase());
        }

        return t;
      }(),
          wi = function arrayToObject2(t, e) {
        for (var r = e && e.plainObjects ? Object.create(null) : {}, n = 0; n < t.length; ++n) {
          "undefined" !== typeof t[n] && (r[n] = t[n]);
        }

        return r;
      },
          Si = {
        arrayToObject: wi,
        assign: function assignSingleSource(t, e) {
          return Object.keys(e).reduce(function (t, r) {
            return t[r] = e[r], t;
          }, t);
        },
        combine: function combine2(t, e) {
          return [].concat(t, e);
        },
        compact: function compact2(t) {
          for (var e = [{
            obj: {
              o: t
            },
            prop: "o"
          }], r = [], n = 0; n < e.length; ++n) {
            for (var i = e[n], o = i.obj[i.prop], a = Object.keys(o), s = 0; s < a.length; ++s) {
              var c = a[s],
                  l = o[c];
              "object" === typeof l && null !== l && -1 === r.indexOf(l) && (e.push({
                obj: o,
                prop: c
              }), r.push(l));
            }
          }

          return function compactQueue2(t) {
            for (; t.length > 1;) {
              var e = t.pop(),
                  r = e.obj[e.prop];

              if (bi(r)) {
                for (var n = [], i = 0; i < r.length; ++i) {
                  "undefined" !== typeof r[i] && n.push(r[i]);
                }

                e.obj[e.prop] = n;
              }
            }
          }(e), t;
        },
        decode: function decode(t, e, r) {
          var n = t.replace(/\+/g, " ");
          if ("iso-8859-1" === r) return n.replace(/%[0-9a-f]{2}/gi, unescape);

          try {
            return decodeURIComponent(n);
          } catch (ts) {
            return n;
          }
        },
        encode: function encode2(t, e, r, n, i) {
          if (0 === t.length) return t;
          var o = t;
          if ("symbol" === typeof t ? o = Symbol.prototype.toString.call(t) : "string" !== typeof t && (o = String(t)), "iso-8859-1" === r) return escape(o).replace(/%u[0-9a-f]{4}/gi, function (t) {
            return "%26%23" + parseInt(t.slice(2), 16) + "%3B";
          });

          for (var a = "", s = 0; s < o.length; ++s) {
            var c = o.charCodeAt(s);
            45 === c || 46 === c || 95 === c || 126 === c || c >= 48 && c <= 57 || c >= 65 && c <= 90 || c >= 97 && c <= 122 || i === mi.RFC1738 && (40 === c || 41 === c) ? a += o.charAt(s) : c < 128 ? a += xi[c] : c < 2048 ? a += xi[192 | c >> 6] + xi[128 | 63 & c] : c < 55296 || c >= 57344 ? a += xi[224 | c >> 12] + xi[128 | c >> 6 & 63] + xi[128 | 63 & c] : (s += 1, c = 65536 + ((1023 & c) << 10 | 1023 & o.charCodeAt(s)), a += xi[240 | c >> 18] + xi[128 | c >> 12 & 63] + xi[128 | c >> 6 & 63] + xi[128 | 63 & c]);
          }

          return a;
        },
        isBuffer: function isBuffer2(t) {
          return !(!t || "object" !== typeof t) && !!(t.constructor && t.constructor.isBuffer && t.constructor.isBuffer(t));
        },
        isRegExp: function isRegExp2(t) {
          return "[object RegExp]" === Object.prototype.toString.call(t);
        },
        maybeMap: function maybeMap2(t, e) {
          if (bi(t)) {
            for (var r = [], n = 0; n < t.length; n += 1) {
              r.push(e(t[n]));
            }

            return r;
          }

          return e(t);
        },
        merge: function merge2(t, e, r) {
          if (!e) return t;

          if ("object" !== typeof e) {
            if (bi(t)) t.push(e);else {
              if (!t || "object" !== typeof t) return [t, e];
              (r && (r.plainObjects || r.allowPrototypes) || !vi.call(Object.prototype, e)) && (t[e] = !0);
            }
            return t;
          }

          if (!t || "object" !== typeof t) return [t].concat(e);
          var n = t;
          return bi(t) && !bi(e) && (n = wi(t, r)), bi(t) && bi(e) ? (e.forEach(function (e, n) {
            if (vi.call(t, n)) {
              var i = t[n];
              i && "object" === typeof i && e && "object" === typeof e ? t[n] = merge2(i, e, r) : t.push(e);
            } else t[n] = e;
          }), t) : Object.keys(e).reduce(function (t, n) {
            var i = e[n];
            return vi.call(t, n) ? t[n] = merge2(t[n], i, r) : t[n] = i, t;
          }, n);
        }
      },
          Oi = Si,
          Ei = gi,
          ki = (Object.prototype.hasOwnProperty, Array.isArray, Array.prototype.push, Date.prototype.toISOString),
          _i = Ei.default,
          Ci = (Oi.encode, Ei.formatters[_i], Si),
          Ti = (Object.prototype.hasOwnProperty, Array.isArray, Ci.decode, "PRODUCTION" === window.__ENV__ ? {
        CUBE_REPORTING_API: "https://cube-reporting.api.drift.com/",
        CUBE_REST_API: "https://cube-core.driftapi.com/cubejs-api/v1",
        METRICS_API: "https://metrics.api.drift.com/",
        throwOnError: !1,
        logEnabled: !1
      } : {
        CUBE_REPORTING_API: "https://cube-reporting.api.driftqa.com/",
        CUBE_REST_API: "https://cube-core.driftapiqa.com/cubejs-api/v1",
        METRICS_API: "https://metrics.api.driftqa.com/",
        throwOnError: !0,
        logEnabled: !0
      });

      function assign(t) {
        for (var e = 1; e < arguments.length; e++) {
          var r = arguments[e];

          for (var n in r) {
            t[n] = r[n];
          }
        }

        return t;
      }

      var Ai = function init(t, e) {
        function set(r, n, i) {
          if ("undefined" !== typeof document) {
            "number" === typeof (i = assign({}, e, i)).expires && (i.expires = new Date(Date.now() + 864e5 * i.expires)), i.expires && (i.expires = i.expires.toUTCString()), r = encodeURIComponent(r).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var o = "";

            for (var a in i) {
              i[a] && (o += "; " + a, !0 !== i[a] && (o += "=" + i[a].split(";")[0]));
            }

            return document.cookie = r + "=" + t.write(n, r) + o;
          }
        }

        return Object.create({
          set: set,
          get: function get(e) {
            if ("undefined" !== typeof document && (!arguments.length || e)) {
              for (var r = document.cookie ? document.cookie.split("; ") : [], n = {}, i = 0; i < r.length; i++) {
                var o = r[i].split("="),
                    a = o.slice(1).join("=");

                try {
                  var s = decodeURIComponent(o[0]);
                  if (n[s] = t.read(a, s), e === s) break;
                } catch (ts) {}
              }

              return e ? n[e] : n;
            }
          },
          remove: function remove(t, e) {
            set(t, "", assign({}, e, {
              expires: -1
            }));
          },
          withAttributes: function withAttributes(t) {
            return init(this.converter, assign({}, this.attributes, t));
          },
          withConverter: function withConverter(t) {
            return init(assign({}, this.converter, t), this.attributes);
          }
        }, {
          attributes: {
            value: Object.freeze(e)
          },
          converter: {
            value: Object.freeze(t)
          }
        });
      }({
        read: function read(t) {
          return '"' === t[0] && (t = t.slice(1, -1)), t.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function write(t) {
          return encodeURIComponent(t).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
      }, {
        path: "/"
      }),
          Mi = function (t) {
        Object(A.a)(HTTPError, t);
        var e = Object(P.a)(HTTPError);

        function HTTPError(t, r, n) {
          var i;
          Object(W.a)(this, HTTPError);
          var o = t.status || 0 === t.status ? t.status : "",
              a = t.statusText || "",
              s = "".concat(o, " ").concat(a).trim(),
              c = s ? "status code ".concat(s) : "an unknown error";
          return i = e.call(this, "Request failed with ".concat(c)), Object.defineProperty(Object(C.a)(i), "response", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
          }), Object.defineProperty(Object(C.a)(i), "request", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
          }), Object.defineProperty(Object(C.a)(i), "options", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
          }), i.name = "HTTPError", i.response = t, i.request = r, i.options = n, i;
        }

        return HTTPError;
      }(Object(j.a)(Error)),
          Pi = function (t) {
        Object(A.a)(TimeoutError, t);
        var e = Object(P.a)(TimeoutError);

        function TimeoutError(t) {
          var r;
          return Object(W.a)(this, TimeoutError), r = e.call(this, "Request timed out"), Object.defineProperty(Object(C.a)(r), "request", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
          }), r.name = "TimeoutError", r.request = t, r;
        }

        return TimeoutError;
      }(Object(j.a)(Error)),
          ji = function isObject(t) {
        return null !== t && "object" === typeof t;
      },
          Ri = function validateAndMerge() {
        for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++) {
          e[r] = arguments[r];
        }

        for (var n = 0, i = e; n < i.length; n++) {
          var o = i[n];
          if ((!ji(o) || Array.isArray(o)) && "undefined" !== typeof o) throw new TypeError("The `options` argument must be an object");
        }

        return Ii.apply(void 0, [{}].concat(e));
      },
          Di = function mergeHeaders() {
        var t,
            e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = new globalThis.Headers(e),
            i = r instanceof globalThis.Headers,
            o = new globalThis.Headers(r),
            a = Object(_.a)(o.entries());

        try {
          for (a.s(); !(t = a.n()).done;) {
            var s = Object(V.a)(t.value, 2),
                c = s[0],
                l = s[1];
            i && "undefined" === l || void 0 === l ? n.delete(c) : n.set(c, l);
          }
        } catch (u) {
          a.e(u);
        } finally {
          a.f();
        }

        return n;
      },
          Ii = function deepMerge() {
        for (var t = {}, e = {}, r = arguments.length, n = new Array(r), i = 0; i < r; i++) {
          n[i] = arguments[i];
        }

        for (var o = 0, a = n; o < a.length; o++) {
          var s = a[o];
          if (Array.isArray(s)) Array.isArray(t) || (t = []), t = [].concat(Object(E.a)(t), Object(E.a)(s));else if (ji(s)) {
            for (var c = 0, l = Object.entries(s); c < l.length; c++) {
              var u = Object(V.a)(l[c], 2),
                  h = u[0],
                  d = u[1];
              ji(d) && h in t && (d = deepMerge(t[h], d)), t = Object(G.a)(Object(G.a)({}, t), {}, Object(F.a)({}, h, d));
            }

            ji(s.headers) && (e = Di(e, s.headers), t.headers = e);
          }
        }

        return t;
      },
          Li = function () {
        var t = !1,
            e = !1;
        return "function" === typeof globalThis.ReadableStream && (e = new globalThis.Request("https://a.com", {
          body: new globalThis.ReadableStream(),
          method: "POST",

          get duplex() {
            return t = !0, "half";
          }

        }).headers.has("Content-Type")), t && !e;
      }(),
          Ni = "function" === typeof globalThis.AbortController,
          Bi = "function" === typeof globalThis.ReadableStream,
          Fi = "function" === typeof globalThis.FormData,
          Ui = ["get", "post", "put", "patch", "head", "delete"],
          Wi = {
        json: "application/json",
        text: "text/*",
        formData: "multipart/form-data",
        arrayBuffer: "*/*",
        blob: "*/*"
      },
          zi = Symbol("stop"),
          qi = function normalizeRequestMethod(t) {
        return Ui.includes(t) ? t.toUpperCase() : t;
      },
          Hi = [413, 429, 503],
          Gi = {
        limit: 2,
        methods: ["get", "put", "head", "delete", "options", "trace"],
        statusCodes: [408, 413, 429, 500, 502, 503, 504],
        afterStatusCodes: Hi,
        maxRetryAfter: Number.POSITIVE_INFINITY,
        backoffLimit: Number.POSITIVE_INFINITY
      },
          Yi = function normalizeRetryOptions() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        if ("number" === typeof t) return Object(G.a)(Object(G.a)({}, Gi), {}, {
          limit: t
        });
        if (t.methods && !Array.isArray(t.methods)) throw new Error("retry.methods must be an array");
        if (t.statusCodes && !Array.isArray(t.statusCodes)) throw new Error("retry.statusCodes must be an array");
        return Object(G.a)(Object(G.a)(Object(G.a)({}, Gi), t), {}, {
          afterStatusCodes: Hi
        });
      };

      function timeout(t, e, r) {
        return _timeout.apply(this, arguments);
      }

      function _timeout() {
        return (_timeout = Object(v.a)(g.a.mark(function _callee34(t, e, r) {
          return g.a.wrap(function _callee34$(n) {
            for (;;) {
              switch (n.prev = n.next) {
                case 0:
                  return n.abrupt("return", new Promise(function (n, i) {
                    var o = setTimeout(function () {
                      e && e.abort(), i(new Pi(t));
                    }, r.timeout);
                    r.fetch(t).then(n).catch(i).then(function () {
                      clearTimeout(o);
                    });
                  }));

                case 1:
                case "end":
                  return n.stop();
              }
            }
          }, _callee34);
        }))).apply(this, arguments);
      }

      var Xi = null != (a = globalThis.DOMException) ? a : Error;

      function composeAbortError(t) {
        var e;
        return new Xi(null != (e = null == t ? void 0 : t.reason) ? e : "The operation was aborted.");
      }

      function delay(t, e) {
        return _delay.apply(this, arguments);
      }

      function _delay() {
        return (_delay = Object(v.a)(g.a.mark(function _callee35(t, e) {
          var r;
          return g.a.wrap(function _callee35$(n) {
            for (;;) {
              switch (n.prev = n.next) {
                case 0:
                  return r = e.signal, n.abrupt("return", new Promise(function (e, n) {
                    if (r) {
                      if (r.aborted) return void n(composeAbortError(r));
                      r.addEventListener("abort", handleAbort, {
                        once: !0
                      });
                    }

                    function handleAbort() {
                      n(composeAbortError(r)), clearTimeout(i);
                    }

                    var i = setTimeout(function () {
                      null == r || r.removeEventListener("abort", handleAbort), e();
                    }, t);
                  }));

                case 2:
                case "end":
                  return n.stop();
              }
            }
          }, _callee35);
        }))).apply(this, arguments);
      }

      var Vi = function () {
        function Ky(t) {
          var e,
              r,
              n,
              i = this,
              o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          if (Object(W.a)(this, Ky), Object.defineProperty(this, "request", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
          }), Object.defineProperty(this, "abortController", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
          }), Object.defineProperty(this, "_retryCount", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
          }), Object.defineProperty(this, "_input", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
          }), Object.defineProperty(this, "_options", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
          }), this._input = t, this._options = Object(G.a)(Object(G.a)({
            credentials: this._input.credentials || "same-origin"
          }, o), {}, {
            headers: Di(this._input.headers, o.headers),
            hooks: Ii({
              beforeRequest: [],
              beforeRetry: [],
              beforeError: [],
              afterResponse: []
            }, o.hooks),
            method: qi(null != (e = o.method) ? e : this._input.method),
            prefixUrl: String(o.prefixUrl || ""),
            retry: Yi(o.retry),
            throwHttpErrors: !1 !== o.throwHttpErrors,
            timeout: "undefined" === typeof o.timeout ? 1e4 : o.timeout,
            fetch: null != (r = o.fetch) ? r : globalThis.fetch.bind(globalThis)
          }), "string" !== typeof this._input && !(this._input instanceof URL || this._input instanceof globalThis.Request)) throw new TypeError("`input` must be a string, URL, or Request");

          if (this._options.prefixUrl && "string" === typeof this._input) {
            if (this._input.startsWith("/")) throw new Error("`input` must not begin with a slash when using `prefixUrl`");
            this._options.prefixUrl.endsWith("/") || (this._options.prefixUrl += "/"), this._input = this._options.prefixUrl + this._input;
          }

          if (Ni) {
            if (this.abortController = new globalThis.AbortController(), this._options.signal) {
              var a = this._options.signal;

              this._options.signal.addEventListener("abort", function () {
                i.abortController.abort(a.reason);
              });
            }

            this._options.signal = this.abortController.signal;
          }

          if (Li && (this._options.duplex = "half"), this.request = new globalThis.Request(this._input, this._options), this._options.searchParams) {
            var s = "?" + ("string" === typeof this._options.searchParams ? this._options.searchParams.replace(/^\?/, "") : new URLSearchParams(this._options.searchParams).toString()),
                c = this.request.url.replace(/(?:\?.*?)?(?=#|$)/, s);
            !(Fi && this._options.body instanceof globalThis.FormData || this._options.body instanceof URLSearchParams) || this._options.headers && this._options.headers["content-type"] || this.request.headers.delete("content-type"), this.request = new globalThis.Request(new globalThis.Request(c, Object(G.a)({}, this.request)), this._options);
          }

          void 0 !== this._options.json && (this._options.body = JSON.stringify(this._options.json), this.request.headers.set("content-type", null != (n = this._options.headers.get("content-type")) ? n : "application/json"), this.request = new globalThis.Request(this.request, {
            body: this._options.body
          }));
        }

        return Object(N.a)(Ky, [{
          key: "_calculateRetryDelay",
          value: function _calculateRetryDelay(t) {
            if (this._retryCount++, this._retryCount < this._options.retry.limit && !(t instanceof Pi)) {
              if (t instanceof Mi) {
                if (!this._options.retry.statusCodes.includes(t.response.status)) return 0;
                var e = t.response.headers.get("Retry-After");

                if (e && this._options.retry.afterStatusCodes.includes(t.response.status)) {
                  var r = Number(e);
                  return Number.isNaN(r) ? r = Date.parse(e) - Date.now() : r *= 1e3, "undefined" !== typeof this._options.retry.maxRetryAfter && r > this._options.retry.maxRetryAfter ? 0 : r;
                }

                if (413 === t.response.status) return 0;
              }

              return Math.min(this._options.retry.backoffLimit, .3 * Math.pow(2, this._retryCount - 1) * 1e3);
            }

            return 0;
          }
        }, {
          key: "_decorateResponse",
          value: function _decorateResponse(t) {
            var e = this;
            return this._options.parseJson && (t.json = Object(v.a)(g.a.mark(function _callee() {
              return g.a.wrap(function _callee$(r) {
                for (;;) {
                  switch (r.prev = r.next) {
                    case 0:
                      return r.t0 = e._options, r.next = 3, t.text();

                    case 3:
                      return r.t1 = r.sent, r.abrupt("return", r.t0.parseJson.call(r.t0, r.t1));

                    case 5:
                    case "end":
                      return r.stop();
                  }
                }
              }, _callee);
            }))), t;
          }
        }, {
          key: "_retry",
          value: function () {
            var t = Object(v.a)(g.a.mark(function _callee2(t) {
              var e, r, n, i;
              return g.a.wrap(function _callee2$(o) {
                for (;;) {
                  switch (o.prev = o.next) {
                    case 0:
                      return o.prev = 0, o.next = 3, t();

                    case 3:
                      return o.abrupt("return", o.sent);

                    case 6:
                      if (o.prev = 6, o.t0 = o.catch(0), !(0 !== (e = Math.min(this._calculateRetryDelay(o.t0), 2147483647)) && this._retryCount > 0)) {
                        o.next = 33;
                        break;
                      }

                      return o.next = 12, delay(e, {
                        signal: this._options.signal
                      });

                    case 12:
                      r = Object(_.a)(this._options.hooks.beforeRetry), o.prev = 13, r.s();

                    case 15:
                      if ((n = r.n()).done) {
                        o.next = 24;
                        break;
                      }

                      return i = n.value, o.next = 19, i({
                        request: this.request,
                        options: this._options,
                        error: o.t0,
                        retryCount: this._retryCount
                      });

                    case 19:
                      if (o.sent !== zi) {
                        o.next = 22;
                        break;
                      }

                      return o.abrupt("return");

                    case 22:
                      o.next = 15;
                      break;

                    case 24:
                      o.next = 29;
                      break;

                    case 26:
                      o.prev = 26, o.t1 = o.catch(13), r.e(o.t1);

                    case 29:
                      return o.prev = 29, r.f(), o.finish(29);

                    case 32:
                      return o.abrupt("return", this._retry(t));

                    case 33:
                      throw o.t0;

                    case 34:
                    case "end":
                      return o.stop();
                  }
                }
              }, _callee2, this, [[0, 6], [13, 26, 29, 32]]);
            }));
            return function _retry(e) {
              return t.apply(this, arguments);
            };
          }()
        }, {
          key: "_fetch",
          value: function () {
            var t = Object(v.a)(g.a.mark(function _callee3() {
              var t, e, r, n;
              return g.a.wrap(function _callee3$(i) {
                for (;;) {
                  switch (i.prev = i.next) {
                    case 0:
                      t = Object(_.a)(this._options.hooks.beforeRequest), i.prev = 1, t.s();

                    case 3:
                      if ((e = t.n()).done) {
                        i.next = 15;
                        break;
                      }

                      return r = e.value, i.next = 7, r(this.request, this._options);

                    case 7:
                      if (!((n = i.sent) instanceof Request)) {
                        i.next = 11;
                        break;
                      }

                      return this.request = n, i.abrupt("break", 15);

                    case 11:
                      if (!(n instanceof Response)) {
                        i.next = 13;
                        break;
                      }

                      return i.abrupt("return", n);

                    case 13:
                      i.next = 3;
                      break;

                    case 15:
                      i.next = 20;
                      break;

                    case 17:
                      i.prev = 17, i.t0 = i.catch(1), t.e(i.t0);

                    case 20:
                      return i.prev = 20, t.f(), i.finish(20);

                    case 23:
                      if (!1 !== this._options.timeout) {
                        i.next = 25;
                        break;
                      }

                      return i.abrupt("return", this._options.fetch(this.request.clone()));

                    case 25:
                      return i.abrupt("return", timeout(this.request.clone(), this.abortController, this._options));

                    case 26:
                    case "end":
                      return i.stop();
                  }
                }
              }, _callee3, this, [[1, 17, 20, 23]]);
            }));
            return function _fetch() {
              return t.apply(this, arguments);
            };
          }()
        }, {
          key: "_stream",
          value: function _stream(t, e) {
            var r = Number(t.headers.get("content-length")) || 0,
                n = 0;
            return 204 === t.status ? (e && e({
              percent: 1,
              totalBytes: r,
              transferredBytes: n
            }, new Uint8Array()), new globalThis.Response(null, {
              status: t.status,
              statusText: t.statusText,
              headers: t.headers
            })) : new globalThis.Response(new globalThis.ReadableStream({
              start: function start(i) {
                return Object(v.a)(g.a.mark(function _callee5() {
                  var o, a, s;
                  return g.a.wrap(function _callee5$(c) {
                    for (;;) {
                      switch (c.prev = c.next) {
                        case 0:
                          return s = function _read3() {
                            return (s = Object(v.a)(g.a.mark(function _callee4() {
                              var t, s, c;
                              return g.a.wrap(function _callee4$(l) {
                                for (;;) {
                                  switch (l.prev = l.next) {
                                    case 0:
                                      return l.next = 2, o.read();

                                    case 2:
                                      if (t = l.sent, s = t.done, c = t.value, !s) {
                                        l.next = 8;
                                        break;
                                      }

                                      return i.close(), l.abrupt("return");

                                    case 8:
                                      return e && (n += c.byteLength, e({
                                        percent: 0 === r ? 0 : n / r,
                                        transferredBytes: n,
                                        totalBytes: r
                                      }, c)), i.enqueue(c), l.next = 12, a();

                                    case 12:
                                    case "end":
                                      return l.stop();
                                  }
                                }
                              }, _callee4);
                            }))).apply(this, arguments);
                          }, a = function _read2() {
                            return s.apply(this, arguments);
                          }, o = t.body.getReader(), e && e({
                            percent: 0,
                            transferredBytes: 0,
                            totalBytes: r
                          }, new Uint8Array()), c.next = 6, a();

                        case 6:
                        case "end":
                          return c.stop();
                      }
                    }
                  }, _callee5);
                }))();
              }
            }), {
              status: t.status,
              statusText: t.statusText,
              headers: t.headers
            });
          }
        }], [{
          key: "create",
          value: function create(t, e) {
            for (var r = new Ky(t, e), n = function () {
              var t = Object(v.a)(g.a.mark(function _callee6() {
                var t, e, n, i, o, a, s, c, l;
                return g.a.wrap(function _callee6$(u) {
                  for (;;) {
                    switch (u.prev = u.next) {
                      case 0:
                        if (!(r._options.timeout > 2147483647)) {
                          u.next = 2;
                          break;
                        }

                        throw new RangeError("The `timeout` option cannot be greater than ".concat(2147483647));

                      case 2:
                        return u.next = 4, Promise.resolve();

                      case 4:
                        return u.next = 6, r._fetch();

                      case 6:
                        t = u.sent, e = Object(_.a)(r._options.hooks.afterResponse), u.prev = 8, e.s();

                      case 10:
                        if ((n = e.n()).done) {
                          u.next = 18;
                          break;
                        }

                        return i = n.value, u.next = 14, i(r.request, r._options, r._decorateResponse(t.clone()));

                      case 14:
                        (o = u.sent) instanceof globalThis.Response && (t = o);

                      case 16:
                        u.next = 10;
                        break;

                      case 18:
                        u.next = 23;
                        break;

                      case 20:
                        u.prev = 20, u.t0 = u.catch(8), e.e(u.t0);

                      case 23:
                        return u.prev = 23, e.f(), u.finish(23);

                      case 26:
                        if (r._decorateResponse(t), t.ok || !r._options.throwHttpErrors) {
                          u.next = 48;
                          break;
                        }

                        a = new Mi(t, r.request, r._options), s = Object(_.a)(r._options.hooks.beforeError), u.prev = 30, s.s();

                      case 32:
                        if ((c = s.n()).done) {
                          u.next = 39;
                          break;
                        }

                        return l = c.value, u.next = 36, l(a);

                      case 36:
                        a = u.sent;

                      case 37:
                        u.next = 32;
                        break;

                      case 39:
                        u.next = 44;
                        break;

                      case 41:
                        u.prev = 41, u.t1 = u.catch(30), s.e(u.t1);

                      case 44:
                        return u.prev = 44, s.f(), u.finish(44);

                      case 47:
                        throw a;

                      case 48:
                        if (!r._options.onDownloadProgress) {
                          u.next = 54;
                          break;
                        }

                        if ("function" === typeof r._options.onDownloadProgress) {
                          u.next = 51;
                          break;
                        }

                        throw new TypeError("The `onDownloadProgress` option must be a function");

                      case 51:
                        if (Bi) {
                          u.next = 53;
                          break;
                        }

                        throw new Error("Streams are not supported in your environment. `ReadableStream` is missing.");

                      case 53:
                        return u.abrupt("return", r._stream(t.clone(), r._options.onDownloadProgress));

                      case 54:
                        return u.abrupt("return", t);

                      case 55:
                      case "end":
                        return u.stop();
                    }
                  }
                }, _callee6, null, [[8, 20, 23, 26], [30, 41, 44, 47]]);
              }));
              return function fn() {
                return t.apply(this, arguments);
              };
            }(), i = r._options.retry.methods.includes(r.request.method.toLowerCase()) ? r._retry(n) : n(), o = function _loop() {
              var t = Object(V.a)(s[a], 2),
                  n = t[0],
                  o = t[1];
              i[n] = Object(v.a)(g.a.mark(function _callee7() {
                var t, a, s;
                return g.a.wrap(function _callee7$(c) {
                  for (;;) {
                    switch (c.prev = c.next) {
                      case 0:
                        return r.request.headers.set("accept", r.request.headers.get("accept") || o), c.next = 3, i;

                      case 3:
                        if (t = c.sent, a = t.clone(), "json" !== n) {
                          c.next = 20;
                          break;
                        }

                        if (204 !== a.status) {
                          c.next = 8;
                          break;
                        }

                        return c.abrupt("return", "");

                      case 8:
                        return c.next = 10, a.clone().arrayBuffer();

                      case 10:
                        if (s = c.sent, 0 !== s.byteLength) {
                          c.next = 14;
                          break;
                        }

                        return c.abrupt("return", "");

                      case 14:
                        if (!e.parseJson) {
                          c.next = 20;
                          break;
                        }

                        return c.t0 = e, c.next = 18, a.text();

                      case 18:
                        return c.t1 = c.sent, c.abrupt("return", c.t0.parseJson.call(c.t0, c.t1));

                      case 20:
                        return c.abrupt("return", a[n]());

                      case 21:
                      case "end":
                        return c.stop();
                    }
                  }
                }, _callee7);
              }));
            }, a = 0, s = Object.entries(Wi); a < s.length; a++) {
              o();
            }

            return i;
          }
        }]), Ky;
      }(),
          $i = function createInstance(t) {
        var e,
            r = function ky2(e, r) {
          return Vi.create(e, Ri(t, r));
        },
            n = Object(_.a)(Ui);

        try {
          var i = function _loop2() {
            var n = e.value;

            r[n] = function (e, r) {
              return Vi.create(e, Ri(t, r, {
                method: n
              }));
            };
          };

          for (n.s(); !(e = n.n()).done;) {
            i();
          }
        } catch (o) {
          n.e(o);
        } finally {
          n.f();
        }

        return r.create = function (t) {
          return createInstance(Ri(t));
        }, r.extend = function (e) {
          return createInstance(Ri(t, e));
        }, r.stop = zi, r;
      }(),
          Qi = function createApiClient(t) {
        return $i.extend({
          prefixUrl: t,
          retry: {
            limit: 3,
            backoffLimit: 3e3,
            statusCodes: [408, 413, 429, 500, 502, 503, 504]
          },
          timeout: 6e4,
          headers: {
            Accept: "application/json, text/plain, text/csv, */*"
          },
          mode: "cors",
          hooks: {
            beforeRequest: [function (t) {
              var e = Ai.get("DrifttAuth");
              e && t.headers.set("Authorization", "Bearer ".concat(e));
            }]
          }
        });
      },
          Ki = Qi(Ti.CUBE_REPORTING_API),
          Zi = Qi(Ti.METRICS_API),
          Ji = function bulkSendMetrics(t) {
        return Zi.post("monitoring/metrics/add/bulk", {
          json: t
        });
      },
          to = function () {
        var t = Object(v.a)(g.a.mark(function _callee9(t) {
          return g.a.wrap(function _callee9$(e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  return e.abrupt("return", Ki.post("export/csv", {
                    json: {
                      query: t
                    },
                    parseJson: function parseJson(t) {
                      return {
                        csvData: t
                      };
                    }
                  }).json().catch(function (t) {
                    throw new Error("CUBE_REPORTING_API_CSV_EXPORT_FAILED", {
                      cause: t
                    });
                  }));

                case 1:
                case "end":
                  return e.stop();
              }
            }
          }, _callee9);
        }));
        return function getCubeCSVExport(e) {
          return t.apply(this, arguments);
        };
      }(),
          eo = Ti.logEnabled,
          ro = Ti.throwOnError,
          no = function log(t) {
        var e,
            r = t.type,
            n = void 0 === r ? "log" : r,
            i = t.data;
        eo && (e = console)[n].apply(e, ["DDS_REPORTS::"].concat(Object(E.a)(i)));
      },
          io = function error(t) {
        !function errorHandler(t) {
          if (ro) throw t;
          no({
            type: "warn",
            data: [t.message]
          });
        }(t instanceof Error ? t : new Error(t));
      },
          oo = function getBrowserTimezone() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "America/New_York";

        try {
          t = Intl.DateTimeFormat().resolvedOptions().timeZone;
        } catch (e) {
          no({
            data: "Could not fetch browser timezone"
          });
        }

        return t;
      },
          ao = ["measures", "filters", "dimensions", "timeDimensions"],
          so = function concatValues(t, e, r) {
        return ao.includes(t) ? Zt(e, r) : r;
      },
          co = function CubeQueryBuilder(t) {
        var e = this,
            r = t.query,
            n = void 0 === r ? {} : r;
        Object(W.a)(this, CubeQueryBuilder), this.withName = function (t) {
          return e.reportingQuery.name = t, e;
        }, this.withQueryName = function (t) {
          return e.reportingQuery.queryName = t, e;
        }, this.withFilters = function (t) {
          return e.localQuery.filters = t, e;
        }, this.withMeasures = function (t) {
          return e.localQuery.measures = t, e;
        }, this.withTimezone = function (t) {
          return e.localQuery.timezone = t, e;
        }, this.withBrowserTimezone = function () {
          return e.localQuery.timezone = oo(), e;
        }, this.withClosestPreaggregatedTimezone = function () {
          return e.withBrowserTimezone(), e;
        }, this.withDimensions = function (t) {
          return e.localQuery.dimensions = t, e;
        }, this.withTimeDimensions = function (t) {
          return e.localQuery.timeDimensions = t, e;
        }, this.withinDateRange = function (t, r, n, i) {
          var o = format(r, "yyyy-MM-dd"),
              a = format(n, "yyyy-MM-dd");
          return e.localQuery.timeDimensions = [{
            dimension: t,
            granularity: i,
            dateRange: [o, a]
          }], e;
        }, this.withOrder = function (t) {
          return e.localQuery.order = t, e;
        }, this.withLimit = function (t) {
          return e.localQuery.limit = t, e;
        }, this.withOffset = function (t) {
          return e.localQuery.offset = t, e;
        }, this.build = function () {
          return {
            name: e.reportingQuery.name,
            queryName: e.reportingQuery.queryName,
            query: Oe(so, e.reportingQuery.query, e.localQuery)
          };
        }, this.reportingQuery = n, this.localQuery = {};
      };

      new Uint8Array(16);

      for (var lo = [], uo = 0; uo < 256; ++uo) {
        lo.push((uo + 256).toString(16).substr(1));
      }

      var ho = {
        exports: {}
      },
          fo = ho.exports = function () {
        var t = "millisecond",
            e = "second",
            r = "minute",
            n = "hour",
            i = "day",
            o = "week",
            a = "month",
            s = "quarter",
            c = "year",
            l = "date",
            u = "Invalid Date",
            h = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,
            d = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,
            f = {
          name: "en",
          weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
          months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
          ordinal: function ordinal(t) {
            var e = ["th", "st", "nd", "rd"],
                r = t % 100;
            return "[" + t + (e[(r - 20) % 10] || e[r] || e[0]) + "]";
          }
        },
            y = function m4(t, e, r) {
          var n = String(t);
          return !n || n.length >= e ? t : "" + Array(e + 1 - n.length).join(r) + t;
        },
            g = {
          s: y,
          z: function z(t) {
            var e = -t.utcOffset(),
                r = Math.abs(e),
                n = Math.floor(r / 60),
                i = r % 60;
            return (e <= 0 ? "+" : "-") + y(n, 2, "0") + ":" + y(i, 2, "0");
          },
          m: function t4(t, e) {
            if (t.date() < e.date()) return -t4(e, t);
            var r = 12 * (e.year() - t.year()) + (e.month() - t.month()),
                n = t.clone().add(r, a),
                i = e - n < 0,
                o = t.clone().add(r + (i ? -1 : 1), a);
            return +(-(r + (e - n) / (i ? n - o : o - n)) || 0);
          },
          a: function a(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
          },
          p: function p(u) {
            return {
              M: a,
              y: c,
              w: o,
              d: i,
              D: l,
              h: n,
              m: r,
              s: e,
              ms: t,
              Q: s
            }[u] || String(u || "").toLowerCase().replace(/s$/, "");
          },
          u: function u(t) {
            return void 0 === t;
          }
        },
            m = "en",
            v = {};

        v[m] = f;

        var b = function p2(t) {
          return t instanceof O;
        },
            x = function t4(t, e, r) {
          var n;
          if (!t) return m;

          if ("string" == typeof t) {
            var i = t.toLowerCase();
            v[i] && (n = i), e && (v[i] = e, n = i);
            var o = t.split("-");
            if (!n && o.length > 1) return t4(o[0]);
          } else {
            var a = t.name;
            v[a] = t, n = a;
          }

          return !r && n && (m = n), n || !r && m;
        },
            w = function w2(t, e) {
          if (b(t)) return t.clone();
          var r = "object" == typeof e ? e : {};
          return r.date = t, r.args = arguments, new O(r);
        },
            S = g;

        S.l = x, S.i = b, S.w = function (t, e) {
          return w(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
          });
        };

        var O = function () {
          function M4(t) {
            this.$L = x(t.locale, null, !0), this.parse(t);
          }

          var f = M4.prototype;
          return f.parse = function (t) {
            this.$d = function (t) {
              var e = t.date,
                  r = t.utc;
              if (null === e) return new Date(NaN);
              if (S.u(e)) return new Date();
              if (e instanceof Date) return new Date(e);

              if ("string" == typeof e && !/Z$/i.test(e)) {
                var n = e.match(h);

                if (n) {
                  var i = n[2] - 1 || 0,
                      o = (n[7] || "0").substring(0, 3);
                  return r ? new Date(Date.UTC(n[1], i, n[3] || 1, n[4] || 0, n[5] || 0, n[6] || 0, o)) : new Date(n[1], i, n[3] || 1, n[4] || 0, n[5] || 0, n[6] || 0, o);
                }
              }

              return new Date(e);
            }(t), this.$x = t.x || {}, this.init();
          }, f.init = function () {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
          }, f.$utils = function () {
            return S;
          }, f.isValid = function () {
            return !(this.$d.toString() === u);
          }, f.isSame = function (t, e) {
            var r = w(t);
            return this.startOf(e) <= r && r <= this.endOf(e);
          }, f.isAfter = function (t, e) {
            return w(t) < this.startOf(e);
          }, f.isBefore = function (t, e) {
            return this.endOf(e) < w(t);
          }, f.$g = function (t, e, r) {
            return S.u(t) ? this[e] : this.set(r, t);
          }, f.unix = function () {
            return Math.floor(this.valueOf() / 1e3);
          }, f.valueOf = function () {
            return this.$d.getTime();
          }, f.startOf = function (t, s) {
            var u = this,
                h = !!S.u(s) || s,
                d = S.p(t),
                f = function l3(t, e) {
              var r = S.w(u.$u ? Date.UTC(u.$y, e, t) : new Date(u.$y, e, t), u);
              return h ? r : r.endOf(i);
            },
                p = function $2(t, e) {
              return S.w(u.toDate()[t].apply(u.toDate("s"), (h ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e)), u);
            },
                y = this.$W,
                g = this.$M,
                m = this.$D,
                v = "set" + (this.$u ? "UTC" : "");

            switch (d) {
              case c:
                return h ? f(1, 0) : f(31, 11);

              case a:
                return h ? f(1, g) : f(0, g + 1);

              case o:
                var b = this.$locale().weekStart || 0,
                    x = (y < b ? y + 7 : y) - b;
                return f(h ? m - x : m + (6 - x), g);

              case i:
              case l:
                return p(v + "Hours", 0);

              case n:
                return p(v + "Minutes", 1);

              case r:
                return p(v + "Seconds", 2);

              case e:
                return p(v + "Milliseconds", 3);

              default:
                return this.clone();
            }
          }, f.endOf = function (t) {
            return this.startOf(t, !1);
          }, f.$set = function (o, s) {
            var u,
                h = S.p(o),
                d = "set" + (this.$u ? "UTC" : ""),
                f = (u = {}, u[i] = d + "Date", u[l] = d + "Date", u[a] = d + "Month", u[c] = d + "FullYear", u[n] = d + "Hours", u[r] = d + "Minutes", u[e] = d + "Seconds", u[t] = d + "Milliseconds", u)[h],
                p = h === i ? this.$D + (s - this.$W) : s;

            if (h === a || h === c) {
              var y = this.clone().set(l, 1);
              y.$d[f](p), y.init(), this.$d = y.set(l, Math.min(this.$D, y.daysInMonth())).$d;
            } else f && this.$d[f](p);

            return this.init(), this;
          }, f.set = function (t, e) {
            return this.clone().$set(t, e);
          }, f.get = function (t) {
            return this[S.p(t)]();
          }, f.add = function (t, s) {
            var l,
                u = this;
            t = Number(t);

            var h = S.p(s),
                d = function y4(e) {
              var r = w(u);
              return S.w(r.date(r.date() + Math.round(e * t)), u);
            };

            if (h === a) return this.set(a, this.$M + t);
            if (h === c) return this.set(c, this.$y + t);
            if (h === i) return d(1);
            if (h === o) return d(7);
            var f = (l = {}, l[r] = 6e4, l[n] = 36e5, l[e] = 1e3, l)[h] || 1,
                p = this.$d.getTime() + t * f;
            return S.w(p, this);
          }, f.subtract = function (t, e) {
            return this.add(-1 * t, e);
          }, f.format = function (t) {
            var e = this,
                r = this.$locale();
            if (!this.isValid()) return r.invalidDate || u;

            var n = t || "YYYY-MM-DDTHH:mm:ssZ",
                i = S.z(this),
                o = this.$H,
                a = this.$m,
                s = this.$M,
                c = r.weekdays,
                l = r.months,
                h = function h5(t, r, i, o) {
              return t && (t[r] || t(e, n)) || i[r].slice(0, o);
            },
                f = function c3(t) {
              return S.s(o % 12 || 12, t, "0");
            },
                p = r.meridiem || function (t, e, r) {
              var n = t < 12 ? "AM" : "PM";
              return r ? n.toLowerCase() : n;
            },
                y = {
              YY: String(this.$y).slice(-2),
              YYYY: this.$y,
              M: s + 1,
              MM: S.s(s + 1, 2, "0"),
              MMM: h(r.monthsShort, s, l, 3),
              MMMM: h(l, s),
              D: this.$D,
              DD: S.s(this.$D, 2, "0"),
              d: String(this.$W),
              dd: h(r.weekdaysMin, this.$W, c, 2),
              ddd: h(r.weekdaysShort, this.$W, c, 3),
              dddd: c[this.$W],
              H: String(o),
              HH: S.s(o, 2, "0"),
              h: f(1),
              hh: f(2),
              a: p(o, a, !0),
              A: p(o, a, !1),
              m: String(a),
              mm: S.s(a, 2, "0"),
              s: String(this.$s),
              ss: S.s(this.$s, 2, "0"),
              SSS: S.s(this.$ms, 3, "0"),
              Z: i
            };

            return n.replace(d, function (t, e) {
              return e || y[t] || i.replace(":", "");
            });
          }, f.utcOffset = function () {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
          }, f.diff = function (t, l, u) {
            var h,
                d = S.p(l),
                f = w(t),
                p = 6e4 * (f.utcOffset() - this.utcOffset()),
                y = this - f,
                g = S.m(this, f);
            return g = (h = {}, h[c] = g / 12, h[a] = g, h[s] = g / 3, h[o] = (y - p) / 6048e5, h[i] = (y - p) / 864e5, h[n] = y / 36e5, h[r] = y / 6e4, h[e] = y / 1e3, h)[d] || y, u ? g : S.a(g);
          }, f.daysInMonth = function () {
            return this.endOf(a).$D;
          }, f.$locale = function () {
            return v[this.$L];
          }, f.locale = function (t, e) {
            if (!t) return this.$L;
            var r = this.clone(),
                n = x(t, e, !0);
            return n && (r.$L = n), r;
          }, f.clone = function () {
            return S.w(this.$d, this);
          }, f.toDate = function () {
            return new Date(this.valueOf());
          }, f.toJSON = function () {
            return this.isValid() ? this.toISOString() : null;
          }, f.toISOString = function () {
            return this.$d.toISOString();
          }, f.toString = function () {
            return this.$d.toUTCString();
          }, M4;
        }(),
            E = O.prototype;

        return w.prototype = E, [["$ms", t], ["$s", e], ["$m", r], ["$H", n], ["$W", i], ["$M", a], ["$y", c], ["$D", l]].forEach(function (t) {
          E[t[1]] = function (e) {
            return this.$g(e, t[0], t[1]);
          };
        }), w.extend = function (t, e) {
          return t.$i || (t(e, O, w), t.$i = !0), w;
        }, w.locale = x, w.isDayjs = b, w.unix = function (t) {
          return w(1e3 * t);
        }, w.en = v[m], w.Ls = v, w.p = {}, w;
      }(),
          po = {
        exports: {}
      },
          yo = po.exports = function () {
        var t = "month",
            e = "quarter";
        return function (r, n) {
          var i = n.prototype;

          i.quarter = function (t) {
            return this.$utils().u(t) ? Math.ceil((this.month() + 1) / 3) : this.month(this.month() % 3 + 3 * (t - 1));
          };

          var o = i.add;

          i.add = function (r, n) {
            return r = Number(r), this.$utils().p(n) === e ? this.add(3 * r, t) : o.bind(this)(r, n);
          };

          var a = i.startOf;

          i.startOf = function (r, n) {
            var i = this.$utils(),
                o = !!i.u(n) || n;

            if (i.p(r) === e) {
              var s = this.quarter() - 1;
              return o ? this.month(3 * s).startOf(t).startOf("day") : this.month(3 * s + 2).endOf(t).endOf("day");
            }

            return a.bind(this)(r, n);
          };
        };
      }(),
          go = {
        exports: {}
      },
          mo = go.exports = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function ordinal(t) {
          var e = ["th", "st", "nd", "rd"],
              r = t % 100;
          return "[" + t + (e[(r - 20) % 10] || e[r] || e[0]) + "]";
        }
      },
          vo = {
        exports: {}
      };

      !function (t, e) {
        var r,
            n = "undefined" !== typeof self ? self : De,
            i = function () {
          function F() {
            this.fetch = !1, this.DOMException = n.DOMException;
          }

          return F.prototype = n, new F();
        }();

        r = i, function (t) {
          var e = {
            searchParams: "URLSearchParams" in r,
            iterable: "Symbol" in r && "iterator" in Symbol,
            blob: "FileReader" in r && "Blob" in r && function () {
              try {
                return new Blob(), !0;
              } catch (ts) {
                return !1;
              }
            }(),
            formData: "FormData" in r,
            arrayBuffer: "ArrayBuffer" in r
          };
          if (e.arrayBuffer) var n = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"],
              i = ArrayBuffer.isView || function (t) {
            return t && n.indexOf(Object.prototype.toString.call(t)) > -1;
          };

          function normalizeName(t) {
            if ("string" !== typeof t && (t = String(t)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(t)) throw new TypeError("Invalid character in header field name");
            return t.toLowerCase();
          }

          function normalizeValue(t) {
            return "string" !== typeof t && (t = String(t)), t;
          }

          function iteratorFor(t) {
            var r = {
              next: function next() {
                var e = t.shift();
                return {
                  done: void 0 === e,
                  value: e
                };
              }
            };
            return e.iterable && (r[Symbol.iterator] = function () {
              return r;
            }), r;
          }

          function Headers(t) {
            this.map = {}, t instanceof Headers ? t.forEach(function (t, e) {
              this.append(e, t);
            }, this) : Array.isArray(t) ? t.forEach(function (t) {
              this.append(t[0], t[1]);
            }, this) : t && Object.getOwnPropertyNames(t).forEach(function (e) {
              this.append(e, t[e]);
            }, this);
          }

          function consumed(t) {
            if (t.bodyUsed) return Promise.reject(new TypeError("Already read"));
            t.bodyUsed = !0;
          }

          function fileReaderReady(t) {
            return new Promise(function (e, r) {
              t.onload = function () {
                e(t.result);
              }, t.onerror = function () {
                r(t.error);
              };
            });
          }

          function readBlobAsArrayBuffer(t) {
            var e = new FileReader(),
                r = fileReaderReady(e);
            return e.readAsArrayBuffer(t), r;
          }

          function bufferClone(t) {
            if (t.slice) return t.slice(0);
            var e = new Uint8Array(t.byteLength);
            return e.set(new Uint8Array(t)), e.buffer;
          }

          function Body() {
            return this.bodyUsed = !1, this._initBody = function (t) {
              this._bodyInit = t, t ? "string" === typeof t ? this._bodyText = t : e.blob && Blob.prototype.isPrototypeOf(t) ? this._bodyBlob = t : e.formData && FormData.prototype.isPrototypeOf(t) ? this._bodyFormData = t : e.searchParams && URLSearchParams.prototype.isPrototypeOf(t) ? this._bodyText = t.toString() : e.arrayBuffer && e.blob && function isDataView(t) {
                return t && DataView.prototype.isPrototypeOf(t);
              }(t) ? (this._bodyArrayBuffer = bufferClone(t.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : e.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(t) || i(t)) ? this._bodyArrayBuffer = bufferClone(t) : this._bodyText = t = Object.prototype.toString.call(t) : this._bodyText = "", this.headers.get("content-type") || ("string" === typeof t ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : e.searchParams && URLSearchParams.prototype.isPrototypeOf(t) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
            }, e.blob && (this.blob = function () {
              var t = consumed(this);
              if (t) return t;
              if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
              if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));
              if (this._bodyFormData) throw new Error("could not read FormData body as blob");
              return Promise.resolve(new Blob([this._bodyText]));
            }, this.arrayBuffer = function () {
              return this._bodyArrayBuffer ? consumed(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(readBlobAsArrayBuffer);
            }), this.text = function () {
              var t = consumed(this);
              if (t) return t;
              if (this._bodyBlob) return function readBlobAsText(t) {
                var e = new FileReader(),
                    r = fileReaderReady(e);
                return e.readAsText(t), r;
              }(this._bodyBlob);
              if (this._bodyArrayBuffer) return Promise.resolve(function readArrayBufferAsText(t) {
                for (var e = new Uint8Array(t), r = new Array(e.length), n = 0; n < e.length; n++) {
                  r[n] = String.fromCharCode(e[n]);
                }

                return r.join("");
              }(this._bodyArrayBuffer));
              if (this._bodyFormData) throw new Error("could not read FormData body as text");
              return Promise.resolve(this._bodyText);
            }, e.formData && (this.formData = function () {
              return this.text().then(decode2);
            }), this.json = function () {
              return this.text().then(JSON.parse);
            }, this;
          }

          Headers.prototype.append = function (t, e) {
            t = normalizeName(t), e = normalizeValue(e);
            var r = this.map[t];
            this.map[t] = r ? r + ", " + e : e;
          }, Headers.prototype.delete = function (t) {
            delete this.map[normalizeName(t)];
          }, Headers.prototype.get = function (t) {
            return t = normalizeName(t), this.has(t) ? this.map[t] : null;
          }, Headers.prototype.has = function (t) {
            return this.map.hasOwnProperty(normalizeName(t));
          }, Headers.prototype.set = function (t, e) {
            this.map[normalizeName(t)] = normalizeValue(e);
          }, Headers.prototype.forEach = function (t, e) {
            for (var r in this.map) {
              this.map.hasOwnProperty(r) && t.call(e, this.map[r], r, this);
            }
          }, Headers.prototype.keys = function () {
            var t = [];
            return this.forEach(function (e, r) {
              t.push(r);
            }), iteratorFor(t);
          }, Headers.prototype.values = function () {
            var t = [];
            return this.forEach(function (e) {
              t.push(e);
            }), iteratorFor(t);
          }, Headers.prototype.entries = function () {
            var t = [];
            return this.forEach(function (e, r) {
              t.push([r, e]);
            }), iteratorFor(t);
          }, e.iterable && (Headers.prototype[Symbol.iterator] = Headers.prototype.entries);
          var o = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];

          function Request2(t, e) {
            var r = (e = e || {}).body;

            if (t instanceof Request2) {
              if (t.bodyUsed) throw new TypeError("Already read");
              this.url = t.url, this.credentials = t.credentials, e.headers || (this.headers = new Headers(t.headers)), this.method = t.method, this.mode = t.mode, this.signal = t.signal, r || null == t._bodyInit || (r = t._bodyInit, t.bodyUsed = !0);
            } else this.url = String(t);

            if (this.credentials = e.credentials || this.credentials || "same-origin", !e.headers && this.headers || (this.headers = new Headers(e.headers)), this.method = function normalizeMethod(t) {
              var e = t.toUpperCase();
              return o.indexOf(e) > -1 ? e : t;
            }(e.method || this.method || "GET"), this.mode = e.mode || this.mode || null, this.signal = e.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && r) throw new TypeError("Body not allowed for GET or HEAD requests");

            this._initBody(r);
          }

          function decode2(t) {
            var e = new FormData();
            return t.trim().split("&").forEach(function (t) {
              if (t) {
                var r = t.split("="),
                    n = r.shift().replace(/\+/g, " "),
                    i = r.join("=").replace(/\+/g, " ");
                e.append(decodeURIComponent(n), decodeURIComponent(i));
              }
            }), e;
          }

          function parseHeaders(t) {
            var e = new Headers();
            return t.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function (t) {
              var r = t.split(":"),
                  n = r.shift().trim();

              if (n) {
                var i = r.join(":").trim();
                e.append(n, i);
              }
            }), e;
          }

          function Response2(t, e) {
            e || (e = {}), this.type = "default", this.status = void 0 === e.status ? 200 : e.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in e ? e.statusText : "OK", this.headers = new Headers(e.headers), this.url = e.url || "", this._initBody(t);
          }

          Request2.prototype.clone = function () {
            return new Request2(this, {
              body: this._bodyInit
            });
          }, Body.call(Request2.prototype), Body.call(Response2.prototype), Response2.prototype.clone = function () {
            return new Response2(this._bodyInit, {
              status: this.status,
              statusText: this.statusText,
              headers: new Headers(this.headers),
              url: this.url
            });
          }, Response2.error = function () {
            var t = new Response2(null, {
              status: 0,
              statusText: ""
            });
            return t.type = "error", t;
          };
          var a = [301, 302, 303, 307, 308];
          Response2.redirect = function (t, e) {
            if (-1 === a.indexOf(e)) throw new RangeError("Invalid status code");
            return new Response2(null, {
              status: e,
              headers: {
                location: t
              }
            });
          }, t.DOMException = r.DOMException;

          try {
            new t.DOMException();
          } catch (s) {
            t.DOMException = function (t, e) {
              this.message = t, this.name = e;
              var r = Error(t);
              this.stack = r.stack;
            }, t.DOMException.prototype = Object.create(Error.prototype), t.DOMException.prototype.constructor = t.DOMException;
          }

          function fetch2(r, n) {
            return new Promise(function (i, o) {
              var a = new Request2(r, n);
              if (a.signal && a.signal.aborted) return o(new t.DOMException("Aborted", "AbortError"));
              var s = new XMLHttpRequest();

              function abortXhr() {
                s.abort();
              }

              s.onload = function () {
                var t = {
                  status: s.status,
                  statusText: s.statusText,
                  headers: parseHeaders(s.getAllResponseHeaders() || "")
                };
                t.url = "responseURL" in s ? s.responseURL : t.headers.get("X-Request-URL");
                var e = "response" in s ? s.response : s.responseText;
                i(new Response2(e, t));
              }, s.onerror = function () {
                o(new TypeError("Network request failed"));
              }, s.ontimeout = function () {
                o(new TypeError("Network request failed"));
              }, s.onabort = function () {
                o(new t.DOMException("Aborted", "AbortError"));
              }, s.open(a.method, a.url, !0), "include" === a.credentials ? s.withCredentials = !0 : "omit" === a.credentials && (s.withCredentials = !1), "responseType" in s && e.blob && (s.responseType = "blob"), a.headers.forEach(function (t, e) {
                s.setRequestHeader(e, t);
              }), a.signal && (a.signal.addEventListener("abort", abortXhr), s.onreadystatechange = function () {
                4 === s.readyState && a.signal.removeEventListener("abort", abortXhr);
              }), s.send("undefined" === typeof a._bodyInit ? null : a._bodyInit);
            });
          }

          fetch2.polyfill = !0, r.fetch || (r.fetch = fetch2, r.Headers = Headers, r.Request = Request2, r.Response = Response2), t.Headers = Headers, t.Request = Request2, t.Response = Response2, t.fetch = fetch2, Object.defineProperty(t, "__esModule", {
            value: !0
          });
        }({}), i.fetch.ponyfill = !0, delete i.fetch.polyfill;
        var o = i;
        (e = o.fetch).default = o.fetch, e.fetch = o.fetch, e.Headers = o.Headers, e.Request = o.Request, e.Response = o.Response, t.exports = e;
      }(vo, vo.exports);
      !function (t) {
        var e = t.URLSearchParams && t.URLSearchParams.prototype.get ? t.URLSearchParams : null,
            r = e && "a=1" === new e({
          a: 1
        }).toString(),
            n = e && "+" === new e("s=%2B").get("s"),
            i = "__URLSearchParams__",
            o = !e || function () {
          var t = new e();
          return t.append("s", " &"), "s=+%26" === t.toString();
        }(),
            a = URLSearchParamsPolyfill.prototype,
            s = !(!t.Symbol || !t.Symbol.iterator);

        if (!(e && r && n && o)) {
          a.append = function (t, e) {
            appendTo(this[i], t, e);
          }, a.delete = function (t) {
            delete this[i][t];
          }, a.get = function (t) {
            var e = this[i];
            return t in e ? e[t][0] : null;
          }, a.getAll = function (t) {
            var e = this[i];
            return t in e ? e[t].slice(0) : [];
          }, a.has = function (t) {
            return t in this[i];
          }, a.set = function set(t, e) {
            this[i][t] = ["" + e];
          }, a.toString = function () {
            var t,
                e,
                r,
                n,
                o = this[i],
                a = [];

            for (e in o) {
              for (r = encode3(e), t = 0, n = o[e]; t < n.length; t++) {
                a.push(r + "=" + encode3(n[t]));
              }
            }

            return a.join("&");
          };
          var c = !!n && e && !r && t.Proxy;
          Object.defineProperty(t, "URLSearchParams", {
            value: c ? new Proxy(e, {
              construct: function construct(t, e) {
                return new t(new URLSearchParamsPolyfill(e[0]).toString());
              }
            }) : URLSearchParamsPolyfill
          });
          var l = t.URLSearchParams.prototype;
          l.polyfill = !0, l.forEach = l.forEach || function (t, e) {
            var r = parseToDict(this.toString());
            Object.getOwnPropertyNames(r).forEach(function (n) {
              r[n].forEach(function (r) {
                t.call(e, r, n, this);
              }, this);
            }, this);
          }, l.sort = l.sort || function () {
            var t,
                e,
                r,
                n = parseToDict(this.toString()),
                i = [];

            for (t in n) {
              i.push(t);
            }

            for (i.sort(), e = 0; e < i.length; e++) {
              this.delete(i[e]);
            }

            for (e = 0; e < i.length; e++) {
              var o = i[e],
                  a = n[o];

              for (r = 0; r < a.length; r++) {
                this.append(o, a[r]);
              }
            }
          }, l.keys = l.keys || function () {
            var t = [];
            return this.forEach(function (e, r) {
              t.push(r);
            }), makeIterator(t);
          }, l.values = l.values || function () {
            var t = [];
            return this.forEach(function (e) {
              t.push(e);
            }), makeIterator(t);
          }, l.entries = l.entries || function () {
            var t = [];
            return this.forEach(function (e, r) {
              t.push([r, e]);
            }), makeIterator(t);
          }, s && (l[t.Symbol.iterator] = l[t.Symbol.iterator] || l.entries);
        }

        function URLSearchParamsPolyfill(t) {
          ((t = t || "") instanceof URLSearchParams || t instanceof URLSearchParamsPolyfill) && (t = t.toString()), this[i] = parseToDict(t);
        }

        function encode3(t) {
          var e = {
            "!": "%21",
            "'": "%27",
            "(": "%28",
            ")": "%29",
            "~": "%7E",
            "%20": "+",
            "%00": "\0"
          };
          return encodeURIComponent(t).replace(/[!'\(\)~]|%20|%00/g, function (t) {
            return e[t];
          });
        }

        function decode2(t) {
          return t.replace(/[ +]/g, "%20").replace(/(%[a-f0-9]{2})+/gi, function (t) {
            return decodeURIComponent(t);
          });
        }

        function makeIterator(e) {
          var r = {
            next: function next() {
              var t = e.shift();
              return {
                done: void 0 === t,
                value: t
              };
            }
          };
          return s && (r[t.Symbol.iterator] = function () {
            return r;
          }), r;
        }

        function parseToDict(t) {
          var e = {};
          if ("object" === typeof t) {
            if (isArray2(t)) for (var r = 0; r < t.length; r++) {
              var n = t[r];
              if (!isArray2(n) || 2 !== n.length) throw new TypeError("Failed to construct 'URLSearchParams': Sequence initializer must only contain pair elements");
              appendTo(e, n[0], n[1]);
            } else for (var i in t) {
              t.hasOwnProperty(i) && appendTo(e, i, t[i]);
            }
          } else {
            0 === t.indexOf("?") && (t = t.slice(1));

            for (var o = t.split("&"), a = 0; a < o.length; a++) {
              var s = o[a],
                  c = s.indexOf("=");
              -1 < c ? appendTo(e, decode2(s.slice(0, c)), decode2(s.slice(c + 1))) : s && appendTo(e, decode2(s), "");
            }
          }
          return e;
        }

        function appendTo(t, e, r) {
          var n = "string" === typeof r ? r : null !== r && void 0 !== r && "function" === typeof r.toString ? r.toString() : JSON.stringify(r);
          e in t ? t[e].push(n) : t[e] = [n];
        }

        function isArray2(t) {
          return !!t && "[object Array]" === Object.prototype.toString.call(t);
        }
      }("undefined" !== typeof De ? De : "undefined" !== typeof window ? window : De);
      var bo = "day";

      function removeEmptyQueryFields(t) {
        return ue(je(t || {}).map(function (t) {
          var e = Object(V.a)(t, 2),
              r = e[0],
              n = e[1];
          if (["measures", "dimensions", "segments", "timeDimensions", "filters"].includes(r) && Array.isArray(n) && 0 === n.length) return null;

          if ("order" === r && n) {
            if (Array.isArray(n) && !n.length) return null;
            if (!Object.keys(n).length) return null;
          }

          return [r, n];
        }).filter(Boolean));
      }

      function defaultOrder(t) {
        var e = (t.timeDimensions || []).find(function (t) {
          return t.granularity;
        });
        return e ? Object(F.a)({}, e.dimension, "asc") : (t.measures || []).length > 0 && (t.dimensions || []).length > 0 ? Object(F.a)({}, t.measures[0], "desc") : (t.dimensions || []).length > 0 ? Object(F.a)({}, t.dimensions[0], "asc") : {};
      }

      function _defaultHeuristics(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = arguments.length > 2 ? arguments[2] : void 0,
            n = Bt(t),
            i = n.query,
            o = Object(U.a)(n, tt),
            a = r.meta,
            s = r.sessionGranularity || bo,
            c = Object(G.a)({
          query: i
        }, o),
            l = null;
        if (function areQueriesEqual() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return Gt(Object.entries(t && t.order || {}), Object.entries(e && e.order || {})) && Gt(t, e);
        }(i, e) || (l = i), Array.isArray(l) || Array.isArray(e)) return t;

        if (l) {
          if (1 === (e.timeDimensions || []).length && 1 === (l.timeDimensions || []).length && l.timeDimensions[0].granularity && e.timeDimensions[0].granularity !== l.timeDimensions[0].granularity && (c = Object(G.a)(Object(G.a)({}, c), {}, {
            sessionGranularity: l.timeDimensions[0].granularity
          })), 0 === (e.measures || []).length && (l.measures || []).length > 0 || 1 === (e.measures || []).length && 1 === (l.measures || []).length && e.measures[0] !== l.measures[0]) {
            var u = l.timeDimensions || [],
                h = Object(V.a)(u, 1)[0],
                d = a.defaultTimeDimensionNameFor(l.measures[0]);
            return l = Object(G.a)(Object(G.a)({}, l), {}, {
              timeDimensions: d ? [{
                dimension: d,
                granularity: h && h.granularity || s,
                dateRange: h && h.dateRange
              }] : []
            }), Object(G.a)(Object(G.a)({}, c), {}, {
              pivotConfig: null,
              shouldApplyHeuristicOrder: !0,
              query: l,
              chartType: d ? "line" : "number"
            });
          }

          return 0 === (e.dimensions || []).length && (l.dimensions || []).length > 0 ? (l = Object(G.a)(Object(G.a)({}, l), {}, {
            timeDimensions: (l.timeDimensions || []).map(function (t) {
              return Object(G.a)(Object(G.a)({}, t), {}, {
                granularity: void 0
              });
            })
          }), Object(G.a)(Object(G.a)({}, c), {}, {
            pivotConfig: null,
            shouldApplyHeuristicOrder: !0,
            query: l,
            chartType: "table"
          })) : (e.dimensions || []).length > 0 && 0 === (l.dimensions || []).length ? (l = Object(G.a)(Object(G.a)({}, l), {}, {
            timeDimensions: (l.timeDimensions || []).map(function (t) {
              return Object(G.a)(Object(G.a)({}, t), {}, {
                granularity: t.granularity || s
              });
            })
          }), Object(G.a)(Object(G.a)({}, c), {}, {
            pivotConfig: null,
            shouldApplyHeuristicOrder: !0,
            query: l,
            chartType: (l.timeDimensions || []).length ? "line" : "number"
          })) : ((e.dimensions || []).length > 0 || (e.measures || []).length > 0) && 0 === (l.dimensions || []).length && 0 === (l.measures || []).length ? (l = Object(G.a)(Object(G.a)({}, l), {}, {
            timeDimensions: [],
            filters: []
          }), Object(G.a)(Object(G.a)({}, c), {}, {
            pivotConfig: null,
            shouldApplyHeuristicOrder: !0,
            query: l,
            sessionGranularity: null
          })) : c;
        }

        if (c.chartType) {
          var f = c.chartType;

          if (("line" === f || "area" === f) && 1 === (e.timeDimensions || []).length && !e.timeDimensions[0].granularity) {
            var p = Object(V.a)(e.timeDimensions, 1)[0];
            return Object(G.a)(Object(G.a)({}, c), {}, {
              pivotConfig: null,
              query: Object(G.a)(Object(G.a)({}, e), {}, {
                timeDimensions: [Object(G.a)(Object(G.a)({}, p), {}, {
                  granularity: s
                })]
              })
            });
          }

          if (("pie" === f || "table" === f || "number" === f) && 1 === (e.timeDimensions || []).length && e.timeDimensions[0].granularity) {
            var y = Object(V.a)(e.timeDimensions, 1)[0];
            return Object(G.a)(Object(G.a)({}, c), {}, {
              pivotConfig: null,
              shouldApplyHeuristicOrder: !0,
              query: Object(G.a)(Object(G.a)({}, e), {}, {
                timeDimensions: [Object(G.a)(Object(G.a)({}, y), {}, {
                  granularity: void 0
                })]
              })
            });
          }
        }

        return c;
      }

      function _isQueryPresent(t) {
        return !!t && (Array.isArray(t) ? t : [t]).every(function (t) {
          return t.measures && t.measures.length || t.dimensions && t.dimensions.length || t.timeDimensions && t.timeDimensions.length;
        });
      }

      function movePivotItem(t, e, r, n, i) {
        var o = Object(G.a)(Object(G.a)({}, t), {}, {
          x: Object(E.a)(t.x),
          y: Object(E.a)(t.y)
        }),
            a = t[n][e],
            s = o[i].length - 1;
        return "measures" === a ? r = s + 1 : r >= s && "measures" === o[i][s] && (r = s - 1), o[n].splice(e, 1), o[i].splice(r, 0, a), o;
      }

      function flattenFilters() {
        return (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : []).reduce(function (t, e) {
          return e.or || e.and ? [].concat(Object(E.a)(t), Object(E.a)(flattenFilters(e.or || e.and))) : [].concat(Object(E.a)(t), [e]);
        }, []);
      }

      function aliasSeries(t, e, r, n) {
        var i = t.filter(function (t) {
          return null != t;
        });
        return r && r.aliasSeries && r.aliasSeries[e] ? [r.aliasSeries[e]].concat(Object(E.a)(i)) : n.has(i[0]) ? [e].concat(Object(E.a)(i)) : i;
      }

      fo.extend(yo);

      var xo = function internalDayjs() {
        return fo.apply(void 0, arguments).locale(Object(G.a)(Object(G.a)({}, mo), {}, {
          weekStart: 1
        }));
      },
          wo = {
        day: function day(t) {
          return t.by("d").map(function (t) {
            return t.format("YYYY-MM-DDT00:00:00.000");
          });
        },
        month: function month(t) {
          return t.snapTo("month").by("M").map(function (t) {
            return t.format("YYYY-MM-01T00:00:00.000");
          });
        },
        year: function year(t) {
          return t.snapTo("year").by("y").map(function (t) {
            return t.format("YYYY-01-01T00:00:00.000");
          });
        },
        hour: function hour(t) {
          return t.by("h").map(function (t) {
            return t.format("YYYY-MM-DDTHH:00:00.000");
          });
        },
        minute: function minute(t) {
          return t.by("m").map(function (t) {
            return t.format("YYYY-MM-DDTHH:mm:00.000");
          });
        },
        second: function second(t) {
          return t.by("s").map(function (t) {
            return t.format("YYYY-MM-DDTHH:mm:ss.000");
          });
        },
        week: function week(t) {
          return t.snapTo("week").by("w").map(function (t) {
            return t.startOf("week").format("YYYY-MM-DDT00:00:00.000");
          });
        },
        quarter: function quarter(t) {
          return t.snapTo("quarter").by("quarter").map(function (t) {
            return t.startOf("quarter").format("YYYY-MM-DDT00:00:00.000");
          });
        }
      },
          So = /^\d\d\d\d-\d\d-\d\d$/,
          Oo = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z?$/,
          Eo = function unnest(t) {
        var e = [];
        return t.forEach(function (t) {
          t.forEach(function (t) {
            return e.push(t);
          });
        }), e;
      },
          ko = function dayRange(t, e) {
        return {
          by: function by(r) {
            for (var n = [], i = xo(t), o = xo(e); i.isBefore(o) || i.isSame(o);) {
              n.push(i), i = i.add(1, r);
            }

            return n;
          },
          snapTo: function snapTo(r) {
            return dayRange(xo(t).startOf(r), xo(e).endOf(r));
          },
          start: xo(t),
          end: xo(e)
        };
      },
          _o = {
        REGULAR_QUERY: "regularQuery",
        COMPARE_DATE_RANGE_QUERY: "compareDateRangeQuery",
        BLENDING_QUERY: "blendingQuery"
      },
          Co = function () {
        function ResultSet(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          if (Object(W.a)(this, ResultSet), this.loadResponse = t, null != this.loadResponse.queryType ? (this.queryType = t.queryType, this.loadResponses = t.results) : (this.queryType = _o.REGULAR_QUERY, this.loadResponse.pivotQuery = Object(G.a)(Object(G.a)({}, t.query), {}, {
            queryType: this.queryType
          }), this.loadResponses = [t]), !Object.values(_o).includes(this.queryType)) throw new Error("Unknown query type");
          this.parseDateMeasures = e.parseDateMeasures, this.options = e, this.backwardCompatibleData = [];
        }

        return Object(N.a)(ResultSet, [{
          key: "drillDown",
          value: function drillDown(t, e) {
            if (this.queryType === _o.COMPARE_DATE_RANGE_QUERY) throw new Error("compareDateRange drillDown query is not currently supported");
            if (this.queryType === _o.BLENDING_QUERY) throw new Error("Data blending drillDown query is not currently supported");
            var r = this.loadResponses[0].query,
                n = t.xValues,
                i = void 0 === n ? [] : n,
                o = t.yValues,
                a = void 0 === o ? [] : o,
                s = this.normalizePivotConfig(e),
                c = [];
            s.x.forEach(function (t, e) {
              return c.push([t, i[e]]);
            }), s.y.forEach(function (t, e) {
              return c.push([t, a[e]]);
            });
            var l = this.query(),
                u = l.filters,
                h = void 0 === u ? [] : u,
                d = l.segments,
                f = void 0 === d ? [] : d,
                p = this.loadResponses[0].annotation.measures,
                y = c.find(function (t) {
              return "measures" === Object(V.a)(t, 1)[0];
            }) || [],
                g = Object(V.a)(y, 2)[1];

            if (void 0 === g) {
              var m = Object.keys(p);
              g = Object(V.a)(m, 1)[0];
            }

            if (!(p[g] && p[g].drillMembers || []).length) return null;
            var v = [{
              member: g,
              operator: "measureFilter"
            }].concat(Object(E.a)(h)),
                b = [];
            return c.filter(function (t) {
              return "measures" !== Object(V.a)(t, 1)[0];
            }).forEach(function (t) {
              var e = Object(V.a)(t, 2),
                  n = e[0],
                  i = e[1],
                  o = n.split("."),
                  a = Object(V.a)(o, 3),
                  s = a[0],
                  c = a[1],
                  l = a[2];

              if (void 0 !== l) {
                var u = ko(i, i).snapTo(l),
                    h = r.timeDimensions.find(function (t) {
                  return t.dimension;
                }),
                    d = [u.start, u.end];

                if (h) {
                  var f = Object(V.a)(h.dateRange, 2),
                      p = f[0],
                      y = f[1];
                  d = [fo(p) > u.start ? fo(p) : u.start, fo(y) < u.end ? fo(y) : u.end];
                }

                b.push({
                  dimension: [s, c].join("."),
                  dateRange: d.map(function (t) {
                    return t.format("YYYY-MM-DDTHH:mm:ss.SSS");
                  })
                });
              } else null == i ? v.push({
                member: n,
                operator: "notSet"
              }) : v.push({
                member: n,
                operator: "equals",
                values: [i.toString()]
              });
            }), 0 === b.length && r.timeDimensions.length > 0 && null == r.timeDimensions[0].granularity && b.push(r.timeDimensions[0]), Object(G.a)(Object(G.a)(Object(G.a)({}, p[g].drillMembersGrouped), {}, {
              filters: v
            }, f.length > 0 ? {
              segments: f
            } : {}), {}, {
              timeDimensions: b,
              segments: f,
              timezone: r.timezone
            });
          }
        }, {
          key: "series",
          value: function series(t) {
            var e = this;
            return this.seriesNames(t).map(function (r) {
              var n = r.title,
                  i = r.shortTitle,
                  o = r.key;
              return {
                title: n,
                shortTitle: i,
                key: o,
                series: e.chartPivot(t).map(function (t) {
                  var e = t.x;
                  return {
                    value: Object(U.a)(t, et)[o],
                    x: e
                  };
                })
              };
            });
          }
        }, {
          key: "axisValues",
          value: function axisValues(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                r = this.loadResponses[e].query;
            return function (e) {
              var n = function value(r) {
                return t.filter(function (t) {
                  return "measures" !== t;
                }).map(function (t) {
                  return null != e[t] ? e[t] : null;
                }).concat(r ? [r] : []);
              };

              return t.find(function (t) {
                return "measures" === t;
              }) && (r.measures || []).length ? r.measures.map(n) : [n()];
            };
          }
        }, {
          key: "axisValuesString",
          value: function axisValuesString(t, e) {
            return t.map(function formatValue(t) {
              return null == t ? "\u2205" : "" === t ? "[Empty string]" : t;
            }).join(e || ", ");
          }
        }, {
          key: "normalizePivotConfig",
          value: function normalizePivotConfig(t) {
            return ResultSet.getNormalizedPivotConfig(this.loadResponse.pivotQuery, t);
          }
        }, {
          key: "timeSeries",
          value: function timeSeries(t, e) {
            if (!t.granularity) return null;
            var r = t.dateRange;

            if (!r) {
              var n = ResultSet.timeDimensionMember(t),
                  i = pipe(Ct(function (t) {
                return t[n] && xo(t[n]);
              }), $t(Boolean))(this.timeDimensionBackwardCompatibleData(e));
              r = i.length && [Dt(_e(function (t) {
                return t.toDate();
              }), i[0], i), Dt(xe(function (t) {
                return t.toDate();
              }), i[0], i)] || null;
            }

            if (!r) return null;
            var o = t.dateRange ? t.dateRange.find(function (t) {
              return t.match(So);
            }) : !["hour", "minute", "second"].includes(t.granularity),
                a = r,
                s = Object(V.a)(a, 2),
                c = s[0],
                l = s[1],
                u = ko(c, l);
            if (!wo[t.granularity]) throw new Error("Unsupported time granularity: ".concat(t.granularity));
            return wo[t.granularity](o ? u.snapTo("d") : u);
          }
        }, {
          key: "pivot",
          value: function pivot(t) {
            var e = this;
            t = this.normalizePivotConfig(t);

            var r = this.loadResponse.pivotQuery,
                n = function pivotImpl() {
              var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
                  i = function groupByToPairs(t) {
                var e = new Map();
                return function (r) {
                  return r.forEach(function (r) {
                    var n = t(r);
                    e.has(n) || e.set(n, []), e.get(n).push(r);
                  }), Array.from(e.entries());
                };
              }(function (t) {
                var r = t.xValues;
                return e.axisValuesString(r);
              }),
                  o = function measureValue(t, e) {
                return t[e] || 0;
              };

              if (t.fillMissingDates && 1 === t.x.length && Gt(t.x, (r.timeDimensions || []).filter(function (t) {
                return Boolean(t.granularity);
              }).map(function (t) {
                return ResultSet.timeDimensionMember(t);
              }))) {
                var a = e.loadResponses.map(function (t) {
                  return e.timeSeries(t.query.timeDimensions[0], n);
                });
                a[0] && (i = function groupByXAxis(t) {
                  var e = he(function (t) {
                    return t.xValues[0];
                  }, t);
                  return a[n].map(function (t) {
                    return [t, e[t] || [{
                      xValues: [t],
                      row: {}
                    }]];
                  });
                });
              }

              var s = pipe(Ct(function (r) {
                return e.axisValues(t.x, n)(r).map(function (t) {
                  return {
                    xValues: t,
                    row: r
                  };
                });
              }), Eo, i)(e.timeDimensionBackwardCompatibleData(n)),
                  c = {};
              s.forEach(function (r) {
                Object(V.a)(r, 2)[1].forEach(function (r) {
                  var i = r.row;
                  e.axisValues(t.y, n)(i).forEach(function (t) {
                    Object.keys(i).length > 0 && (c[t.join()] = t);
                  });
                });
              });
              var l = Object.values(c),
                  u = Boolean(t.x.find(function (t) {
                return "measures" === t;
              }));
              return s.map(function (r) {
                var i = Object(V.a)(r, 2)[1],
                    a = i[0].xValues,
                    s = {};
                return i.forEach(function (r) {
                  var i = r.row;
                  e.axisValues(t.y, n)(i).map(function (t) {
                    return {
                      yValues: t,
                      row: i
                    };
                  }).forEach(function (t) {
                    s[e.axisValuesString(t.yValues)] = t;
                  });
                }), {
                  xValues: a,
                  yValuesArray: Eo(l.map(function (t) {
                    var r = u ? ResultSet.measureFromAxis(a) : ResultSet.measureFromAxis(t);
                    return [[t, o((s[e.axisValuesString(t)] || {
                      row: {}
                    }).row, r)]];
                  }))
                };
              });
            },
                i = this.loadResponses.length > 1 ? this.loadResponses.map(function (t, e) {
              return n(e);
            }) : [];

            return i.length ? this.mergePivots(i, t.joinDateRange) : n();
          }
        }, {
          key: "mergePivots",
          value: function mergePivots(t, e) {
            var r = t.reduce(function (t, e) {
              return null != t && e.length >= t.length ? t : e;
            }, null);
            return r.map(function (n, i) {
              return {
                xValues: e ? [t.map(function (t) {
                  return t[i] && t[i].xValues || [];
                }).join(", ")] : r[i].xValues,
                yValuesArray: Eo(t.map(function (t) {
                  return t[i].yValuesArray;
                }))
              };
            });
          }
        }, {
          key: "pivotedRows",
          value: function pivotedRows(t) {
            return this.chartPivot(t);
          }
        }, {
          key: "chartPivot",
          value: function chartPivot(t) {
            var e = this,
                r = new Set();
            this.queryType === _o.BLENDING_QUERY && le(this.loadResponses.map(function (t) {
              return t.query.measures;
            })).filter(function (t, e, r) {
              return r.indexOf(t) !== e;
            }).forEach(function (t) {
              return r.add(t);
            });
            return this.pivot(t).map(function (n) {
              var i = n.xValues,
                  o = n.yValuesArray,
                  a = {};
              return o.forEach(function (n, i) {
                var o = Object(V.a)(n, 2),
                    s = o[0],
                    c = o[1];

                a[e.axisValuesString(aliasSeries(s, i, t, r), ",")] = c && function validate2(t) {
                  return e.parseDateMeasures && Oo.test(t) ? new Date(t) : Number.isNaN(Number.parseFloat(t)) ? t : Number.parseFloat(t);
                }(c);
              }), Object(G.a)({
                x: e.axisValuesString(i, ","),
                xValues: i
              }, a);
            });
          }
        }, {
          key: "tablePivot",
          value: function tablePivot(t) {
            var e = this.normalizePivotConfig(t || {}),
                r = e.x.concat(e.y).includes("measures");
            return this.pivot(e).map(function (t) {
              var n = t.xValues,
                  i = t.yValuesArray;
              return ue(e.x.map(function (t, e) {
                return [t, n[e]];
              }).concat(r ? i.map(function (t) {
                var e = Object(V.a)(t, 2),
                    r = e[0],
                    n = e[1];
                return [r.length ? r.join() : "value", n];
              }) : []));
            });
          }
        }, {
          key: "tableColumns",
          value: function tableColumns(t) {
            var e = this.normalizePivotConfig(t || {}),
                r = pipe(Rt("annotation"), Dt(Ee(), {}))(this.loadResponses),
                n = Object.values(r).reduce(function (t, e) {
              return Object(G.a)(Object(G.a)({}, t), e);
            }, {}),
                i = {},
                o = function extractFields(t) {
              var e = n[t] || {};
              return {
                key: t,
                title: e.title,
                shortTitle: e.shortTitle,
                type: e.type,
                format: e.format,
                meta: e.meta
              };
            },
                a = this.pivot(e);

            (a[0] && a[0].yValuesArray || []).forEach(function (t) {
              var r = Object(V.a)(t, 1)[0];

              if (r.length > 0) {
                var n = i;
                r.forEach(function (t, r) {
                  n["_".concat(t)] = {
                    key: t,
                    memberId: "measures" === e.y[r] ? t : e.y[r],
                    children: n["_".concat(t)] && n["_".concat(t)].children || {}
                  }, n = n["_".concat(t)].children;
                });
              }
            });
            var s = [];
            return !a.length && e.y.includes("measures") && (s = (this.loadResponses[0].query.measures || []).map(function (t) {
              return Object(G.a)(Object(G.a)({}, o(t)), {}, {
                dataIndex: t
              });
            })), !e.y.length && e.x.includes("measures") && s.push({
              key: "value",
              dataIndex: "value",
              title: "Value",
              shortTitle: "Value",
              type: "string"
            }), e.x.map(function (t) {
              return "measures" === t ? {
                key: "measures",
                dataIndex: "measures",
                title: "Measures",
                shortTitle: "Measures",
                type: "string"
              } : Object(G.a)(Object(G.a)({}, o(t)), {}, {
                dataIndex: t
              });
            }).concat(function toColumns() {
              var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                  e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
              return 0 === Object.keys(t).length ? [] : Object.values(t).map(function (t) {
                var r = t.key,
                    n = Object(U.a)(t, rt),
                    i = toColumns(n.children, [].concat(Object(E.a)(e), [r])),
                    a = o(n.memberId),
                    s = a.title,
                    c = a.shortTitle,
                    l = Object(U.a)(a, nt),
                    u = r !== n.memberId || null == s ? r : "";
                return i.length ? Object(G.a)(Object(G.a)({}, l), {}, {
                  key: r,
                  title: [s, u].join(" ").trim(),
                  shortTitle: u || c,
                  children: i
                }) : Object(G.a)(Object(G.a)({}, l), {}, {
                  key: r,
                  dataIndex: [].concat(Object(E.a)(e), [r]).join(),
                  title: [s, u].join(" ").trim(),
                  shortTitle: u || c
                });
              });
            }(i)).concat(s);
          }
        }, {
          key: "totalRow",
          value: function totalRow(t) {
            return this.chartPivot(t)[0];
          }
        }, {
          key: "categories",
          value: function categories(t) {
            return this.chartPivot(t);
          }
        }, {
          key: "seriesNames",
          value: function seriesNames(t) {
            var e = this;
            t = this.normalizePivotConfig(t);
            var r = pipe(Rt("annotation"), Rt("measures"), we)(this.loadResponses),
                seriesNames = Eo(this.loadResponses.map(function (r, n) {
              return pipe(Ct(e.axisValues(t.y, n)), Eo, ye)(e.timeDimensionBackwardCompatibleData(n));
            })),
                n = new Set();
            this.queryType === _o.BLENDING_QUERY && le(this.loadResponses.map(function (t) {
              return t.query.measures;
            })).filter(function (t, e, r) {
              return r.indexOf(t) !== e;
            }).forEach(function (t) {
              return n.add(t);
            });
            return seriesNames.map(function (i, o) {
              var a = aliasSeries(i, o, t, n);
              return {
                title: e.axisValuesString(t.y.find(function (t) {
                  return "measures" === t;
                }) ? se(1, a).concat(r[ResultSet.measureFromAxis(i)].title) : a, ", "),
                shortTitle: e.axisValuesString(t.y.find(function (t) {
                  return "measures" === t;
                }) ? se(1, a).concat(r[ResultSet.measureFromAxis(i)].shortTitle) : a, ", "),
                key: e.axisValuesString(a, ","),
                yValues: i
              };
            });
          }
        }, {
          key: "query",
          value: function query() {
            if (this.queryType !== _o.REGULAR_QUERY) throw new Error("Method is not supported for a '".concat(this.queryType, "' query type. Please use decompose"));
            return this.loadResponses[0].query;
          }
        }, {
          key: "pivotQuery",
          value: function pivotQuery() {
            return this.loadResponse.pivotQuery || null;
          }
        }, {
          key: "rawData",
          value: function rawData() {
            if (this.queryType !== _o.REGULAR_QUERY) throw new Error("Method is not supported for a '".concat(this.queryType, "' query type. Please use decompose"));
            return this.loadResponses[0].data;
          }
        }, {
          key: "annotation",
          value: function annotation() {
            if (this.queryType !== _o.REGULAR_QUERY) throw new Error("Method is not supported for a '".concat(this.queryType, "' query type. Please use decompose"));
            return this.loadResponses[0].annotation;
          }
        }, {
          key: "timeDimensionBackwardCompatibleData",
          value: function timeDimensionBackwardCompatibleData(t) {
            if (void 0 === t) throw new Error("resultIndex is required");

            if (!this.backwardCompatibleData[t]) {
              var e = this.loadResponses[t],
                  r = e.data,
                  n = (e.query.timeDimensions || []).filter(function (t) {
                return Boolean(t.granularity);
              });
              this.backwardCompatibleData[t] = r.map(function (t) {
                return Object(G.a)(Object(G.a)({}, t), ue(Object.keys(t).filter(function (e) {
                  return n.find(function (t) {
                    return t.dimension === e;
                  }) && !t[ResultSet.timeDimensionMember(n.find(function (t) {
                    return t.dimension === e;
                  }))];
                }).map(function (e) {
                  return [ResultSet.timeDimensionMember(n.find(function (t) {
                    return t.dimension === e;
                  })), t[e]];
                })));
              });
            }

            return this.backwardCompatibleData[t];
          }
        }, {
          key: "decompose",
          value: function decompose() {
            var t = this;
            return this.loadResponses.map(function (e) {
              return new ResultSet({
                queryType: _o.REGULAR_QUERY,
                pivotQuery: Object(G.a)(Object(G.a)({}, e.query), {}, {
                  queryType: _o.REGULAR_QUERY
                }),
                results: [e]
              }, t.options);
            });
          }
        }, {
          key: "serialize",
          value: function serialize() {
            return {
              loadResponse: Bt(this.loadResponse)
            };
          }
        }], [{
          key: "measureFromAxis",
          value: function measureFromAxis(t) {
            return t[t.length - 1];
          }
        }, {
          key: "timeDimensionMember",
          value: function timeDimensionMember(t) {
            return "".concat(t.dimension, ".").concat(t.granularity);
          }
        }, {
          key: "deserialize",
          value: function deserialize(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return new ResultSet(t.loadResponse, e);
          }
        }, {
          key: "getNormalizedPivotConfig",
          value: function getNormalizedPivotConfig() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
                r = t.measures,
                n = void 0 === r ? [] : r,
                i = t.dimensions,
                o = void 0 === i ? [] : i,
                a = (t.timeDimensions || []).filter(function (t) {
              return !!t.granularity;
            });
            e = e || (a.length ? {
              x: a.map(function (t) {
                return ResultSet.timeDimensionMember(t);
              }),
              y: o
            } : {
              x: o,
              y: []
            });

            var s = function substituteTimeDimensionMembers(e) {
              return e.map(function (e) {
                return a.find(function (t) {
                  return t.dimension === e;
                }) && !o.find(function (t) {
                  return t === e;
                }) ? ResultSet.timeDimensionMember(t.timeDimensions.find(function (t) {
                  return t.dimension === e;
                })) : e;
              });
            };

            (e = Ee(e, {
              x: [],
              y: [],
              fillMissingDates: !0,
              joinDateRange: !1
            })).x = s(e.x), e.y = s(e.y);

            var c = e.x.concat(e.y),
                l = a.map(function (t) {
              return ResultSet.timeDimensionMember(t);
            }).concat(o),
                u = function dimensionFilter(t) {
              return l.includes(t) || "measures" === t;
            };

            return e.x = e.x.concat(l.filter(function (t) {
              return !c.includes(t) && "compareDateRange" !== t;
            })).filter(u), e.y = e.y.filter(u), e.x.concat(e.y).find(function (t) {
              return "measures" === t;
            }) || e.y.push("measures"), o.includes("compareDateRange") && !e.y.concat(e.x).includes("compareDateRange") && e.y.unshift("compareDateRange"), n.length || (e.x = e.x.filter(function (t) {
              return "measures" !== t;
            }), e.y = e.y.filter(function (t) {
              return "measures" !== t;
            })), e;
          }
        }]), ResultSet;
      }();

      Error;

      var To = Object($.createContext)(null),
          Ao = function (t) {
        Object(A.a)(QueryRenderer, t);
        var e = Object(P.a)(QueryRenderer);

        function QueryRenderer(t) {
          var r;
          return Object(W.a)(this, QueryRenderer), (r = e.call(this, t)).state = {}, r.mutexObj = {}, r;
        }

        return Object(N.a)(QueryRenderer, [{
          key: "componentDidMount",
          value: function componentDidMount() {
            var t = this.props,
                e = t.query,
                r = t.queries;
            e && this.load(e), r && this.loadQueries(r);
          }
        }, {
          key: "shouldComponentUpdate",
          value: function shouldComponentUpdate(t, e) {
            var r = this.props,
                n = r.query,
                i = r.queries,
                o = r.render,
                a = r.cubejsApi,
                s = r.loadSql,
                c = r.updateOnlyOnStateChange;
            return !c || !Gt(t.query, n) || !Gt(t.queries, i) || (null == t.render || null == o) && t.render !== o || t.cubejsApi !== a || t.loadSql !== s || !Gt(e, this.state) || t.updateOnlyOnStateChange !== c;
          }
        }, {
          key: "componentDidUpdate",
          value: function componentDidUpdate(t) {
            var e = this.props,
                r = e.query,
                n = e.queries;
            Gt(t.query, r) || this.load(r), Gt(t.queries, n) || this.loadQueries(n);
          }
        }, {
          key: "cubejsApi",
          value: function cubejsApi() {
            return this.props.cubejsApi || this.context && this.context.cubejsApi;
          }
        }, {
          key: "load",
          value: function load(t) {
            var e = this,
                r = this.props.resetResultSetOnChange;
            this.setState(Object(G.a)({
              isLoading: !0,
              error: null,
              sqlQuery: null
            }, r ? {
              resultSet: null
            } : {}));
            var n = this.props.loadSql,
                i = this.cubejsApi();
            t && _isQueryPresent(t) && ("only" === n ? i.sql(t, {
              mutexObj: this.mutexObj,
              mutexKey: "sql"
            }).then(function (t) {
              return e.setState({
                sqlQuery: t,
                error: null,
                isLoading: !1
              });
            }).catch(function (t) {
              return e.setState(Object(G.a)(Object(G.a)({}, r ? {
                resultSet: null
              } : {}), {}, {
                error: t,
                isLoading: !1
              }));
            }) : n ? Promise.all([i.sql(t, {
              mutexObj: this.mutexObj,
              mutexKey: "sql"
            }), i.load(t, {
              mutexObj: this.mutexObj,
              mutexKey: "query"
            })]).then(function (t) {
              var r = Object(V.a)(t, 2),
                  n = r[0],
                  i = r[1];
              return e.setState({
                sqlQuery: n,
                resultSet: i,
                error: null,
                isLoading: !1
              });
            }).catch(function (t) {
              return e.setState(Object(G.a)(Object(G.a)({}, r ? {
                resultSet: null
              } : {}), {}, {
                error: t,
                isLoading: !1
              }));
            }) : i.load(t, {
              mutexObj: this.mutexObj,
              mutexKey: "query"
            }).then(function (t) {
              return e.setState({
                resultSet: t,
                error: null,
                isLoading: !1
              });
            }).catch(function (t) {
              return e.setState(Object(G.a)(Object(G.a)({}, r ? {
                resultSet: null
              } : {}), {}, {
                error: t,
                isLoading: !1
              }));
            }));
          }
        }, {
          key: "loadQueries",
          value: function loadQueries(t) {
            var e = this,
                r = this.cubejsApi(),
                n = this.props.resetResultSetOnChange;
            this.setState(Object(G.a)(Object(G.a)({
              isLoading: !0
            }, n ? {
              resultSet: null
            } : {}), {}, {
              error: null
            })), Promise.all(je(t).map(function (t) {
              var n = Object(V.a)(t, 2),
                  i = n[0],
                  o = n[1];
              return r.load(o, {
                mutexObj: e.mutexObj,
                mutexKey: i
              }).then(function (t) {
                return [i, t];
              });
            })).then(function (t) {
              return e.setState({
                resultSet: ue(t),
                error: null,
                isLoading: !1
              });
            }).catch(function (t) {
              return e.setState(Object(G.a)(Object(G.a)({}, n ? {
                resultSet: null
              } : {}), {}, {
                error: t,
                isLoading: !1
              }));
            });
          }
        }, {
          key: "render",
          value: function render() {
            var t,
                e = this.state,
                r = e.error,
                n = e.queries,
                i = e.resultSet,
                o = e.isLoading,
                a = e.sqlQuery,
                render = this.props.render,
                s = {
              error: r ? new Error((null == (t = r.response) ? void 0 : t.plainError) || r.message || r.toString()) : null,
              resultSet: n ? i || {} : i,
              loadingState: {
                isLoading: o
              },
              sqlQuery: a
            };
            return render ? render(s) : null;
          }
        }], [{
          key: "isQueryPresent",
          value: function isQueryPresent(t) {
            return _isQueryPresent(t);
          }
        }]), QueryRenderer;
      }(Z.a.Component);

      function removeEmpty(t) {
        return "object" !== typeof t ? t : Object.fromEntries(Object.entries(t).filter(function (t) {
          return null != Object(V.a)(t, 2)[1];
        }).map(function (t) {
          var e = Object(V.a)(t, 2),
              r = e[0],
              n = e[1];
          return Array.isArray(n) ? [r, n.map(removeEmpty)] : [r, "object" === typeof n ? removeEmpty(n) : n];
        }));
      }

      ut(Ao, "contextType", To), ut(Ao, "defaultProps", {
        cubejsApi: null,
        query: null,
        render: null,
        queries: null,
        loadSql: null,
        updateOnlyOnStateChange: !1,
        resetResultSetOnChange: !0
      });

      var Mo = [{
        name: void 0,
        title: "w/o grouping"
      }, {
        name: "second",
        title: "Second"
      }, {
        name: "minute",
        title: "Minute"
      }, {
        name: "hour",
        title: "Hour"
      }, {
        name: "day",
        title: "Day"
      }, {
        name: "week",
        title: "Week"
      }, {
        name: "month",
        title: "Month"
      }, {
        name: "quarter",
        title: "Quarter"
      }, {
        name: "year",
        title: "Year"
      }],
          Po = function (t) {
        Object(A.a)(_QueryBuilder, t);
        var e = Object(P.a)(_QueryBuilder);

        function _QueryBuilder(t) {
          var r;
          return Object(W.a)(this, _QueryBuilder), r = e.call(this, t), ut(Object(C.a)(r), "fetchMeta", Object(v.a)(g.a.mark(function _callee19() {
            var t, e, n, i, o, a, s;
            return g.a.wrap(function _callee19$(c) {
              for (;;) {
                switch (c.prev = c.next) {
                  case 0:
                    if (r.cubejsApi()) {
                      c.next = 2;
                      break;
                    }

                    return c.abrupt("return");

                  case 2:
                    return o = null, a = null, s = null, c.prev = 5, r.setState({
                      isFetchingMeta: !0
                    }), c.next = 9, r.cubejsApi().meta();

                  case 9:
                    i = c.sent, c.next = 17;
                    break;

                  case 12:
                    c.prev = 12, c.t0 = c.catch(5), o = (null == (t = c.t0.response) ? void 0 : t.plainError) || c.t0, a = c.t0, s = (null == (n = null == (e = c.t0.response) ? void 0 : e.stack) ? void 0 : n.replace(c.t0.message || "", "")) || "";

                  case 17:
                    r.setState({
                      meta: i,
                      metaError: o ? new Error(o.message || o.toString()) : null,
                      richMetaError: a,
                      metaErrorStack: s,
                      isFetchingMeta: !1
                    }, function () {
                      r.updateQuery({});
                    });

                  case 18:
                  case "end":
                    return c.stop();
                }
              }
            }, _callee19, null, [[5, 12]]);
          }))), r.state = Object(G.a)(Object(G.a)({
            query: t.defaultQuery || t.query,
            chartType: t.defaultChartType,
            validatedQuery: t.query,
            missingMembers: [],
            isFetchingMeta: !0,
            dryRunResponse: null
          }, t.vizState), t.initialVizState), r.mutexObj = {}, r.orderMembersOrderKeys = [], r;
        }

        return Object(N.a)(_QueryBuilder, [{
          key: "componentDidMount",
          value: function () {
            var t = Object(v.a)(g.a.mark(function _callee20() {
              return g.a.wrap(function _callee20$(t) {
                for (;;) {
                  switch (t.prev = t.next) {
                    case 0:
                      return this.prevContext = this.context, t.next = 3, this.fetchMeta();

                    case 3:
                    case "end":
                      return t.stop();
                  }
                }
              }, _callee20, this);
            }));
            return function componentDidMount() {
              return t.apply(this, arguments);
            };
          }()
        }, {
          key: "componentDidUpdate",
          value: function () {
            var t = Object(v.a)(g.a.mark(function _callee22(t) {
              var e,
                  r,
                  n,
                  i,
                  o,
                  a,
                  s,
                  c = this;
              return g.a.wrap(function _callee22$(l) {
                for (;;) {
                  switch (l.prev = l.next) {
                    case 0:
                      if (n = this.props, i = n.schemaVersion, o = n.onSchemaChange, a = this.state.meta, (null == (e = this.prevContext) ? void 0 : e.cubejsApi) === (null == (r = this.context) ? void 0 : r.cubejsApi)) {
                        l.next = 6;
                        break;
                      }

                      return this.prevContext = this.context, l.next = 6, this.fetchMeta();

                    case 6:
                      if (t.schemaVersion === i) {
                        l.next = 17;
                        break;
                      }

                      return l.prev = 7, l.next = 10, this.cubejsApi().meta();

                    case 10:
                      s = l.sent, Gt(s, a) || "function" !== typeof o || o({
                        schemaVersion: i,
                        refresh: function () {
                          var t = Object(v.a)(g.a.mark(function _callee21() {
                            return g.a.wrap(function _callee21$(t) {
                              for (;;) {
                                switch (t.prev = t.next) {
                                  case 0:
                                    return t.next = 2, c.fetchMeta();

                                  case 2:
                                  case "end":
                                    return t.stop();
                                }
                              }
                            }, _callee21);
                          }));
                          return function refresh() {
                            return t.apply(this, arguments);
                          };
                        }()
                      }), l.next = 17;
                      break;

                    case 14:
                      l.prev = 14, l.t0 = l.catch(7), this.setState({
                        metaError: l.t0
                      });

                    case 17:
                    case "end":
                      return l.stop();
                  }
                }
              }, _callee22, this, [[7, 14]]);
            }));
            return function componentDidUpdate(e) {
              return t.apply(this, arguments);
            };
          }()
        }, {
          key: "cubejsApi",
          value: function cubejsApi() {
            var cubejsApi = this.props.cubejsApi;
            return cubejsApi || this.context && this.context.cubejsApi;
          }
        }, {
          key: "getMissingMembers",
          value: function getMissingMembers(t, e) {
            return e ? function getQueryMembers() {
              var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                  e = new Set();
              return ["measures", "dimensions", "segments"].forEach(function (r) {
                return (t[r] || []).forEach(function (t) {
                  return e.add(t);
                });
              }), (t.timeDimensions || []).forEach(function (t) {
                return e.add(t.dimension);
              }), flattenFilters(t.filters).forEach(function (t) {
                return e.add(t.dimension || t.member);
              }), Object(E.a)(e);
            }(t).map(function (t) {
              return !!e.resolveMember(t, ["measures", "dimensions", "segments"]).error && t;
            }).filter(Boolean) : [];
          }
        }, {
          key: "isQueryPresent",
          value: function isQueryPresent() {
            var t = this.state.query;
            return Ao.isQueryPresent(t);
          }
        }, {
          key: "prepareRenderProps",
          value: function prepareRenderProps(t) {
            var e = this,
                r = function getName(t) {
              return t.name;
            },
                n = function updateMethods(t) {
              var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : r;
              return {
                add: function add(r) {
                  var i = e.state.query;
                  e.updateQuery(Object(F.a)({}, t, (i[t] || []).concat(n(r))));
                },
                remove: function remove(r) {
                  var n = e.state.query;
                  return e.updateQuery(Object(F.a)({}, t, (n[t] || []).filter(function (t, e) {
                    return e !== r.index;
                  })));
                },
                update: function update(r, i) {
                  var o = (e.state.query[t] || []).concat([]);
                  return o.splice(r.index, 1, n(i)), e.updateQuery(Object(F.a)({}, t, o));
                }
              };
            },
                i = this.state,
                o = i.meta,
                a = i.metaError,
                s = i.richMetaError,
                c = i.query,
                l = i.queryError,
                u = i.chartType,
                h = i.pivotConfig,
                d = i.validatedQuery,
                f = i.missingMembers,
                p = i.isFetchingMeta,
                y = i.dryRunResponse,
                g = i.metaErrorStack,
                m = pe(function (t) {
              return "".concat(jt("member", t)).concat(jt("operator", t));
            }, flattenFilters(o && c.filters || []).map(function (t) {
              return Object(G.a)(Object(G.a)({}, t), {}, {
                member: t.member || t.dimension
              });
            })).map(function (t, e) {
              return Object(G.a)(Object(G.a)({}, t), {}, {
                dimension: o.resolveMember(t.member || t.dimension, ["dimensions", "measures"]),
                operators: o.filterOperatorsForMember(t.member || t.dimension, ["dimensions", "measures"]),
                index: e
              });
            }),
                v = _QueryBuilder.resolveMember("measures", this.state),
                b = _QueryBuilder.resolveMember("dimensions", this.state),
                x = _QueryBuilder.resolveMember("timeDimensions", this.state),
                w = (o && c.segments || []).map(function (t, e) {
              return Object(G.a)({
                index: e
              }, o.resolveMember(t, "segments"));
            }),
                S = [],
                O = [],
                k = [],
                _ = [],
                C = (null == o ? void 0 : o.membersGroupedByCube()) || {
              measures: [],
              dimensions: [],
              segments: [],
              timeDimensions: []
            };

            if (o) {
              S = o.membersForQuery(c, "measures"), O = o.membersForQuery(c, "dimensions"), k = o.membersForQuery(c, "segments");
              var T = fe(jt("cubeName"), C.measures),
                  A = fe(jt("cubeName"), C.dimensions);
              _ = ye([].concat(Object(E.a)(Object.keys(T)), Object(E.a)(Object.keys(A)))).sort().map(function (t) {
                var e,
                    r,
                    n = T[t] || A[t];
                return Object(G.a)(Object(G.a)({}, n), {}, {
                  members: [].concat(Object(E.a)(null == (e = T[t]) ? void 0 : e.members), Object(E.a)(null == (r = A[t]) ? void 0 : r.members)).sort(function (t, e) {
                    return t.shortTitle > e.shortTitle ? 1 : -1;
                  })
                });
              });
            }

            var M = Array.isArray(c.order) ? Object.fromEntries(c.order) : c.order,
                P = [].concat(Object(E.a)(v), Object(E.a)(b), Object(E.a)(x.map(function (t) {
              return t.dimension;
            }))),
                j = pe(jt("id"), Object(E.a)(P.map(function (t) {
              var e = t.name;
              return {
                id: e,
                title: t.title,
                order: (null == M ? void 0 : M[e]) || "none"
              };
            })));
            return this.orderMembersOrderKeys.length !== j.length && (this.orderMembersOrderKeys = j.map(function (t) {
              return t.id;
            })), this.orderMembersOrderKeys.length && (j = (this.orderMembersOrderKeys || []).map(function (t) {
              return j.find(function (e) {
                return e.id === t;
              });
            }).filter(Boolean)), Object(G.a)({
              meta: o,
              metaError: a,
              richMetaError: s,
              metaErrorStack: g,
              query: c,
              error: l,
              validatedQuery: d,
              isQueryPresent: this.isQueryPresent(),
              chartType: u,
              measures: v,
              dimensions: b,
              timeDimensions: x,
              segments: w,
              filters: m,
              orderMembers: j,
              availableMeasures: S,
              availableDimensions: O,
              availableTimeDimensions: O.filter(function (t) {
                return "time" === t.type;
              }),
              availableSegments: k,
              availableMembers: C,
              availableFilterMembers: _,
              updateQuery: function updateQuery(t) {
                return e.updateQuery(t);
              },
              updateMeasures: n("measures"),
              updateDimensions: n("dimensions"),
              updateSegments: n("segments"),
              updateTimeDimensions: n("timeDimensions", function toTimeDimension(t) {
                var e = t.compareDateRange ? {
                  compareDateRange: t.compareDateRange
                } : {
                  dateRange: t.dateRange
                };
                return removeEmpty(Object(G.a)({
                  dimension: t.dimension.name,
                  granularity: t.granularity
                }, e));
              }),
              updateFilters: n("filters", function toFilter(t) {
                var e, r;
                return Object(G.a)({
                  member: (null == (e = t.member) ? void 0 : e.name) || (null == (r = t.dimension) ? void 0 : r.name),
                  operator: t.operator
                }, ["set", "notSet"].includes(t.operator) ? {} : {
                  values: t.values
                });
              }),
              updateChartType: function updateChartType(t) {
                return e.updateVizState({
                  chartType: t
                });
              },
              updateOrder: {
                set: function set(t) {
                  var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "asc";
                  e.updateQuery({
                    order: j.map(function (e) {
                      return Object(G.a)(Object(G.a)({}, e), {}, {
                        order: e.id === t ? r : e.order
                      });
                    }).reduce(function (t, e) {
                      var r = e.id,
                          n = e.order;
                      return "none" !== n ? [].concat(Object(E.a)(t), [[r, n]]) : t;
                    }, [])
                  });
                },
                update: function update(t) {
                  e.updateQuery({
                    order: t
                  });
                },
                reorder: function reorder(t, r) {
                  if (null != t && null != r) {
                    var n = function moveItemInArray(t, e, r) {
                      var n = Object(E.a)(t),
                          i = n.splice(e, 1),
                          o = Object(V.a)(i, 1)[0];
                      return n.splice(r, 0, o), n;
                    }(j, t, r);

                    e.orderMembersOrderKeys = n.map(function (t) {
                      return t.id;
                    }), e.updateQuery({
                      order: n.reduce(function (t, e) {
                        var r = e.id,
                            n = e.order;
                        return "none" !== n ? [].concat(Object(E.a)(t), [[r, n]]) : t;
                      }, [])
                    });
                  }
                }
              },
              pivotConfig: h,
              updatePivotConfig: {
                moveItem: function moveItem(t) {
                  var r = t.sourceIndex,
                      n = t.destinationIndex,
                      i = t.sourceAxis,
                      o = t.destinationAxis;
                  e.updateVizState({
                    pivotConfig: movePivotItem(h, r, n, i, o)
                  });
                },
                update: function update(t) {
                  var r = t.limit;
                  e.updateVizState(Object(G.a)({
                    pivotConfig: Object(G.a)(Object(G.a)({}, h), t)
                  }, r ? {
                    query: Object(G.a)(Object(G.a)({}, c), {}, {
                      limit: r
                    })
                  } : null));
                }
              },
              missingMembers: f,
              refresh: this.fetchMeta,
              isFetchingMeta: p,
              dryRunResponse: y
            }, t);
          }
        }, {
          key: "updateQuery",
          value: function updateQuery(t) {
            var e = this.state.query;
            this.updateVizState({
              query: removeEmptyQueryFields(Object(G.a)(Object(G.a)({}, e), t))
            });
          }
        }, {
          key: "updateVizState",
          value: function () {
            var t = Object(v.a)(g.a.mark(function _callee23(t) {
              var e,
                  r,
                  n,
                  i,
                  o,
                  a,
                  s,
                  c,
                  l,
                  u,
                  h,
                  d,
                  f,
                  p,
                  y = this;
              return g.a.wrap(function _callee23$(g) {
                for (;;) {
                  switch (g.prev = g.next) {
                    case 0:
                      if (r = this.props, n = r.setQuery, i = r.setVizState, o = this.state, a = o.query, s = o.pivotConfig, c = o.chartType, l = o.meta, (u = this.applyStateChangeHeuristics(t)).query || (u.query = Object(G.a)({}, a)), h = null, d = function handleVizStateChange(t) {
                        var e = y.props.onVizStateChanged;

                        if (e) {
                          var r = Ae(["chartType", "pivotConfig", "query"], t);
                          h && Gt(h, r) || (e(r), h = Bt(r));
                        }
                      }, f = function runSetters(t) {
                        i && i(Ae(["chartType", "pivotConfig", "query"], t)), t.query && n && n(t.query);
                      }, u.shouldApplyHeuristicOrder && (u.query.order = defaultOrder(u.query)), u.pivotConfig = Co.getNormalizedPivotConfig(u.query, void 0 !== u.pivotConfig ? u.pivotConfig : s), u.missingMembers = this.getMissingMembers(u.query, l), u.chartType = u.chartType || t.chartType || c, f(Object(G.a)(Object(G.a)({}, t), {}, {
                        query: u.query
                      })), this.setState(Object(G.a)(Object(G.a)({}, u), {}, {
                        queryError: null
                      })), d(u), !!Gt(Ae(["measures", "dimensions", "timeDimensions"], a), Ae(["measures", "dimensions", "timeDimensions"], u.query)) || !_isQueryPresent(u.query) || 0 !== u.missingMembers.length) {
                        g.next = 30;
                        break;
                      }

                      return g.prev = 16, g.next = 19, this.cubejsApi().dryRun(u.query, {
                        mutexObj: this.mutexObj
                      });

                    case 19:
                      p = g.sent, u.shouldApplyHeuristicOrder && (u.query.order = (p.queryOrder || []).reduce(function (t, e) {
                        return Object(G.a)(Object(G.a)({}, t), e);
                      }, {})), u.pivotConfig = Co.getNormalizedPivotConfig(p.pivotQuery, u.pivotConfig), u.validatedQuery = this.validatedQuery(u), u.dryRunResponse = p, _isQueryPresent(a) && f(Object(G.a)(Object(G.a)({}, this.state), u)), g.next = 30;
                      break;

                    case 27:
                      g.prev = 27, g.t0 = g.catch(16), this.setState({
                        queryError: new Error((null == (e = g.t0.response) ? void 0 : e.plainError) || g.t0.message),
                        richQueryError: new Error(g.t0.message || g.t0.toString())
                      });

                    case 30:
                      this.setState(u, function () {
                        return d(y.state);
                      });

                    case 31:
                    case "end":
                      return g.stop();
                  }
                }
              }, _callee23, this, [[16, 27]]);
            }));
            return function updateVizState(e) {
              return t.apply(this, arguments);
            };
          }()
        }, {
          key: "validatedQuery",
          value: function validatedQuery(t) {
            return function validateQuery(t) {
              var e = t || {};
              return removeEmptyQueryFields(Object(G.a)(Object(G.a)({}, e), {}, {
                filters: (e.filters || []).filter(function (t) {
                  return t.operator;
                }),
                timeDimensions: (e.timeDimensions || []).filter(function (t) {
                  return !(!t.dateRange && !t.granularity);
                })
              }));
            }((t || this.state).query);
          }
        }, {
          key: "defaultHeuristics",
          value: function defaultHeuristics(t) {
            var e = this.state,
                r = e.query,
                n = e.sessionGranularity;
            return _defaultHeuristics(t, r, {
              meta: e.meta,
              sessionGranularity: n || "day"
            });
          }
        }, {
          key: "applyStateChangeHeuristics",
          value: function applyStateChangeHeuristics(t) {
            var e = this.props,
                r = e.stateChangeHeuristics;
            return e.disableHeuristics ? t : r && r(this.state, t) || this.defaultHeuristics(t);
          }
        }, {
          key: "render",
          value: function render() {
            var t = this,
                e = this.state.query,
                r = this.props,
                n = r.cubejsApi,
                i = r.render;
            return r.wrapWithQueryRenderer ? er(Ao, {
              query: e,
              cubejsApi: n,
              resetResultSetOnChange: !1,
              render: function render(e) {
                return i ? i(t.prepareRenderProps(e)) : null;
              }
            }) : i ? i(this.prepareRenderProps()) : null;
          }
        }], [{
          key: "getDerivedStateFromProps",
          value: function getDerivedStateFromProps(t, e) {
            if (t.query || t.vizState) {
              var r = Object(G.a)(Object(G.a)({}, e), t.vizState || {});
              if (Array.isArray(t.query)) throw new Error("Array of queries is not supported.");
              return Object(G.a)(Object(G.a)({}, r), {}, {
                query: Object(G.a)(Object(G.a)({}, r.query), t.query || {})
              });
            }

            return null;
          }
        }, {
          key: "resolveMember",
          value: function resolveMember(t, e) {
            var r = e.meta,
                n = e.query;
            return r ? Array.isArray(n) ? n.reduce(function (e, n) {
              return e.concat(_QueryBuilder.resolveMember(t, {
                meta: r,
                query: n
              }));
            }, []) : "timeDimensions" === t ? (n.timeDimensions || []).map(function (t, e) {
              return Object(G.a)(Object(G.a)({}, t), {}, {
                dimension: Object(G.a)(Object(G.a)({}, r.resolveMember(t.dimension, "dimensions")), {}, {
                  granularities: Mo
                }),
                index: e
              });
            }) : (n[t] || []).map(function (e, n) {
              return Object(G.a)({
                index: n
              }, r.resolveMember(e, t));
            }) : [];
          }
        }]), _QueryBuilder;
      }(Z.a.Component);

      ut(Po, "contextType", To), ut(Po, "defaultProps", {
        cubejsApi: null,
        stateChangeHeuristics: null,
        disableHeuristics: !1,
        render: null,
        wrapWithQueryRenderer: !0,
        defaultChartType: "line",
        defaultQuery: {},
        initialVizState: null,
        onVizStateChanged: null,
        query: null,
        setQuery: null,
        vizState: null,
        setVizState: null
      });

      var jo = function useCubeContext() {
        return {
          cubeJsApi: Object($.useContext)(To).cubejsApi
        };
      },
          Ro = function () {
        function Subscribable() {
          Object(W.a)(this, Subscribable), this.listeners = [], this.subscribe = this.subscribe.bind(this);
        }

        return Object(N.a)(Subscribable, [{
          key: "subscribe",
          value: function subscribe(t) {
            var e = this;
            return this.listeners.push(t), this.onSubscribe(), function () {
              e.listeners = e.listeners.filter(function (e) {
                return e !== t;
              }), e.onUnsubscribe();
            };
          }
        }, {
          key: "hasListeners",
          value: function hasListeners() {
            return this.listeners.length > 0;
          }
        }, {
          key: "onSubscribe",
          value: function onSubscribe() {}
        }, {
          key: "onUnsubscribe",
          value: function onUnsubscribe() {}
        }]), Subscribable;
      }(),
          Do = "undefined" === typeof window || "Deno" in window;

      function noop() {}

      function isValidTimeout(t) {
        return "number" === typeof t && t >= 0 && t !== 1 / 0;
      }

      function timeUntilStale(t, e) {
        return Math.max(t + (e || 0) - Date.now(), 0);
      }

      function parseQueryArgs(t, e, r) {
        return isQueryKey(t) ? "function" === typeof e ? Object(G.a)(Object(G.a)({}, r), {}, {
          queryKey: t,
          queryFn: e
        }) : Object(G.a)(Object(G.a)({}, e), {}, {
          queryKey: t
        }) : t;
      }

      function shallowEqualObjects(t, e) {
        if (t && !e || e && !t) return !1;

        for (var r in t) {
          if (t[r] !== e[r]) return !1;
        }

        return !0;
      }

      function isPlainArray(t) {
        return Array.isArray(t) && t.length === Object.keys(t).length;
      }

      function isPlainObject(t) {
        if (!hasObjectPrototype(t)) return !1;
        var e = t.constructor;
        if ("undefined" === typeof e) return !0;
        var r = e.prototype;
        return !!hasObjectPrototype(r) && !!r.hasOwnProperty("isPrototypeOf");
      }

      function hasObjectPrototype(t) {
        return "[object Object]" === Object.prototype.toString.call(t);
      }

      function isQueryKey(t) {
        return Array.isArray(t);
      }

      function sleep(t) {
        return new Promise(function (e) {
          setTimeout(e, t);
        });
      }

      function scheduleMicrotask(t) {
        sleep(0).then(t);
      }

      function replaceData(t, e, r) {
        return null != r.isDataEqual && r.isDataEqual(t, e) ? t : "function" === typeof r.structuralSharing ? r.structuralSharing(t, e) : !1 !== r.structuralSharing ? function replaceEqualDeep(t, e) {
          if (t === e) return t;
          var r = isPlainArray(t) && isPlainArray(e);

          if (r || isPlainObject(t) && isPlainObject(e)) {
            for (var n = r ? t.length : Object.keys(t).length, i = r ? e : Object.keys(e), o = i.length, a = r ? [] : {}, s = 0, c = 0; c < o; c++) {
              var l = r ? c : i[c];
              a[l] = replaceEqualDeep(t[l], e[l]), a[l] === t[l] && s++;
            }

            return n === o && s === n ? t : a;
          }

          return e;
        }(t, e) : e;
      }

      var Io = new (function (t) {
        Object(A.a)(FocusManager, t);
        var e = Object(P.a)(FocusManager);

        function FocusManager() {
          var t;
          return Object(W.a)(this, FocusManager), (t = e.call(this)).setup = function (t) {
            if (!Do && window.addEventListener) {
              var e = function listener() {
                return t();
              };

              return window.addEventListener("visibilitychange", e, !1), window.addEventListener("focus", e, !1), function () {
                window.removeEventListener("visibilitychange", e), window.removeEventListener("focus", e);
              };
            }
          }, t;
        }

        return Object(N.a)(FocusManager, [{
          key: "onSubscribe",
          value: function onSubscribe() {
            this.cleanup || this.setEventListener(this.setup);
          }
        }, {
          key: "onUnsubscribe",
          value: function onUnsubscribe() {
            var t;
            this.hasListeners() || (null == (t = this.cleanup) || t.call(this), this.cleanup = void 0);
          }
        }, {
          key: "setEventListener",
          value: function setEventListener(t) {
            var e,
                r = this;
            this.setup = t, null == (e = this.cleanup) || e.call(this), this.cleanup = t(function (t) {
              "boolean" === typeof t ? r.setFocused(t) : r.onFocus();
            });
          }
        }, {
          key: "setFocused",
          value: function setFocused(t) {
            this.focused = t, t && this.onFocus();
          }
        }, {
          key: "onFocus",
          value: function onFocus() {
            this.listeners.forEach(function (t) {
              t();
            });
          }
        }, {
          key: "isFocused",
          value: function isFocused() {
            return "boolean" === typeof this.focused ? this.focused : "undefined" === typeof document || [void 0, "visible", "prerender"].includes(document.visibilityState);
          }
        }]), FocusManager;
      }(Ro))(),
          Lo = new (function (t) {
        Object(A.a)(OnlineManager, t);
        var e = Object(P.a)(OnlineManager);

        function OnlineManager() {
          var t;
          return Object(W.a)(this, OnlineManager), (t = e.call(this)).setup = function (t) {
            if (!Do && window.addEventListener) {
              var e = function listener() {
                return t();
              };

              return window.addEventListener("online", e, !1), window.addEventListener("offline", e, !1), function () {
                window.removeEventListener("online", e), window.removeEventListener("offline", e);
              };
            }
          }, t;
        }

        return Object(N.a)(OnlineManager, [{
          key: "onSubscribe",
          value: function onSubscribe() {
            this.cleanup || this.setEventListener(this.setup);
          }
        }, {
          key: "onUnsubscribe",
          value: function onUnsubscribe() {
            var t;
            this.hasListeners() || (null == (t = this.cleanup) || t.call(this), this.cleanup = void 0);
          }
        }, {
          key: "setEventListener",
          value: function setEventListener(t) {
            var e,
                r = this;
            this.setup = t, null == (e = this.cleanup) || e.call(this), this.cleanup = t(function (t) {
              "boolean" === typeof t ? r.setOnline(t) : r.onOnline();
            });
          }
        }, {
          key: "setOnline",
          value: function setOnline(t) {
            this.online = t, t && this.onOnline();
          }
        }, {
          key: "onOnline",
          value: function onOnline() {
            this.listeners.forEach(function (t) {
              t();
            });
          }
        }, {
          key: "isOnline",
          value: function isOnline() {
            return "boolean" === typeof this.online ? this.online : "undefined" === typeof navigator || "undefined" === typeof navigator.onLine || navigator.onLine;
          }
        }]), OnlineManager;
      }(Ro))();

      function canFetch(t) {
        return "online" !== (null != t ? t : "online") || Lo.isOnline();
      }

      var No = function CancelledError(t) {
        Object(W.a)(this, CancelledError), this.revert = null == t ? void 0 : t.revert, this.silent = null == t ? void 0 : t.silent;
      };

      function isCancelledError(t) {
        return t instanceof No;
      }

      console;

      var Bo = function createNotifyManager() {
        var t = [],
            e = 0,
            r = function notifyFn(t) {
          t();
        },
            n = function batchNotifyFn(t) {
          t();
        },
            i = function schedule(n) {
          e ? t.push(n) : scheduleMicrotask(function () {
            r(n);
          });
        },
            o = function flush() {
          var e = t;
          t = [], e.length && scheduleMicrotask(function () {
            n(function () {
              e.forEach(function (t) {
                r(t);
              });
            });
          });
        };

        return {
          batch: function batch(t) {
            var r;
            e++;

            try {
              r = t();
            } finally {
              --e || o();
            }

            return r;
          },
          batchCalls: function batchCalls(t) {
            return function () {
              for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++) {
                r[n] = arguments[n];
              }

              i(function () {
                t.apply(void 0, r);
              });
            };
          },
          schedule: i,
          setNotifyFunction: function setNotifyFunction(t) {
            r = t;
          },
          setBatchNotifyFunction: function setBatchNotifyFunction(t) {
            n = t;
          }
        };
      }();

      function infiniteQueryBehavior() {
        return {
          onFetch: function onFetch(t) {
            t.fetchFn = function () {
              var e,
                  r,
                  n,
                  i,
                  o,
                  a,
                  s,
                  c = null == (e = t.fetchOptions) ? void 0 : null == (r = e.meta) ? void 0 : r.refetchPage,
                  l = null == (n = t.fetchOptions) ? void 0 : null == (i = n.meta) ? void 0 : i.fetchMore,
                  u = null == l ? void 0 : l.pageParam,
                  h = "forward" === (null == l ? void 0 : l.direction),
                  d = "backward" === (null == l ? void 0 : l.direction),
                  f = (null == (o = t.state.data) ? void 0 : o.pages) || [],
                  p = (null == (a = t.state.data) ? void 0 : a.pageParams) || [],
                  y = p,
                  g = !1,
                  m = t.options.queryFn || function () {
                return Promise.reject("Missing queryFn");
              },
                  v = function buildNewPages(t, e, r, n) {
                return y = n ? [e].concat(Object(E.a)(y)) : [].concat(Object(E.a)(y), [e]), n ? [r].concat(Object(E.a)(t)) : [].concat(Object(E.a)(t), [r]);
              },
                  b = function fetchPage(e, r, n, i) {
                if (g) return Promise.reject("Cancelled");
                if ("undefined" === typeof n && !r && e.length) return Promise.resolve(e);
                var o = {
                  queryKey: t.queryKey,
                  pageParam: n,
                  meta: t.options.meta
                };
                !function addSignalProperty(e) {
                  Object.defineProperty(e, "signal", {
                    enumerable: !0,
                    get: function get() {
                      var e, r;
                      return null != (e = t.signal) && e.aborted ? g = !0 : null == (r = t.signal) || r.addEventListener("abort", function () {
                        g = !0;
                      }), t.signal;
                    }
                  });
                }(o);
                var a = m(o);
                return Promise.resolve(a).then(function (t) {
                  return v(e, n, t, i);
                });
              };

              if (f.length) {
                if (h) {
                  var x = "undefined" !== typeof u,
                      w = x ? u : getNextPageParam(t.options, f);
                  s = b(f, x, w);
                } else if (d) {
                  var S = "undefined" !== typeof u,
                      O = S ? u : getPreviousPageParam(t.options, f);
                  s = b(f, S, O, !0);
                } else !function () {
                  y = [];
                  var e = "undefined" === typeof t.options.getNextPageParam,
                      r = !c || !f[0] || c(f[0], 0, f);
                  s = r ? b([], e, p[0]) : Promise.resolve(v([], p[0], f[0]));

                  for (var n = function _loop3(r) {
                    s = s.then(function (n) {
                      if (!c || !f[r] || c(f[r], r, f)) {
                        var i = e ? p[r] : getNextPageParam(t.options, n);
                        return b(n, e, i);
                      }

                      return Promise.resolve(v(n, p[r], f[r]));
                    });
                  }, i = 1; i < f.length; i++) {
                    n(i);
                  }
                }();
              } else s = b([]);
              return s.then(function (t) {
                return {
                  pages: t,
                  pageParams: y
                };
              });
            };
          }
        };
      }

      function getNextPageParam(t, e) {
        return null == t.getNextPageParam ? void 0 : t.getNextPageParam(e[e.length - 1], e);
      }

      function getPreviousPageParam(t, e) {
        return null == t.getPreviousPageParam ? void 0 : t.getPreviousPageParam(e[0], e);
      }

      function hasNextPage(t, e) {
        if (t.getNextPageParam && Array.isArray(e)) {
          var r = getNextPageParam(t, e);
          return "undefined" !== typeof r && null !== r && !1 !== r;
        }
      }

      function hasPreviousPage(t, e) {
        if (t.getPreviousPageParam && Array.isArray(e)) {
          var r = getPreviousPageParam(t, e);
          return "undefined" !== typeof r && null !== r && !1 !== r;
        }
      }

      var Fo = function (t) {
        Object(A.a)(QueryObserver, t);
        var e = Object(P.a)(QueryObserver);

        function QueryObserver(t, r) {
          var n;
          return Object(W.a)(this, QueryObserver), (n = e.call(this)).client = t, n.options = r, n.trackedProps = new Set(), n.selectError = null, n.bindMethods(), n.setOptions(r), n;
        }

        return Object(N.a)(QueryObserver, [{
          key: "bindMethods",
          value: function bindMethods() {
            this.remove = this.remove.bind(this), this.refetch = this.refetch.bind(this);
          }
        }, {
          key: "onSubscribe",
          value: function onSubscribe() {
            1 === this.listeners.length && (this.currentQuery.addObserver(this), shouldFetchOnMount(this.currentQuery, this.options) && this.executeFetch(), this.updateTimers());
          }
        }, {
          key: "onUnsubscribe",
          value: function onUnsubscribe() {
            this.listeners.length || this.destroy();
          }
        }, {
          key: "shouldFetchOnReconnect",
          value: function shouldFetchOnReconnect() {
            return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
          }
        }, {
          key: "shouldFetchOnWindowFocus",
          value: function shouldFetchOnWindowFocus() {
            return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
          }
        }, {
          key: "destroy",
          value: function destroy() {
            this.listeners = [], this.clearStaleTimeout(), this.clearRefetchInterval(), this.currentQuery.removeObserver(this);
          }
        }, {
          key: "setOptions",
          value: function setOptions(t, e) {
            var r = this.options,
                n = this.currentQuery;
            if (this.options = this.client.defaultQueryOptions(t), shallowEqualObjects(r, this.options) || this.client.getQueryCache().notify({
              type: "observerOptionsUpdated",
              query: this.currentQuery,
              observer: this
            }), "undefined" !== typeof this.options.enabled && "boolean" !== typeof this.options.enabled) throw new Error("Expected enabled to be a boolean");
            this.options.queryKey || (this.options.queryKey = r.queryKey), this.updateQuery();
            var i = this.hasListeners();
            i && shouldFetchOptionally(this.currentQuery, n, this.options, r) && this.executeFetch(), this.updateResult(e), !i || this.currentQuery === n && this.options.enabled === r.enabled && this.options.staleTime === r.staleTime || this.updateStaleTimeout();
            var o = this.computeRefetchInterval();
            !i || this.currentQuery === n && this.options.enabled === r.enabled && o === this.currentRefetchInterval || this.updateRefetchInterval(o);
          }
        }, {
          key: "getOptimisticResult",
          value: function getOptimisticResult(t) {
            var e = this.client.getQueryCache().build(this.client, t);
            return this.createResult(e, t);
          }
        }, {
          key: "getCurrentResult",
          value: function getCurrentResult() {
            return this.currentResult;
          }
        }, {
          key: "trackResult",
          value: function trackResult(t) {
            var e = this,
                r = {};
            return Object.keys(t).forEach(function (n) {
              Object.defineProperty(r, n, {
                configurable: !1,
                enumerable: !0,
                get: function get() {
                  return e.trackedProps.add(n), t[n];
                }
              });
            }), r;
          }
        }, {
          key: "getCurrentQuery",
          value: function getCurrentQuery() {
            return this.currentQuery;
          }
        }, {
          key: "remove",
          value: function remove() {
            this.client.getQueryCache().remove(this.currentQuery);
          }
        }, {
          key: "refetch",
          value: function refetch() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                e = t.refetchPage,
                r = Object(U.a)(t, it);
            return this.fetch(Object(G.a)(Object(G.a)({}, r), {}, {
              meta: {
                refetchPage: e
              }
            }));
          }
        }, {
          key: "fetchOptimistic",
          value: function fetchOptimistic(t) {
            var e = this,
                r = this.client.defaultQueryOptions(t),
                n = this.client.getQueryCache().build(this.client, r);
            return n.isFetchingOptimistic = !0, n.fetch().then(function () {
              return e.createResult(n, r);
            });
          }
        }, {
          key: "fetch",
          value: function fetch(t) {
            var e,
                r = this;
            return this.executeFetch(Object(G.a)(Object(G.a)({}, t), {}, {
              cancelRefetch: null == (e = t.cancelRefetch) || e
            })).then(function () {
              return r.updateResult(), r.currentResult;
            });
          }
        }, {
          key: "executeFetch",
          value: function executeFetch(t) {
            this.updateQuery();
            var e = this.currentQuery.fetch(this.options, t);
            return null != t && t.throwOnError || (e = e.catch(noop)), e;
          }
        }, {
          key: "updateStaleTimeout",
          value: function updateStaleTimeout() {
            var t = this;

            if (this.clearStaleTimeout(), !Do && !this.currentResult.isStale && isValidTimeout(this.options.staleTime)) {
              var e = timeUntilStale(this.currentResult.dataUpdatedAt, this.options.staleTime) + 1;
              this.staleTimeoutId = setTimeout(function () {
                t.currentResult.isStale || t.updateResult();
              }, e);
            }
          }
        }, {
          key: "computeRefetchInterval",
          value: function computeRefetchInterval() {
            var t;
            return "function" === typeof this.options.refetchInterval ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : null != (t = this.options.refetchInterval) && t;
          }
        }, {
          key: "updateRefetchInterval",
          value: function updateRefetchInterval(t) {
            var e = this;
            this.clearRefetchInterval(), this.currentRefetchInterval = t, !Do && !1 !== this.options.enabled && isValidTimeout(this.currentRefetchInterval) && 0 !== this.currentRefetchInterval && (this.refetchIntervalId = setInterval(function () {
              (e.options.refetchIntervalInBackground || Io.isFocused()) && e.executeFetch();
            }, this.currentRefetchInterval));
          }
        }, {
          key: "updateTimers",
          value: function updateTimers() {
            this.updateStaleTimeout(), this.updateRefetchInterval(this.computeRefetchInterval());
          }
        }, {
          key: "clearStaleTimeout",
          value: function clearStaleTimeout() {
            this.staleTimeoutId && (clearTimeout(this.staleTimeoutId), this.staleTimeoutId = void 0);
          }
        }, {
          key: "clearRefetchInterval",
          value: function clearRefetchInterval() {
            this.refetchIntervalId && (clearInterval(this.refetchIntervalId), this.refetchIntervalId = void 0);
          }
        }, {
          key: "createResult",
          value: function createResult(t, e) {
            var r,
                n = this.currentQuery,
                i = this.options,
                o = this.currentResult,
                a = this.currentResultState,
                s = this.currentResultOptions,
                c = t !== n,
                l = c ? t.state : this.currentQueryInitialState,
                u = c ? this.currentResult : this.previousQueryResult,
                h = t.state,
                d = h.dataUpdatedAt,
                f = h.error,
                p = h.errorUpdatedAt,
                y = h.fetchStatus,
                g = h.status,
                m = !1,
                v = !1;

            if (e._optimisticResults) {
              var b = this.hasListeners(),
                  x = !b && shouldFetchOnMount(t, e),
                  w = b && shouldFetchOptionally(t, n, e, i);
              (x || w) && (y = canFetch(t.options.networkMode) ? "fetching" : "paused", d || (g = "loading")), "isRestoring" === e._optimisticResults && (y = "idle");
            }

            if (e.keepPreviousData && !h.dataUpdatedAt && null != u && u.isSuccess && "error" !== g) r = u.data, d = u.dataUpdatedAt, g = u.status, m = !0;else if (e.select && "undefined" !== typeof h.data) {
              if (o && h.data === (null == a ? void 0 : a.data) && e.select === this.selectFn) r = this.selectResult;else try {
                this.selectFn = e.select, r = e.select(h.data), r = replaceData(null == o ? void 0 : o.data, r, e), this.selectResult = r, this.selectError = null;
              } catch (_) {
                this.selectError = _;
              }
            } else r = h.data;

            if ("undefined" !== typeof e.placeholderData && "undefined" === typeof r && "loading" === g) {
              var S;
              if (null != o && o.isPlaceholderData && e.placeholderData === (null == s ? void 0 : s.placeholderData)) S = o.data;else if (S = "function" === typeof e.placeholderData ? e.placeholderData() : e.placeholderData, e.select && "undefined" !== typeof S) try {
                S = e.select(S), this.selectError = null;
              } catch (_) {
                this.selectError = _;
              }
              "undefined" !== typeof S && (g = "success", r = replaceData(null == o ? void 0 : o.data, S, e), v = !0);
            }

            this.selectError && (f = this.selectError, r = this.selectResult, p = Date.now(), g = "error");
            var O = "fetching" === y,
                E = "loading" === g,
                k = "error" === g;
            return {
              status: g,
              fetchStatus: y,
              isLoading: E,
              isSuccess: "success" === g,
              isError: k,
              isInitialLoading: E && O,
              data: r,
              dataUpdatedAt: d,
              error: f,
              errorUpdatedAt: p,
              failureCount: h.fetchFailureCount,
              failureReason: h.fetchFailureReason,
              errorUpdateCount: h.errorUpdateCount,
              isFetched: h.dataUpdateCount > 0 || h.errorUpdateCount > 0,
              isFetchedAfterMount: h.dataUpdateCount > l.dataUpdateCount || h.errorUpdateCount > l.errorUpdateCount,
              isFetching: O,
              isRefetching: O && !E,
              isLoadingError: k && 0 === h.dataUpdatedAt,
              isPaused: "paused" === y,
              isPlaceholderData: v,
              isPreviousData: m,
              isRefetchError: k && 0 !== h.dataUpdatedAt,
              isStale: isStale(t, e),
              refetch: this.refetch,
              remove: this.remove
            };
          }
        }, {
          key: "updateResult",
          value: function updateResult(t) {
            var e = this,
                r = this.currentResult,
                n = this.createResult(this.currentQuery, this.options);

            if (this.currentResultState = this.currentQuery.state, this.currentResultOptions = this.options, !shallowEqualObjects(n, r)) {
              this.currentResult = n;
              var i = {
                cache: !0
              };
              !1 !== (null == t ? void 0 : t.listeners) && function shouldNotifyListeners() {
                if (!r) return !0;
                var t = e.options.notifyOnChangeProps;
                if ("all" === t || !t && !e.trackedProps.size) return !0;
                var n = new Set(null != t ? t : e.trackedProps);
                return e.options.useErrorBoundary && n.add("error"), Object.keys(e.currentResult).some(function (t) {
                  var i = t;
                  return e.currentResult[i] !== r[i] && n.has(i);
                });
              }() && (i.listeners = !0), this.notify(Object(G.a)(Object(G.a)({}, i), t));
            }
          }
        }, {
          key: "updateQuery",
          value: function updateQuery() {
            var t = this.client.getQueryCache().build(this.client, this.options);

            if (t !== this.currentQuery) {
              var e = this.currentQuery;
              this.currentQuery = t, this.currentQueryInitialState = t.state, this.previousQueryResult = this.currentResult, this.hasListeners() && (null == e || e.removeObserver(this), t.addObserver(this));
            }
          }
        }, {
          key: "onQueryUpdate",
          value: function onQueryUpdate(t) {
            var e = {};
            "success" === t.type ? e.onSuccess = !t.manual : "error" !== t.type || isCancelledError(t.error) || (e.onError = !0), this.updateResult(e), this.hasListeners() && this.updateTimers();
          }
        }, {
          key: "notify",
          value: function notify(t) {
            var e = this;
            Bo.batch(function () {
              var r, n, i, o;
              if (t.onSuccess) null == (r = (n = e.options).onSuccess) || r.call(n, e.currentResult.data), null == (i = (o = e.options).onSettled) || i.call(o, e.currentResult.data, null);else if (t.onError) {
                var a, s, c, l;
                null == (a = (s = e.options).onError) || a.call(s, e.currentResult.error), null == (c = (l = e.options).onSettled) || c.call(l, void 0, e.currentResult.error);
              }
              t.listeners && e.listeners.forEach(function (t) {
                t(e.currentResult);
              }), t.cache && e.client.getQueryCache().notify({
                query: e.currentQuery,
                type: "observerResultsUpdated"
              });
            });
          }
        }]), QueryObserver;
      }(Ro);

      function shouldFetchOnMount(t, e) {
        return function shouldLoadOnMount(t, e) {
          return !1 !== e.enabled && !t.state.dataUpdatedAt && !("error" === t.state.status && !1 === e.retryOnMount);
        }(t, e) || t.state.dataUpdatedAt > 0 && shouldFetchOn(t, e, e.refetchOnMount);
      }

      function shouldFetchOn(t, e, r) {
        if (!1 !== e.enabled) {
          var n = "function" === typeof r ? r(t) : r;
          return "always" === n || !1 !== n && isStale(t, e);
        }

        return !1;
      }

      function shouldFetchOptionally(t, e, r, n) {
        return !1 !== r.enabled && (t !== e || !1 === n.enabled) && (!r.suspense || "error" !== t.state.status) && isStale(t, r);
      }

      function isStale(t, e) {
        return t.isStaleByTime(e.staleTime);
      }

      var Uo = function (t) {
        Object(A.a)(InfiniteQueryObserver, t);
        var e = Object(P.a)(InfiniteQueryObserver);

        function InfiniteQueryObserver(t, r) {
          return Object(W.a)(this, InfiniteQueryObserver), e.call(this, t, r);
        }

        return Object(N.a)(InfiniteQueryObserver, [{
          key: "bindMethods",
          value: function bindMethods() {
            Object(l.a)(Object(f.a)(InfiniteQueryObserver.prototype), "bindMethods", this).call(this), this.fetchNextPage = this.fetchNextPage.bind(this), this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
          }
        }, {
          key: "setOptions",
          value: function setOptions(t, e) {
            Object(l.a)(Object(f.a)(InfiniteQueryObserver.prototype), "setOptions", this).call(this, Object(G.a)(Object(G.a)({}, t), {}, {
              behavior: infiniteQueryBehavior()
            }), e);
          }
        }, {
          key: "getOptimisticResult",
          value: function getOptimisticResult(t) {
            return t.behavior = infiniteQueryBehavior(), Object(l.a)(Object(f.a)(InfiniteQueryObserver.prototype), "getOptimisticResult", this).call(this, t);
          }
        }, {
          key: "fetchNextPage",
          value: function fetchNextPage() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                e = t.pageParam,
                r = Object(U.a)(t, ot);
            return this.fetch(Object(G.a)(Object(G.a)({}, r), {}, {
              meta: {
                fetchMore: {
                  direction: "forward",
                  pageParam: e
                }
              }
            }));
          }
        }, {
          key: "fetchPreviousPage",
          value: function fetchPreviousPage() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                e = t.pageParam,
                r = Object(U.a)(t, at);
            return this.fetch(Object(G.a)(Object(G.a)({}, r), {}, {
              meta: {
                fetchMore: {
                  direction: "backward",
                  pageParam: e
                }
              }
            }));
          }
        }, {
          key: "createResult",
          value: function createResult(t, e) {
            var r,
                n,
                i,
                o,
                a,
                s,
                c = t.state,
                u = Object(l.a)(Object(f.a)(InfiniteQueryObserver.prototype), "createResult", this).call(this, t, e),
                h = u.isFetching,
                d = u.isRefetching,
                p = h && "forward" === (null == (r = c.fetchMeta) ? void 0 : null == (n = r.fetchMore) ? void 0 : n.direction),
                y = h && "backward" === (null == (i = c.fetchMeta) ? void 0 : null == (o = i.fetchMore) ? void 0 : o.direction);
            return Object(G.a)(Object(G.a)({}, u), {}, {
              fetchNextPage: this.fetchNextPage,
              fetchPreviousPage: this.fetchPreviousPage,
              hasNextPage: hasNextPage(e, null == (a = c.data) ? void 0 : a.pages),
              hasPreviousPage: hasPreviousPage(e, null == (s = c.data) ? void 0 : s.pages),
              isFetchingNextPage: p,
              isFetchingPreviousPage: y,
              isRefetching: d && !p && !y
            });
          }
        }]), InfiniteQueryObserver;
      }(Fo),
          Wo = {
        exports: {}
      },
          zo = {},
          qo = Z.a;

      var Ho = "function" === typeof Object.is ? Object.is : function h3(t, e) {
        return t === e && (0 !== t || 1 / t === 1 / e) || t !== t && e !== e;
      },
          Go = qo.useState,
          Yo = qo.useEffect,
          Xo = qo.useLayoutEffect,
          Vo = qo.useDebugValue;

      function r(t) {
        var e = t.getSnapshot;
        t = t.value;

        try {
          var r = e();
          return !Ho(t, r);
        } catch (n) {
          return !0;
        }
      }

      var $o = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? function t2(t, e) {
        return e();
      } : function q2(t, e) {
        var n = e(),
            i = Go({
          inst: {
            value: n,
            getSnapshot: e
          }
        }),
            o = i[0].inst,
            a = i[1];
        return Xo(function () {
          o.value = n, o.getSnapshot = e, r(o) && a({
            inst: o
          });
        }, [t, n, e]), Yo(function () {
          return r(o) && a({
            inst: o
          }), t(function () {
            r(o) && a({
              inst: o
            });
          });
        }, [t]), Vo(n), n;
      };
      zo.useSyncExternalStore = void 0 !== qo.useSyncExternalStore ? qo.useSyncExternalStore : $o, Wo.exports = zo;
      var Qo = Wo.exports.useSyncExternalStore,
          Ko = $.createContext(void 0),
          Zo = $.createContext(!1);

      function getQueryClientContext(t, e) {
        return t || (e && "undefined" !== typeof window ? (window.ReactQueryClientContext || (window.ReactQueryClientContext = Ko), window.ReactQueryClientContext) : Ko);
      }

      var Jo = function useQueryClient() {
        var t = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).context,
            e = $.useContext(getQueryClientContext(t, $.useContext(Zo)));
        if (!e) throw new Error("No QueryClient set, use QueryClientProvider to set one");
        return e;
      },
          ta = $.createContext(!1),
          ea = function useIsRestoring() {
        return $.useContext(ta);
      };

      ta.Provider;

      var ra = $.createContext(function createValue() {
        var t = !1;
        return {
          clearReset: function clearReset() {
            t = !1;
          },
          reset: function reset() {
            t = !0;
          },
          isReset: function isReset() {
            return t;
          }
        };
      }()),
          na = function useQueryErrorResetBoundary() {
        return $.useContext(ra);
      };

      var ia = function ensurePreventErrorBoundaryRetry(t, e) {
        (t.suspense || t.useErrorBoundary) && (e.isReset() || (t.retryOnMount = !1));
      },
          oa = function useClearResetErrorBoundary(t) {
        $.useEffect(function () {
          t.clearReset();
        }, [t]);
      },
          aa = function getHasError(t) {
        var e = t.result,
            r = t.errorResetBoundary,
            n = t.useErrorBoundary,
            i = t.query;
        return e.isError && !r.isReset() && !e.isFetching && function shouldThrowError(t, e) {
          return "function" === typeof t ? t.apply(void 0, Object(E.a)(e)) : !!t;
        }(n, [e.error, i]);
      },
          sa = function ensureStaleTime(t) {
        t.suspense && "number" !== typeof t.staleTime && (t.staleTime = 1e3);
      },
          ca = function willFetch(t, e) {
        return t.isLoading && t.isFetching && !e;
      },
          la = function shouldSuspend(t, e, r) {
        return (null == t ? void 0 : t.suspense) && ca(e, r);
      },
          ua = function fetchOptimistic(t, e, r) {
        return e.fetchOptimistic(t).then(function (e) {
          var r = e.data;
          null == t.onSuccess || t.onSuccess(r), null == t.onSettled || t.onSettled(r, null);
        }).catch(function (e) {
          r.clearReset(), null == t.onError || t.onError(e), null == t.onSettled || t.onSettled(void 0, e);
        });
      };

      function useBaseQuery(t, e) {
        var r = Jo({
          context: t.context
        }),
            n = ea(),
            i = na(),
            o = r.defaultQueryOptions(t);
        o._optimisticResults = n ? "isRestoring" : "optimistic", o.onError && (o.onError = Bo.batchCalls(o.onError)), o.onSuccess && (o.onSuccess = Bo.batchCalls(o.onSuccess)), o.onSettled && (o.onSettled = Bo.batchCalls(o.onSettled)), sa(o), ia(o, i), oa(i);
        var a = $.useState(function () {
          return new e(r, o);
        }),
            s = Object(V.a)(a, 1)[0],
            c = s.getOptimisticResult(o);
        if (Qo($.useCallback(function (t) {
          return n ? function () {} : s.subscribe(Bo.batchCalls(t));
        }, [s, n]), function () {
          return s.getCurrentResult();
        }, function () {
          return s.getCurrentResult();
        }), $.useEffect(function () {
          s.setOptions(o, {
            listeners: !1
          });
        }, [o, s]), la(o, c, n)) throw ua(o, s, i);
        if (aa({
          result: c,
          errorResetBoundary: i,
          useErrorBoundary: o.useErrorBoundary,
          query: s.getCurrentQuery()
        })) throw c.error;
        return o.notifyOnChangeProps ? c : s.trackResult(c);
      }

      function useQuery(t, e, r) {
        return useBaseQuery(parseQueryArgs(t, e, r), Fo);
      }

      var ha = compose(It, be(function createDimension(t, e) {
        return "".concat(e, "=").concat(t);
      }), Me(compose(Ft, Lt))),
          da = function createMetric(t, e) {
        return "".concat(t, ":").concat(ha(e).join(";"));
      },
          fa = function getIdAgnosticPathname() {
        return window.location.pathname.split("/").map(function (t) {
          return isNaN(Number(t)) ? t : 0 == t.length ? "" : "-";
        }).join("/");
      },
          pa = function CubePerformanceMetricBuilder() {
        var t = this;
        Object(W.a)(this, CubePerformanceMetricBuilder), this.withView = function (e) {
          return t.metric.viewName = e, t;
        }, this.withBuckets = function (e) {
          return t.metric.buckets = e.join(", "), t;
        }, this.withExecutionTime = function (e) {
          return t.metric.executionTime = e, t;
        }, this.withTimezone = function (e) {
          return e && (t.metric.timezone = e), t;
        }, this.build = function () {
          return {
            metric: da("cubeChart.loadTime.buckets", {
              page: fa(),
              timezone: t.metric.timezone,
              view: t.metric.viewName
            }),
            value: t.metric.executionTime,
            dimensions: {
              type: "bucket",
              buckets: t.metric.buckets || "300, 500, 1000, 5000, 10000, 30000"
            }
          };
        }, this.metric = {};
      },
          ya = 100,
          ga = 5e3,
          ma = new (function (t) {
        Object(A.a)(PerformanceMetricEventBuffer, t);
        var e = Object(P.a)(PerformanceMetricEventBuffer);

        function PerformanceMetricEventBuffer() {
          var t;
          return Object(W.a)(this, PerformanceMetricEventBuffer), (t = e.call(this, ga))._publishBuffer = Object(v.a)(g.a.mark(function _callee26() {
            return g.a.wrap(function _callee26$(e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return t._events.length || Promise.reject(new Error("No events available")), e.prev = 1, e.next = 4, Ji(t._events);

                  case 4:
                    t._resetBuffer(), e.next = 11;
                    break;

                  case 7:
                    e.prev = 7, e.t0 = e.catch(1), t._events.length >= ya && t._resetBuffer(), io(new Error("Failed to send bulk reporting metrics", {
                      cause: e.t0
                    }));

                  case 11:
                  case "end":
                    return e.stop();
                }
              }
            }, _callee26, null, [[1, 7]]);
          })), t;
        }

        return PerformanceMetricEventBuffer;
      }(function EventBuffer() {
        var t = this,
            e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 2e3;
        Object(W.a)(this, EventBuffer), this._startPublishTimer = function () {
          t._eventBufferTimer = window.setTimeout(t._publishBuffer, t._bufferTime);
        }, this._resetBuffer = function () {
          t._events = [], t._eventBufferTimer && (window.clearTimeout(t._eventBufferTimer), t._eventBufferTimer = null);
        }, this._publishBuffer = function () {
          io(new Error("You must implement the _publishBuffer method in your extension of eventBuffer"));
        }, this.push = function () {
          var e = Object(v.a)(g.a.mark(function _callee25(e) {
            return g.a.wrap(function _callee25$(r) {
              for (;;) {
                switch (r.prev = r.next) {
                  case 0:
                    t._events.push(e), t._eventBufferTimer || t._startPublishTimer();

                  case 2:
                  case "end":
                    return r.stop();
                }
              }
            }, _callee25);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(), this._resetBuffer(), this._events = [], this._eventBufferTimer = null, this._bufferTime = e;
      }))(),
          va = function extrapolateCacheKeys(t) {
        var e,
            r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [],
            i = arguments.length > 3 ? arguments[3] : void 0,
            o = [t, null != (e = Ai.get("DrifttAuth")) ? e : ""],
            a = function formatTimeDimensionCacheKeys(t) {
          return t.map(function (t) {
            var e = t.dimension,
                r = t.dateRange;
            if (!r || 2 !== r.length) return e;

            var n = function toTimestamp(t) {
              return isNaN(new Date(t).getMonth()) ? new Date().getTime() : new Date(t).getTime();
            };

            return "".concat(e, "-").concat(n(r[0]), "-").concat(n(r[1]));
          });
        }(r),
            s = function formatFilterCacheKeys(t) {
          return t.map(function (t) {
            var e = Te(!1, ["or"], t),
                r = Te(!1, ["and"], t);
            if (e || r) return "";
            var n = Pt(["member"], t),
                i = Pt(["operator"], t),
                o = Te([], ["values"], t);
            return "".concat(n, "-").concat(i, "-").concat(le(o).join("-"));
          });
        }(n),
            c = function formatOrderCacheKeys(t) {
          return Array.isArray(t) ? t.map(function (t) {
            return "".concat(t[0], "-").concat(t[1]);
          }) : [Object.entries(t).join("-")];
        }(i);

        return Re(a) || o.push.apply(o, Object(E.a)(a)), Re(s) || o.push.apply(o, Object(E.a)(s)), Re(c) || o.push.apply(o, Object(E.a)(c)), o;
      },
          ba = function () {
        var t = Object(v.a)(g.a.mark(function _callee27(t) {
          var e, r, n, i, o, a, s;
          return g.a.wrap(function _callee27$(c) {
            for (;;) {
              switch (c.prev = c.next) {
                case 0:
                  return e = t.name, r = t.timezone, n = t.queryFn, i = performance.now(), c.next = 4, n();

                case 4:
                  return o = c.sent, a = performance.now(), s = new pa().withTimezone(r).withExecutionTime(a - i).withView(e).build(), ma.push(s), c.abrupt("return", o);

                case 9:
                case "end":
                  return c.stop();
              }
            }
          }, _callee27);
        }));
        return function executeMeasuredCubeQuery(e) {
          return t.apply(this, arguments);
        };
      }(),
          xa = function useInfiniteCubeQuery(t) {
        var e,
            r = t.query,
            n = t.limit,
            i = void 0 === n ? 25 : n,
            o = t.options,
            a = void 0 === o ? {} : o,
            s = jo().cubeJsApi,
            c = new co({
          query: r
        }).withLimit(i).withBrowserTimezone().build(),
            l = c.query,
            u = c.name,
            h = function useInfiniteQuery(t, e, r) {
          return useBaseQuery(parseQueryArgs(t, e, r), Uo);
        }(Object(G.a)({
          queryKey: [["cube-infinite-query"]].concat(Object(E.a)(va(u, l.timeDimensions, l.filters, null != (e = l.order) ? e : []))),
          enabled: !1,
          queryFn: function () {
            var t = Object(v.a)(g.a.mark(function _callee29(t) {
              var e, r, n;
              return g.a.wrap(function _callee29$(o) {
                for (;;) {
                  switch (o.prev = o.next) {
                    case 0:
                      return e = t.pageParam, r = void 0 === e ? 0 : e, o.next = 3, s.load(Object(G.a)(Object(G.a)({}, l), {}, {
                        offset: r * i
                      }));

                    case 3:
                      return n = o.sent, o.abrupt("return", n.tablePivot());

                    case 5:
                    case "end":
                      return o.stop();
                  }
                }
              }, _callee29);
            }));
            return function queryFn(e) {
              return t.apply(this, arguments);
            };
          }(),
          getNextPageParam: function getNextPageParam(t, e) {
            if (!(t.length < i)) return e.length;
          },
          select: function select(t) {
            return {
              pages: t.pages.map(function (t) {
                return xn(t);
              }),
              pageParams: t.pageParams
            };
          },
          staleTime: 3e4,
          retry: 2,
          keepPreviousData: !0
        }, null == a ? void 0 : a.reactQueryOptions)),
            d = h.data,
            f = h.error,
            p = h.refetch,
            y = h.fetchNextPage,
            m = h.hasNextPage,
            b = h.isFetching,
            x = h.isFetchingNextPage,
            w = h.isLoading;

        return {
          data: d,
          flatData: null == d ? void 0 : d.pages.flat(),
          error: f,
          fetchInitialData: p,
          fetchNextPage: y,
          hasNextPage: m,
          isLoading: w,
          isFetching: b,
          isFetchingNextPage: x
        };
      },
          wa = function downloadCSVInUI(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "export",
            r = document.createElement("a");
        r.setAttribute("href", t), r.setAttribute("download", "".concat(e, ".csv")), document.body.appendChild(r), r.click();
      },
          Sa = function useCubeExport(t) {
        var e,
            r = t.query,
            n = t.enabled,
            i = t.exportFileName,
            o = t.onExportSuccess,
            a = t.onExportError,
            s = t.options,
            c = void 0 === s ? {} : s,
            l = r.query,
            u = r.name;
        return l.timezone || (l.timezone = oo()), useQuery(Object(G.a)({
          queryKey: [["cube-export"]].concat(Object(E.a)(va(u, l.timeDimensions, l.filters, null != (e = l.order) ? e : []))),
          queryFn: function () {
            var t = Object(v.a)(g.a.mark(function _callee30() {
              return g.a.wrap(function _callee30$(t) {
                for (;;) {
                  switch (t.prev = t.next) {
                    case 0:
                      return t.abrupt("return", ba({
                        name: u,
                        timezone: l.timezone,
                        queryFn: function queryFn() {
                          return to(r.query);
                        }
                      }));

                    case 1:
                    case "end":
                      return t.stop();
                  }
                }
              }, _callee30);
            }));
            return function queryFn() {
              return t.apply(this, arguments);
            };
          }(),
          staleTime: 3e4,
          retry: 2,
          enabled: n,
          refetchOnWindowFocus: !1,
          onSuccess: function onSuccess(t) {
            var e;
            !function createCSVDownload(t) {
              var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "export",
                  r = new Blob([t], {
                type: "text/csv"
              }),
                  n = URL.createObjectURL(r),
                  i = encodeURI(n);
              wa(i, e);
            }(null != (e = null == t ? void 0 : t.csvData) ? e : "", null != i ? i : "Drift"), o && o();
          },
          onError: function onError(t) {
            console.error(t), a && a();
          }
        }, null == c ? void 0 : c.reactQueryOptions));
      },
          Oa = function datesAreEqual(t, e) {
        return Gt(Vr.DATE(t), Vr.DATE(e));
      },
          Ea = function formatExportFileName(t, e, r) {
        return "Drift_".concat(function formatTextWithUnderscores(t) {
          var e;
          return null == (e = Vr.TITLE_CASE(t)) ? void 0 : e.replace(/\s+/g, "_");
        }(t), "_").concat(function formatExportDateRange(t, e) {
          return Oa(t, e) ? "".concat(Vr.DATE_DASH(t)) : "".concat(Vr.DATE_DASH(t), "_to_").concat(Vr.DATE_DASH(e));
        }(e, r));
      },
          ka = Object(J.styled)(J.Box, {
        width: 1,
        height: "$2",
        backgroundColor: "$gray3"
      }),
          _a = Object(J.createComponentContext)("DrillDownDataModal", {
        tableData: [],
        isLoading: !0
      }),
          Ca = Object(V.a)(_a, 2),
          Ta = Ca[0];

      Ca[1];
      (function DrillDownDataModal(t) {
        var e = t.title,
            r = t.open,
            n = t.onClose,
            i = t.totalRecords,
            o = void 0 === i ? 0 : i,
            a = t.startDate,
            s = t.endDate,
            c = t.cubeQuery,
            l = t.exportCubeQuery,
            u = void 0 === l ? c : l,
            h = t.filters,
            d = t.children,
            f = t.onExportTriggered,
            p = Object($.useRef)(null),
            y = Object(J.useToast)(),
            g = Sa({
          query: u,
          enabled: !1,
          exportFileName: Ea(e, a, s),
          onExportSuccess: function onExportSuccess() {
            return function handleExportSuccess() {
              y({
                message: "Successfully exported CSV",
                variant: "success"
              });
            }();
          },
          onExportError: function onExportError() {
            return function handleExportError() {
              y({
                message: "Error exporting CSV",
                variant: "error"
              });
            }();
          }
        }),
            m = g.isInitialLoading,
            v = g.refetch,
            b = xa({
          query: c,
          limit: 25
        }),
            x = b.flatData,
            w = void 0 === x ? [] : x,
            S = b.isLoading,
            O = b.fetchNextPage,
            E = b.fetchInitialData,
            k = b.hasNextPage,
            _ = b.isFetchingNextPage,
            C = Object($.useCallback)(function (t) {
          if (t) {
            var e = t.scrollHeight;
            e - t.scrollTop - t.clientHeight < e / 5 && !S && !_ && k && O();
          }
        }, [O, S, _, k]);
        Object($.useEffect)(function () {
          C(p.current);
        }, [C]), Object($.useEffect)(function () {
          r && E();
        }, [r, E]);
        var T = Object($.useMemo)(function () {
          return function formatDateRangeDisplay(t, e) {
            return Oa(t, e) ? Vr.DATE(t) : "".concat(Vr.DATE(t), " - ").concat(Vr.DATE(e));
          }(a, s);
        }, [a, s]),
            A = Object($.useCallback)(function () {
          f && f(e, a, s, null != o ? o : 0), v();
        }, [v, f, e, a, s, o]);
        return r ? er(Ta, {
          tableData: w,
          isLoading: S,
          children: er(J.Modal.Root, {
            open: r,
            onClose: n,
            children: rr(J.Modal.Dialog, {
              size: "x-large",
              variant: "info",
              xlColumnSize: "100-0",
              preventContentAutoFocusOnOpen: !0,
              fullWidth: !0,
              children: [er(J.Modal.Title, {
                title: e,
                subtitle: T,
                children: rr(J.Flex, {
                  alignItems: "center",
                  css: {
                    paddingTop: "$2"
                  },
                  children: [rr(J.Text, {
                    children: ["Showing", " ", er(J.Text, {
                      as: "span",
                      variant: "bodyBold",
                      children: "".concat(Vr.RAW_HUMANIZED(null != o ? o : 0), " ").concat(Vr.PLURALIZE(null != o ? o : 0, "record"))
                    })]
                  }), null == h ? void 0 : h.map(function (t) {
                    return rr(J.Flex, {
                      alignItems: "center",
                      children: [er(ka, {
                        role: "none"
                      }), er(bn, Object(G.a)({}, t))]
                    }, t.filterKey);
                  })]
                })
              }), er(J.Modal.Content, {
                fullWidth: !0,
                onScroll: function onScroll(t) {
                  return C(t.target);
                },
                ref: p,
                css: {
                  background: "transparent",
                  padding: 0
                },
                children: er(J.Skeleton, {
                  isLoading: S,
                  height: "400px",
                  children: d
                })
              }), er(J.Modal.Actions, {
                justifyContent: "flex-end",
                children: er(J.Button, {
                  variant: "primary",
                  loading: m,
                  onClick: A,
                  children: "Export CSV"
                })
              })]
            })
          })
        }) : null;
      }).displayName = "DrillDownDataModal";
      var Aa = {};
      Object.defineProperty(Aa, "__esModule", {
        value: !0
      });
      var Ma = Aa.faCircleInfo = void 0;
      Ma = Aa.faCircleInfo = {
        prefix: "fal",
        iconName: "faCircleInfo",
        icon: [512, 512, [], "", "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 480c-123.5 0-224-100.5-224-224s100.5-224 224-224s224 100.5 224 224S379.5 480 256 480zM256 184c13.25 0 24-10.74 24-24c0-13.25-10.75-24-24-24S232 146.7 232 160C232 173.3 242.7 184 256 184zM304 352h-32V240C272 231.2 264.8 224 256 224H224C215.2 224 208 231.2 208 240S215.2 256 224 256h16v96h-32C199.2 352 192 359.2 192 368C192 376.8 199.2 384 208 384h96c8.836 0 16-7.164 16-16C320 359.2 312.8 352 304 352z"]
      };
      var Pa = Object(J.styled)(J.Card, {
        width: "100%"
      }),
          ja = Object($.forwardRef)(function (t, e) {
        var r = t.children,
            n = t.css,
            i = t.rootProps,
            o = Object(U.a)(t, st);
        return er(Pa, Object(G.a)(Object(G.a)(Object(G.a)({
          ref: e,
          css: n
        }, o), i), {}, {
          children: r
        }));
      });
      ja.displayName = "ChartCard";
      var Ra = Object(J.styled)(function ChartCardHeaderComponent(t) {
        var e = t.title,
            r = t.subtitle,
            n = t.action,
            i = t.tooltip;
        return rr(J.Card.Header, {
          as: J.Flex,
          justifyContent: "space-between",
          children: [rr(J.Flex, {
            direction: "column",
            children: [i ? rr(J.Flex, {
              alignItems: "baseline",
              children: [er(J.Header, {
                variant: "h3",
                title: e,
                children: e
              }), er(J.Tooltip, {
                content: i,
                title: void 0,
                children: er(J.Icon, {
                  icon: Ma
                })
              })]
            }) : er(J.Header, {
              variant: "h3",
              children: e
            }), er(J.Text, {
              variant: "metadata",
              children: r
            })]
          }), n]
        });
      }),
          Da = Object(J.styled)(function ChartCardContentComponent(t) {
        var e = t.children;
        return er(J.Card.Content, {
          as: J.Flex,
          fullHeight: !0,
          children: e
        });
      }),
          Ia = Object(J.styled)("div"),
          La = Object(J.styled)("div"),
          Na = (Object(G.a)(Object(G.a)({}, ja), {}, {
        Header: Ra,
        Content: Da,
        Action: Ia,
        Drilldown: La
      }), {
        align: "center",
        floating: !0,
        verticalAlign: "middle",
        useHTML: !0,
        x: -72,
        y: 35
      }),
          Ba = {
        chart: {
          type: "pie"
        },
        title: Object(G.a)(Object(G.a)({}, Na), {}, {
          style: {
            color: "var(--drift-dds-colors-gray12)",
            fontFamily: "var(--drift-dds-fonts-primary)",
            fontSize: "var(--drift-dds-fontSizes-metric)",
            fontWeight: "var(--drift-dds-fontWeights-metric)",
            lineHeight: "var(--drift-dds-lineHeights-metric)",
            letterSpacing: "var(--drift-dds-letterSpacings-metric)"
          }
        }),
        subtitle: Object(G.a)(Object(G.a)({}, Na), {}, {
          y: 47,
          style: {
            color: "var(--drift-dds-colors-gray8)",
            fontFamily: "var(--drift-dds-fonts-primary)",
            fontSize: "var(--drift-dds-fontSizes-body)",
            fontWeight: "var(--drift-dds-fontWeights-body)",
            lineHeight: "var(--drift-dds-lineHeights-body)",
            letterSpacing: "var(--drift-dds-letterSpacings-body)"
          }
        }),
        legend: {
          squareSymbol: !0,
          symbolRadius: 2,
          symbolWidth: 12,
          symbolHeight: 12,
          itemMarginTop: 8,
          itemMarginBottom: 8,
          align: "right",
          verticalAlign: "middle",
          layout: "vertical",
          itemStyle: {
            color: "var(--drift-dds-colors-gray10)",
            fontFamily: "var(--drift-dds-fonts-primary)",
            fontSize: "var(--drift-dds-fontSizes-2)",
            fontWeight: "var(--drift-dds-fontWeights-body)",
            lineHeight: "var(--drift-dds-lineHeights-body)",
            letterSpacing: "var(--drift-dds-letterSpacings-body)"
          }
        }
      },
          Fa = (ke(un, Ba), function (t) {
        return t.RECTANGLE = "rectangle", t.LINE = "line", t;
      }(Fa || {})),
          Ua = (Object(J.styled)("span", {
        height: "12px",
        width: "12px",
        border: "1px solid $green3",
        borderRadius: "$1",
        variants: {
          shape: {
            rectangle: {
              width: "12px",
              border: "1px solid $green8"
            },
            line: {
              border: "2px solid $red6",
              width: "2px",
              margin: "0 4px"
            }
          }
        },
        defaultVariants: {
          shape: Fa.RECTANGLE
        }
      }), {});
      Object.defineProperty(Ua, "__esModule", {
        value: !0
      });
      Ua.faChevronLeft = void 0;
      Ua.faChevronLeft = {
        prefix: "fal",
        iconName: "faChevronLeft",
        icon: [320, 512, [], "", "M234.8 36.25c3.438 3.141 5.156 7.438 5.156 11.75c0 3.891-1.406 7.781-4.25 10.86L53.77 256l181.1 197.1c6 6.5 5.625 16.64-.9062 22.61c-6.5 6-16.59 5.594-22.59-.8906l-192-208c-5.688-6.156-5.688-15.56 0-21.72l192-208C218.2 30.66 228.3 30.25 234.8 36.25z"]
      };
      var Wa = {};
      Object.defineProperty(Wa, "__esModule", {
        value: !0
      });
      Wa.faChevronRight = void 0;
      Wa.faChevronRight = {
        prefix: "fal",
        iconName: "faChevronRight",
        icon: [320, 512, [], "", "M85.14 475.8c-3.438-3.141-5.156-7.438-5.156-11.75c0-3.891 1.406-7.781 4.25-10.86l181.1-197.1L84.23 58.86c-6-6.5-5.625-16.64 .9062-22.61c6.5-6 16.59-5.594 22.59 .8906l192 208c5.688 6.156 5.688 15.56 0 21.72l-192 208C101.7 481.3 91.64 481.8 85.14 475.8z"]
      };

      var za = function (t) {
        return t.WEEK = "week", t.DAY = "day", t;
      }(za || {}),
          qa = function (t) {
        return t[t.week = 7] = "week", t[t.day = 24] = "day", t;
      }(qa || {}),
          Ha = function (t) {
        return t.BODY = "body", t.HEADER = "header", t;
      }(Ha || {}),
          Ga = za.DAY,
          Ya = {
        week: {
          gridTemplateColumns: "repeat(".concat(qa.week, ", 1fr)")
        },
        day: {
          gridTemplateColumns: "repeat(".concat(qa.day, ", 1fr)")
        }
      },
          Xa = {
        clickable: {
          "&:hover": {
            cursor: "pointer"
          }
        },
        non_clickable: {
          "&:hover": {
            cursor: "unset"
          }
        }
      },
          Va = (Object(J.styled)(J.SimpleGrid, {
        overflowX: "hidden",
        variants: {
          layout: {
            regular: {
              gridTemplateColumns: "1fr"
            },
            withSidebar: {
              gridTemplateColumns: "minmax(100px, 300px) 1fr"
            }
          }
        },
        defaultVariants: {
          layout: "regular"
        }
      }), Object(J.styled)(J.SimpleGrid, {
        border: "1px solid $gray3",
        gridTemplateRows: "var(--drift-dds-sizes-4) 1fr"
      }), Object(J.styled)(J.SimpleGrid, {
        overflowX: "scroll"
      }), Object(J.styled)(J.SimpleGrid, {
        textAlign: "center",
        borderCollapse: "collapse",
        variants: {
          type: {
            body: {
              height: "$7"
            },
            header: {
              height: "$4"
            }
          },
          view: Ya
        },
        defaultVariants: {
          type: "body"
        }
      }), Object(J.styled)(J.Flex, {
        position: "relative",
        outline: "1px solid $gray3",
        minWidth: "120px",
        padding: 0,
        variants: {
          type: {
            body: {
              backgroundColor: "$white",
              alignItems: "center"
            },
            header: {
              backgroundColor: "$gray2",
              textOverflow: "ellipsis",
              overflow: "hidden",
              alignItems: "center"
            }
          }
        },
        defaultVariants: {
          type: "body"
        }
      })),
          $a = (Object(J.styled)("div", {
        position: "absolute",
        height: "20px",
        zIndex: "$default",
        background: "$green2",
        border: "1px solid $green3",
        borderRadius: "$1",
        "&:hover": {
          background: "$green3"
        },
        variants: {
          clickable: Xa
        },
        defaultVariants: {
          clickable: "non_clickable"
        }
      }), Object(J.styled)(J.Flex, {
        position: "absolute",
        height: "20px",
        width: "6px",
        background: "transparent",
        transform: "translate(-50%, 0)",
        justifyContent: "center",
        zIndex: "calc($default + 1)",
        variants: {
          clickable: Xa
        },
        defaultVariants: {
          clickable: "non_clickable"
        }
      }), Object(J.styled)("div", {
        height: "20px",
        width: "1px",
        variants: {
          type: {
            success: {
              border: "1px solid  $green8"
            },
            error: {
              border: "1px solid  $red6"
            }
          }
        },
        defaultVariants: {
          type: "body"
        }
      }), Object(J.styled)(J.Flex, {
        zIndex: "$tooltip",
        backgroundColor: "$transparent",
        paddingX: "$1",
        paddingY: "$half"
      }), Object(J.styled)(J.Flex, {
        width: "100%",
        borderTopLeftRadius: "$1",
        borderTopRightRadius: "$1",
        textStyles: "metadata",
        textColor: "metadata",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }), Object(J.styled)(J.SimpleGrid, {
        outline: "1px solid $gray3",
        margin: "0 1px 1px 1px",
        paddingTop: 1
      }), Object(J.styled)(J.Box, {
        borderRight: "1px solid $gray3",
        height: "100%",
        borderStyle: "none dashed none none"
      })),
          Qa = Object(J.styled)(J.Text, {
        position: "absolute",
        bottom: 0,
        textAlign: "center",
        width: "100%"
      });

      Object(J.styled)("div", {
        position: "absolute",
        height: "20px",
        zIndex: "$default"
      });
      var Ka = Object($.forwardRef)(function (t, e) {
        var r = t.children,
            n = t.withDashedDividers,
            i = void 0 !== n && n,
            o = t.type,
            a = void 0 === o ? Ha.BODY : o,
            s = t.withMiddleTimeLabel,
            c = void 0 !== s && s,
            l = t.isNoonLabel,
            u = t.cellDate,
            h = Object(U.a)(t, ct);
        return rr(Va, Object(G.a)(Object(G.a)({
          type: a
        }, h), {}, {
          ref: e,
          children: [r, a === Ha.BODY && i && rr(J.Flex, {
            fullHeight: !0,
            fullWidth: !0,
            gap: 0,
            children: [er($a, {
              fullWidth: !0
            }), er($a, {
              fullWidth: !0
            }), er($a, {
              fullWidth: !0
            }), er(J.Box, {
              fullWidth: !0
            })]
          }), a === Ha.BODY && u && c && er(Qa, {
            variant: "metadata",
            css: {
              fontSize: "10px",
              color: "$gray4"
            },
            children: Vr.TIME(l ? u : addMinutes(u, 30))
          })]
        }));
      });
      Ka.displayName = "GanttCell";
      var Za = Object(J.createComponentContext)("Gantt", {
        ganttViewType: Ga,
        startDate: new Date(),
        columnsToDisplay: 7,
        isLoading: !0,
        options: {
          chart: {
            isMiddleTimeLabelEnabled: !0,
            showBodyCellDashedDividers: !0,
            loadingState: {
              dateNavigationHeader: {
                renderSkeleton: !0
              }
            },
            weekIsMondayToSunday: !1,
            showLastDayOfWeekWhenSwitchingToDayView: !1,
            defaultViewType: "week",
            emptyState: {
              title: "No data for this timeframe",
              message: "Select a different date range to see this chart",
              minHeight: 300
            },
            scrollToColumnIndexOnLoad: 0
          },
          debug: !1
        }
      }),
          Ja = Object(V.a)(Za, 2);
      Ja[0], Ja[1];
    }).call(this, n(37));
  }, function (t, e, r) {
    "use strict";

    t.exports = r(83);
  }, function (t, e, r) {
    "use strict";

    function _isNativeReflectConstruct() {
      if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" === typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }

    r.d(e, "a", function () {
      return _isNativeReflectConstruct;
    });
  }, function (t, e) {
    t.exports = i;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.faGlobe = void 0;
    e.faGlobe = {
      prefix: "fal",
      iconName: "faGlobe",
      icon: [512, 512, [], "", "M256 16C123.5 16 16 123.5 16 256s107.5 240 240 240s239.1-107.5 239.1-240S388.5 16 256 16zM464 256c0 22.34-3.633 43.82-10.18 64h-74.56c3.008-20.4 4.744-41.8 4.744-64s-1.736-43.6-4.744-64h74.56C460.4 212.2 464 233.7 464 256zM256 464c-32.23 0-66.98-43.18-84.49-112h168.1C322.1 420.8 288.2 464 256 464zM164.9 320C161.8 300.1 160 278.7 160 256s1.754-44.14 4.875-64h182.3c3.121 19.86 4.875 41.28 4.875 64s-1.754 44.14-4.875 64H164.9zM48 256c0-22.34 3.633-43.82 10.18-64h74.56c-3.008 20.4-4.744 41.8-4.744 64s1.736 43.6 4.744 64H58.18C51.63 299.8 48 278.3 48 256zM256 48c32.23 0 66.98 43.18 84.49 112H171.5C189 91.18 223.8 48 256 48zM440.3 160H373.3c-9.131-39.15-23.7-72.71-41.88-97.64C378.4 80.73 417.1 115.6 440.3 160zM180.6 62.36C162.4 87.29 147.9 120.8 138.7 160H71.66C94.87 115.6 133.6 80.73 180.6 62.36zM71.66 352H138.7c9.131 39.15 23.7 72.71 41.88 97.64C133.6 431.3 94.87 396.4 71.66 352zM331.4 449.6C349.6 424.7 364.1 391.2 373.3 352h67.06C417.1 396.4 378.4 431.3 331.4 449.6z"]
    };
  }, function (t, e, r) {
    !function webpackUniversalModuleDefinition(e, n) {
      t.exports = n(r(12));
    }(window, function (t) {
      return function (t) {
        var e = {};

        function __webpack_require__(r) {
          if (e[r]) return e[r].exports;
          var n = e[r] = {
            i: r,
            l: !1,
            exports: {}
          };
          return t[r].call(n.exports, n, n.exports, __webpack_require__), n.l = !0, n.exports;
        }

        return __webpack_require__.m = t, __webpack_require__.c = e, __webpack_require__.d = function (t, e, r) {
          __webpack_require__.o(t, e) || Object.defineProperty(t, e, {
            enumerable: !0,
            get: r
          });
        }, __webpack_require__.r = function (t) {
          "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
          }), Object.defineProperty(t, "__esModule", {
            value: !0
          });
        }, __webpack_require__.t = function (t, e) {
          if (1 & e && (t = __webpack_require__(t)), 8 & e) return t;
          if (4 & e && "object" === typeof t && t && t.__esModule) return t;
          var r = Object.create(null);
          if (__webpack_require__.r(r), Object.defineProperty(r, "default", {
            enumerable: !0,
            value: t
          }), 2 & e && "string" != typeof t) for (var n in t) {
            __webpack_require__.d(r, n, function (e) {
              return t[e];
            }.bind(null, n));
          }
          return r;
        }, __webpack_require__.n = function (t) {
          var e = t && t.__esModule ? function getDefault() {
            return t.default;
          } : function getModuleExports() {
            return t;
          };
          return __webpack_require__.d(e, "a", e), e;
        }, __webpack_require__.o = function (t, e) {
          return Object.prototype.hasOwnProperty.call(t, e);
        }, __webpack_require__.p = "/", __webpack_require__(__webpack_require__.s = 20);
      }([function (t, e, r) {
        "use strict";

        var n = r(6),
            i = Object.prototype.toString;

        function isArray(t) {
          return "[object Array]" === i.call(t);
        }

        function isUndefined(t) {
          return "undefined" === typeof t;
        }

        function isObject(t) {
          return null !== t && "object" === typeof t;
        }

        function isPlainObject(t) {
          if ("[object Object]" !== i.call(t)) return !1;
          var e = Object.getPrototypeOf(t);
          return null === e || e === Object.prototype;
        }

        function isFunction(t) {
          return "[object Function]" === i.call(t);
        }

        function forEach(t, e) {
          if (null !== t && "undefined" !== typeof t) if ("object" !== typeof t && (t = [t]), isArray(t)) for (var r = 0, n = t.length; r < n; r++) {
            e.call(null, t[r], r, t);
          } else for (var i in t) {
            Object.prototype.hasOwnProperty.call(t, i) && e.call(null, t[i], i, t);
          }
        }

        t.exports = {
          isArray: isArray,
          isArrayBuffer: function isArrayBuffer(t) {
            return "[object ArrayBuffer]" === i.call(t);
          },
          isBuffer: function isBuffer(t) {
            return null !== t && !isUndefined(t) && null !== t.constructor && !isUndefined(t.constructor) && "function" === typeof t.constructor.isBuffer && t.constructor.isBuffer(t);
          },
          isFormData: function isFormData(t) {
            return "undefined" !== typeof FormData && t instanceof FormData;
          },
          isArrayBufferView: function isArrayBufferView(t) {
            return "undefined" !== typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(t) : t && t.buffer && t.buffer instanceof ArrayBuffer;
          },
          isString: function isString(t) {
            return "string" === typeof t;
          },
          isNumber: function isNumber(t) {
            return "number" === typeof t;
          },
          isObject: isObject,
          isPlainObject: isPlainObject,
          isUndefined: isUndefined,
          isDate: function isDate(t) {
            return "[object Date]" === i.call(t);
          },
          isFile: function isFile(t) {
            return "[object File]" === i.call(t);
          },
          isBlob: function isBlob(t) {
            return "[object Blob]" === i.call(t);
          },
          isFunction: isFunction,
          isStream: function isStream(t) {
            return isObject(t) && isFunction(t.pipe);
          },
          isURLSearchParams: function isURLSearchParams(t) {
            return "undefined" !== typeof URLSearchParams && t instanceof URLSearchParams;
          },
          isStandardBrowserEnv: function isStandardBrowserEnv() {
            return ("undefined" === typeof navigator || "ReactNative" !== navigator.product && "NativeScript" !== navigator.product && "NS" !== navigator.product) && "undefined" !== typeof window && "undefined" !== typeof document;
          },
          forEach: forEach,
          merge: function merge() {
            var t = {};

            function assignValue(e, r) {
              isPlainObject(t[r]) && isPlainObject(e) ? t[r] = merge(t[r], e) : isPlainObject(e) ? t[r] = merge({}, e) : isArray(e) ? t[r] = e.slice() : t[r] = e;
            }

            for (var e = 0, r = arguments.length; e < r; e++) {
              forEach(arguments[e], assignValue);
            }

            return t;
          },
          extend: function extend(t, e, r) {
            return forEach(e, function assignValue(e, i) {
              t[i] = r && "function" === typeof e ? n(e, r) : e;
            }), t;
          },
          trim: function trim(t) {
            return t.replace(/^\s*/, "").replace(/\s*$/, "");
          },
          stripBOM: function stripBOM(t) {
            return 65279 === t.charCodeAt(0) && (t = t.slice(1)), t;
          }
        };
      }, function (e, r) {
        e.exports = t;
      }, function (t, e, r) {
        t.exports = r(39);
      }, function (t, e, r) {
        t.exports = r(21);
      }, function (t, e, r) {
        var n, i, o;
        o = function o() {
          function extend() {
            for (var t = 0, e = {}; t < arguments.length; t++) {
              var r = arguments[t];

              for (var n in r) {
                e[n] = r[n];
              }
            }

            return e;
          }

          return function init(t) {
            function api(e, r, n) {
              var i;

              if ("undefined" !== typeof document) {
                if (arguments.length > 1) {
                  if ("number" === typeof (n = extend({
                    path: "/"
                  }, api.defaults, n)).expires) {
                    var o = new Date();
                    o.setMilliseconds(o.getMilliseconds() + 864e5 * n.expires), n.expires = o;
                  }

                  n.expires = n.expires ? n.expires.toUTCString() : "";

                  try {
                    i = JSON.stringify(r), /^[\{\[]/.test(i) && (r = i);
                  } catch (p) {}

                  r = t.write ? t.write(r, e) : encodeURIComponent(String(r)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), e = (e = (e = encodeURIComponent(String(e))).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)).replace(/[\(\)]/g, escape);
                  var a = "";

                  for (var s in n) {
                    n[s] && (a += "; " + s, !0 !== n[s] && (a += "=" + n[s]));
                  }

                  return document.cookie = e + "=" + r + a;
                }

                e || (i = {});

                for (var c = document.cookie ? document.cookie.split("; ") : [], l = /(%[0-9A-Z]{2})+/g, u = 0; u < c.length; u++) {
                  var h = c[u].split("="),
                      d = h.slice(1).join("=");
                  this.json || '"' !== d.charAt(0) || (d = d.slice(1, -1));

                  try {
                    var f = h[0].replace(l, decodeURIComponent);
                    if (d = t.read ? t.read(d, f) : t(d, f) || d.replace(l, decodeURIComponent), this.json) try {
                      d = JSON.parse(d);
                    } catch (p) {}

                    if (e === f) {
                      i = d;
                      break;
                    }

                    e || (i[f] = d);
                  } catch (p) {}
                }

                return i;
              }
            }

            return api.set = api, api.get = function (t) {
              return api.call(api, t);
            }, api.getJSON = function () {
              return api.apply({
                json: !0
              }, [].slice.call(arguments));
            }, api.defaults = {}, api.remove = function (t, e) {
              api(t, "", extend(e, {
                expires: -1
              }));
            }, api.withConverter = init, api;
          }(function () {});
        }, void 0 === (i = "function" === typeof (n = o) ? n.call(e, r, e, t) : n) || (t.exports = i), t.exports = o();
      }, function (t, e, r) {
        t.exports = r(40), t.exports.default = t.exports;
      }, function (t, e, r) {
        "use strict";

        t.exports = function bind(t, e) {
          return function wrap() {
            for (var r = new Array(arguments.length), n = 0; n < r.length; n++) {
              r[n] = arguments[n];
            }

            return t.apply(e, r);
          };
        };
      }, function (t, e, r) {
        "use strict";

        var n = r(0);

        function encode(t) {
          return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
        }

        t.exports = function buildURL(t, e, r) {
          if (!e) return t;
          var i;
          if (r) i = r(e);else if (n.isURLSearchParams(e)) i = e.toString();else {
            var o = [];
            n.forEach(e, function serialize(t, e) {
              null !== t && "undefined" !== typeof t && (n.isArray(t) ? e += "[]" : t = [t], n.forEach(t, function parseValue(t) {
                n.isDate(t) ? t = t.toISOString() : n.isObject(t) && (t = JSON.stringify(t)), o.push(encode(e) + "=" + encode(t));
              }));
            }), i = o.join("&");
          }

          if (i) {
            var a = t.indexOf("#");
            -1 !== a && (t = t.slice(0, a)), t += (-1 === t.indexOf("?") ? "?" : "&") + i;
          }

          return t;
        };
      }, function (t, e, r) {
        "use strict";

        t.exports = function isCancel(t) {
          return !(!t || !t.__CANCEL__);
        };
      }, function (t, e, r) {
        "use strict";

        (function (e) {
          var n = r(0),
              i = r(27),
              o = {
            "Content-Type": "application/x-www-form-urlencoded"
          };

          function setContentTypeIfUnset(t, e) {
            !n.isUndefined(t) && n.isUndefined(t["Content-Type"]) && (t["Content-Type"] = e);
          }

          var a = {
            adapter: function getDefaultAdapter() {
              var t;
              return "undefined" !== typeof XMLHttpRequest ? t = r(10) : "undefined" !== typeof e && "[object process]" === Object.prototype.toString.call(e) && (t = r(10)), t;
            }(),
            transformRequest: [function transformRequest(t, e) {
              return i(e, "Accept"), i(e, "Content-Type"), n.isFormData(t) || n.isArrayBuffer(t) || n.isBuffer(t) || n.isStream(t) || n.isFile(t) || n.isBlob(t) ? t : n.isArrayBufferView(t) ? t.buffer : n.isURLSearchParams(t) ? (setContentTypeIfUnset(e, "application/x-www-form-urlencoded;charset=utf-8"), t.toString()) : n.isObject(t) ? (setContentTypeIfUnset(e, "application/json;charset=utf-8"), JSON.stringify(t)) : t;
            }],
            transformResponse: [function transformResponse(t) {
              if ("string" === typeof t) try {
                t = JSON.parse(t);
              } catch (e) {}
              return t;
            }],
            timeout: 0,
            xsrfCookieName: "XSRF-TOKEN",
            xsrfHeaderName: "X-XSRF-TOKEN",
            maxContentLength: -1,
            maxBodyLength: -1,
            validateStatus: function validateStatus(t) {
              return t >= 200 && t < 300;
            },
            headers: {
              common: {
                Accept: "application/json, text/plain, */*"
              }
            }
          };
          n.forEach(["delete", "get", "head"], function forEachMethodNoData(t) {
            a.headers[t] = {};
          }), n.forEach(["post", "put", "patch"], function forEachMethodWithData(t) {
            a.headers[t] = n.merge(o);
          }), t.exports = a;
        }).call(this, r(26));
      }, function (t, e, r) {
        "use strict";

        var n = r(0),
            i = r(28),
            o = r(30),
            a = r(7),
            s = r(31),
            c = r(34),
            l = r(35),
            u = r(11);

        t.exports = function xhrAdapter(t) {
          return new Promise(function dispatchXhrRequest(e, r) {
            var h = t.data,
                d = t.headers;
            n.isFormData(h) && delete d["Content-Type"];
            var f = new XMLHttpRequest();

            if (t.auth) {
              var p = t.auth.username || "",
                  y = t.auth.password ? unescape(encodeURIComponent(t.auth.password)) : "";
              d.Authorization = "Basic " + btoa(p + ":" + y);
            }

            var g = s(t.baseURL, t.url);

            if (f.open(t.method.toUpperCase(), a(g, t.params, t.paramsSerializer), !0), f.timeout = t.timeout, f.onreadystatechange = function handleLoad() {
              if (f && 4 === f.readyState && (0 !== f.status || f.responseURL && 0 === f.responseURL.indexOf("file:"))) {
                var n = "getAllResponseHeaders" in f ? c(f.getAllResponseHeaders()) : null,
                    o = {
                  data: t.responseType && "text" !== t.responseType ? f.response : f.responseText,
                  status: f.status,
                  statusText: f.statusText,
                  headers: n,
                  config: t,
                  request: f
                };
                i(e, r, o), f = null;
              }
            }, f.onabort = function handleAbort() {
              f && (r(u("Request aborted", t, "ECONNABORTED", f)), f = null);
            }, f.onerror = function handleError() {
              r(u("Network Error", t, null, f)), f = null;
            }, f.ontimeout = function handleTimeout() {
              var e = "timeout of " + t.timeout + "ms exceeded";
              t.timeoutErrorMessage && (e = t.timeoutErrorMessage), r(u(e, t, "ECONNABORTED", f)), f = null;
            }, n.isStandardBrowserEnv()) {
              var m = (t.withCredentials || l(g)) && t.xsrfCookieName ? o.read(t.xsrfCookieName) : void 0;
              m && (d[t.xsrfHeaderName] = m);
            }

            if ("setRequestHeader" in f && n.forEach(d, function setRequestHeader(t, e) {
              "undefined" === typeof h && "content-type" === e.toLowerCase() ? delete d[e] : f.setRequestHeader(e, t);
            }), n.isUndefined(t.withCredentials) || (f.withCredentials = !!t.withCredentials), t.responseType) try {
              f.responseType = t.responseType;
            } catch (v) {
              if ("json" !== t.responseType) throw v;
            }
            "function" === typeof t.onDownloadProgress && f.addEventListener("progress", t.onDownloadProgress), "function" === typeof t.onUploadProgress && f.upload && f.upload.addEventListener("progress", t.onUploadProgress), t.cancelToken && t.cancelToken.promise.then(function onCanceled(t) {
              f && (f.abort(), r(t), f = null);
            }), h || (h = null), f.send(h);
          });
        };
      }, function (t, e, r) {
        "use strict";

        var n = r(29);

        t.exports = function createError(t, e, r, i, o) {
          var a = new Error(t);
          return n(a, e, r, i, o);
        };
      }, function (t, e, r) {
        "use strict";

        var n = r(0);

        t.exports = function mergeConfig(t, e) {
          e = e || {};
          var r = {},
              i = ["url", "method", "data"],
              o = ["headers", "auth", "proxy", "params"],
              a = ["baseURL", "transformRequest", "transformResponse", "paramsSerializer", "timeout", "timeoutMessage", "withCredentials", "adapter", "responseType", "xsrfCookieName", "xsrfHeaderName", "onUploadProgress", "onDownloadProgress", "decompress", "maxContentLength", "maxBodyLength", "maxRedirects", "transport", "httpAgent", "httpsAgent", "cancelToken", "socketPath", "responseEncoding"],
              s = ["validateStatus"];

          function getMergedValue(t, e) {
            return n.isPlainObject(t) && n.isPlainObject(e) ? n.merge(t, e) : n.isPlainObject(e) ? n.merge({}, e) : n.isArray(e) ? e.slice() : e;
          }

          function mergeDeepProperties(i) {
            n.isUndefined(e[i]) ? n.isUndefined(t[i]) || (r[i] = getMergedValue(void 0, t[i])) : r[i] = getMergedValue(t[i], e[i]);
          }

          n.forEach(i, function valueFromConfig2(t) {
            n.isUndefined(e[t]) || (r[t] = getMergedValue(void 0, e[t]));
          }), n.forEach(o, mergeDeepProperties), n.forEach(a, function defaultToConfig2(i) {
            n.isUndefined(e[i]) ? n.isUndefined(t[i]) || (r[i] = getMergedValue(void 0, t[i])) : r[i] = getMergedValue(void 0, e[i]);
          }), n.forEach(s, function merge(n) {
            n in e ? r[n] = getMergedValue(t[n], e[n]) : n in t && (r[n] = getMergedValue(void 0, t[n]));
          });
          var c = i.concat(o).concat(a).concat(s),
              l = Object.keys(t).concat(Object.keys(e)).filter(function filterAxiosKeys(t) {
            return -1 === c.indexOf(t);
          });
          return n.forEach(l, mergeDeepProperties), r;
        };
      }, function (t, e, r) {
        "use strict";

        function Cancel(t) {
          this.message = t;
        }

        Cancel.prototype.toString = function toString() {
          return "Cancel" + (this.message ? ": " + this.message : "");
        }, Cancel.prototype.__CANCEL__ = !0, t.exports = Cancel;
      }, function (t, e) {
        var r;

        r = function () {
          return this;
        }();

        try {
          r = r || new Function("return this")();
        } catch (n) {
          "object" === typeof window && (r = window);
        }

        t.exports = r;
      }, function (t) {
        t.exports = {
          LOGIN_URL: "https://start.driftqa.com/login",
          CHROME_EXTENSION_ID: "dhgfncomjfnbcbokpcmmpkjnccdinicg",
          LOGIN_EXTENSION_ID: "nmniheggnpdimggobickgijhejfagdob",
          VIDEO_EXTENSION_ID: "bkcjmdbbpmkmdbihgjdpdeffopmhgaaa",
          NEW_VIDEO_EXTENSION_ID: "gbhgmblainnlaljfifmdfkbkdkipamij",
          TOKEN_MANAGER_URL: "http://localhost:3000",
          DEFAULT_COOKIE_OPTIONS: {
            path: "/"
          },
          CROSS_SKU_AUTH_ENABLED: !1
        };
      }, function (t) {
        t.exports = {
          LOGIN_URL: "https://start.drift.com/login",
          CHROME_EXTENSION_ID: "obpicmhmbfddhkcbiapfeginbafnjmmm",
          LOGIN_EXTENSION_ID: "gpkmgamohlkjijibojblielfahgpgcne",
          VIDEO_EXTENSION_ID: "kfhkikpdmehlpkaiplafjkaicdljldcf",
          NEW_VIDEO_EXTENSION_ID: "ngdkgbjaflegmfopaehddkdommggplda",
          TOKEN_MANAGER_URL: "https://auth.drift.com",
          DEFAULT_COOKIE_OPTIONS: {
            path: "/",
            secure: !0
          },
          CROSS_SKU_AUTH_ENABLED: !0
        };
      }, function (t) {
        t.exports = {
          LOGIN_URL: "https://start.driftqa.com/login",
          CHROME_EXTENSION_ID: "dhgfncomjfnbcbokpcmmpkjnccdinicg",
          LOGIN_EXTENSION_ID: "gpkmgamohlkjijibojblielfahgpgcne",
          VIDEO_EXTENSION_ID: "lbkepapcgenekcckmaailciejbdpgedb",
          NEW_VIDEO_EXTENSION_ID: "jmncadimlpigibdhcojgjodiefpmjjdb",
          TOKEN_MANAGER_URL: "https://auth.driftqa.com",
          DEFAULT_COOKIE_OPTIONS: {
            path: "/",
            secure: !0
          },
          CROSS_SKU_AUTH_ENABLED: !0
        };
      }, function (t) {
        t.exports = {
          LOGIN_URL: "https://start.drift.com/login",
          CHROME_EXTENSION_ID: "obpicmhmbfddhkcbiapfeginbafnjmmm",
          LOGIN_EXTENSION_ID: "gpkmgamohlkjijibojblielfahgpgcne",
          VIDEO_EXTENSION_ID: "kfhkikpdmehlpkaiplafjkaicdljldcf",
          NEW_VIDEO_EXTENSION_ID: "ngdkgbjaflegmfopaehddkdommggplda",
          TOKEN_MANAGER_URL: "https://auth.drift.com",
          DEFAULT_COOKIE_OPTIONS: {
            path: "/",
            secure: !0
          },
          CROSS_SKU_AUTH_ENABLED: !0
        };
      }, function (t, e, r) {
        "use strict";

        (function (e) {
          var n = r(45),
              i = r(46),
              o = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\S\s]*)/i,
              a = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//,
              s = [["#", "hash"], ["?", "query"], function sanitize(t) {
            return t.replace("\\", "/");
          }, ["/", "pathname"], ["@", "auth", 1], [NaN, "host", void 0, 1, 1], [/:(\d+)$/, "port", void 0, 1], [NaN, "hostname", void 0, 1, 1]],
              c = {
            hash: 1,
            query: 1
          };

          function lolcation(t) {
            var r,
                n = e && e.location || {},
                i = {},
                o = typeof (t = t || n);
            if ("blob:" === t.protocol) i = new Url(unescape(t.pathname), {});else if ("string" === o) for (r in i = new Url(t, {}), c) {
              delete i[r];
            } else if ("object" === o) {
              for (r in t) {
                r in c || (i[r] = t[r]);
              }

              void 0 === i.slashes && (i.slashes = a.test(t.href));
            }
            return i;
          }

          function extractProtocol(t) {
            var e = o.exec(t);
            return {
              protocol: e[1] ? e[1].toLowerCase() : "",
              slashes: !!e[2],
              rest: e[3]
            };
          }

          function Url(t, e, r) {
            if (!(this instanceof Url)) return new Url(t, e, r);
            var o,
                a,
                c,
                l,
                u,
                h,
                d = s.slice(),
                f = typeof e,
                p = this,
                y = 0;

            for ("object" !== f && "string" !== f && (r = e, e = null), r && "function" !== typeof r && (r = i.parse), e = lolcation(e), o = !(a = extractProtocol(t || "")).protocol && !a.slashes, p.slashes = a.slashes || o && e.slashes, p.protocol = a.protocol || e.protocol || "", t = a.rest, a.slashes || (d[3] = [/(.*)/, "pathname"]); y < d.length; y++) {
              "function" !== typeof (l = d[y]) ? (c = l[0], h = l[1], c !== c ? p[h] = t : "string" === typeof c ? ~(u = t.indexOf(c)) && ("number" === typeof l[2] ? (p[h] = t.slice(0, u), t = t.slice(u + l[2])) : (p[h] = t.slice(u), t = t.slice(0, u))) : (u = c.exec(t)) && (p[h] = u[1], t = t.slice(0, u.index)), p[h] = p[h] || o && l[3] && e[h] || "", l[4] && (p[h] = p[h].toLowerCase())) : t = l(t);
            }

            r && (p.query = r(p.query)), o && e.slashes && "/" !== p.pathname.charAt(0) && ("" !== p.pathname || "" !== e.pathname) && (p.pathname = function resolve(t, e) {
              for (var r = (e || "/").split("/").slice(0, -1).concat(t.split("/")), n = r.length, i = r[n - 1], o = !1, a = 0; n--;) {
                "." === r[n] ? r.splice(n, 1) : ".." === r[n] ? (r.splice(n, 1), a++) : a && (0 === n && (o = !0), r.splice(n, 1), a--);
              }

              return o && r.unshift(""), "." !== i && ".." !== i || r.push(""), r.join("/");
            }(p.pathname, e.pathname)), n(p.port, p.protocol) || (p.host = p.hostname, p.port = ""), p.username = p.password = "", p.auth && (l = p.auth.split(":"), p.username = l[0] || "", p.password = l[1] || ""), p.origin = p.protocol && p.host && "file:" !== p.protocol ? p.protocol + "//" + p.host : "null", p.href = p.toString();
          }

          Url.prototype = {
            set: function set(t, e, r) {
              var o = this;

              switch (t) {
                case "query":
                  "string" === typeof e && e.length && (e = (r || i.parse)(e)), o[t] = e;
                  break;

                case "port":
                  o[t] = e, n(e, o.protocol) ? e && (o.host = o.hostname + ":" + e) : (o.host = o.hostname, o[t] = "");
                  break;

                case "hostname":
                  o[t] = e, o.port && (e += ":" + o.port), o.host = e;
                  break;

                case "host":
                  o[t] = e, /:\d+$/.test(e) ? (e = e.split(":"), o.port = e.pop(), o.hostname = e.join(":")) : (o.hostname = e, o.port = "");
                  break;

                case "protocol":
                  o.protocol = e.toLowerCase(), o.slashes = !r;
                  break;

                case "pathname":
                case "hash":
                  if (e) {
                    var a = "pathname" === t ? "/" : "#";
                    o[t] = e.charAt(0) !== a ? a + e : e;
                  } else o[t] = e;

                  break;

                default:
                  o[t] = e;
              }

              for (var c = 0; c < s.length; c++) {
                var l = s[c];
                l[4] && (o[l[1]] = o[l[1]].toLowerCase());
              }

              return o.origin = o.protocol && o.host && "file:" !== o.protocol ? o.protocol + "//" + o.host : "null", o.href = o.toString(), o;
            },
            toString: function toString(t) {
              t && "function" === typeof t || (t = i.stringify);
              var e,
                  r = this,
                  n = r.protocol;
              n && ":" !== n.charAt(n.length - 1) && (n += ":");
              var o = n + (r.slashes ? "//" : "");
              return r.username && (o += r.username, r.password && (o += ":" + r.password), o += "@"), o += r.host + r.pathname, (e = "object" === typeof r.query ? t(r.query) : r.query) && (o += "?" !== e.charAt(0) ? "?" + e : e), r.hash && (o += r.hash), o;
            }
          }, Url.extractProtocol = extractProtocol, Url.location = lolcation, Url.qs = i, t.exports = Url;
        }).call(this, r(14));
      }, function (t, e, r) {
        t.exports = r(47);
      }, function (t, e, r) {
        "use strict";

        var n = r(0),
            i = r(6),
            o = r(22),
            a = r(12);

        function createInstance(t) {
          var e = new o(t),
              r = i(o.prototype.request, e);
          return n.extend(r, o.prototype, e), n.extend(r, e), r;
        }

        var s = createInstance(r(9));
        s.Axios = o, s.create = function create(t) {
          return createInstance(a(s.defaults, t));
        }, s.Cancel = r(13), s.CancelToken = r(36), s.isCancel = r(8), s.all = function all(t) {
          return Promise.all(t);
        }, s.spread = r(37), s.isAxiosError = r(38), t.exports = s, t.exports.default = s;
      }, function (t, e, r) {
        "use strict";

        var n = r(0),
            i = r(7),
            o = r(23),
            a = r(24),
            s = r(12);

        function Axios(t) {
          this.defaults = t, this.interceptors = {
            request: new o(),
            response: new o()
          };
        }

        Axios.prototype.request = function request(t) {
          "string" === typeof t ? (t = arguments[1] || {}).url = arguments[0] : t = t || {}, (t = s(this.defaults, t)).method ? t.method = t.method.toLowerCase() : this.defaults.method ? t.method = this.defaults.method.toLowerCase() : t.method = "get";
          var e = [a, void 0],
              r = Promise.resolve(t);

          for (this.interceptors.request.forEach(function unshiftRequestInterceptors(t) {
            e.unshift(t.fulfilled, t.rejected);
          }), this.interceptors.response.forEach(function pushResponseInterceptors(t) {
            e.push(t.fulfilled, t.rejected);
          }); e.length;) {
            r = r.then(e.shift(), e.shift());
          }

          return r;
        }, Axios.prototype.getUri = function getUri(t) {
          return t = s(this.defaults, t), i(t.url, t.params, t.paramsSerializer).replace(/^\?/, "");
        }, n.forEach(["delete", "get", "head", "options"], function forEachMethodNoData(t) {
          Axios.prototype[t] = function (e, r) {
            return this.request(s(r || {}, {
              method: t,
              url: e,
              data: (r || {}).data
            }));
          };
        }), n.forEach(["post", "put", "patch"], function forEachMethodWithData(t) {
          Axios.prototype[t] = function (e, r, n) {
            return this.request(s(n || {}, {
              method: t,
              url: e,
              data: r
            }));
          };
        }), t.exports = Axios;
      }, function (t, e, r) {
        "use strict";

        var n = r(0);

        function InterceptorManager() {
          this.handlers = [];
        }

        InterceptorManager.prototype.use = function use(t, e) {
          return this.handlers.push({
            fulfilled: t,
            rejected: e
          }), this.handlers.length - 1;
        }, InterceptorManager.prototype.eject = function eject(t) {
          this.handlers[t] && (this.handlers[t] = null);
        }, InterceptorManager.prototype.forEach = function forEach(t) {
          n.forEach(this.handlers, function forEachHandler(e) {
            null !== e && t(e);
          });
        }, t.exports = InterceptorManager;
      }, function (t, e, r) {
        "use strict";

        var n = r(0),
            i = r(25),
            o = r(8),
            a = r(9);

        function throwIfCancellationRequested(t) {
          t.cancelToken && t.cancelToken.throwIfRequested();
        }

        t.exports = function dispatchRequest(t) {
          return throwIfCancellationRequested(t), t.headers = t.headers || {}, t.data = i(t.data, t.headers, t.transformRequest), t.headers = n.merge(t.headers.common || {}, t.headers[t.method] || {}, t.headers), n.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function cleanHeaderConfig(e) {
            delete t.headers[e];
          }), (t.adapter || a.adapter)(t).then(function onAdapterResolution(e) {
            return throwIfCancellationRequested(t), e.data = i(e.data, e.headers, t.transformResponse), e;
          }, function onAdapterRejection(e) {
            return o(e) || (throwIfCancellationRequested(t), e && e.response && (e.response.data = i(e.response.data, e.response.headers, t.transformResponse))), Promise.reject(e);
          });
        };
      }, function (t, e, r) {
        "use strict";

        var n = r(0);

        t.exports = function transformData(t, e, r) {
          return n.forEach(r, function transform(r) {
            t = r(t, e);
          }), t;
        };
      }, function (t, e) {
        var r,
            n,
            i = t.exports = {};

        function defaultSetTimout() {
          throw new Error("setTimeout has not been defined");
        }

        function defaultClearTimeout() {
          throw new Error("clearTimeout has not been defined");
        }

        function runTimeout(t) {
          if (r === setTimeout) return setTimeout(t, 0);
          if ((r === defaultSetTimout || !r) && setTimeout) return r = setTimeout, setTimeout(t, 0);

          try {
            return r(t, 0);
          } catch (e) {
            try {
              return r.call(null, t, 0);
            } catch (e) {
              return r.call(this, t, 0);
            }
          }
        }

        !function () {
          try {
            r = "function" === typeof setTimeout ? setTimeout : defaultSetTimout;
          } catch (t) {
            r = defaultSetTimout;
          }

          try {
            n = "function" === typeof clearTimeout ? clearTimeout : defaultClearTimeout;
          } catch (t) {
            n = defaultClearTimeout;
          }
        }();
        var o,
            a = [],
            s = !1,
            c = -1;

        function cleanUpNextTick() {
          s && o && (s = !1, o.length ? a = o.concat(a) : c = -1, a.length && drainQueue());
        }

        function drainQueue() {
          if (!s) {
            var t = runTimeout(cleanUpNextTick);
            s = !0;

            for (var e = a.length; e;) {
              for (o = a, a = []; ++c < e;) {
                o && o[c].run();
              }

              c = -1, e = a.length;
            }

            o = null, s = !1, function runClearTimeout(t) {
              if (n === clearTimeout) return clearTimeout(t);
              if ((n === defaultClearTimeout || !n) && clearTimeout) return n = clearTimeout, clearTimeout(t);

              try {
                n(t);
              } catch (e) {
                try {
                  return n.call(null, t);
                } catch (e) {
                  return n.call(this, t);
                }
              }
            }(t);
          }
        }

        function Item(t, e) {
          this.fun = t, this.array = e;
        }

        function noop() {}

        i.nextTick = function (t) {
          var e = new Array(arguments.length - 1);
          if (arguments.length > 1) for (var r = 1; r < arguments.length; r++) {
            e[r - 1] = arguments[r];
          }
          a.push(new Item(t, e)), 1 !== a.length || s || runTimeout(drainQueue);
        }, Item.prototype.run = function () {
          this.fun.apply(null, this.array);
        }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = noop, i.addListener = noop, i.once = noop, i.off = noop, i.removeListener = noop, i.removeAllListeners = noop, i.emit = noop, i.prependListener = noop, i.prependOnceListener = noop, i.listeners = function (t) {
          return [];
        }, i.binding = function (t) {
          throw new Error("process.binding is not supported");
        }, i.cwd = function () {
          return "/";
        }, i.chdir = function (t) {
          throw new Error("process.chdir is not supported");
        }, i.umask = function () {
          return 0;
        };
      }, function (t, e, r) {
        "use strict";

        var n = r(0);

        t.exports = function normalizeHeaderName(t, e) {
          n.forEach(t, function processHeader(r, n) {
            n !== e && n.toUpperCase() === e.toUpperCase() && (t[e] = r, delete t[n]);
          });
        };
      }, function (t, e, r) {
        "use strict";

        var n = r(11);

        t.exports = function settle(t, e, r) {
          var i = r.config.validateStatus;
          r.status && i && !i(r.status) ? e(n("Request failed with status code " + r.status, r.config, null, r.request, r)) : t(r);
        };
      }, function (t, e, r) {
        "use strict";

        t.exports = function enhanceError(t, e, r, n, i) {
          return t.config = e, r && (t.code = r), t.request = n, t.response = i, t.isAxiosError = !0, t.toJSON = function toJSON() {
            return {
              message: this.message,
              name: this.name,
              description: this.description,
              number: this.number,
              fileName: this.fileName,
              lineNumber: this.lineNumber,
              columnNumber: this.columnNumber,
              stack: this.stack,
              config: this.config,
              code: this.code
            };
          }, t;
        };
      }, function (t, e, r) {
        "use strict";

        var n = r(0);
        t.exports = n.isStandardBrowserEnv() ? function standardBrowserEnv() {
          return {
            write: function write(t, e, r, i, o, a) {
              var s = [];
              s.push(t + "=" + encodeURIComponent(e)), n.isNumber(r) && s.push("expires=" + new Date(r).toGMTString()), n.isString(i) && s.push("path=" + i), n.isString(o) && s.push("domain=" + o), !0 === a && s.push("secure"), document.cookie = s.join("; ");
            },
            read: function read(t) {
              var e = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
              return e ? decodeURIComponent(e[3]) : null;
            },
            remove: function remove(t) {
              this.write(t, "", Date.now() - 864e5);
            }
          };
        }() : {
          write: function write() {},
          read: function read() {
            return null;
          },
          remove: function remove() {}
        };
      }, function (t, e, r) {
        "use strict";

        var n = r(32),
            i = r(33);

        t.exports = function buildFullPath(t, e) {
          return t && !n(e) ? i(t, e) : e;
        };
      }, function (t, e, r) {
        "use strict";

        t.exports = function isAbsoluteURL(t) {
          return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(t);
        };
      }, function (t, e, r) {
        "use strict";

        t.exports = function combineURLs(t, e) {
          return e ? t.replace(/\/+$/, "") + "/" + e.replace(/^\/+/, "") : t;
        };
      }, function (t, e, r) {
        "use strict";

        var n = r(0),
            i = ["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"];

        t.exports = function parseHeaders(t) {
          var e,
              r,
              o,
              a = {};
          return t ? (n.forEach(t.split("\n"), function parser(t) {
            if (o = t.indexOf(":"), e = n.trim(t.substr(0, o)).toLowerCase(), r = n.trim(t.substr(o + 1)), e) {
              if (a[e] && i.indexOf(e) >= 0) return;
              a[e] = "set-cookie" === e ? (a[e] ? a[e] : []).concat([r]) : a[e] ? a[e] + ", " + r : r;
            }
          }), a) : a;
        };
      }, function (t, e, r) {
        "use strict";

        var n = r(0);
        t.exports = n.isStandardBrowserEnv() ? function standardBrowserEnv() {
          var t,
              e = /(msie|trident)/i.test(navigator.userAgent),
              r = document.createElement("a");

          function resolveURL(t) {
            var n = t;
            return e && (r.setAttribute("href", n), n = r.href), r.setAttribute("href", n), {
              href: r.href,
              protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
              host: r.host,
              search: r.search ? r.search.replace(/^\?/, "") : "",
              hash: r.hash ? r.hash.replace(/^#/, "") : "",
              hostname: r.hostname,
              port: r.port,
              pathname: "/" === r.pathname.charAt(0) ? r.pathname : "/" + r.pathname
            };
          }

          return t = resolveURL(window.location.href), function isURLSameOrigin(e) {
            var r = n.isString(e) ? resolveURL(e) : e;
            return r.protocol === t.protocol && r.host === t.host;
          };
        }() : function isURLSameOrigin() {
          return !0;
        };
      }, function (t, e, r) {
        "use strict";

        var n = r(13);

        function CancelToken(t) {
          if ("function" !== typeof t) throw new TypeError("executor must be a function.");
          var e;
          this.promise = new Promise(function promiseExecutor(t) {
            e = t;
          });
          var r = this;
          t(function cancel(t) {
            r.reason || (r.reason = new n(t), e(r.reason));
          });
        }

        CancelToken.prototype.throwIfRequested = function throwIfRequested() {
          if (this.reason) throw this.reason;
        }, CancelToken.source = function source() {
          var t;
          return {
            token: new CancelToken(function executor(e) {
              t = e;
            }),
            cancel: t
          };
        }, t.exports = CancelToken;
      }, function (t, e, r) {
        "use strict";

        t.exports = function spread(t) {
          return function wrap(e) {
            return t.apply(null, e);
          };
        };
      }, function (t, e, r) {
        "use strict";

        t.exports = function isAxiosError(t) {
          return "object" === typeof t && !0 === t.isAxiosError;
        };
      }, function (t, e, r) {
        var n = function (t) {
          "use strict";

          var e,
              r = Object.prototype,
              n = r.hasOwnProperty,
              i = "function" === typeof Symbol ? Symbol : {},
              o = i.iterator || "@@iterator",
              a = i.asyncIterator || "@@asyncIterator",
              s = i.toStringTag || "@@toStringTag";

          function define(t, e, r) {
            return Object.defineProperty(t, e, {
              value: r,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }), t[e];
          }

          try {
            define({}, "");
          } catch (m) {
            define = function define(t, e, r) {
              return t[e] = r;
            };
          }

          function wrap(t, e, r, n) {
            var i = e && e.prototype instanceof Generator ? e : Generator,
                o = Object.create(i.prototype),
                a = new Context(n || []);
            return o._invoke = function makeInvokeMethod(t, e, r) {
              var n = c;
              return function invoke(i, o) {
                if (n === u) throw new Error("Generator is already running");

                if (n === h) {
                  if ("throw" === i) throw o;
                  return doneResult();
                }

                for (r.method = i, r.arg = o;;) {
                  var a = r.delegate;

                  if (a) {
                    var s = maybeInvokeDelegate(a, r);

                    if (s) {
                      if (s === d) continue;
                      return s;
                    }
                  }

                  if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                    if (n === c) throw n = h, r.arg;
                    r.dispatchException(r.arg);
                  } else "return" === r.method && r.abrupt("return", r.arg);
                  n = u;
                  var f = tryCatch(t, e, r);

                  if ("normal" === f.type) {
                    if (n = r.done ? h : l, f.arg === d) continue;
                    return {
                      value: f.arg,
                      done: r.done
                    };
                  }

                  "throw" === f.type && (n = h, r.method = "throw", r.arg = f.arg);
                }
              };
            }(t, r, a), o;
          }

          function tryCatch(t, e, r) {
            try {
              return {
                type: "normal",
                arg: t.call(e, r)
              };
            } catch (m) {
              return {
                type: "throw",
                arg: m
              };
            }
          }

          t.wrap = wrap;
          var c = "suspendedStart",
              l = "suspendedYield",
              u = "executing",
              h = "completed",
              d = {};

          function Generator() {}

          function GeneratorFunction() {}

          function GeneratorFunctionPrototype() {}

          var f = {};

          f[o] = function () {
            return this;
          };

          var p = Object.getPrototypeOf,
              y = p && p(p(values([])));
          y && y !== r && n.call(y, o) && (f = y);
          var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(f);

          function defineIteratorMethods(t) {
            ["next", "throw", "return"].forEach(function (e) {
              define(t, e, function (t) {
                return this._invoke(e, t);
              });
            });
          }

          function AsyncIterator(t, e) {
            var r;

            this._invoke = function enqueue(i, o) {
              function callInvokeWithMethodAndArg() {
                return new e(function (r, a) {
                  !function invoke(r, i, o, a) {
                    var s = tryCatch(t[r], t, i);

                    if ("throw" !== s.type) {
                      var c = s.arg,
                          l = c.value;
                      return l && "object" === typeof l && n.call(l, "__await") ? e.resolve(l.__await).then(function (t) {
                        invoke("next", t, o, a);
                      }, function (t) {
                        invoke("throw", t, o, a);
                      }) : e.resolve(l).then(function (t) {
                        c.value = t, o(c);
                      }, function (t) {
                        return invoke("throw", t, o, a);
                      });
                    }

                    a(s.arg);
                  }(i, o, r, a);
                });
              }

              return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            };
          }

          function maybeInvokeDelegate(t, r) {
            var n = t.iterator[r.method];

            if (n === e) {
              if (r.delegate = null, "throw" === r.method) {
                if (t.iterator.return && (r.method = "return", r.arg = e, maybeInvokeDelegate(t, r), "throw" === r.method)) return d;
                r.method = "throw", r.arg = new TypeError("The iterator does not provide a 'throw' method");
              }

              return d;
            }

            var i = tryCatch(n, t.iterator, r.arg);
            if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, d;
            var o = i.arg;
            return o ? o.done ? (r[t.resultName] = o.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e), r.delegate = null, d) : o : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, d);
          }

          function pushTryEntry(t) {
            var e = {
              tryLoc: t[0]
            };
            1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
          }

          function resetTryEntry(t) {
            var e = t.completion || {};
            e.type = "normal", delete e.arg, t.completion = e;
          }

          function Context(t) {
            this.tryEntries = [{
              tryLoc: "root"
            }], t.forEach(pushTryEntry, this), this.reset(!0);
          }

          function values(t) {
            if (t) {
              var r = t[o];
              if (r) return r.call(t);
              if ("function" === typeof t.next) return t;

              if (!isNaN(t.length)) {
                var i = -1,
                    a = function next() {
                  for (; ++i < t.length;) {
                    if (n.call(t, i)) return next.value = t[i], next.done = !1, next;
                  }

                  return next.value = e, next.done = !0, next;
                };

                return a.next = a;
              }
            }

            return {
              next: doneResult
            };
          }

          function doneResult() {
            return {
              value: e,
              done: !0
            };
          }

          return GeneratorFunction.prototype = g.constructor = GeneratorFunctionPrototype, GeneratorFunctionPrototype.constructor = GeneratorFunction, GeneratorFunction.displayName = define(GeneratorFunctionPrototype, s, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
            var e = "function" === typeof t && t.constructor;
            return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
          }, t.mark = function (t) {
            return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, s, "GeneratorFunction")), t.prototype = Object.create(g), t;
          }, t.awrap = function (t) {
            return {
              __await: t
            };
          }, defineIteratorMethods(AsyncIterator.prototype), AsyncIterator.prototype[a] = function () {
            return this;
          }, t.AsyncIterator = AsyncIterator, t.async = function (e, r, n, i, o) {
            void 0 === o && (o = Promise);
            var a = new AsyncIterator(wrap(e, r, n, i), o);
            return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
              return t.done ? t.value : a.next();
            });
          }, defineIteratorMethods(g), define(g, s, "Generator"), g[o] = function () {
            return this;
          }, g.toString = function () {
            return "[object Generator]";
          }, t.keys = function (t) {
            var e = [];

            for (var r in t) {
              e.push(r);
            }

            return e.reverse(), function next() {
              for (; e.length;) {
                var r = e.pop();
                if (r in t) return next.value = r, next.done = !1, next;
              }

              return next.done = !0, next;
            };
          }, t.values = values, Context.prototype = {
            constructor: Context,
            reset: function reset(t) {
              if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(resetTryEntry), !t) for (var r in this) {
                "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e);
              }
            },
            stop: function stop() {
              this.done = !0;
              var t = this.tryEntries[0].completion;
              if ("throw" === t.type) throw t.arg;
              return this.rval;
            },
            dispatchException: function dispatchException(t) {
              if (this.done) throw t;
              var r = this;

              function handle(n, i) {
                return a.type = "throw", a.arg = t, r.next = n, i && (r.method = "next", r.arg = e), !!i;
              }

              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var o = this.tryEntries[i],
                    a = o.completion;
                if ("root" === o.tryLoc) return handle("end");

                if (o.tryLoc <= this.prev) {
                  var s = n.call(o, "catchLoc"),
                      c = n.call(o, "finallyLoc");

                  if (s && c) {
                    if (this.prev < o.catchLoc) return handle(o.catchLoc, !0);
                    if (this.prev < o.finallyLoc) return handle(o.finallyLoc);
                  } else if (s) {
                    if (this.prev < o.catchLoc) return handle(o.catchLoc, !0);
                  } else {
                    if (!c) throw new Error("try statement without catch or finally");
                    if (this.prev < o.finallyLoc) return handle(o.finallyLoc);
                  }
                }
              }
            },
            abrupt: function abrupt(t, e) {
              for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                var i = this.tryEntries[r];

                if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                  var o = i;
                  break;
                }
              }

              o && ("break" === t || "continue" === t) && o.tryLoc <= e && e <= o.finallyLoc && (o = null);
              var a = o ? o.completion : {};
              return a.type = t, a.arg = e, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
            },
            complete: function complete(t, e) {
              if ("throw" === t.type) throw t.arg;
              return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), d;
            },
            finish: function finish(t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), d;
              }
            },
            catch: function _catch(t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var r = this.tryEntries[e];

                if (r.tryLoc === t) {
                  var n = r.completion;

                  if ("throw" === n.type) {
                    var i = n.arg;
                    resetTryEntry(r);
                  }

                  return i;
                }
              }

              throw new Error("illegal catch attempt");
            },
            delegateYield: function delegateYield(t, r, n) {
              return this.delegate = {
                iterator: values(t),
                resultName: r,
                nextLoc: n
              }, "next" === this.method && (this.arg = e), d;
            }
          }, t;
        }(t.exports);

        try {
          regeneratorRuntime = n;
        } catch (i) {
          Function("r", "regeneratorRuntime = r")(n);
        }
      }, function (t, e, r) {
        (function (e) {
          "undefined" != typeof self && self, t.exports = function (t) {
            var e = {};

            function __webpack_require__(r) {
              if (e[r]) return e[r].exports;
              var n = e[r] = {
                i: r,
                l: !1,
                exports: {}
              };
              return t[r].call(n.exports, n, n.exports, __webpack_require__), n.l = !0, n.exports;
            }

            return __webpack_require__.m = t, __webpack_require__.c = e, __webpack_require__.d = function (t, e, r) {
              __webpack_require__.o(t, e) || Object.defineProperty(t, e, {
                enumerable: !0,
                get: r
              });
            }, __webpack_require__.r = function (t) {
              "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
              }), Object.defineProperty(t, "__esModule", {
                value: !0
              });
            }, __webpack_require__.t = function (t, e) {
              if (1 & e && (t = __webpack_require__(t)), 8 & e) return t;
              if (4 & e && "object" == typeof t && t && t.__esModule) return t;
              var r = Object.create(null);
              if (__webpack_require__.r(r), Object.defineProperty(r, "default", {
                enumerable: !0,
                value: t
              }), 2 & e && "string" != typeof t) for (var n in t) {
                __webpack_require__.d(r, n, function (e) {
                  return t[e];
                }.bind(null, n));
              }
              return r;
            }, __webpack_require__.n = function (t) {
              var e = t && t.__esModule ? function () {
                return t.default;
              } : function () {
                return t;
              };
              return __webpack_require__.d(e, "a", e), e;
            }, __webpack_require__.o = function (t, e) {
              return {}.hasOwnProperty.call(t, e);
            }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 0);
          }([function (t, r, i) {
            "use strict";

            function isRegex(t) {
              return "[object RegExp]" === {}.toString.call(t);
            }

            i.r(r);
            var o = "Call was rejected by callee.\r\n";

            function isAboutProtocol(t) {
              return void 0 === t && (t = window), "about:" === t.location.protocol;
            }

            function getParent(t) {
              if (void 0 === t && (t = window), t) try {
                if (t.parent && t.parent !== t) return t.parent;
              } catch (e) {}
            }

            function getOpener(t) {
              if (void 0 === t && (t = window), t && !getParent(t)) try {
                return t.opener;
              } catch (e) {}
            }

            function canReadFromWindow(t) {
              try {
                return !0;
              } catch (e) {}

              return !1;
            }

            function getActualDomain(t) {
              void 0 === t && (t = window);
              var e = t.location;
              if (!e) throw new Error("Can not read window location");
              var r = e.protocol;
              if (!r) throw new Error("Can not read window protocol");
              if ("file:" === r) return "file://";

              if ("about:" === r) {
                var n = getParent(t);
                return n && canReadFromWindow() ? getActualDomain(n) : "about://";
              }

              var i = e.host;
              if (!i) throw new Error("Can not read window host");
              return r + "//" + i;
            }

            function getDomain(t) {
              void 0 === t && (t = window);
              var e = getActualDomain(t);
              return e && t.mockDomain && 0 === t.mockDomain.indexOf("mock:") ? t.mockDomain : e;
            }

            function isSameDomain(t) {
              if (!function (t) {
                try {
                  if (t === window) return !0;
                } catch (r) {}

                try {
                  var e = Object.getOwnPropertyDescriptor(t, "location");
                  if (e && !1 === e.enumerable) return !1;
                } catch (r) {}

                try {
                  if (isAboutProtocol(t) && canReadFromWindow()) return !0;
                } catch (r) {}

                try {
                  if (getActualDomain(t) === getActualDomain(window)) return !0;
                } catch (r) {}

                return !1;
              }(t)) return !1;

              try {
                if (t === window) return !0;
                if (isAboutProtocol(t) && canReadFromWindow()) return !0;
                if (getDomain(window) === getDomain(t)) return !0;
              } catch (e) {}

              return !1;
            }

            function assertSameDomain(t) {
              if (!isSameDomain(t)) throw new Error("Expected window to be same domain");
              return t;
            }

            function isAncestorParent(t, e) {
              if (!t || !e) return !1;
              var r = getParent(e);
              return r ? r === t : -1 !== function (t) {
                var e = [];

                try {
                  for (; t.parent !== t;) {
                    e.push(t.parent), t = t.parent;
                  }
                } catch (r) {}

                return e;
              }(e).indexOf(t);
            }

            function getFrames(t) {
              var e,
                  r,
                  n = [];

              try {
                e = t.frames;
              } catch (l) {
                e = t;
              }

              try {
                r = e.length;
              } catch (l) {}

              if (0 === r) return n;

              if (r) {
                for (var i = 0; i < r; i++) {
                  var o = void 0;

                  try {
                    o = e[i];
                  } catch (l) {
                    continue;
                  }

                  n.push(o);
                }

                return n;
              }

              for (var a = 0; a < 100; a++) {
                var s = void 0;

                try {
                  s = e[a];
                } catch (l) {
                  return n;
                }

                if (!s) return n;
                n.push(s);
              }

              return n;
            }

            var a = [],
                s = [];

            function isWindowClosed(t, e) {
              void 0 === e && (e = !0);

              try {
                if (t === window) return !1;
              } catch (c) {
                return !0;
              }

              try {
                if (!t) return !0;
              } catch (c) {
                return !0;
              }

              try {
                if (t.closed) return !0;
              } catch (c) {
                return !c || c.message !== o;
              }

              if (e && isSameDomain(t)) try {
                if (t.mockclosed) return !0;
              } catch (c) {}

              try {
                if (!t.parent || !t.top) return !0;
              } catch (c) {}

              var r = function (t, e) {
                for (var r = 0; r < t.length; r++) {
                  try {
                    if (t[r] === e) return r;
                  } catch (c) {}
                }

                return -1;
              }(a, t);

              if (-1 !== r) {
                var n = s[r];
                if (n && function (t) {
                  if (!t.contentWindow) return !0;
                  if (!t.parentNode) return !0;
                  var e = t.ownerDocument;
                  return !(!e || !e.documentElement || e.documentElement.contains(t));
                }(n)) return !0;
              }

              return !1;
            }

            function getAncestor(t) {
              return void 0 === t && (t = window), getOpener(t = t || window) || getParent(t) || void 0;
            }

            function matchDomain(t, e) {
              if ("string" == typeof t) {
                if ("string" == typeof e) return "*" === t || e === t;
                if (isRegex(e)) return !1;
                if (Array.isArray(e)) return !1;
              }

              return isRegex(t) ? isRegex(e) ? t.toString() === e.toString() : !Array.isArray(e) && Boolean(e.match(t)) : !!Array.isArray(t) && (Array.isArray(e) ? JSON.stringify(t) === JSON.stringify(e) : !isRegex(e) && t.some(function (t) {
                return matchDomain(t, e);
              }));
            }

            function isWindow(t) {
              try {
                if (t === window) return !0;
              } catch (e) {
                if (e && e.message === o) return !0;
              }

              try {
                if ("[object Window]" === {}.toString.call(t)) return !0;
              } catch (e) {
                if (e && e.message === o) return !0;
              }

              try {
                if (window.Window && t instanceof window.Window) return !0;
              } catch (e) {
                if (e && e.message === o) return !0;
              }

              try {
                if (t && t.self === t) return !0;
              } catch (e) {
                if (e && e.message === o) return !0;
              }

              try {
                if (t && t.parent === t) return !0;
              } catch (e) {
                if (e && e.message === o) return !0;
              }

              try {
                if (t && t.top === t) return !0;
              } catch (e) {
                if (e && e.message === o) return !0;
              }

              try {
                if (t && "__unlikely_value__" === t.__cross_domain_utils_window_check__) return !1;
              } catch (e) {
                return !0;
              }

              return !1;
            }

            function closeWindow(t) {
              try {
                t.close();
              } catch (e) {}
            }

            function utils_isPromise(t) {
              try {
                if (!t) return !1;
                if ("undefined" != typeof Promise && t instanceof Promise) return !0;
                if ("undefined" != typeof window && "function" == typeof window.Window && t instanceof window.Window) return !1;
                if ("undefined" != typeof window && "function" == typeof window.constructor && t instanceof window.constructor) return !1;
                var e = {}.toString;

                if (e) {
                  var r = e.call(t);
                  if ("[object Window]" === r || "[object global]" === r || "[object DOMWindow]" === r) return !1;
                }

                if ("function" == typeof t.then) return !0;
              } catch (i) {
                return !1;
              }

              return !1;
            }

            var c,
                l = [],
                u = [],
                h = 0;

            function flushActive() {
              if (!h && c) {
                var t = c;
                c = null, t.resolve();
              }
            }

            function startActive() {
              h += 1;
            }

            function endActive() {
              h -= 1, flushActive();
            }

            var d = function () {
              function ZalgoPromise(t) {
                var e = this;

                if (this.resolved = void 0, this.rejected = void 0, this.errorHandled = void 0, this.value = void 0, this.error = void 0, this.handlers = void 0, this.dispatching = void 0, this.stack = void 0, this.resolved = !1, this.rejected = !1, this.errorHandled = !1, this.handlers = [], t) {
                  var r,
                      n,
                      i = !1,
                      o = !1,
                      a = !1;
                  startActive();

                  try {
                    t(function (t) {
                      a ? e.resolve(t) : (i = !0, r = t);
                    }, function (t) {
                      a ? e.reject(t) : (o = !0, n = t);
                    });
                  } catch (c) {
                    return endActive(), void this.reject(c);
                  }

                  endActive(), a = !0, i ? this.resolve(r) : o && this.reject(n);
                }
              }

              var t = ZalgoPromise.prototype;
              return t.resolve = function (t) {
                if (this.resolved || this.rejected) return this;
                if (utils_isPromise(t)) throw new Error("Can not resolve promise with another promise");
                return this.resolved = !0, this.value = t, this.dispatch(), this;
              }, t.reject = function (t) {
                var e = this;
                if (this.resolved || this.rejected) return this;
                if (utils_isPromise(t)) throw new Error("Can not reject promise with another promise");

                if (!t) {
                  var r = t && "function" == typeof t.toString ? t.toString() : {}.toString.call(t);
                  t = new Error("Expected reject to be called with Error, got " + r);
                }

                return this.rejected = !0, this.error = t, this.errorHandled || setTimeout(function () {
                  e.errorHandled || function (t, e) {
                    if (-1 === l.indexOf(t)) {
                      l.push(t), setTimeout(function () {
                        throw t;
                      }, 1);

                      for (var r = 0; r < u.length; r++) {
                        u[r](t, e);
                      }
                    }
                  }(t, e);
                }, 1), this.dispatch(), this;
              }, t.asyncReject = function (t) {
                return this.errorHandled = !0, this.reject(t), this;
              }, t.dispatch = function () {
                var t = this.resolved,
                    e = this.rejected,
                    r = this.handlers;

                if (!this.dispatching && (t || e)) {
                  this.dispatching = !0, startActive();

                  for (var n = function chain(t, e) {
                    return t.then(function (t) {
                      e.resolve(t);
                    }, function (t) {
                      e.reject(t);
                    });
                  }, i = 0; i < r.length; i++) {
                    var o = r[i],
                        a = o.onSuccess,
                        s = o.onError,
                        c = o.promise,
                        l = void 0;
                    if (t) try {
                      l = a ? a(this.value) : this.value;
                    } catch (h) {
                      c.reject(h);
                      continue;
                    } else if (e) {
                      if (!s) {
                        c.reject(this.error);
                        continue;
                      }

                      try {
                        l = s(this.error);
                      } catch (h) {
                        c.reject(h);
                        continue;
                      }
                    }
                    l instanceof ZalgoPromise && (l.resolved || l.rejected) ? (l.resolved ? c.resolve(l.value) : c.reject(l.error), l.errorHandled = !0) : utils_isPromise(l) ? l instanceof ZalgoPromise && (l.resolved || l.rejected) ? l.resolved ? c.resolve(l.value) : c.reject(l.error) : n(l, c) : c.resolve(l);
                  }

                  r.length = 0, this.dispatching = !1, endActive();
                }
              }, t.then = function (t, e) {
                if (t && "function" != typeof t && !t.call) throw new Error("Promise.then expected a function for success handler");
                if (e && "function" != typeof e && !e.call) throw new Error("Promise.then expected a function for error handler");
                var r = new ZalgoPromise();
                return this.handlers.push({
                  promise: r,
                  onSuccess: t,
                  onError: e
                }), this.errorHandled = !0, this.dispatch(), r;
              }, t.catch = function (t) {
                return this.then(void 0, t);
              }, t.finally = function (t) {
                if (t && "function" != typeof t && !t.call) throw new Error("Promise.finally expected a function");
                return this.then(function (e) {
                  return ZalgoPromise.try(t).then(function () {
                    return e;
                  });
                }, function (e) {
                  return ZalgoPromise.try(t).then(function () {
                    throw e;
                  });
                });
              }, t.timeout = function (t, e) {
                var r = this;
                if (this.resolved || this.rejected) return this;
                var n = setTimeout(function () {
                  r.resolved || r.rejected || r.reject(e || new Error("Promise timed out after " + t + "ms"));
                }, t);
                return this.then(function (t) {
                  return clearTimeout(n), t;
                });
              }, t.toPromise = function () {
                if ("undefined" == typeof Promise) throw new TypeError("Could not find Promise");
                return Promise.resolve(this);
              }, ZalgoPromise.resolve = function (t) {
                return t instanceof ZalgoPromise ? t : utils_isPromise(t) ? new ZalgoPromise(function (e, r) {
                  return t.then(e, r);
                }) : new ZalgoPromise().resolve(t);
              }, ZalgoPromise.reject = function (t) {
                return new ZalgoPromise().reject(t);
              }, ZalgoPromise.asyncReject = function (t) {
                return new ZalgoPromise().asyncReject(t);
              }, ZalgoPromise.all = function (t) {
                var e = new ZalgoPromise(),
                    r = t.length,
                    n = [];
                if (!r) return e.resolve(n), e;

                for (var i = function chain(t, i, o) {
                  return i.then(function (i) {
                    n[t] = i, 0 == (r -= 1) && e.resolve(n);
                  }, function (t) {
                    o.reject(t);
                  });
                }, o = 0; o < t.length; o++) {
                  var a = t[o];

                  if (a instanceof ZalgoPromise) {
                    if (a.resolved) {
                      n[o] = a.value, r -= 1;
                      continue;
                    }
                  } else if (!utils_isPromise(a)) {
                    n[o] = a, r -= 1;
                    continue;
                  }

                  i(o, ZalgoPromise.resolve(a), e);
                }

                return 0 === r && e.resolve(n), e;
              }, ZalgoPromise.hash = function (t) {
                var e = {};
                return ZalgoPromise.all(Object.keys(t).map(function (r) {
                  return ZalgoPromise.resolve(t[r]).then(function (t) {
                    e[r] = t;
                  });
                })).then(function () {
                  return e;
                });
              }, ZalgoPromise.map = function (t, e) {
                return ZalgoPromise.all(t.map(e));
              }, ZalgoPromise.onPossiblyUnhandledException = function (t) {
                return function (t) {
                  return u.push(t), {
                    cancel: function cancel() {
                      u.splice(u.indexOf(t), 1);
                    }
                  };
                }(t);
              }, ZalgoPromise.try = function (t, e, r) {
                if (t && "function" != typeof t && !t.call) throw new Error("Promise.try expected a function");
                var n;
                startActive();

                try {
                  n = t.apply(e, r || []);
                } catch (o) {
                  return endActive(), ZalgoPromise.reject(o);
                }

                return endActive(), ZalgoPromise.resolve(n);
              }, ZalgoPromise.delay = function (t) {
                return new ZalgoPromise(function (e) {
                  setTimeout(e, t);
                });
              }, ZalgoPromise.isPromise = function (t) {
                return !!(t && t instanceof ZalgoPromise) || utils_isPromise(t);
              }, ZalgoPromise.flush = function () {
                return function (t) {
                  var e = c = c || new ZalgoPromise();
                  return flushActive(), e;
                }();
              }, ZalgoPromise;
            }();

            function _extends() {
              return (_extends = Object.assign || function (t) {
                for (var e = 1; e < arguments.length; e++) {
                  var r = arguments[e];

                  for (var n in r) {
                    ({}).hasOwnProperty.call(r, n) && (t[n] = r[n]);
                  }
                }

                return t;
              }).apply(this, arguments);
            }

            function util_safeIndexOf(t, e) {
              for (var r = 0; r < t.length; r++) {
                try {
                  if (t[r] === e) return r;
                } catch (i) {}
              }

              return -1;
            }

            var f,
                p = function () {
              function CrossDomainSafeWeakMap() {
                if (this.name = void 0, this.weakmap = void 0, this.keys = void 0, this.values = void 0, this.name = "__weakmap_" + (1e9 * Math.random() >>> 0) + "__", function () {
                  if ("undefined" == typeof WeakMap) return !1;
                  if (void 0 === Object.freeze) return !1;

                  try {
                    var t = new WeakMap(),
                        e = {};
                    return Object.freeze(e), t.set(e, "__testvalue__"), "__testvalue__" === t.get(e);
                  } catch (r) {
                    return !1;
                  }
                }()) try {
                  this.weakmap = new WeakMap();
                } catch (t) {}
                this.keys = [], this.values = [];
              }

              var t = CrossDomainSafeWeakMap.prototype;
              return t._cleanupClosedWindows = function () {
                for (var t = this.weakmap, e = this.keys, r = 0; r < e.length; r++) {
                  var n = e[r];

                  if (isWindow(n) && isWindowClosed(n)) {
                    if (t) try {
                      t.delete(n);
                    } catch (o) {}
                    e.splice(r, 1), this.values.splice(r, 1), r -= 1;
                  }
                }
              }, t.isSafeToReadWrite = function (t) {
                return !isWindow(t);
              }, t.set = function (t, e) {
                if (!t) throw new Error("WeakMap expected key");
                var r = this.weakmap;
                if (r) try {
                  r.set(t, e);
                } catch (l) {
                  delete this.weakmap;
                }
                if (this.isSafeToReadWrite(t)) try {
                  var n = this.name,
                      i = t[n];
                  return void (i && i[0] === t ? i[1] = e : Object.defineProperty(t, n, {
                    value: [t, e],
                    writable: !0
                  }));
                } catch (l) {}

                this._cleanupClosedWindows();

                var o = this.keys,
                    a = this.values,
                    s = util_safeIndexOf(o, t);
                -1 === s ? (o.push(t), a.push(e)) : a[s] = e;
              }, t.get = function (t) {
                if (!t) throw new Error("WeakMap expected key");
                var e = this.weakmap;
                if (e) try {
                  if (e.has(t)) return e.get(t);
                } catch (o) {
                  delete this.weakmap;
                }
                if (this.isSafeToReadWrite(t)) try {
                  var r = t[this.name];
                  return r && r[0] === t ? r[1] : void 0;
                } catch (o) {}

                this._cleanupClosedWindows();

                var n = util_safeIndexOf(this.keys, t);
                if (-1 !== n) return this.values[n];
              }, t.delete = function (t) {
                if (!t) throw new Error("WeakMap expected key");
                var e = this.weakmap;
                if (e) try {
                  e.delete(t);
                } catch (a) {
                  delete this.weakmap;
                }
                if (this.isSafeToReadWrite(t)) try {
                  var r = t[this.name];
                  r && r[0] === t && (r[0] = r[1] = void 0);
                } catch (a) {}

                this._cleanupClosedWindows();

                var n = this.keys,
                    i = util_safeIndexOf(n, t);
                -1 !== i && (n.splice(i, 1), this.values.splice(i, 1));
              }, t.has = function (t) {
                if (!t) throw new Error("WeakMap expected key");
                var e = this.weakmap;
                if (e) try {
                  if (e.has(t)) return !0;
                } catch (i) {
                  delete this.weakmap;
                }
                if (this.isSafeToReadWrite(t)) try {
                  var r = t[this.name];
                  return !(!r || r[0] !== t);
                } catch (i) {}
                return this._cleanupClosedWindows(), -1 !== util_safeIndexOf(this.keys, t);
              }, t.getOrSet = function (t, e) {
                if (this.has(t)) return this.get(t);
                var r = e();
                return this.set(t, r), r;
              }, CrossDomainSafeWeakMap;
            }();

            function uniqueID() {
              var t = "0123456789abcdef";
              return "xxxxxxxxxx".replace(/./g, function () {
                return t.charAt(Math.floor(Math.random() * t.length));
              }) + "_" + function (t) {
                if ("function" == typeof btoa) return btoa(encodeURIComponent(t).replace(/%([0-9A-F]{2})/g, function (t, e) {
                  return String.fromCharCode(parseInt(e, 16));
                }));
                if ("undefined" != typeof e) return e.from(t, "utf8").toString("base64");
                throw new Error("Can not find window.btoa or Buffer");
              }(new Date().toISOString().slice(11, 19).replace("T", ".")).replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
            }

            function memoizePromise(t) {
              var e,
                  r = {};

              function memoizedPromiseFunction() {
                for (var e = arguments, n = this, i = arguments.length, o = new Array(i), a = 0; a < i; a++) {
                  o[a] = arguments[a];
                }

                var s = function serializeArgs(t) {
                  try {
                    return JSON.stringify([].slice.call(t), function (t, e) {
                      return "function" == typeof e ? "memoize[" + function (t) {
                        if (f = f || new p(), null == t || "object" != typeof t && "function" != typeof t) throw new Error("Invalid object");
                        var e = f.get(t);
                        return e || (e = typeof t + ":" + uniqueID(), f.set(t, e)), e;
                      }(e) + "]" : e;
                    });
                  } catch (e) {
                    throw new Error("Arguments not serializable -- can not be used to memoize");
                  }
                }(o);

                return r.hasOwnProperty(s) ? r[s] : (r[s] = d.try(function () {
                  return t.apply(n, e);
                }).finally(function () {
                  delete r[s];
                }), r[s]);
              }

              return memoizedPromiseFunction.reset = function () {
                r = {};
              }, function (t, e) {
                try {
                  delete t.name, t.name = e;
                } catch (r) {}

                return t.__name__ = t.displayName = e, t;
              }(memoizedPromiseFunction, ((e = t).name || e.__name__ || e.displayName || "anonymous") + "::promiseMemoized");
            }

            function src_util_noop() {}

            function stringifyError(t, e) {
              if (void 0 === e && (e = 1), e >= 3) return "stringifyError stack overflow";

              try {
                if (!t) return "<unknown error: " + {}.toString.call(t) + ">";
                if ("string" == typeof t) return t;

                if (t instanceof Error) {
                  var r = t && t.stack,
                      n = t && t.message;
                  if (r && n) return -1 !== r.indexOf(n) ? r : n + "\n" + r;
                  if (r) return r;
                  if (n) return n;
                }

                return t && t.toString && "function" == typeof t.toString ? t.toString() : {}.toString.call(t);
              } catch (o) {
                return "Error while stringifying error: " + stringifyError(o, e + 1);
              }
            }

            function stringify(t) {
              return "string" == typeof t ? t : t && t.toString && "function" == typeof t.toString ? t.toString() : {}.toString.call(t);
            }

            function util_isRegex(t) {
              return "[object RegExp]" === {}.toString.call(t);
            }

            function util_getOrSet(t, e, r) {
              if (t.hasOwnProperty(e)) return t[e];
              var n = r();
              return t[e] = n, n;
            }

            function global_getGlobal(t) {
              return void 0 === t && (t = window), t !== window ? t.__post_robot_10_0_31__ : t.__post_robot_10_0_31__ = t.__post_robot_10_0_31__ || {};
            }

            Object.create(Error.prototype);

            var y = function getObj() {
              return {};
            };

            function globalStore(t, e) {
              return void 0 === t && (t = "store"), void 0 === e && (e = y), util_getOrSet(global_getGlobal(), t, function () {
                var t = e();
                return {
                  has: function has(e) {
                    return t.hasOwnProperty(e);
                  },
                  get: function get(e, r) {
                    return t.hasOwnProperty(e) ? t[e] : r;
                  },
                  set: function set(e, r) {
                    return t[e] = r, r;
                  },
                  del: function del(e) {
                    delete t[e];
                  },
                  getOrSet: function getOrSet(e, r) {
                    return util_getOrSet(t, e, r);
                  },
                  reset: function reset() {
                    t = e();
                  },
                  keys: function keys() {
                    return Object.keys(t);
                  }
                };
              });
            }

            var g,
                m = function WildCard() {};

            function getWildcard() {
              var t = global_getGlobal();
              return t.WINDOW_WILDCARD = t.WINDOW_WILDCARD || new m(), t.WINDOW_WILDCARD;
            }

            function windowStore(t, e) {
              return void 0 === t && (t = "store"), void 0 === e && (e = y), globalStore("windowStore").getOrSet(t, function () {
                var r = new p(),
                    n = function getStore(t) {
                  return r.getOrSet(t, e);
                };

                return {
                  has: function has(e) {
                    return n(e).hasOwnProperty(t);
                  },
                  get: function get(e, r) {
                    var i = n(e);
                    return i.hasOwnProperty(t) ? i[t] : r;
                  },
                  set: function set(e, r) {
                    return n(e)[t] = r, r;
                  },
                  del: function del(e) {
                    delete n(e)[t];
                  },
                  getOrSet: function getOrSet(e, r) {
                    return util_getOrSet(n(e), t, r);
                  }
                };
              });
            }

            function getInstanceID() {
              return globalStore("instance").getOrSet("instanceID", uniqueID);
            }

            function resolveHelloPromise(t, e) {
              var r = e.domain,
                  n = windowStore("helloPromises"),
                  i = n.get(t);
              i && i.resolve({
                domain: r
              });
              var o = d.resolve({
                domain: r
              });
              return n.set(t, o), o;
            }

            function sayHello(t, e) {
              return (0, e.send)(t, "postrobot_hello", {
                instanceID: getInstanceID()
              }, {
                domain: "*",
                timeout: -1
              }).then(function (e) {
                var r = e.origin,
                    n = e.data.instanceID;
                return resolveHelloPromise(t, {
                  domain: r
                }), {
                  win: t,
                  domain: r,
                  instanceID: n
                };
              });
            }

            function getWindowInstanceID(t, e) {
              var r = e.send;
              return windowStore("windowInstanceIDPromises").getOrSet(t, function () {
                return sayHello(t, {
                  send: r
                }).then(function (t) {
                  return t.instanceID;
                });
              });
            }

            function markWindowKnown(t) {
              windowStore("knownWindows").set(t, !0);
            }

            function isSerializedType(t) {
              return "object" == typeof t && null !== t && "string" == typeof t.__type__;
            }

            function determineType(t) {
              return void 0 === t ? "undefined" : null === t ? "null" : Array.isArray(t) ? "array" : "function" == typeof t ? "function" : "object" == typeof t ? t instanceof Error ? "error" : "function" == typeof t.then ? "promise" : "[object RegExp]" === {}.toString.call(t) ? "regex" : "[object Date]" === {}.toString.call(t) ? "date" : "object" : "string" == typeof t ? "string" : "number" == typeof t ? "number" : "boolean" == typeof t ? "boolean" : void 0;
            }

            function serializeType(t, e) {
              return {
                __type__: t,
                __val__: e
              };
            }

            var v,
                b = ((g = {}).function = function () {}, g.error = function (t) {
              return serializeType("error", {
                message: t.message,
                stack: t.stack,
                code: t.code
              });
            }, g.promise = function () {}, g.regex = function (t) {
              return serializeType("regex", t.source);
            }, g.date = function (t) {
              return serializeType("date", t.toJSON());
            }, g.array = function (t) {
              return t;
            }, g.object = function (t) {
              return t;
            }, g.string = function (t) {
              return t;
            }, g.number = function (t) {
              return t;
            }, g.boolean = function (t) {
              return t;
            }, g.null = function (t) {
              return t;
            }, g),
                x = {},
                w = ((v = {}).function = function () {
              throw new Error("Function serialization is not implemented; nothing to deserialize");
            }, v.error = function (t) {
              var e = t.stack,
                  r = t.code,
                  n = new Error(t.message);
              return n.code = r, n.stack = e + "\n\n" + n.stack, n;
            }, v.promise = function () {
              throw new Error("Promise serialization is not implemented; nothing to deserialize");
            }, v.regex = function (t) {
              return new RegExp(t);
            }, v.date = function (t) {
              return new Date(t);
            }, v.array = function (t) {
              return t;
            }, v.object = function (t) {
              return t;
            }, v.string = function (t) {
              return t;
            }, v.number = function (t) {
              return t;
            }, v.boolean = function (t) {
              return t;
            }, v.null = function (t) {
              return t;
            }, v),
                S = {};

            function cleanupProxyWindows() {
              for (var t = globalStore("idToProxyWindow"), e = 0, r = t.keys(); e < r.length; e++) {
                var n = r[e];
                t.get(n).shouldClean() && t.del(n);
              }
            }

            function getSerializedWindow(t, e) {
              var r = e.send,
                  n = e.id,
                  i = void 0 === n ? uniqueID() : n,
                  o = t.then(function (t) {
                if (isSameDomain(t)) return assertSameDomain(t).name;
              });
              return {
                id: i,
                getType: function getType() {
                  return t.then(function (t) {
                    return getOpener(t) ? "popup" : "iframe";
                  });
                },
                getInstanceID: memoizePromise(function () {
                  return t.then(function (t) {
                    return getWindowInstanceID(t, {
                      send: r
                    });
                  });
                }),
                close: function close() {
                  return t.then(closeWindow);
                },
                getName: function getName() {
                  return t.then(function (t) {
                    if (!isWindowClosed(t)) return isSameDomain(t) ? assertSameDomain(t).name : o;
                  });
                },
                focus: function focus() {
                  return t.then(function (t) {
                    t.focus();
                  });
                },
                isClosed: function isClosed() {
                  return t.then(function (t) {
                    return isWindowClosed(t);
                  });
                },
                setLocation: function setLocation(e) {
                  return t.then(function (t) {
                    if (isSameDomain(t)) try {
                      if (t.location && "function" == typeof t.location.replace) return void t.location.replace(e);
                    } catch (r) {}
                    t.location = e;
                  });
                },
                setName: function setName(e) {
                  return t.then(function (t) {
                    var r = isSameDomain(t),
                        n = function (t) {
                      if (isSameDomain(t)) return assertSameDomain(t).frameElement;

                      for (var e = 0, r = document.querySelectorAll("iframe"); e < r.length; e++) {
                        var n = r[e];
                        if (n && n.contentWindow && n.contentWindow === t) return n;
                      }
                    }(t);

                    if (!r) throw new Error("Can not set name for cross-domain window: " + e);
                    assertSameDomain(t).name = e, n && n.setAttribute("name", e), o = d.resolve(e);
                  });
                }
              };
            }

            new d(function (t) {
              if (window.document && window.document.body) return t(window.document.body);
              var e = setInterval(function () {
                if (window.document && window.document.body) return clearInterval(e), t(window.document.body);
              }, 10);
            });

            var O = function () {
              function ProxyWindow(t) {
                var e = t.send,
                    r = t.win,
                    n = t.serializedWindow;
                this.id = void 0, this.isProxyWindow = !0, this.serializedWindow = void 0, this.actualWindow = void 0, this.actualWindowPromise = void 0, this.send = void 0, this.name = void 0, this.actualWindowPromise = new d(), this.serializedWindow = n || getSerializedWindow(this.actualWindowPromise, {
                  send: e
                }), globalStore("idToProxyWindow").set(this.getID(), this), r && this.setWindow(r, {
                  send: e
                });
              }

              var t = ProxyWindow.prototype;
              return t.getID = function () {
                return this.serializedWindow.id;
              }, t.getType = function () {
                return this.serializedWindow.getType();
              }, t.isPopup = function () {
                return this.getType().then(function (t) {
                  return "popup" === t;
                });
              }, t.setLocation = function (t) {
                var e = this;
                return this.serializedWindow.setLocation(t).then(function () {
                  return e;
                });
              }, t.getName = function () {
                return this.serializedWindow.getName();
              }, t.setName = function (t) {
                var e = this;
                return this.serializedWindow.setName(t).then(function () {
                  return e;
                });
              }, t.close = function () {
                var t = this;
                return this.serializedWindow.close().then(function () {
                  return t;
                });
              }, t.focus = function () {
                var t = this,
                    e = this.isPopup(),
                    r = this.getName(),
                    n = d.hash({
                  isPopup: e,
                  name: r
                }).then(function (t) {
                  var e = t.name;
                  t.isPopup && e && window.open("", e);
                }),
                    i = this.serializedWindow.focus();
                return d.all([n, i]).then(function () {
                  return t;
                });
              }, t.isClosed = function () {
                return this.serializedWindow.isClosed();
              }, t.getWindow = function () {
                return this.actualWindow;
              }, t.setWindow = function (t, e) {
                var r = e.send;
                this.actualWindow = t, this.actualWindowPromise.resolve(this.actualWindow), this.serializedWindow = getSerializedWindow(this.actualWindowPromise, {
                  send: r,
                  id: this.getID()
                }), windowStore("winToProxyWindow").set(t, this);
              }, t.awaitWindow = function () {
                return this.actualWindowPromise;
              }, t.matchWindow = function (t, e) {
                var r = this,
                    n = e.send;
                return d.try(function () {
                  return r.actualWindow ? t === r.actualWindow : d.hash({
                    proxyInstanceID: r.getInstanceID(),
                    knownWindowInstanceID: getWindowInstanceID(t, {
                      send: n
                    })
                  }).then(function (e) {
                    var i = e.proxyInstanceID === e.knownWindowInstanceID;
                    return i && r.setWindow(t, {
                      send: n
                    }), i;
                  });
                });
              }, t.unwrap = function () {
                return this.actualWindow || this;
              }, t.getInstanceID = function () {
                return this.serializedWindow.getInstanceID();
              }, t.shouldClean = function () {
                return Boolean(this.actualWindow && isWindowClosed(this.actualWindow));
              }, t.serialize = function () {
                return this.serializedWindow;
              }, ProxyWindow.unwrap = function (t) {
                return ProxyWindow.isProxyWindow(t) ? t.unwrap() : t;
              }, ProxyWindow.serialize = function (t, e) {
                var r = e.send;
                return cleanupProxyWindows(), ProxyWindow.toProxyWindow(t, {
                  send: r
                }).serialize();
              }, ProxyWindow.deserialize = function (t, e) {
                var r = e.send;
                return cleanupProxyWindows(), globalStore("idToProxyWindow").get(t.id) || new ProxyWindow({
                  serializedWindow: t,
                  send: r
                });
              }, ProxyWindow.isProxyWindow = function (t) {
                return Boolean(t && !isWindow(t) && t.isProxyWindow);
              }, ProxyWindow.toProxyWindow = function (t, e) {
                var r = e.send;
                if (cleanupProxyWindows(), ProxyWindow.isProxyWindow(t)) return t;
                var n = t;
                return windowStore("winToProxyWindow").get(n) || new ProxyWindow({
                  win: n,
                  send: r
                });
              }, ProxyWindow;
            }();

            function addMethod(t, e, r, n, i) {
              var o = windowStore("methodStore"),
                  a = globalStore("proxyWindowMethods");
              O.isProxyWindow(n) ? a.set(t, {
                val: e,
                name: r,
                domain: i,
                source: n
              }) : (a.del(t), o.getOrSet(n, function () {
                return {};
              })[t] = {
                domain: i,
                name: r,
                val: e,
                source: n
              });
            }

            function lookupMethod(t, e) {
              var r = windowStore("methodStore"),
                  n = globalStore("proxyWindowMethods");
              return r.getOrSet(t, function () {
                return {};
              })[e] || n.get(e);
            }

            function function_serializeFunction(t, e, r, n, i) {
              var o, a, s;
              a = (o = {
                on: i.on,
                send: i.send
              }).on, s = o.send, globalStore("builtinListeners").getOrSet("functionCalls", function () {
                return a("postrobot_method", {
                  domain: "*"
                }, function (t) {
                  var e = t.source,
                      r = t.origin,
                      n = t.data,
                      i = n.id,
                      o = n.name,
                      a = lookupMethod(e, i);
                  if (!a) throw new Error("Could not find method '" + o + "' with id: " + n.id + " in " + getDomain(window));
                  var c = a.source,
                      l = a.domain,
                      u = a.val;
                  return d.try(function () {
                    if (!matchDomain(l, r)) throw new Error("Method '" + n.name + "' domain " + JSON.stringify(util_isRegex(a.domain) ? a.domain.source : a.domain) + " does not match origin " + r + " in " + getDomain(window));
                    if (O.isProxyWindow(c)) return c.matchWindow(e, {
                      send: s
                    }).then(function (t) {
                      if (!t) throw new Error("Method call '" + n.name + "' failed - proxy window does not match source in " + getDomain(window));
                    });
                  }).then(function () {
                    return u.apply({
                      source: e,
                      origin: r
                    }, n.args);
                  }, function (t) {
                    return d.try(function () {
                      if (u.onError) return u.onError(t);
                    }).then(function () {
                      throw t.stack && (t.stack = "Remote call to " + o + "(" + function (t) {
                        return void 0 === t && (t = []), (e = t, [].slice.call(e)).map(function (t) {
                          return "string" == typeof t ? "'" + t + "'" : void 0 === t ? "undefined" : null === t ? "null" : "boolean" == typeof t ? t.toString() : Array.isArray(t) ? "[ ... ]" : "object" == typeof t ? "{ ... }" : "function" == typeof t ? "() => { ... }" : "<" + typeof t + ">";
                        }).join(", ");
                        var e;
                      }(n.args) + ") failed\n\n" + t.stack), t;
                    });
                  }).then(function (t) {
                    return {
                      result: t,
                      id: i,
                      name: o
                    };
                  });
                });
              });
              var c = r.__id__ || uniqueID();
              t = O.unwrap(t);
              var l = r.__name__ || r.name || n;
              return "string" == typeof l && "function" == typeof l.indexOf && 0 === l.indexOf("anonymous::") && (l = l.replace("anonymous::", n + "::")), O.isProxyWindow(t) ? (addMethod(c, r, l, t, e), t.awaitWindow().then(function (t) {
                addMethod(c, r, l, t, e);
              })) : addMethod(c, r, l, t, e), serializeType("cross_domain_function", {
                id: c,
                name: l
              });
            }

            function serializeMessage(t, e, r, n) {
              var i,
                  o = n.on,
                  a = n.send;
              return function (t, e) {
                void 0 === e && (e = x);
                var r = JSON.stringify(t, function (t) {
                  var r = this[t];
                  if (isSerializedType(this)) return r;
                  var n = determineType(r);
                  if (!n) return r;
                  var i = e[n] || b[n];
                  return i ? i(r, t) : r;
                });
                return void 0 === r ? "undefined" : r;
              }(r, ((i = {}).promise = function (r, n) {
                return function (t, e, r, n, i) {
                  return serializeType("cross_domain_zalgo_promise", {
                    then: function_serializeFunction(t, e, function (t, e) {
                      return r.then(t, e);
                    }, n, {
                      on: i.on,
                      send: i.send
                    })
                  });
                }(t, e, r, n, {
                  on: o,
                  send: a
                });
              }, i.function = function (r, n) {
                return function_serializeFunction(t, e, r, n, {
                  on: o,
                  send: a
                });
              }, i.object = function (t) {
                return isWindow(t) || O.isProxyWindow(t) ? serializeType("cross_domain_window", O.serialize(t, {
                  send: a
                })) : t;
              }, i));
            }

            function deserializeMessage(t, e, r, n) {
              var i,
                  o = n.on,
                  a = n.send;
              return function (t, e) {
                if (void 0 === e && (e = S), "undefined" !== t) return JSON.parse(t, function (t, r) {
                  if (isSerializedType(this)) return r;
                  var n, i;
                  if (isSerializedType(r) ? (n = r.__type__, i = r.__val__) : (n = determineType(r), i = r), !n) return i;
                  var o = e[n] || w[n];
                  return o ? o(i, t) : i;
                });
              }(r, ((i = {}).cross_domain_zalgo_promise = function (t) {
                return new d(t.then);
              }, i.cross_domain_function = function (r) {
                return function (t, e, r, n) {
                  var i = r.id,
                      o = r.name,
                      a = n.send,
                      s = function getDeserializedFunction(r) {
                    function crossDomainFunctionWrapper() {
                      var n = arguments;
                      return O.toProxyWindow(t, {
                        send: a
                      }).awaitWindow().then(function (t) {
                        var s = lookupMethod(t, i);
                        if (s && s.val !== crossDomainFunctionWrapper) return s.val.apply({
                          source: window,
                          origin: getDomain()
                        }, n);
                        var c = {
                          domain: e,
                          fireAndForget: r.fireAndForget
                        },
                            l = [].slice.call(n);
                        return a(t, "postrobot_method", {
                          id: i,
                          name: o,
                          args: l
                        }, c).then(function (t) {
                          if (!r.fireAndForget) return t.data.result;
                        });
                      }).catch(function (t) {
                        throw t;
                      });
                    }

                    return void 0 === r && (r = {}), crossDomainFunctionWrapper.__name__ = o, crossDomainFunctionWrapper.__origin__ = e, crossDomainFunctionWrapper.__source__ = t, crossDomainFunctionWrapper.__id__ = i, crossDomainFunctionWrapper.origin = e, crossDomainFunctionWrapper;
                  },
                      c = s();

                  return c.fireAndForget = s({
                    fireAndForget: !0
                  }), c;
                }(t, e, r, {
                  on: o,
                  send: a
                });
              }, i.cross_domain_window = function (t) {
                return O.deserialize(t, {
                  send: a
                });
              }, i));
            }

            var E,
                k = {};

            function send_sendMessage(t, e, r, n) {
              var i,
                  o = n.on,
                  a = n.send;
              if (isWindowClosed(t)) throw new Error("Window is closed");

              for (var s = serializeMessage(t, e, ((i = {}).__post_robot_10_0_31__ = _extends({
                id: uniqueID(),
                origin: getDomain(window)
              }, r), i), {
                on: o,
                send: a
              }), c = Object.keys(k), l = [], u = 0; u < c.length; u++) {
                var h = c[u];

                try {
                  k[h](t, s, e);
                } catch (f) {
                  l.push(f);
                }
              }

              if (l.length === c.length) throw new Error("All post-robot messaging strategies failed:\n\n" + l.map(function (t, e) {
                return e + ". " + stringifyError(t);
              }).join("\n\n"));
            }

            function getResponseListener(t) {
              return globalStore("responseListeners").get(t);
            }

            function deleteResponseListener(t) {
              globalStore("responseListeners").del(t);
            }

            function isResponseListenerErrored(t) {
              return globalStore("erroredResponseListeners").has(t);
            }

            function getRequestListener(t) {
              var e = t.name,
                  r = t.win,
                  n = t.domain,
                  i = windowStore("requestListeners");
              if ("*" === r && (r = null), "*" === n && (n = null), !e) throw new Error("Name required to get request listener");

              for (var o = 0, a = [r, getWildcard()]; o < a.length; o++) {
                var s = a[o];

                if (s) {
                  var c = i.get(s);

                  if (c) {
                    var l = c[e];

                    if (l) {
                      if (n && "string" == typeof n) {
                        if (l[n]) return l[n];
                        if (l.__domain_regex__) for (var u = 0, h = l.__domain_regex__; u < h.length; u++) {
                          var d = h[u],
                              f = d.listener;
                          if (matchDomain(d.regex, n)) return f;
                        }
                      }

                      if (l["*"]) return l["*"];
                    }
                  }
                }
              }
            }

            k.postrobot_post_message = function (t, e, r) {
              (Array.isArray(r) ? r : "string" == typeof r ? [r] : ["*"]).map(function (t) {
                return 0 === t.indexOf("file:") ? "*" : t;
              }).forEach(function (r) {
                t.postMessage(e, r);
              });
            };

            var _ = ((E = {}).postrobot_message_request = function (t, e, r, n) {
              var i = n.on,
                  o = n.send,
                  a = getRequestListener({
                name: r.name,
                win: t,
                domain: e
              }),
                  s = "postrobot_method" === r.name && r.data && "string" == typeof r.data.name ? r.data.name + "()" : r.name;

              function sendResponse(n, a, c) {
                if (void 0 === c && (c = {}), !r.fireAndForget && !isWindowClosed(t)) try {
                  send_sendMessage(t, e, _extends({
                    type: n,
                    ack: a,
                    hash: r.hash,
                    name: r.name
                  }, c), {
                    on: i,
                    send: o
                  });
                } catch (u) {
                  throw new Error("Send response message failed for " + s + " in " + getDomain() + "\n\n" + stringifyError(u));
                }
              }

              return d.all([sendResponse("postrobot_message_ack"), d.try(function () {
                if (!a) throw new Error("No handler found for post message: " + r.name + " from " + e + " in " + window.location.protocol + "//" + window.location.host + window.location.pathname);
                if (!matchDomain(a.domain, e)) throw new Error("Request origin " + e + " does not match domain " + a.domain.toString());
                return a.handler({
                  source: t,
                  origin: e,
                  data: r.data
                });
              }).then(function (t) {
                return sendResponse("postrobot_message_response", "success", {
                  data: t
                });
              }, function (t) {
                return sendResponse("postrobot_message_response", "error", {
                  error: t
                });
              })]).then(src_util_noop).catch(function (t) {
                if (a && a.handleError) return a.handleError(t);
                throw t;
              });
            }, E.postrobot_message_ack = function (t, e, r) {
              if (!isResponseListenerErrored(r.hash)) {
                var n = getResponseListener(r.hash);
                if (!n) throw new Error("No handler found for post message ack for message: " + r.name + " from " + e + " in " + window.location.protocol + "//" + window.location.host + window.location.pathname);

                try {
                  if (!matchDomain(n.domain, e)) throw new Error("Ack origin " + e + " does not match domain " + n.domain.toString());
                  if (t !== n.win) throw new Error("Ack source does not match registered window");
                } catch (o) {
                  n.promise.reject(o);
                }

                n.ack = !0;
              }
            }, E.postrobot_message_response = function (t, e, r) {
              if (!isResponseListenerErrored(r.hash)) {
                var n,
                    i = getResponseListener(r.hash);
                if (!i) throw new Error("No handler found for post message response for message: " + r.name + " from " + e + " in " + window.location.protocol + "//" + window.location.host + window.location.pathname);
                if (!matchDomain(i.domain, e)) throw new Error("Response origin " + e + " does not match domain " + (n = i.domain, Array.isArray(n) ? "(" + n.join(" | ") + ")" : isRegex(n) ? "RegExp(" + n.toString() : n.toString()));
                if (t !== i.win) throw new Error("Response source does not match registered window");
                deleteResponseListener(r.hash), "error" === r.ack ? i.promise.reject(r.error) : "success" === r.ack && i.promise.resolve({
                  source: t,
                  origin: e,
                  data: r.data
                });
              }
            }, E);

            function receive_receiveMessage(t, e) {
              var r = e.on,
                  n = e.send,
                  i = globalStore("receivedMessages");

              try {
                if (!window || window.closed || !t.source) return;
              } catch (l) {
                return;
              }

              var o = t.source,
                  a = t.origin,
                  s = function (t, e, r, n) {
                var i,
                    o = n.on,
                    a = n.send;

                try {
                  i = deserializeMessage(e, r, t, {
                    on: o,
                    send: a
                  });
                } catch (l) {
                  return;
                }

                if (i && "object" == typeof i && null !== i && (i = i.__post_robot_10_0_31__) && "object" == typeof i && null !== i && i.type && "string" == typeof i.type && _[i.type]) return i;
              }(t.data, o, a, {
                on: r,
                send: n
              });

              s && (markWindowKnown(o), i.has(s.id) || (i.set(s.id, !0), isWindowClosed(o) && !s.fireAndForget || (0 === s.origin.indexOf("file:") && (a = "file://"), _[s.type](o, a, s, {
                on: r,
                send: n
              }))));
            }

            function on_on(t, e, r) {
              if (!t) throw new Error("Expected name");
              if ("function" == typeof e && (r = e, e = {}), !r) throw new Error("Expected handler");
              (e = e || {}).name = t, e.handler = r || e.handler;

              var n = e.window,
                  i = e.domain,
                  o = function addRequestListener(t, e) {
                var r = t.name,
                    n = t.win,
                    i = t.domain,
                    o = windowStore("requestListeners");
                if (!r || "string" != typeof r) throw new Error("Name required to add request listener");

                if (Array.isArray(n)) {
                  for (var a = [], s = 0, c = n; s < c.length; s++) {
                    a.push(addRequestListener({
                      name: r,
                      domain: i,
                      win: c[s]
                    }, e));
                  }

                  return {
                    cancel: function cancel() {
                      for (var t = 0; t < a.length; t++) {
                        a[t].cancel();
                      }
                    }
                  };
                }

                if (Array.isArray(i)) {
                  for (var l = [], u = 0, h = i; u < h.length; u++) {
                    l.push(addRequestListener({
                      name: r,
                      win: n,
                      domain: h[u]
                    }, e));
                  }

                  return {
                    cancel: function cancel() {
                      for (var t = 0; t < l.length; t++) {
                        l[t].cancel();
                      }
                    }
                  };
                }

                var d = getRequestListener({
                  name: r,
                  win: n,
                  domain: i
                });
                if (n && "*" !== n || (n = getWildcard()), i = i || "*", d) throw n && i ? new Error("Request listener already exists for " + r + " on domain " + i.toString() + " for " + (n === getWildcard() ? "wildcard" : "specified") + " window") : n ? new Error("Request listener already exists for " + r + " for " + (n === getWildcard() ? "wildcard" : "specified") + " window") : i ? new Error("Request listener already exists for " + r + " on domain " + i.toString()) : new Error("Request listener already exists for " + r);
                var f,
                    p,
                    y = o.getOrSet(n, function () {
                  return {};
                }),
                    g = util_getOrSet(y, r, function () {
                  return {};
                }),
                    m = i.toString();
                return util_isRegex(i) ? (f = util_getOrSet(g, "__domain_regex__", function () {
                  return [];
                })).push(p = {
                  regex: i,
                  listener: e
                }) : g[m] = e, {
                  cancel: function cancel() {
                    delete g[m], p && (f.splice(f.indexOf(p, 1)), f.length || delete g.__domain_regex__), Object.keys(g).length || delete y[r], n && !Object.keys(y).length && o.del(n);
                  }
                };
              }({
                name: t,
                win: n,
                domain: i
              }, {
                handler: e.handler,
                handleError: e.errorHandler || function (t) {
                  throw t;
                },
                window: n,
                domain: i || "*",
                name: t
              });

              return {
                cancel: function cancel() {
                  o.cancel();
                }
              };
            }

            function on_once(t, e, r) {
              "function" == typeof (e = e || {}) && (r = e, e = {});
              var n,
                  i = new d();
              return e.errorHandler = function (t) {
                n.cancel(), i.reject(t);
              }, n = on_on(t, e, function (t) {
                if (n.cancel(), i.resolve(t), r) return r(t);
              }), i.cancel = n.cancel, i;
            }

            var C = function send(t, e, r, n) {
              var i = (n = n || {}).domain || "*",
                  o = n.timeout || -1,
                  a = n.timeout || 5e3,
                  s = n.fireAndForget || !1;
              return d.try(function () {
                if (function (t, e, r) {
                  if (!t) throw new Error("Expected name");
                  if (r && "string" != typeof r && !Array.isArray(r) && !util_isRegex(r)) throw new TypeError("Expected domain to be a string, array, or regex");
                  if (isWindowClosed(e)) throw new Error("Target window is closed");
                }(e, t, i), function (t, e) {
                  var r = getAncestor(e);
                  if (r) return r === t;
                  if (e === t) return !1;
                  if (function (t) {
                    void 0 === t && (t = window);

                    try {
                      if (t.top) return t.top;
                    } catch (i) {}

                    if (getParent(t) === t) return t;

                    try {
                      if (isAncestorParent(window, t) && window.top) return window.top;
                    } catch (i) {}

                    try {
                      if (isAncestorParent(t, window) && window.top) return window.top;
                    } catch (i) {}

                    for (var e = 0, r = function getAllChildFrames(t) {
                      for (var e = [], r = 0, n = getFrames(t); r < n.length; r++) {
                        var i = n[r];
                        e.push(i);

                        for (var o = 0, a = getAllChildFrames(i); o < a.length; o++) {
                          e.push(a[o]);
                        }
                      }

                      return e;
                    }(t); e < r.length; e++) {
                      var n = r[e];

                      try {
                        if (n.top) return n.top;
                      } catch (i) {}

                      if (getParent(n) === n) return n;
                    }
                  }(e) === e) return !1;

                  for (var n = 0, i = getFrames(t); n < i.length; n++) {
                    if (i[n] === e) return !0;
                  }

                  return !1;
                }(window, t)) return function (t, e, r) {
                  void 0 === e && (e = 5e3), void 0 === r && (r = "Window");

                  var n = function (t) {
                    return windowStore("helloPromises").getOrSet(t, function () {
                      return new d();
                    });
                  }(t);

                  return -1 !== e && (n = n.timeout(e, new Error(r + " did not load after " + e + "ms"))), n;
                }(t, a);
              }).then(function (e) {
                return function (t, e, r, n) {
                  var i = {
                    send: send
                  }.send;
                  return "string" == typeof e ? d.resolve(e) : d.try(function () {
                    return r || sayHello(t, {
                      send: i
                    }).then(function (t) {
                      return t.domain;
                    });
                  }).then(function (t) {
                    if (!matchDomain(e, e)) throw new Error("Domain " + stringify(e) + " does not match " + stringify(e));
                    return t;
                  });
                }(t, i, (void 0 === e ? {} : e).domain);
              }).then(function (n) {
                i = n;
                var a = "postrobot_method" === e && r && "string" == typeof r.name ? r.name + "()" : e,
                    c = new d(),
                    l = e + "_" + uniqueID();

                if (!s) {
                  var u = {
                    name: e,
                    win: t,
                    domain: i,
                    promise: c
                  };
                  !function (t, e) {
                    globalStore("responseListeners").set(t, e);
                  }(l, u);
                  var h = windowStore("requestPromises").getOrSet(t, function () {
                    return [];
                  });
                  h.push(c), c.catch(function () {
                    var t;
                    t = l, globalStore("erroredResponseListeners").set(t, !0), deleteResponseListener(l);
                  });

                  var f = function (t) {
                    return windowStore("knownWindows").get(t, !1);
                  }(t) ? 1e4 : 2e3,
                      p = o,
                      y = f,
                      g = p,
                      m = function (r, n) {
                    var i;
                    return function loop() {
                      i = setTimeout(function () {
                        isWindowClosed(t) ? c.reject(new Error("Window closed for " + e + " before " + (u.ack ? "response" : "ack"))) : u.cancelled ? c.reject(new Error("Response listener was cancelled for " + e)) : (y = Math.max(y - 500, 0), -1 !== g && (g = Math.max(g - 500, 0)), u.ack || 0 !== y ? 0 === g && c.reject(new Error("No response for postMessage " + a + " in " + getDomain() + " in " + p + "ms")) : c.reject(new Error("No ack for postMessage " + a + " in " + getDomain() + " in " + f + "ms"))), loop();
                      }, 500);
                    }(), {
                      cancel: function cancel() {
                        clearTimeout(i);
                      }
                    };
                  }();

                  c.finally(function () {
                    m.cancel(), h.splice(h.indexOf(c, 1));
                  }).catch(src_util_noop);
                }

                try {
                  send_sendMessage(t, i, {
                    type: "postrobot_message_request",
                    hash: l,
                    name: e,
                    data: r,
                    fireAndForget: s
                  }, {
                    on: on_on,
                    send: send
                  });
                } catch (b) {
                  throw new Error("Send request message failed for " + a + " in " + getDomain() + "\n\n" + stringifyError(b));
                }

                return s ? c.resolve() : c;
              });
            };

            function setup_serializeMessage(t, e, r) {
              return serializeMessage(t, e, r, {
                on: on_on,
                send: C
              });
            }

            function setup_deserializeMessage(t, e, r) {
              return deserializeMessage(t, e, r, {
                on: on_on,
                send: C
              });
            }

            function createProxyWindow(t) {
              return new O({
                send: C,
                win: t
              });
            }

            function setup_toProxyWindow(t) {
              return O.toProxyWindow(t, {
                send: C
              });
            }

            function setup() {
              var t, e, r, n;
              global_getGlobal().initialized || (global_getGlobal().initialized = !0, e = (t = {
                on: on_on,
                send: C
              }).on, r = t.send, (n = global_getGlobal()).receiveMessage = n.receiveMessage || function (t) {
                return receive_receiveMessage(t, {
                  on: e,
                  send: r
                });
              }, function (t) {
                var e = t.on,
                    r = t.send;
                globalStore().getOrSet("postMessageListener", function () {
                  return t = window, n = function n(t) {
                    !function (t, e) {
                      var r = e.on,
                          n = e.send,
                          i = t.source || t.sourceElement,
                          o = t.origin || t.originalEvent && t.originalEvent.origin,
                          a = t.data;

                      if ("null" === o && (o = "file://"), i) {
                        if (!o) throw new Error("Post message did not have origin domain");
                        receive_receiveMessage({
                          source: i,
                          origin: o,
                          data: a
                        }, {
                          on: r,
                          send: n
                        });
                      }
                    }(t, {
                      on: e,
                      send: r
                    });
                  }, t.addEventListener("message", n), {
                    cancel: function cancel() {
                      t.removeEventListener("message", n);
                    }
                  };
                  var t, n;
                });
              }({
                on: on_on,
                send: C
              }), function (t) {
                var e = t.on,
                    r = t.send;
                globalStore("builtinListeners").getOrSet("helloListener", function () {
                  var t = e("postrobot_hello", {
                    domain: "*"
                  }, function (t) {
                    return resolveHelloPromise(t.source, {
                      domain: t.origin
                    }), {
                      instanceID: getInstanceID()
                    };
                  }),
                      n = getAncestor();
                  return n && sayHello(n, {
                    send: r
                  }).catch(src_util_noop), t;
                });
              }({
                on: on_on,
                send: C
              }));
            }

            function destroy() {
              var t;
              !function () {
                for (var t = globalStore("responseListeners"), e = 0, r = t.keys(); e < r.length; e++) {
                  var n = r[e],
                      i = t.get(n);
                  i && (i.cancelled = !0), t.del(n);
                }
              }(), (t = globalStore().get("postMessageListener")) && t.cancel(), delete window.__post_robot_10_0_31__;
            }

            function cleanUpWindow(t) {
              for (var e = 0, r = windowStore("requestPromises").get(t, []); e < r.length; e++) {
                r[e].reject(new Error("Window " + (isWindowClosed(t) ? "closed" : "cleaned up") + " before response")).catch(src_util_noop);
              }
            }

            i.d(r, "bridge", function () {}), i.d(r, "Promise", function () {
              return d;
            }), i.d(r, "TYPES", function () {
              return !0;
            }), i.d(r, "ProxyWindow", function () {
              return O;
            }), i.d(r, "setup", function () {
              return setup;
            }), i.d(r, "destroy", function () {
              return destroy;
            }), i.d(r, "serializeMessage", function () {
              return setup_serializeMessage;
            }), i.d(r, "deserializeMessage", function () {
              return setup_deserializeMessage;
            }), i.d(r, "createProxyWindow", function () {
              return createProxyWindow;
            }), i.d(r, "toProxyWindow", function () {
              return setup_toProxyWindow;
            }), i.d(r, "on", function () {
              return on_on;
            }), i.d(r, "once", function () {
              return on_once;
            }), i.d(r, "send", function () {
              return C;
            }), i.d(r, "markWindowKnown", function () {
              return markWindowKnown;
            }), i.d(r, "cleanUpWindow", function () {
              return cleanUpWindow;
            }), setup();
          }]);
        }).call(this, r(41).Buffer);
      }, function (t, e, r) {
        "use strict";

        (function (t) {
          var n = r(42),
              i = r(43),
              o = r(44);

          function kMaxLength() {
            return Buffer.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
          }

          function createBuffer(t, e) {
            if (kMaxLength() < e) throw new RangeError("Invalid typed array length");
            return Buffer.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(e)).__proto__ = Buffer.prototype : (null === t && (t = new Buffer(e)), t.length = e), t;
          }

          function Buffer(t, e, r) {
            if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) return new Buffer(t, e, r);

            if ("number" === typeof t) {
              if ("string" === typeof e) throw new Error("If encoding is specified then the first argument must be a string");
              return allocUnsafe(this, t);
            }

            return from(this, t, e, r);
          }

          function from(t, e, r, n) {
            if ("number" === typeof e) throw new TypeError('"value" argument must not be a number');
            return "undefined" !== typeof ArrayBuffer && e instanceof ArrayBuffer ? function fromArrayBuffer(t, e, r, n) {
              if (e.byteLength, r < 0 || e.byteLength < r) throw new RangeError("'offset' is out of bounds");
              if (e.byteLength < r + (n || 0)) throw new RangeError("'length' is out of bounds");
              return e = void 0 === r && void 0 === n ? new Uint8Array(e) : void 0 === n ? new Uint8Array(e, r) : new Uint8Array(e, r, n), Buffer.TYPED_ARRAY_SUPPORT ? (t = e).__proto__ = Buffer.prototype : t = fromArrayLike(t, e), t;
            }(t, e, r, n) : "string" === typeof e ? function fromString(t, e, r) {
              if ("string" === typeof r && "" !== r || (r = "utf8"), !Buffer.isEncoding(r)) throw new TypeError('"encoding" must be a valid string encoding');
              var n = 0 | byteLength(e, r),
                  i = (t = createBuffer(t, n)).write(e, r);
              return i !== n && (t = t.slice(0, i)), t;
            }(t, e, r) : function fromObject(t, e) {
              if (Buffer.isBuffer(e)) {
                var r = 0 | checked(e.length);
                return 0 === (t = createBuffer(t, r)).length ? t : (e.copy(t, 0, 0, r), t);
              }

              if (e) {
                if ("undefined" !== typeof ArrayBuffer && e.buffer instanceof ArrayBuffer || "length" in e) return "number" !== typeof e.length || function isnan(t) {
                  return t !== t;
                }(e.length) ? createBuffer(t, 0) : fromArrayLike(t, e);
                if ("Buffer" === e.type && o(e.data)) return fromArrayLike(t, e.data);
              }

              throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
            }(t, e);
          }

          function assertSize(t) {
            if ("number" !== typeof t) throw new TypeError('"size" argument must be a number');
            if (t < 0) throw new RangeError('"size" argument must not be negative');
          }

          function allocUnsafe(t, e) {
            if (assertSize(e), t = createBuffer(t, e < 0 ? 0 : 0 | checked(e)), !Buffer.TYPED_ARRAY_SUPPORT) for (var r = 0; r < e; ++r) {
              t[r] = 0;
            }
            return t;
          }

          function fromArrayLike(t, e) {
            var r = e.length < 0 ? 0 : 0 | checked(e.length);
            t = createBuffer(t, r);

            for (var n = 0; n < r; n += 1) {
              t[n] = 255 & e[n];
            }

            return t;
          }

          function checked(t) {
            if (t >= kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + kMaxLength().toString(16) + " bytes");
            return 0 | t;
          }

          function byteLength(t, e) {
            if (Buffer.isBuffer(t)) return t.length;
            if ("undefined" !== typeof ArrayBuffer && "function" === typeof ArrayBuffer.isView && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer)) return t.byteLength;
            "string" !== typeof t && (t = "" + t);
            var r = t.length;
            if (0 === r) return 0;

            for (var n = !1;;) {
              switch (e) {
                case "ascii":
                case "latin1":
                case "binary":
                  return r;

                case "utf8":
                case "utf-8":
                case void 0:
                  return utf8ToBytes(t).length;

                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return 2 * r;

                case "hex":
                  return r >>> 1;

                case "base64":
                  return base64ToBytes(t).length;

                default:
                  if (n) return utf8ToBytes(t).length;
                  e = ("" + e).toLowerCase(), n = !0;
              }
            }
          }

          function swap(t, e, r) {
            var n = t[e];
            t[e] = t[r], t[r] = n;
          }

          function bidirectionalIndexOf(t, e, r, n, i) {
            if (0 === t.length) return -1;

            if ("string" === typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = i ? 0 : t.length - 1), r < 0 && (r = t.length + r), r >= t.length) {
              if (i) return -1;
              r = t.length - 1;
            } else if (r < 0) {
              if (!i) return -1;
              r = 0;
            }

            if ("string" === typeof e && (e = Buffer.from(e, n)), Buffer.isBuffer(e)) return 0 === e.length ? -1 : arrayIndexOf(t, e, r, n, i);
            if ("number" === typeof e) return e &= 255, Buffer.TYPED_ARRAY_SUPPORT && "function" === typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(t, e, r) : Uint8Array.prototype.lastIndexOf.call(t, e, r) : arrayIndexOf(t, [e], r, n, i);
            throw new TypeError("val must be string, number or Buffer");
          }

          function arrayIndexOf(t, e, r, n, i) {
            var o,
                a = 1,
                s = t.length,
                c = e.length;

            if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
              if (t.length < 2 || e.length < 2) return -1;
              a = 2, s /= 2, c /= 2, r /= 2;
            }

            function read(t, e) {
              return 1 === a ? t[e] : t.readUInt16BE(e * a);
            }

            if (i) {
              var l = -1;

              for (o = r; o < s; o++) {
                if (read(t, o) === read(e, -1 === l ? 0 : o - l)) {
                  if (-1 === l && (l = o), o - l + 1 === c) return l * a;
                } else -1 !== l && (o -= o - l), l = -1;
              }
            } else for (r + c > s && (r = s - c), o = r; o >= 0; o--) {
              for (var u = !0, h = 0; h < c; h++) {
                if (read(t, o + h) !== read(e, h)) {
                  u = !1;
                  break;
                }
              }

              if (u) return o;
            }

            return -1;
          }

          function hexWrite(t, e, r, n) {
            r = Number(r) || 0;
            var i = t.length - r;
            n ? (n = Number(n)) > i && (n = i) : n = i;
            var o = e.length;
            if (o % 2 !== 0) throw new TypeError("Invalid hex string");
            n > o / 2 && (n = o / 2);

            for (var a = 0; a < n; ++a) {
              var s = parseInt(e.substr(2 * a, 2), 16);
              if (isNaN(s)) return a;
              t[r + a] = s;
            }

            return a;
          }

          function utf8Write(t, e, r, n) {
            return blitBuffer(utf8ToBytes(e, t.length - r), t, r, n);
          }

          function asciiWrite(t, e, r, n) {
            return blitBuffer(function asciiToBytes(t) {
              for (var e = [], r = 0; r < t.length; ++r) {
                e.push(255 & t.charCodeAt(r));
              }

              return e;
            }(e), t, r, n);
          }

          function latin1Write(t, e, r, n) {
            return asciiWrite(t, e, r, n);
          }

          function base64Write(t, e, r, n) {
            return blitBuffer(base64ToBytes(e), t, r, n);
          }

          function ucs2Write(t, e, r, n) {
            return blitBuffer(function utf16leToBytes(t, e) {
              for (var r, n, i, o = [], a = 0; a < t.length && !((e -= 2) < 0); ++a) {
                n = (r = t.charCodeAt(a)) >> 8, i = r % 256, o.push(i), o.push(n);
              }

              return o;
            }(e, t.length - r), t, r, n);
          }

          function base64Slice(t, e, r) {
            return 0 === e && r === t.length ? n.fromByteArray(t) : n.fromByteArray(t.slice(e, r));
          }

          function utf8Slice(t, e, r) {
            r = Math.min(t.length, r);

            for (var n = [], i = e; i < r;) {
              var o,
                  s,
                  c,
                  l,
                  u = t[i],
                  h = null,
                  d = u > 239 ? 4 : u > 223 ? 3 : u > 191 ? 2 : 1;
              if (i + d <= r) switch (d) {
                case 1:
                  u < 128 && (h = u);
                  break;

                case 2:
                  128 === (192 & (o = t[i + 1])) && (l = (31 & u) << 6 | 63 & o) > 127 && (h = l);
                  break;

                case 3:
                  o = t[i + 1], s = t[i + 2], 128 === (192 & o) && 128 === (192 & s) && (l = (15 & u) << 12 | (63 & o) << 6 | 63 & s) > 2047 && (l < 55296 || l > 57343) && (h = l);
                  break;

                case 4:
                  o = t[i + 1], s = t[i + 2], c = t[i + 3], 128 === (192 & o) && 128 === (192 & s) && 128 === (192 & c) && (l = (15 & u) << 18 | (63 & o) << 12 | (63 & s) << 6 | 63 & c) > 65535 && l < 1114112 && (h = l);
              }
              null === h ? (h = 65533, d = 1) : h > 65535 && (h -= 65536, n.push(h >>> 10 & 1023 | 55296), h = 56320 | 1023 & h), n.push(h), i += d;
            }

            return function decodeCodePointsArray(t) {
              var e = t.length;
              if (e <= a) return String.fromCharCode.apply(String, t);

              for (var r = "", n = 0; n < e;) {
                r += String.fromCharCode.apply(String, t.slice(n, n += a));
              }

              return r;
            }(n);
          }

          e.Buffer = Buffer, e.SlowBuffer = function SlowBuffer(t) {
            return +t != t && (t = 0), Buffer.alloc(+t);
          }, e.INSPECT_MAX_BYTES = 50, Buffer.TYPED_ARRAY_SUPPORT = void 0 !== t.TYPED_ARRAY_SUPPORT ? t.TYPED_ARRAY_SUPPORT : function typedArraySupport() {
            try {
              var t = new Uint8Array(1);
              return t.__proto__ = {
                __proto__: Uint8Array.prototype,
                foo: function foo() {
                  return 42;
                }
              }, 42 === t.foo() && "function" === typeof t.subarray && 0 === t.subarray(1, 1).byteLength;
            } catch (e) {
              return !1;
            }
          }(), e.kMaxLength = kMaxLength(), Buffer.poolSize = 8192, Buffer._augment = function (t) {
            return t.__proto__ = Buffer.prototype, t;
          }, Buffer.from = function (t, e, r) {
            return from(null, t, e, r);
          }, Buffer.TYPED_ARRAY_SUPPORT && (Buffer.prototype.__proto__ = Uint8Array.prototype, Buffer.__proto__ = Uint8Array, "undefined" !== typeof Symbol && Symbol.species && Buffer[Symbol.species] === Buffer && Object.defineProperty(Buffer, Symbol.species, {
            value: null,
            configurable: !0
          })), Buffer.alloc = function (t, e, r) {
            return function alloc(t, e, r, n) {
              return assertSize(e), e <= 0 ? createBuffer(t, e) : void 0 !== r ? "string" === typeof n ? createBuffer(t, e).fill(r, n) : createBuffer(t, e).fill(r) : createBuffer(t, e);
            }(null, t, e, r);
          }, Buffer.allocUnsafe = function (t) {
            return allocUnsafe(null, t);
          }, Buffer.allocUnsafeSlow = function (t) {
            return allocUnsafe(null, t);
          }, Buffer.isBuffer = function isBuffer(t) {
            return !(null == t || !t._isBuffer);
          }, Buffer.compare = function compare(t, e) {
            if (!Buffer.isBuffer(t) || !Buffer.isBuffer(e)) throw new TypeError("Arguments must be Buffers");
            if (t === e) return 0;

            for (var r = t.length, n = e.length, i = 0, o = Math.min(r, n); i < o; ++i) {
              if (t[i] !== e[i]) {
                r = t[i], n = e[i];
                break;
              }
            }

            return r < n ? -1 : n < r ? 1 : 0;
          }, Buffer.isEncoding = function isEncoding(t) {
            switch (String(t).toLowerCase()) {
              case "hex":
              case "utf8":
              case "utf-8":
              case "ascii":
              case "latin1":
              case "binary":
              case "base64":
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return !0;

              default:
                return !1;
            }
          }, Buffer.concat = function concat(t, e) {
            if (!o(t)) throw new TypeError('"list" argument must be an Array of Buffers');
            if (0 === t.length) return Buffer.alloc(0);
            var r;
            if (void 0 === e) for (e = 0, r = 0; r < t.length; ++r) {
              e += t[r].length;
            }
            var n = Buffer.allocUnsafe(e),
                i = 0;

            for (r = 0; r < t.length; ++r) {
              var a = t[r];
              if (!Buffer.isBuffer(a)) throw new TypeError('"list" argument must be an Array of Buffers');
              a.copy(n, i), i += a.length;
            }

            return n;
          }, Buffer.byteLength = byteLength, Buffer.prototype._isBuffer = !0, Buffer.prototype.swap16 = function swap16() {
            var t = this.length;
            if (t % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");

            for (var e = 0; e < t; e += 2) {
              swap(this, e, e + 1);
            }

            return this;
          }, Buffer.prototype.swap32 = function swap32() {
            var t = this.length;
            if (t % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");

            for (var e = 0; e < t; e += 4) {
              swap(this, e, e + 3), swap(this, e + 1, e + 2);
            }

            return this;
          }, Buffer.prototype.swap64 = function swap64() {
            var t = this.length;
            if (t % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");

            for (var e = 0; e < t; e += 8) {
              swap(this, e, e + 7), swap(this, e + 1, e + 6), swap(this, e + 2, e + 5), swap(this, e + 3, e + 4);
            }

            return this;
          }, Buffer.prototype.toString = function toString() {
            var t = 0 | this.length;
            return 0 === t ? "" : 0 === arguments.length ? utf8Slice(this, 0, t) : function slowToString(t, e, r) {
              var n = !1;
              if ((void 0 === e || e < 0) && (e = 0), e > this.length) return "";
              if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
              if ((r >>>= 0) <= (e >>>= 0)) return "";

              for (t || (t = "utf8");;) {
                switch (t) {
                  case "hex":
                    return hexSlice(this, e, r);

                  case "utf8":
                  case "utf-8":
                    return utf8Slice(this, e, r);

                  case "ascii":
                    return asciiSlice(this, e, r);

                  case "latin1":
                  case "binary":
                    return latin1Slice(this, e, r);

                  case "base64":
                    return base64Slice(this, e, r);

                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return utf16leSlice(this, e, r);

                  default:
                    if (n) throw new TypeError("Unknown encoding: " + t);
                    t = (t + "").toLowerCase(), n = !0;
                }
              }
            }.apply(this, arguments);
          }, Buffer.prototype.equals = function equals(t) {
            if (!Buffer.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
            return this === t || 0 === Buffer.compare(this, t);
          }, Buffer.prototype.inspect = function inspect() {
            var t = "",
                r = e.INSPECT_MAX_BYTES;
            return this.length > 0 && (t = this.toString("hex", 0, r).match(/.{2}/g).join(" "), this.length > r && (t += " ... ")), "<Buffer " + t + ">";
          }, Buffer.prototype.compare = function compare(t, e, r, n, i) {
            if (!Buffer.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
            if (void 0 === e && (e = 0), void 0 === r && (r = t ? t.length : 0), void 0 === n && (n = 0), void 0 === i && (i = this.length), e < 0 || r > t.length || n < 0 || i > this.length) throw new RangeError("out of range index");
            if (n >= i && e >= r) return 0;
            if (n >= i) return -1;
            if (e >= r) return 1;
            if (this === t) return 0;

            for (var o = (i >>>= 0) - (n >>>= 0), a = (r >>>= 0) - (e >>>= 0), s = Math.min(o, a), c = this.slice(n, i), l = t.slice(e, r), u = 0; u < s; ++u) {
              if (c[u] !== l[u]) {
                o = c[u], a = l[u];
                break;
              }
            }

            return o < a ? -1 : a < o ? 1 : 0;
          }, Buffer.prototype.includes = function includes(t, e, r) {
            return -1 !== this.indexOf(t, e, r);
          }, Buffer.prototype.indexOf = function indexOf(t, e, r) {
            return bidirectionalIndexOf(this, t, e, r, !0);
          }, Buffer.prototype.lastIndexOf = function lastIndexOf(t, e, r) {
            return bidirectionalIndexOf(this, t, e, r, !1);
          }, Buffer.prototype.write = function write(t, e, r, n) {
            if (void 0 === e) n = "utf8", r = this.length, e = 0;else if (void 0 === r && "string" === typeof e) n = e, r = this.length, e = 0;else {
              if (!isFinite(e)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
              e |= 0, isFinite(r) ? (r |= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
            }
            var i = this.length - e;
            if ((void 0 === r || r > i) && (r = i), t.length > 0 && (r < 0 || e < 0) || e > this.length) throw new RangeError("Attempt to write outside buffer bounds");
            n || (n = "utf8");

            for (var o = !1;;) {
              switch (n) {
                case "hex":
                  return hexWrite(this, t, e, r);

                case "utf8":
                case "utf-8":
                  return utf8Write(this, t, e, r);

                case "ascii":
                  return asciiWrite(this, t, e, r);

                case "latin1":
                case "binary":
                  return latin1Write(this, t, e, r);

                case "base64":
                  return base64Write(this, t, e, r);

                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return ucs2Write(this, t, e, r);

                default:
                  if (o) throw new TypeError("Unknown encoding: " + n);
                  n = ("" + n).toLowerCase(), o = !0;
              }
            }
          }, Buffer.prototype.toJSON = function toJSON() {
            return {
              type: "Buffer",
              data: Array.prototype.slice.call(this._arr || this, 0)
            };
          };
          var a = 4096;

          function asciiSlice(t, e, r) {
            var n = "";
            r = Math.min(t.length, r);

            for (var i = e; i < r; ++i) {
              n += String.fromCharCode(127 & t[i]);
            }

            return n;
          }

          function latin1Slice(t, e, r) {
            var n = "";
            r = Math.min(t.length, r);

            for (var i = e; i < r; ++i) {
              n += String.fromCharCode(t[i]);
            }

            return n;
          }

          function hexSlice(t, e, r) {
            var n = t.length;
            (!e || e < 0) && (e = 0), (!r || r < 0 || r > n) && (r = n);

            for (var i = "", o = e; o < r; ++o) {
              i += toHex(t[o]);
            }

            return i;
          }

          function utf16leSlice(t, e, r) {
            for (var n = t.slice(e, r), i = "", o = 0; o < n.length; o += 2) {
              i += String.fromCharCode(n[o] + 256 * n[o + 1]);
            }

            return i;
          }

          function checkOffset(t, e, r) {
            if (t % 1 !== 0 || t < 0) throw new RangeError("offset is not uint");
            if (t + e > r) throw new RangeError("Trying to access beyond buffer length");
          }

          function checkInt(t, e, r, n, i, o) {
            if (!Buffer.isBuffer(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
            if (e > i || e < o) throw new RangeError('"value" argument is out of bounds');
            if (r + n > t.length) throw new RangeError("Index out of range");
          }

          function objectWriteUInt16(t, e, r, n) {
            e < 0 && (e = 65535 + e + 1);

            for (var i = 0, o = Math.min(t.length - r, 2); i < o; ++i) {
              t[r + i] = (e & 255 << 8 * (n ? i : 1 - i)) >>> 8 * (n ? i : 1 - i);
            }
          }

          function objectWriteUInt32(t, e, r, n) {
            e < 0 && (e = 4294967295 + e + 1);

            for (var i = 0, o = Math.min(t.length - r, 4); i < o; ++i) {
              t[r + i] = e >>> 8 * (n ? i : 3 - i) & 255;
            }
          }

          function checkIEEE754(t, e, r, n, i, o) {
            if (r + n > t.length) throw new RangeError("Index out of range");
            if (r < 0) throw new RangeError("Index out of range");
          }

          function writeFloat(t, e, r, n, o) {
            return o || checkIEEE754(t, 0, r, 4), i.write(t, e, r, n, 23, 4), r + 4;
          }

          function writeDouble(t, e, r, n, o) {
            return o || checkIEEE754(t, 0, r, 8), i.write(t, e, r, n, 52, 8), r + 8;
          }

          Buffer.prototype.slice = function slice(t, e) {
            var r,
                n = this.length;
            if ((t = ~~t) < 0 ? (t += n) < 0 && (t = 0) : t > n && (t = n), (e = void 0 === e ? n : ~~e) < 0 ? (e += n) < 0 && (e = 0) : e > n && (e = n), e < t && (e = t), Buffer.TYPED_ARRAY_SUPPORT) (r = this.subarray(t, e)).__proto__ = Buffer.prototype;else {
              var i = e - t;
              r = new Buffer(i, void 0);

              for (var o = 0; o < i; ++o) {
                r[o] = this[o + t];
              }
            }
            return r;
          }, Buffer.prototype.readUIntLE = function readUIntLE(t, e, r) {
            t |= 0, e |= 0, r || checkOffset(t, e, this.length);

            for (var n = this[t], i = 1, o = 0; ++o < e && (i *= 256);) {
              n += this[t + o] * i;
            }

            return n;
          }, Buffer.prototype.readUIntBE = function readUIntBE(t, e, r) {
            t |= 0, e |= 0, r || checkOffset(t, e, this.length);

            for (var n = this[t + --e], i = 1; e > 0 && (i *= 256);) {
              n += this[t + --e] * i;
            }

            return n;
          }, Buffer.prototype.readUInt8 = function readUInt8(t, e) {
            return e || checkOffset(t, 1, this.length), this[t];
          }, Buffer.prototype.readUInt16LE = function readUInt16LE(t, e) {
            return e || checkOffset(t, 2, this.length), this[t] | this[t + 1] << 8;
          }, Buffer.prototype.readUInt16BE = function readUInt16BE(t, e) {
            return e || checkOffset(t, 2, this.length), this[t] << 8 | this[t + 1];
          }, Buffer.prototype.readUInt32LE = function readUInt32LE(t, e) {
            return e || checkOffset(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + 16777216 * this[t + 3];
          }, Buffer.prototype.readUInt32BE = function readUInt32BE(t, e) {
            return e || checkOffset(t, 4, this.length), 16777216 * this[t] + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
          }, Buffer.prototype.readIntLE = function readIntLE(t, e, r) {
            t |= 0, e |= 0, r || checkOffset(t, e, this.length);

            for (var n = this[t], i = 1, o = 0; ++o < e && (i *= 256);) {
              n += this[t + o] * i;
            }

            return n >= (i *= 128) && (n -= Math.pow(2, 8 * e)), n;
          }, Buffer.prototype.readIntBE = function readIntBE(t, e, r) {
            t |= 0, e |= 0, r || checkOffset(t, e, this.length);

            for (var n = e, i = 1, o = this[t + --n]; n > 0 && (i *= 256);) {
              o += this[t + --n] * i;
            }

            return o >= (i *= 128) && (o -= Math.pow(2, 8 * e)), o;
          }, Buffer.prototype.readInt8 = function readInt8(t, e) {
            return e || checkOffset(t, 1, this.length), 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t];
          }, Buffer.prototype.readInt16LE = function readInt16LE(t, e) {
            e || checkOffset(t, 2, this.length);
            var r = this[t] | this[t + 1] << 8;
            return 32768 & r ? 4294901760 | r : r;
          }, Buffer.prototype.readInt16BE = function readInt16BE(t, e) {
            e || checkOffset(t, 2, this.length);
            var r = this[t + 1] | this[t] << 8;
            return 32768 & r ? 4294901760 | r : r;
          }, Buffer.prototype.readInt32LE = function readInt32LE(t, e) {
            return e || checkOffset(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
          }, Buffer.prototype.readInt32BE = function readInt32BE(t, e) {
            return e || checkOffset(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
          }, Buffer.prototype.readFloatLE = function readFloatLE(t, e) {
            return e || checkOffset(t, 4, this.length), i.read(this, t, !0, 23, 4);
          }, Buffer.prototype.readFloatBE = function readFloatBE(t, e) {
            return e || checkOffset(t, 4, this.length), i.read(this, t, !1, 23, 4);
          }, Buffer.prototype.readDoubleLE = function readDoubleLE(t, e) {
            return e || checkOffset(t, 8, this.length), i.read(this, t, !0, 52, 8);
          }, Buffer.prototype.readDoubleBE = function readDoubleBE(t, e) {
            return e || checkOffset(t, 8, this.length), i.read(this, t, !1, 52, 8);
          }, Buffer.prototype.writeUIntLE = function writeUIntLE(t, e, r, n) {
            t = +t, e |= 0, r |= 0, n || checkInt(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
            var i = 1,
                o = 0;

            for (this[e] = 255 & t; ++o < r && (i *= 256);) {
              this[e + o] = t / i & 255;
            }

            return e + r;
          }, Buffer.prototype.writeUIntBE = function writeUIntBE(t, e, r, n) {
            t = +t, e |= 0, r |= 0, n || checkInt(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
            var i = r - 1,
                o = 1;

            for (this[e + i] = 255 & t; --i >= 0 && (o *= 256);) {
              this[e + i] = t / o & 255;
            }

            return e + r;
          }, Buffer.prototype.writeUInt8 = function writeUInt8(t, e, r) {
            return t = +t, e |= 0, r || checkInt(this, t, e, 1, 255, 0), Buffer.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), this[e] = 255 & t, e + 1;
          }, Buffer.prototype.writeUInt16LE = function writeUInt16LE(t, e, r) {
            return t = +t, e |= 0, r || checkInt(this, t, e, 2, 65535, 0), Buffer.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : objectWriteUInt16(this, t, e, !0), e + 2;
          }, Buffer.prototype.writeUInt16BE = function writeUInt16BE(t, e, r) {
            return t = +t, e |= 0, r || checkInt(this, t, e, 2, 65535, 0), Buffer.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : objectWriteUInt16(this, t, e, !1), e + 2;
          }, Buffer.prototype.writeUInt32LE = function writeUInt32LE(t, e, r) {
            return t = +t, e |= 0, r || checkInt(this, t, e, 4, 4294967295, 0), Buffer.TYPED_ARRAY_SUPPORT ? (this[e + 3] = t >>> 24, this[e + 2] = t >>> 16, this[e + 1] = t >>> 8, this[e] = 255 & t) : objectWriteUInt32(this, t, e, !0), e + 4;
          }, Buffer.prototype.writeUInt32BE = function writeUInt32BE(t, e, r) {
            return t = +t, e |= 0, r || checkInt(this, t, e, 4, 4294967295, 0), Buffer.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : objectWriteUInt32(this, t, e, !1), e + 4;
          }, Buffer.prototype.writeIntLE = function writeIntLE(t, e, r, n) {
            if (t = +t, e |= 0, !n) {
              var i = Math.pow(2, 8 * r - 1);
              checkInt(this, t, e, r, i - 1, -i);
            }

            var o = 0,
                a = 1,
                s = 0;

            for (this[e] = 255 & t; ++o < r && (a *= 256);) {
              t < 0 && 0 === s && 0 !== this[e + o - 1] && (s = 1), this[e + o] = (t / a >> 0) - s & 255;
            }

            return e + r;
          }, Buffer.prototype.writeIntBE = function writeIntBE(t, e, r, n) {
            if (t = +t, e |= 0, !n) {
              var i = Math.pow(2, 8 * r - 1);
              checkInt(this, t, e, r, i - 1, -i);
            }

            var o = r - 1,
                a = 1,
                s = 0;

            for (this[e + o] = 255 & t; --o >= 0 && (a *= 256);) {
              t < 0 && 0 === s && 0 !== this[e + o + 1] && (s = 1), this[e + o] = (t / a >> 0) - s & 255;
            }

            return e + r;
          }, Buffer.prototype.writeInt8 = function writeInt8(t, e, r) {
            return t = +t, e |= 0, r || checkInt(this, t, e, 1, 127, -128), Buffer.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), t < 0 && (t = 255 + t + 1), this[e] = 255 & t, e + 1;
          }, Buffer.prototype.writeInt16LE = function writeInt16LE(t, e, r) {
            return t = +t, e |= 0, r || checkInt(this, t, e, 2, 32767, -32768), Buffer.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : objectWriteUInt16(this, t, e, !0), e + 2;
          }, Buffer.prototype.writeInt16BE = function writeInt16BE(t, e, r) {
            return t = +t, e |= 0, r || checkInt(this, t, e, 2, 32767, -32768), Buffer.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : objectWriteUInt16(this, t, e, !1), e + 2;
          }, Buffer.prototype.writeInt32LE = function writeInt32LE(t, e, r) {
            return t = +t, e |= 0, r || checkInt(this, t, e, 4, 2147483647, -2147483648), Buffer.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8, this[e + 2] = t >>> 16, this[e + 3] = t >>> 24) : objectWriteUInt32(this, t, e, !0), e + 4;
          }, Buffer.prototype.writeInt32BE = function writeInt32BE(t, e, r) {
            return t = +t, e |= 0, r || checkInt(this, t, e, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), Buffer.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : objectWriteUInt32(this, t, e, !1), e + 4;
          }, Buffer.prototype.writeFloatLE = function writeFloatLE(t, e, r) {
            return writeFloat(this, t, e, !0, r);
          }, Buffer.prototype.writeFloatBE = function writeFloatBE(t, e, r) {
            return writeFloat(this, t, e, !1, r);
          }, Buffer.prototype.writeDoubleLE = function writeDoubleLE(t, e, r) {
            return writeDouble(this, t, e, !0, r);
          }, Buffer.prototype.writeDoubleBE = function writeDoubleBE(t, e, r) {
            return writeDouble(this, t, e, !1, r);
          }, Buffer.prototype.copy = function copy(t, e, r, n) {
            if (r || (r = 0), n || 0 === n || (n = this.length), e >= t.length && (e = t.length), e || (e = 0), n > 0 && n < r && (n = r), n === r) return 0;
            if (0 === t.length || 0 === this.length) return 0;
            if (e < 0) throw new RangeError("targetStart out of bounds");
            if (r < 0 || r >= this.length) throw new RangeError("sourceStart out of bounds");
            if (n < 0) throw new RangeError("sourceEnd out of bounds");
            n > this.length && (n = this.length), t.length - e < n - r && (n = t.length - e + r);
            var i,
                o = n - r;
            if (this === t && r < e && e < n) for (i = o - 1; i >= 0; --i) {
              t[i + e] = this[i + r];
            } else if (o < 1e3 || !Buffer.TYPED_ARRAY_SUPPORT) for (i = 0; i < o; ++i) {
              t[i + e] = this[i + r];
            } else Uint8Array.prototype.set.call(t, this.subarray(r, r + o), e);
            return o;
          }, Buffer.prototype.fill = function fill(t, e, r, n) {
            if ("string" === typeof t) {
              if ("string" === typeof e ? (n = e, e = 0, r = this.length) : "string" === typeof r && (n = r, r = this.length), 1 === t.length) {
                var i = t.charCodeAt(0);
                i < 256 && (t = i);
              }

              if (void 0 !== n && "string" !== typeof n) throw new TypeError("encoding must be a string");
              if ("string" === typeof n && !Buffer.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
            } else "number" === typeof t && (t &= 255);

            if (e < 0 || this.length < e || this.length < r) throw new RangeError("Out of range index");
            if (r <= e) return this;
            var o;
            if (e >>>= 0, r = void 0 === r ? this.length : r >>> 0, t || (t = 0), "number" === typeof t) for (o = e; o < r; ++o) {
              this[o] = t;
            } else {
              var a = Buffer.isBuffer(t) ? t : utf8ToBytes(new Buffer(t, n).toString()),
                  s = a.length;

              for (o = 0; o < r - e; ++o) {
                this[o + e] = a[o % s];
              }
            }
            return this;
          };
          var s = /[^+\/0-9A-Za-z-_]/g;

          function toHex(t) {
            return t < 16 ? "0" + t.toString(16) : t.toString(16);
          }

          function utf8ToBytes(t, e) {
            var r;
            e = e || 1 / 0;

            for (var n = t.length, i = null, o = [], a = 0; a < n; ++a) {
              if ((r = t.charCodeAt(a)) > 55295 && r < 57344) {
                if (!i) {
                  if (r > 56319) {
                    (e -= 3) > -1 && o.push(239, 191, 189);
                    continue;
                  }

                  if (a + 1 === n) {
                    (e -= 3) > -1 && o.push(239, 191, 189);
                    continue;
                  }

                  i = r;
                  continue;
                }

                if (r < 56320) {
                  (e -= 3) > -1 && o.push(239, 191, 189), i = r;
                  continue;
                }

                r = 65536 + (i - 55296 << 10 | r - 56320);
              } else i && (e -= 3) > -1 && o.push(239, 191, 189);

              if (i = null, r < 128) {
                if ((e -= 1) < 0) break;
                o.push(r);
              } else if (r < 2048) {
                if ((e -= 2) < 0) break;
                o.push(r >> 6 | 192, 63 & r | 128);
              } else if (r < 65536) {
                if ((e -= 3) < 0) break;
                o.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
              } else {
                if (!(r < 1114112)) throw new Error("Invalid code point");
                if ((e -= 4) < 0) break;
                o.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
              }
            }

            return o;
          }

          function base64ToBytes(t) {
            return n.toByteArray(function base64clean(t) {
              if ((t = function stringtrim(t) {
                return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
              }(t).replace(s, "")).length < 2) return "";

              for (; t.length % 4 !== 0;) {
                t += "=";
              }

              return t;
            }(t));
          }

          function blitBuffer(t, e, r, n) {
            for (var i = 0; i < n && !(i + r >= e.length || i >= t.length); ++i) {
              e[i + r] = t[i];
            }

            return i;
          }
        }).call(this, r(14));
      }, function (t, e, r) {
        "use strict";

        e.byteLength = function byteLength(t) {
          var e = getLens(t),
              r = e[0],
              n = e[1];
          return 3 * (r + n) / 4 - n;
        }, e.toByteArray = function toByteArray(t) {
          for (var e, r = getLens(t), n = r[0], a = r[1], s = new o(function _byteLength(t, e, r) {
            return 3 * (e + r) / 4 - r;
          }(0, n, a)), c = 0, l = a > 0 ? n - 4 : n, u = 0; u < l; u += 4) {
            e = i[t.charCodeAt(u)] << 18 | i[t.charCodeAt(u + 1)] << 12 | i[t.charCodeAt(u + 2)] << 6 | i[t.charCodeAt(u + 3)], s[c++] = e >> 16 & 255, s[c++] = e >> 8 & 255, s[c++] = 255 & e;
          }

          return 2 === a && (e = i[t.charCodeAt(u)] << 2 | i[t.charCodeAt(u + 1)] >> 4, s[c++] = 255 & e), 1 === a && (e = i[t.charCodeAt(u)] << 10 | i[t.charCodeAt(u + 1)] << 4 | i[t.charCodeAt(u + 2)] >> 2, s[c++] = e >> 8 & 255, s[c++] = 255 & e), s;
        }, e.fromByteArray = function fromByteArray(t) {
          for (var e, r = t.length, i = r % 3, o = [], a = 0, s = r - i; a < s; a += 16383) {
            o.push(encodeChunk(t, a, a + 16383 > s ? s : a + 16383));
          }

          return 1 === i ? (e = t[r - 1], o.push(n[e >> 2] + n[e << 4 & 63] + "==")) : 2 === i && (e = (t[r - 2] << 8) + t[r - 1], o.push(n[e >> 10] + n[e >> 4 & 63] + n[e << 2 & 63] + "=")), o.join("");
        };

        for (var n = [], i = [], o = "undefined" !== typeof Uint8Array ? Uint8Array : Array, a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", s = 0, c = a.length; s < c; ++s) {
          n[s] = a[s], i[a.charCodeAt(s)] = s;
        }

        function getLens(t) {
          var e = t.length;
          if (e % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
          var r = t.indexOf("=");
          return -1 === r && (r = e), [r, r === e ? 0 : 4 - r % 4];
        }

        function encodeChunk(t, e, r) {
          for (var i, o, a = [], s = e; s < r; s += 3) {
            i = (t[s] << 16 & 16711680) + (t[s + 1] << 8 & 65280) + (255 & t[s + 2]), a.push(n[(o = i) >> 18 & 63] + n[o >> 12 & 63] + n[o >> 6 & 63] + n[63 & o]);
          }

          return a.join("");
        }

        i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63;
      }, function (t, e) {
        e.read = function (t, e, r, n, i) {
          var o,
              a,
              s = 8 * i - n - 1,
              c = (1 << s) - 1,
              l = c >> 1,
              u = -7,
              h = r ? i - 1 : 0,
              d = r ? -1 : 1,
              f = t[e + h];

          for (h += d, o = f & (1 << -u) - 1, f >>= -u, u += s; u > 0; o = 256 * o + t[e + h], h += d, u -= 8) {
            ;
          }

          for (a = o & (1 << -u) - 1, o >>= -u, u += n; u > 0; a = 256 * a + t[e + h], h += d, u -= 8) {
            ;
          }

          if (0 === o) o = 1 - l;else {
            if (o === c) return a ? NaN : 1 / 0 * (f ? -1 : 1);
            a += Math.pow(2, n), o -= l;
          }
          return (f ? -1 : 1) * a * Math.pow(2, o - n);
        }, e.write = function (t, e, r, n, i, o) {
          var a,
              s,
              c,
              l = 8 * o - i - 1,
              u = (1 << l) - 1,
              h = u >> 1,
              d = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
              f = n ? 0 : o - 1,
              p = n ? 1 : -1,
              y = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;

          for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (s = isNaN(e) ? 1 : 0, a = u) : (a = Math.floor(Math.log(e) / Math.LN2), e * (c = Math.pow(2, -a)) < 1 && (a--, c *= 2), (e += a + h >= 1 ? d / c : d * Math.pow(2, 1 - h)) * c >= 2 && (a++, c /= 2), a + h >= u ? (s = 0, a = u) : a + h >= 1 ? (s = (e * c - 1) * Math.pow(2, i), a += h) : (s = e * Math.pow(2, h - 1) * Math.pow(2, i), a = 0)); i >= 8; t[r + f] = 255 & s, f += p, s /= 256, i -= 8) {
            ;
          }

          for (a = a << i | s, l += i; l > 0; t[r + f] = 255 & a, f += p, a /= 256, l -= 8) {
            ;
          }

          t[r + f - p] |= 128 * y;
        };
      }, function (t, e) {
        var r = {}.toString;

        t.exports = Array.isArray || function (t) {
          return "[object Array]" == r.call(t);
        };
      }, function (t, e, r) {
        "use strict";

        t.exports = function required(t, e) {
          if (e = e.split(":")[0], !(t = +t)) return !1;

          switch (e) {
            case "http":
            case "ws":
              return 80 !== t;

            case "https":
            case "wss":
              return 443 !== t;

            case "ftp":
              return 21 !== t;

            case "gopher":
              return 70 !== t;

            case "file":
              return !1;
          }

          return 0 !== t;
        };
      }, function (t, e, r) {
        "use strict";

        var n = Object.prototype.hasOwnProperty;

        function decode(t) {
          return decodeURIComponent(t.replace(/\+/g, " "));
        }

        e.stringify = function querystringify(t, e) {
          e = e || "";
          var r,
              i,
              o = [];

          for (i in "string" !== typeof e && (e = "?"), t) {
            n.call(t, i) && ((r = t[i]) || null !== r && void 0 !== r && !isNaN(r) || (r = ""), o.push(encodeURIComponent(i) + "=" + encodeURIComponent(r)));
          }

          return o.length ? e + o.join("&") : "";
        }, e.parse = function querystring(t) {
          for (var e, r = /([^=?&]+)=?([^&]*)/g, n = {}; e = r.exec(t);) {
            var i = decode(e[1]),
                o = decode(e[2]);
            i in n || (n[i] = o);
          }

          return n;
        };
      }, function (t, e, r) {
        "use strict";

        function _defineProperty(t, e, r) {
          return e in t ? Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : t[e] = r, t;
        }

        function ownKeys(t, e) {
          var r = Object.keys(t);

          if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(t);
            e && (n = n.filter(function (e) {
              return Object.getOwnPropertyDescriptor(t, e).enumerable;
            })), r.push.apply(r, n);
          }

          return r;
        }

        function _objectSpread2(t) {
          for (var e = 1; e < arguments.length; e++) {
            var r = null != arguments[e] ? arguments[e] : {};
            e % 2 ? ownKeys(Object(r), !0).forEach(function (e) {
              _defineProperty(t, e, r[e]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function (e) {
              Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
            });
          }

          return t;
        }

        r.r(e);

        var n = r(15),
            i = r(16),
            o = {
          QA: r(17),
          EU: r(18),
          US: i,
          DEV: n
        },
            a = _objectSpread2(_objectSpread2({}, window.DRIFT_CONFIG || {}), o[window.DRIFT_REGION || ("PRODUCTION" === window.__ENV__ ? "US" : "MASTER" === window.__ENV__ ? "QA" : "DEV")]),
            s = r(3),
            c = r.n(s),
            l = c.a.create({
          baseURL: a.AUTH_API,
          headers: {
            "Content-Type": "application/json"
          }
        }),
            u = r(2),
            h = r.n(u);

        function asyncGeneratorStep(t, e, r, n, i, o, a) {
          try {
            var s = t[o](a),
                c = s.value;
          } catch (l) {
            return void r(l);
          }

          s.done ? e(c) : Promise.resolve(c).then(n, i);
        }

        function _asyncToGenerator(t) {
          return function () {
            var e = this,
                r = arguments;
            return new Promise(function (n, i) {
              var o = t.apply(e, r);

              function _next(t) {
                asyncGeneratorStep(o, n, i, _next, _throw, "next", t);
              }

              function _throw(t) {
                asyncGeneratorStep(o, n, i, _next, _throw, "throw", t);
              }

              _next(void 0);
            });
          };
        }

        var d = r(4),
            f = r.n(d),
            p = r(1),
            y = r(5),
            g = r.n(y),
            m = {
          domain: a.TOKEN_MANAGER_URL
        },
            v = "writeToken",
            b = function getCookie(t) {
          return f.a.get(t);
        },
            x = function setCookie(t, e, r) {
          return f.a.set(t, e, r);
        },
            w = function crossSkuAuthEnabled() {
          return a.CROSS_SKU_AUTH_ENABLED;
        },
            S = function () {
          var t = _asyncToGenerator(h.a.mark(function _callee() {
            var t;
            return h.a.wrap(function _callee$(e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return (t = document.createElement("iframe")).id = "tokenFrame", t.src = a.TOKEN_MANAGER_URL, t.style = "display:none", document.body.appendChild(t), e.abrupt("return", new Promise(function (e, r) {
                      var n = setTimeout(function () {
                        window.analytics && window.analytics.track("Failed to load global auth"), r("Failed to load global auth");
                      }, 2e3);
                      g.a.on("frameLoaded", {
                        window: t.contentWindow
                      }, function () {
                        clearTimeout(n), e();
                      });
                    }));

                  case 6:
                  case "end":
                    return e.stop();
                }
              }
            }, _callee);
          }));

          return function generateNewAuthFrame() {
            return t.apply(this, arguments);
          };
        }(),
            O = function postToAuthFrame(t, e) {
          if (w()) {
            var r = document.getElementById("tokenFrame"),
                n = !!r && r.contentWindow;
            return g.a.send(n, t, e, m).catch(function (t) {
              return console.warn("Global auth error: ", t);
            });
          }
        },
            E = function resolveCookieOptions(t) {
          var e = function resolveExpirationDate(t) {
            return new Date(Date.now() + 1e3 * (t || 31536e3));
          }(t.expirationInSeconds);

          return Object(p.merge)(a.DEFAULT_COOKIE_OPTIONS, {
            expires: e
          });
        },
            k = function () {
          var t = _asyncToGenerator(h.a.mark(function _callee2() {
            var t;
            return h.a.wrap(function _callee2$(e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (!w()) {
                      e.next = 17;
                      break;
                    }

                    if (t = document.getElementById("tokenFrame"), e.prev = 2, !t) {
                      e.next = 8;
                      break;
                    }

                    return e.next = 6, _();

                  case 6:
                    e.next = 12;
                    break;

                  case 8:
                    return e.next = 10, S();

                  case 10:
                    return e.next = 12, _();

                  case 12:
                    e.next = 17;
                    break;

                  case 14:
                    e.prev = 14, e.t0 = e.catch(2), console.warn(e.t0);

                  case 17:
                  case "end":
                    return e.stop();
                }
              }
            }, _callee2, null, [[2, 14]]);
          }));

          return function loadAuthFrameAndTransferCookie() {
            return t.apply(this, arguments);
          };
        }(),
            _ = function () {
          var t = _asyncToGenerator(h.a.mark(function _callee3() {
            var t, e, r;
            return h.a.wrap(function _callee3$(n) {
              for (;;) {
                switch (n.prev = n.next) {
                  case 0:
                    if (!(t = A())) {
                      n.next = 5;
                      break;
                    }

                    O(v, {
                      token: t
                    }), n.next = 10;
                    break;

                  case 5:
                    return n.next = 7, O("readToken", {});

                  case 7:
                    e = n.sent, (r = e.data) && T({
                      token: r
                    });

                  case 10:
                  case "end":
                    return n.stop();
                }
              }
            }, _callee3);
          }));

          return function transferCookieFromFrame() {
            return t.apply(this, arguments);
          };
        }(),
            C = function setAuthCookie(t) {
          var e = t.token,
              r = t.expirationInSeconds;
          T({
            token: e,
            expirationInSeconds: r
          }), O(v, {
            token: e,
            expirationInSeconds: r
          });
        },
            T = function setLocalAuthCookie(t) {
          var e = t.token,
              r = t.expirationInSeconds;
          x("DrifttAuth", e, E({
            expirationInSeconds: r
          }));
        },
            A = function readAuthCookie() {
          return b("DrifttAuth");
        },
            M = r(19),
            P = r.n(M),
            j = function expireToken() {
          return function client() {
            return c.a.create({
              baseURL: a.CUSTOMER_API,
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer ".concat(A())
              }
            });
          }().delete("/oauth/token").catch(function (t) {});
        },
            R = function setIdentityInfo(t, e) {
          var r = t.id,
              n = t.orgId,
              i = t.email,
              o = t.name,
              a = t.scopes,
              s = t.avatarUrl,
              c = t.disabled,
              l = t.token,
              u = void 0 === l ? A() : l,
              h = e.name,
              d = e["org-logo-url"];
          D({
            id: r,
            orgId: n,
            email: i,
            name: o,
            scopes: a,
            avatarUrl: s,
            disabled: c,
            token: u,
            orgName: h,
            orgLogo: d
          });
        },
            D = function storeIdentityInfo(t) {
          var e = t.id,
              r = t.orgId,
              n = t.email,
              i = t.name,
              o = t.scopes,
              a = t.avatarUrl,
              s = t.disabled,
              c = t.token,
              l = void 0 === c ? A() : c,
              u = t.orgName,
              h = t.orgLogo;
          window.localStorage.setItem("".concat("drift.identity", ".").concat(e), JSON.stringify({
            email: n,
            name: i,
            orgId: r,
            avatarUrl: a,
            disabled: s,
            token: l,
            orgName: u,
            orgLogo: h,
            scopes: o
          })), I().includes(e) || window.localStorage.setItem("".concat("drift.identity"), JSON.stringify(Object(p.append)(e, I())));
        },
            I = function getAvailableIdentities() {
          var t = window.localStorage.getItem("".concat("drift.identity"));
          return t ? JSON.parse(t) : [];
        },
            L = function getIdentityInfo(t) {
          var e = t.id;
          return JSON.parse(window.localStorage.getItem("".concat("drift.identity", ".").concat(e)));
        },
            N = function clearIdentityInfo(t) {
          var e = Object(p.findIndex)(Object(p.propEq)("token", t))(I().map(function (t) {
            return L({
              id: t
            });
          }));

          if (!Object(p.isNil)(e) && e >= 0) {
            var r = I()[e],
                n = L({
              id: r
            });
            n.id = r, n.disabled = !0, D(n);
          }
        },
            B = function getDisplayableIdentities() {
          return Object(p.filter)(function (t) {
            return !t.disabled;
          }, I().map(function (t) {
            return L({
              id: t
            });
          }));
        },
            F = function constructUrlObjectWithoutAuthParams(t) {
          var e = function parseUrl(t) {
            return P()("".concat(t.pathname).concat(t.search), !0);
          }(t),
              r = Object(p.omit)(["code", "token"], e.query);

          return e.set("query", r);
        },
            U = function removeServiceWorkers() {
          return "serviceWorker" in navigator && "PushManager" in window ? navigator.serviceWorker.getRegistrations().then(function (t) {
            return Promise.all(t.map(function (t) {
              return t.unregister().catch(function (e) {
                return console.error("Unable to unsubscribe service worker", t, e);
              });
            }));
          }) : Promise.resolve();
        },
            W = function () {
          var t = _asyncToGenerator(h.a.mark(function _callee(t, e, r) {
            var n, i, o;
            return h.a.wrap(function _callee$(s) {
              for (;;) {
                switch (s.prev = s.next) {
                  case 0:
                    return s.prev = 0, s.next = 3, U();

                  case 3:
                    s.next = 8;
                    break;

                  case 5:
                    s.prev = 5, s.t0 = s.catch(0), console.error("Unable to unregister service worker", s.t0);

                  case 8:
                    return s.next = 10, j();

                  case 10:
                    N(A()), Q(), (n = F(window.location).href).indexOf("logout") > 0 && (n = "/"), i = encodeURIComponent(n), o = "".concat(a.LOGIN_URL, "?redirect=").concat(i, "&client=").concat(t, "&timeout=").concat(!!e, "&deleteAccount=").concat(!!r), window.location.href = o;

                  case 17:
                  case "end":
                    return s.stop();
                }
              }
            }, _callee, null, [[0, 5]]);
          }));

          return function redirectToLoginPage(e, r, n) {
            return t.apply(this, arguments);
          };
        }(),
            z = {
          headers: {
            "Content-Type": "application/json"
          }
        },
            q = function DEFAULT_COOKIE_HANDLER(t) {
          var e = t.headers,
              r = A();
          return r && (e.Authorization = "Bearer ".concat(r)), _objectSpread2(_objectSpread2({}, t), {}, {
            headers: e
          });
        },
            H = function buildResponseErrorHandlers() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
          return function (e) {
            return t.forEach(function (t) {
              return t(e);
            }), function DEFAULT_ERROR_HANDLER(t) {
              return Promise.reject(t);
            }(e);
          };
        },
            G = function createAuthedHttpClient(t) {
          var e = t.baseConfig,
              r = void 0 === e ? {} : e,
              n = t.responseSuccessHandlers,
              i = void 0 === n ? [] : n,
              o = t.responseErrorHandlers,
              a = void 0 === o ? [] : o;
          return function createAxiosInstance(t) {
            var e = t.config,
                r = t.responseSuccessInterceptor,
                n = t.responseErrorInterceptor,
                i = c.a.create(e);
            return i.interceptors.response.use(r, n), i.interceptors.request.use(q), i;
          }({
            config: function resolveConfig(t) {
              return Object(p.merge)(z, t);
            }(r),
            responseSuccessInterceptor: function buildResponseSuccessHandlers() {
              var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
              return function (e) {
                return t.forEach(function (t) {
                  return t(e);
                }), function DEFAULT_SUCCESS_HANDLER(t) {
                  return t;
                }(e);
              };
            }(i),
            responseErrorInterceptor: H(a)
          });
        },
            Y = function authenticateWithCode(t) {
          var e = t.authorizationCode,
              r = t.clientId;
          Q();

          var n = function sendTokenToExtension(t, e) {
            return window.chrome.runtime.sendMessage(e, {
              type: "AUTH_TOKEN",
              token: t
            });
          };

          return function exchangeCodeForToken(t) {
            var e = {
              code: t
            };
            return l.post("/authenticate/token", e).then(function (t) {
              return t.data;
            });
          }(e).then(function handleToken(t) {
            var e = t.token,
                r = t.expirationInSeconds;
            !function setHttpClientAuth(t) {
              c.a.defaults.headers.common.Authorization = "Bearer ".concat(t);
            }(e), C({
              token: e,
              expirationInSeconds: r
            }), window.chrome && window.chrome.runtime && (n(e, a.CHROME_EXTENSION_ID), n(e, a.LOGIN_EXTENSION_ID), n(e, a.VIDEO_EXTENSION_ID), n(e, a.NEW_VIDEO_EXTENSION_ID));
          }).catch(function () {
            return W(r);
          });
        },
            X = function getAccessToken() {
          return A();
        },
            V = C,
            $ = function removeAuthCookieExpiration() {
          var t = b("DrifttAuth");
          t && (x("DrifttAuth", t, a.DEFAULT_COOKIE_OPTIONS), O(v, {
            token: t
          }));
        },
            Q = function deleteAccessToken() {
          return function clearAuthCookie() {
            !function clearCookie(t, e) {
              f.a.remove(t, e);
            }("DrifttAuth", a.DEFAULT_COOKIE_OPTIONS), O("deleteToken", {});
          }();
        },
            K = function checkForGlobalSession() {
          return k();
        },
            Z = function increaseOpenTabCount() {
          var t = tt();
          et(t > 0 ? t + 1 : 1);
        },
            J = function decreaseOpenTabCount(t) {
          var e = t.tokenExpirationInMillis,
              r = tt();
          et(r - 1), r <= 1 && e > 0 && function updateAuthCookieExpiration(t) {
            var e = t.expirationInSeconds,
                r = b("DrifttAuth");
            r && (x("DrifttAuth", r, E({
              expirationInSeconds: e
            })), O(v, {
              token: r,
              expirationInSeconds: e
            }));
          }({
            expirationInSeconds: e / 1e3
          });
        },
            tt = function getOpenTabCount() {
          return parseInt(localStorage.getItem("openTabCount"), 10);
        },
            et = function setOpenTabCount(t) {
          return localStorage.setItem("openTabCount", t);
        };

        r.d(e, "authenticateWithCode", function () {
          return Y;
        }), r.d(e, "checkForGlobalSession", function () {
          return K;
        }), r.d(e, "clearIdentityInfo", function () {
          return N;
        }), r.d(e, "constructUrlObjectWithoutAuthParams", function () {
          return F;
        }), r.d(e, "createAuthedHttpClient", function () {
          return G;
        }), r.d(e, "decreaseOpenTabCount", function () {
          return J;
        }), r.d(e, "deleteAccessToken", function () {
          return Q;
        }), r.d(e, "getAccessToken", function () {
          return X;
        }), r.d(e, "getAvailableIdentities", function () {
          return I;
        }), r.d(e, "getDisplayableIdentities", function () {
          return B;
        }), r.d(e, "getIdentityInfo", function () {
          return L;
        }), r.d(e, "increaseOpenTabCount", function () {
          return Z;
        }), r.d(e, "redirectToLoginPage", function () {
          return W;
        }), r.d(e, "removeAccessTokenExpiration", function () {
          return $;
        }), r.d(e, "setAccessToken", function () {
          return V;
        }), r.d(e, "setIdentityInfo", function () {
          return R;
        });
      }]);
    });
  }, function (t, e, r) {
    "use strict";

    var n = r(56),
        i = r(69),
        o = r(32);
    t.exports = {
      formats: o,
      parse: i,
      stringify: n
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(15),
        i = r(20);
    var o = r(25);

    function construct_construct(t, e, r) {
      return (construct_construct = Object(o.a)() ? Reflect.construct : function _construct(t, e, r) {
        var n = [null];
        n.push.apply(n, e);
        var o = new (Function.bind.apply(t, n))();
        return r && Object(i.a)(o, r.prototype), o;
      }).apply(null, arguments);
    }

    function wrapNativeSuper_wrapNativeSuper(t) {
      var e = "function" === typeof Map ? new Map() : void 0;
      return (wrapNativeSuper_wrapNativeSuper = function _wrapNativeSuper(t) {
        if (null === t || !function _isNativeFunction(t) {
          return -1 !== Function.toString.call(t).indexOf("[native code]");
        }(t)) return t;
        if ("function" !== typeof t) throw new TypeError("Super expression must either be null or a function");

        if ("undefined" !== typeof e) {
          if (e.has(t)) return e.get(t);
          e.set(t, Wrapper);
        }

        function Wrapper() {
          return construct_construct(t, arguments, Object(n.a)(this).constructor);
        }

        return Wrapper.prototype = Object.create(t.prototype, {
          constructor: {
            value: Wrapper,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), Object(i.a)(Wrapper, t);
      })(t);
    }

    r.d(e, "a", function () {
      return wrapNativeSuper_wrapNativeSuper;
    });
  }, function (t, e, r) {
    "use strict";

    var n = r(61);
    t.exports = Function.prototype.bind || n;
  }, function (t, e, r) {
    "use strict";

    var n = String.prototype.replace,
        i = /%20/g,
        o = "RFC1738",
        a = "RFC3986";
    t.exports = {
      default: a,
      formatters: {
        RFC1738: function RFC1738(t) {
          return n.call(t, i, "+");
        },
        RFC3986: function RFC3986(t) {
          return String(t);
        }
      },
      RFC1738: o,
      RFC3986: a
    };
  }, function (t, e, r) {
    var n = r(39);

    t.exports = function _unsupportedIterableToArray(t, e) {
      if (t) {
        if ("string" === typeof t) return n(t, e);
        var r = Object.prototype.toString.call(t).slice(8, -1);
        return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(r) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? n(t, e) : void 0;
      }
    };
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.faWrench = void 0;
    e.faWrench = {
      prefix: "far",
      iconName: "faWrench",
      icon: [512, 512, [], "", "M507.5 117.1c-2.1-12.13-12.37-21.75-24.5-25.13c-12.12-3.25-25.12 .125-33.1 9L390.4 159.6L357.9 154.2l-5.375-32.38l58.75-58.75c8.75-8.875 12.25-21.88 8.875-33.88c-3.375-12.13-13.12-21.5-25.25-24.63c-53.12-13.13-107.1 2.125-146.6 40.75c-37.62 37.63-52.62 91.38-40.75 143.3L23.1 371.1C8.5 387.5 0 408.1 0 429.1s8.5 42.5 23.1 58S60.12 512 81.1 512c21.88 0 42.5-8.5 58-24l183.4-183.3c51.75 11.88 105.6-3.125 143.5-41C504.9 225.7 520.5 169.5 507.5 117.1zM432.9 229.9c-28.5 28.5-70.25 38.13-108.1 25.25l-14.12-4.75l-203.7 203.6c-12.75 12.88-35.25 12.88-47.1 0c-6.499-6.375-9.999-14.88-9.999-24c0-9 3.5-17.63 9.999-24l203.9-203.8l-4.625-14.13C244.4 149.2 253.1 107.5 282.2 79.24c20.37-20.25 47.12-31.25 74.1-31.25h1.125L301.1 105.4l15.12 90.5l90.5 15.13l57.37-57.25C464.5 181.1 453.5 209.2 432.9 229.9zM87.1 407.1c-8.875 0-15.1 7.125-15.1 16c0 8.875 7.125 16 15.1 16s15.1-7.125 15.1-16C103.1 415.1 96.87 407.1 87.1 407.1z"]
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(17)("%Object.defineProperty%", !0),
        i = function hasPropertyDescriptors() {
      if (n) try {
        return n({}, "a", {
          value: 1
        }), !0;
      } catch (t) {
        return !1;
      }
      return !1;
    };

    i.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
      if (!i()) return null;

      try {
        return 1 !== n([], "length", {
          value: 1
        }).length;
      } catch (t) {
        return !0;
      }
    }, t.exports = i;
  }, function (t, e, r) {
    "use strict";

    var n = r(17)("%Object.getOwnPropertyDescriptor%", !0);
    if (n) try {
      n([], "length");
    } catch (i) {
      n = null;
    }
    t.exports = n;
  }, function (t, e) {
    var r;

    r = function () {
      return this;
    }();

    try {
      r = r || new Function("return this")();
    } catch (n) {
      "object" === typeof window && (r = window);
    }

    t.exports = r;
  }, function (t, e, r) {
    "use strict";

    var n = r(32),
        i = Object.prototype.hasOwnProperty,
        o = Array.isArray,
        a = function () {
      for (var t = [], e = 0; e < 256; ++e) {
        t.push("%" + ((e < 16 ? "0" : "") + e.toString(16)).toUpperCase());
      }

      return t;
    }(),
        s = function arrayToObject(t, e) {
      for (var r = e && e.plainObjects ? Object.create(null) : {}, n = 0; n < t.length; ++n) {
        "undefined" !== typeof t[n] && (r[n] = t[n]);
      }

      return r;
    };

    t.exports = {
      arrayToObject: s,
      assign: function assignSingleSource(t, e) {
        return Object.keys(e).reduce(function (t, r) {
          return t[r] = e[r], t;
        }, t);
      },
      combine: function combine(t, e) {
        return [].concat(t, e);
      },
      compact: function compact(t) {
        for (var e = [{
          obj: {
            o: t
          },
          prop: "o"
        }], r = [], n = 0; n < e.length; ++n) {
          for (var i = e[n], a = i.obj[i.prop], s = Object.keys(a), c = 0; c < s.length; ++c) {
            var l = s[c],
                u = a[l];
            "object" === typeof u && null !== u && -1 === r.indexOf(u) && (e.push({
              obj: a,
              prop: l
            }), r.push(u));
          }
        }

        return function compactQueue(t) {
          for (; t.length > 1;) {
            var e = t.pop(),
                r = e.obj[e.prop];

            if (o(r)) {
              for (var n = [], i = 0; i < r.length; ++i) {
                "undefined" !== typeof r[i] && n.push(r[i]);
              }

              e.obj[e.prop] = n;
            }
          }
        }(e), t;
      },
      decode: function decode(t, e, r) {
        var n = t.replace(/\+/g, " ");
        if ("iso-8859-1" === r) return n.replace(/%[0-9a-f]{2}/gi, unescape);

        try {
          return decodeURIComponent(n);
        } catch (i) {
          return n;
        }
      },
      encode: function encode(t, e, r, i, o) {
        if (0 === t.length) return t;
        var s = t;
        if ("symbol" === typeof t ? s = Symbol.prototype.toString.call(t) : "string" !== typeof t && (s = String(t)), "iso-8859-1" === r) return escape(s).replace(/%u[0-9a-f]{4}/gi, function (t) {
          return "%26%23" + parseInt(t.slice(2), 16) + "%3B";
        });

        for (var c = "", l = 0; l < s.length; ++l) {
          var u = s.charCodeAt(l);
          45 === u || 46 === u || 95 === u || 126 === u || u >= 48 && u <= 57 || u >= 65 && u <= 90 || u >= 97 && u <= 122 || o === n.RFC1738 && (40 === u || 41 === u) ? c += s.charAt(l) : u < 128 ? c += a[u] : u < 2048 ? c += a[192 | u >> 6] + a[128 | 63 & u] : u < 55296 || u >= 57344 ? c += a[224 | u >> 12] + a[128 | u >> 6 & 63] + a[128 | 63 & u] : (l += 1, u = 65536 + ((1023 & u) << 10 | 1023 & s.charCodeAt(l)), c += a[240 | u >> 18] + a[128 | u >> 12 & 63] + a[128 | u >> 6 & 63] + a[128 | 63 & u]);
        }

        return c;
      },
      isBuffer: function isBuffer(t) {
        return !(!t || "object" !== typeof t) && !!(t.constructor && t.constructor.isBuffer && t.constructor.isBuffer(t));
      },
      isRegExp: function isRegExp(t) {
        return "[object RegExp]" === Object.prototype.toString.call(t);
      },
      maybeMap: function maybeMap(t, e) {
        if (o(t)) {
          for (var r = [], n = 0; n < t.length; n += 1) {
            r.push(e(t[n]));
          }

          return r;
        }

        return e(t);
      },
      merge: function merge(t, e, r) {
        if (!e) return t;

        if ("object" !== typeof e) {
          if (o(t)) t.push(e);else {
            if (!t || "object" !== typeof t) return [t, e];
            (r && (r.plainObjects || r.allowPrototypes) || !i.call(Object.prototype, e)) && (t[e] = !0);
          }
          return t;
        }

        if (!t || "object" !== typeof t) return [t].concat(e);
        var n = t;
        return o(t) && !o(e) && (n = s(t, r)), o(t) && o(e) ? (e.forEach(function (e, n) {
          if (i.call(t, n)) {
            var o = t[n];
            o && "object" === typeof o && e && "object" === typeof e ? t[n] = merge(o, e, r) : t.push(e);
          } else t[n] = e;
        }), t) : Object.keys(e).reduce(function (t, n) {
          var o = e[n];
          return i.call(t, n) ? t[n] = merge(t[n], o, r) : t[n] = o, t;
        }, n);
      }
    };
  }, function (t, e) {
    t.exports = function _arrayLikeToArray(t, e) {
      (null == e || e > t.length) && (e = t.length);

      for (var r = 0, n = new Array(e); r < e; r++) {
        n[r] = t[r];
      }

      return n;
    };
  }, function (t) {
    t.exports = {
      APP_URL: "https://app.driftqa.com",
      PAGES_HOST: "driftqa.click"
    };
  }, function (t) {
    t.exports = {
      APP_URL: "https://app.drift.com",
      PAGES_HOST: "eu.drift.click"
    };
  }, function (t) {
    t.exports = {
      APP_URL: "https://app.drift.com",
      PAGES_HOST: "drift.click"
    };
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.faThumbsDown = void 0;
    e.faThumbsDown = {
      prefix: "fal",
      iconName: "faThumbsDown",
      icon: [512, 512, [], "", "M128 280v-208C128 49.94 110.1 32 88 32h-48C17.94 32 0 49.94 0 72v208C0 302.1 17.94 320 40 320h48C110.1 320 128 302.1 128 280zM96 280C96 284.4 92.41 288 88 288h-48C35.59 288 32 284.4 32 280v-208C32 67.59 35.59 64 40 64h48C92.41 64 96 67.59 96 72V280zM477.9 235.7c2.469-6.672 3.75-13.77 3.75-20.98c0-22.97-12.75-43.42-32.06-53.94c1.141-4.672 1.734-9.469 1.734-14.27c0-22.06-11.78-41.94-30.33-52.8C421 59.84 393.4 32 359.5 32H303.9c-77.41 0-143.9 63.11-143.9 80.07c0 8.767 7.133 15.96 16 15.96C195.8 128 222.2 64 303.9 64h55.63c16.27 0 29.5 13.22 29.5 29.47c0 4.826-1.185 6.491-1.185 10.01c0 20.94 31.51 12.09 31.51 43.05c0 12.84-6.765 14.68-6.765 23.56c0 9.347 7.255 14.66 13.06 15.75c13.92 2.594 24.03 14.75 24.03 28.89c0 17.77-12.06 18.45-12.06 30.63c0 8.314 6.443 15.38 14.91 15.96C467.9 262.4 480 275.2 480 290.5C480 306.8 466.8 320 450.5 320h-128.3c-8.273 0-15.1 6.658-15.1 16.01c0 2.699 .68 5.398 2.046 7.83c17.73 31.53 26.62 65.39 26.62 75.48C334.9 431.2 325.6 448 304.9 448c-16.7 0-19.66-4.953-28.78-32.78c-21.79-66.41-36.14-69.47-88.81-122.5C184.2 289.6 180.1 288 176 288C167.4 288 160 294.9 160 303.1c0 23.25 57.94 36.53 85.73 121.2C254.2 450.9 263.6 480 304.9 480c38.77 0 62.01-30.84 62.01-60.67c0-13.84-6.844-40.27-18.83-67.33h102.5C484.4 352 512 324.4 512 290.5C512 266.8 498.2 245.8 477.9 235.7z"]
    };
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.faThumbsUp = void 0;
    e.faThumbsUp = {
      prefix: "fal",
      iconName: "faThumbsUp",
      icon: [512, 512, [], "", "M88 192h-48C17.94 192 0 209.9 0 232v208C0 462.1 17.94 480 40 480h48C110.1 480 128 462.1 128 440v-208C128 209.9 110.1 192 88 192zM96 440C96 444.4 92.41 448 88 448h-48C35.59 448 32 444.4 32 440v-208C32 227.6 35.59 224 40 224h48C92.41 224 96 227.6 96 232V440zM512 221.5C512 187.6 484.4 160 450.5 160h-102.5c11.98-27.06 18.83-53.48 18.83-67.33C366.9 62.84 343.6 32 304.9 32c-41.22 0-50.7 29.11-59.12 54.81C218.1 171.1 160 184.8 160 208C160 217.1 167.5 224 176 224C180.1 224 184.2 222.4 187.3 219.3c52.68-53.04 67.02-56.11 88.81-122.5C285.3 68.95 288.2 64 304.9 64c20.66 0 29.94 16.77 29.94 28.67c0 10.09-8.891 43.95-26.62 75.48c-1.366 2.432-2.046 5.131-2.046 7.83C306.2 185.5 314 192 322.2 192h128.3C466.8 192 480 205.2 480 221.5c0 15.33-12.08 28.16-27.48 29.2c-8.462 .5813-14.91 7.649-14.91 15.96c0 12.19 12.06 12.86 12.06 30.63c0 14.14-10.11 26.3-24.03 28.89c-5.778 1.082-13.06 6.417-13.06 15.75c0 8.886 6.765 10.72 6.765 23.56c0 31.02-31.51 22.12-31.51 43.05c0 3.526 1.185 5.13 1.185 10.01C389 434.8 375.8 448 359.5 448H303.9c-82.01 0-108.3-64.02-127.9-64.02c-8.873 0-16 7.193-16 15.96C159.1 416.3 224.6 480 303.9 480h55.63c33.91 0 61.5-27.58 61.5-61.47c18.55-10.86 30.33-31 30.33-53.06c0-4.797-.5938-9.594-1.734-14.27c19.31-10.52 32.06-30.97 32.06-53.94c0-7.219-1.281-14.31-3.75-20.98C498.2 266.2 512 245.3 512 221.5z"]
    };
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.faThumbsDown = void 0;
    e.faThumbsDown = {
      prefix: "fas",
      iconName: "faThumbsDown",
      icon: [512, 512, [], "", "M96 32.04H32c-17.67 0-32 14.32-32 31.1v223.1c0 17.67 14.33 31.1 32 31.1h64c17.67 0 32-14.33 32-31.1V64.03C128 46.36 113.7 32.04 96 32.04zM467.3 240.2C475.1 231.7 480 220.4 480 207.9c0-23.47-16.87-42.92-39.14-47.09C445.3 153.6 448 145.1 448 135.1c0-21.32-14-39.18-33.25-45.43C415.5 87.12 416 83.61 416 79.98C416 53.47 394.5 32 368 32h-58.69c-34.61 0-68.28 11.22-95.97 31.98L179.2 89.57C167.1 98.63 160 112.9 160 127.1l.1074 160c0 0-.0234-.0234 0 0c.0703 13.99 6.123 27.94 17.91 37.36l16.3 13.03C276.2 403.9 239.4 480 302.5 480c30.96 0 49.47-24.52 49.47-48.11c0-15.15-11.76-58.12-34.52-96.02H464c26.52 0 48-21.47 48-47.98C512 262.5 492.2 241.9 467.3 240.2z"]
    };
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.faThumbsUp = void 0;
    e.faThumbsUp = {
      prefix: "fas",
      iconName: "faThumbsUp",
      icon: [512, 512, [], "", "M128 447.1V223.1c0-17.67-14.33-31.1-32-31.1H32c-17.67 0-32 14.33-32 31.1v223.1c0 17.67 14.33 31.1 32 31.1h64C113.7 479.1 128 465.6 128 447.1zM512 224.1c0-26.5-21.48-47.98-48-47.98h-146.5c22.77-37.91 34.52-80.88 34.52-96.02C352 56.52 333.5 32 302.5 32c-63.13 0-26.36 76.15-108.2 141.6L178 186.6C166.2 196.1 160.2 210 160.1 224c-.0234 .0234 0 0 0 0L160 384c0 15.1 7.113 29.33 19.2 38.39l34.14 25.59C241 468.8 274.7 480 309.3 480H368c26.52 0 48-21.47 48-47.98c0-3.635-.4805-7.143-1.246-10.55C434 415.2 448 397.4 448 376c0-9.148-2.697-17.61-7.139-24.88C463.1 347 480 327.5 480 304.1c0-12.5-4.893-23.78-12.72-32.32C492.2 270.1 512 249.5 512 224.1z"]
    };
  }, function (t, e) {
    t.exports = o;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.faArrowsRotate = void 0;
    e.faArrowsRotate = {
      prefix: "fal",
      iconName: "faArrowsRotate",
      icon: [512, 512, [], "", "M464 32C455.2 32 448 39.16 448 48v129.3C416.2 99.72 340.6 48 256 48c-102 0-188.3 72.91-205.1 173.3C49.42 230.1 55.3 238.3 64.02 239.8C64.91 239.9 65.8 240 66.67 240c7.672 0 14.45-5.531 15.77-13.34C96.69 141.7 169.7 80 256 80c72.49 0 137.3 44.88 163.6 112H304C295.2 192 288 199.2 288 208S295.2 224 304 224h160C472.8 224 480 216.8 480 208v-160C480 39.16 472.8 32 464 32zM447.1 272.2c-8.766-1.562-16.97 4.406-18.42 13.12C415.3 370.3 342.3 432 255.1 432c-72.49 0-137.3-44.88-163.6-112H208C216.8 320 224 312.8 224 304S216.8 288 208 288h-160C39.16 288 32 295.2 32 304v160C32 472.8 39.16 480 48 480S64 472.8 64 464v-129.3C95.84 412.3 171.4 464 256 464c101.1 0 188.3-72.91 205.1-173.3C462.6 281.9 456.7 273.7 447.1 272.2z"]
    };
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.faArrowRight = void 0;
    e.faArrowRight = {
      prefix: "far",
      iconName: "faArrowRight",
      icon: [448, 512, [], "", "M264.6 70.63l176 168c4.75 4.531 7.438 10.81 7.438 17.38s-2.688 12.84-7.438 17.38l-176 168c-9.594 9.125-24.78 8.781-33.94-.8125c-9.156-9.5-8.812-24.75 .8125-33.94l132.7-126.6H24.01c-13.25 0-24.01-10.76-24.01-24.01s10.76-23.99 24.01-23.99h340.1l-132.7-126.6C221.8 96.23 221.5 80.98 230.6 71.45C239.8 61.85 254.1 61.51 264.6 70.63z"]
    };
  }, function (t, e) {
    t.exports = a;
  }, function (t, e, r) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.faPlus = void 0;
    e.faPlus = {
      prefix: "fal",
      iconName: "faPlus",
      icon: [448, 512, [], "", "M432 256C432 264.8 424.8 272 416 272h-176V448c0 8.844-7.156 16.01-16 16.01S208 456.8 208 448V272H32c-8.844 0-16-7.15-16-15.99C16 247.2 23.16 240 32 240h176V64c0-8.844 7.156-15.99 16-15.99S240 55.16 240 64v176H416C424.8 240 432 247.2 432 256z"]
    };
  }, function (t, e, r) {
    var n = r(71),
        i = r(75),
        o = r(76),
        a = r(79);

    t.exports = function () {
      "use strict";

      var t = Object.entries,
          e = Object.setPrototypeOf,
          r = Object.isFrozen,
          s = Object.getPrototypeOf,
          c = Object.getOwnPropertyDescriptor,
          l = Object.freeze,
          u = Object.seal,
          h = Object.create,
          d = "undefined" !== typeof Reflect && Reflect,
          f = d.apply,
          p = d.construct;
      l || (l = function freeze(t) {
        return t;
      }), u || (u = function seal(t) {
        return t;
      }), f || (f = function apply(t, e, r) {
        return t.apply(e, r);
      }), p || (p = function construct(t, e) {
        return o(t, a(e));
      });

      var y = unapply(Array.prototype.forEach),
          g = unapply(Array.prototype.pop),
          m = unapply(Array.prototype.push),
          v = unapply(String.prototype.toLowerCase),
          b = unapply(String.prototype.toString),
          x = unapply(String.prototype.match),
          w = unapply(String.prototype.replace),
          S = unapply(String.prototype.indexOf),
          O = unapply(String.prototype.trim),
          E = unapply(Object.prototype.hasOwnProperty),
          k = unapply(RegExp.prototype.test),
          _ = function unconstruct(t) {
        return function () {
          for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++) {
            r[n] = arguments[n];
          }

          return p(t, r);
        };
      }(TypeError);

      function unapply(t) {
        return function (e) {
          for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++) {
            n[i - 1] = arguments[i];
          }

          return f(t, e, n);
        };
      }

      function addToSet(t, n) {
        var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : v;
        e && e(t, null);

        for (var o = n.length; o--;) {
          var a = n[o];

          if ("string" === typeof a) {
            var s = i(a);
            s !== a && (r(n) || (n[o] = s), a = s);
          }

          t[a] = !0;
        }

        return t;
      }

      function cleanArray(t) {
        for (var e = 0; e < t.length; e++) {
          var r = E(t, e);
          r || (t[e] = null);
        }

        return t;
      }

      function clone(e) {
        var r,
            o = h(null),
            a = i(t(e));

        try {
          for (a.s(); !(r = a.n()).done;) {
            var s = n(r.value, 2),
                c = s[0],
                l = s[1],
                u = E(e, c);
            u && (Array.isArray(l) ? o[c] = cleanArray(l) : l && "object" === typeof l && l.constructor === Object ? o[c] = clone(l) : o[c] = l);
          }
        } catch (d) {
          a.e(d);
        } finally {
          a.f();
        }

        return o;
      }

      function lookupGetter(t, e) {
        for (; null !== t;) {
          var r = c(t, e);

          if (r) {
            if (r.get) return unapply(r.get);
            if ("function" === typeof r.value) return unapply(r.value);
          }

          t = s(t);
        }

        return function fallbackValue() {
          return null;
        };
      }

      var C = l(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]),
          T = l(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]),
          A = l(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]),
          M = l(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]),
          P = l(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]),
          j = l(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]),
          R = l(["#text"]),
          D = l(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]),
          I = l(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]),
          L = l(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]),
          N = l(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]),
          B = u(/\{\{[\w\W]*|[\w\W]*\}\}/gm),
          F = u(/<%[\w\W]*|[\w\W]*%>/gm),
          U = u(/\${[\w\W]*}/gm),
          W = u(/^data-[\-\w.\u00B7-\uFFFF]/),
          z = u(/^aria-[\-\w]+$/),
          q = u(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i),
          H = u(/^(?:\w+script|data):/i),
          G = u(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g),
          Y = u(/^html$/i),
          X = u(/^[a-z][.\w]*(-[.\w]+)+$/i),
          V = Object.freeze({
        __proto__: null,
        MUSTACHE_EXPR: B,
        ERB_EXPR: F,
        TMPLIT_EXPR: U,
        DATA_ATTR: W,
        ARIA_ATTR: z,
        IS_ALLOWED_URI: q,
        IS_SCRIPT_OR_DATA: H,
        ATTR_WHITESPACE: G,
        DOCTYPE_NAME: Y,
        CUSTOM_ELEMENT: X
      }),
          $ = {
        element: 1,
        attribute: 2,
        text: 3,
        cdataSection: 4,
        entityReference: 5,
        entityNode: 6,
        progressingInstruction: 7,
        comment: 8,
        document: 9,
        documentType: 10,
        documentFragment: 11,
        notation: 12
      },
          Q = function getGlobal() {
        return "undefined" === typeof window ? null : window;
      },
          K = function _createTrustedTypesPolicy(t, e) {
        if ("object" !== typeof t || "function" !== typeof t.createPolicy) return null;
        var r = null;
        e && e.hasAttribute("data-tt-policy-suffix") && (r = e.getAttribute("data-tt-policy-suffix"));
        var n = "dompurify" + (r ? "#" + r : "");

        try {
          return t.createPolicy(n, {
            createHTML: function createHTML(t) {
              return t;
            },
            createScriptURL: function createScriptURL(t) {
              return t;
            }
          });
        } catch (i) {
          return console.warn("TrustedTypes policy " + n + " could not be created."), null;
        }
      };

      return function createDOMPurify() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Q(),
            r = function DOMPurify(t) {
          return createDOMPurify(t);
        };

        if (r.version = "3.1.6", r.removed = [], !e || !e.document || e.document.nodeType !== $.document) return r.isSupported = !1, r;
        var n,
            i = e.document,
            o = i,
            s = o.currentScript,
            c = e.DocumentFragment,
            u = e.HTMLTemplateElement,
            d = e.Node,
            f = e.Element,
            p = e.NodeFilter,
            B = e.NamedNodeMap,
            F = void 0 === B ? e.NamedNodeMap || e.MozNamedAttrMap : B,
            U = e.HTMLFormElement,
            W = e.DOMParser,
            z = e.trustedTypes,
            H = f.prototype,
            G = lookupGetter(H, "cloneNode"),
            X = lookupGetter(H, "remove"),
            Z = lookupGetter(H, "nextSibling"),
            J = lookupGetter(H, "childNodes"),
            tt = lookupGetter(H, "parentNode");

        if ("function" === typeof u) {
          var et = i.createElement("template");
          et.content && et.content.ownerDocument && (i = et.content.ownerDocument);
        }

        var rt = "",
            nt = i,
            it = nt.implementation,
            ot = nt.createNodeIterator,
            at = nt.createDocumentFragment,
            st = nt.getElementsByTagName,
            ct = o.importNode,
            lt = {};
        r.isSupported = "function" === typeof t && "function" === typeof tt && it && void 0 !== it.createHTMLDocument;

        var ut = V.MUSTACHE_EXPR,
            ht = V.ERB_EXPR,
            dt = V.TMPLIT_EXPR,
            ft = V.DATA_ATTR,
            pt = V.ARIA_ATTR,
            yt = V.IS_SCRIPT_OR_DATA,
            gt = V.ATTR_WHITESPACE,
            mt = V.CUSTOM_ELEMENT,
            vt = V.IS_ALLOWED_URI,
            bt = null,
            xt = addToSet({}, [].concat(a(C), a(T), a(A), a(P), a(R))),
            wt = null,
            St = addToSet({}, [].concat(a(D), a(I), a(L), a(N))),
            Ot = Object.seal(h(null, {
          tagNameCheck: {
            writable: !0,
            configurable: !1,
            enumerable: !0,
            value: null
          },
          attributeNameCheck: {
            writable: !0,
            configurable: !1,
            enumerable: !0,
            value: null
          },
          allowCustomizedBuiltInElements: {
            writable: !0,
            configurable: !1,
            enumerable: !0,
            value: !1
          }
        })),
            Et = null,
            kt = null,
            _t = !0,
            Ct = !0,
            Tt = !1,
            At = !0,
            Mt = !1,
            Pt = !0,
            jt = !1,
            Rt = !1,
            Dt = !1,
            It = !1,
            Lt = !1,
            Nt = !1,
            Bt = !0,
            Ft = !1,
            Ut = !0,
            Wt = !1,
            zt = {},
            qt = null,
            Ht = addToSet({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]),
            Gt = null,
            Yt = addToSet({}, ["audio", "video", "img", "source", "image", "track"]),
            Xt = null,
            Vt = addToSet({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]),
            $t = "http://www.w3.org/1998/Math/MathML",
            Qt = "http://www.w3.org/2000/svg",
            Kt = "http://www.w3.org/1999/xhtml",
            Zt = Kt,
            Jt = !1,
            te = null,
            ee = addToSet({}, [$t, Qt, Kt], b),
            re = null,
            ne = ["application/xhtml+xml", "text/html"],
            ie = null,
            oe = null,
            ae = i.createElement("form"),
            se = function isRegexOrFunction(t) {
          return t instanceof RegExp || t instanceof Function;
        },
            ce = function _parseConfig() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};

          if (!oe || oe !== t) {
            if (t && "object" === typeof t || (t = {}), t = clone(t), re = -1 === ne.indexOf(t.PARSER_MEDIA_TYPE) ? "text/html" : t.PARSER_MEDIA_TYPE, ie = "application/xhtml+xml" === re ? b : v, bt = E(t, "ALLOWED_TAGS") ? addToSet({}, t.ALLOWED_TAGS, ie) : xt, wt = E(t, "ALLOWED_ATTR") ? addToSet({}, t.ALLOWED_ATTR, ie) : St, te = E(t, "ALLOWED_NAMESPACES") ? addToSet({}, t.ALLOWED_NAMESPACES, b) : ee, Xt = E(t, "ADD_URI_SAFE_ATTR") ? addToSet(clone(Vt), t.ADD_URI_SAFE_ATTR, ie) : Vt, Gt = E(t, "ADD_DATA_URI_TAGS") ? addToSet(clone(Yt), t.ADD_DATA_URI_TAGS, ie) : Yt, qt = E(t, "FORBID_CONTENTS") ? addToSet({}, t.FORBID_CONTENTS, ie) : Ht, Et = E(t, "FORBID_TAGS") ? addToSet({}, t.FORBID_TAGS, ie) : {}, kt = E(t, "FORBID_ATTR") ? addToSet({}, t.FORBID_ATTR, ie) : {}, zt = !!E(t, "USE_PROFILES") && t.USE_PROFILES, _t = !1 !== t.ALLOW_ARIA_ATTR, Ct = !1 !== t.ALLOW_DATA_ATTR, Tt = t.ALLOW_UNKNOWN_PROTOCOLS || !1, At = !1 !== t.ALLOW_SELF_CLOSE_IN_ATTR, Mt = t.SAFE_FOR_TEMPLATES || !1, Pt = !1 !== t.SAFE_FOR_XML, jt = t.WHOLE_DOCUMENT || !1, It = t.RETURN_DOM || !1, Lt = t.RETURN_DOM_FRAGMENT || !1, Nt = t.RETURN_TRUSTED_TYPE || !1, Dt = t.FORCE_BODY || !1, Bt = !1 !== t.SANITIZE_DOM, Ft = t.SANITIZE_NAMED_PROPS || !1, Ut = !1 !== t.KEEP_CONTENT, Wt = t.IN_PLACE || !1, vt = t.ALLOWED_URI_REGEXP || q, Zt = t.NAMESPACE || Kt, Ot = t.CUSTOM_ELEMENT_HANDLING || {}, t.CUSTOM_ELEMENT_HANDLING && se(t.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (Ot.tagNameCheck = t.CUSTOM_ELEMENT_HANDLING.tagNameCheck), t.CUSTOM_ELEMENT_HANDLING && se(t.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (Ot.attributeNameCheck = t.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), t.CUSTOM_ELEMENT_HANDLING && "boolean" === typeof t.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (Ot.allowCustomizedBuiltInElements = t.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), Mt && (Ct = !1), Lt && (It = !0), zt && (bt = addToSet({}, R), wt = [], !0 === zt.html && (addToSet(bt, C), addToSet(wt, D)), !0 === zt.svg && (addToSet(bt, T), addToSet(wt, I), addToSet(wt, N)), !0 === zt.svgFilters && (addToSet(bt, A), addToSet(wt, I), addToSet(wt, N)), !0 === zt.mathMl && (addToSet(bt, P), addToSet(wt, L), addToSet(wt, N))), t.ADD_TAGS && (bt === xt && (bt = clone(bt)), addToSet(bt, t.ADD_TAGS, ie)), t.ADD_ATTR && (wt === St && (wt = clone(wt)), addToSet(wt, t.ADD_ATTR, ie)), t.ADD_URI_SAFE_ATTR && addToSet(Xt, t.ADD_URI_SAFE_ATTR, ie), t.FORBID_CONTENTS && (qt === Ht && (qt = clone(qt)), addToSet(qt, t.FORBID_CONTENTS, ie)), Ut && (bt["#text"] = !0), jt && addToSet(bt, ["html", "head", "body"]), bt.table && (addToSet(bt, ["tbody"]), delete Et.tbody), t.TRUSTED_TYPES_POLICY) {
              if ("function" !== typeof t.TRUSTED_TYPES_POLICY.createHTML) throw _('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
              if ("function" !== typeof t.TRUSTED_TYPES_POLICY.createScriptURL) throw _('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
              n = t.TRUSTED_TYPES_POLICY, rt = n.createHTML("");
            } else void 0 === n && (n = K(z, s)), null !== n && "string" === typeof rt && (rt = n.createHTML(""));

            l && l(t), oe = t;
          }
        },
            le = addToSet({}, ["mi", "mo", "mn", "ms", "mtext"]),
            ue = addToSet({}, ["foreignobject", "annotation-xml"]),
            he = addToSet({}, ["title", "style", "font", "a", "script"]),
            de = addToSet({}, [].concat(a(T), a(A), a(M))),
            fe = addToSet({}, [].concat(a(P), a(j))),
            pe = function _forceRemove(t) {
          m(r.removed, {
            element: t
          });

          try {
            tt(t).removeChild(t);
          } catch (e) {
            X(t);
          }
        },
            ye = function _removeAttribute(t, e) {
          try {
            m(r.removed, {
              attribute: e.getAttributeNode(t),
              from: e
            });
          } catch (n) {
            m(r.removed, {
              attribute: null,
              from: e
            });
          }

          if (e.removeAttribute(t), "is" === t && !wt[t]) if (It || Lt) try {
            pe(e);
          } catch (n) {} else try {
            e.setAttribute(t, "");
          } catch (n) {}
        },
            ge = function _initDocument(t) {
          var e = null,
              r = null;
          if (Dt) t = "<remove></remove>" + t;else {
            var o = x(t, /^[\r\n\t ]+/);
            r = o && o[0];
          }
          "application/xhtml+xml" === re && Zt === Kt && (t = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + t + "</body></html>");
          var a = n ? n.createHTML(t) : t;
          if (Zt === Kt) try {
            e = new W().parseFromString(a, re);
          } catch (c) {}

          if (!e || !e.documentElement) {
            e = it.createDocument(Zt, "template", null);

            try {
              e.documentElement.innerHTML = Jt ? rt : a;
            } catch (c) {}
          }

          var s = e.body || e.documentElement;
          return t && r && s.insertBefore(i.createTextNode(r), s.childNodes[0] || null), Zt === Kt ? st.call(e, jt ? "html" : "body")[0] : jt ? e.documentElement : s;
        },
            me = function _createNodeIterator(t) {
          return ot.call(t.ownerDocument || t, t, p.SHOW_ELEMENT | p.SHOW_COMMENT | p.SHOW_TEXT | p.SHOW_PROCESSING_INSTRUCTION | p.SHOW_CDATA_SECTION, null);
        },
            ve = function _isClobbered(t) {
          return t instanceof U && ("string" !== typeof t.nodeName || "string" !== typeof t.textContent || "function" !== typeof t.removeChild || !(t.attributes instanceof F) || "function" !== typeof t.removeAttribute || "function" !== typeof t.setAttribute || "string" !== typeof t.namespaceURI || "function" !== typeof t.insertBefore || "function" !== typeof t.hasChildNodes);
        },
            be = function _isNode(t) {
          return "function" === typeof d && t instanceof d;
        },
            xe = function _executeHook(t, e, n) {
          lt[t] && y(lt[t], function (t) {
            t.call(r, e, n, oe);
          });
        },
            we = function _sanitizeElements(t) {
          var e = null;
          if (xe("beforeSanitizeElements", t, null), ve(t)) return pe(t), !0;
          var n = ie(t.nodeName);
          if (xe("uponSanitizeElement", t, {
            tagName: n,
            allowedTags: bt
          }), t.hasChildNodes() && !be(t.firstElementChild) && k(/<[/\w]/g, t.innerHTML) && k(/<[/\w]/g, t.textContent)) return pe(t), !0;
          if (t.nodeType === $.progressingInstruction) return pe(t), !0;
          if (Pt && t.nodeType === $.comment && k(/<[/\w]/g, t.data)) return pe(t), !0;

          if (!bt[n] || Et[n]) {
            if (!Et[n] && Oe(n)) {
              if (Ot.tagNameCheck instanceof RegExp && k(Ot.tagNameCheck, n)) return !1;
              if (Ot.tagNameCheck instanceof Function && Ot.tagNameCheck(n)) return !1;
            }

            if (Ut && !qt[n]) {
              var i = tt(t) || t.parentNode,
                  o = J(t) || t.childNodes;
              if (o && i) for (var a = o.length, s = a - 1; s >= 0; --s) {
                var c = G(o[s], !0);
                c.__removalCount = (t.__removalCount || 0) + 1, i.insertBefore(c, Z(t));
              }
            }

            return pe(t), !0;
          }

          return t instanceof f && !function _checkValidNamespace(t) {
            var e = tt(t);
            e && e.tagName || (e = {
              namespaceURI: Zt,
              tagName: "template"
            });
            var r = v(t.tagName),
                n = v(e.tagName);
            return !!te[t.namespaceURI] && (t.namespaceURI === Qt ? e.namespaceURI === Kt ? "svg" === r : e.namespaceURI === $t ? "svg" === r && ("annotation-xml" === n || le[n]) : Boolean(de[r]) : t.namespaceURI === $t ? e.namespaceURI === Kt ? "math" === r : e.namespaceURI === Qt ? "math" === r && ue[n] : Boolean(fe[r]) : t.namespaceURI === Kt ? !(e.namespaceURI === Qt && !ue[n]) && !(e.namespaceURI === $t && !le[n]) && !fe[r] && (he[r] || !de[r]) : !("application/xhtml+xml" !== re || !te[t.namespaceURI]));
          }(t) ? (pe(t), !0) : "noscript" !== n && "noembed" !== n && "noframes" !== n || !k(/<\/no(script|embed|frames)/i, t.innerHTML) ? (Mt && t.nodeType === $.text && (e = t.textContent, y([ut, ht, dt], function (t) {
            e = w(e, t, " ");
          }), t.textContent !== e && (m(r.removed, {
            element: t.cloneNode()
          }), t.textContent = e)), xe("afterSanitizeElements", t, null), !1) : (pe(t), !0);
        },
            Se = function _isValidAttribute(t, e, r) {
          if (Bt && ("id" === e || "name" === e) && (r in i || r in ae)) return !1;
          if (Ct && !kt[e] && k(ft, e)) ;else if (_t && k(pt, e)) ;else if (!wt[e] || kt[e]) {
            if (!(Oe(t) && (Ot.tagNameCheck instanceof RegExp && k(Ot.tagNameCheck, t) || Ot.tagNameCheck instanceof Function && Ot.tagNameCheck(t)) && (Ot.attributeNameCheck instanceof RegExp && k(Ot.attributeNameCheck, e) || Ot.attributeNameCheck instanceof Function && Ot.attributeNameCheck(e)) || "is" === e && Ot.allowCustomizedBuiltInElements && (Ot.tagNameCheck instanceof RegExp && k(Ot.tagNameCheck, r) || Ot.tagNameCheck instanceof Function && Ot.tagNameCheck(r)))) return !1;
          } else if (Xt[e]) ;else if (k(vt, w(r, gt, ""))) ;else if ("src" !== e && "xlink:href" !== e && "href" !== e || "script" === t || 0 !== S(r, "data:") || !Gt[t]) if (Tt && !k(yt, w(r, gt, ""))) ;else if (r) return !1;
          return !0;
        },
            Oe = function _isBasicCustomElement(t) {
          return "annotation-xml" !== t && x(t, mt);
        },
            Ee = function _sanitizeAttributes(t) {
          xe("beforeSanitizeAttributes", t, null);
          var e = t.attributes;

          if (e) {
            for (var i = {
              attrName: "",
              attrValue: "",
              keepAttr: !0,
              allowedAttributes: wt
            }, o = e.length, a = function _loop() {
              var a = e[o],
                  s = a.name,
                  c = a.namespaceURI,
                  l = a.value,
                  u = ie(s),
                  h = "value" === s ? l : O(l);
              if (i.attrName = u, i.attrValue = h, i.keepAttr = !0, i.forceKeepAttr = void 0, xe("uponSanitizeAttribute", t, i), h = i.attrValue, Pt && k(/((--!?|])>)|<\/(style|title)/i, h)) return ye(s, t), "continue";
              if (i.forceKeepAttr) return "continue";
              if (ye(s, t), !i.keepAttr) return "continue";
              if (!At && k(/\/>/i, h)) return ye(s, t), "continue";
              Mt && y([ut, ht, dt], function (t) {
                h = w(h, t, " ");
              });
              var d = ie(t.nodeName);
              if (!Se(d, u, h)) return "continue";
              if (!Ft || "id" !== u && "name" !== u || (ye(s, t), h = "user-content-" + h), n && "object" === typeof z && "function" === typeof z.getAttributeType) if (c) ;else switch (z.getAttributeType(d, u)) {
                case "TrustedHTML":
                  h = n.createHTML(h);
                  break;

                case "TrustedScriptURL":
                  h = n.createScriptURL(h);
              }

              try {
                c ? t.setAttributeNS(c, s, h) : t.setAttribute(s, h), ve(t) ? pe(t) : g(r.removed);
              } catch (f) {}
            }; o--;) {
              a();
            }

            xe("afterSanitizeAttributes", t, null);
          }
        },
            ke = function _sanitizeShadowDOM(t) {
          var e = null,
              r = me(t);

          for (xe("beforeSanitizeShadowDOM", t, null); e = r.nextNode();) {
            xe("uponSanitizeShadowNode", e, null), we(e) || (e.content instanceof c && _sanitizeShadowDOM(e.content), Ee(e));
          }

          xe("afterSanitizeShadowDOM", t, null);
        };

        return r.sanitize = function (t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              i = null,
              a = null,
              s = null,
              l = null;

          if ((Jt = !t) && (t = "\x3c!--\x3e"), "string" !== typeof t && !be(t)) {
            if ("function" !== typeof t.toString) throw _("toString is not a function");
            if ("string" !== typeof (t = t.toString())) throw _("dirty is not a string, aborting");
          }

          if (!r.isSupported) return t;

          if (Rt || ce(e), r.removed = [], "string" === typeof t && (Wt = !1), Wt) {
            if (t.nodeName) {
              var u = ie(t.nodeName);
              if (!bt[u] || Et[u]) throw _("root node is forbidden and cannot be sanitized in-place");
            }
          } else if (t instanceof d) i = ge("\x3c!----\x3e"), (a = i.ownerDocument.importNode(t, !0)).nodeType === $.element && "BODY" === a.nodeName ? i = a : "HTML" === a.nodeName ? i = a : i.appendChild(a);else {
            if (!It && !Mt && !jt && -1 === t.indexOf("<")) return n && Nt ? n.createHTML(t) : t;
            if (!(i = ge(t))) return It ? null : Nt ? rt : "";
          }

          i && Dt && pe(i.firstChild);

          for (var h = me(Wt ? t : i); s = h.nextNode();) {
            we(s) || (s.content instanceof c && ke(s.content), Ee(s));
          }

          if (Wt) return t;

          if (It) {
            if (Lt) for (l = at.call(i.ownerDocument); i.firstChild;) {
              l.appendChild(i.firstChild);
            } else l = i;
            return (wt.shadowroot || wt.shadowrootmode) && (l = ct.call(o, l, !0)), l;
          }

          var f = jt ? i.outerHTML : i.innerHTML;
          return jt && bt["!doctype"] && i.ownerDocument && i.ownerDocument.doctype && i.ownerDocument.doctype.name && k(Y, i.ownerDocument.doctype.name) && (f = "<!DOCTYPE " + i.ownerDocument.doctype.name + ">\n" + f), Mt && y([ut, ht, dt], function (t) {
            f = w(f, t, " ");
          }), n && Nt ? n.createHTML(f) : f;
        }, r.setConfig = function () {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          ce(t), Rt = !0;
        }, r.clearConfig = function () {
          oe = null, Rt = !1;
        }, r.isValidAttribute = function (t, e, r) {
          oe || ce({});
          var n = ie(t),
              i = ie(e);
          return Se(n, i, r);
        }, r.addHook = function (t, e) {
          "function" === typeof e && (lt[t] = lt[t] || [], m(lt[t], e));
        }, r.removeHook = function (t) {
          if (lt[t]) return g(lt[t]);
        }, r.removeHooks = function (t) {
          lt[t] && (lt[t] = []);
        }, r.removeAllHooks = function () {
          lt = {};
        }, r;
      }();
    }();
  }, function (t, e, r) {
    "use strict";

    var n = r(24),
        i = r.n(n);
    e.default = i.a;
  }, function (t, e) {
    var r = "complete",
        n = "canceled";

    function setElementScroll(t, e, r) {
      Math.max(0, e), Math.max(0, r), t.self === t ? t.scrollTo(e, r) : (t.scrollLeft = e, t.scrollTop = r);
    }

    function animate(t) {
      var e = t._scrollSettings;

      if (e) {
        var n = e.maxSynchronousAlignments,
            i = function getTargetScrollLocation(t, e) {
          var r,
              n,
              i,
              o,
              a,
              s,
              c,
              l = t.align,
              u = t.target.getBoundingClientRect(),
              h = l && null != l.left ? l.left : .5,
              d = l && null != l.top ? l.top : .5,
              f = l && null != l.leftOffset ? l.leftOffset : 0,
              p = l && null != l.topOffset ? l.topOffset : 0,
              y = h,
              g = d;
          if (t.isWindow(e)) s = Math.min(u.width, e.innerWidth), c = Math.min(u.height, e.innerHeight), n = u.left + e.pageXOffset - e.innerWidth * y + s * y, i = u.top + e.pageYOffset - e.innerHeight * g + c * g, n -= f, i -= p, n = t.align.lockX ? e.pageXOffset : n, i = t.align.lockY ? e.pageYOffset : i, o = n - e.pageXOffset, a = i - e.pageYOffset;else {
            s = u.width, c = u.height, r = e.getBoundingClientRect();
            var m = u.left - (r.left - e.scrollLeft),
                v = u.top - (r.top - e.scrollTop);
            n = m + s * y - e.clientWidth * y, i = v + c * g - e.clientHeight * g, n -= f, i -= p, n = Math.max(Math.min(n, e.scrollWidth - e.clientWidth), 0), i = Math.max(Math.min(i, e.scrollHeight - e.clientHeight), 0), n = t.align.lockX ? e.scrollLeft : n, i = t.align.lockY ? e.scrollTop : i, o = n - e.scrollLeft, a = i - e.scrollTop;
          }
          return {
            x: n,
            y: i,
            differenceX: o,
            differenceY: a
          };
        }(e, t),
            o = Date.now() - e.startTime,
            a = Math.min(1 / e.time * o, 1);

        if (e.endIterations >= n) return setElementScroll(t, i.x, i.y), t._scrollSettings = null, e.end(r);
        var s = 1 - e.ease(a);
        if (setElementScroll(t, i.x - i.differenceX * s, i.y - i.differenceY * s), o >= e.time) return e.endIterations++, e.scrollAncestor && animate(e.scrollAncestor), void animate(t);
        !function raf(t) {
          if ("requestAnimationFrame" in window) return window.requestAnimationFrame(t);
          setTimeout(t, 16);
        }(animate.bind(null, t));
      }
    }

    function defaultIsWindow(t) {
      return t.self === t;
    }

    function defaultIsScrollable(t) {
      return "pageXOffset" in t || (t.scrollHeight !== t.clientHeight || t.scrollWidth !== t.clientWidth) && "hidden" !== getComputedStyle(t).overflow;
    }

    function defaultValidTarget() {
      return !0;
    }

    function findParentElement(t) {
      if (t.assignedSlot) return findParentElement(t.assignedSlot);
      if (t.parentElement) return "BODY" === t.parentElement.tagName ? t.parentElement.ownerDocument.defaultView || t.parentElement.ownerDocument.ownerWindow : t.parentElement;

      if (t.getRootNode) {
        var e = t.getRootNode();
        if (11 === e.nodeType) return e.host;
      }
    }

    t.exports = function (t, e, i) {
      if (t) {
        "function" === typeof e && (i = e, e = null), e || (e = {}), e.time = isNaN(e.time) ? 1e3 : e.time, e.ease = e.ease || function (t) {
          return 1 - Math.pow(1 - t, t / 2);
        }, e.align = e.align || {};
        var o = findParentElement(t),
            a = 1,
            s = e.validTarget || defaultValidTarget,
            c = e.isScrollable;
        e.debug && (console.log("About to scroll to", t), o || console.error("Target did not have a parent, is it mounted in the DOM?"));

        for (var l = []; o;) {
          if (e.debug && console.log("Scrolling parent node", o), s(o, a) && (c ? c(o, defaultIsScrollable) : defaultIsScrollable(o)) && (a++, l.push(o)), !(o = findParentElement(o))) {
            done(r);
            break;
          }
        }

        return l.reduce(function (r, i, o) {
          return function transitionScrollTo(t, e, r, i, o) {
            var a,
                s = !e._scrollSettings,
                c = e._scrollSettings,
                l = Date.now(),
                u = {
              passive: !0
            };

            function end(t) {
              e._scrollSettings = null, e.parentElement && e.parentElement._scrollSettings && e.parentElement._scrollSettings.end(t), r.debug && console.log("Scrolling ended with type", t, "for", e), o(t), a && (e.removeEventListener("touchstart", a, u), e.removeEventListener("wheel", a, u));
            }

            c && c.end(n);
            var h = r.maxSynchronousAlignments;
            return null == h && (h = 3), e._scrollSettings = {
              startTime: l,
              endIterations: 0,
              target: t,
              time: r.time,
              ease: r.ease,
              align: r.align,
              isWindow: r.isWindow || defaultIsWindow,
              maxSynchronousAlignments: h,
              end: end,
              scrollAncestor: i
            }, "cancellable" in r && !r.cancellable || (a = end.bind(null, n), e.addEventListener("touchstart", a, u), e.addEventListener("wheel", a, u)), s && animate(e), a;
          }(t, i, e, l[o + 1], done);
        }, null);
      }

      function done(t) {
        --a || i && i(t);
      }
    };
  }, function (t, e, r) {
    t.exports = r(89);
  }, function (t, e, r) {
    "use strict";

    var n = r(57),
        i = r(38),
        o = r(32),
        a = Object.prototype.hasOwnProperty,
        s = {
      brackets: function brackets(t) {
        return t + "[]";
      },
      comma: "comma",
      indices: function indices(t, e) {
        return t + "[" + e + "]";
      },
      repeat: function repeat(t) {
        return t;
      }
    },
        c = Array.isArray,
        l = Array.prototype.push,
        u = function pushToArray(t, e) {
      l.apply(t, c(e) ? e : [e]);
    },
        h = Date.prototype.toISOString,
        d = o.default,
        f = {
      addQueryPrefix: !1,
      allowDots: !1,
      charset: "utf-8",
      charsetSentinel: !1,
      delimiter: "&",
      encode: !0,
      encoder: i.encode,
      encodeValuesOnly: !1,
      format: d,
      formatter: o.formatters[d],
      indices: !1,
      serializeDate: function serializeDate(t) {
        return h.call(t);
      },
      skipNulls: !1,
      strictNullHandling: !1
    },
        p = {},
        y = function stringify(t, e, r, o, a, s, l, h, d, y, g, m, v, b, x, w) {
      for (var S = t, O = w, E = 0, k = !1; void 0 !== (O = O.get(p)) && !k;) {
        var _ = O.get(t);

        if (E += 1, "undefined" !== typeof _) {
          if (_ === E) throw new RangeError("Cyclic object value");
          k = !0;
        }

        "undefined" === typeof O.get(p) && (E = 0);
      }

      if ("function" === typeof h ? S = h(e, S) : S instanceof Date ? S = g(S) : "comma" === r && c(S) && (S = i.maybeMap(S, function (t) {
        return t instanceof Date ? g(t) : t;
      })), null === S) {
        if (a) return l && !b ? l(e, f.encoder, x, "key", m) : e;
        S = "";
      }

      if (function isNonNullishPrimitive(t) {
        return "string" === typeof t || "number" === typeof t || "boolean" === typeof t || "symbol" === typeof t || "bigint" === typeof t;
      }(S) || i.isBuffer(S)) return l ? [v(b ? e : l(e, f.encoder, x, "key", m)) + "=" + v(l(S, f.encoder, x, "value", m))] : [v(e) + "=" + v(String(S))];
      var C,
          T = [];
      if ("undefined" === typeof S) return T;
      if ("comma" === r && c(S)) b && l && (S = i.maybeMap(S, l)), C = [{
        value: S.length > 0 ? S.join(",") || null : void 0
      }];else if (c(h)) C = h;else {
        var A = Object.keys(S);
        C = d ? A.sort(d) : A;
      }

      for (var M = o && c(S) && 1 === S.length ? e + "[]" : e, P = 0; P < C.length; ++P) {
        var j = C[P],
            R = "object" === typeof j && "undefined" !== typeof j.value ? j.value : S[j];

        if (!s || null !== R) {
          var D = c(S) ? "function" === typeof r ? r(M, j) : M : M + (y ? "." + j : "[" + j + "]");
          w.set(t, E);
          var I = n();
          I.set(p, w), u(T, stringify(R, D, r, o, a, s, "comma" === r && b && c(S) ? null : l, h, d, y, g, m, v, b, x, I));
        }
      }

      return T;
    };

    t.exports = function (t, e) {
      var r,
          i = t,
          l = function normalizeStringifyOptions(t) {
        if (!t) return f;
        if (null !== t.encoder && "undefined" !== typeof t.encoder && "function" !== typeof t.encoder) throw new TypeError("Encoder has to be a function.");
        var e = t.charset || f.charset;
        if ("undefined" !== typeof t.charset && "utf-8" !== t.charset && "iso-8859-1" !== t.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
        var r = o.default;

        if ("undefined" !== typeof t.format) {
          if (!a.call(o.formatters, t.format)) throw new TypeError("Unknown format option provided.");
          r = t.format;
        }

        var n = o.formatters[r],
            i = f.filter;
        return ("function" === typeof t.filter || c(t.filter)) && (i = t.filter), {
          addQueryPrefix: "boolean" === typeof t.addQueryPrefix ? t.addQueryPrefix : f.addQueryPrefix,
          allowDots: "undefined" === typeof t.allowDots ? f.allowDots : !!t.allowDots,
          charset: e,
          charsetSentinel: "boolean" === typeof t.charsetSentinel ? t.charsetSentinel : f.charsetSentinel,
          delimiter: "undefined" === typeof t.delimiter ? f.delimiter : t.delimiter,
          encode: "boolean" === typeof t.encode ? t.encode : f.encode,
          encoder: "function" === typeof t.encoder ? t.encoder : f.encoder,
          encodeValuesOnly: "boolean" === typeof t.encodeValuesOnly ? t.encodeValuesOnly : f.encodeValuesOnly,
          filter: i,
          format: r,
          formatter: n,
          serializeDate: "function" === typeof t.serializeDate ? t.serializeDate : f.serializeDate,
          skipNulls: "boolean" === typeof t.skipNulls ? t.skipNulls : f.skipNulls,
          sort: "function" === typeof t.sort ? t.sort : null,
          strictNullHandling: "boolean" === typeof t.strictNullHandling ? t.strictNullHandling : f.strictNullHandling
        };
      }(e);

      "function" === typeof l.filter ? i = (0, l.filter)("", i) : c(l.filter) && (r = l.filter);
      var h,
          d = [];
      if ("object" !== typeof i || null === i) return "";
      h = e && e.arrayFormat in s ? e.arrayFormat : e && "indices" in e ? e.indices ? "indices" : "repeat" : "indices";
      var p = s[h];
      if (e && "commaRoundTrip" in e && "boolean" !== typeof e.commaRoundTrip) throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
      var g = "comma" === p && e && e.commaRoundTrip;
      r || (r = Object.keys(i)), l.sort && r.sort(l.sort);

      for (var m = n(), v = 0; v < r.length; ++v) {
        var b = r[v];
        l.skipNulls && null === i[b] || u(d, y(i[b], b, p, g, l.strictNullHandling, l.skipNulls, l.encode ? l.encoder : null, l.filter, l.sort, l.allowDots, l.serializeDate, l.format, l.formatter, l.encodeValuesOnly, l.charset, m));
      }

      var x = d.join(l.delimiter),
          w = !0 === l.addQueryPrefix ? "?" : "";
      return l.charsetSentinel && ("iso-8859-1" === l.charset ? w += "utf8=%26%2310003%3B&" : w += "utf8=%E2%9C%93&"), x.length > 0 ? w + x : "";
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(17),
        i = r(63),
        o = r(67),
        a = n("%TypeError%"),
        s = n("%WeakMap%", !0),
        c = n("%Map%", !0),
        l = i("WeakMap.prototype.get", !0),
        u = i("WeakMap.prototype.set", !0),
        h = i("WeakMap.prototype.has", !0),
        d = i("Map.prototype.get", !0),
        f = i("Map.prototype.set", !0),
        p = i("Map.prototype.has", !0),
        y = function listGetNode(t, e) {
      for (var r, n = t; null !== (r = n.next); n = r) {
        if (r.key === e) return n.next = r.next, r.next = t.next, t.next = r, r;
      }
    };

    t.exports = function getSideChannel() {
      var t,
          e,
          r,
          n = {
        assert: function assert(t) {
          if (!n.has(t)) throw new a("Side channel does not contain " + o(t));
        },
        get: function get(n) {
          if (s && n && ("object" === typeof n || "function" === typeof n)) {
            if (t) return l(t, n);
          } else if (c) {
            if (e) return d(e, n);
          } else if (r) return function listGet(t, e) {
            var r = y(t, e);
            return r && r.value;
          }(r, n);
        },
        has: function has(n) {
          if (s && n && ("object" === typeof n || "function" === typeof n)) {
            if (t) return h(t, n);
          } else if (c) {
            if (e) return p(e, n);
          } else if (r) return function listHas(t, e) {
            return !!y(t, e);
          }(r, n);

          return !1;
        },
        set: function set(n, i) {
          s && n && ("object" === typeof n || "function" === typeof n) ? (t || (t = new s()), u(t, n, i)) : c ? (e || (e = new c()), f(e, n, i)) : (r || (r = {
            key: {},
            next: null
          }), function listSet(t, e, r) {
            var n = y(t, e);
            n ? n.value = r : t.next = {
              key: e,
              next: t.next,
              value: r
            };
          }(r, n, i));
        }
      };
      return n;
    };
  }, function (t, e, r) {
    "use strict";

    var n = "undefined" !== typeof Symbol && Symbol,
        i = r(59);

    t.exports = function hasNativeSymbols() {
      return "function" === typeof n && "function" === typeof Symbol && "symbol" === typeof n("foo") && "symbol" === typeof Symbol("bar") && i();
    };
  }, function (t, e, r) {
    "use strict";

    t.exports = function hasSymbols() {
      if ("function" !== typeof Symbol || "function" !== typeof Object.getOwnPropertySymbols) return !1;
      if ("symbol" === typeof Symbol.iterator) return !0;
      var t = {},
          e = Symbol("test"),
          r = Object(e);
      if ("string" === typeof e) return !1;
      if ("[object Symbol]" !== Object.prototype.toString.call(e)) return !1;
      if ("[object Symbol]" !== Object.prototype.toString.call(r)) return !1;

      for (e in t[e] = 42, t) {
        return !1;
      }

      if ("function" === typeof Object.keys && 0 !== Object.keys(t).length) return !1;
      if ("function" === typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(t).length) return !1;
      var n = Object.getOwnPropertySymbols(t);
      if (1 !== n.length || n[0] !== e) return !1;
      if (!Object.prototype.propertyIsEnumerable.call(t, e)) return !1;

      if ("function" === typeof Object.getOwnPropertyDescriptor) {
        var i = Object.getOwnPropertyDescriptor(t, e);
        if (42 !== i.value || !0 !== i.enumerable) return !1;
      }

      return !0;
    };
  }, function (t, e, r) {
    "use strict";

    var n = {
      foo: {}
    },
        i = Object;

    t.exports = function hasProto() {
      return {
        __proto__: n
      }.foo === n.foo && !({
        __proto__: null
      } instanceof i);
    };
  }, function (t, e, r) {
    "use strict";

    var n = Object.prototype.toString,
        i = Math.max,
        o = function concatty(t, e) {
      for (var r = [], n = 0; n < t.length; n += 1) {
        r[n] = t[n];
      }

      for (var i = 0; i < e.length; i += 1) {
        r[i + t.length] = e[i];
      }

      return r;
    };

    t.exports = function bind(t) {
      var e = this;
      if ("function" !== typeof e || "[object Function]" !== n.apply(e)) throw new TypeError("Function.prototype.bind called on incompatible " + e);

      for (var r, a = function slicy(t, e) {
        for (var r = [], n = e || 0, i = 0; n < t.length; n += 1, i += 1) {
          r[i] = t[n];
        }

        return r;
      }(arguments, 1), s = i(0, e.length - a.length), c = [], l = 0; l < s; l++) {
        c[l] = "$" + l;
      }

      if (r = Function("binder", "return function (" + function joiny(t, e) {
        for (var r = "", n = 0; n < t.length; n += 1) {
          r += t[n], n + 1 < t.length && (r += e);
        }

        return r;
      }(c, ",") + "){ return binder.apply(this,arguments); }")(function binder() {
        if (this instanceof r) {
          var n = e.apply(this, o(a, arguments));
          return Object(n) === n ? n : this;
        }

        return e.apply(t, o(a, arguments));
      }), e.prototype) {
        var u = function Empty() {};

        u.prototype = e.prototype, r.prototype = new u(), u.prototype = null;
      }

      return r;
    };
  }, function (t, e, r) {
    "use strict";

    var n = Function.prototype.call,
        i = Object.prototype.hasOwnProperty,
        o = r(31);
    t.exports = o.call(n, i);
  }, function (t, e, r) {
    "use strict";

    var n = r(17),
        i = r(64),
        o = i(n("String.prototype.indexOf"));

    t.exports = function callBoundIntrinsic(t, e) {
      var r = n(t, !!e);
      return "function" === typeof r && o(t, ".prototype.") > -1 ? i(r) : r;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(31),
        i = r(17),
        o = r(65),
        a = i("%TypeError%"),
        s = i("%Function.prototype.apply%"),
        c = i("%Function.prototype.call%"),
        l = i("%Reflect.apply%", !0) || n.call(c, s),
        u = i("%Object.defineProperty%", !0),
        h = i("%Math.max%");
    if (u) try {
      u({}, "a", {
        value: 1
      });
    } catch (f) {
      u = null;
    }

    t.exports = function callBind(t) {
      if ("function" !== typeof t) throw new a("a function is required");
      var e = l(n, c, arguments);
      return o(e, 1 + h(0, t.length - (arguments.length - 1)), !0);
    };

    var d = function applyBind() {
      return l(n, s, arguments);
    };

    u ? u(t.exports, "apply", {
      value: d
    }) : t.exports.apply = d;
  }, function (t, e, r) {
    "use strict";

    var n = r(17),
        i = r(66),
        o = r(35)(),
        a = r(36),
        s = n("%TypeError%"),
        c = n("%Math.floor%");

    t.exports = function setFunctionLength(t, e) {
      if ("function" !== typeof t) throw new s("`fn` is not a function");
      if ("number" !== typeof e || e < 0 || e > 4294967295 || c(e) !== e) throw new s("`length` must be a positive 32-bit integer");
      var r = arguments.length > 2 && !!arguments[2],
          n = !0,
          l = !0;

      if ("length" in t && a) {
        var u = a(t, "length");
        u && !u.configurable && (n = !1), u && !u.writable && (l = !1);
      }

      return (n || l || !r) && (o ? i(t, "length", e, !0, !0) : i(t, "length", e)), t;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(35)(),
        i = r(17),
        o = n && i("%Object.defineProperty%", !0);
    if (o) try {
      o({}, "a", {
        value: 1
      });
    } catch (l) {
      o = !1;
    }
    var a = i("%SyntaxError%"),
        s = i("%TypeError%"),
        c = r(36);

    t.exports = function defineDataProperty(t, e, r) {
      if (!t || "object" !== typeof t && "function" !== typeof t) throw new s("`obj` must be an object or a function`");
      if ("string" !== typeof e && "symbol" !== typeof e) throw new s("`property` must be a string or a symbol`");
      if (arguments.length > 3 && "boolean" !== typeof arguments[3] && null !== arguments[3]) throw new s("`nonEnumerable`, if provided, must be a boolean or null");
      if (arguments.length > 4 && "boolean" !== typeof arguments[4] && null !== arguments[4]) throw new s("`nonWritable`, if provided, must be a boolean or null");
      if (arguments.length > 5 && "boolean" !== typeof arguments[5] && null !== arguments[5]) throw new s("`nonConfigurable`, if provided, must be a boolean or null");
      if (arguments.length > 6 && "boolean" !== typeof arguments[6]) throw new s("`loose`, if provided, must be a boolean");
      var n = arguments.length > 3 ? arguments[3] : null,
          i = arguments.length > 4 ? arguments[4] : null,
          l = arguments.length > 5 ? arguments[5] : null,
          u = arguments.length > 6 && arguments[6],
          h = !!c && c(t, e);
      if (o) o(t, e, {
        configurable: null === l && h ? h.configurable : !l,
        enumerable: null === n && h ? h.enumerable : !n,
        value: r,
        writable: null === i && h ? h.writable : !i
      });else {
        if (!u && (n || i || l)) throw new a("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
        t[e] = r;
      }
    };
  }, function (t, e, r) {
    (function (e) {
      var n = "function" === typeof Map && Map.prototype,
          i = Object.getOwnPropertyDescriptor && n ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null,
          o = n && i && "function" === typeof i.get ? i.get : null,
          a = n && Map.prototype.forEach,
          s = "function" === typeof Set && Set.prototype,
          c = Object.getOwnPropertyDescriptor && s ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null,
          l = s && c && "function" === typeof c.get ? c.get : null,
          u = s && Set.prototype.forEach,
          h = "function" === typeof WeakMap && WeakMap.prototype ? WeakMap.prototype.has : null,
          d = "function" === typeof WeakSet && WeakSet.prototype ? WeakSet.prototype.has : null,
          f = "function" === typeof WeakRef && WeakRef.prototype ? WeakRef.prototype.deref : null,
          p = Boolean.prototype.valueOf,
          y = Object.prototype.toString,
          g = Function.prototype.toString,
          m = String.prototype.match,
          v = String.prototype.slice,
          b = String.prototype.replace,
          x = String.prototype.toUpperCase,
          w = String.prototype.toLowerCase,
          S = RegExp.prototype.test,
          O = Array.prototype.concat,
          E = Array.prototype.join,
          k = Array.prototype.slice,
          _ = Math.floor,
          C = "function" === typeof BigInt ? BigInt.prototype.valueOf : null,
          T = Object.getOwnPropertySymbols,
          A = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? Symbol.prototype.toString : null,
          M = "function" === typeof Symbol && "object" === typeof Symbol.iterator,
          P = "function" === typeof Symbol && Symbol.toStringTag && (typeof Symbol.toStringTag === M || "symbol") ? Symbol.toStringTag : null,
          j = Object.prototype.propertyIsEnumerable,
          R = ("function" === typeof Reflect ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function (t) {
        return t.__proto__;
      } : null);

      function addNumericSeparator(t, e) {
        if (t === 1 / 0 || t === -1 / 0 || t !== t || t && t > -1e3 && t < 1e3 || S.call(/e/, e)) return e;
        var r = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;

        if ("number" === typeof t) {
          var n = t < 0 ? -_(-t) : _(t);

          if (n !== t) {
            var i = String(n),
                o = v.call(e, i.length + 1);
            return b.call(i, r, "$&_") + "." + b.call(b.call(o, /([0-9]{3})/g, "$&_"), /_$/, "");
          }
        }

        return b.call(e, r, "$&_");
      }

      var D = r(68),
          I = D.custom,
          L = isSymbol(I) ? I : null;

      function wrapQuotes(t, e, r) {
        var n = "double" === (r.quoteStyle || e) ? '"' : "'";
        return n + t + n;
      }

      function quote(t) {
        return b.call(String(t), /"/g, "&quot;");
      }

      function isArray(t) {
        return "[object Array]" === toStr(t) && (!P || !("object" === typeof t && P in t));
      }

      function isRegExp(t) {
        return "[object RegExp]" === toStr(t) && (!P || !("object" === typeof t && P in t));
      }

      function isSymbol(t) {
        if (M) return t && "object" === typeof t && t instanceof Symbol;
        if ("symbol" === typeof t) return !0;
        if (!t || "object" !== typeof t || !A) return !1;

        try {
          return A.call(t), !0;
        } catch (e) {}

        return !1;
      }

      t.exports = function inspect_(t, r, n, i) {
        var s = r || {};
        if (has(s, "quoteStyle") && "single" !== s.quoteStyle && "double" !== s.quoteStyle) throw new TypeError('option "quoteStyle" must be "single" or "double"');
        if (has(s, "maxStringLength") && ("number" === typeof s.maxStringLength ? s.maxStringLength < 0 && s.maxStringLength !== 1 / 0 : null !== s.maxStringLength)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
        var c = !has(s, "customInspect") || s.customInspect;
        if ("boolean" !== typeof c && "symbol" !== c) throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
        if (has(s, "indent") && null !== s.indent && "\t" !== s.indent && !(parseInt(s.indent, 10) === s.indent && s.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
        if (has(s, "numericSeparator") && "boolean" !== typeof s.numericSeparator) throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
        var y = s.numericSeparator;
        if ("undefined" === typeof t) return "undefined";
        if (null === t) return "null";
        if ("boolean" === typeof t) return t ? "true" : "false";
        if ("string" === typeof t) return function inspectString(t, e) {
          if (t.length > e.maxStringLength) {
            var r = t.length - e.maxStringLength,
                n = "... " + r + " more character" + (r > 1 ? "s" : "");
            return inspectString(v.call(t, 0, e.maxStringLength), e) + n;
          }

          var i = b.call(b.call(t, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, lowbyte);
          return wrapQuotes(i, "single", e);
        }(t, s);

        if ("number" === typeof t) {
          if (0 === t) return 1 / 0 / t > 0 ? "0" : "-0";
          var x = String(t);
          return y ? addNumericSeparator(t, x) : x;
        }

        if ("bigint" === typeof t) {
          var S = String(t) + "n";
          return y ? addNumericSeparator(t, S) : S;
        }

        var _ = "undefined" === typeof s.depth ? 5 : s.depth;

        if ("undefined" === typeof n && (n = 0), n >= _ && _ > 0 && "object" === typeof t) return isArray(t) ? "[Array]" : "[Object]";

        var T = function getIndent(t, e) {
          var r;
          if ("\t" === t.indent) r = "\t";else {
            if (!("number" === typeof t.indent && t.indent > 0)) return null;
            r = E.call(Array(t.indent + 1), " ");
          }
          return {
            base: r,
            prev: E.call(Array(e + 1), r)
          };
        }(s, n);

        if ("undefined" === typeof i) i = [];else if (indexOf(i, t) >= 0) return "[Circular]";

        function inspect(t, e, r) {
          if (e && (i = k.call(i)).push(e), r) {
            var o = {
              depth: s.depth
            };
            return has(s, "quoteStyle") && (o.quoteStyle = s.quoteStyle), inspect_(t, o, n + 1, i);
          }

          return inspect_(t, s, n + 1, i);
        }

        if ("function" === typeof t && !isRegExp(t)) {
          var I = function nameOf(t) {
            if (t.name) return t.name;
            var e = m.call(g.call(t), /^function\s*([\w$]+)/);
            if (e) return e[1];
            return null;
          }(t),
              N = arrObjKeys(t, inspect);

          return "[Function" + (I ? ": " + I : " (anonymous)") + "]" + (N.length > 0 ? " { " + E.call(N, ", ") + " }" : "");
        }

        if (isSymbol(t)) {
          var B = M ? b.call(String(t), /^(Symbol\(.*\))_[^)]*$/, "$1") : A.call(t);
          return "object" !== typeof t || M ? B : markBoxed(B);
        }

        if (function isElement(t) {
          if (!t || "object" !== typeof t) return !1;
          if ("undefined" !== typeof HTMLElement && t instanceof HTMLElement) return !0;
          return "string" === typeof t.nodeName && "function" === typeof t.getAttribute;
        }(t)) {
          for (var F = "<" + w.call(String(t.nodeName)), U = t.attributes || [], W = 0; W < U.length; W++) {
            F += " " + U[W].name + "=" + wrapQuotes(quote(U[W].value), "double", s);
          }

          return F += ">", t.childNodes && t.childNodes.length && (F += "..."), F += "</" + w.call(String(t.nodeName)) + ">";
        }

        if (isArray(t)) {
          if (0 === t.length) return "[]";
          var z = arrObjKeys(t, inspect);
          return T && !function singleLineValues(t) {
            for (var e = 0; e < t.length; e++) {
              if (indexOf(t[e], "\n") >= 0) return !1;
            }

            return !0;
          }(z) ? "[" + indentedJoin(z, T) + "]" : "[ " + E.call(z, ", ") + " ]";
        }

        if (function isError(t) {
          return "[object Error]" === toStr(t) && (!P || !("object" === typeof t && P in t));
        }(t)) {
          var q = arrObjKeys(t, inspect);
          return "cause" in Error.prototype || !("cause" in t) || j.call(t, "cause") ? 0 === q.length ? "[" + String(t) + "]" : "{ [" + String(t) + "] " + E.call(q, ", ") + " }" : "{ [" + String(t) + "] " + E.call(O.call("[cause]: " + inspect(t.cause), q), ", ") + " }";
        }

        if ("object" === typeof t && c) {
          if (L && "function" === typeof t[L] && D) return D(t, {
            depth: _ - n
          });
          if ("symbol" !== c && "function" === typeof t.inspect) return t.inspect();
        }

        if (function isMap(t) {
          if (!o || !t || "object" !== typeof t) return !1;

          try {
            o.call(t);

            try {
              l.call(t);
            } catch (F) {
              return !0;
            }

            return t instanceof Map;
          } catch (e) {}

          return !1;
        }(t)) {
          var H = [];
          return a && a.call(t, function (e, r) {
            H.push(inspect(r, t, !0) + " => " + inspect(e, t));
          }), collectionOf("Map", o.call(t), H, T);
        }

        if (function isSet(t) {
          if (!l || !t || "object" !== typeof t) return !1;

          try {
            l.call(t);

            try {
              o.call(t);
            } catch (e) {
              return !0;
            }

            return t instanceof Set;
          } catch (r) {}

          return !1;
        }(t)) {
          var G = [];
          return u && u.call(t, function (e) {
            G.push(inspect(e, t));
          }), collectionOf("Set", l.call(t), G, T);
        }

        if (function isWeakMap(t) {
          if (!h || !t || "object" !== typeof t) return !1;

          try {
            h.call(t, h);

            try {
              d.call(t, d);
            } catch (F) {
              return !0;
            }

            return t instanceof WeakMap;
          } catch (e) {}

          return !1;
        }(t)) return weakCollectionOf("WeakMap");
        if (function isWeakSet(t) {
          if (!d || !t || "object" !== typeof t) return !1;

          try {
            d.call(t, d);

            try {
              h.call(t, h);
            } catch (F) {
              return !0;
            }

            return t instanceof WeakSet;
          } catch (e) {}

          return !1;
        }(t)) return weakCollectionOf("WeakSet");
        if (function isWeakRef(t) {
          if (!f || !t || "object" !== typeof t) return !1;

          try {
            return f.call(t), !0;
          } catch (e) {}

          return !1;
        }(t)) return weakCollectionOf("WeakRef");
        if (function isNumber(t) {
          return "[object Number]" === toStr(t) && (!P || !("object" === typeof t && P in t));
        }(t)) return markBoxed(inspect(Number(t)));
        if (function isBigInt(t) {
          if (!t || "object" !== typeof t || !C) return !1;

          try {
            return C.call(t), !0;
          } catch (e) {}

          return !1;
        }(t)) return markBoxed(inspect(C.call(t)));
        if (function isBoolean(t) {
          return "[object Boolean]" === toStr(t) && (!P || !("object" === typeof t && P in t));
        }(t)) return markBoxed(p.call(t));
        if (function isString(t) {
          return "[object String]" === toStr(t) && (!P || !("object" === typeof t && P in t));
        }(t)) return markBoxed(inspect(String(t)));
        if ("undefined" !== typeof window && t === window) return "{ [object Window] }";
        if (t === e) return "{ [object globalThis] }";

        if (!function isDate(t) {
          return "[object Date]" === toStr(t) && (!P || !("object" === typeof t && P in t));
        }(t) && !isRegExp(t)) {
          var Y = arrObjKeys(t, inspect),
              X = R ? R(t) === Object.prototype : t instanceof Object || t.constructor === Object,
              V = t instanceof Object ? "" : "null prototype",
              $ = !X && P && Object(t) === t && P in t ? v.call(toStr(t), 8, -1) : V ? "Object" : "",
              Q = (X || "function" !== typeof t.constructor ? "" : t.constructor.name ? t.constructor.name + " " : "") + ($ || V ? "[" + E.call(O.call([], $ || [], V || []), ": ") + "] " : "");
          return 0 === Y.length ? Q + "{}" : T ? Q + "{" + indentedJoin(Y, T) + "}" : Q + "{ " + E.call(Y, ", ") + " }";
        }

        return String(t);
      };

      var N = Object.prototype.hasOwnProperty || function (t) {
        return t in this;
      };

      function has(t, e) {
        return N.call(t, e);
      }

      function toStr(t) {
        return y.call(t);
      }

      function indexOf(t, e) {
        if (t.indexOf) return t.indexOf(e);

        for (var r = 0, n = t.length; r < n; r++) {
          if (t[r] === e) return r;
        }

        return -1;
      }

      function lowbyte(t) {
        var e = t.charCodeAt(0),
            r = {
          8: "b",
          9: "t",
          10: "n",
          12: "f",
          13: "r"
        }[e];
        return r ? "\\" + r : "\\x" + (e < 16 ? "0" : "") + x.call(e.toString(16));
      }

      function markBoxed(t) {
        return "Object(" + t + ")";
      }

      function weakCollectionOf(t) {
        return t + " { ? }";
      }

      function collectionOf(t, e, r, n) {
        return t + " (" + e + ") {" + (n ? indentedJoin(r, n) : E.call(r, ", ")) + "}";
      }

      function indentedJoin(t, e) {
        if (0 === t.length) return "";
        var r = "\n" + e.prev + e.base;
        return r + E.call(t, "," + r) + "\n" + e.prev;
      }

      function arrObjKeys(t, e) {
        var r = isArray(t),
            n = [];

        if (r) {
          n.length = t.length;

          for (var i = 0; i < t.length; i++) {
            n[i] = has(t, i) ? e(t[i], t) : "";
          }
        }

        var o,
            a = "function" === typeof T ? T(t) : [];

        if (M) {
          o = {};

          for (var s = 0; s < a.length; s++) {
            o["$" + a[s]] = a[s];
          }
        }

        for (var c in t) {
          has(t, c) && (r && String(Number(c)) === c && c < t.length || M && o["$" + c] instanceof Symbol || (S.call(/[^\w$]/, c) ? n.push(e(c, t) + ": " + e(t[c], t)) : n.push(c + ": " + e(t[c], t))));
        }

        if ("function" === typeof T) for (var l = 0; l < a.length; l++) {
          j.call(t, a[l]) && n.push("[" + e(a[l]) + "]: " + e(t[a[l]], t));
        }
        return n;
      }
    }).call(this, r(37));
  }, function (t, e) {}, function (t, e, r) {
    "use strict";

    var n = r(38),
        i = Object.prototype.hasOwnProperty,
        o = Array.isArray,
        a = {
      allowDots: !1,
      allowPrototypes: !1,
      allowSparse: !1,
      arrayLimit: 20,
      charset: "utf-8",
      charsetSentinel: !1,
      comma: !1,
      decoder: n.decode,
      delimiter: "&",
      depth: 5,
      ignoreQueryPrefix: !1,
      interpretNumericEntities: !1,
      parameterLimit: 1e3,
      parseArrays: !0,
      plainObjects: !1,
      strictNullHandling: !1
    },
        s = function interpretNumericEntities(t) {
      return t.replace(/&#(\d+);/g, function (t, e) {
        return String.fromCharCode(parseInt(e, 10));
      });
    },
        c = function parseArrayValue(t, e) {
      return t && "string" === typeof t && e.comma && t.indexOf(",") > -1 ? t.split(",") : t;
    },
        l = function parseQueryStringKeys(t, e, r, n) {
      if (t) {
        var o = r.allowDots ? t.replace(/\.([^.[]+)/g, "[$1]") : t,
            a = /(\[[^[\]]*])/g,
            s = r.depth > 0 && /(\[[^[\]]*])/.exec(o),
            l = s ? o.slice(0, s.index) : o,
            u = [];

        if (l) {
          if (!r.plainObjects && i.call(Object.prototype, l) && !r.allowPrototypes) return;
          u.push(l);
        }

        for (var h = 0; r.depth > 0 && null !== (s = a.exec(o)) && h < r.depth;) {
          if (h += 1, !r.plainObjects && i.call(Object.prototype, s[1].slice(1, -1)) && !r.allowPrototypes) return;
          u.push(s[1]);
        }

        return s && u.push("[" + o.slice(s.index) + "]"), function parseObject(t, e, r, n) {
          for (var i = n ? e : c(e, r), o = t.length - 1; o >= 0; --o) {
            var a,
                s = t[o];
            if ("[]" === s && r.parseArrays) a = [].concat(i);else {
              a = r.plainObjects ? Object.create(null) : {};
              var l = "[" === s.charAt(0) && "]" === s.charAt(s.length - 1) ? s.slice(1, -1) : s,
                  u = parseInt(l, 10);
              r.parseArrays || "" !== l ? !isNaN(u) && s !== l && String(u) === l && u >= 0 && r.parseArrays && u <= r.arrayLimit ? (a = [])[u] = i : "__proto__" !== l && (a[l] = i) : a = {
                0: i
              };
            }
            i = a;
          }

          return i;
        }(u, e, r, n);
      }
    };

    t.exports = function (t, e) {
      var r = function normalizeParseOptions(t) {
        if (!t) return a;
        if (null !== t.decoder && void 0 !== t.decoder && "function" !== typeof t.decoder) throw new TypeError("Decoder has to be a function.");
        if ("undefined" !== typeof t.charset && "utf-8" !== t.charset && "iso-8859-1" !== t.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
        var e = "undefined" === typeof t.charset ? a.charset : t.charset;
        return {
          allowDots: "undefined" === typeof t.allowDots ? a.allowDots : !!t.allowDots,
          allowPrototypes: "boolean" === typeof t.allowPrototypes ? t.allowPrototypes : a.allowPrototypes,
          allowSparse: "boolean" === typeof t.allowSparse ? t.allowSparse : a.allowSparse,
          arrayLimit: "number" === typeof t.arrayLimit ? t.arrayLimit : a.arrayLimit,
          charset: e,
          charsetSentinel: "boolean" === typeof t.charsetSentinel ? t.charsetSentinel : a.charsetSentinel,
          comma: "boolean" === typeof t.comma ? t.comma : a.comma,
          decoder: "function" === typeof t.decoder ? t.decoder : a.decoder,
          delimiter: "string" === typeof t.delimiter || n.isRegExp(t.delimiter) ? t.delimiter : a.delimiter,
          depth: "number" === typeof t.depth || !1 === t.depth ? +t.depth : a.depth,
          ignoreQueryPrefix: !0 === t.ignoreQueryPrefix,
          interpretNumericEntities: "boolean" === typeof t.interpretNumericEntities ? t.interpretNumericEntities : a.interpretNumericEntities,
          parameterLimit: "number" === typeof t.parameterLimit ? t.parameterLimit : a.parameterLimit,
          parseArrays: !1 !== t.parseArrays,
          plainObjects: "boolean" === typeof t.plainObjects ? t.plainObjects : a.plainObjects,
          strictNullHandling: "boolean" === typeof t.strictNullHandling ? t.strictNullHandling : a.strictNullHandling
        };
      }(e);

      if ("" === t || null === t || "undefined" === typeof t) return r.plainObjects ? Object.create(null) : {};

      for (var u = "string" === typeof t ? function parseQueryStringValues(t, e) {
        var r,
            l = {
          __proto__: null
        },
            u = e.ignoreQueryPrefix ? t.replace(/^\?/, "") : t,
            h = e.parameterLimit === 1 / 0 ? void 0 : e.parameterLimit,
            d = u.split(e.delimiter, h),
            f = -1,
            p = e.charset;
        if (e.charsetSentinel) for (r = 0; r < d.length; ++r) {
          0 === d[r].indexOf("utf8=") && ("utf8=%E2%9C%93" === d[r] ? p = "utf-8" : "utf8=%26%2310003%3B" === d[r] && (p = "iso-8859-1"), f = r, r = d.length);
        }

        for (r = 0; r < d.length; ++r) {
          if (r !== f) {
            var y,
                g,
                m = d[r],
                v = m.indexOf("]="),
                b = -1 === v ? m.indexOf("=") : v + 1;
            -1 === b ? (y = e.decoder(m, a.decoder, p, "key"), g = e.strictNullHandling ? null : "") : (y = e.decoder(m.slice(0, b), a.decoder, p, "key"), g = n.maybeMap(c(m.slice(b + 1), e), function (t) {
              return e.decoder(t, a.decoder, p, "value");
            })), g && e.interpretNumericEntities && "iso-8859-1" === p && (g = s(g)), m.indexOf("[]=") > -1 && (g = o(g) ? [g] : g), i.call(l, y) ? l[y] = n.combine(l[y], g) : l[y] = g;
          }
        }

        return l;
      }(t, r) : t, h = r.plainObjects ? Object.create(null) : {}, d = Object.keys(u), f = 0; f < d.length; ++f) {
        var p = d[f],
            y = l(p, u[p], r, "string" === typeof t);
        h = n.merge(h, y, r);
      }

      return !0 === r.allowSparse ? h : n.compact(h);
    };
  }, function (t, e, r) {
    var n = function (t) {
      "use strict";

      var e,
          r = Object.prototype,
          n = r.hasOwnProperty,
          i = "function" === typeof Symbol ? Symbol : {},
          o = i.iterator || "@@iterator",
          a = i.asyncIterator || "@@asyncIterator",
          s = i.toStringTag || "@@toStringTag";

      function define(t, e, r) {
        return Object.defineProperty(t, e, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), t[e];
      }

      try {
        define({}, "");
      } catch (m) {
        define = function define(t, e, r) {
          return t[e] = r;
        };
      }

      function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator,
            o = Object.create(i.prototype),
            a = new Context(n || []);
        return o._invoke = function makeInvokeMethod(t, e, r) {
          var n = c;
          return function invoke(i, o) {
            if (n === u) throw new Error("Generator is already running");

            if (n === h) {
              if ("throw" === i) throw o;
              return doneResult();
            }

            for (r.method = i, r.arg = o;;) {
              var a = r.delegate;

              if (a) {
                var s = maybeInvokeDelegate(a, r);

                if (s) {
                  if (s === d) continue;
                  return s;
                }
              }

              if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                if (n === c) throw n = h, r.arg;
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              n = u;
              var f = tryCatch(t, e, r);

              if ("normal" === f.type) {
                if (n = r.done ? h : l, f.arg === d) continue;
                return {
                  value: f.arg,
                  done: r.done
                };
              }

              "throw" === f.type && (n = h, r.method = "throw", r.arg = f.arg);
            }
          };
        }(t, r, a), o;
      }

      function tryCatch(t, e, r) {
        try {
          return {
            type: "normal",
            arg: t.call(e, r)
          };
        } catch (m) {
          return {
            type: "throw",
            arg: m
          };
        }
      }

      t.wrap = wrap;
      var c = "suspendedStart",
          l = "suspendedYield",
          u = "executing",
          h = "completed",
          d = {};

      function Generator() {}

      function GeneratorFunction() {}

      function GeneratorFunctionPrototype() {}

      var f = {};
      define(f, o, function () {
        return this;
      });
      var p = Object.getPrototypeOf,
          y = p && p(p(values([])));
      y && y !== r && n.call(y, o) && (f = y);
      var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(f);

      function defineIteratorMethods(t) {
        ["next", "throw", "return"].forEach(function (e) {
          define(t, e, function (t) {
            return this._invoke(e, t);
          });
        });
      }

      function AsyncIterator(t, e) {
        var r;

        this._invoke = function enqueue(i, o) {
          function callInvokeWithMethodAndArg() {
            return new e(function (r, a) {
              !function invoke(r, i, o, a) {
                var s = tryCatch(t[r], t, i);

                if ("throw" !== s.type) {
                  var c = s.arg,
                      l = c.value;
                  return l && "object" === typeof l && n.call(l, "__await") ? e.resolve(l.__await).then(function (t) {
                    invoke("next", t, o, a);
                  }, function (t) {
                    invoke("throw", t, o, a);
                  }) : e.resolve(l).then(function (t) {
                    c.value = t, o(c);
                  }, function (t) {
                    return invoke("throw", t, o, a);
                  });
                }

                a(s.arg);
              }(i, o, r, a);
            });
          }

          return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
      }

      function maybeInvokeDelegate(t, r) {
        var n = t.iterator[r.method];

        if (n === e) {
          if (r.delegate = null, "throw" === r.method) {
            if (t.iterator.return && (r.method = "return", r.arg = e, maybeInvokeDelegate(t, r), "throw" === r.method)) return d;
            r.method = "throw", r.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return d;
        }

        var i = tryCatch(n, t.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, d;
        var o = i.arg;
        return o ? o.done ? (r[t.resultName] = o.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e), r.delegate = null, d) : o : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, d);
      }

      function pushTryEntry(t) {
        var e = {
          tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
      }

      function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
      }

      function Context(t) {
        this.tryEntries = [{
          tryLoc: "root"
        }], t.forEach(pushTryEntry, this), this.reset(!0);
      }

      function values(t) {
        if (t) {
          var r = t[o];
          if (r) return r.call(t);
          if ("function" === typeof t.next) return t;

          if (!isNaN(t.length)) {
            var i = -1,
                a = function next() {
              for (; ++i < t.length;) {
                if (n.call(t, i)) return next.value = t[i], next.done = !1, next;
              }

              return next.value = e, next.done = !0, next;
            };

            return a.next = a;
          }
        }

        return {
          next: doneResult
        };
      }

      function doneResult() {
        return {
          value: e,
          done: !0
        };
      }

      return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(g, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, s, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
        var e = "function" === typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
      }, t.mark = function (t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, s, "GeneratorFunction")), t.prototype = Object.create(g), t;
      }, t.awrap = function (t) {
        return {
          __await: t
        };
      }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, a, function () {
        return this;
      }), t.AsyncIterator = AsyncIterator, t.async = function (e, r, n, i, o) {
        void 0 === o && (o = Promise);
        var a = new AsyncIterator(wrap(e, r, n, i), o);
        return t.isGeneratorFunction(r) ? a : a.next().then(function (t) {
          return t.done ? t.value : a.next();
        });
      }, defineIteratorMethods(g), define(g, s, "Generator"), define(g, o, function () {
        return this;
      }), define(g, "toString", function () {
        return "[object Generator]";
      }), t.keys = function (t) {
        var e = [];

        for (var r in t) {
          e.push(r);
        }

        return e.reverse(), function next() {
          for (; e.length;) {
            var r = e.pop();
            if (r in t) return next.value = r, next.done = !1, next;
          }

          return next.done = !0, next;
        };
      }, t.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(t) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(resetTryEntry), !t) for (var r in this) {
            "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e);
          }
        },
        stop: function stop() {
          this.done = !0;
          var t = this.tryEntries[0].completion;
          if ("throw" === t.type) throw t.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(t) {
          if (this.done) throw t;
          var r = this;

          function handle(n, i) {
            return a.type = "throw", a.arg = t, r.next = n, i && (r.method = "next", r.arg = e), !!i;
          }

          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var o = this.tryEntries[i],
                a = o.completion;
            if ("root" === o.tryLoc) return handle("end");

            if (o.tryLoc <= this.prev) {
              var s = n.call(o, "catchLoc"),
                  c = n.call(o, "finallyLoc");

              if (s && c) {
                if (this.prev < o.catchLoc) return handle(o.catchLoc, !0);
                if (this.prev < o.finallyLoc) return handle(o.finallyLoc);
              } else if (s) {
                if (this.prev < o.catchLoc) return handle(o.catchLoc, !0);
              } else {
                if (!c) throw new Error("try statement without catch or finally");
                if (this.prev < o.finallyLoc) return handle(o.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(t, e) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var i = this.tryEntries[r];

            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
              var o = i;
              break;
            }
          }

          o && ("break" === t || "continue" === t) && o.tryLoc <= e && e <= o.finallyLoc && (o = null);
          var a = o ? o.completion : {};
          return a.type = t, a.arg = e, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(a);
        },
        complete: function complete(t, e) {
          if ("throw" === t.type) throw t.arg;
          return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), d;
        },
        finish: function finish(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];
            if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), d;
          }
        },
        catch: function _catch(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];

            if (r.tryLoc === t) {
              var n = r.completion;

              if ("throw" === n.type) {
                var i = n.arg;
                resetTryEntry(r);
              }

              return i;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(t, r, n) {
          return this.delegate = {
            iterator: values(t),
            resultName: r,
            nextLoc: n
          }, "next" === this.method && (this.arg = e), d;
        }
      }, t;
    }(t.exports);

    try {
      regeneratorRuntime = n;
    } catch (i) {
      "object" === typeof globalThis ? globalThis.regeneratorRuntime = n : Function("r", "regeneratorRuntime = r")(n);
    }
  }, function (t, e, r) {
    var n = r(72),
        i = r(73),
        o = r(33),
        a = r(74);

    t.exports = function _slicedToArray(t, e) {
      return n(t) || i(t, e) || o(t, e) || a();
    };
  }, function (t, e) {
    t.exports = function _arrayWithHoles(t) {
      if (Array.isArray(t)) return t;
    };
  }, function (t, e) {
    t.exports = function _iterableToArrayLimit(t, e) {
      if ("undefined" !== typeof Symbol && Symbol.iterator in Object(t)) {
        var r = [],
            n = !0,
            i = !1,
            o = void 0;

        try {
          for (var a, s = t[Symbol.iterator](); !(n = (a = s.next()).done) && (r.push(a.value), !e || r.length !== e); n = !0) {
            ;
          }
        } catch (c) {
          i = !0, o = c;
        } finally {
          try {
            n || null == s.return || s.return();
          } finally {
            if (i) throw o;
          }
        }

        return r;
      }
    };
  }, function (t, e) {
    t.exports = function _nonIterableRest() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    };
  }, function (t, e, r) {
    var n = r(33);

    t.exports = function _createForOfIteratorHelper(t) {
      if ("undefined" === typeof Symbol || null == t[Symbol.iterator]) {
        if (Array.isArray(t) || (t = n(t))) {
          var r = 0,
              i = function F() {};

          return {
            s: i,
            n: function n() {
              return r >= t.length ? {
                done: !0
              } : {
                done: !1,
                value: t[r++]
              };
            },
            e: function e(t) {
              throw t;
            },
            f: i
          };
        }

        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }

      var o,
          a,
          c = !0,
          l = !1;
      return {
        s: function s() {
          o = t[Symbol.iterator]();
        },
        n: function n() {
          var t = o.next();
          return c = t.done, t;
        },
        e: function e(t) {
          l = !0, a = t;
        },
        f: function f() {
          try {
            c || null == o.return || o.return();
          } finally {
            if (l) throw a;
          }
        }
      };
    };
  }, function (t, e, r) {
    var n = r(77),
        i = r(78);

    function _construct(e, r, o) {
      return i() ? t.exports = _construct = Reflect.construct : t.exports = _construct = function _construct(t, e, r) {
        var i = [null];
        i.push.apply(i, e);
        var o = new (Function.bind.apply(t, i))();
        return r && n(o, r.prototype), o;
      }, _construct.apply(null, arguments);
    }

    t.exports = _construct;
  }, function (t, e) {
    function _setPrototypeOf(e, r) {
      return t.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(t, e) {
        return t.__proto__ = e, t;
      }, _setPrototypeOf(e, r);
    }

    t.exports = _setPrototypeOf;
  }, function (t, e) {
    t.exports = function _isNativeReflectConstruct() {
      if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" === typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    };
  }, function (t, e, r) {
    var n = r(80),
        i = r(81),
        o = r(33),
        a = r(82);

    t.exports = function _toConsumableArray(t) {
      return n(t) || i(t) || o(t) || a();
    };
  }, function (t, e, r) {
    var n = r(39);

    t.exports = function _arrayWithoutHoles(t) {
      if (Array.isArray(t)) return n(t);
    };
  }, function (t, e) {
    t.exports = function _iterableToArray(t) {
      if ("undefined" !== typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
    };
  }, function (t, e) {
    t.exports = function _nonIterableSpread() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(84),
        i = r(1);

    function q(t) {
      for (var e = "https://reactjs.org/docs/error-decoder.html?invariant=" + t, r = 1; r < arguments.length; r++) {
        e += "&args[]=" + encodeURIComponent(arguments[r]);
      }

      return "Minified React error #" + t + "; visit " + e + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }

    var o = "function" === typeof Symbol && Symbol.for,
        s = o ? Symbol.for("react.portal") : 60106,
        c = o ? Symbol.for("react.fragment") : 60107,
        l = o ? Symbol.for("react.strict_mode") : 60108,
        u = o ? Symbol.for("react.profiler") : 60114,
        h = o ? Symbol.for("react.provider") : 60109,
        f = o ? Symbol.for("react.context") : 60110,
        p = o ? Symbol.for("react.concurrent_mode") : 60111,
        y = o ? Symbol.for("react.forward_ref") : 60112,
        g = o ? Symbol.for("react.suspense") : 60113,
        m = o ? Symbol.for("react.suspense_list") : 60120,
        v = o ? Symbol.for("react.memo") : 60115,
        b = o ? Symbol.for("react.lazy") : 60116,
        x = o ? Symbol.for("react.fundamental") : 60117,
        w = o ? Symbol.for("react.scope") : 60119,
        S = i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

    function D(t) {
      if (null == t) return null;
      if ("function" === typeof t) return t.displayName || t.name || null;
      if ("string" === typeof t) return t;

      switch (t) {
        case c:
          return "Fragment";

        case s:
          return "Portal";

        case u:
          return "Profiler";

        case l:
          return "StrictMode";

        case g:
          return "Suspense";

        case m:
          return "SuspenseList";
      }

      if ("object" === typeof t) switch (t.$$typeof) {
        case f:
          return "Context.Consumer";

        case h:
          return "Context.Provider";

        case y:
          var e = t.render;
          return e = e.displayName || e.name || "", t.displayName || ("" !== e ? "ForwardRef(" + e + ")" : "ForwardRef");

        case v:
          return D(t.type);

        case b:
          if (t = 1 === t._status ? t._result : null) return D(t);
      }
      return null;
    }

    S.hasOwnProperty("ReactCurrentDispatcher") || (S.ReactCurrentDispatcher = {
      current: null
    }), S.hasOwnProperty("ReactCurrentBatchConfig") || (S.ReactCurrentBatchConfig = {
      suspense: null
    });
    var O = {};

    function E(t, e) {
      for (var r = 0 | t._threadCount; r <= e; r++) {
        t[r] = t._currentValue2, t._threadCount = r + 1;
      }
    }

    for (var k = new Uint16Array(16), _ = 0; 15 > _; _++) {
      k[_] = _ + 1;
    }

    k[15] = 0;
    var C = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
        T = Object.prototype.hasOwnProperty,
        A = {},
        P = {};

    function ta(t) {
      return !!T.call(P, t) || !T.call(A, t) && (C.test(t) ? P[t] = !0 : (A[t] = !0, !1));
    }

    function J(t, e, r, n, i, o) {
      this.acceptsBooleans = 2 === e || 3 === e || 4 === e, this.attributeName = n, this.attributeNamespace = i, this.mustUseProperty = r, this.propertyName = t, this.type = e, this.sanitizeURL = o;
    }

    var j = {};
    "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (t) {
      j[t] = new J(t, 0, !1, t, null, !1);
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (t) {
      var e = t[0];
      j[e] = new J(e, 1, !1, t[1], null, !1);
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (t) {
      j[t] = new J(t, 2, !1, t.toLowerCase(), null, !1);
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (t) {
      j[t] = new J(t, 2, !1, t, null, !1);
    }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (t) {
      j[t] = new J(t, 3, !1, t.toLowerCase(), null, !1);
    }), ["checked", "multiple", "muted", "selected"].forEach(function (t) {
      j[t] = new J(t, 3, !0, t, null, !1);
    }), ["capture", "download"].forEach(function (t) {
      j[t] = new J(t, 4, !1, t, null, !1);
    }), ["cols", "rows", "size", "span"].forEach(function (t) {
      j[t] = new J(t, 6, !1, t, null, !1);
    }), ["rowSpan", "start"].forEach(function (t) {
      j[t] = new J(t, 5, !1, t.toLowerCase(), null, !1);
    });
    var R = /[\-:]([a-z])/g;

    function M(t) {
      return t[1].toUpperCase();
    }

    "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (t) {
      var e = t.replace(R, M);
      j[e] = new J(e, 1, !1, t, null, !1);
    }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (t) {
      var e = t.replace(R, M);
      j[e] = new J(e, 1, !1, t, "http://www.w3.org/1999/xlink", !1);
    }), ["xml:base", "xml:lang", "xml:space"].forEach(function (t) {
      var e = t.replace(R, M);
      j[e] = new J(e, 1, !1, t, "http://www.w3.org/XML/1998/namespace", !1);
    }), ["tabIndex", "crossOrigin"].forEach(function (t) {
      j[t] = new J(t, 1, !1, t.toLowerCase(), null, !1);
    }), j.xlinkHref = new J("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0), ["src", "href", "action", "formAction"].forEach(function (t) {
      j[t] = new J(t, 1, !1, t.toLowerCase(), null, !0);
    });
    var I = /["'&<>]/;

    function N(t) {
      if ("boolean" === typeof t || "number" === typeof t) return "" + t;
      t = "" + t;
      var e = I.exec(t);

      if (e) {
        var r,
            n = "",
            i = 0;

        for (r = e.index; r < t.length; r++) {
          switch (t.charCodeAt(r)) {
            case 34:
              e = "&quot;";
              break;

            case 38:
              e = "&amp;";
              break;

            case 39:
              e = "&#x27;";
              break;

            case 60:
              e = "&lt;";
              break;

            case 62:
              e = "&gt;";
              break;

            default:
              continue;
          }

          i !== r && (n += t.substring(i, r)), i = r + 1, n += e;
        }

        t = i !== r ? n + t.substring(i, r) : n;
      }

      return t;
    }

    function xa(t, e) {
      var r,
          n = j.hasOwnProperty(t) ? j[t] : null;
      return (r = "style" !== t) && (r = null !== n ? 0 === n.type : 2 < t.length && ("o" === t[0] || "O" === t[0]) && ("n" === t[1] || "N" === t[1])), r || function va(t, e, r, n) {
        if (null === e || "undefined" === typeof e || function ua(t, e, r, n) {
          if (null !== r && 0 === r.type) return !1;

          switch (typeof e) {
            case "function":
            case "symbol":
              return !0;

            case "boolean":
              return !n && (null !== r ? !r.acceptsBooleans : "data-" !== (t = t.toLowerCase().slice(0, 5)) && "aria-" !== t);

            default:
              return !1;
          }
        }(t, e, r, n)) return !0;
        if (n) return !1;
        if (null !== r) switch (r.type) {
          case 3:
            return !e;

          case 4:
            return !1 === e;

          case 5:
            return isNaN(e);

          case 6:
            return isNaN(e) || 1 > e;
        }
        return !1;
      }(t, e, n, !1) ? "" : null !== n ? (t = n.attributeName, 3 === (r = n.type) || 4 === r && !0 === e ? t + '=""' : (n.sanitizeURL && (e = "" + e), t + '="' + N(e) + '"')) : ta(t) ? t + '="' + N(e) + '"' : "";
    }

    var L = "function" === typeof Object.is ? Object.is : function ya(t, e) {
      return t === e && (0 !== t || 1 / t === 1 / e) || t !== t && e !== e;
    },
        B = null,
        F = null,
        U = null,
        z = !1,
        H = !1,
        G = null,
        Y = 0;

    function W() {
      if (null === B) throw Error(q(321));
      return B;
    }

    function Aa() {
      if (0 < Y) throw Error(q(312));
      return {
        memoizedState: null,
        queue: null,
        next: null
      };
    }

    function Ba() {
      return null === U ? null === F ? (z = !1, F = U = Aa()) : (z = !0, U = F) : null === U.next ? (z = !1, U = U.next = Aa()) : (z = !0, U = U.next), U;
    }

    function Ca(t, e, r, n) {
      for (; H;) {
        H = !1, Y += 1, U = null, r = t(e, n);
      }

      return F = B = null, Y = 0, U = G = null, r;
    }

    function Da(t, e) {
      return "function" === typeof e ? e(t) : e;
    }

    function Ea(t, e, r) {
      if (B = W(), U = Ba(), z) {
        var n = U.queue;

        if (e = n.dispatch, null !== G && void 0 !== (r = G.get(n))) {
          G.delete(n), n = U.memoizedState;

          do {
            n = t(n, r.action), r = r.next;
          } while (null !== r);

          return U.memoizedState = n, [n, e];
        }

        return [U.memoizedState, e];
      }

      return t = t === Da ? "function" === typeof e ? e() : e : void 0 !== r ? r(e) : e, U.memoizedState = t, t = (t = U.queue = {
        last: null,
        dispatch: null
      }).dispatch = function Fa(t, e, r) {
        if (!(25 > Y)) throw Error(q(301));
        if (t === B) if (H = !0, t = {
          action: r,
          next: null
        }, null === G && (G = new Map()), void 0 === (r = G.get(e))) G.set(e, t);else {
          for (e = r; null !== e.next;) {
            e = e.next;
          }

          e.next = t;
        }
      }.bind(null, B, t), [U.memoizedState, t];
    }

    function Ga() {}

    var X = 0,
        V = {
      readContext: function readContext(t) {
        var e = X;
        return E(t, e), t[e];
      },
      useContext: function useContext(t) {
        W();
        var e = X;
        return E(t, e), t[e];
      },
      useMemo: function useMemo(t, e) {
        if (B = W(), e = void 0 === e ? null : e, null !== (U = Ba())) {
          var r = U.memoizedState;

          if (null !== r && null !== e) {
            t: {
              var n = r[1];
              if (null === n) n = !1;else {
                for (var i = 0; i < n.length && i < e.length; i++) {
                  if (!L(e[i], n[i])) {
                    n = !1;
                    break t;
                  }
                }

                n = !0;
              }
            }

            if (n) return r[0];
          }
        }

        return t = t(), U.memoizedState = [t, e], t;
      },
      useReducer: Ea,
      useRef: function useRef(t) {
        B = W();
        var e = (U = Ba()).memoizedState;
        return null === e ? (t = {
          current: t
        }, U.memoizedState = t) : e;
      },
      useState: function useState(t) {
        return Ea(Da, t);
      },
      useLayoutEffect: function useLayoutEffect() {},
      useCallback: function useCallback(t) {
        return t;
      },
      useImperativeHandle: Ga,
      useEffect: Ga,
      useDebugValue: Ga,
      useResponder: function useResponder(t, e) {
        return {
          props: e,
          responder: t
        };
      },
      useDeferredValue: function useDeferredValue(t) {
        return W(), t;
      },
      useTransition: function useTransition() {
        return W(), [function (t) {
          t();
        }, !1];
      }
    },
        $ = {
      html: "http://www.w3.org/1999/xhtml",
      mathml: "http://www.w3.org/1998/Math/MathML",
      svg: "http://www.w3.org/2000/svg"
    };

    function Ja(t) {
      switch (t) {
        case "svg":
          return "http://www.w3.org/2000/svg";

        case "math":
          return "http://www.w3.org/1998/Math/MathML";

        default:
          return "http://www.w3.org/1999/xhtml";
      }
    }

    var Q = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
    },
        K = n({
      menuitem: !0
    }, Q),
        Z = {
      animationIterationCount: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    },
        tt = ["Webkit", "ms", "Moz", "O"];
    Object.keys(Z).forEach(function (t) {
      tt.forEach(function (e) {
        e = e + t.charAt(0).toUpperCase() + t.substring(1), Z[e] = Z[t];
      });
    });
    var et = /([A-Z])/g,
        rt = /^ms-/,
        nt = i.Children.toArray,
        it = S.ReactCurrentDispatcher,
        ot = {
      listing: !0,
      pre: !0,
      textarea: !0
    },
        at = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,
        st = {},
        ct = {};
    var lt = Object.prototype.hasOwnProperty,
        ut = {
      children: null,
      dangerouslySetInnerHTML: null,
      suppressContentEditableWarning: null,
      suppressHydrationWarning: null
    };

    function Xa(t, e) {
      if (void 0 === t) throw Error(q(152, D(e) || "Component"));
    }

    function Ya(t, e, r) {
      function d(i, o) {
        var a = o.prototype && o.prototype.isReactComponent,
            s = function oa(t, e, r, n) {
          if (n && "object" === typeof (n = t.contextType) && null !== n) return E(n, r), n[r];

          if (t = t.contextTypes) {
            for (var i in r = {}, t) {
              r[i] = e[i];
            }

            e = r;
          } else e = O;

          return e;
        }(o, e, r, a),
            c = [],
            l = !1,
            u = {
          isMounted: function isMounted() {
            return !1;
          },
          enqueueForceUpdate: function enqueueForceUpdate() {
            if (null === c) return null;
          },
          enqueueReplaceState: function enqueueReplaceState(t, e) {
            l = !0, c = [e];
          },
          enqueueSetState: function enqueueSetState(t, e) {
            if (null === c) return null;
            c.push(e);
          }
        };

        if (a) {
          if (a = new o(i.props, s, u), "function" === typeof o.getDerivedStateFromProps) {
            var h = o.getDerivedStateFromProps.call(null, i.props, a.state);
            null != h && (a.state = n({}, a.state, h));
          }
        } else if (B = {}, a = o(i.props, s, u), null == (a = Ca(o, i.props, a, s)) || null == a.render) return void Xa(t = a, o);

        if (a.props = i.props, a.context = s, a.updater = u, void 0 === (u = a.state) && (a.state = u = null), "function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount) if ("function" === typeof a.componentWillMount && "function" !== typeof o.getDerivedStateFromProps && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && "function" !== typeof o.getDerivedStateFromProps && a.UNSAFE_componentWillMount(), c.length) {
          u = c;
          var d = l;
          if (c = null, l = !1, d && 1 === u.length) a.state = u[0];else {
            h = d ? u[0] : a.state;
            var f = !0;

            for (d = d ? 1 : 0; d < u.length; d++) {
              var p = u[d];
              null != (p = "function" === typeof p ? p.call(a, h, i.props, s) : p) && (f ? (f = !1, h = n({}, h, p)) : n(h, p));
            }

            a.state = h;
          }
        } else c = null;

        if (Xa(t = a.render(), o), "function" === typeof a.getChildContext && "object" === typeof (i = o.childContextTypes)) {
          var y = a.getChildContext();

          for (var g in y) {
            if (!(g in i)) throw Error(q(108, D(o) || "Unknown", g));
          }
        }

        y && (e = n({}, e, y));
      }

      for (; i.isValidElement(t);) {
        var o = t,
            a = o.type;
        if ("function" !== typeof a) break;
        d(o, a);
      }

      return {
        child: t,
        context: e
      };
    }

    var ht = function () {
      function a(t, e) {
        i.isValidElement(t) ? t.type !== c ? t = [t] : (t = t.props.children, t = i.isValidElement(t) ? [t] : nt(t)) : t = nt(t), t = {
          type: null,
          domNamespace: $.html,
          children: t,
          childIndex: 0,
          context: O,
          footer: ""
        };
        var r = k[0];

        if (0 === r) {
          var n = k,
              o = 2 * (r = n.length);
          if (!(65536 >= o)) throw Error(q(304));
          var a = new Uint16Array(o);

          for (a.set(n), (k = a)[0] = r + 1, n = r; n < o - 1; n++) {
            k[n] = n + 1;
          }

          k[o - 1] = 0;
        } else k[0] = k[r];

        this.threadID = r, this.stack = [t], this.exhausted = !1, this.currentSelectValue = null, this.previousWasTextNode = !1, this.makeStaticMarkup = e, this.suspenseDepth = 0, this.contextIndex = -1, this.contextStack = [], this.contextValueStack = [];
      }

      var t = a.prototype;
      return t.destroy = function () {
        if (!this.exhausted) {
          this.exhausted = !0, this.clearProviders();
          var t = this.threadID;
          k[t] = k[0], k[0] = t;
        }
      }, t.pushProvider = function (t) {
        var e = ++this.contextIndex,
            r = t.type._context,
            n = this.threadID;
        E(r, n);
        var i = r[n];
        this.contextStack[e] = r, this.contextValueStack[e] = i, r[n] = t.props.value;
      }, t.popProvider = function () {
        var t = this.contextIndex,
            e = this.contextStack[t],
            r = this.contextValueStack[t];
        this.contextStack[t] = null, this.contextValueStack[t] = null, this.contextIndex--, e[this.threadID] = r;
      }, t.clearProviders = function () {
        for (var t = this.contextIndex; 0 <= t; t--) {
          this.contextStack[t][this.threadID] = this.contextValueStack[t];
        }
      }, t.read = function (t) {
        if (this.exhausted) return null;
        var e = X;
        X = this.threadID;
        var r = it.current;
        it.current = V;

        try {
          for (var n = [""], i = !1; n[0].length < t;) {
            if (0 === this.stack.length) {
              this.exhausted = !0;
              var o = this.threadID;
              k[o] = k[0], k[0] = o;
              break;
            }

            var a = this.stack[this.stack.length - 1];

            if (i || a.childIndex >= a.children.length) {
              var s = a.footer;
              if ("" !== s && (this.previousWasTextNode = !1), this.stack.pop(), "select" === a.type) this.currentSelectValue = null;else if (null != a.type && null != a.type.type && a.type.type.$$typeof === h) this.popProvider(a.type);else if (a.type === g) {
                this.suspenseDepth--;
                var c = n.pop();

                if (i) {
                  i = !1;
                  var l = a.fallbackFrame;
                  if (!l) throw Error(q(303));
                  this.stack.push(l), n[this.suspenseDepth] += "\x3c!--$!--\x3e";
                  continue;
                }

                n[this.suspenseDepth] += c;
              }
              n[this.suspenseDepth] += s;
            } else {
              var u = a.children[a.childIndex++],
                  d = "";

              try {
                d += this.render(u, a.context, a.domNamespace);
              } catch (f) {
                if (null != f && "function" === typeof f.then) throw Error(q(294));
                throw f;
              }

              n.length <= this.suspenseDepth && n.push(""), n[this.suspenseDepth] += d;
            }
          }

          return n[0];
        } finally {
          it.current = r, X = e;
        }
      }, t.render = function (t, e, r) {
        if ("string" === typeof t || "number" === typeof t) return "" === (r = "" + t) ? "" : this.makeStaticMarkup ? N(r) : this.previousWasTextNode ? "\x3c!-- --\x3e" + N(r) : (this.previousWasTextNode = !0, N(r));
        if (t = (e = Ya(t, e, this.threadID)).child, e = e.context, null === t || !1 === t) return "";

        if (!i.isValidElement(t)) {
          if (null != t && null != t.$$typeof) {
            if ((r = t.$$typeof) === s) throw Error(q(257));
            throw Error(q(258, r.toString()));
          }

          return t = nt(t), this.stack.push({
            type: null,
            domNamespace: r,
            children: t,
            childIndex: 0,
            context: e,
            footer: ""
          }), "";
        }

        var o = t.type;
        if ("string" === typeof o) return this.renderDOM(t, e, r);

        switch (o) {
          case l:
          case p:
          case u:
          case m:
          case c:
            return t = nt(t.props.children), this.stack.push({
              type: null,
              domNamespace: r,
              children: t,
              childIndex: 0,
              context: e,
              footer: ""
            }), "";

          case g:
            throw Error(q(294));
        }

        if ("object" === typeof o && null !== o) switch (o.$$typeof) {
          case y:
            B = {};
            var a = o.render(t.props, t.ref);
            return a = Ca(o.render, t.props, a, t.ref), a = nt(a), this.stack.push({
              type: null,
              domNamespace: r,
              children: a,
              childIndex: 0,
              context: e,
              footer: ""
            }), "";

          case v:
            return t = [i.createElement(o.type, n({
              ref: t.ref
            }, t.props))], this.stack.push({
              type: null,
              domNamespace: r,
              children: t,
              childIndex: 0,
              context: e,
              footer: ""
            }), "";

          case h:
            return r = {
              type: t,
              domNamespace: r,
              children: o = nt(t.props.children),
              childIndex: 0,
              context: e,
              footer: ""
            }, this.pushProvider(t), this.stack.push(r), "";

          case f:
            o = t.type, a = t.props;
            var d = this.threadID;
            return E(o, d), o = nt(a.children(o[d])), this.stack.push({
              type: t,
              domNamespace: r,
              children: o,
              childIndex: 0,
              context: e,
              footer: ""
            }), "";

          case x:
            throw Error(q(338));

          case b:
            switch (function ma(t) {
              if (-1 === t._status) {
                t._status = 0;
                var e = t._ctor;
                e = e(), t._result = e, e.then(function (e) {
                  0 === t._status && (e = e.default, t._status = 1, t._result = e);
                }, function (e) {
                  0 === t._status && (t._status = 2, t._result = e);
                });
              }
            }(o = t.type), o._status) {
              case 1:
                return t = [i.createElement(o._result, n({
                  ref: t.ref
                }, t.props))], this.stack.push({
                  type: null,
                  domNamespace: r,
                  children: t,
                  childIndex: 0,
                  context: e,
                  footer: ""
                }), "";

              case 2:
                throw o._result;

              default:
                throw Error(q(295));
            }

          case w:
            throw Error(q(343));
        }
        throw Error(q(130, null == o ? o : typeof o, ""));
      }, t.renderDOM = function (t, e, r) {
        var o = t.type.toLowerCase();

        if (r === $.html && Ja(o), !st.hasOwnProperty(o)) {
          if (!at.test(o)) throw Error(q(65, o));
          st[o] = !0;
        }

        var a = t.props;
        if ("input" === o) a = n({
          type: void 0
        }, a, {
          defaultChecked: void 0,
          defaultValue: void 0,
          value: null != a.value ? a.value : a.defaultValue,
          checked: null != a.checked ? a.checked : a.defaultChecked
        });else if ("textarea" === o) {
          var s = a.value;

          if (null == s) {
            s = a.defaultValue;
            var c = a.children;

            if (null != c) {
              if (null != s) throw Error(q(92));

              if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(q(93));
                c = c[0];
              }

              s = "" + c;
            }

            null == s && (s = "");
          }

          a = n({}, a, {
            value: void 0,
            children: "" + s
          });
        } else if ("select" === o) this.currentSelectValue = null != a.value ? a.value : a.defaultValue, a = n({}, a, {
          value: void 0
        });else if ("option" === o) {
          c = this.currentSelectValue;

          var l = function Ua(t) {
            if (void 0 === t || null === t) return t;
            var e = "";
            return i.Children.forEach(t, function (t) {
              null != t && (e += t);
            }), e;
          }(a.children);

          if (null != c) {
            var u = null != a.value ? a.value + "" : l;

            if (s = !1, Array.isArray(c)) {
              for (var h = 0; h < c.length; h++) {
                if ("" + c[h] === u) {
                  s = !0;
                  break;
                }
              }
            } else s = "" + c === u;

            a = n({
              selected: void 0,
              children: void 0
            }, a, {
              selected: s,
              children: l
            });
          }
        }

        if (s = a) {
          if (K[o] && (null != s.children || null != s.dangerouslySetInnerHTML)) throw Error(q(137, o, ""));

          if (null != s.dangerouslySetInnerHTML) {
            if (null != s.children) throw Error(q(60));
            if (!("object" === typeof s.dangerouslySetInnerHTML && "__html" in s.dangerouslySetInnerHTML)) throw Error(q(61));
          }

          if (null != s.style && "object" !== typeof s.style) throw Error(q(62, ""));
        }

        for (b in s = a, c = this.makeStaticMarkup, l = 1 === this.stack.length, u = "<" + t.type, s) {
          if (lt.call(s, b)) {
            var d = s[b];

            if (null != d) {
              if ("style" === b) {
                h = void 0;
                var f = "",
                    p = "";

                for (h in d) {
                  if (d.hasOwnProperty(h)) {
                    var y = 0 === h.indexOf("--"),
                        g = d[h];

                    if (null != g) {
                      if (y) var m = h;else if (m = h, ct.hasOwnProperty(m)) m = ct[m];else {
                        var v = m.replace(et, "-$1").toLowerCase().replace(rt, "-ms-");
                        m = ct[m] = v;
                      }
                      f += p + m + ":", p = h, f += y = null == g || "boolean" === typeof g || "" === g ? "" : y || "number" !== typeof g || 0 === g || Z.hasOwnProperty(p) && Z[p] ? ("" + g).trim() : g + "px", p = ";";
                    }
                  }
                }

                d = f || null;
              }

              h = null;

              t: if (y = o, g = s, -1 === y.indexOf("-")) y = "string" === typeof g.is;else switch (y) {
                case "annotation-xml":
                case "color-profile":
                case "font-face":
                case "font-face-src":
                case "font-face-uri":
                case "font-face-format":
                case "font-face-name":
                case "missing-glyph":
                  y = !1;
                  break t;

                default:
                  y = !0;
              }

              y ? ut.hasOwnProperty(b) || (h = ta(h = b) && null != d ? h + '="' + N(d) + '"' : "") : h = xa(b, d), h && (u += " " + h);
            }
          }
        }

        c || l && (u += ' data-reactroot=""');
        var b = u;
        s = "", Q.hasOwnProperty(o) ? b += "/>" : (b += ">", s = "</" + t.type + ">");

        t: {
          if (null != (c = a.dangerouslySetInnerHTML)) {
            if (null != c.__html) {
              c = c.__html;
              break t;
            }
          } else if ("string" === typeof (c = a.children) || "number" === typeof c) {
            c = N(c);
            break t;
          }

          c = null;
        }

        return null != c ? (a = [], ot[o] && "\n" === c.charAt(0) && (b += "\n"), b += c) : a = nt(a.children), t = t.type, r = null == r || "http://www.w3.org/1999/xhtml" === r ? Ja(t) : "http://www.w3.org/2000/svg" === r && "foreignObject" === t ? "http://www.w3.org/1999/xhtml" : r, this.stack.push({
          domNamespace: r,
          type: o,
          children: a,
          childIndex: 0,
          context: e,
          footer: s
        }), this.previousWasTextNode = !1, b;
      }, a;
    }(),
        dt = {
      renderToString: function renderToString(t) {
        t = new ht(t, !1);

        try {
          return t.read(1 / 0);
        } finally {
          t.destroy();
        }
      },
      renderToStaticMarkup: function renderToStaticMarkup(t) {
        t = new ht(t, !0);

        try {
          return t.read(1 / 0);
        } finally {
          t.destroy();
        }
      },
      renderToNodeStream: function renderToNodeStream() {
        throw Error(q(207));
      },
      renderToStaticNodeStream: function renderToStaticNodeStream() {
        throw Error(q(208));
      },
      version: "16.12.0"
    },
        ft = {
      default: dt
    },
        pt = ft && dt || ft;

    t.exports = pt.default || pt;
  }, function (t, e, r) {
    "use strict";

    var n = Object.getOwnPropertySymbols,
        i = Object.prototype.hasOwnProperty,
        o = Object.prototype.propertyIsEnumerable;
    t.exports = function shouldUseNative() {
      try {
        if (!Object.assign) return !1;
        var t = new String("abc");
        if (t[5] = "de", "5" === Object.getOwnPropertyNames(t)[0]) return !1;

        for (var e = {}, r = 0; r < 10; r++) {
          e["_" + String.fromCharCode(r)] = r;
        }

        if ("0123456789" !== Object.getOwnPropertyNames(e).map(function (t) {
          return e[t];
        }).join("")) return !1;
        var n = {};
        return "abcdefghijklmnopqrst".split("").forEach(function (t) {
          n[t] = t;
        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, n)).join("");
      } catch (i) {
        return !1;
      }
    }() ? Object.assign : function (t, e) {
      for (var r, a, s = function toObject(t) {
        if (null === t || void 0 === t) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(t);
      }(t), c = 1; c < arguments.length; c++) {
        for (var l in r = Object(arguments[c])) {
          i.call(r, l) && (s[l] = r[l]);
        }

        if (n) {
          a = n(r);

          for (var u = 0; u < a.length; u++) {
            o.call(r, a[u]) && (s[a[u]] = r[a[u]]);
          }
        }
      }

      return s;
    };
  }, function (t, e, r) {
    var n = r(86);
    "string" === typeof (n = n.__esModule ? n.default : n) && (n = [[t.i, n, ""]]);
    var i = {
      insert: "head",
      singleton: !1
    };
    r(88)(n, i);
    n.locals && (t.exports = n.locals);
  }, function (t, e, r) {
    (t.exports = r(87)(!0)).push([t.i, "div:has(.bad-feedback-input):nth-child(2) {\n  border: none;\n}\n", "", {
      version: 3,
      sources: ["index.css"],
      names: [],
      mappings: "AAAA;EACE,YAAY;AACd",
      file: "index.css",
      sourcesContent: ["div:has(.bad-feedback-input):nth-child(2) {\n  border: none;\n}\n"]
    }]);
  }, function (t, e, r) {
    "use strict";

    t.exports = function (t) {
      var e = [];
      return e.toString = function toString() {
        return this.map(function (e) {
          var r = function cssWithMappingToString(t, e) {
            var r = t[1] || "",
                n = t[3];
            if (!n) return r;

            if (e && "function" === typeof btoa) {
              var i = function toComment(t) {
                return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(t)))) + " */";
              }(n),
                  o = n.sources.map(function (t) {
                return "/*# sourceURL=" + n.sourceRoot + t + " */";
              });

              return [r].concat(o).concat([i]).join("\n");
            }

            return [r].join("\n");
          }(e, t);

          return e[2] ? "@media " + e[2] + "{" + r + "}" : r;
        }).join("");
      }, e.i = function (t, r) {
        "string" === typeof t && (t = [[null, t, ""]]);

        for (var n = {}, i = 0; i < this.length; i++) {
          var o = this[i][0];
          null != o && (n[o] = !0);
        }

        for (i = 0; i < t.length; i++) {
          var a = t[i];
          null != a[0] && n[a[0]] || (r && !a[2] ? a[2] = r : r && (a[2] = "(" + a[2] + ") and (" + r + ")"), e.push(a));
        }
      }, e;
    };
  }, function (t, e, r) {
    "use strict";

    var n = {},
        i = function isOldIE() {
      var t;
      return function memorize() {
        return "undefined" === typeof t && (t = Boolean(window && document && document.all && !window.atob)), t;
      };
    }(),
        o = function getTarget() {
      var t = {};
      return function memorize(e) {
        if ("undefined" === typeof t[e]) {
          var r = document.querySelector(e);
          if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
            r = r.contentDocument.head;
          } catch (n) {
            r = null;
          }
          t[e] = r;
        }

        return t[e];
      };
    }();

    function listToStyles(t, e) {
      for (var r = [], n = {}, i = 0; i < t.length; i++) {
        var o = t[i],
            a = e.base ? o[0] + e.base : o[0],
            s = {
          css: o[1],
          media: o[2],
          sourceMap: o[3]
        };
        n[a] ? n[a].parts.push(s) : r.push(n[a] = {
          id: a,
          parts: [s]
        });
      }

      return r;
    }

    function addStylesToDom(t, e) {
      for (var r = 0; r < t.length; r++) {
        var i = t[r],
            o = n[i.id],
            a = 0;

        if (o) {
          for (o.refs++; a < o.parts.length; a++) {
            o.parts[a](i.parts[a]);
          }

          for (; a < i.parts.length; a++) {
            o.parts.push(addStyle(i.parts[a], e));
          }
        } else {
          for (var s = []; a < i.parts.length; a++) {
            s.push(addStyle(i.parts[a], e));
          }

          n[i.id] = {
            id: i.id,
            refs: 1,
            parts: s
          };
        }
      }
    }

    function insertStyleElement(t) {
      var e = document.createElement("style");

      if ("undefined" === typeof t.attributes.nonce) {
        var n = r.nc;
        n && (t.attributes.nonce = n);
      }

      if (Object.keys(t.attributes).forEach(function (r) {
        e.setAttribute(r, t.attributes[r]);
      }), "function" === typeof t.insert) t.insert(e);else {
        var i = o(t.insert || "head");
        if (!i) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
        i.appendChild(e);
      }
      return e;
    }

    var a = function replaceText() {
      var t = [];
      return function replace(e, r) {
        return t[e] = r, t.filter(Boolean).join("\n");
      };
    }();

    function applyToSingletonTag(t, e, r, n) {
      var i = r ? "" : n.css;
      if (t.styleSheet) t.styleSheet.cssText = a(e, i);else {
        var o = document.createTextNode(i),
            s = t.childNodes;
        s[e] && t.removeChild(s[e]), s.length ? t.insertBefore(o, s[e]) : t.appendChild(o);
      }
    }

    var s = null,
        c = 0;

    function addStyle(t, e) {
      var r, n, i;

      if (e.singleton) {
        var o = c++;
        r = s || (s = insertStyleElement(e)), n = applyToSingletonTag.bind(null, r, o, !1), i = applyToSingletonTag.bind(null, r, o, !0);
      } else r = insertStyleElement(e), n = function applyToTag(t, e, r) {
        var n = r.css,
            i = r.media,
            o = r.sourceMap;
        if (i && t.setAttribute("media", i), o && btoa && (n += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(o)))), " */")), t.styleSheet) t.styleSheet.cssText = n;else {
          for (; t.firstChild;) {
            t.removeChild(t.firstChild);
          }

          t.appendChild(document.createTextNode(n));
        }
      }.bind(null, r, e), i = function remove() {
        !function removeStyleElement(t) {
          if (null === t.parentNode) return !1;
          t.parentNode.removeChild(t);
        }(r);
      };

      return n(t), function updateStyle(e) {
        if (e) {
          if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap) return;
          n(t = e);
        } else i();
      };
    }

    t.exports = function (t, e) {
      (e = e || {}).attributes = "object" === typeof e.attributes ? e.attributes : {}, e.singleton || "boolean" === typeof e.singleton || (e.singleton = i());
      var r = listToStyles(t, e);
      return addStylesToDom(r, e), function update(t) {
        for (var i = [], o = 0; o < r.length; o++) {
          var a = r[o],
              s = n[a.id];
          s && (s.refs--, i.push(s));
        }

        t && addStylesToDom(listToStyles(t, e), e);

        for (var c = 0; c < i.length; c++) {
          var l = i[c];

          if (0 === l.refs) {
            for (var u = 0; u < l.parts.length; u++) {
              l.parts[u]();
            }

            delete n[l.id];
          }
        }
      };
    };
  }, function (t, e, r) {
    "use strict";

    r.r(e);
    var n,
        i,
        o,
        a,
        s = r(0),
        c = r(13),
        l = r(1),
        u = r.n(l),
        h = r(3),
        d = r(12),
        f = r(28),
        p = r(29),
        y = r.n(p),
        g = r(2),
        m = {
      QA: r(40),
      EU: r(41),
      US: r(42)
    },
        v = Object(g.a)(Object(g.a)({}, window.DRIFT_CONFIG || {}), m[window.DRIFT_REGION || ("PRODUCTION" === window.__ENV__ ? "US" : "QA")]),
        b = Object(f.createAuthedHttpClient)({
      baseConfig: {
        baseURL: v.AI_PLATFORM_API,
        paramsSerializer: function paramsSerializer(t) {
          return y.a.stringify(t, {
            arrayFormat: "repeat"
          });
        }
      }
    }),
        x = Object(f.createAuthedHttpClient)({
      baseConfig: {
        baseURL: v.CONTENT_MANAGEMENT_API,
        paramsSerializer: function paramsSerializer(t) {
          return y.a.stringify(t, {
            arrayFormat: "repeat"
          });
        }
      }
    }),
        w = Object(f.createAuthedHttpClient)({
      baseConfig: {
        baseURL: v.CUSTOMER_API,
        paramsSerializer: function paramsSerializer(t) {
          return y.a.stringify(t, {
            arrayFormat: "repeat"
          });
        }
      }
    }),
        S = r(8);
    !function (t) {
      t.DID_NOT_ANSWER_QUESTION = "DID_NOT_ANSWER_QUESTION", t.INCORRECT_RESPONSE = "INCORRECT_RESPONSE", t.OFF_LIMITS = "OFF_LIMITS", t.MISSED_SCENARIO = "MISSED_SCENARIO", t.INCORRECT_SCENARIO = "INCORRECT_SCENARIO", t.GENERAL_INQUIRY = "GENERAL_INQUIRY", t.CORRECT_SCENARIO_WRONG_RESPONSE = "CORRECT_SCENARIO_WRONG_RESPONSE", t.OTHER = "OTHER", t.INCORRECT_SOURCE = "INCORRECT_SOURCE", t.SHOULD_HAVE_BEEN_ANSWERED = "SHOULD_HAVE_BEEN_ANSWERED", t.OFF_TOPIC_INQUIRY = "OFF_TOPIC_INQUIRY";
    }(a || (a = {}));

    var O = (n = {}, Object(S.a)(n, a.DID_NOT_ANSWER_QUESTION, "Didn't answer the question"), Object(S.a)(n, a.INCORRECT_RESPONSE, "Bad response"), Object(S.a)(n, a.OFF_LIMITS, "Off limits topic"), Object(S.a)(n, a.MISSED_SCENARIO, "Should have hit a scenarios or guardrails"), Object(S.a)(n, a.INCORRECT_SCENARIO, "Wrong scenario detected"), Object(S.a)(n, a.GENERAL_INQUIRY, "Should not have hit any scenarios"), Object(S.a)(n, a.OTHER, "Other"), Object(S.a)(n, a.CORRECT_SCENARIO_WRONG_RESPONSE, "Correct scenario, incorrect response"), Object(S.a)(n, a.INCORRECT_SOURCE, "Bad response"), Object(S.a)(n, a.SHOULD_HAVE_BEEN_ANSWERED, "Should have been answered"), Object(S.a)(n, a.OFF_TOPIC_INQUIRY, "Off topic inquiry"), n),
        E = [a.INCORRECT_SOURCE, a.OTHER],
        k = [a.INCORRECT_SCENARIO, a.GENERAL_INQUIRY, a.CORRECT_SCENARIO_WRONG_RESPONSE],
        _ = [a.MISSED_SCENARIO, a.GENERAL_INQUIRY, a.OFF_TOPIC_INQUIRY, a.OTHER],
        C = [a.MISSED_SCENARIO, a.GENERAL_INQUIRY, a.OTHER],
        T = [a.INCORRECT_SOURCE, a.MISSED_SCENARIO, a.OTHER],
        A = [a.INCORRECT_SOURCE, a.MISSED_SCENARIO, a.OFF_TOPIC_INQUIRY, a.OTHER],
        M = [a.SHOULD_HAVE_BEEN_ANSWERED, a.MISSED_SCENARIO, a.OTHER],
        P = {
      REGULAR: "REGULAR",
      CUSTOM_SCENARIO: "CUSTOM_SCENARIO",
      GLOBAL_SCENARIO: "GLOBAL_SCENARIO",
      GUARDRAIL: "GUARDRAIL"
    },
        j = (i = {}, Object(S.a)(i, P.REGULAR, "This was a good response"), Object(S.a)(i, P.CUSTOM_SCENARIO, "Good response; correctly hit the {{scenarioName}} scenario"), Object(S.a)(i, P.GLOBAL_SCENARIO, "Good response; correctly hit the {{scenarioName}} scenario"), Object(S.a)(i, P.GUARDRAIL, "Good response; correctly hit the {{scenarioName}} guardrail"), i),
        R = (o = {}, Object(S.a)(o, P.REGULAR, "Bad response"), Object(S.a)(o, P.CUSTOM_SCENARIO, "Bad Response; should not have hit the {{scenarioName}} scenario"), Object(S.a)(o, P.GLOBAL_SCENARIO, "Bad Response; should not have hit the {{scenarioName}} scenario"), Object(S.a)(o, P.GUARDRAIL, "Bad Response; should not have hit the {{scenarioName}} guardrail"), o),
        D = Object(l.createContext)(null),
        I = function AIMessageConfigProvider(t) {
      var e = t.children,
          r = t.closeFeedbackForm,
          n = t.review,
          i = t.message,
          o = t.isBionic,
          s = t.hasVertexSearch,
          c = t.messageResponseType,
          d = t.possibleScenarios,
          f = t.allVertexUrls,
          p = t.isLoadingVertexUrls,
          y = t.scenarioName,
          g = t.scenarioExposed,
          m = t.eventNamePrefix,
          v = t.messageIndex,
          b = Object(l.useState)(!1),
          x = Object(h.a)(b, 2),
          w = x[0],
          S = x[1],
          O = Object(l.useState)(""),
          E = Object(h.a)(O, 2),
          k = E[0],
          _ = E[1],
          C = Object(l.useMemo)(function () {
        return (null === n || void 0 === n ? void 0 : n.negativeReviewReason) === a.INCORRECT_SOURCE;
      }, [null === n || void 0 === n ? void 0 : n.negativeReviewReason]),
          T = Object(l.useMemo)(function () {
        return "DOWN" === (null === n || void 0 === n ? void 0 : n.thumbs);
      }, [null === n || void 0 === n ? void 0 : n.thumbs]),
          A = Object(l.useMemo)(function () {
        return T && C;
      }, [T, C]);
      return u.a.createElement(D.Provider, {
        value: {
          showAdditionalFeedbackForm: w,
          setShowAdditionalFeedbackForm: S,
          closeFeedbackForm: r,
          updatedSourceMessage: k,
          setUpdatedSourceMessage: _,
          review: n,
          message: i,
          isBionic: o,
          hasVertexSearch: s,
          messageResponseType: c,
          possibleScenarios: d,
          allVertexUrls: f,
          isLoadingVertexUrls: p,
          scenarioName: y,
          scenarioExposed: g,
          eventNamePrefix: m,
          messageIndex: v,
          isIncorrectSource: C,
          hasThumbsDown: T,
          shouldConfirmFeedbackRemoval: A
        }
      }, e);
    },
        L = function useAIMessageConfig() {
      var t = Object(l.useContext)(D);
      if (!t) throw new Error("No context provided for AIMessageConfigContext");
      return t;
    },
        N = r(43),
        B = r(44),
        F = r(45),
        U = r(46),
        W = function RemoveFeedbackModal(t) {
      var e = t.isOpen,
          r = t.handleClose,
          n = t.onConfirm,
          i = t.review,
          o = Object(s.useToast)(),
          a = Object(c.useMutation)(function () {
        return b.post("/improvement/".concat(i.orgId, "/delete/cachedResponse"), {
          messageId: i.messageId.toString(),
          conversationId: null === i || void 0 === i ? void 0 : i.conversationId
        });
      }, {
        onSuccess: function onSuccess() {
          n(), r();
        },
        onError: function onError() {
          o({
            message: "An error occurred while removing your feedback, please try again later",
            variant: "error"
          });
        }
      });
      return u.a.createElement(s.Modal.Root, {
        open: e,
        onClose: r
      }, u.a.createElement(s.Modal.Dialog, {
        size: "medium",
        variant: "error"
      }, u.a.createElement(s.Modal.Title, {
        title: "Remove feedback"
      }), u.a.createElement(s.Modal.Content, null, u.a.createElement(s.Text, null, "Are you sure you want to remove the current feedback?", u.a.createElement("b", null, " It will be permanently removed from the database."), " You will not be able to recover this feedback and this action cannot be undone.")), u.a.createElement(s.Modal.Actions, null, u.a.createElement(s.Button, {
        variant: "secondary",
        onClick: r
      }, "Cancel"), u.a.createElement(s.Button, {
        variant: "error",
        onClick: function handleRemove(t) {
          t.preventDefault(), t.stopPropagation(), a.mutate();
        },
        loading: a.isLoading
      }, "Remove permanently"))));
    },
        z = r(23),
        q = Object(s.styled)(s.Text, {
      '&[data-state="hasReview"]': {
        fontWeight: "$bodyBold"
      }
    }),
        H = function trackEvent(t, e) {
      window.analytics.track(t, e);
    },
        G = function isEmptyOrNil(t) {
      return Object(d.isEmpty)(t) || Object(d.isNil)(t);
    },
        Y = function humanizeDetectedParams(t, e, r, n, i) {
      if (i) return "Issue: ".concat(O[i]);

      if (t !== P.REGULAR && e) {
        var o = e.replace("{{scenarioName}}", G(r) || !n ? "" : "<strong>".concat(r, "</strong>"));
        return G(r) || !n ? o.replace("the", "a") : o;
      }

      return e;
    },
        X = function ThumbsDownTooltipContent(t) {
      var e = t.review,
          r = t.messageResponseType,
          n = t.scenarioName,
          i = t.scenarioExposed,
          o = t.displayName,
          a = t.isIncorrectSource,
          c = t.hasThumbsDown,
          l = t.openUpdatedMessageDetail;
      return u.a.createElement(s.Flex, {
        direction: "column",
        alignItems: "flex-start",
        gap: 0
      }, u.a.createElement(q, {
        variant: "metadata",
        "data-state": "DOWN" === (null === e || void 0 === e ? void 0 : e.thumbs) && "hasReview",
        dangerouslySetInnerHTML: {
          __html: Y(r, R[r], n, i, null === e || void 0 === e ? void 0 : e.negativeReviewReason)
        }
      }), c && u.a.createElement(s.Flex, {
        direction: "column",
        gap: 0,
        css: {
          marginTop: "$1"
        }
      }, a && e.newGeneratedResponse ? u.a.createElement(s.Box, null, u.a.createElement(s.Text, {
        variant: "metadata",
        css: {
          color: "$blue7",
          cursor: "pointer",
          fontWeight: "$bold"
        },
        onClick: l
      }, (null === e || void 0 === e ? void 0 : e.newSource) ? "Source updated " : "Response updated "), u.a.createElement(s.Text, {
        variant: "metadata"
      }, "for future inquiries by ".concat(o, " on ").concat(z.a.DATE(e.createdAt)))) : u.a.createElement(s.Text, {
        variant: "metadata"
      }, "Reviewed by ".concat(o, " on ").concat(z.a.DATE(e.createdAt)))));
    },
        V = function ThumbsUpTooltipContent(t) {
      var e = t.review,
          r = t.messageResponseType,
          n = t.scenarioName,
          i = t.scenarioExposed,
          o = t.displayName;
      return u.a.createElement(s.Flex, {
        direction: "column",
        css: {
          textAlign: "center"
        },
        gap: 0
      }, u.a.createElement(q, {
        "data-state": "UP" === (null === e || void 0 === e ? void 0 : e.thumbs) && "hasReview",
        variant: "metadata",
        dangerouslySetInnerHTML: {
          __html: Y(r, j[r], n, i)
        },
        css: {
          textAlign: "center",
          width: "100%"
        }
      }), "UP" === (null === e || void 0 === e ? void 0 : e.thumbs) && u.a.createElement(s.Text, {
        variant: "metadata"
      }, "Reviewed by ".concat(o, " on ").concat(z.a.DATE(e.createdAt))));
    },
        $ = function ReviewActions(t) {
      var e = t.onUpdateRate,
          r = t.isLoading,
          n = t.openUpdatedMessageDetail,
          i = L(),
          o = i.setUpdatedSourceMessage,
          a = i.review,
          f = i.messageResponseType,
          p = i.scenarioName,
          y = i.scenarioExposed,
          g = i.isIncorrectSource,
          m = i.hasThumbsDown,
          v = i.shouldConfirmFeedbackRemoval,
          b = i.messageIndex,
          x = function useReviewerInfo(t) {
        var e = Object(c.useQuery)({
          queryKey: ["search_convo_reviewer", t],
          queryFn: function queryFn() {
            return w.get("/users/".concat(t)).then(function (t) {
              return t.data;
            });
          },
          enabled: !Object(d.isNil)(t)
        }).data,
            r = Object(l.useMemo)(function () {
          var t, r;
          return null !== (t = null !== (r = null === e || void 0 === e ? void 0 : e.name) && void 0 !== r ? r : null === e || void 0 === e ? void 0 : e.alias) && void 0 !== t ? t : null === e || void 0 === e ? void 0 : e.email;
        }, [e]);
        return {
          user: e,
          displayName: r
        };
      }(null === a || void 0 === a ? void 0 : a.createdBy).displayName,
          S = Object(l.useState)(!1),
          O = Object(h.a)(S, 2),
          E = O[0],
          k = O[1],
          _ = Object(l.useState)(null === a || void 0 === a ? void 0 : a.thumbs),
          C = Object(h.a)(_, 2),
          T = C[0],
          A = C[1];

      Object(l.useEffect)(function () {
        A(null === a || void 0 === a ? void 0 : a.thumbs);
      }, [b]);
      var M = m ? void 0 : u.a.createElement(V, {
        review: a,
        messageResponseType: f,
        scenarioName: p,
        scenarioExposed: y,
        displayName: x
      }),
          P = "UP" === (null === a || void 0 === a ? void 0 : a.thumbs) ? void 0 : u.a.createElement(X, {
        review: a,
        messageResponseType: f,
        scenarioName: p,
        scenarioExposed: y,
        displayName: x,
        isIncorrectSource: g,
        hasThumbsDown: m,
        openUpdatedMessageDetail: n
      });
      return u.a.createElement(u.a.Fragment, null, u.a.createElement(s.ToggleButtonGroup, {
        key: "thumbs-".concat(b),
        color: "UP" === T ? "green" : "DOWN" === T ? "red" : void 0,
        appearance: "outline",
        initialSelectedValues: T ? [T] : void 0,
        onChange: function handleToggleChange(t) {
          if (0 !== t.length) {
            var r = t[0];
            A(r), "UP" === r ? e("UP") : "DOWN" === r && (v ? k(!0) : (e("DOWN"), o("")));
          } else (null === a || void 0 === a ? void 0 : a.thumbs) && (A(void 0), o(""), v ? k(!0) : e(a.thumbs));
        },
        exclusive: !0
      }, u.a.createElement(s.ToggleButton, {
        title: M,
        isDisabled: r,
        value: "UP",
        icon: B.faThumbsUp,
        selectedIcon: U.faThumbsUp
      }), u.a.createElement(s.ToggleButton, {
        title: P,
        value: "DOWN",
        icon: N.faThumbsDown,
        selectedIcon: F.faThumbsDown,
        isDisabled: r
      })), a && u.a.createElement(W, {
        review: a,
        isOpen: E,
        onConfirm: function onConfirm() {
          return e("DOWN");
        },
        handleClose: function handleClose() {
          return k(!1);
        }
      }));
    },
        Q = r(4),
        K = r.n(Q),
        Z = r(7),
        J = r(26),
        tt = function useBotUser() {
      return function useOrgUsers() {
        return Object(J.useSelector)(function (t) {
          var e;
          return (null === t || void 0 === t ? void 0 : null === (e = t.org) || void 0 === e ? void 0 : e.users) || [];
        });
      }().find(function (t) {
        return t.bot;
      }) || null;
    },
        et = r(48),
        rt = r(27),
        nt = r(49),
        it = r(34),
        ot = "Response accepted for future inquiries.",
        at = "Source accepted for future inquiries.",
        st = r(50).access.hasGates,
        ct = function ResponseContent(t) {
      var e = t.customerInquiry,
          r = t.generatedResponse,
          n = t.onClickAction,
          i = t.isCacheResponseLoading,
          o = t.actionTitle,
          a = t.actionTooltip,
          c = t.isUpdated,
          l = void 0 === c || c,
          h = t.isGenerating,
          d = void 0 !== h && h,
          f = t.backgroundFill,
          p = void 0 === f || f,
          y = t.isRefine,
          g = void 0 !== y && y,
          m = t.avatarUrl,
          v = void 0 === m ? "" : m;
      return u.a.createElement(s.Flex, {
        direction: "column",
        gap: 0,
        css: {
          flexGrow: "initial"
        },
        fullWidth: !0
      }, u.a.createElement(s.Flex, {
        direction: "row",
        css: {
          background: "$gray8",
          padding: "$1",
          flexGrow: "initial"
        },
        justifyContent: "center",
        alignItems: "center",
        fullWidth: !0
      }, u.a.createElement(s.Text, {
        variant: "metadata",
        css: {
          color: "$gray1"
        }
      }, e)), d ? u.a.createElement(s.Flex, {
        fullWidth: !0,
        justifyContent: "center",
        alignItems: "center",
        css: {
          height: 100
        }
      }, u.a.createElement(s.CircleLoader, {
        size: "extra-large",
        variant: "inherit",
        css: {
          color: "$blue3"
        }
      })) : u.a.createElement(s.Flex, {
        direction: "column",
        css: {
          background: p ? "$gray2" : "transparent",
          padding: "$2",
          flexGrow: "initial"
        },
        fullWidth: !0
      }, g && u.a.createElement(s.Text, {
        variant: "bodyBold"
      }, l ? "Updated response" : "Original response"), u.a.createElement(s.Flex, {
        direction: "row",
        alignItems: "flex-start"
      }, v && u.a.createElement(s.UserAvatar, {
        imageUrl: v,
        size: "x-small"
      }), u.a.createElement(s.Box, {
        css: {
          background: "$gray3",
          border: "1px transparent",
          borderRadius: 6,
          padding: "$1"
        }
      }, u.a.createElement(s.Text, {
        css: {
          color: "$gray12"
        },
        dangerouslySetInnerHTML: {
          __html: r
        }
      }))), o && n && u.a.createElement(s.Tooltip, {
        content: a
      }, u.a.createElement(s.Button, {
        loading: null !== i && void 0 !== i && i,
        variant: "primary",
        size: "medium",
        onClick: n,
        css: {
          border: "none"
        }
      }, o))));
    },
        lt = r(5),
        ut = r(51),
        ht = function useDebounce(t, e) {
      var r = Object(l.useState)(t),
          n = Object(h.a)(r, 2),
          i = n[0],
          o = n[1];
      return Object(l.useEffect)(function () {
        var r = setTimeout(function () {
          o(t);
        }, e);
        return function () {
          clearTimeout(r);
        };
      }, [t, e]), i;
    },
        dt = function useSources() {
      var t = Object(l.useState)(""),
          e = Object(h.a)(t, 2),
          r = e[0],
          n = e[1],
          i = ht(r, 500),
          o = Object(c.useQuery)({
        queryKey: ["search-sources", i],
        queryFn: function queryFn() {
          return function fetchSources(t) {
            var e = t.search,
                r = t.limit;
            return x.get("/sources/urls/processed/all", {
              params: {
                search: e,
                limit: r
              }
            });
          }({
            search: i,
            limit: 10
          }).then(function (t) {
            return t.data;
          }).catch(function (t) {
            return t;
          });
        },
        refetchOnWindowFocus: !1
      }),
          a = o.data,
          s = void 0 === a ? [] : a,
          u = o.isLoading,
          d = Object(lt.a)((null !== s && void 0 !== s ? s : []).map(function (t) {
        var e;
        return {
          label: null !== (e = t.title) && void 0 !== e ? e : "Uploaded url",
          description: t.uploadUrl,
          value: t.uploadUrl,
          id: t.id,
          documentId: t.documentId
        };
      }));
      return {
        isLoading: r !== i || u,
        sources: d,
        filterSources: function filterSources(t) {
          var e = t.searchTerm;
          return n(e);
        }
      };
    },
        ft = {
      label: u.a.createElement(s.Flex, {
        width: 370,
        alignItems: "center",
        justifyContent: "center"
      }, u.a.createElement(s.CircleLoader, {
        size: "medium"
      })),
      value: "LOADER",
      isDisabled: !0
    },
        pt = {
      label: u.a.createElement(s.Flex, {
        width: 370,
        alignItems: "center",
        css: {
          borderTop: "1px solid $gray3",
          marginTop: "-6px",
          paddingTop: "6px"
        }
      }, u.a.createElement(s.Icon, {
        icon: ut.faPlus,
        size: "medium"
      }), u.a.createElement(s.Text, {
        as: "div",
        variant: "bodyBold"
      }, "Add content")),
      value: "SELECT_ACTION"
    },
        yt = function SourcesAutocomplete(t) {
      var e = t.eventNamePrefix,
          r = t.messageId,
          n = t.errorMessage,
          i = t.handleErrorMessage,
          o = t.sourceSelected,
          a = t.handleSourceSelected,
          c = dt(),
          l = c.sources,
          h = c.isLoading,
          d = c.filterSources,
          f = h ? [ft, pt] : [].concat(Object(lt.a)(l), [pt]);
      return u.a.createElement(u.a.Fragment, null, u.a.createElement(s.Flex, {
        direction: "column",
        fullWidth: !0,
        gap: 2
      }, u.a.createElement(s.Header, {
        variant: "h3"
      }, "Specify a source"), u.a.createElement(s.Select, {
        size: "fullWidth",
        label: "New source",
        placeholder: "Search for a URL or term...",
        options: f,
        value: o,
        onChange: function handleSelectChange(t) {
          var o;

          if (t) {
            if ("SELECT_ACTION" === t.value) return a(void 0), H("".concat(e, "_response_add_content_clicked"), {
              message_id: r
            }), void window.open("".concat(v.APP_URL, "/content-management/library"), "_blank");
            n && i("");
            var s = null === l || void 0 === l ? void 0 : null === (o = l.find(function (e) {
              return e.id === t.id;
            })) || void 0 === o ? void 0 : o.documentId;
            s && a(Object(g.a)(Object(g.a)({}, t), {}, {
              id: s
            }));
          }
        },
        onInputChange: function onInputChange(t) {
          return d({
            searchTerm: t
          });
        },
        error: n,
        filterOption: function filterOption(t, e) {
          var r, n, i, o;
          return "SELECT_ACTION" === (null === t || void 0 === t ? void 0 : t.value) || "LOADER" === (null === t || void 0 === t ? void 0 : t.value) || "".concat(null !== (r = null === t || void 0 === t ? void 0 : t.label) && void 0 !== r ? r : "", " ").concat(null !== (n = null === (i = t) || void 0 === i ? void 0 : i.description) && void 0 !== n ? n : "", " ").concat(null !== (o = null === t || void 0 === t ? void 0 : t.value) && void 0 !== o ? o : "").toLowerCase().includes(e.toLowerCase());
        },
        allowResetValueWhenValueIsFalsy: !0,
        onKeyDown: function handleKeyDown(t) {
          t && "Enter" === t.key && h && t.preventDefault();
        }
      })));
    },
        gt = r(10),
        mt = r(11),
        vt = r(6),
        bt = r(9);

    function isArray(t) {
      return Array.isArray ? Array.isArray(t) : "[object Array]" === getTag(t);
    }

    var xt = 1 / 0;

    function fuse_esm_toString(t) {
      return null == t ? "" : function baseToString(t) {
        if ("string" == typeof t) return t;
        var e = t + "";
        return "0" == e && 1 / t == -xt ? "-0" : e;
      }(t);
    }

    function isString(t) {
      return "string" === typeof t;
    }

    function isNumber(t) {
      return "number" === typeof t;
    }

    function isBoolean(t) {
      return !0 === t || !1 === t || function isObjectLike(t) {
        return isObject(t) && null !== t;
      }(t) && "[object Boolean]" == getTag(t);
    }

    function isObject(t) {
      return "object" === typeof t;
    }

    function isDefined(t) {
      return void 0 !== t && null !== t;
    }

    function isBlank(t) {
      return !t.trim().length;
    }

    function getTag(t) {
      return null == t ? void 0 === t ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(t);
    }

    var wt = function LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(t) {
      return "Invalid value for key ".concat(t);
    },
        St = function PATTERN_LENGTH_TOO_LARGE(t) {
      return "Pattern length exceeds max of ".concat(t, ".");
    },
        Ot = function MISSING_KEY_PROPERTY(t) {
      return "Missing ".concat(t, " property in key");
    },
        Et = function INVALID_KEY_WEIGHT_VALUE(t) {
      return "Property 'weight' in key '".concat(t, "' must be a positive integer");
    },
        kt = Object.prototype.hasOwnProperty,
        _t = function () {
      function KeyStore(t) {
        var e = this;
        Object(vt.a)(this, KeyStore), this._keys = [], this._keyMap = {};
        var r = 0;
        t.forEach(function (t) {
          var n = createKey(t);
          r += n.weight, e._keys.push(n), e._keyMap[n.id] = n, r += n.weight;
        }), this._keys.forEach(function (t) {
          t.weight /= r;
        });
      }

      return Object(bt.a)(KeyStore, [{
        key: "get",
        value: function get(t) {
          return this._keyMap[t];
        }
      }, {
        key: "keys",
        value: function keys() {
          return this._keys;
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          return JSON.stringify(this._keys);
        }
      }]), KeyStore;
    }();

    function createKey(t) {
      var e = null,
          r = null,
          n = null,
          i = 1,
          o = null;
      if (isString(t) || isArray(t)) n = t, e = createKeyPath(t), r = createKeyId(t);else {
        if (!kt.call(t, "name")) throw new Error(Ot("name"));
        var a = t.name;
        if (n = a, kt.call(t, "weight") && (i = t.weight) <= 0) throw new Error(Et(a));
        e = createKeyPath(a), r = createKeyId(a), o = t.getFn;
      }
      return {
        path: e,
        id: r,
        weight: i,
        src: n,
        getFn: o
      };
    }

    function createKeyPath(t) {
      return isArray(t) ? t : t.split(".");
    }

    function createKeyId(t) {
      return isArray(t) ? t.join(".") : t;
    }

    var Ct = {
      useExtendedSearch: !1,
      getFn: function get(t, e) {
        var r = [],
            n = !1;
        return function deepGet(t, e, i) {
          if (isDefined(t)) if (e[i]) {
            var o = t[e[i]];
            if (!isDefined(o)) return;
            if (i === e.length - 1 && (isString(o) || isNumber(o) || isBoolean(o))) r.push(fuse_esm_toString(o));else if (isArray(o)) {
              n = !0;

              for (var a = 0, s = o.length; a < s; a += 1) {
                deepGet(o[a], e, i + 1);
              }
            } else e.length && deepGet(o, e, i + 1);
          } else r.push(t);
        }(t, isString(e) ? e.split(".") : e, 0), n ? r : r[0];
      },
      ignoreLocation: !1,
      ignoreFieldNorm: !1,
      fieldNormWeight: 1
    },
        Tt = Object(g.a)(Object(g.a)(Object(g.a)(Object(g.a)({}, {
      isCaseSensitive: !1,
      includeScore: !1,
      keys: [],
      shouldSort: !0,
      sortFn: function sortFn(t, e) {
        return t.score === e.score ? t.idx < e.idx ? -1 : 1 : t.score < e.score ? -1 : 1;
      }
    }), {
      includeMatches: !1,
      findAllMatches: !1,
      minMatchCharLength: 1
    }), {
      location: 0,
      threshold: .6,
      distance: 100
    }), Ct),
        At = /[^ ]+/g;

    var Mt = function () {
      function FuseIndex() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = t.getFn,
            r = void 0 === e ? Tt.getFn : e,
            n = t.fieldNormWeight,
            i = void 0 === n ? Tt.fieldNormWeight : n;
        Object(vt.a)(this, FuseIndex), this.norm = function norm() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
              e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 3,
              r = new Map(),
              n = Math.pow(10, e);
          return {
            get: function get(e) {
              var i = e.match(At).length;
              if (r.has(i)) return r.get(i);
              var o = 1 / Math.pow(i, .5 * t),
                  a = parseFloat(Math.round(o * n) / n);
              return r.set(i, a), a;
            },
            clear: function clear() {
              r.clear();
            }
          };
        }(i, 3), this.getFn = r, this.isCreated = !1, this.setIndexRecords();
      }

      return Object(bt.a)(FuseIndex, [{
        key: "setSources",
        value: function setSources() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
          this.docs = t;
        }
      }, {
        key: "setIndexRecords",
        value: function setIndexRecords() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
          this.records = t;
        }
      }, {
        key: "setKeys",
        value: function setKeys() {
          var t = this,
              e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
          this.keys = e, this._keysMap = {}, e.forEach(function (e, r) {
            t._keysMap[e.id] = r;
          });
        }
      }, {
        key: "create",
        value: function create() {
          var t = this;
          !this.isCreated && this.docs.length && (this.isCreated = !0, isString(this.docs[0]) ? this.docs.forEach(function (e, r) {
            t._addString(e, r);
          }) : this.docs.forEach(function (e, r) {
            t._addObject(e, r);
          }), this.norm.clear());
        }
      }, {
        key: "add",
        value: function add(t) {
          var e = this.size();
          isString(t) ? this._addString(t, e) : this._addObject(t, e);
        }
      }, {
        key: "removeAt",
        value: function removeAt(t) {
          this.records.splice(t, 1);

          for (var e = t, r = this.size(); e < r; e += 1) {
            this.records[e].i -= 1;
          }
        }
      }, {
        key: "getValueForItemAtKeyId",
        value: function getValueForItemAtKeyId(t, e) {
          return t[this._keysMap[e]];
        }
      }, {
        key: "size",
        value: function size() {
          return this.records.length;
        }
      }, {
        key: "_addString",
        value: function _addString(t, e) {
          if (isDefined(t) && !isBlank(t)) {
            var r = {
              v: t,
              i: e,
              n: this.norm.get(t)
            };
            this.records.push(r);
          }
        }
      }, {
        key: "_addObject",
        value: function _addObject(t, e) {
          var r = this,
              n = {
            i: e,
            $: {}
          };
          this.keys.forEach(function (e, i) {
            var o = e.getFn ? e.getFn(t) : r.getFn(t, e.path);
            if (isDefined(o)) if (isArray(o)) !function () {
              for (var t = [], e = [{
                nestedArrIndex: -1,
                value: o
              }]; e.length;) {
                var a = e.pop(),
                    s = a.nestedArrIndex,
                    c = a.value;
                if (isDefined(c)) if (isString(c) && !isBlank(c)) {
                  var l = {
                    v: c,
                    i: s,
                    n: r.norm.get(c)
                  };
                  t.push(l);
                } else isArray(c) && c.forEach(function (t, r) {
                  e.push({
                    nestedArrIndex: r,
                    value: t
                  });
                });
              }

              n.$[i] = t;
            }();else if (isString(o) && !isBlank(o)) {
              var a = {
                v: o,
                n: r.norm.get(o)
              };
              n.$[i] = a;
            }
          }), this.records.push(n);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          return {
            keys: this.keys,
            records: this.records
          };
        }
      }]), FuseIndex;
    }();

    function createIndex(t, e) {
      var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          n = r.getFn,
          i = void 0 === n ? Tt.getFn : n,
          o = r.fieldNormWeight,
          a = void 0 === o ? Tt.fieldNormWeight : o,
          s = new Mt({
        getFn: i,
        fieldNormWeight: a
      });
      return s.setKeys(t.map(createKey)), s.setSources(e), s.create(), s;
    }

    function computeScore$1(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = e.errors,
          n = void 0 === r ? 0 : r,
          i = e.currentLocation,
          o = void 0 === i ? 0 : i,
          a = e.expectedLocation,
          s = void 0 === a ? 0 : a,
          c = e.distance,
          l = void 0 === c ? Tt.distance : c,
          u = e.ignoreLocation,
          h = void 0 === u ? Tt.ignoreLocation : u,
          d = n / t.length;
      if (h) return d;
      var f = Math.abs(s - o);
      return l ? d + f / l : f ? 1 : d;
    }

    var Pt = 32;

    function fuse_esm_search(t, e, r) {
      var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
          i = n.location,
          o = void 0 === i ? Tt.location : i,
          a = n.distance,
          s = void 0 === a ? Tt.distance : a,
          c = n.threshold,
          l = void 0 === c ? Tt.threshold : c,
          u = n.findAllMatches,
          h = void 0 === u ? Tt.findAllMatches : u,
          d = n.minMatchCharLength,
          f = void 0 === d ? Tt.minMatchCharLength : d,
          p = n.includeMatches,
          y = void 0 === p ? Tt.includeMatches : p,
          g = n.ignoreLocation,
          m = void 0 === g ? Tt.ignoreLocation : g;
      if (e.length > Pt) throw new Error(St(Pt));

      for (var v, b = e.length, x = t.length, w = Math.max(0, Math.min(o, x)), S = l, O = w, E = f > 1 || y, k = E ? Array(x) : []; (v = t.indexOf(e, O)) > -1;) {
        var _ = computeScore$1(e, {
          currentLocation: v,
          expectedLocation: w,
          distance: s,
          ignoreLocation: m
        });

        if (S = Math.min(_, S), O = v + b, E) for (var C = 0; C < b;) {
          k[v + C] = 1, C += 1;
        }
      }

      O = -1;

      for (var T = [], A = 1, M = b + x, P = 1 << b - 1, j = 0; j < b; j += 1) {
        for (var R = 0, D = M; R < D;) {
          computeScore$1(e, {
            errors: j,
            currentLocation: w + D,
            expectedLocation: w,
            distance: s,
            ignoreLocation: m
          }) <= S ? R = D : M = D, D = Math.floor((M - R) / 2 + R);
        }

        M = D;
        var I = Math.max(1, w - D + 1),
            L = h ? x : Math.min(w + D, x) + b,
            N = Array(L + 2);
        N[L + 1] = (1 << j) - 1;

        for (var B = L; B >= I; B -= 1) {
          var F = B - 1,
              U = r[t.charAt(F)];

          if (E && (k[F] = +!!U), N[B] = (N[B + 1] << 1 | 1) & U, j && (N[B] |= (T[B + 1] | T[B]) << 1 | 1 | T[B + 1]), N[B] & P && (A = computeScore$1(e, {
            errors: j,
            currentLocation: F,
            expectedLocation: w,
            distance: s,
            ignoreLocation: m
          })) <= S) {
            if (S = A, (O = F) <= w) break;
            I = Math.max(1, 2 * w - O);
          }
        }

        if (computeScore$1(e, {
          errors: j + 1,
          currentLocation: w,
          expectedLocation: w,
          distance: s,
          ignoreLocation: m
        }) > S) break;
        T = N;
      }

      var W = {
        isMatch: O >= 0,
        score: Math.max(.001, A)
      };

      if (E) {
        var z = function convertMaskToIndices() {
          for (var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Tt.minMatchCharLength, r = [], n = -1, i = -1, o = 0, a = t.length; o < a; o += 1) {
            var s = t[o];
            s && -1 === n ? n = o : s || -1 === n || ((i = o - 1) - n + 1 >= e && r.push([n, i]), n = -1);
          }

          return t[o - 1] && o - n >= e && r.push([n, o - 1]), r;
        }(k, f);

        z.length ? y && (W.indices = z) : W.isMatch = !1;
      }

      return W;
    }

    function createPatternAlphabet(t) {
      for (var e = {}, r = 0, n = t.length; r < n; r += 1) {
        var i = t.charAt(r);
        e[i] = (e[i] || 0) | 1 << n - r - 1;
      }

      return e;
    }

    var jt = function () {
      function BitapSearch(t) {
        var e = this,
            r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = r.location,
            i = void 0 === n ? Tt.location : n,
            o = r.threshold,
            a = void 0 === o ? Tt.threshold : o,
            s = r.distance,
            c = void 0 === s ? Tt.distance : s,
            l = r.includeMatches,
            u = void 0 === l ? Tt.includeMatches : l,
            h = r.findAllMatches,
            d = void 0 === h ? Tt.findAllMatches : h,
            f = r.minMatchCharLength,
            p = void 0 === f ? Tt.minMatchCharLength : f,
            y = r.isCaseSensitive,
            g = void 0 === y ? Tt.isCaseSensitive : y,
            m = r.ignoreLocation,
            v = void 0 === m ? Tt.ignoreLocation : m;

        if (Object(vt.a)(this, BitapSearch), this.options = {
          location: i,
          threshold: a,
          distance: c,
          includeMatches: u,
          findAllMatches: d,
          minMatchCharLength: p,
          isCaseSensitive: g,
          ignoreLocation: v
        }, this.pattern = g ? t : t.toLowerCase(), this.chunks = [], this.pattern.length) {
          var b = function addChunk(t, r) {
            e.chunks.push({
              pattern: t,
              alphabet: createPatternAlphabet(t),
              startIndex: r
            });
          },
              x = this.pattern.length;

          if (x > Pt) {
            for (var w = 0, S = x % Pt, O = x - S; w < O;) {
              b(this.pattern.substr(w, Pt), w), w += Pt;
            }

            if (S) {
              var E = x - Pt;
              b(this.pattern.substr(E), E);
            }
          } else b(this.pattern, 0);
        }
      }

      return Object(bt.a)(BitapSearch, [{
        key: "searchIn",
        value: function searchIn(t) {
          var e = this.options,
              r = e.isCaseSensitive,
              n = e.includeMatches;

          if (r || (t = t.toLowerCase()), this.pattern === t) {
            var i = {
              isMatch: !0,
              score: 0
            };
            return n && (i.indices = [[0, t.length - 1]]), i;
          }

          var o = this.options,
              a = o.location,
              s = o.distance,
              c = o.threshold,
              l = o.findAllMatches,
              u = o.minMatchCharLength,
              h = o.ignoreLocation,
              d = [],
              f = 0,
              p = !1;
          this.chunks.forEach(function (e) {
            var r = e.pattern,
                i = e.alphabet,
                o = e.startIndex,
                y = fuse_esm_search(t, r, i, {
              location: a + o,
              distance: s,
              threshold: c,
              findAllMatches: l,
              minMatchCharLength: u,
              includeMatches: n,
              ignoreLocation: h
            }),
                g = y.isMatch,
                m = y.score,
                v = y.indices;
            g && (p = !0), f += m, g && v && (d = [].concat(Object(lt.a)(d), Object(lt.a)(v)));
          });
          var y = {
            isMatch: p,
            score: p ? f / this.chunks.length : 1
          };
          return p && n && (y.indices = d), y;
        }
      }]), BitapSearch;
    }(),
        Rt = function () {
      function BaseMatch(t) {
        Object(vt.a)(this, BaseMatch), this.pattern = t;
      }

      return Object(bt.a)(BaseMatch, [{
        key: "search",
        value: function search() {}
      }], [{
        key: "isMultiMatch",
        value: function isMultiMatch(t) {
          return getMatch(t, this.multiRegex);
        }
      }, {
        key: "isSingleMatch",
        value: function isSingleMatch(t) {
          return getMatch(t, this.singleRegex);
        }
      }]), BaseMatch;
    }();

    function getMatch(t, e) {
      var r = t.match(e);
      return r ? r[1] : null;
    }

    var Dt = function (t) {
      Object(gt.a)(ExactMatch, t);
      var e = Object(mt.a)(ExactMatch);

      function ExactMatch(t) {
        return Object(vt.a)(this, ExactMatch), e.call(this, t);
      }

      return Object(bt.a)(ExactMatch, [{
        key: "search",
        value: function search(t) {
          var e = t === this.pattern;
          return {
            isMatch: e,
            score: e ? 0 : 1,
            indices: [0, this.pattern.length - 1]
          };
        }
      }], [{
        key: "type",
        get: function get() {
          return "exact";
        }
      }, {
        key: "multiRegex",
        get: function get() {
          return /^="(.*)"$/;
        }
      }, {
        key: "singleRegex",
        get: function get() {
          return /^=(.*)$/;
        }
      }]), ExactMatch;
    }(Rt),
        It = function (t) {
      Object(gt.a)(InverseExactMatch, t);
      var e = Object(mt.a)(InverseExactMatch);

      function InverseExactMatch(t) {
        return Object(vt.a)(this, InverseExactMatch), e.call(this, t);
      }

      return Object(bt.a)(InverseExactMatch, [{
        key: "search",
        value: function search(t) {
          var e = -1 === t.indexOf(this.pattern);
          return {
            isMatch: e,
            score: e ? 0 : 1,
            indices: [0, t.length - 1]
          };
        }
      }], [{
        key: "type",
        get: function get() {
          return "inverse-exact";
        }
      }, {
        key: "multiRegex",
        get: function get() {
          return /^!"(.*)"$/;
        }
      }, {
        key: "singleRegex",
        get: function get() {
          return /^!(.*)$/;
        }
      }]), InverseExactMatch;
    }(Rt),
        Lt = function (t) {
      Object(gt.a)(PrefixExactMatch, t);
      var e = Object(mt.a)(PrefixExactMatch);

      function PrefixExactMatch(t) {
        return Object(vt.a)(this, PrefixExactMatch), e.call(this, t);
      }

      return Object(bt.a)(PrefixExactMatch, [{
        key: "search",
        value: function search(t) {
          var e = t.startsWith(this.pattern);
          return {
            isMatch: e,
            score: e ? 0 : 1,
            indices: [0, this.pattern.length - 1]
          };
        }
      }], [{
        key: "type",
        get: function get() {
          return "prefix-exact";
        }
      }, {
        key: "multiRegex",
        get: function get() {
          return /^\^"(.*)"$/;
        }
      }, {
        key: "singleRegex",
        get: function get() {
          return /^\^(.*)$/;
        }
      }]), PrefixExactMatch;
    }(Rt),
        Nt = function (t) {
      Object(gt.a)(InversePrefixExactMatch, t);
      var e = Object(mt.a)(InversePrefixExactMatch);

      function InversePrefixExactMatch(t) {
        return Object(vt.a)(this, InversePrefixExactMatch), e.call(this, t);
      }

      return Object(bt.a)(InversePrefixExactMatch, [{
        key: "search",
        value: function search(t) {
          var e = !t.startsWith(this.pattern);
          return {
            isMatch: e,
            score: e ? 0 : 1,
            indices: [0, t.length - 1]
          };
        }
      }], [{
        key: "type",
        get: function get() {
          return "inverse-prefix-exact";
        }
      }, {
        key: "multiRegex",
        get: function get() {
          return /^!\^"(.*)"$/;
        }
      }, {
        key: "singleRegex",
        get: function get() {
          return /^!\^(.*)$/;
        }
      }]), InversePrefixExactMatch;
    }(Rt),
        Bt = function (t) {
      Object(gt.a)(SuffixExactMatch, t);
      var e = Object(mt.a)(SuffixExactMatch);

      function SuffixExactMatch(t) {
        return Object(vt.a)(this, SuffixExactMatch), e.call(this, t);
      }

      return Object(bt.a)(SuffixExactMatch, [{
        key: "search",
        value: function search(t) {
          var e = t.endsWith(this.pattern);
          return {
            isMatch: e,
            score: e ? 0 : 1,
            indices: [t.length - this.pattern.length, t.length - 1]
          };
        }
      }], [{
        key: "type",
        get: function get() {
          return "suffix-exact";
        }
      }, {
        key: "multiRegex",
        get: function get() {
          return /^"(.*)"\$$/;
        }
      }, {
        key: "singleRegex",
        get: function get() {
          return /^(.*)\$$/;
        }
      }]), SuffixExactMatch;
    }(Rt),
        Ft = function (t) {
      Object(gt.a)(InverseSuffixExactMatch, t);
      var e = Object(mt.a)(InverseSuffixExactMatch);

      function InverseSuffixExactMatch(t) {
        return Object(vt.a)(this, InverseSuffixExactMatch), e.call(this, t);
      }

      return Object(bt.a)(InverseSuffixExactMatch, [{
        key: "search",
        value: function search(t) {
          var e = !t.endsWith(this.pattern);
          return {
            isMatch: e,
            score: e ? 0 : 1,
            indices: [0, t.length - 1]
          };
        }
      }], [{
        key: "type",
        get: function get() {
          return "inverse-suffix-exact";
        }
      }, {
        key: "multiRegex",
        get: function get() {
          return /^!"(.*)"\$$/;
        }
      }, {
        key: "singleRegex",
        get: function get() {
          return /^!(.*)\$$/;
        }
      }]), InverseSuffixExactMatch;
    }(Rt),
        Ut = function (t) {
      Object(gt.a)(FuzzyMatch, t);
      var e = Object(mt.a)(FuzzyMatch);

      function FuzzyMatch(t) {
        var r,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            i = n.location,
            o = void 0 === i ? Tt.location : i,
            a = n.threshold,
            s = void 0 === a ? Tt.threshold : a,
            c = n.distance,
            l = void 0 === c ? Tt.distance : c,
            u = n.includeMatches,
            h = void 0 === u ? Tt.includeMatches : u,
            d = n.findAllMatches,
            f = void 0 === d ? Tt.findAllMatches : d,
            p = n.minMatchCharLength,
            y = void 0 === p ? Tt.minMatchCharLength : p,
            g = n.isCaseSensitive,
            m = void 0 === g ? Tt.isCaseSensitive : g,
            v = n.ignoreLocation,
            b = void 0 === v ? Tt.ignoreLocation : v;
        return Object(vt.a)(this, FuzzyMatch), (r = e.call(this, t))._bitapSearch = new jt(t, {
          location: o,
          threshold: s,
          distance: l,
          includeMatches: h,
          findAllMatches: f,
          minMatchCharLength: y,
          isCaseSensitive: m,
          ignoreLocation: b
        }), r;
      }

      return Object(bt.a)(FuzzyMatch, [{
        key: "search",
        value: function search(t) {
          return this._bitapSearch.searchIn(t);
        }
      }], [{
        key: "type",
        get: function get() {
          return "fuzzy";
        }
      }, {
        key: "multiRegex",
        get: function get() {
          return /^"(.*)"$/;
        }
      }, {
        key: "singleRegex",
        get: function get() {
          return /^(.*)$/;
        }
      }]), FuzzyMatch;
    }(Rt),
        Wt = function (t) {
      Object(gt.a)(IncludeMatch, t);
      var e = Object(mt.a)(IncludeMatch);

      function IncludeMatch(t) {
        return Object(vt.a)(this, IncludeMatch), e.call(this, t);
      }

      return Object(bt.a)(IncludeMatch, [{
        key: "search",
        value: function search(t) {
          for (var e, r = 0, n = [], i = this.pattern.length; (e = t.indexOf(this.pattern, r)) > -1;) {
            r = e + i, n.push([e, r - 1]);
          }

          var o = !!n.length;
          return {
            isMatch: o,
            score: o ? 0 : 1,
            indices: n
          };
        }
      }], [{
        key: "type",
        get: function get() {
          return "include";
        }
      }, {
        key: "multiRegex",
        get: function get() {
          return /^'"(.*)"$/;
        }
      }, {
        key: "singleRegex",
        get: function get() {
          return /^'(.*)$/;
        }
      }]), IncludeMatch;
    }(Rt),
        zt = [Dt, Wt, Lt, Nt, Ft, Bt, It, Ut],
        qt = zt.length,
        Ht = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/,
        Gt = "|";

    var Yt = new Set([Ut.type, Wt.type]),
        Xt = function () {
      function ExtendedSearch(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = e.isCaseSensitive,
            n = void 0 === r ? Tt.isCaseSensitive : r,
            i = e.includeMatches,
            o = void 0 === i ? Tt.includeMatches : i,
            a = e.minMatchCharLength,
            s = void 0 === a ? Tt.minMatchCharLength : a,
            c = e.ignoreLocation,
            l = void 0 === c ? Tt.ignoreLocation : c,
            u = e.findAllMatches,
            h = void 0 === u ? Tt.findAllMatches : u,
            d = e.location,
            f = void 0 === d ? Tt.location : d,
            p = e.threshold,
            y = void 0 === p ? Tt.threshold : p,
            g = e.distance,
            m = void 0 === g ? Tt.distance : g;
        Object(vt.a)(this, ExtendedSearch), this.query = null, this.options = {
          isCaseSensitive: n,
          includeMatches: o,
          minMatchCharLength: s,
          findAllMatches: h,
          ignoreLocation: l,
          location: f,
          threshold: y,
          distance: m
        }, this.pattern = n ? t : t.toLowerCase(), this.query = function parseQuery(t) {
          var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return t.split(Gt).map(function (t) {
            for (var r = t.trim().split(Ht).filter(function (t) {
              return t && !!t.trim();
            }), n = [], i = 0, o = r.length; i < o; i += 1) {
              for (var a = r[i], s = !1, c = -1; !s && ++c < qt;) {
                var l = zt[c],
                    u = l.isMultiMatch(a);
                u && (n.push(new l(u, e)), s = !0);
              }

              if (!s) for (c = -1; ++c < qt;) {
                var h = zt[c],
                    d = h.isSingleMatch(a);

                if (d) {
                  n.push(new h(d, e));
                  break;
                }
              }
            }

            return n;
          });
        }(this.pattern, this.options);
      }

      return Object(bt.a)(ExtendedSearch, [{
        key: "searchIn",
        value: function searchIn(t) {
          var e = this.query;
          if (!e) return {
            isMatch: !1,
            score: 1
          };
          var r = this.options,
              n = r.includeMatches;
          t = r.isCaseSensitive ? t : t.toLowerCase();

          for (var i = 0, o = [], a = 0, s = 0, c = e.length; s < c; s += 1) {
            var l = e[s];
            o.length = 0, i = 0;

            for (var u = 0, h = l.length; u < h; u += 1) {
              var d = l[u],
                  f = d.search(t),
                  p = f.isMatch,
                  y = f.indices,
                  g = f.score;

              if (!p) {
                a = 0, i = 0, o.length = 0;
                break;
              }

              if (i += 1, a += g, n) {
                var m = d.constructor.type;
                Yt.has(m) ? o = [].concat(Object(lt.a)(o), Object(lt.a)(y)) : o.push(y);
              }
            }

            if (i) {
              var v = {
                isMatch: !0,
                score: a / i
              };
              return n && (v.indices = o), v;
            }
          }

          return {
            isMatch: !1,
            score: 1
          };
        }
      }], [{
        key: "condition",
        value: function condition(t, e) {
          return e.useExtendedSearch;
        }
      }]), ExtendedSearch;
    }(),
        Vt = [];

    function createSearcher(t, e) {
      for (var r = 0, n = Vt.length; r < n; r += 1) {
        var i = Vt[r];
        if (i.condition(t, e)) return new i(t, e);
      }

      return new jt(t, e);
    }

    var $t = "$and",
        Qt = "$or",
        Kt = {
      PATH: "$path",
      PATTERN: "$val"
    },
        Zt = function isExpression(t) {
      return !(!t[$t] && !t[Qt]);
    },
        Jt = function isPath(t) {
      return !!t[Kt.PATH];
    },
        te = function isLeaf(t) {
      return !isArray(t) && isObject(t) && !Zt(t);
    },
        ee = function convertToExplicit(t) {
      return Object(S.a)({}, $t, Object.keys(t).map(function (e) {
        return Object(S.a)({}, e, t[e]);
      }));
    };

    function parse(t, e) {
      var r = (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}).auto,
          n = void 0 === r || r;
      return Zt(t) || (t = ee(t)), function next(t) {
        var r = Object.keys(t),
            i = Jt(t);
        if (!i && r.length > 1 && !Zt(t)) return next(ee(t));

        if (te(t)) {
          var o = i ? t[Kt.PATH] : r[0],
              a = i ? t[Kt.PATTERN] : t[o];
          if (!isString(a)) throw new Error(wt(o));
          var s = {
            keyId: createKeyId(o),
            pattern: a
          };
          return n && (s.searcher = createSearcher(a, e)), s;
        }

        var c = {
          children: [],
          operator: r[0]
        };
        return r.forEach(function (e) {
          var r = t[e];
          isArray(r) && r.forEach(function (t) {
            c.children.push(next(t));
          });
        }), c;
      }(t);
    }

    function transformMatches(t, e) {
      var r = t.matches;
      e.matches = [], isDefined(r) && r.forEach(function (t) {
        if (isDefined(t.indices) && t.indices.length) {
          var r = {
            indices: t.indices,
            value: t.value
          };
          t.key && (r.key = t.key.src), t.idx > -1 && (r.refIndex = t.idx), e.matches.push(r);
        }
      });
    }

    function transformScore(t, e) {
      e.score = t.score;
    }

    var re = function () {
      function Fuse(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = arguments.length > 2 ? arguments[2] : void 0;
        Object(vt.a)(this, Fuse), this.options = Object(g.a)(Object(g.a)({}, Tt), e), this.options.useExtendedSearch, this._keyStore = new _t(this.options.keys), this.setCollection(t, r);
      }

      return Object(bt.a)(Fuse, [{
        key: "setCollection",
        value: function setCollection(t, e) {
          if (this._docs = t, e && !(e instanceof Mt)) throw new Error("Incorrect 'index' type");
          this._myIndex = e || createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
          });
        }
      }, {
        key: "add",
        value: function add(t) {
          isDefined(t) && (this._docs.push(t), this._myIndex.add(t));
        }
      }, {
        key: "remove",
        value: function remove() {
          for (var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : function () {
            return !1;
          }, e = [], r = 0, n = this._docs.length; r < n; r += 1) {
            var i = this._docs[r];
            t(i, r) && (this.removeAt(r), r -= 1, n -= 1, e.push(i));
          }

          return e;
        }
      }, {
        key: "removeAt",
        value: function removeAt(t) {
          this._docs.splice(t, 1), this._myIndex.removeAt(t);
        }
      }, {
        key: "getIndex",
        value: function getIndex() {
          return this._myIndex;
        }
      }, {
        key: "search",
        value: function search(t) {
          var e = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).limit,
              r = void 0 === e ? -1 : e,
              n = this.options,
              i = n.includeMatches,
              o = n.includeScore,
              a = n.shouldSort,
              s = n.sortFn,
              c = n.ignoreFieldNorm,
              l = isString(t) ? isString(this._docs[0]) ? this._searchStringList(t) : this._searchObjectList(t) : this._searchLogical(t);
          return function computeScore(t, e) {
            var r = e.ignoreFieldNorm,
                n = void 0 === r ? Tt.ignoreFieldNorm : r;
            t.forEach(function (t) {
              var e = 1;
              t.matches.forEach(function (t) {
                var r = t.key,
                    i = t.norm,
                    o = t.score,
                    a = r ? r.weight : null;
                e *= Math.pow(0 === o && a ? Number.EPSILON : o, (a || 1) * (n ? 1 : i));
              }), t.score = e;
            });
          }(l, {
            ignoreFieldNorm: c
          }), a && l.sort(s), isNumber(r) && r > -1 && (l = l.slice(0, r)), function format(t, e) {
            var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                n = r.includeMatches,
                i = void 0 === n ? Tt.includeMatches : n,
                o = r.includeScore,
                a = void 0 === o ? Tt.includeScore : o,
                s = [];
            return i && s.push(transformMatches), a && s.push(transformScore), t.map(function (t) {
              var r = t.idx,
                  n = {
                item: e[r],
                refIndex: r
              };
              return s.length && s.forEach(function (e) {
                e(t, n);
              }), n;
            });
          }(l, this._docs, {
            includeMatches: i,
            includeScore: o
          });
        }
      }, {
        key: "_searchStringList",
        value: function _searchStringList(t) {
          var e = createSearcher(t, this.options),
              r = this._myIndex.records,
              n = [];
          return r.forEach(function (t) {
            var r = t.v,
                i = t.i,
                o = t.n;

            if (isDefined(r)) {
              var a = e.searchIn(r),
                  s = a.isMatch,
                  c = a.score,
                  l = a.indices;
              s && n.push({
                item: r,
                idx: i,
                matches: [{
                  score: c,
                  value: r,
                  norm: o,
                  indices: l
                }]
              });
            }
          }), n;
        }
      }, {
        key: "_searchLogical",
        value: function _searchLogical(t) {
          var e = this,
              r = parse(t, this.options),
              n = this._myIndex.records,
              i = {},
              o = [];
          return n.forEach(function (t) {
            var n = t.$,
                a = t.i;

            if (isDefined(n)) {
              var s = function evaluate(t, r, n) {
                if (!t.children) {
                  var i = t.keyId,
                      o = t.searcher,
                      a = e._findMatches({
                    key: e._keyStore.get(i),
                    value: e._myIndex.getValueForItemAtKeyId(r, i),
                    searcher: o
                  });

                  return a && a.length ? [{
                    idx: n,
                    item: r,
                    matches: a
                  }] : [];
                }

                for (var s = [], c = 0, l = t.children.length; c < l; c += 1) {
                  var u = evaluate(t.children[c], r, n);
                  if (u.length) s.push.apply(s, Object(lt.a)(u));else if (t.operator === $t) return [];
                }

                return s;
              }(r, n, a);

              s.length && (i[a] || (i[a] = {
                idx: a,
                item: n,
                matches: []
              }, o.push(i[a])), s.forEach(function (t) {
                var e,
                    r = t.matches;
                (e = i[a].matches).push.apply(e, Object(lt.a)(r));
              }));
            }
          }), o;
        }
      }, {
        key: "_searchObjectList",
        value: function _searchObjectList(t) {
          var e = this,
              r = createSearcher(t, this.options),
              n = this._myIndex,
              i = n.keys,
              o = n.records,
              a = [];
          return o.forEach(function (t) {
            var n = t.$,
                o = t.i;

            if (isDefined(n)) {
              var s = [];
              i.forEach(function (t, i) {
                s.push.apply(s, Object(lt.a)(e._findMatches({
                  key: t,
                  value: n[i],
                  searcher: r
                })));
              }), s.length && a.push({
                idx: o,
                item: n,
                matches: s
              });
            }
          }), a;
        }
      }, {
        key: "_findMatches",
        value: function _findMatches(t) {
          var e = t.key,
              r = t.value,
              n = t.searcher;
          if (!isDefined(r)) return [];
          var i = [];
          if (isArray(r)) r.forEach(function (t) {
            var r = t.v,
                o = t.i,
                a = t.n;

            if (isDefined(r)) {
              var s = n.searchIn(r),
                  c = s.isMatch,
                  l = s.score,
                  u = s.indices;
              c && i.push({
                score: l,
                key: e,
                value: r,
                idx: o,
                norm: a,
                indices: u
              });
            }
          });else {
            var o = r.v,
                a = r.n,
                s = n.searchIn(o),
                c = s.isMatch,
                l = s.score,
                u = s.indices;
            c && i.push({
              score: l,
              key: e,
              value: o,
              norm: a,
              indices: u
            });
          }
          return i;
        }
      }]), Fuse;
    }();

    re.version = "6.6.2", re.createIndex = createIndex, re.parseIndex = function parseIndex(t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = e.getFn,
          n = void 0 === r ? Tt.getFn : r,
          i = e.fieldNormWeight,
          o = void 0 === i ? Tt.fieldNormWeight : i,
          a = t.keys,
          s = t.records,
          c = new Mt({
        getFn: n,
        fieldNormWeight: o
      });
      return c.setKeys(a), c.setIndexRecords(s), c;
    }, re.config = Tt, re.parseQuery = parse, function register() {
      Vt.push.apply(Vt, arguments);
    }(Xt);

    var ne,
        ie = {
      label: u.a.createElement(s.Flex, {
        width: 370,
        alignItems: "center",
        justifyContent: "center"
      }, u.a.createElement(s.CircleLoader, {
        size: "medium"
      })),
      value: "LOADER",
      isDisabled: !0
    },
        oe = function SourcesAutocompleteV2(t) {
      var e = t.errorMessage,
          r = t.handleErrorMessage,
          n = t.sourceSelected,
          i = t.handleSourceSelected,
          o = t.allVertexUrls,
          a = t.isLoadingVertexUrls,
          c = Object(l.useState)(""),
          d = Object(h.a)(c, 2),
          f = d[0],
          p = d[1],
          y = ht(f, 500),
          g = null !== o && void 0 !== o ? o : [],
          m = Object(l.useMemo)(function () {
        if ("" === y) return g.slice(0, 100);
        var t = new re(g, {
          keys: ["label"],
          threshold: .3,
          shouldSort: !0
        }).search(y).map(function (t) {
          return t.item;
        }),
            e = t.filter(function (t) {
          return t.toLowerCase() === y.toLowerCase();
        }),
            r = t.filter(function (t) {
          return t.toLowerCase() !== y.toLowerCase();
        });
        return [].concat(Object(lt.a)(e), Object(lt.a)(r)).slice(0, 100);
      }, [y, g]),
          v = y !== f || a,
          b = v ? [ie] : function getOptionsFromSources(t) {
        return t.map(function (t) {
          return {
            label: t,
            value: t,
            description: "",
            id: ""
          };
        });
      }(m);
      return u.a.createElement(u.a.Fragment, null, u.a.createElement(s.Flex, {
        direction: "column",
        fullWidth: !0,
        gap: 2
      }, u.a.createElement(s.Header, {
        variant: "h3"
      }, "Specify a source"), u.a.createElement(s.Select, {
        size: "fullWidth",
        label: "New source",
        placeholder: "Search for a URL or term...",
        options: b,
        value: n,
        onChange: function handleSelectChange(t) {
          t && (e && r(""), i(t));
        },
        onInputChange: function onInputChange(t) {
          return p(t);
        },
        error: e,
        filterOption: function filterOption() {
          return !0;
        },
        allowResetValueWhenValueIsFalsy: !0,
        onKeyDown: function handleKeyDown(t) {
          t && "Enter" === t.key && v && t.preventDefault();
        }
      })));
    },
        ae = Object(s.styled)(s.Box, {
      borderRadius: "$round",
      background: "$gray7",
      position: "absolute",
      left: "-25px",
      transform: "translateX(-50%)",
      padding: "6px $1"
    }),
        se = function ChangeSourceModal(t) {
      var e,
          r = t.isOpen,
          n = t.onClose,
          i = t.message,
          o = t.onUpdateReview,
          a = t.onSwitchToRefine,
          f = t.allVertexUrls,
          p = t.isLoadingVertexUrls,
          y = Object(s.useToast)(),
          m = function userHasVertexSearch() {
        return st("vertex_search");
      }(),
          v = Object(l.useState)(""),
          x = Object(h.a)(v, 2),
          w = x[0],
          S = x[1],
          O = Object(l.useState)(void 0),
          E = Object(h.a)(O, 2),
          k = E[0],
          _ = E[1],
          C = Object(J.useSelector)(function (t) {
        return t.org.properties;
      }),
          T = L(),
          A = T.isBionic,
          M = T.setUpdatedSourceMessage,
          P = T.eventNamePrefix,
          j = u.a.useState(),
          R = Object(h.a)(j, 2),
          D = R[0],
          I = R[1],
          N = (null === D || void 0 === D ? void 0 : D.sourceTitle) || (null === k || void 0 === k ? void 0 : k.label) || "",
          B = Object(c.useMutation)(function (t) {
        return b.post("/improvement/".concat(i.orgId, "/generateReplyWithSource"), t);
      }, {
        onSuccess: function onSuccess(t) {
          var e,
              r,
              n,
              o = t.data;
          if (!o || !o.reply) return H("".concat(P, "_response_generation_failed"), {
            message_id: i.id
          }), void S(A ? "Question does not generate an answer. Try again, upload relevant content to your library, or refine the original response." : "Question does not generate an answer. Please try again or upload relevant content to your library.");
          H("".concat(P, "_response_generated"), {
            message_id: i.id
          }), I({
            reply: null !== (e = o.reply) && void 0 !== e ? e : "",
            sourceTitle: null !== (r = o.source_title) && void 0 !== r ? r : "",
            sourceUrl: null !== (n = o.source_url) && void 0 !== n ? n : ""
          });
        },
        onError: function onError(t) {
          y({
            variant: "error",
            message: "We couldn't generate a response. Please try again."
          });
        }
      }),
          F = B.isLoading,
          U = function () {
        var t = Object(Z.a)(K.a.mark(function _callee() {
          var t, e;
          return K.a.wrap(function _callee$(r) {
            for (;;) {
              switch (r.prev = r.next) {
                case 0:
                  if (t = !!(null === C || void 0 === C ? void 0 : C.AIResponsesMultilang), e = m ? null === k || void 0 === k ? void 0 : k.value : null === k || void 0 === k ? void 0 : k.id) {
                    r.next = 4;
                    break;
                  }

                  return r.abrupt("return");

                case 4:
                  B.mutate(Object(g.a)({
                    org_id: i.orgId,
                    prompt: i.prompt,
                    document_uuid: e,
                    conversation_id: i.conversationId,
                    message_id: i.id,
                    is_search: !0
                  }, A && {
                    multi_language: t,
                    is_search: !1
                  }));

                case 5:
                case "end":
                  return r.stop();
              }
            }
          }, _callee);
        }));
        return function handleGenerateResponse() {
          return t.apply(this, arguments);
        };
      }(),
          W = Object(c.useMutation)(function (t) {
        return b.post("/improvement/".concat(i.orgId, "/cacheResponse"), t);
      }, {
        onSuccess: function onSuccess() {
          var t,
              e = (null === k || void 0 === k ? void 0 : k.value) === (null === (t = i.references[0]) || void 0 === t ? void 0 : t.url);
          H("".concat(P, "_response_saved_for_future_inquiries"), {
            usedSameUrl: e,
            message_id: i.id
          });
        },
        onError: function onError() {
          console.error("error");
        }
      }),
          z = function () {
        var t = Object(Z.a)(K.a.mark(function _callee2() {
          var t;
          return K.a.wrap(function _callee2$(e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (D) {
                    e.next = 2;
                    break;
                  }

                  return e.abrupt("return");

                case 2:
                  return t = D.sourceUrl.startsWith("https://file2") ? "PDF" : "URL", e.next = 5, W.mutateAsync({
                    org_id: i.orgId,
                    messageId: i.id,
                    conversation_id: i.conversationId,
                    inquiry: i.prompt,
                    reply: D.reply,
                    source_url: D.sourceUrl,
                    source_title: N,
                    source_type: t
                  });

                case 5:
                  o({
                    newGeneratedResponse: null === D || void 0 === D ? void 0 : D.reply,
                    newSource: {
                      sourceUrl: D.sourceUrl,
                      sourceTitle: N,
                      sourceType: t
                    }
                  }), n(), M(at);

                case 8:
                case "end":
                  return e.stop();
              }
            }
          }, _callee2);
        }));
        return function handleUseUpdated() {
          return t.apply(this, arguments);
        };
      }(),
          q = m ? oe : yt;

      return u.a.createElement(s.Modal.Root, {
        open: r,
        onClose: n
      }, u.a.createElement(s.Modal.Dialog, {
        size: "x-large",
        variant: "info"
      }, u.a.createElement(s.Modal.Title, {
        title: "",
        subtitle: ""
      }), u.a.createElement(s.Modal.Content, {
        scrollOverflow: "inside",
        css: {
          padding: "0",
          minWidth: "889px",
          marginBottom: "-$3"
        }
      }, u.a.createElement(s.Separator, {
        color: "$gray4",
        orientation: "horizontal"
      }), u.a.createElement(s.SimpleGrid, {
        minChildWidth: 400
      }, u.a.createElement(s.Flex, {
        direction: "column",
        fullWidth: !0,
        gap: 2,
        css: {
          padding: "$2 $3 $0",
          background: "$gray2",
          borderRight: "1px solid $gray6"
        }
      }, u.a.createElement(s.Header, {
        variant: "h3"
      }, "Original response"), !Object(d.isNil)(null === i || void 0 === i ? void 0 : i.references) && u.a.createElement(s.Box, {
        fullWidth: !0
      }, u.a.createElement(s.Text, {
        variant: "metadata"
      }, "Original source"), i.references.map(function (t, e) {
        return u.a.createElement(s.Flex, {
          key: e,
          gap: "half",
          fullWidth: !0
        }, u.a.createElement(s.Icon, {
          css: {
            marginTop: "2px"
          },
          icon: rt.faGlobe
        }), u.a.createElement(s.Box, {
          key: e,
          fullWidth: !0
        }, u.a.createElement(s.Text, null, t.title), u.a.createElement(s.Link, {
          truncate: !0,
          variant: "inline",
          href: t.url
        }, t.url)));
      }))), u.a.createElement(s.Flex, {
        direction: "column",
        fullWidth: !0,
        gap: 1,
        css: {
          padding: "$2 $3 $0"
        }
      }, Object(d.isNil)(null === D || void 0 === D ? void 0 : D.reply) ? u.a.createElement(q, {
        eventNamePrefix: P,
        messageId: i.id,
        errorMessage: w,
        handleErrorMessage: S,
        sourceSelected: k,
        allVertexUrls: f,
        isLoadingVertexUrls: p,
        handleSourceSelected: _
      }) : u.a.createElement(s.Flex, {
        direction: "column",
        fullWidth: !0,
        gap: 2,
        css: {
          position: "relative"
        }
      }, u.a.createElement(s.Header, {
        variant: "h3"
      }, "New response"), u.a.createElement(s.Box, {
        fullWidth: !0
      }, u.a.createElement(s.Text, {
        variant: "metadata"
      }, "New source"), u.a.createElement(s.Text, {
        truncate: !0
      }, null === k || void 0 === k ? void 0 : k.label), !m && u.a.createElement(s.Text, {
        truncate: !0,
        variant: "metadata"
      }, null === k || void 0 === k ? void 0 : k.value), u.a.createElement(s.Text, {
        css: {
          color: "$blue7",
          cursor: "pointer"
        },
        onClick: function onClick() {
          _(void 0), I(null);
        }
      }, "Change source"), u.a.createElement(s.Separator, {
        css: {
          background: "linear-gradient(270deg, #FFFFFF 0%, #DFE4E8 100%)",
          marginTop: "$1",
          marginBottom: "$2"
        }
      })), u.a.createElement(ae, null, u.a.createElement(s.Icon, {
        icon: nt.faArrowRight,
        size: "large",
        color: "white"
      }))), Object(d.isNil)(null === D || void 0 === D ? void 0 : D.reply) && u.a.createElement(s.Flex, null, u.a.createElement(s.Button, {
        loading: F,
        disabled: Object(d.isNil)(k),
        onClick: U
      }, "Generate a response using this source"), A && u.a.createElement(s.IconButton, {
        variant: "education",
        title: "Refine original response",
        disabled: Object(d.isNil)(k),
        icon: it.faWrench,
        size: "default",
        onClick: function onClick(t) {
          t.stopPropagation(), a(void 0);
        }
      }))), u.a.createElement(s.Box, {
        css: {
          padding: "$0 $3 $2",
          background: "$gray2",
          borderRight: "1px solid $gray6"
        },
        fullWidth: !0
      }, u.a.createElement(s.Separator, {
        css: {
          background: "linear-gradient(270deg, #FFFFFF 0%, #DFE4E8 100%)",
          marginTop: "-17px",
          marginBottom: "$2"
        }
      }), u.a.createElement(ct, {
        customerInquiry: i.prompt,
        generatedResponse: i.response,
        avatarUrl: null === i || void 0 === i ? void 0 : i.avatarUrl
      })), Object(d.isNil)(null === D || void 0 === D ? void 0 : D.reply) ? null : u.a.createElement(s.Box, {
        css: {
          padding: "$0 $3 $2"
        }
      }, u.a.createElement(ct, {
        customerInquiry: i.prompt,
        generatedResponse: null !== (e = null === D || void 0 === D ? void 0 : D.reply) && void 0 !== e ? e : "",
        isGenerating: F,
        backgroundFill: !1,
        avatarUrl: null === i || void 0 === i ? void 0 : i.avatarUrl
      }), !F && u.a.createElement(s.Flex, {
        direction: "column",
        gap: 2,
        css: {
          marginTop: "$2"
        }
      }, u.a.createElement(s.Separator, {
        css: {
          background: "linear-gradient(270deg, #FFFFFF 0%, #DFE4E8 100%)"
        }
      }), u.a.createElement(s.Flex, null, u.a.createElement(s.Button, {
        loading: W.isLoading,
        disabled: Object(d.isNil)(k),
        onClick: z
      }, "Use this response for future inquiries"), u.a.createElement(s.IconButton, {
        variant: "education",
        title: "Regenerate",
        icon: et.faArrowsRotate,
        onClick: function onClick(t) {
          U(), t.stopPropagation();
        }
      }), A && u.a.createElement(s.IconButton, {
        variant: "education",
        title: "Refine response",
        icon: it.faWrench,
        size: "default",
        onClick: function onClick(t) {
          t.stopPropagation(), a(D ? {
            sourceTitle: N,
            sourceUrl: D.sourceUrl,
            generatedResponse: D.reply
          } : void 0);
        }
      }))))))));
    },
        ce = r(52),
        le = r.n(ce),
        ue = r(53),
        he = r(54),
        de = r.n(he),
        fe = (r(85), function RefineResponseModal(t) {
      var e,
          r = t.isOpen,
          n = t.onClose,
          i = t.message,
          o = t.newSource,
          a = t.onUpdateReview,
          f = Object(s.useToast)(),
          p = L(),
          y = p.setUpdatedSourceMessage,
          m = p.eventNamePrefix,
          v = Object(l.useState)(""),
          x = Object(h.a)(v, 2),
          w = x[0],
          S = x[1],
          O = u.a.useState([]),
          E = Object(h.a)(O, 2),
          k = E[0],
          _ = E[1],
          C = null === o || void 0 === o ? void 0 : o.generatedResponse,
          T = Object(c.useMutation)(function (t) {
        return b.post("/improvement/".concat(i.orgId, "/coachResponse"), t);
      }, {
        onSuccess: function onSuccess(t) {
          var e = t.data;
          H("".concat(m, "_response_refined"), {
            message_id: i.id
          }), _([].concat(Object(lt.a)(k), [{
            role: "LEAD",
            message: w
          }, {
            role: "USER",
            message: null === e || void 0 === e ? void 0 : e[0]
          }]));
        },
        onError: function onError() {
          f({
            message: "An error ocurred while saving your feedback, plese try again later",
            variant: "error"
          });
        },
        onSettled: function onSettled() {
          S("");
        }
      }),
          A = function resetFeedback() {
        _([]), S("");
      },
          M = Object(c.useMutation)(function (t) {
        return b.post("/improvement/".concat(i.orgId, "/cacheResponse"), t);
      }, {
        onSuccess: function onSuccess() {
          var t, e, r;
          A(), f({
            message: "Source saved. This may take up to 24 hours to take effect.",
            variant: "success"
          }), H("".concat(m, "_response_saved_for_future_inquiries"), {
            message_id: i.id,
            usedSameUrl: !o || (null === (t = null === i || void 0 === i ? void 0 : null === (r = i.attributes) || void 0 === r ? void 0 : r.bionicSources) || void 0 === t ? void 0 : null === (e = t[0]) || void 0 === e ? void 0 : e.source_url) === o.sourceUrl
          }), n(), y(ot);
        },
        onError: function onError() {
          f({
            message: "An error ocurred while saving your feedback, plese try again later",
            variant: "error"
          });
        }
      });

      Object(l.useEffect)(function () {
        var t = document.getElementById("fb-queue-".concat(null === k || void 0 === k ? void 0 : k.length));
        t && de()(t, {
          time: 1e3
        });
      }, [k]);

      var P = function () {
        var t = Object(Z.a)(K.a.mark(function _callee() {
          var t, e;
          return K.a.wrap(function _callee$(r) {
            for (;;) {
              switch (r.prev = r.next) {
                case 0:
                  return r.next = 2, T.mutateAsync({
                    org_id: i.orgId,
                    conversation_id: i.conversationId,
                    message_id: i.id,
                    visitor_message: i.prompt,
                    base_response: C || (null === k || void 0 === k ? void 0 : null === (t = k.slice(-1)) || void 0 === t ? void 0 : null === (e = t[0]) || void 0 === e ? void 0 : e.message) || i.response,
                    coaching_criteria: w
                  });

                case 2:
                case "end":
                  return r.stop();
              }
            }
          }, _callee);
        }));
        return function handleSendFeedback() {
          return t.apply(this, arguments);
        };
      }(),
          j = function () {
        var t = Object(Z.a)(K.a.mark(function _callee2(t, e) {
          var r, n, o, s, c, l, u, h, d, f, p, y;
          return K.a.wrap(function _callee2$(m) {
            for (;;) {
              switch (m.prev = m.next) {
                case 0:
                  return f = Array.isArray(null === i || void 0 === i ? void 0 : null === (r = i.attributes) || void 0 === r ? void 0 : r.bionicSources) && (null === i || void 0 === i ? void 0 : null === (n = i.attributes) || void 0 === n ? void 0 : n.bionicSources[0]) && {
                    source_url: null === i || void 0 === i ? void 0 : null === (o = i.attributes) || void 0 === o ? void 0 : null === (s = o.bionicSources[0]) || void 0 === s ? void 0 : s.source_url,
                    source_title: null === i || void 0 === i ? void 0 : null === (c = i.attributes) || void 0 === c ? void 0 : null === (l = c.bionicSources[0]) || void 0 === l ? void 0 : l.title,
                    source_type: null === i || void 0 === i ? void 0 : null === (u = i.attributes) || void 0 === u ? void 0 : null === (h = u.bionicSources[0]) || void 0 === h ? void 0 : h.source_type
                  }, p = e ? {
                    source_url: e.sourceUrl,
                    source_title: e.sourceTitle,
                    source_type: (null === (d = e.sourceUrl) || void 0 === d ? void 0 : d.startsWith("https://file2")) ? "PDF" : "URL"
                  } : void 0, y = p || f, m.next = 5, M.mutateAsync(Object(g.a)({
                    org_id: i.orgId,
                    messageId: i.id,
                    conversation_id: i.conversationId,
                    inquiry: i.prompt,
                    reply: t
                  }, y || {}));

                case 5:
                  a(Object(g.a)({
                    newGeneratedResponse: t
                  }, C && {
                    newSource: {
                      sourceUrl: y.source_url,
                      sourceTitle: y.source_title,
                      sourceType: y.source_type
                    }
                  }));

                case 6:
                case "end":
                  return m.stop();
              }
            }
          }, _callee2);
        }));
        return function handleUseUpdated(e, r) {
          return t.apply(this, arguments);
        };
      }(),
          R = T.isLoading,
          D = M.isLoading;

      return u.a.createElement(s.Modal.Root, {
        open: r,
        onClose: function onClose() {
          A(), n(!!C);
        }
      }, u.a.createElement(s.Modal.Dialog, {
        size: "large",
        fullWidth: !0,
        variant: "info",
        css: {
          maxWidth: 900
        }
      }, u.a.createElement(s.Modal.Title, {
        title: "",
        subtitle: ""
      }), u.a.createElement(s.Modal.Content, {
        scrollOverflow: "inside",
        css: {
          padding: "$1 $3"
        }
      }, u.a.createElement(s.Flex, {
        direction: "column",
        fullWidth: !0,
        gap: 2,
        css: {
          height: "fit-content"
        }
      }, u.a.createElement(s.Box, {
        fullWidth: !0,
        css: {
          border: "1px solid",
          borderColor: "$blue4",
          background: "$blue1",
          padding: "$2"
        }
      }, u.a.createElement(s.Text, {
        variant: "body",
        dangerouslySetInnerHTML: {
          __html: le.a.sanitize(ue.default.renderToStaticMarkup(u.a.createElement(s.Flex, {
            direction: "column",
            gap: 0
          }, u.a.createElement(s.Box, {
            css: {
              paddingBottom: "$2"
            }
          }, "Using the following tips, please", " ", u.a.createElement("b", null, "explain what you'd like to change"), " about the bot response shown below."), u.a.createElement(s.Flex, {
            direction: "row",
            gap: 1
          }, u.a.createElement("span", null, "\u2022"), u.a.createElement("b", null, "Use plain English")), u.a.createElement(s.Flex, {
            direction: "row",
            gap: 1
          }, u.a.createElement("span", null, "\u2022"), u.a.createElement("b", null, "Provide instructions, rather than specific phrases.")), u.a.createElement("span", null, 'For example: "Make it shorter." or "Try again without using the word \'widget.\' "'))))
        }
      })), u.a.createElement(ct, {
        customerInquiry: null !== (e = i.prompt) && void 0 !== e ? e : "",
        generatedResponse: C || i.response || "",
        isUpdated: !!C,
        isRefine: !0,
        avatarUrl: null === i || void 0 === i ? void 0 : i.avatarUrl
      }), u.a.createElement(s.Flex, {
        direction: "column",
        gap: 2,
        fullWidth: !0,
        css: {
          marginTop: "$5"
        }
      }, k.map(function (t, e) {
        var r;
        return u.a.createElement(s.Box, {
          id: "fb-queue-".concat(1 + e),
          fullWidth: !0,
          key: "fb-queue-".concat(1 + e)
        }, "LEAD" === (null === t || void 0 === t ? void 0 : t.role) ? u.a.createElement(s.Flex, {
          direction: "column",
          gap: 0,
          fullWidth: !0
        }, u.a.createElement(s.Text, {
          variant: "bodyBold"
        }, "Your feedback"), u.a.createElement(s.Box, {
          fullWidth: !0,
          css: {
            background: "$gray2",
            padding: "$2",
            borderLeft: "1px solid"
          }
        }, t.message)) : u.a.createElement(ct, {
          isCacheResponseLoading: D,
          customerInquiry: null !== (r = i.prompt) && void 0 !== r ? r : "",
          generatedResponse: t.message,
          onClickAction: function onClickAction() {
            return j(t.message, o);
          },
          actionTitle: "Accept this response",
          actionTooltip: "Accept this response and use it for future inquiries",
          isRefine: !0,
          avatarUrl: null === i || void 0 === i ? void 0 : i.avatarUrl
        }));
      })))), u.a.createElement(s.Modal.Actions, null, u.a.createElement(s.Flex, {
        fullWidth: !0,
        direction: "row",
        gap: 1,
        alignItems: "center",
        css: {
          border: "1px solid",
          borderColor: "$blue3",
          padding: "$1"
        }
      }, u.a.createElement(s.InputText, {
        label: "",
        className: "bad-feedback-input",
        hideLabel: !0,
        placeholder: "Type feedback here",
        size: "full-width",
        value: w,
        onChange: function onChange(t) {
          return S(t.target.value);
        },
        css: {
          padding: "$1 0"
        },
        rootProps: {
          onKeyDown: function onKeyDown(t) {
            13 === t.keyCode && P();
          }
        }
      }), u.a.createElement(s.Button, {
        loading: R,
        variant: "secondary",
        size: "small",
        onClick: function onClick(t) {
          t.stopPropagation(), P();
        },
        disabled: Object(d.isNil)(w) || R || D
      }, "Send")))));
    });

    !function (t) {
      t.CHANGE_SOURCE = "changeSource", t.REFINE_RESPONSE = "refineResponse";
    }(ne || (ne = {}));

    var pe,
        ye = function MissedScenarioInput(t) {
      var e = t.selectedScenario,
          r = t.onScenarioChange,
          n = L(),
          i = n.review,
          o = n.possibleScenarios,
          c = (void 0 === o ? [] : o).filter(function (t) {
        return t.exposed && !t.archived && !("Moderation" === t.name && "GUARDRAIL" === t.type);
      }).map(function (t) {
        return {
          label: t.name,
          value: t.scenarioId
        };
      });
      return u.a.createElement(s.Flex, {
        direction: "column",
        fullWidth: !0,
        css: {
          paddingRight: "$2"
        }
      }, u.a.createElement(s.Text, null, "Select the correct scenario or guardrail", " ", u.a.createElement(s.Text, {
        as: "span",
        variant: "metadata",
        css: {
          color: "$gray10"
        }
      }, "(Optional)")), u.a.createElement(s.Select, {
        size: "fullWidth",
        className: "missed-scenario-select",
        label: "Select the correct scenario or guardrail",
        hideLabel: !0,
        value: e,
        onChange: function onChange(t) {
          r(t);
        },
        options: (null === i || void 0 === i ? void 0 : i.negativeReviewReason) === a.MISSED_SCENARIO ? c : c.filter(function (t) {
          var e;
          return t.value !== (null === i || void 0 === i ? void 0 : null === (e = i.scenarioId) || void 0 === e ? void 0 : e.toString());
        })
      }));
    },
        ge = function ThanksForFeedback() {
      return u.a.createElement(s.Box, {
        onClick: function onClick(t) {
          t.stopPropagation();
        },
        css: {
          width: "100%",
          maxWidth: "600px"
        }
      }, u.a.createElement(s.Text, {
        variant: "body"
      }, u.a.createElement("strong", null, "Thanks for the feedback!"), " It was saved successfully."));
    },
        me = (pe = {}, Object(S.a)(pe, a.INCORRECT_SOURCE, {
      component: function BadResponseFeedbackFlow(t) {
        var e = t.onUpdateReview,
            r = t.onClose,
            n = L(),
            i = n.isBionic,
            o = n.eventNamePrefix,
            a = n.message,
            c = n.allVertexUrls,
            d = n.isLoadingVertexUrls,
            f = Object(l.useState)(!1),
            p = Object(h.a)(f, 2),
            y = p[0],
            g = p[1],
            m = Object(l.useState)(!1),
            v = Object(h.a)(m, 2),
            b = v[0],
            x = v[1],
            w = Object(l.useState)(void 0),
            S = Object(h.a)(w, 2),
            O = S[0],
            E = S[1],
            k = function switchModal(t, e) {
          switch (t) {
            case ne.CHANGE_SOURCE:
              E(void 0), x(!1), g(!0);
              break;

            case ne.REFINE_RESPONSE:
              E(e), g(!1), x(!0);
          }
        },
            _ = function handleUpdateReviewAndClose(t) {
          e(t), null === r || void 0 === r || r();
        };

        return u.a.createElement(u.a.Fragment, null, u.a.createElement(s.Flex, {
          direction: "column",
          gap: 1,
          onClick: function onClick(t) {
            t.stopPropagation();
          },
          fullWidth: !0,
          css: {
            maxWidth: "600px"
          }
        }, u.a.createElement(s.Text, null, "Fix this response for next time", " ", u.a.createElement(s.Text, {
          as: "span",
          variant: "metadata",
          css: {
            color: "$gray10"
          }
        }, "(Optional)")), u.a.createElement(s.Flex, {
          gap: 1
        }, u.a.createElement(s.Button, {
          variant: "secondary",
          onClick: function handleUseDifferentSourceClick(t) {
            t.stopPropagation();
            var e = "".concat(o, "_use_different_source_clicked");
            H(e, {
              message_id: a.id
            }), g(!0);
          }
        }, "Use a different source"), i && u.a.createElement(s.Button, {
          variant: "secondary",
          onClick: function handleRefineResponseClick(t) {
            t.stopPropagation();
            var e = "".concat(o, "_refine_response_clicked");
            H(e, {
              message_id: a.id
            }), x(!0), E(void 0);
          }
        }, "Refine response"))), u.a.createElement(se, {
          isOpen: y,
          onClose: function onClose() {
            g(!1);
          },
          message: a,
          onUpdateReview: _,
          allVertexUrls: c,
          isLoadingVertexUrls: d,
          onSwitchToRefine: function onSwitchToRefine(t) {
            return k(ne.REFINE_RESPONSE, t);
          }
        }), u.a.createElement(fe, {
          isOpen: b,
          onClose: function onClose(t) {
            t ? k(ne.CHANGE_SOURCE) : x(!1);
          },
          onUpdateReview: _,
          message: a,
          newSource: O
        }));
      }
    }), Object(S.a)(pe, a.MISSED_SCENARIO, {
      component: ye,
      requiresSubmit: !0
    }), Object(S.a)(pe, a.INCORRECT_SCENARIO, {
      component: ye,
      requiresSubmit: !0
    }), Object(S.a)(pe, a.SHOULD_HAVE_BEEN_ANSWERED, {
      component: ge
    }), Object(S.a)(pe, a.OFF_TOPIC_INQUIRY, {
      component: ge
    }), Object(S.a)(pe, "DEFAULT", {
      component: function FeedbackTextAreaInput(t) {
        var e = t.value,
            r = t.onChange;
        return u.a.createElement(s.Box, {
          fullWidth: !0,
          onClick: function onClick(t) {
            t.stopPropagation();
          }
        }, u.a.createElement(s.Text, {
          variant: "body"
        }, "Share additional feedback", " ", u.a.createElement(s.Text, {
          as: "span",
          variant: "metadata",
          css: {
            color: "$gray10"
          }
        }, "(Optional)")), u.a.createElement(s.Textarea, {
          size: "full-width",
          label: "",
          value: e,
          placeholder: "The bot should have responded like...",
          onChange: function onChange(t) {
            var e = t.target.value;
            return r(e);
          }
        }));
      },
      requiresSubmit: !0
    }), pe),
        ve = Object(s.styled)(s.Chip, {
      background: "$white",
      paddingTop: "14px",
      paddingBottom: "14px",
      paddingLeft: "16px",
      paddingRight: "16px",
      borderRadius: 100,
      borderColor: "$blue3",
      maxWidth: "100%",
      cursor: "pointer",
      '&[data-state="selected"]': {
        background: "$blue1",
        borderColor: "$blue8"
      },
      "& span": {
        maxWidth: "100%"
      }
    }),
        be = Object(s.styled)(s.Text, {
      fontWeight: "bold"
    }),
        xe = function FeedbackOption(t) {
      var e = t.title,
          r = t.onClick,
          n = t.selected,
          i = t.tooltip;
      return u.a.createElement(s.Tooltip, {
        avoidCollisions: !0,
        content: i,
        side: "top"
      }, u.a.createElement(ve, {
        onClick: function onClick(t) {
          t.stopPropagation(), r();
        },
        "data-state": n && "selected"
      }, u.a.createElement(be, {
        variant: "metadata",
        "data-state": n && "selected"
      }, u.a.createElement("strong", null, e))));
    },
        we = "Your additional feedback was submitted successfully.",
        Se = "Scenario updated for future inquiries.",
        Oe = function ReviewFeedbackModal(t) {
      var e,
          r = t.isOpen,
          n = t.onClose,
          i = t.onUpdateReview,
          o = L(),
          c = o.review,
          f = o.isBionic,
          p = o.hasVertexSearch,
          y = o.messageResponseType,
          g = o.message,
          m = o.setUpdatedSourceMessage,
          v = function useBotName() {
        var t = tt();
        return (null === t || void 0 === t ? void 0 : t.name) || "Bot";
      }(),
          b = Object(l.useState)(null),
          x = Object(h.a)(b, 2),
          w = x[0],
          S = x[1],
          j = Object(l.useState)(function () {
        var t;
        return null !== (t = null === c || void 0 === c ? void 0 : c.negativeReviewReasonText) && void 0 !== t ? t : "";
      }),
          R = Object(h.a)(j, 2),
          D = R[0],
          I = R[1],
          N = Object(l.useState)(),
          B = Object(h.a)(N, 2),
          F = B[0],
          U = B[1],
          W = Object(l.useState)(!1),
          z = Object(h.a)(W, 2),
          q = z[0],
          H = z[1],
          G = Object(s.useToast)(),
          Y = Object(l.useMemo)(function () {
        return ![P.REGULAR, P.GUARDRAIL].includes(y) && "DOWN" === (null === c || void 0 === c ? void 0 : c.thumbs);
      }, [y, c]),
          X = Object(l.useMemo)(function () {
        return y === P.GUARDRAIL && "DOWN" === (null === c || void 0 === c ? void 0 : c.thumbs);
      }, [y, c]),
          V = !!(null === (e = g.attributes) || void 0 === e ? void 0 : e.offTopic),
          $ = Object(l.useMemo)(function () {
        return f ? Y ? k : X ? p ? C : _ : V && !p ? M : p ? T : A : E;
      }, [f, Y, X, V, p]),
          Q = Object(l.useMemo)(function () {
        var t;
        return w ? null !== (t = me[w]) && void 0 !== t ? t : me.DEFAULT : null;
      }, [w]),
          J = null === Q || void 0 === Q ? void 0 : Q.component,
          et = w === a.MISSED_SCENARIO || w === a.INCORRECT_SCENARIO,
          rt = w === a.INCORRECT_SOURCE,
          nt = function handleClose() {
        S(null), I(""), U(void 0), H(!1), n();
      },
          it = function () {
        var t = Object(Z.a)(K.a.mark(function _callee() {
          var t;
          return K.a.wrap(function _callee$(e) {
            for (;;) {
              switch (e.prev = e.next) {
                case 0:
                  if (!rt) {
                    e.next = 3;
                    break;
                  }

                  return nt(), e.abrupt("return");

                case 3:
                  if (!w || (et ? !F : D.trim() === (null !== (t = null === c || void 0 === c ? void 0 : c.negativeReviewReasonText) && void 0 !== t ? t : "").trim()) || !w) {
                    e.next = 28;
                    break;
                  }

                  if (H(!0), e.prev = 6, !et) {
                    e.next = 13;
                    break;
                  }

                  return e.next = 10, i({
                    negativeReviewReason: w,
                    missedScenarioId: null === F || void 0 === F ? void 0 : F.value,
                    missedScenarioName: null === F || void 0 === F ? void 0 : F.label,
                    endUserMessageBody: g.prompt
                  });

                case 10:
                  m(Se), e.next = 16;
                  break;

                case 13:
                  return e.next = 15, i({
                    negativeReviewReason: w,
                    negativeReviewReasonText: D
                  });

                case 15:
                  m(we);

                case 16:
                  G({
                    message: "Feedback saved",
                    variant: "success"
                  }), nt(), e.next = 23;
                  break;

                case 20:
                  e.prev = 20, e.t0 = e.catch(6), G({
                    message: "An error occurred while saving your feedback. Please try again.",
                    variant: "error"
                  });

                case 23:
                  return e.prev = 23, H(!1), e.finish(23);

                case 26:
                  e.next = 29;
                  break;

                case 28:
                  nt();

                case 29:
                case "end":
                  return e.stop();
              }
            }
          }, _callee, null, [[6, 20, 23, 26]]);
        }));
        return function handleSubmit() {
          return t.apply(this, arguments);
        };
      }();

      return u.a.createElement(s.Modal.Root, {
        open: r,
        onClose: nt
      }, u.a.createElement(s.Modal.Dialog, {
        size: "medium",
        variant: "info"
      }, u.a.createElement(s.Modal.Title, {
        title: "Select your feedback"
      }), u.a.createElement(s.Modal.Content, {
        as: s.Flex,
        direction: "column",
        gap: 2,
        scrollOverflow: "outside"
      }, u.a.createElement(s.Box, null, u.a.createElement(s.Text, {
        variant: "metadata"
      }, v), u.a.createElement(s.Box, {
        css: {
          background: "#F5F8FA",
          padding: "$half $1",
          borderRadius: "$1"
        }
      }, u.a.createElement(s.Text, {
        dangerouslySetInnerHTML: {
          __html: g.response
        }
      }))), u.a.createElement(s.Flex, {
        wrap: "wrap",
        fullWidth: !0,
        gap: 1
      }, $.map(function (t) {
        return u.a.createElement(xe, {
          key: t,
          title: X && t === a.GENERAL_INQUIRY ? "Should not have hit any guardrails" : O[t],
          onClick: function onClick() {
            return function handleOptionClick(t) {
              S(t), i({
                negativeReviewReason: t
              });
            }(t);
          },
          selected: w === t
        });
      })), !Object(d.isNil)(J) && u.a.createElement(s.Flex, {
        gap: 2,
        fullWidth: !0
      }, u.a.createElement(s.Separator, {
        orientation: "vertical",
        rootProps: {
          style: {
            width: "2px"
          }
        }
      }), rt ? u.a.createElement(J, {
        onUpdateReview: i,
        onClose: nt
      }) : et ? u.a.createElement(J, {
        selectedScenario: F,
        onScenarioChange: U
      }) : u.a.createElement(J, {
        value: D,
        onChange: I
      }))), u.a.createElement(s.Modal.Actions, null, u.a.createElement(s.Button, {
        variant: "secondary",
        onClick: nt
      }, "Cancel"), u.a.createElement(s.Button, {
        onClick: it,
        loading: q
      }, "Submit"))));
    },
        Ee = function UpdatedResponseInfoModal(t) {
      var e = t.isOpen,
          r = t.onClose,
          n = t.sourceMessage,
          i = t.review || {},
          o = i.newSource,
          a = i.newGeneratedResponse;
      return u.a.createElement(s.Modal.Root, {
        open: e,
        onClose: r
      }, u.a.createElement(s.Modal.Dialog, {
        size: "medium",
        fullWidth: !0,
        variant: "info"
      }, u.a.createElement(s.Modal.Title, {
        title: "Updated response"
      }), u.a.createElement(s.Modal.Content, null, u.a.createElement(s.Flex, {
        direction: "column",
        fullWidth: !0,
        gap: 2
      }, u.a.createElement(s.Text, {
        variant: "body"
      }, "Next time this inquiry comes up in conversation, we'll use the following response:"), u.a.createElement(s.Flex, {
        direction: "row",
        css: {
          background: "$gray8",
          padding: "$1",
          flexGrow: "initial"
        },
        justifyContent: "center",
        alignItems: "center",
        fullWidth: !0
      }, u.a.createElement(s.Text, {
        variant: "metadata",
        css: {
          color: "$gray1"
        }
      }, n)), u.a.createElement(s.Flex, {
        direction: "row",
        alignItems: "flex-start",
        css: {
          marginTop: "$1"
        }
      }, u.a.createElement(s.Box, {
        css: {
          background: "$gray3",
          border: "1px transparent",
          borderRadius: 6,
          padding: "$1"
        }
      }, u.a.createElement(s.Text, {
        variant: "body",
        css: {
          color: "$gray12"
        }
      }, a))), (null === o || void 0 === o ? void 0 : o.sourceUrl) && u.a.createElement(s.Box, null, u.a.createElement(s.Text, {
        variant: "metadata"
      }, "Source"), u.a.createElement(s.Flex, {
        gap: "half",
        fullWidth: !0
      }, u.a.createElement(s.Icon, {
        css: {
          marginTop: "2px"
        },
        icon: "PDF" === o.sourceType ? void 0 : rt.faGlobe
      }), u.a.createElement(s.Box, null, u.a.createElement(s.Text, null, o.sourceTitle), u.a.createElement(s.Text, {
        variant: "metadata"
      }, o.sourceUrl))))))));
    },
        ke = function MessageReview(t) {
      var e,
          r = t.leftComponent,
          n = t.messageReview,
          i = t.onUpdateReview,
          o = t.onDeleteReview,
          a = t.isLoading,
          f = t.message,
          p = t.isBionic,
          y = t.hasVertexSearch,
          g = t.possibleScenarios,
          m = t.allVertexUrls,
          v = t.isLoadingVertexUrls,
          x = t.messageResponseType,
          w = void 0 === x ? "REGULAR" : x,
          S = t.scenarioName,
          O = t.scenarioExposed,
          E = t.eventNamePrefix,
          k = t.messageIndex,
          _ = Object(l.useState)(!1),
          C = Object(h.a)(_, 2),
          T = C[0],
          A = C[1],
          M = Object(l.useState)(!1),
          P = Object(h.a)(M, 2),
          j = P[0],
          R = P[1],
          D = null === (e = f.attributes) || void 0 === e ? void 0 : e.cachedReply,
          L = Object(c.useMutation)(function () {
        return b.post("/improvement/".concat(f.orgId, "/delete/inquiry/cachedResponse"), {
          orgId: f.orgId,
          reviewId: null === D || void 0 === D ? void 0 : D.review_id,
          conversationId: null === D || void 0 === D ? void 0 : D.conversation_id,
          inquiry: null === D || void 0 === D ? void 0 : D.similar_inquiry
        });
      }),
          N = Object(c.useMutation)(function (t) {
        return b.post("/improvement/".concat(f.orgId, "/cacheResponse"), t);
      });

      return u.a.createElement(I, {
        closeFeedbackForm: function closeFeedbackForm() {
          return A(!1);
        },
        review: n,
        message: f,
        isBionic: p,
        hasVertexSearch: y,
        messageResponseType: w,
        possibleScenarios: g,
        allVertexUrls: m,
        isLoadingVertexUrls: v,
        scenarioName: S,
        scenarioExposed: O,
        eventNamePrefix: E,
        messageIndex: k
      }, u.a.createElement(s.Flex, {
        gap: "half",
        alignItems: "center"
      }, Object(d.isNil)(r) ? null : r, u.a.createElement($, {
        onUpdateRate: function handleUpdateRate(t) {
          if (!Object(d.isNil)(n) && t === (null === n || void 0 === n ? void 0 : n.thumbs)) return A(!1), void o();
          var e, r, a;
          "UP" === t && (D || "REGULAR" !== w || N.mutate({
            org_id: f.orgId,
            conversation_id: f.conversationId,
            inquiry: f.prompt,
            reply: f.response,
            source_url: null === (e = f.references[0]) || void 0 === e ? void 0 : e.url,
            source_title: null === (r = f.references[0]) || void 0 === r ? void 0 : r.title,
            source_type: null === (a = f.references[0]) || void 0 === a ? void 0 : a.type,
            messageId: f.id
          })), "DOWN" === t && (A(!0), D && L.mutate()), i({
            thumbs: t
          });
        },
        isLoading: a,
        openUpdatedMessageDetail: function handleOpenResponseModal(t) {
          t.preventDefault(), t.stopPropagation(), R(!0);
        }
      })), T && n && "DOWN" === n.thumbs && u.a.createElement(Oe, {
        isOpen: T,
        onClose: function onClose() {
          return A(!1);
        },
        onUpdateReview: i
      }), u.a.createElement(Ee, {
        isOpen: j,
        onClose: function onClose() {
          return R(!1);
        },
        sourceMessage: f.prompt,
        review: n
      }));
    },
        _e = new c.QueryClient(),
        Ce = function AIMessageReviewWrapper(t) {
      return u.a.createElement(c.QueryClientProvider, {
        client: _e
      }, u.a.createElement(s.ToastProvider, null, u.a.createElement(ke, t)));
    };

    r.d(e, "MessageReview", function () {
      return Ce;
    }), r.d(e, "THUMBS_UP", function () {
      return "UP";
    });
  }]);
});